var uu = Object.defineProperty;
var du = (s, t, e) => t in s ? uu(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var A = (s, t, e) => du(s, typeof t != "symbol" ? t + "" : t, e);
import Rt, { defineComponent as g, nextTick as pe, inject as pu, computed as Q, unref as Be, ref as st, watch as Te, provide as hu, getCurrentInstance as Fn, onMounted as Ln, toRefs as Pe, getCurrentScope as fu, onScopeDispose as mu, watchEffect as gu } from "vue";
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function Is(s) {
  return s + 0.5 | 0;
}
const re = (s, t, e) => Math.max(Math.min(s, e), t);
function cs(s) {
  return re(Is(s * 2.55), 0, 255);
}
function ce(s) {
  return re(Is(s * 255), 0, 255);
}
function Jt(s) {
  return re(Is(s / 2.55) / 100, 0, 1);
}
function Lr(s) {
  return re(Is(s * 100), 0, 100);
}
const Pt = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, fn = [..."0123456789ABCDEF"], _u = (s) => fn[s & 15], yu = (s) => fn[(s & 240) >> 4] + fn[s & 15], Bs = (s) => (s & 240) >> 4 === (s & 15), bu = (s) => Bs(s.r) && Bs(s.g) && Bs(s.b) && Bs(s.a);
function vu(s) {
  var t = s.length, e;
  return s[0] === "#" && (t === 4 || t === 5 ? e = {
    r: 255 & Pt[s[1]] * 17,
    g: 255 & Pt[s[2]] * 17,
    b: 255 & Pt[s[3]] * 17,
    a: t === 5 ? Pt[s[4]] * 17 : 255
  } : (t === 7 || t === 9) && (e = {
    r: Pt[s[1]] << 4 | Pt[s[2]],
    g: Pt[s[3]] << 4 | Pt[s[4]],
    b: Pt[s[5]] << 4 | Pt[s[6]],
    a: t === 9 ? Pt[s[7]] << 4 | Pt[s[8]] : 255
  })), e;
}
const ku = (s, t) => s < 255 ? t(s) : "";
function xu(s) {
  var t = bu(s) ? _u : yu;
  return s ? "#" + t(s.r) + t(s.g) + t(s.b) + ku(s.a, t) : void 0;
}
const Cu = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function Wo(s, t, e) {
  const i = t * Math.min(e, 1 - e), n = (r, a = (r + s / 30) % 12) => e - i * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [n(0), n(8), n(4)];
}
function wu(s, t, e) {
  const i = (n, r = (n + s / 60) % 6) => e - e * t * Math.max(Math.min(r, 4 - r, 1), 0);
  return [i(5), i(3), i(1)];
}
function $u(s, t, e) {
  const i = Wo(s, 1, 0.5);
  let n;
  for (t + e > 1 && (n = 1 / (t + e), t *= n, e *= n), n = 0; n < 3; n++)
    i[n] *= 1 - t - e, i[n] += t;
  return i;
}
function Su(s, t, e, i, n) {
  return s === n ? (t - e) / i + (t < e ? 6 : 0) : t === n ? (e - s) / i + 2 : (s - t) / i + 4;
}
function qn(s) {
  const e = s.r / 255, i = s.g / 255, n = s.b / 255, r = Math.max(e, i, n), a = Math.min(e, i, n), o = (r + a) / 2;
  let l, c, u;
  return r !== a && (u = r - a, c = o > 0.5 ? u / (2 - r - a) : u / (r + a), l = Su(e, i, n, u, r), l = l * 60 + 0.5), [l | 0, c || 0, o];
}
function Un(s, t, e, i) {
  return (Array.isArray(t) ? s(t[0], t[1], t[2]) : s(t, e, i)).map(ce);
}
function Nn(s, t, e) {
  return Un(Wo, s, t, e);
}
function Tu(s, t, e) {
  return Un($u, s, t, e);
}
function Iu(s, t, e) {
  return Un(wu, s, t, e);
}
function Go(s) {
  return (s % 360 + 360) % 360;
}
function Au(s) {
  const t = Cu.exec(s);
  let e = 255, i;
  if (!t)
    return;
  t[5] !== i && (e = t[6] ? cs(+t[5]) : ce(+t[5]));
  const n = Go(+t[2]), r = +t[3] / 100, a = +t[4] / 100;
  return t[1] === "hwb" ? i = Tu(n, r, a) : t[1] === "hsv" ? i = Iu(n, r, a) : i = Nn(n, r, a), {
    r: i[0],
    g: i[1],
    b: i[2],
    a: e
  };
}
function Pu(s, t) {
  var e = qn(s);
  e[0] = Go(e[0] + t), e = Nn(e), s.r = e[0], s.g = e[1], s.b = e[2];
}
function Ou(s) {
  if (!s)
    return;
  const t = qn(s), e = t[0], i = Lr(t[1]), n = Lr(t[2]);
  return s.a < 255 ? `hsla(${e}, ${i}%, ${n}%, ${Jt(s.a)})` : `hsl(${e}, ${i}%, ${n}%)`;
}
const qr = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Ur = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function Mu() {
  const s = {}, t = Object.keys(Ur), e = Object.keys(qr);
  let i, n, r, a, o;
  for (i = 0; i < t.length; i++) {
    for (a = o = t[i], n = 0; n < e.length; n++)
      r = e[n], o = o.replace(r, qr[r]);
    r = parseInt(Ur[a], 16), s[o] = [r >> 16 & 255, r >> 8 & 255, r & 255];
  }
  return s;
}
let js;
function Ru(s) {
  js || (js = Mu(), js.transparent = [0, 0, 0, 0]);
  const t = js[s.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const Eu = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function Du(s) {
  const t = Eu.exec(s);
  let e = 255, i, n, r;
  if (t) {
    if (t[7] !== i) {
      const a = +t[7];
      e = t[8] ? cs(a) : re(a * 255, 0, 255);
    }
    return i = +t[1], n = +t[3], r = +t[5], i = 255 & (t[2] ? cs(i) : re(i, 0, 255)), n = 255 & (t[4] ? cs(n) : re(n, 0, 255)), r = 255 & (t[6] ? cs(r) : re(r, 0, 255)), {
      r: i,
      g: n,
      b: r,
      a: e
    };
  }
}
function Fu(s) {
  return s && (s.a < 255 ? `rgba(${s.r}, ${s.g}, ${s.b}, ${Jt(s.a)})` : `rgb(${s.r}, ${s.g}, ${s.b})`);
}
const Gi = (s) => s <= 31308e-7 ? s * 12.92 : Math.pow(s, 1 / 2.4) * 1.055 - 0.055, Ue = (s) => s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
function Lu(s, t, e) {
  const i = Ue(Jt(s.r)), n = Ue(Jt(s.g)), r = Ue(Jt(s.b));
  return {
    r: ce(Gi(i + e * (Ue(Jt(t.r)) - i))),
    g: ce(Gi(n + e * (Ue(Jt(t.g)) - n))),
    b: ce(Gi(r + e * (Ue(Jt(t.b)) - r))),
    a: s.a + e * (t.a - s.a)
  };
}
function zs(s, t, e) {
  if (s) {
    let i = qn(s);
    i[t] = Math.max(0, Math.min(i[t] + i[t] * e, t === 0 ? 360 : 1)), i = Nn(i), s.r = i[0], s.g = i[1], s.b = i[2];
  }
}
function Ko(s, t) {
  return s && Object.assign(t || {}, s);
}
function Nr(s) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(s) ? s.length >= 3 && (t = { r: s[0], g: s[1], b: s[2], a: 255 }, s.length > 3 && (t.a = ce(s[3]))) : (t = Ko(s, { r: 0, g: 0, b: 0, a: 1 }), t.a = ce(t.a)), t;
}
function qu(s) {
  return s.charAt(0) === "r" ? Du(s) : Au(s);
}
class vs {
  constructor(t) {
    if (t instanceof vs)
      return t;
    const e = typeof t;
    let i;
    e === "object" ? i = Nr(t) : e === "string" && (i = vu(t) || Ru(t) || qu(t)), this._rgb = i, this._valid = !!i;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = Ko(this._rgb);
    return t && (t.a = Jt(t.a)), t;
  }
  set rgb(t) {
    this._rgb = Nr(t);
  }
  rgbString() {
    return this._valid ? Fu(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? xu(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Ou(this._rgb) : void 0;
  }
  mix(t, e) {
    if (t) {
      const i = this.rgb, n = t.rgb;
      let r;
      const a = e === r ? 0.5 : e, o = 2 * a - 1, l = i.a - n.a, c = ((o * l === -1 ? o : (o + l) / (1 + o * l)) + 1) / 2;
      r = 1 - c, i.r = 255 & c * i.r + r * n.r + 0.5, i.g = 255 & c * i.g + r * n.g + 0.5, i.b = 255 & c * i.b + r * n.b + 0.5, i.a = a * i.a + (1 - a) * n.a, this.rgb = i;
    }
    return this;
  }
  interpolate(t, e) {
    return t && (this._rgb = Lu(this._rgb, t._rgb, e)), this;
  }
  clone() {
    return new vs(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = ce(t), this;
  }
  clearer(t) {
    const e = this._rgb;
    return e.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, e = Is(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = e, this;
  }
  opaquer(t) {
    const e = this._rgb;
    return e.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return zs(this._rgb, 2, t), this;
  }
  darken(t) {
    return zs(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return zs(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return zs(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return Pu(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.4.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function Xt() {
}
const Uu = /* @__PURE__ */ (() => {
  let s = 0;
  return () => s++;
})();
function N(s) {
  return s === null || typeof s > "u";
}
function Z(s) {
  if (Array.isArray && Array.isArray(s))
    return !0;
  const t = Object.prototype.toString.call(s);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function U(s) {
  return s !== null && Object.prototype.toString.call(s) === "[object Object]";
}
function it(s) {
  return (typeof s == "number" || s instanceof Number) && isFinite(+s);
}
function Tt(s, t) {
  return it(s) ? s : t;
}
function D(s, t) {
  return typeof s > "u" ? t : s;
}
const Nu = (s, t) => typeof s == "string" && s.endsWith("%") ? parseFloat(s) / 100 : +s / t, Yo = (s, t) => typeof s == "string" && s.endsWith("%") ? parseFloat(s) / 100 * t : +s;
function W(s, t, e) {
  if (s && typeof s.call == "function")
    return s.apply(e, t);
}
function j(s, t, e, i) {
  let n, r, a;
  if (Z(s))
    for (r = s.length, n = 0; n < r; n++)
      t.call(e, s[n], n);
  else if (U(s))
    for (a = Object.keys(s), r = a.length, n = 0; n < r; n++)
      t.call(e, s[a[n]], a[n]);
}
function mi(s, t) {
  let e, i, n, r;
  if (!s || !t || s.length !== t.length)
    return !1;
  for (e = 0, i = s.length; e < i; ++e)
    if (n = s[e], r = t[e], n.datasetIndex !== r.datasetIndex || n.index !== r.index)
      return !1;
  return !0;
}
function gi(s) {
  if (Z(s))
    return s.map(gi);
  if (U(s)) {
    const t = /* @__PURE__ */ Object.create(null), e = Object.keys(s), i = e.length;
    let n = 0;
    for (; n < i; ++n)
      t[e[n]] = gi(s[e[n]]);
    return t;
  }
  return s;
}
function Xo(s) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(s) === -1;
}
function Bu(s, t, e, i) {
  if (!Xo(s))
    return;
  const n = t[s], r = e[s];
  U(n) && U(r) ? ks(n, r, i) : t[s] = gi(r);
}
function ks(s, t, e) {
  const i = Z(t) ? t : [
    t
  ], n = i.length;
  if (!U(s))
    return s;
  e = e || {};
  const r = e.merger || Bu;
  let a;
  for (let o = 0; o < n; ++o) {
    if (a = i[o], !U(a))
      continue;
    const l = Object.keys(a);
    for (let c = 0, u = l.length; c < u; ++c)
      r(l[c], s, a, e);
  }
  return s;
}
function ms(s, t) {
  return ks(s, t, {
    merger: ju
  });
}
function ju(s, t, e) {
  if (!Xo(s))
    return;
  const i = t[s], n = e[s];
  U(i) && U(n) ? ms(i, n) : Object.prototype.hasOwnProperty.call(t, s) || (t[s] = gi(n));
}
const Br = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (s) => s,
  // default resolvers
  x: (s) => s.x,
  y: (s) => s.y
};
function zu(s) {
  const t = s.split("."), e = [];
  let i = "";
  for (const n of t)
    i += n, i.endsWith("\\") ? i = i.slice(0, -1) + "." : (e.push(i), i = "");
  return e;
}
function Vu(s) {
  const t = zu(s);
  return (e) => {
    for (const i of t) {
      if (i === "")
        break;
      e = e && e[i];
    }
    return e;
  };
}
function ue(s, t) {
  return (Br[t] || (Br[t] = Vu(t)))(s);
}
function Bn(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
const xs = (s) => typeof s < "u", de = (s) => typeof s == "function", jr = (s, t) => {
  if (s.size !== t.size)
    return !1;
  for (const e of s)
    if (!t.has(e))
      return !1;
  return !0;
};
function Hu(s) {
  return s.type === "mouseup" || s.type === "click" || s.type === "contextmenu";
}
const K = Math.PI, G = 2 * K, Wu = G + K, _i = Number.POSITIVE_INFINITY, Gu = K / 180, at = K / 2, me = K / 4, zr = K * 2 / 3, ae = Math.log10, Vt = Math.sign;
function gs(s, t, e) {
  return Math.abs(s - t) < e;
}
function Vr(s) {
  const t = Math.round(s);
  s = gs(s, t, s / 1e3) ? t : s;
  const e = Math.pow(10, Math.floor(ae(s))), i = s / e;
  return (i <= 1 ? 1 : i <= 2 ? 2 : i <= 5 ? 5 : 10) * e;
}
function Ku(s) {
  const t = [], e = Math.sqrt(s);
  let i;
  for (i = 1; i < e; i++)
    s % i === 0 && (t.push(i), t.push(s / i));
  return e === (e | 0) && t.push(e), t.sort((n, r) => n - r).pop(), t;
}
function ze(s) {
  return !isNaN(parseFloat(s)) && isFinite(s);
}
function Yu(s, t) {
  const e = Math.round(s);
  return e - t <= s && e + t >= s;
}
function Zo(s, t, e) {
  let i, n, r;
  for (i = 0, n = s.length; i < n; i++)
    r = s[i][e], isNaN(r) || (t.min = Math.min(t.min, r), t.max = Math.max(t.max, r));
}
function Ft(s) {
  return s * (K / 180);
}
function jn(s) {
  return s * (180 / K);
}
function Hr(s) {
  if (!it(s))
    return;
  let t = 1, e = 0;
  for (; Math.round(s * t) / t !== s; )
    t *= 10, e++;
  return e;
}
function Qo(s, t) {
  const e = t.x - s.x, i = t.y - s.y, n = Math.sqrt(e * e + i * i);
  let r = Math.atan2(i, e);
  return r < -0.5 * K && (r += G), {
    angle: r,
    distance: n
  };
}
function mn(s, t) {
  return Math.sqrt(Math.pow(t.x - s.x, 2) + Math.pow(t.y - s.y, 2));
}
function Xu(s, t) {
  return (s - t + Wu) % G - K;
}
function It(s) {
  return (s % G + G) % G;
}
function Cs(s, t, e, i) {
  const n = It(s), r = It(t), a = It(e), o = It(r - n), l = It(a - n), c = It(n - r), u = It(n - a);
  return n === r || n === a || i && r === a || o > l && c < u;
}
function ut(s, t, e) {
  return Math.max(t, Math.min(e, s));
}
function Zu(s) {
  return ut(s, -32768, 32767);
}
function te(s, t, e, i = 1e-6) {
  return s >= Math.min(t, e) - i && s <= Math.max(t, e) + i;
}
function zn(s, t, e) {
  e = e || ((a) => s[a] < t);
  let i = s.length - 1, n = 0, r;
  for (; i - n > 1; )
    r = n + i >> 1, e(r) ? n = r : i = r;
  return {
    lo: n,
    hi: i
  };
}
const ee = (s, t, e, i) => zn(s, e, i ? (n) => {
  const r = s[n][t];
  return r < e || r === e && s[n + 1][t] === e;
} : (n) => s[n][t] < e), Qu = (s, t, e) => zn(s, e, (i) => s[i][t] >= e);
function Ju(s, t, e) {
  let i = 0, n = s.length;
  for (; i < n && s[i] < t; )
    i++;
  for (; n > i && s[n - 1] > e; )
    n--;
  return i > 0 || n < s.length ? s.slice(i, n) : s;
}
const Jo = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function td(s, t) {
  if (s._chartjs) {
    s._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(s, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), Jo.forEach((e) => {
    const i = "_onData" + Bn(e), n = s[e];
    Object.defineProperty(s, e, {
      configurable: !0,
      enumerable: !1,
      value(...r) {
        const a = n.apply(this, r);
        return s._chartjs.listeners.forEach((o) => {
          typeof o[i] == "function" && o[i](...r);
        }), a;
      }
    });
  });
}
function Wr(s, t) {
  const e = s._chartjs;
  if (!e)
    return;
  const i = e.listeners, n = i.indexOf(t);
  n !== -1 && i.splice(n, 1), !(i.length > 0) && (Jo.forEach((r) => {
    delete s[r];
  }), delete s._chartjs);
}
function tl(s) {
  const t = new Set(s);
  return t.size === s.length ? s : Array.from(t);
}
const el = function() {
  return typeof window > "u" ? function(s) {
    return s();
  } : window.requestAnimationFrame;
}();
function sl(s, t) {
  let e = [], i = !1;
  return function(...n) {
    e = n, i || (i = !0, el.call(window, () => {
      i = !1, s.apply(t, e);
    }));
  };
}
function ed(s, t) {
  let e;
  return function(...i) {
    return t ? (clearTimeout(e), e = setTimeout(s, t, i)) : s.apply(this, i), t;
  };
}
const Vn = (s) => s === "start" ? "left" : s === "end" ? "right" : "center", ft = (s, t, e) => s === "start" ? t : s === "end" ? e : (t + e) / 2, sd = (s, t, e, i) => s === (i ? "left" : "right") ? e : s === "center" ? (t + e) / 2 : t;
function il(s, t, e) {
  const i = t.length;
  let n = 0, r = i;
  if (s._sorted) {
    const { iScale: a, _parsed: o } = s, l = a.axis, { min: c, max: u, minDefined: d, maxDefined: p } = a.getUserBounds();
    d && (n = ut(Math.min(
      // @ts-expect-error Need to type _parsed
      ee(o, l, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      e ? i : ee(t, l, a.getPixelForValue(c)).lo
    ), 0, i - 1)), p ? r = ut(Math.max(
      // @ts-expect-error Need to type _parsed
      ee(o, a.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      e ? 0 : ee(t, l, a.getPixelForValue(u), !0).hi + 1
    ), n, i) - n : r = i - n;
  }
  return {
    start: n,
    count: r
  };
}
function nl(s) {
  const { xScale: t, yScale: e, _scaleRanges: i } = s, n = {
    xmin: t.min,
    xmax: t.max,
    ymin: e.min,
    ymax: e.max
  };
  if (!i)
    return s._scaleRanges = n, !0;
  const r = i.xmin !== t.min || i.xmax !== t.max || i.ymin !== e.min || i.ymax !== e.max;
  return Object.assign(i, n), r;
}
const Vs = (s) => s === 0 || s === 1, Gr = (s, t, e) => -(Math.pow(2, 10 * (s -= 1)) * Math.sin((s - t) * G / e)), Kr = (s, t, e) => Math.pow(2, -10 * s) * Math.sin((s - t) * G / e) + 1, _s = {
  linear: (s) => s,
  easeInQuad: (s) => s * s,
  easeOutQuad: (s) => -s * (s - 2),
  easeInOutQuad: (s) => (s /= 0.5) < 1 ? 0.5 * s * s : -0.5 * (--s * (s - 2) - 1),
  easeInCubic: (s) => s * s * s,
  easeOutCubic: (s) => (s -= 1) * s * s + 1,
  easeInOutCubic: (s) => (s /= 0.5) < 1 ? 0.5 * s * s * s : 0.5 * ((s -= 2) * s * s + 2),
  easeInQuart: (s) => s * s * s * s,
  easeOutQuart: (s) => -((s -= 1) * s * s * s - 1),
  easeInOutQuart: (s) => (s /= 0.5) < 1 ? 0.5 * s * s * s * s : -0.5 * ((s -= 2) * s * s * s - 2),
  easeInQuint: (s) => s * s * s * s * s,
  easeOutQuint: (s) => (s -= 1) * s * s * s * s + 1,
  easeInOutQuint: (s) => (s /= 0.5) < 1 ? 0.5 * s * s * s * s * s : 0.5 * ((s -= 2) * s * s * s * s + 2),
  easeInSine: (s) => -Math.cos(s * at) + 1,
  easeOutSine: (s) => Math.sin(s * at),
  easeInOutSine: (s) => -0.5 * (Math.cos(K * s) - 1),
  easeInExpo: (s) => s === 0 ? 0 : Math.pow(2, 10 * (s - 1)),
  easeOutExpo: (s) => s === 1 ? 1 : -Math.pow(2, -10 * s) + 1,
  easeInOutExpo: (s) => Vs(s) ? s : s < 0.5 ? 0.5 * Math.pow(2, 10 * (s * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (s * 2 - 1)) + 2),
  easeInCirc: (s) => s >= 1 ? s : -(Math.sqrt(1 - s * s) - 1),
  easeOutCirc: (s) => Math.sqrt(1 - (s -= 1) * s),
  easeInOutCirc: (s) => (s /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - s * s) - 1) : 0.5 * (Math.sqrt(1 - (s -= 2) * s) + 1),
  easeInElastic: (s) => Vs(s) ? s : Gr(s, 0.075, 0.3),
  easeOutElastic: (s) => Vs(s) ? s : Kr(s, 0.075, 0.3),
  easeInOutElastic(s) {
    return Vs(s) ? s : s < 0.5 ? 0.5 * Gr(s * 2, 0.1125, 0.45) : 0.5 + 0.5 * Kr(s * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(s) {
    return s * s * ((1.70158 + 1) * s - 1.70158);
  },
  easeOutBack(s) {
    return (s -= 1) * s * ((1.70158 + 1) * s + 1.70158) + 1;
  },
  easeInOutBack(s) {
    let t = 1.70158;
    return (s /= 0.5) < 1 ? 0.5 * (s * s * (((t *= 1.525) + 1) * s - t)) : 0.5 * ((s -= 2) * s * (((t *= 1.525) + 1) * s + t) + 2);
  },
  easeInBounce: (s) => 1 - _s.easeOutBounce(1 - s),
  easeOutBounce(s) {
    return s < 1 / 2.75 ? 7.5625 * s * s : s < 2 / 2.75 ? 7.5625 * (s -= 1.5 / 2.75) * s + 0.75 : s < 2.5 / 2.75 ? 7.5625 * (s -= 2.25 / 2.75) * s + 0.9375 : 7.5625 * (s -= 2.625 / 2.75) * s + 0.984375;
  },
  easeInOutBounce: (s) => s < 0.5 ? _s.easeInBounce(s * 2) * 0.5 : _s.easeOutBounce(s * 2 - 1) * 0.5 + 0.5
};
function Hn(s) {
  if (s && typeof s == "object") {
    const t = s.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function Yr(s) {
  return Hn(s) ? s : new vs(s);
}
function Ki(s) {
  return Hn(s) ? s : new vs(s).saturate(0.5).darken(0.1).hexString();
}
const id = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], nd = [
  "color",
  "borderColor",
  "backgroundColor"
];
function rd(s) {
  s.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), s.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), s.set("animations", {
    colors: {
      type: "color",
      properties: nd
    },
    numbers: {
      type: "number",
      properties: id
    }
  }), s.describe("animations", {
    _fallback: "animation"
  }), s.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function ad(s) {
  s.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Xr = /* @__PURE__ */ new Map();
function od(s, t) {
  t = t || {};
  const e = s + JSON.stringify(t);
  let i = Xr.get(e);
  return i || (i = new Intl.NumberFormat(s, t), Xr.set(e, i)), i;
}
function As(s, t, e) {
  return od(t, e).format(s);
}
const rl = {
  values(s) {
    return Z(s) ? s : "" + s;
  },
  numeric(s, t, e) {
    if (s === 0)
      return "0";
    const i = this.chart.options.locale;
    let n, r = s;
    if (e.length > 1) {
      const c = Math.max(Math.abs(e[0].value), Math.abs(e[e.length - 1].value));
      (c < 1e-4 || c > 1e15) && (n = "scientific"), r = ld(s, e);
    }
    const a = ae(Math.abs(r)), o = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), l = {
      notation: n,
      minimumFractionDigits: o,
      maximumFractionDigits: o
    };
    return Object.assign(l, this.options.ticks.format), As(s, i, l);
  },
  logarithmic(s, t, e) {
    if (s === 0)
      return "0";
    const i = e[t].significand || s / Math.pow(10, Math.floor(ae(s)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(i) || t > 0.8 * e.length ? rl.numeric.call(this, s, t, e) : "";
  }
};
function ld(s, t) {
  let e = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(e) >= 1 && s !== Math.floor(s) && (e = s - Math.floor(s)), e;
}
var Si = {
  formatters: rl
};
function cd(s) {
  s.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, e) => e.lineWidth,
      tickColor: (t, e) => e.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Si.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), s.route("scale.ticks", "color", "", "color"), s.route("scale.grid", "color", "", "borderColor"), s.route("scale.border", "color", "", "borderColor"), s.route("scale.title", "color", "", "color"), s.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), s.describe("scales", {
    _fallback: "scale"
  }), s.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const Ie = /* @__PURE__ */ Object.create(null), gn = /* @__PURE__ */ Object.create(null);
function ys(s, t) {
  if (!t)
    return s;
  const e = t.split(".");
  for (let i = 0, n = e.length; i < n; ++i) {
    const r = e[i];
    s = s[r] || (s[r] = /* @__PURE__ */ Object.create(null));
  }
  return s;
}
function Yi(s, t, e) {
  return typeof t == "string" ? ks(ys(s, t), e) : ks(ys(s, ""), t);
}
class ud {
  constructor(t, e) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (i) => i.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (i, n) => Ki(n.backgroundColor), this.hoverBorderColor = (i, n) => Ki(n.borderColor), this.hoverColor = (i, n) => Ki(n.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(e);
  }
  set(t, e) {
    return Yi(this, t, e);
  }
  get(t) {
    return ys(this, t);
  }
  describe(t, e) {
    return Yi(gn, t, e);
  }
  override(t, e) {
    return Yi(Ie, t, e);
  }
  route(t, e, i, n) {
    const r = ys(this, t), a = ys(this, i), o = "_" + e;
    Object.defineProperties(r, {
      [o]: {
        value: r[e],
        writable: !0
      },
      [e]: {
        enumerable: !0,
        get() {
          const l = this[o], c = a[n];
          return U(l) ? Object.assign({}, c, l) : D(l, c);
        },
        set(l) {
          this[o] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((e) => e(this));
  }
}
var nt = /* @__PURE__ */ new ud({
  _scriptable: (s) => !s.startsWith("on"),
  _indexable: (s) => s !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  rd,
  ad,
  cd
]);
function dd(s) {
  return !s || N(s.size) || N(s.family) ? null : (s.style ? s.style + " " : "") + (s.weight ? s.weight + " " : "") + s.size + "px " + s.family;
}
function yi(s, t, e, i, n) {
  let r = t[n];
  return r || (r = t[n] = s.measureText(n).width, e.push(n)), r > i && (i = r), i;
}
function pd(s, t, e, i) {
  i = i || {};
  let n = i.data = i.data || {}, r = i.garbageCollect = i.garbageCollect || [];
  i.font !== t && (n = i.data = {}, r = i.garbageCollect = [], i.font = t), s.save(), s.font = t;
  let a = 0;
  const o = e.length;
  let l, c, u, d, p;
  for (l = 0; l < o; l++)
    if (d = e[l], d != null && !Z(d))
      a = yi(s, n, r, a, d);
    else if (Z(d))
      for (c = 0, u = d.length; c < u; c++)
        p = d[c], p != null && !Z(p) && (a = yi(s, n, r, a, p));
  s.restore();
  const h = r.length / 2;
  if (h > e.length) {
    for (l = 0; l < h; l++)
      delete n[r[l]];
    r.splice(0, h);
  }
  return a;
}
function ge(s, t, e) {
  const i = s.currentDevicePixelRatio, n = e !== 0 ? Math.max(e / 2, 0.5) : 0;
  return Math.round((t - n) * i) / i + n;
}
function Zr(s, t) {
  t = t || s.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, s.width, s.height), t.restore();
}
function _n(s, t, e, i) {
  al(s, t, e, i, null);
}
function al(s, t, e, i, n) {
  let r, a, o, l, c, u, d, p;
  const h = t.pointStyle, m = t.rotation, _ = t.radius;
  let y = (m || 0) * Gu;
  if (h && typeof h == "object" && (r = h.toString(), r === "[object HTMLImageElement]" || r === "[object HTMLCanvasElement]")) {
    s.save(), s.translate(e, i), s.rotate(y), s.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), s.restore();
    return;
  }
  if (!(isNaN(_) || _ <= 0)) {
    switch (s.beginPath(), h) {
      default:
        n ? s.ellipse(e, i, n / 2, _, 0, 0, G) : s.arc(e, i, _, 0, G), s.closePath();
        break;
      case "triangle":
        u = n ? n / 2 : _, s.moveTo(e + Math.sin(y) * u, i - Math.cos(y) * _), y += zr, s.lineTo(e + Math.sin(y) * u, i - Math.cos(y) * _), y += zr, s.lineTo(e + Math.sin(y) * u, i - Math.cos(y) * _), s.closePath();
        break;
      case "rectRounded":
        c = _ * 0.516, l = _ - c, a = Math.cos(y + me) * l, d = Math.cos(y + me) * (n ? n / 2 - c : l), o = Math.sin(y + me) * l, p = Math.sin(y + me) * (n ? n / 2 - c : l), s.arc(e - d, i - o, c, y - K, y - at), s.arc(e + p, i - a, c, y - at, y), s.arc(e + d, i + o, c, y, y + at), s.arc(e - p, i + a, c, y + at, y + K), s.closePath();
        break;
      case "rect":
        if (!m) {
          l = Math.SQRT1_2 * _, u = n ? n / 2 : l, s.rect(e - u, i - l, 2 * u, 2 * l);
          break;
        }
        y += me;
      case "rectRot":
        d = Math.cos(y) * (n ? n / 2 : _), a = Math.cos(y) * _, o = Math.sin(y) * _, p = Math.sin(y) * (n ? n / 2 : _), s.moveTo(e - d, i - o), s.lineTo(e + p, i - a), s.lineTo(e + d, i + o), s.lineTo(e - p, i + a), s.closePath();
        break;
      case "crossRot":
        y += me;
      case "cross":
        d = Math.cos(y) * (n ? n / 2 : _), a = Math.cos(y) * _, o = Math.sin(y) * _, p = Math.sin(y) * (n ? n / 2 : _), s.moveTo(e - d, i - o), s.lineTo(e + d, i + o), s.moveTo(e + p, i - a), s.lineTo(e - p, i + a);
        break;
      case "star":
        d = Math.cos(y) * (n ? n / 2 : _), a = Math.cos(y) * _, o = Math.sin(y) * _, p = Math.sin(y) * (n ? n / 2 : _), s.moveTo(e - d, i - o), s.lineTo(e + d, i + o), s.moveTo(e + p, i - a), s.lineTo(e - p, i + a), y += me, d = Math.cos(y) * (n ? n / 2 : _), a = Math.cos(y) * _, o = Math.sin(y) * _, p = Math.sin(y) * (n ? n / 2 : _), s.moveTo(e - d, i - o), s.lineTo(e + d, i + o), s.moveTo(e + p, i - a), s.lineTo(e - p, i + a);
        break;
      case "line":
        a = n ? n / 2 : Math.cos(y) * _, o = Math.sin(y) * _, s.moveTo(e - a, i - o), s.lineTo(e + a, i + o);
        break;
      case "dash":
        s.moveTo(e, i), s.lineTo(e + Math.cos(y) * (n ? n / 2 : _), i + Math.sin(y) * _);
        break;
      case !1:
        s.closePath();
        break;
    }
    s.fill(), t.borderWidth > 0 && s.stroke();
  }
}
function se(s, t, e) {
  return e = e || 0.5, !t || s && s.x > t.left - e && s.x < t.right + e && s.y > t.top - e && s.y < t.bottom + e;
}
function Ti(s, t) {
  s.save(), s.beginPath(), s.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), s.clip();
}
function Ii(s) {
  s.restore();
}
function hd(s, t, e, i, n) {
  if (!t)
    return s.lineTo(e.x, e.y);
  if (n === "middle") {
    const r = (t.x + e.x) / 2;
    s.lineTo(r, t.y), s.lineTo(r, e.y);
  } else n === "after" != !!i ? s.lineTo(t.x, e.y) : s.lineTo(e.x, t.y);
  s.lineTo(e.x, e.y);
}
function fd(s, t, e, i) {
  if (!t)
    return s.lineTo(e.x, e.y);
  s.bezierCurveTo(i ? t.cp1x : t.cp2x, i ? t.cp1y : t.cp2y, i ? e.cp2x : e.cp1x, i ? e.cp2y : e.cp1y, e.x, e.y);
}
function md(s, t) {
  t.translation && s.translate(t.translation[0], t.translation[1]), N(t.rotation) || s.rotate(t.rotation), t.color && (s.fillStyle = t.color), t.textAlign && (s.textAlign = t.textAlign), t.textBaseline && (s.textBaseline = t.textBaseline);
}
function gd(s, t, e, i, n) {
  if (n.strikethrough || n.underline) {
    const r = s.measureText(i), a = t - r.actualBoundingBoxLeft, o = t + r.actualBoundingBoxRight, l = e - r.actualBoundingBoxAscent, c = e + r.actualBoundingBoxDescent, u = n.strikethrough ? (l + c) / 2 : c;
    s.strokeStyle = s.fillStyle, s.beginPath(), s.lineWidth = n.decorationWidth || 2, s.moveTo(a, u), s.lineTo(o, u), s.stroke();
  }
}
function _d(s, t) {
  const e = s.fillStyle;
  s.fillStyle = t.color, s.fillRect(t.left, t.top, t.width, t.height), s.fillStyle = e;
}
function Ae(s, t, e, i, n, r = {}) {
  const a = Z(t) ? t : [
    t
  ], o = r.strokeWidth > 0 && r.strokeColor !== "";
  let l, c;
  for (s.save(), s.font = n.string, md(s, r), l = 0; l < a.length; ++l)
    c = a[l], r.backdrop && _d(s, r.backdrop), o && (r.strokeColor && (s.strokeStyle = r.strokeColor), N(r.strokeWidth) || (s.lineWidth = r.strokeWidth), s.strokeText(c, e, i, r.maxWidth)), s.fillText(c, e, i, r.maxWidth), gd(s, e, i, c, r), i += Number(n.lineHeight);
  s.restore();
}
function ws(s, t) {
  const { x: e, y: i, w: n, h: r, radius: a } = t;
  s.arc(e + a.topLeft, i + a.topLeft, a.topLeft, 1.5 * K, K, !0), s.lineTo(e, i + r - a.bottomLeft), s.arc(e + a.bottomLeft, i + r - a.bottomLeft, a.bottomLeft, K, at, !0), s.lineTo(e + n - a.bottomRight, i + r), s.arc(e + n - a.bottomRight, i + r - a.bottomRight, a.bottomRight, at, 0, !0), s.lineTo(e + n, i + a.topRight), s.arc(e + n - a.topRight, i + a.topRight, a.topRight, 0, -at, !0), s.lineTo(e + a.topLeft, i);
}
const yd = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, bd = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function vd(s, t) {
  const e = ("" + s).match(yd);
  if (!e || e[1] === "normal")
    return t * 1.2;
  switch (s = +e[2], e[3]) {
    case "px":
      return s;
    case "%":
      s /= 100;
      break;
  }
  return t * s;
}
const kd = (s) => +s || 0;
function Wn(s, t) {
  const e = {}, i = U(t), n = i ? Object.keys(t) : t, r = U(s) ? i ? (a) => D(s[a], s[t[a]]) : (a) => s[a] : () => s;
  for (const a of n)
    e[a] = kd(r(a));
  return e;
}
function ol(s) {
  return Wn(s, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function we(s) {
  return Wn(s, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function gt(s) {
  const t = ol(s);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function ot(s, t) {
  s = s || {}, t = t || nt.font;
  let e = D(s.size, t.size);
  typeof e == "string" && (e = parseInt(e, 10));
  let i = D(s.style, t.style);
  i && !("" + i).match(bd) && (console.warn('Invalid font style specified: "' + i + '"'), i = void 0);
  const n = {
    family: D(s.family, t.family),
    lineHeight: vd(D(s.lineHeight, t.lineHeight), e),
    size: e,
    style: i,
    weight: D(s.weight, t.weight),
    string: ""
  };
  return n.string = dd(n), n;
}
function us(s, t, e, i) {
  let n, r, a;
  for (n = 0, r = s.length; n < r; ++n)
    if (a = s[n], a !== void 0 && a !== void 0)
      return a;
}
function xd(s, t, e) {
  const { min: i, max: n } = s, r = Yo(t, (n - i) / 2), a = (o, l) => e && o === 0 ? 0 : o + l;
  return {
    min: a(i, -Math.abs(r)),
    max: a(n, r)
  };
}
function he(s, t) {
  return Object.assign(Object.create(s), t);
}
function Gn(s, t = [
  ""
], e, i, n = () => s[0]) {
  const r = e || s;
  typeof i > "u" && (i = dl("_fallback", s));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: s,
    _rootScopes: r,
    _fallback: i,
    _getTarget: n,
    override: (o) => Gn([
      o,
      ...s
    ], t, r, i)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(o, l) {
      return delete o[l], delete o._keys, delete s[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(o, l) {
      return cl(o, l, () => Pd(l, t, s, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(o, l) {
      return Reflect.getOwnPropertyDescriptor(o._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(s[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(o, l) {
      return Jr(o).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(o) {
      return Jr(o);
    },
    /**
    * A trap for setting property values.
    */
    set(o, l, c) {
      const u = o._storage || (o._storage = n());
      return o[l] = u[l] = c, delete o._keys, !0;
    }
  });
}
function Ve(s, t, e, i) {
  const n = {
    _cacheable: !1,
    _proxy: s,
    _context: t,
    _subProxy: e,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: ll(s, i),
    setContext: (r) => Ve(s, r, e, i),
    override: (r) => Ve(s.override(r), t, e, i)
  };
  return new Proxy(n, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(r, a) {
      return delete r[a], delete s[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(r, a, o) {
      return cl(r, a, () => wd(r, a, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(r, a) {
      return r._descriptors.allKeys ? Reflect.has(s, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(s, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(s);
    },
    /**
    * A trap for the in operator.
    */
    has(r, a) {
      return Reflect.has(s, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(s);
    },
    /**
    * A trap for setting property values.
    */
    set(r, a, o) {
      return s[a] = o, delete r[a], !0;
    }
  });
}
function ll(s, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: e = t.scriptable, _indexable: i = t.indexable, _allKeys: n = t.allKeys } = s;
  return {
    allKeys: n,
    scriptable: e,
    indexable: i,
    isScriptable: de(e) ? e : () => e,
    isIndexable: de(i) ? i : () => i
  };
}
const Cd = (s, t) => s ? s + Bn(t) : t, Kn = (s, t) => U(t) && s !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function cl(s, t, e) {
  if (Object.prototype.hasOwnProperty.call(s, t))
    return s[t];
  const i = e();
  return s[t] = i, i;
}
function wd(s, t, e) {
  const { _proxy: i, _context: n, _subProxy: r, _descriptors: a } = s;
  let o = i[t];
  return de(o) && a.isScriptable(t) && (o = $d(t, o, s, e)), Z(o) && o.length && (o = Sd(t, o, s, a.isIndexable)), Kn(t, o) && (o = Ve(o, n, r && r[t], a)), o;
}
function $d(s, t, e, i) {
  const { _proxy: n, _context: r, _subProxy: a, _stack: o } = e;
  if (o.has(s))
    throw new Error("Recursion detected: " + Array.from(o).join("->") + "->" + s);
  o.add(s);
  let l = t(r, a || i);
  return o.delete(s), Kn(s, l) && (l = Yn(n._scopes, n, s, l)), l;
}
function Sd(s, t, e, i) {
  const { _proxy: n, _context: r, _subProxy: a, _descriptors: o } = e;
  if (typeof r.index < "u" && i(s))
    return t[r.index % t.length];
  if (U(t[0])) {
    const l = t, c = n._scopes.filter((u) => u !== l);
    t = [];
    for (const u of l) {
      const d = Yn(c, n, s, u);
      t.push(Ve(d, r, a && a[s], o));
    }
  }
  return t;
}
function ul(s, t, e) {
  return de(s) ? s(t, e) : s;
}
const Td = (s, t) => s === !0 ? t : typeof s == "string" ? ue(t, s) : void 0;
function Id(s, t, e, i, n) {
  for (const r of t) {
    const a = Td(e, r);
    if (a) {
      s.add(a);
      const o = ul(a._fallback, e, n);
      if (typeof o < "u" && o !== e && o !== i)
        return o;
    } else if (a === !1 && typeof i < "u" && e !== i)
      return null;
  }
  return !1;
}
function Yn(s, t, e, i) {
  const n = t._rootScopes, r = ul(t._fallback, e, i), a = [
    ...s,
    ...n
  ], o = /* @__PURE__ */ new Set();
  o.add(i);
  let l = Qr(o, a, e, r || e, i);
  return l === null || typeof r < "u" && r !== e && (l = Qr(o, a, r, l, i), l === null) ? !1 : Gn(Array.from(o), [
    ""
  ], n, r, () => Ad(t, e, i));
}
function Qr(s, t, e, i, n) {
  for (; e; )
    e = Id(s, t, e, i, n);
  return e;
}
function Ad(s, t, e) {
  const i = s._getTarget();
  t in i || (i[t] = {});
  const n = i[t];
  return Z(n) && U(e) ? e : n || {};
}
function Pd(s, t, e, i) {
  let n;
  for (const r of t)
    if (n = dl(Cd(r, s), e), typeof n < "u")
      return Kn(s, n) ? Yn(e, i, s, n) : n;
}
function dl(s, t) {
  for (const e of t) {
    if (!e)
      continue;
    const i = e[s];
    if (typeof i < "u")
      return i;
  }
}
function Jr(s) {
  let t = s._keys;
  return t || (t = s._keys = Od(s._scopes)), t;
}
function Od(s) {
  const t = /* @__PURE__ */ new Set();
  for (const e of s)
    for (const i of Object.keys(e).filter((n) => !n.startsWith("_")))
      t.add(i);
  return Array.from(t);
}
function pl(s, t, e, i) {
  const { iScale: n } = s, { key: r = "r" } = this._parsing, a = new Array(i);
  let o, l, c, u;
  for (o = 0, l = i; o < l; ++o)
    c = o + e, u = t[c], a[o] = {
      r: n.parse(ue(u, r), c)
    };
  return a;
}
const Md = Number.EPSILON || 1e-14, He = (s, t) => t < s.length && !s[t].skip && s[t], hl = (s) => s === "x" ? "y" : "x";
function Rd(s, t, e, i) {
  const n = s.skip ? t : s, r = t, a = e.skip ? t : e, o = mn(r, n), l = mn(a, r);
  let c = o / (o + l), u = l / (o + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const d = i * c, p = i * u;
  return {
    previous: {
      x: r.x - d * (a.x - n.x),
      y: r.y - d * (a.y - n.y)
    },
    next: {
      x: r.x + p * (a.x - n.x),
      y: r.y + p * (a.y - n.y)
    }
  };
}
function Ed(s, t, e) {
  const i = s.length;
  let n, r, a, o, l, c = He(s, 0);
  for (let u = 0; u < i - 1; ++u)
    if (l = c, c = He(s, u + 1), !(!l || !c)) {
      if (gs(t[u], 0, Md)) {
        e[u] = e[u + 1] = 0;
        continue;
      }
      n = e[u] / t[u], r = e[u + 1] / t[u], o = Math.pow(n, 2) + Math.pow(r, 2), !(o <= 9) && (a = 3 / Math.sqrt(o), e[u] = n * a * t[u], e[u + 1] = r * a * t[u]);
    }
}
function Dd(s, t, e = "x") {
  const i = hl(e), n = s.length;
  let r, a, o, l = He(s, 0);
  for (let c = 0; c < n; ++c) {
    if (a = o, o = l, l = He(s, c + 1), !o)
      continue;
    const u = o[e], d = o[i];
    a && (r = (u - a[e]) / 3, o[`cp1${e}`] = u - r, o[`cp1${i}`] = d - r * t[c]), l && (r = (l[e] - u) / 3, o[`cp2${e}`] = u + r, o[`cp2${i}`] = d + r * t[c]);
  }
}
function Fd(s, t = "x") {
  const e = hl(t), i = s.length, n = Array(i).fill(0), r = Array(i);
  let a, o, l, c = He(s, 0);
  for (a = 0; a < i; ++a)
    if (o = l, l = c, c = He(s, a + 1), !!l) {
      if (c) {
        const u = c[t] - l[t];
        n[a] = u !== 0 ? (c[e] - l[e]) / u : 0;
      }
      r[a] = o ? c ? Vt(n[a - 1]) !== Vt(n[a]) ? 0 : (n[a - 1] + n[a]) / 2 : n[a - 1] : n[a];
    }
  Ed(s, n, r), Dd(s, r, t);
}
function Hs(s, t, e) {
  return Math.max(Math.min(s, e), t);
}
function Ld(s, t) {
  let e, i, n, r, a, o = se(s[0], t);
  for (e = 0, i = s.length; e < i; ++e)
    a = r, r = o, o = e < i - 1 && se(s[e + 1], t), r && (n = s[e], a && (n.cp1x = Hs(n.cp1x, t.left, t.right), n.cp1y = Hs(n.cp1y, t.top, t.bottom)), o && (n.cp2x = Hs(n.cp2x, t.left, t.right), n.cp2y = Hs(n.cp2y, t.top, t.bottom)));
}
function qd(s, t, e, i, n) {
  let r, a, o, l;
  if (t.spanGaps && (s = s.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    Fd(s, n);
  else {
    let c = i ? s[s.length - 1] : s[0];
    for (r = 0, a = s.length; r < a; ++r)
      o = s[r], l = Rd(c, o, s[Math.min(r + 1, a - (i ? 0 : 1)) % a], t.tension), o.cp1x = l.previous.x, o.cp1y = l.previous.y, o.cp2x = l.next.x, o.cp2y = l.next.y, c = o;
  }
  t.capBezierPoints && Ld(s, e);
}
function Xn() {
  return typeof window < "u" && typeof document < "u";
}
function Zn(s) {
  let t = s.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function bi(s, t, e) {
  let i;
  return typeof s == "string" ? (i = parseInt(s, 10), s.indexOf("%") !== -1 && (i = i / 100 * t.parentNode[e])) : i = s, i;
}
const Ai = (s) => s.ownerDocument.defaultView.getComputedStyle(s, null);
function Ud(s, t) {
  return Ai(s).getPropertyValue(t);
}
const Nd = [
  "top",
  "right",
  "bottom",
  "left"
];
function $e(s, t, e) {
  const i = {};
  e = e ? "-" + e : "";
  for (let n = 0; n < 4; n++) {
    const r = Nd[n];
    i[r] = parseFloat(s[t + "-" + r + e]) || 0;
  }
  return i.width = i.left + i.right, i.height = i.top + i.bottom, i;
}
const Bd = (s, t, e) => (s > 0 || t > 0) && (!e || !e.shadowRoot);
function jd(s, t) {
  const e = s.touches, i = e && e.length ? e[0] : s, { offsetX: n, offsetY: r } = i;
  let a = !1, o, l;
  if (Bd(n, r, s.target))
    o = n, l = r;
  else {
    const c = t.getBoundingClientRect();
    o = i.clientX - c.left, l = i.clientY - c.top, a = !0;
  }
  return {
    x: o,
    y: l,
    box: a
  };
}
function ve(s, t) {
  if ("native" in s)
    return s;
  const { canvas: e, currentDevicePixelRatio: i } = t, n = Ai(e), r = n.boxSizing === "border-box", a = $e(n, "padding"), o = $e(n, "border", "width"), { x: l, y: c, box: u } = jd(s, e), d = a.left + (u && o.left), p = a.top + (u && o.top);
  let { width: h, height: m } = t;
  return r && (h -= a.width + o.width, m -= a.height + o.height), {
    x: Math.round((l - d) / h * e.width / i),
    y: Math.round((c - p) / m * e.height / i)
  };
}
function zd(s, t, e) {
  let i, n;
  if (t === void 0 || e === void 0) {
    const r = Zn(s);
    if (!r)
      t = s.clientWidth, e = s.clientHeight;
    else {
      const a = r.getBoundingClientRect(), o = Ai(r), l = $e(o, "border", "width"), c = $e(o, "padding");
      t = a.width - c.width - l.width, e = a.height - c.height - l.height, i = bi(o.maxWidth, r, "clientWidth"), n = bi(o.maxHeight, r, "clientHeight");
    }
  }
  return {
    width: t,
    height: e,
    maxWidth: i || _i,
    maxHeight: n || _i
  };
}
const Ws = (s) => Math.round(s * 10) / 10;
function Vd(s, t, e, i) {
  const n = Ai(s), r = $e(n, "margin"), a = bi(n.maxWidth, s, "clientWidth") || _i, o = bi(n.maxHeight, s, "clientHeight") || _i, l = zd(s, t, e);
  let { width: c, height: u } = l;
  if (n.boxSizing === "content-box") {
    const p = $e(n, "border", "width"), h = $e(n, "padding");
    c -= h.width + p.width, u -= h.height + p.height;
  }
  return c = Math.max(0, c - r.width), u = Math.max(0, i ? c / i : u - r.height), c = Ws(Math.min(c, a, l.maxWidth)), u = Ws(Math.min(u, o, l.maxHeight)), c && !u && (u = Ws(c / 2)), (t !== void 0 || e !== void 0) && i && l.height && u > l.height && (u = l.height, c = Ws(Math.floor(u * i))), {
    width: c,
    height: u
  };
}
function ta(s, t, e) {
  const i = t || 1, n = Math.floor(s.height * i), r = Math.floor(s.width * i);
  s.height = Math.floor(s.height), s.width = Math.floor(s.width);
  const a = s.canvas;
  return a.style && (e || !a.style.height && !a.style.width) && (a.style.height = `${s.height}px`, a.style.width = `${s.width}px`), s.currentDevicePixelRatio !== i || a.height !== n || a.width !== r ? (s.currentDevicePixelRatio = i, a.height = n, a.width = r, s.ctx.setTransform(i, 0, 0, i, 0, 0), !0) : !1;
}
const Hd = function() {
  let s = !1;
  try {
    const t = {
      get passive() {
        return s = !0, !1;
      }
    };
    Xn() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return s;
}();
function ea(s, t) {
  const e = Ud(s, t), i = e && e.match(/^(\d+)(\.\d+)?px$/);
  return i ? +i[1] : void 0;
}
function ke(s, t, e, i) {
  return {
    x: s.x + e * (t.x - s.x),
    y: s.y + e * (t.y - s.y)
  };
}
function Wd(s, t, e, i) {
  return {
    x: s.x + e * (t.x - s.x),
    y: i === "middle" ? e < 0.5 ? s.y : t.y : i === "after" ? e < 1 ? s.y : t.y : e > 0 ? t.y : s.y
  };
}
function Gd(s, t, e, i) {
  const n = {
    x: s.cp2x,
    y: s.cp2y
  }, r = {
    x: t.cp1x,
    y: t.cp1y
  }, a = ke(s, n, e), o = ke(n, r, e), l = ke(r, t, e), c = ke(a, o, e), u = ke(o, l, e);
  return ke(c, u, e);
}
const Kd = function(s, t) {
  return {
    x(e) {
      return s + s + t - e;
    },
    setWidth(e) {
      t = e;
    },
    textAlign(e) {
      return e === "center" ? e : e === "right" ? "left" : "right";
    },
    xPlus(e, i) {
      return e - i;
    },
    leftForLtr(e, i) {
      return e - i;
    }
  };
}, Yd = function() {
  return {
    x(s) {
      return s;
    },
    setWidth(s) {
    },
    textAlign(s) {
      return s;
    },
    xPlus(s, t) {
      return s + t;
    },
    leftForLtr(s, t) {
      return s;
    }
  };
};
function je(s, t, e) {
  return s ? Kd(t, e) : Yd();
}
function fl(s, t) {
  let e, i;
  (t === "ltr" || t === "rtl") && (e = s.canvas.style, i = [
    e.getPropertyValue("direction"),
    e.getPropertyPriority("direction")
  ], e.setProperty("direction", t, "important"), s.prevTextDirection = i);
}
function ml(s, t) {
  t !== void 0 && (delete s.prevTextDirection, s.canvas.style.setProperty("direction", t[0], t[1]));
}
function gl(s) {
  return s === "angle" ? {
    between: Cs,
    compare: Xu,
    normalize: It
  } : {
    between: te,
    compare: (t, e) => t - e,
    normalize: (t) => t
  };
}
function sa({ start: s, end: t, count: e, loop: i, style: n }) {
  return {
    start: s % e,
    end: t % e,
    loop: i && (t - s + 1) % e === 0,
    style: n
  };
}
function Xd(s, t, e) {
  const { property: i, start: n, end: r } = e, { between: a, normalize: o } = gl(i), l = t.length;
  let { start: c, end: u, loop: d } = s, p, h;
  if (d) {
    for (c += l, u += l, p = 0, h = l; p < h && a(o(t[c % l][i]), n, r); ++p)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: d,
    style: s.style
  };
}
function _l(s, t, e) {
  if (!e)
    return [
      s
    ];
  const { property: i, start: n, end: r } = e, a = t.length, { compare: o, between: l, normalize: c } = gl(i), { start: u, end: d, loop: p, style: h } = Xd(s, t, e), m = [];
  let _ = !1, y = null, v, k, w;
  const x = () => l(n, w, v) && o(n, w) !== 0, C = () => o(r, v) === 0 || l(r, w, v), $ = () => _ || x(), S = () => !_ || C();
  for (let I = u, R = u; I <= d; ++I)
    k = t[I % a], !k.skip && (v = c(k[i]), v !== w && (_ = l(v, n, r), y === null && $() && (y = o(v, n) === 0 ? I : R), y !== null && S() && (m.push(sa({
      start: y,
      end: I,
      loop: p,
      count: a,
      style: h
    })), y = null), R = I, w = v));
  return y !== null && m.push(sa({
    start: y,
    end: d,
    loop: p,
    count: a,
    style: h
  })), m;
}
function yl(s, t) {
  const e = [], i = s.segments;
  for (let n = 0; n < i.length; n++) {
    const r = _l(i[n], s.points, t);
    r.length && e.push(...r);
  }
  return e;
}
function Zd(s, t, e, i) {
  let n = 0, r = t - 1;
  if (e && !i)
    for (; n < t && !s[n].skip; )
      n++;
  for (; n < t && s[n].skip; )
    n++;
  for (n %= t, e && (r += n); r > n && s[r % t].skip; )
    r--;
  return r %= t, {
    start: n,
    end: r
  };
}
function Qd(s, t, e, i) {
  const n = s.length, r = [];
  let a = t, o = s[t], l;
  for (l = t + 1; l <= e; ++l) {
    const c = s[l % n];
    c.skip || c.stop ? o.skip || (i = !1, r.push({
      start: t % n,
      end: (l - 1) % n,
      loop: i
    }), t = a = c.stop ? l : null) : (a = l, o.skip && (t = l)), o = c;
  }
  return a !== null && r.push({
    start: t % n,
    end: a % n,
    loop: i
  }), r;
}
function Jd(s, t) {
  const e = s.points, i = s.options.spanGaps, n = e.length;
  if (!n)
    return [];
  const r = !!s._loop, { start: a, end: o } = Zd(e, n, r, i);
  if (i === !0)
    return ia(s, [
      {
        start: a,
        end: o,
        loop: r
      }
    ], e, t);
  const l = o < a ? o + n : o, c = !!s._fullLoop && a === 0 && o === n - 1;
  return ia(s, Qd(e, a, l, c), e, t);
}
function ia(s, t, e, i) {
  return !i || !i.setContext || !e ? t : tp(s, t, e, i);
}
function tp(s, t, e, i) {
  const n = s._chart.getContext(), r = na(s.options), { _datasetIndex: a, options: { spanGaps: o } } = s, l = e.length, c = [];
  let u = r, d = t[0].start, p = d;
  function h(m, _, y, v) {
    const k = o ? -1 : 1;
    if (m !== _) {
      for (m += l; e[m % l].skip; )
        m -= k;
      for (; e[_ % l].skip; )
        _ += k;
      m % l !== _ % l && (c.push({
        start: m % l,
        end: _ % l,
        loop: y,
        style: v
      }), u = v, d = _ % l);
    }
  }
  for (const m of t) {
    d = o ? d : m.start;
    let _ = e[d % l], y;
    for (p = d + 1; p <= m.end; p++) {
      const v = e[p % l];
      y = na(i.setContext(he(n, {
        type: "segment",
        p0: _,
        p1: v,
        p0DataIndex: (p - 1) % l,
        p1DataIndex: p % l,
        datasetIndex: a
      }))), ep(y, u) && h(d, p - 1, m.loop, u), _ = v, u = y;
    }
    d < p - 1 && h(d, p - 1, m.loop, u);
  }
  return c;
}
function na(s) {
  return {
    backgroundColor: s.backgroundColor,
    borderCapStyle: s.borderCapStyle,
    borderDash: s.borderDash,
    borderDashOffset: s.borderDashOffset,
    borderJoinStyle: s.borderJoinStyle,
    borderWidth: s.borderWidth,
    borderColor: s.borderColor
  };
}
function ep(s, t) {
  if (!t)
    return !1;
  const e = [], i = function(n, r) {
    return Hn(r) ? (e.includes(r) || e.push(r), e.indexOf(r)) : r;
  };
  return JSON.stringify(s, i) !== JSON.stringify(t, i);
}
/*!
 * Chart.js v4.4.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class sp {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, e, i, n) {
    const r = e.listeners[n], a = e.duration;
    r.forEach((o) => o({
      chart: t,
      initial: e.initial,
      numSteps: a,
      currentStep: Math.min(i - e.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = el.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let e = 0;
    this._charts.forEach((i, n) => {
      if (!i.running || !i.items.length)
        return;
      const r = i.items;
      let a = r.length - 1, o = !1, l;
      for (; a >= 0; --a)
        l = r[a], l._active ? (l._total > i.duration && (i.duration = l._total), l.tick(t), o = !0) : (r[a] = r[r.length - 1], r.pop());
      o && (n.draw(), this._notify(n, i, t, "progress")), r.length || (i.running = !1, this._notify(n, i, t, "complete"), i.initial = !1), e += r.length;
    }), this._lastDate = t, e === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const e = this._charts;
    let i = e.get(t);
    return i || (i = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, e.set(t, i)), i;
  }
  listen(t, e, i) {
    this._getAnims(t).listeners[e].push(i);
  }
  add(t, e) {
    !e || !e.length || this._getAnims(t).items.push(...e);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const e = this._charts.get(t);
    e && (e.running = !0, e.start = Date.now(), e.duration = e.items.reduce((i, n) => Math.max(i, n._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const e = this._charts.get(t);
    return !(!e || !e.running || !e.items.length);
  }
  stop(t) {
    const e = this._charts.get(t);
    if (!e || !e.items.length)
      return;
    const i = e.items;
    let n = i.length - 1;
    for (; n >= 0; --n)
      i[n].cancel();
    e.items = [], this._notify(t, e, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var Zt = /* @__PURE__ */ new sp();
const ra = "transparent", ip = {
  boolean(s, t, e) {
    return e > 0.5 ? t : s;
  },
  color(s, t, e) {
    const i = Yr(s || ra), n = i.valid && Yr(t || ra);
    return n && n.valid ? n.mix(i, e).hexString() : t;
  },
  number(s, t, e) {
    return s + (t - s) * e;
  }
};
class np {
  constructor(t, e, i, n) {
    const r = e[i];
    n = us([
      t.to,
      n,
      r,
      t.from
    ]);
    const a = us([
      t.from,
      r,
      n
    ]);
    this._active = !0, this._fn = t.fn || ip[t.type || typeof a], this._easing = _s[t.easing] || _s.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = e, this._prop = i, this._from = a, this._to = n, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, e, i) {
    if (this._active) {
      this._notify(!1);
      const n = this._target[this._prop], r = i - this._start, a = this._duration - r;
      this._start = i, this._duration = Math.floor(Math.max(a, t.duration)), this._total += r, this._loop = !!t.loop, this._to = us([
        t.to,
        e,
        n,
        t.from
      ]), this._from = us([
        t.from,
        n,
        e
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const e = t - this._start, i = this._duration, n = this._prop, r = this._from, a = this._loop, o = this._to;
    let l;
    if (this._active = r !== o && (a || e < i), !this._active) {
      this._target[n] = o, this._notify(!0);
      return;
    }
    if (e < 0) {
      this._target[n] = r;
      return;
    }
    l = e / i % 2, l = a && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[n] = this._fn(r, o, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((e, i) => {
      t.push({
        res: e,
        rej: i
      });
    });
  }
  _notify(t) {
    const e = t ? "res" : "rej", i = this._promises || [];
    for (let n = 0; n < i.length; n++)
      i[n][e]();
  }
}
class bl {
  constructor(t, e) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(e);
  }
  configure(t) {
    if (!U(t))
      return;
    const e = Object.keys(nt.animation), i = this._properties;
    Object.getOwnPropertyNames(t).forEach((n) => {
      const r = t[n];
      if (!U(r))
        return;
      const a = {};
      for (const o of e)
        a[o] = r[o];
      (Z(r.properties) && r.properties || [
        n
      ]).forEach((o) => {
        (o === n || !i.has(o)) && i.set(o, a);
      });
    });
  }
  _animateOptions(t, e) {
    const i = e.options, n = ap(t, i);
    if (!n)
      return [];
    const r = this._createAnimations(n, i);
    return i.$shared && rp(t.options.$animations, i).then(() => {
      t.options = i;
    }, () => {
    }), r;
  }
  _createAnimations(t, e) {
    const i = this._properties, n = [], r = t.$animations || (t.$animations = {}), a = Object.keys(e), o = Date.now();
    let l;
    for (l = a.length - 1; l >= 0; --l) {
      const c = a[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        n.push(...this._animateOptions(t, e));
        continue;
      }
      const u = e[c];
      let d = r[c];
      const p = i.get(c);
      if (d)
        if (p && d.active()) {
          d.update(p, u, o);
          continue;
        } else
          d.cancel();
      if (!p || !p.duration) {
        t[c] = u;
        continue;
      }
      r[c] = d = new np(p, t, c, u), n.push(d);
    }
    return n;
  }
  update(t, e) {
    if (this._properties.size === 0) {
      Object.assign(t, e);
      return;
    }
    const i = this._createAnimations(t, e);
    if (i.length)
      return Zt.add(this._chart, i), !0;
  }
}
function rp(s, t) {
  const e = [], i = Object.keys(t);
  for (let n = 0; n < i.length; n++) {
    const r = s[i[n]];
    r && r.active() && e.push(r.wait());
  }
  return Promise.all(e);
}
function ap(s, t) {
  if (!t)
    return;
  let e = s.options;
  if (!e) {
    s.options = t;
    return;
  }
  return e.$shared && (s.options = e = Object.assign({}, e, {
    $shared: !1,
    $animations: {}
  })), e;
}
function aa(s, t) {
  const e = s && s.options || {}, i = e.reverse, n = e.min === void 0 ? t : 0, r = e.max === void 0 ? t : 0;
  return {
    start: i ? r : n,
    end: i ? n : r
  };
}
function op(s, t, e) {
  if (e === !1)
    return !1;
  const i = aa(s, e), n = aa(t, e);
  return {
    top: n.end,
    right: i.end,
    bottom: n.start,
    left: i.start
  };
}
function lp(s) {
  let t, e, i, n;
  return U(s) ? (t = s.top, e = s.right, i = s.bottom, n = s.left) : t = e = i = n = s, {
    top: t,
    right: e,
    bottom: i,
    left: n,
    disabled: s === !1
  };
}
function vl(s, t) {
  const e = [], i = s._getSortedDatasetMetas(t);
  let n, r;
  for (n = 0, r = i.length; n < r; ++n)
    e.push(i[n].index);
  return e;
}
function oa(s, t, e, i = {}) {
  const n = s.keys, r = i.mode === "single";
  let a, o, l, c;
  if (t !== null) {
    for (a = 0, o = n.length; a < o; ++a) {
      if (l = +n[a], l === e) {
        if (i.all)
          continue;
        break;
      }
      c = s.values[l], it(c) && (r || t === 0 || Vt(t) === Vt(c)) && (t += c);
    }
    return t;
  }
}
function cp(s) {
  const t = Object.keys(s), e = new Array(t.length);
  let i, n, r;
  for (i = 0, n = t.length; i < n; ++i)
    r = t[i], e[i] = {
      x: r,
      y: s[r]
    };
  return e;
}
function la(s, t) {
  const e = s && s.options.stacked;
  return e || e === void 0 && t.stack !== void 0;
}
function up(s, t, e) {
  return `${s.id}.${t.id}.${e.stack || e.type}`;
}
function dp(s) {
  const { min: t, max: e, minDefined: i, maxDefined: n } = s.getUserBounds();
  return {
    min: i ? t : Number.NEGATIVE_INFINITY,
    max: n ? e : Number.POSITIVE_INFINITY
  };
}
function pp(s, t, e) {
  const i = s[t] || (s[t] = {});
  return i[e] || (i[e] = {});
}
function ca(s, t, e, i) {
  for (const n of t.getMatchingVisibleMetas(i).reverse()) {
    const r = s[n.index];
    if (e && r > 0 || !e && r < 0)
      return n.index;
  }
  return null;
}
function ua(s, t) {
  const { chart: e, _cachedMeta: i } = s, n = e._stacks || (e._stacks = {}), { iScale: r, vScale: a, index: o } = i, l = r.axis, c = a.axis, u = up(r, a, i), d = t.length;
  let p;
  for (let h = 0; h < d; ++h) {
    const m = t[h], { [l]: _, [c]: y } = m, v = m._stacks || (m._stacks = {});
    p = v[c] = pp(n, u, _), p[o] = y, p._top = ca(p, a, !0, i.type), p._bottom = ca(p, a, !1, i.type);
    const k = p._visualValues || (p._visualValues = {});
    k[o] = y;
  }
}
function Xi(s, t) {
  const e = s.scales;
  return Object.keys(e).filter((i) => e[i].axis === t).shift();
}
function hp(s, t) {
  return he(s, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function fp(s, t, e) {
  return he(s, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: e,
    index: t,
    mode: "default",
    type: "data"
  });
}
function Ze(s, t) {
  const e = s.controller.index, i = s.vScale && s.vScale.axis;
  if (i) {
    t = t || s._parsed;
    for (const n of t) {
      const r = n._stacks;
      if (!r || r[i] === void 0 || r[i][e] === void 0)
        return;
      delete r[i][e], r[i]._visualValues !== void 0 && r[i]._visualValues[e] !== void 0 && delete r[i]._visualValues[e];
    }
  }
}
const Zi = (s) => s === "reset" || s === "none", da = (s, t) => t ? s : Object.assign({}, s), mp = (s, t, e) => s && !t.hidden && t._stacked && {
  keys: vl(e, !0),
  values: null
};
class Lt {
  constructor(t, e) {
    this.chart = t, this._ctx = t.ctx, this.index = e, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = la(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && Ze(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, e = this._cachedMeta, i = this.getDataset(), n = (d, p, h, m) => d === "x" ? p : d === "r" ? m : h, r = e.xAxisID = D(i.xAxisID, Xi(t, "x")), a = e.yAxisID = D(i.yAxisID, Xi(t, "y")), o = e.rAxisID = D(i.rAxisID, Xi(t, "r")), l = e.indexAxis, c = e.iAxisID = n(l, r, a, o), u = e.vAxisID = n(l, a, r, o);
    e.xScale = this.getScaleForId(r), e.yScale = this.getScaleForId(a), e.rScale = this.getScaleForId(o), e.iScale = this.getScaleForId(c), e.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const e = this._cachedMeta;
    return t === e.iScale ? e.vScale : e.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && Wr(this._data, this), t._stacked && Ze(t);
  }
  _dataCheck() {
    const t = this.getDataset(), e = t.data || (t.data = []), i = this._data;
    if (U(e))
      this._data = cp(e);
    else if (i !== e) {
      if (i) {
        Wr(i, this);
        const n = this._cachedMeta;
        Ze(n), n._parsed = [];
      }
      e && Object.isExtensible(e) && td(e, this), this._syncList = [], this._data = e;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const e = this._cachedMeta, i = this.getDataset();
    let n = !1;
    this._dataCheck();
    const r = e._stacked;
    e._stacked = la(e.vScale, e), e.stack !== i.stack && (n = !0, Ze(e), e.stack = i.stack), this._resyncElements(t), (n || r !== e._stacked) && ua(this, e._parsed);
  }
  configure() {
    const t = this.chart.config, e = t.datasetScopeKeys(this._type), i = t.getOptionScopes(this.getDataset(), e, !0);
    this.options = t.createResolver(i, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, e) {
    const { _cachedMeta: i, _data: n } = this, { iScale: r, _stacked: a } = i, o = r.axis;
    let l = t === 0 && e === n.length ? !0 : i._sorted, c = t > 0 && i._parsed[t - 1], u, d, p;
    if (this._parsing === !1)
      i._parsed = n, i._sorted = !0, p = n;
    else {
      Z(n[t]) ? p = this.parseArrayData(i, n, t, e) : U(n[t]) ? p = this.parseObjectData(i, n, t, e) : p = this.parsePrimitiveData(i, n, t, e);
      const h = () => d[o] === null || c && d[o] < c[o];
      for (u = 0; u < e; ++u)
        i._parsed[u + t] = d = p[u], l && (h() && (l = !1), c = d);
      i._sorted = l;
    }
    a && ua(this, p);
  }
  parsePrimitiveData(t, e, i, n) {
    const { iScale: r, vScale: a } = t, o = r.axis, l = a.axis, c = r.getLabels(), u = r === a, d = new Array(n);
    let p, h, m;
    for (p = 0, h = n; p < h; ++p)
      m = p + i, d[p] = {
        [o]: u || r.parse(c[m], m),
        [l]: a.parse(e[m], m)
      };
    return d;
  }
  parseArrayData(t, e, i, n) {
    const { xScale: r, yScale: a } = t, o = new Array(n);
    let l, c, u, d;
    for (l = 0, c = n; l < c; ++l)
      u = l + i, d = e[u], o[l] = {
        x: r.parse(d[0], u),
        y: a.parse(d[1], u)
      };
    return o;
  }
  parseObjectData(t, e, i, n) {
    const { xScale: r, yScale: a } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(n);
    let u, d, p, h;
    for (u = 0, d = n; u < d; ++u)
      p = u + i, h = e[p], c[u] = {
        x: r.parse(ue(h, o), p),
        y: a.parse(ue(h, l), p)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, e, i) {
    const n = this.chart, r = this._cachedMeta, a = e[t.axis], o = {
      keys: vl(n, !0),
      values: e._stacks[t.axis]._visualValues
    };
    return oa(o, a, r.index, {
      mode: i
    });
  }
  updateRangeFromParsed(t, e, i, n) {
    const r = i[e.axis];
    let a = r === null ? NaN : r;
    const o = n && i._stacks[e.axis];
    n && o && (n.values = o, a = oa(n, r, this._cachedMeta.index)), t.min = Math.min(t.min, a), t.max = Math.max(t.max, a);
  }
  getMinMax(t, e) {
    const i = this._cachedMeta, n = i._parsed, r = i._sorted && t === i.iScale, a = n.length, o = this._getOtherScale(t), l = mp(e, i, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = dp(o);
    let p, h;
    function m() {
      h = n[p];
      const _ = h[o.axis];
      return !it(h[t.axis]) || u > _ || d < _;
    }
    for (p = 0; p < a && !(!m() && (this.updateRangeFromParsed(c, t, h, l), r)); ++p)
      ;
    if (r) {
      for (p = a - 1; p >= 0; --p)
        if (!m()) {
          this.updateRangeFromParsed(c, t, h, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const e = this._cachedMeta._parsed, i = [];
    let n, r, a;
    for (n = 0, r = e.length; n < r; ++n)
      a = e[n][t.axis], it(a) && i.push(a);
    return i;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, i = e.iScale, n = e.vScale, r = this.getParsed(t);
    return {
      label: i ? "" + i.getLabelForValue(r[i.axis]) : "",
      value: n ? "" + n.getLabelForValue(r[n.axis]) : ""
    };
  }
  _update(t) {
    const e = this._cachedMeta;
    this.update(t || "default"), e._clip = lp(D(this.options.clip, op(e.xScale, e.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, e = this.chart, i = this._cachedMeta, n = i.data || [], r = e.chartArea, a = [], o = this._drawStart || 0, l = this._drawCount || n.length - o, c = this.options.drawActiveElementsOnTop;
    let u;
    for (i.dataset && i.dataset.draw(t, r, o, l), u = o; u < o + l; ++u) {
      const d = n[u];
      d.hidden || (d.active && c ? a.push(d) : d.draw(t, r));
    }
    for (u = 0; u < a.length; ++u)
      a[u].draw(t, r);
  }
  getStyle(t, e) {
    const i = e ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(i) : this.resolveDataElementOptions(t || 0, i);
  }
  getContext(t, e, i) {
    const n = this.getDataset();
    let r;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[t];
      r = a.$context || (a.$context = fp(this.getContext(), t, a)), r.parsed = this.getParsed(t), r.raw = n.data[t], r.index = r.dataIndex = t;
    } else
      r = this.$context || (this.$context = hp(this.chart.getContext(), this.index)), r.dataset = n, r.index = r.datasetIndex = this.index;
    return r.active = !!e, r.mode = i, r;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, e) {
    return this._resolveElementOptions(this.dataElementType.id, e, t);
  }
  _resolveElementOptions(t, e = "default", i) {
    const n = e === "active", r = this._cachedDataOpts, a = t + "-" + e, o = r[a], l = this.enableOptionSharing && xs(i);
    if (o)
      return da(o, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, t), d = n ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], p = c.getOptionScopes(this.getDataset(), u), h = Object.keys(nt.elements[t]), m = () => this.getContext(i, n, e), _ = c.resolveNamedOptions(p, h, m, d);
    return _.$shared && (_.$shared = l, r[a] = Object.freeze(da(_, l))), _;
  }
  _resolveAnimations(t, e, i) {
    const n = this.chart, r = this._cachedDataOpts, a = `animation-${e}`, o = r[a];
    if (o)
      return o;
    let l;
    if (n.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, e), p = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(p, this.getContext(t, i, e));
    }
    const c = new bl(n, l && l.animations);
    return l && l._cacheable && (r[a] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, e) {
    return !e || Zi(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, e) {
    const i = this.resolveDataElementOptions(t, e), n = this._sharedOptions, r = this.getSharedOptions(i), a = this.includeOptions(e, r) || r !== n;
    return this.updateSharedOptions(r, e, i), {
      sharedOptions: r,
      includeOptions: a
    };
  }
  updateElement(t, e, i, n) {
    Zi(n) ? Object.assign(t, i) : this._resolveAnimations(e, n).update(t, i);
  }
  updateSharedOptions(t, e, i) {
    t && !Zi(e) && this._resolveAnimations(void 0, e).update(t, i);
  }
  _setStyle(t, e, i, n) {
    t.active = n;
    const r = this.getStyle(e, n);
    this._resolveAnimations(e, i, n).update(t, {
      options: !n && this.getSharedOptions(r) || r
    });
  }
  removeHoverStyle(t, e, i) {
    this._setStyle(t, i, "active", !1);
  }
  setHoverStyle(t, e, i) {
    this._setStyle(t, i, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const e = this._data, i = this._cachedMeta.data;
    for (const [o, l, c] of this._syncList)
      this[o](l, c);
    this._syncList = [];
    const n = i.length, r = e.length, a = Math.min(r, n);
    a && this.parse(0, a), r > n ? this._insertElements(n, r - n, t) : r < n && this._removeElements(r, n - r);
  }
  _insertElements(t, e, i = !0) {
    const n = this._cachedMeta, r = n.data, a = t + e;
    let o;
    const l = (c) => {
      for (c.length += e, o = c.length - 1; o >= a; o--)
        c[o] = c[o - e];
    };
    for (l(r), o = t; o < a; ++o)
      r[o] = new this.dataElementType();
    this._parsing && l(n._parsed), this.parse(t, e), i && this.updateElements(r, t, e, "reset");
  }
  updateElements(t, e, i, n) {
  }
  _removeElements(t, e) {
    const i = this._cachedMeta;
    if (this._parsing) {
      const n = i._parsed.splice(t, e);
      i._stacked && Ze(i, n);
    }
    i.data.splice(t, e);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [e, i, n] = t;
      this[e](i, n);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, e) {
    e && this._sync([
      "_removeElements",
      t,
      e
    ]);
    const i = arguments.length - 2;
    i && this._sync([
      "_insertElements",
      t,
      i
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
A(Lt, "defaults", {}), A(Lt, "datasetElementType", null), A(Lt, "dataElementType", null);
function gp(s, t) {
  if (!s._cache.$bar) {
    const e = s.getMatchingVisibleMetas(t);
    let i = [];
    for (let n = 0, r = e.length; n < r; n++)
      i = i.concat(e[n].controller.getAllParsedValues(s));
    s._cache.$bar = tl(i.sort((n, r) => n - r));
  }
  return s._cache.$bar;
}
function _p(s) {
  const t = s.iScale, e = gp(t, s.type);
  let i = t._length, n, r, a, o;
  const l = () => {
    a === 32767 || a === -32768 || (xs(o) && (i = Math.min(i, Math.abs(a - o) || i)), o = a);
  };
  for (n = 0, r = e.length; n < r; ++n)
    a = t.getPixelForValue(e[n]), l();
  for (o = void 0, n = 0, r = t.ticks.length; n < r; ++n)
    a = t.getPixelForTick(n), l();
  return i;
}
function yp(s, t, e, i) {
  const n = e.barThickness;
  let r, a;
  return N(n) ? (r = t.min * e.categoryPercentage, a = e.barPercentage) : (r = n * i, a = 1), {
    chunk: r / i,
    ratio: a,
    start: t.pixels[s] - r / 2
  };
}
function bp(s, t, e, i) {
  const n = t.pixels, r = n[s];
  let a = s > 0 ? n[s - 1] : null, o = s < n.length - 1 ? n[s + 1] : null;
  const l = e.categoryPercentage;
  a === null && (a = r - (o === null ? t.end - t.start : o - r)), o === null && (o = r + r - a);
  const c = r - (r - Math.min(a, o)) / 2 * l;
  return {
    chunk: Math.abs(o - a) / 2 * l / i,
    ratio: e.barPercentage,
    start: c
  };
}
function vp(s, t, e, i) {
  const n = e.parse(s[0], i), r = e.parse(s[1], i), a = Math.min(n, r), o = Math.max(n, r);
  let l = a, c = o;
  Math.abs(a) > Math.abs(o) && (l = o, c = a), t[e.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: n,
    end: r,
    min: a,
    max: o
  };
}
function kl(s, t, e, i) {
  return Z(s) ? vp(s, t, e, i) : t[e.axis] = e.parse(s, i), t;
}
function pa(s, t, e, i) {
  const n = s.iScale, r = s.vScale, a = n.getLabels(), o = n === r, l = [];
  let c, u, d, p;
  for (c = e, u = e + i; c < u; ++c)
    p = t[c], d = {}, d[n.axis] = o || n.parse(a[c], c), l.push(kl(p, d, r, c));
  return l;
}
function Qi(s) {
  return s && s.barStart !== void 0 && s.barEnd !== void 0;
}
function kp(s, t, e) {
  return s !== 0 ? Vt(s) : (t.isHorizontal() ? 1 : -1) * (t.min >= e ? 1 : -1);
}
function xp(s) {
  let t, e, i, n, r;
  return s.horizontal ? (t = s.base > s.x, e = "left", i = "right") : (t = s.base < s.y, e = "bottom", i = "top"), t ? (n = "end", r = "start") : (n = "start", r = "end"), {
    start: e,
    end: i,
    reverse: t,
    top: n,
    bottom: r
  };
}
function Cp(s, t, e, i) {
  let n = t.borderSkipped;
  const r = {};
  if (!n) {
    s.borderSkipped = r;
    return;
  }
  if (n === !0) {
    s.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: a, end: o, reverse: l, top: c, bottom: u } = xp(s);
  n === "middle" && e && (s.enableBorderRadius = !0, (e._top || 0) === i ? n = c : (e._bottom || 0) === i ? n = u : (r[ha(u, a, o, l)] = !0, n = c)), r[ha(n, a, o, l)] = !0, s.borderSkipped = r;
}
function ha(s, t, e, i) {
  return i ? (s = wp(s, t, e), s = fa(s, e, t)) : s = fa(s, t, e), s;
}
function wp(s, t, e) {
  return s === t ? e : s === e ? t : s;
}
function fa(s, t, e) {
  return s === "start" ? t : s === "end" ? e : s;
}
function $p(s, { inflateAmount: t }, e) {
  s.inflateAmount = t === "auto" ? e === 1 ? 0.33 : 0 : t;
}
class ni extends Lt {
  parsePrimitiveData(t, e, i, n) {
    return pa(t, e, i, n);
  }
  parseArrayData(t, e, i, n) {
    return pa(t, e, i, n);
  }
  parseObjectData(t, e, i, n) {
    const { iScale: r, vScale: a } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = r.axis === "x" ? o : l, u = a.axis === "x" ? o : l, d = [];
    let p, h, m, _;
    for (p = i, h = i + n; p < h; ++p)
      _ = e[p], m = {}, m[r.axis] = r.parse(ue(_, c), p), d.push(kl(ue(_, u), m, a, p));
    return d;
  }
  updateRangeFromParsed(t, e, i, n) {
    super.updateRangeFromParsed(t, e, i, n);
    const r = i._custom;
    r && e === this._cachedMeta.vScale && (t.min = Math.min(t.min, r.min), t.max = Math.max(t.max, r.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, { iScale: i, vScale: n } = e, r = this.getParsed(t), a = r._custom, o = Qi(a) ? "[" + a.start + ", " + a.end + "]" : "" + n.getLabelForValue(r[n.axis]);
    return {
      label: "" + i.getLabelForValue(r[i.axis]),
      value: o
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const e = this._cachedMeta;
    this.updateElements(e.data, 0, e.data.length, t);
  }
  updateElements(t, e, i, n) {
    const r = n === "reset", { index: a, _cachedMeta: { vScale: o } } = this, l = o.getBasePixel(), c = o.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: p } = this._getSharedOptions(e, n);
    for (let h = e; h < e + i; h++) {
      const m = this.getParsed(h), _ = r || N(m[o.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(h), y = this._calculateBarIndexPixels(h, u), v = (m._stacks || {})[o.axis], k = {
        horizontal: c,
        base: _.base,
        enableBorderRadius: !v || Qi(m._custom) || a === v._top || a === v._bottom,
        x: c ? _.head : y.center,
        y: c ? y.center : _.head,
        height: c ? y.size : Math.abs(_.size),
        width: c ? Math.abs(_.size) : y.size
      };
      p && (k.options = d || this.resolveDataElementOptions(h, t[h].active ? "active" : n));
      const w = k.options || t[h].options;
      Cp(k, w, v, a), $p(k, w, u.ratio), this.updateElement(t[h], h, k, n);
    }
  }
  _getStacks(t, e) {
    const { iScale: i } = this._cachedMeta, n = i.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), r = i.options.stacked, a = [], o = (l) => {
      const c = l.controller.getParsed(e), u = c && c[l.vScale.axis];
      if (N(u) || isNaN(u))
        return !0;
    };
    for (const l of n)
      if (!(e !== void 0 && o(l)) && ((r === !1 || a.indexOf(l.stack) === -1 || r === void 0 && l.stack === void 0) && a.push(l.stack), l.index === t))
        break;
    return a.length || a.push(void 0), a;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, e, i) {
    const n = this._getStacks(t, i), r = e !== void 0 ? n.indexOf(e) : -1;
    return r === -1 ? n.length - 1 : r;
  }
  _getRuler() {
    const t = this.options, e = this._cachedMeta, i = e.iScale, n = [];
    let r, a;
    for (r = 0, a = e.data.length; r < a; ++r)
      n.push(i.getPixelForValue(this.getParsed(r)[i.axis], r));
    const o = t.barThickness;
    return {
      min: o || _p(e),
      pixels: n,
      start: i._startPixel,
      end: i._endPixel,
      stackCount: this._getStackCount(),
      scale: i,
      grouped: t.grouped,
      ratio: o ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: e, _stacked: i, index: n }, options: { base: r, minBarLength: a } } = this, o = r || 0, l = this.getParsed(t), c = l._custom, u = Qi(c);
    let d = l[e.axis], p = 0, h = i ? this.applyStack(e, l, i) : d, m, _;
    h !== d && (p = h - d, h = d), u && (d = c.barStart, h = c.barEnd - c.barStart, d !== 0 && Vt(d) !== Vt(c.barEnd) && (p = 0), p += d);
    const y = !N(r) && !u ? r : p;
    let v = e.getPixelForValue(y);
    if (this.chart.getDataVisibility(t) ? m = e.getPixelForValue(p + h) : m = v, _ = m - v, Math.abs(_) < a) {
      _ = kp(_, e, o) * a, d === o && (v -= _ / 2);
      const k = e.getPixelForDecimal(0), w = e.getPixelForDecimal(1), x = Math.min(k, w), C = Math.max(k, w);
      v = Math.max(Math.min(v, C), x), m = v + _, i && !u && (l._stacks[e.axis]._visualValues[n] = e.getValueForPixel(m) - e.getValueForPixel(v));
    }
    if (v === e.getPixelForValue(o)) {
      const k = Vt(_) * e.getLineWidthForValue(o) / 2;
      v += k, _ -= k;
    }
    return {
      size: _,
      base: v,
      head: m,
      center: m + _ / 2
    };
  }
  _calculateBarIndexPixels(t, e) {
    const i = e.scale, n = this.options, r = n.skipNull, a = D(n.maxBarThickness, 1 / 0);
    let o, l;
    if (e.grouped) {
      const c = r ? this._getStackCount(t) : e.stackCount, u = n.barThickness === "flex" ? bp(t, e, n, c) : yp(t, e, n, c), d = this._getStackIndex(this.index, this._cachedMeta.stack, r ? t : void 0);
      o = u.start + u.chunk * d + u.chunk / 2, l = Math.min(a, u.chunk * u.ratio);
    } else
      o = i.getPixelForValue(this.getParsed(t)[i.axis], t), l = Math.min(a, e.min * e.ratio);
    return {
      base: o - l / 2,
      head: o + l / 2,
      center: o,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, e = t.vScale, i = t.data, n = i.length;
    let r = 0;
    for (; r < n; ++r)
      this.getParsed(r)[e.axis] !== null && i[r].draw(this._ctx);
  }
}
A(ni, "id", "bar"), A(ni, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), A(ni, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class ri extends Lt {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, e, i, n) {
    const r = super.parsePrimitiveData(t, e, i, n);
    for (let a = 0; a < r.length; a++)
      r[a]._custom = this.resolveDataElementOptions(a + i).radius;
    return r;
  }
  parseArrayData(t, e, i, n) {
    const r = super.parseArrayData(t, e, i, n);
    for (let a = 0; a < r.length; a++) {
      const o = e[i + a];
      r[a]._custom = D(o[2], this.resolveDataElementOptions(a + i).radius);
    }
    return r;
  }
  parseObjectData(t, e, i, n) {
    const r = super.parseObjectData(t, e, i, n);
    for (let a = 0; a < r.length; a++) {
      const o = e[i + a];
      r[a]._custom = D(o && o.r && +o.r, this.resolveDataElementOptions(a + i).radius);
    }
    return r;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let e = 0;
    for (let i = t.length - 1; i >= 0; --i)
      e = Math.max(e, t[i].size(this.resolveDataElementOptions(i)) / 2);
    return e > 0 && e;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, i = this.chart.data.labels || [], { xScale: n, yScale: r } = e, a = this.getParsed(t), o = n.getLabelForValue(a.x), l = r.getLabelForValue(a.y), c = a._custom;
    return {
      label: i[t] || "",
      value: "(" + o + ", " + l + (c ? ", " + c : "") + ")"
    };
  }
  update(t) {
    const e = this._cachedMeta.data;
    this.updateElements(e, 0, e.length, t);
  }
  updateElements(t, e, i, n) {
    const r = n === "reset", { iScale: a, vScale: o } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(e, n), u = a.axis, d = o.axis;
    for (let p = e; p < e + i; p++) {
      const h = t[p], m = !r && this.getParsed(p), _ = {}, y = _[u] = r ? a.getPixelForDecimal(0.5) : a.getPixelForValue(m[u]), v = _[d] = r ? o.getBasePixel() : o.getPixelForValue(m[d]);
      _.skip = isNaN(y) || isNaN(v), c && (_.options = l || this.resolveDataElementOptions(p, h.active ? "active" : n), r && (_.options.radius = 0)), this.updateElement(h, p, _, n);
    }
  }
  resolveDataElementOptions(t, e) {
    const i = this.getParsed(t);
    let n = super.resolveDataElementOptions(t, e);
    n.$shared && (n = Object.assign({}, n, {
      $shared: !1
    }));
    const r = n.radius;
    return e !== "active" && (n.radius = 0), n.radius += D(i && i._custom, r), n;
  }
}
A(ri, "id", "bubble"), A(ri, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), A(ri, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function Sp(s, t, e) {
  let i = 1, n = 1, r = 0, a = 0;
  if (t < G) {
    const o = s, l = o + t, c = Math.cos(o), u = Math.sin(o), d = Math.cos(l), p = Math.sin(l), h = (w, x, C) => Cs(w, o, l, !0) ? 1 : Math.max(x, x * e, C, C * e), m = (w, x, C) => Cs(w, o, l, !0) ? -1 : Math.min(x, x * e, C, C * e), _ = h(0, c, d), y = h(at, u, p), v = m(K, c, d), k = m(K + at, u, p);
    i = (_ - v) / 2, n = (y - k) / 2, r = -(_ + v) / 2, a = -(y + k) / 2;
  }
  return {
    ratioX: i,
    ratioY: n,
    offsetX: r,
    offsetY: a
  };
}
class Ce extends Lt {
  constructor(t, e) {
    super(t, e), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, e) {
    const i = this.getDataset().data, n = this._cachedMeta;
    if (this._parsing === !1)
      n._parsed = i;
    else {
      let r = (l) => +i[l];
      if (U(i[t])) {
        const { key: l = "value" } = this._parsing;
        r = (c) => +ue(i[c], l);
      }
      let a, o;
      for (a = t, o = t + e; a < o; ++a)
        n._parsed[a] = r(a);
    }
  }
  _getRotation() {
    return Ft(this.options.rotation - 90);
  }
  _getCircumference() {
    return Ft(this.options.circumference);
  }
  _getRotationExtents() {
    let t = G, e = -G;
    for (let i = 0; i < this.chart.data.datasets.length; ++i)
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const n = this.chart.getDatasetMeta(i).controller, r = n._getRotation(), a = n._getCircumference();
        t = Math.min(t, r), e = Math.max(e, r + a);
      }
    return {
      rotation: t,
      circumference: e - t
    };
  }
  update(t) {
    const e = this.chart, { chartArea: i } = e, n = this._cachedMeta, r = n.data, a = this.getMaxBorderWidth() + this.getMaxOffset(r) + this.options.spacing, o = Math.max((Math.min(i.width, i.height) - a) / 2, 0), l = Math.min(Nu(this.options.cutout, o), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: d } = this._getRotationExtents(), { ratioX: p, ratioY: h, offsetX: m, offsetY: _ } = Sp(d, u, l), y = (i.width - a) / p, v = (i.height - a) / h, k = Math.max(Math.min(y, v) / 2, 0), w = Yo(this.options.radius, k), x = Math.max(w * l, 0), C = (w - x) / this._getVisibleDatasetWeightTotal();
    this.offsetX = m * w, this.offsetY = _ * w, n.total = this.calculateTotal(), this.outerRadius = w - C * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - C * c, 0), this.updateElements(r, 0, r.length, t);
  }
  _circumference(t, e) {
    const i = this.options, n = this._cachedMeta, r = this._getCircumference();
    return e && i.animation.animateRotate || !this.chart.getDataVisibility(t) || n._parsed[t] === null || n.data[t].hidden ? 0 : this.calculateCircumference(n._parsed[t] * r / G);
  }
  updateElements(t, e, i, n) {
    const r = n === "reset", a = this.chart, o = a.chartArea, c = a.options.animation, u = (o.left + o.right) / 2, d = (o.top + o.bottom) / 2, p = r && c.animateScale, h = p ? 0 : this.innerRadius, m = p ? 0 : this.outerRadius, { sharedOptions: _, includeOptions: y } = this._getSharedOptions(e, n);
    let v = this._getRotation(), k;
    for (k = 0; k < e; ++k)
      v += this._circumference(k, r);
    for (k = e; k < e + i; ++k) {
      const w = this._circumference(k, r), x = t[k], C = {
        x: u + this.offsetX,
        y: d + this.offsetY,
        startAngle: v,
        endAngle: v + w,
        circumference: w,
        outerRadius: m,
        innerRadius: h
      };
      y && (C.options = _ || this.resolveDataElementOptions(k, x.active ? "active" : n)), v += w, this.updateElement(x, k, C, n);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, e = t.data;
    let i = 0, n;
    for (n = 0; n < e.length; n++) {
      const r = t._parsed[n];
      r !== null && !isNaN(r) && this.chart.getDataVisibility(n) && !e[n].hidden && (i += Math.abs(r));
    }
    return i;
  }
  calculateCircumference(t) {
    const e = this._cachedMeta.total;
    return e > 0 && !isNaN(t) ? G * (Math.abs(t) / e) : 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, i = this.chart, n = i.data.labels || [], r = As(e._parsed[t], i.options.locale);
    return {
      label: n[t] || "",
      value: r
    };
  }
  getMaxBorderWidth(t) {
    let e = 0;
    const i = this.chart;
    let n, r, a, o, l;
    if (!t) {
      for (n = 0, r = i.data.datasets.length; n < r; ++n)
        if (i.isDatasetVisible(n)) {
          a = i.getDatasetMeta(n), t = a.data, o = a.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (n = 0, r = t.length; n < r; ++n)
      l = o.resolveDataElementOptions(n), l.borderAlign !== "inner" && (e = Math.max(e, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return e;
  }
  getMaxOffset(t) {
    let e = 0;
    for (let i = 0, n = t.length; i < n; ++i) {
      const r = this.resolveDataElementOptions(i);
      e = Math.max(e, r.offset || 0, r.hoverOffset || 0);
    }
    return e;
  }
  _getRingWeightOffset(t) {
    let e = 0;
    for (let i = 0; i < t; ++i)
      this.chart.isDatasetVisible(i) && (e += this._getRingWeight(i));
    return e;
  }
  _getRingWeight(t) {
    return Math.max(D(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
A(Ce, "id", "doughnut"), A(Ce, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), A(Ce, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), A(Ce, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const e = t.data;
          if (e.labels.length && e.datasets.length) {
            const { labels: { pointStyle: i, color: n } } = t.legend.options;
            return e.labels.map((r, a) => {
              const l = t.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: r,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: n,
                lineWidth: l.borderWidth,
                pointStyle: i,
                hidden: !t.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(t, e, i) {
        i.chart.toggleDataVisibility(e.index), i.chart.update();
      }
    }
  }
});
class ai extends Lt {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const e = this._cachedMeta, { dataset: i, data: n = [], _dataset: r } = e, a = this.chart._animationsDisabled;
    let { start: o, count: l } = il(e, n, a);
    this._drawStart = o, this._drawCount = l, nl(e) && (o = 0, l = n.length), i._chart = this.chart, i._datasetIndex = this.index, i._decimated = !!r._decimated, i.points = n;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(i, void 0, {
      animated: !a,
      options: c
    }, t), this.updateElements(n, o, l, t);
  }
  updateElements(t, e, i, n) {
    const r = n === "reset", { iScale: a, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(e, n), p = a.axis, h = o.axis, { spanGaps: m, segment: _ } = this.options, y = ze(m) ? m : Number.POSITIVE_INFINITY, v = this.chart._animationsDisabled || r || n === "none", k = e + i, w = t.length;
    let x = e > 0 && this.getParsed(e - 1);
    for (let C = 0; C < w; ++C) {
      const $ = t[C], S = v ? $ : {};
      if (C < e || C >= k) {
        S.skip = !0;
        continue;
      }
      const I = this.getParsed(C), R = N(I[h]), F = S[p] = a.getPixelForValue(I[p], C), O = S[h] = r || R ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, I, l) : I[h], C);
      S.skip = isNaN(F) || isNaN(O) || R, S.stop = C > 0 && Math.abs(I[p] - x[p]) > y, _ && (S.parsed = I, S.raw = c.data[C]), d && (S.options = u || this.resolveDataElementOptions(C, $.active ? "active" : n)), v || this.updateElement($, C, S, n), x = I;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.dataset, i = e.options && e.options.borderWidth || 0, n = t.data || [];
    if (!n.length)
      return i;
    const r = n[0].size(this.resolveDataElementOptions(0)), a = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(i, r, a) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
A(ai, "id", "line"), A(ai, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), A(ai, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class bs extends Lt {
  constructor(t, e) {
    super(t, e), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, i = this.chart, n = i.data.labels || [], r = As(e._parsed[t].r, i.options.locale);
    return {
      label: n[t] || "",
      value: r
    };
  }
  parseObjectData(t, e, i, n) {
    return pl.bind(this)(t, e, i, n);
  }
  update(t) {
    const e = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(e, 0, e.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, e = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return t.data.forEach((i, n) => {
      const r = this.getParsed(n).r;
      !isNaN(r) && this.chart.getDataVisibility(n) && (r < e.min && (e.min = r), r > e.max && (e.max = r));
    }), e;
  }
  _updateRadius() {
    const t = this.chart, e = t.chartArea, i = t.options, n = Math.min(e.right - e.left, e.bottom - e.top), r = Math.max(n / 2, 0), a = Math.max(i.cutoutPercentage ? r / 100 * i.cutoutPercentage : 1, 0), o = (r - a) / t.getVisibleDatasetCount();
    this.outerRadius = r - o * this.index, this.innerRadius = this.outerRadius - o;
  }
  updateElements(t, e, i, n) {
    const r = n === "reset", a = this.chart, l = a.options.animation, c = this._cachedMeta.rScale, u = c.xCenter, d = c.yCenter, p = c.getIndexAngle(0) - 0.5 * K;
    let h = p, m;
    const _ = 360 / this.countVisibleElements();
    for (m = 0; m < e; ++m)
      h += this._computeAngle(m, n, _);
    for (m = e; m < e + i; m++) {
      const y = t[m];
      let v = h, k = h + this._computeAngle(m, n, _), w = a.getDataVisibility(m) ? c.getDistanceFromCenterForValue(this.getParsed(m).r) : 0;
      h = k, r && (l.animateScale && (w = 0), l.animateRotate && (v = k = p));
      const x = {
        x: u,
        y: d,
        innerRadius: 0,
        outerRadius: w,
        startAngle: v,
        endAngle: k,
        options: this.resolveDataElementOptions(m, y.active ? "active" : n)
      };
      this.updateElement(y, m, x, n);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let e = 0;
    return t.data.forEach((i, n) => {
      !isNaN(this.getParsed(n).r) && this.chart.getDataVisibility(n) && e++;
    }), e;
  }
  _computeAngle(t, e, i) {
    return this.chart.getDataVisibility(t) ? Ft(this.resolveDataElementOptions(t, e).angle || i) : 0;
  }
}
A(bs, "id", "polarArea"), A(bs, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), A(bs, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const e = t.data;
          if (e.labels.length && e.datasets.length) {
            const { labels: { pointStyle: i, color: n } } = t.legend.options;
            return e.labels.map((r, a) => {
              const l = t.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: r,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: n,
                lineWidth: l.borderWidth,
                pointStyle: i,
                hidden: !t.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(t, e, i) {
        i.chart.toggleDataVisibility(e.index), i.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class yn extends Ce {
}
A(yn, "id", "pie"), A(yn, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class oi extends Lt {
  getLabelAndValue(t) {
    const e = this._cachedMeta.vScale, i = this.getParsed(t);
    return {
      label: e.getLabels()[t],
      value: "" + e.getLabelForValue(i[e.axis])
    };
  }
  parseObjectData(t, e, i, n) {
    return pl.bind(this)(t, e, i, n);
  }
  update(t) {
    const e = this._cachedMeta, i = e.dataset, n = e.data || [], r = e.iScale.getLabels();
    if (i.points = n, t !== "resize") {
      const a = this.resolveDatasetElementOptions(t);
      this.options.showLine || (a.borderWidth = 0);
      const o = {
        _loop: !0,
        _fullLoop: r.length === n.length,
        options: a
      };
      this.updateElement(i, void 0, o, t);
    }
    this.updateElements(n, 0, n.length, t);
  }
  updateElements(t, e, i, n) {
    const r = this._cachedMeta.rScale, a = n === "reset";
    for (let o = e; o < e + i; o++) {
      const l = t[o], c = this.resolveDataElementOptions(o, l.active ? "active" : n), u = r.getPointPositionForValue(o, this.getParsed(o).r), d = a ? r.xCenter : u.x, p = a ? r.yCenter : u.y, h = {
        x: d,
        y: p,
        angle: u.angle,
        skip: isNaN(d) || isNaN(p),
        options: c
      };
      this.updateElement(l, o, h, n);
    }
  }
}
A(oi, "id", "radar"), A(oi, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), A(oi, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class li extends Lt {
  getLabelAndValue(t) {
    const e = this._cachedMeta, i = this.chart.data.labels || [], { xScale: n, yScale: r } = e, a = this.getParsed(t), o = n.getLabelForValue(a.x), l = r.getLabelForValue(a.y);
    return {
      label: i[t] || "",
      value: "(" + o + ", " + l + ")"
    };
  }
  update(t) {
    const e = this._cachedMeta, { data: i = [] } = e, n = this.chart._animationsDisabled;
    let { start: r, count: a } = il(e, i, n);
    if (this._drawStart = r, this._drawCount = a, nl(e) && (r = 0, a = i.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: o, _dataset: l } = e;
      o._chart = this.chart, o._datasetIndex = this.index, o._decimated = !!l._decimated, o.points = i;
      const c = this.resolveDatasetElementOptions(t);
      c.segment = this.options.segment, this.updateElement(o, void 0, {
        animated: !n,
        options: c
      }, t);
    } else this.datasetElementType && (delete e.dataset, this.datasetElementType = !1);
    this.updateElements(i, r, a, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, e, i, n) {
    const r = n === "reset", { iScale: a, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, u = this.resolveDataElementOptions(e, n), d = this.getSharedOptions(u), p = this.includeOptions(n, d), h = a.axis, m = o.axis, { spanGaps: _, segment: y } = this.options, v = ze(_) ? _ : Number.POSITIVE_INFINITY, k = this.chart._animationsDisabled || r || n === "none";
    let w = e > 0 && this.getParsed(e - 1);
    for (let x = e; x < e + i; ++x) {
      const C = t[x], $ = this.getParsed(x), S = k ? C : {}, I = N($[m]), R = S[h] = a.getPixelForValue($[h], x), F = S[m] = r || I ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, $, l) : $[m], x);
      S.skip = isNaN(R) || isNaN(F) || I, S.stop = x > 0 && Math.abs($[h] - w[h]) > v, y && (S.parsed = $, S.raw = c.data[x]), p && (S.options = d || this.resolveDataElementOptions(x, C.active ? "active" : n)), k || this.updateElement(C, x, S, n), w = $;
    }
    this.updateSharedOptions(d, n, u);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.data || [];
    if (!this.options.showLine) {
      let o = 0;
      for (let l = e.length - 1; l >= 0; --l)
        o = Math.max(o, e[l].size(this.resolveDataElementOptions(l)) / 2);
      return o > 0 && o;
    }
    const i = t.dataset, n = i.options && i.options.borderWidth || 0;
    if (!e.length)
      return n;
    const r = e[0].size(this.resolveDataElementOptions(0)), a = e[e.length - 1].size(this.resolveDataElementOptions(e.length - 1));
    return Math.max(n, r, a) / 2;
  }
}
A(li, "id", "scatter"), A(li, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), A(li, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var Tp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: ni,
  BubbleController: ri,
  DoughnutController: Ce,
  LineController: ai,
  PieController: yn,
  PolarAreaController: bs,
  RadarController: oi,
  ScatterController: li
});
function _e() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Qn {
  constructor(t) {
    A(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(Qn.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return _e();
  }
  parse() {
    return _e();
  }
  format() {
    return _e();
  }
  add() {
    return _e();
  }
  diff() {
    return _e();
  }
  startOf() {
    return _e();
  }
  endOf() {
    return _e();
  }
}
var Ip = {
  _date: Qn
};
function Ap(s, t, e, i) {
  const { controller: n, data: r, _sorted: a } = s, o = n._cachedMeta.iScale;
  if (o && t === o.axis && t !== "r" && a && r.length) {
    const l = o._reversePixels ? Qu : ee;
    if (i) {
      if (n._sharedOptions) {
        const c = r[0], u = typeof c.getRange == "function" && c.getRange(t);
        if (u) {
          const d = l(r, t, e - u), p = l(r, t, e + u);
          return {
            lo: d.lo,
            hi: p.hi
          };
        }
      }
    } else return l(r, t, e);
  }
  return {
    lo: 0,
    hi: r.length - 1
  };
}
function Pi(s, t, e, i, n) {
  const r = s.getSortedVisibleDatasetMetas(), a = e[t];
  for (let o = 0, l = r.length; o < l; ++o) {
    const { index: c, data: u } = r[o], { lo: d, hi: p } = Ap(r[o], t, a, n);
    for (let h = d; h <= p; ++h) {
      const m = u[h];
      m.skip || i(m, c, h);
    }
  }
}
function Pp(s) {
  const t = s.indexOf("x") !== -1, e = s.indexOf("y") !== -1;
  return function(i, n) {
    const r = t ? Math.abs(i.x - n.x) : 0, a = e ? Math.abs(i.y - n.y) : 0;
    return Math.sqrt(Math.pow(r, 2) + Math.pow(a, 2));
  };
}
function Ji(s, t, e, i, n) {
  const r = [];
  return !n && !s.isPointInArea(t) || Pi(s, e, t, function(o, l, c) {
    !n && !se(o, s.chartArea, 0) || o.inRange(t.x, t.y, i) && r.push({
      element: o,
      datasetIndex: l,
      index: c
    });
  }, !0), r;
}
function Op(s, t, e, i) {
  let n = [];
  function r(a, o, l) {
    const { startAngle: c, endAngle: u } = a.getProps([
      "startAngle",
      "endAngle"
    ], i), { angle: d } = Qo(a, {
      x: t.x,
      y: t.y
    });
    Cs(d, c, u) && n.push({
      element: a,
      datasetIndex: o,
      index: l
    });
  }
  return Pi(s, e, t, r), n;
}
function Mp(s, t, e, i, n, r) {
  let a = [];
  const o = Pp(e);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, p) {
    const h = u.inRange(t.x, t.y, n);
    if (i && !h)
      return;
    const m = u.getCenterPoint(n);
    if (!(!!r || s.isPointInArea(m)) && !h)
      return;
    const y = o(t, m);
    y < l ? (a = [
      {
        element: u,
        datasetIndex: d,
        index: p
      }
    ], l = y) : y === l && a.push({
      element: u,
      datasetIndex: d,
      index: p
    });
  }
  return Pi(s, e, t, c), a;
}
function tn(s, t, e, i, n, r) {
  return !r && !s.isPointInArea(t) ? [] : e === "r" && !i ? Op(s, t, e, n) : Mp(s, t, e, i, n, r);
}
function ma(s, t, e, i, n) {
  const r = [], a = e === "x" ? "inXRange" : "inYRange";
  let o = !1;
  return Pi(s, e, t, (l, c, u) => {
    l[a](t[e], n) && (r.push({
      element: l,
      datasetIndex: c,
      index: u
    }), o = o || l.inRange(t.x, t.y, n));
  }), i && !o ? [] : r;
}
var Rp = {
  modes: {
    index(s, t, e, i) {
      const n = ve(t, s), r = e.axis || "x", a = e.includeInvisible || !1, o = e.intersect ? Ji(s, n, r, i, a) : tn(s, n, r, !1, i, a), l = [];
      return o.length ? (s.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = o[0].index, d = c.data[u];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(s, t, e, i) {
      const n = ve(t, s), r = e.axis || "xy", a = e.includeInvisible || !1;
      let o = e.intersect ? Ji(s, n, r, i, a) : tn(s, n, r, !1, i, a);
      if (o.length > 0) {
        const l = o[0].datasetIndex, c = s.getDatasetMeta(l).data;
        o = [];
        for (let u = 0; u < c.length; ++u)
          o.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return o;
    },
    point(s, t, e, i) {
      const n = ve(t, s), r = e.axis || "xy", a = e.includeInvisible || !1;
      return Ji(s, n, r, i, a);
    },
    nearest(s, t, e, i) {
      const n = ve(t, s), r = e.axis || "xy", a = e.includeInvisible || !1;
      return tn(s, n, r, e.intersect, i, a);
    },
    x(s, t, e, i) {
      const n = ve(t, s);
      return ma(s, n, "x", e.intersect, i);
    },
    y(s, t, e, i) {
      const n = ve(t, s);
      return ma(s, n, "y", e.intersect, i);
    }
  }
};
const xl = [
  "left",
  "top",
  "right",
  "bottom"
];
function Qe(s, t) {
  return s.filter((e) => e.pos === t);
}
function ga(s, t) {
  return s.filter((e) => xl.indexOf(e.pos) === -1 && e.box.axis === t);
}
function Je(s, t) {
  return s.sort((e, i) => {
    const n = t ? i : e, r = t ? e : i;
    return n.weight === r.weight ? n.index - r.index : n.weight - r.weight;
  });
}
function Ep(s) {
  const t = [];
  let e, i, n, r, a, o;
  for (e = 0, i = (s || []).length; e < i; ++e)
    n = s[e], { position: r, options: { stack: a, stackWeight: o = 1 } } = n, t.push({
      index: e,
      box: n,
      pos: r,
      horizontal: n.isHorizontal(),
      weight: n.weight,
      stack: a && r + a,
      stackWeight: o
    });
  return t;
}
function Dp(s) {
  const t = {};
  for (const e of s) {
    const { stack: i, pos: n, stackWeight: r } = e;
    if (!i || !xl.includes(n))
      continue;
    const a = t[i] || (t[i] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    a.count++, a.weight += r;
  }
  return t;
}
function Fp(s, t) {
  const e = Dp(s), { vBoxMaxWidth: i, hBoxMaxHeight: n } = t;
  let r, a, o;
  for (r = 0, a = s.length; r < a; ++r) {
    o = s[r];
    const { fullSize: l } = o.box, c = e[o.stack], u = c && o.stackWeight / c.weight;
    o.horizontal ? (o.width = u ? u * i : l && t.availableWidth, o.height = n) : (o.width = i, o.height = u ? u * n : l && t.availableHeight);
  }
  return e;
}
function Lp(s) {
  const t = Ep(s), e = Je(t.filter((c) => c.box.fullSize), !0), i = Je(Qe(t, "left"), !0), n = Je(Qe(t, "right")), r = Je(Qe(t, "top"), !0), a = Je(Qe(t, "bottom")), o = ga(t, "x"), l = ga(t, "y");
  return {
    fullSize: e,
    leftAndTop: i.concat(r),
    rightAndBottom: n.concat(l).concat(a).concat(o),
    chartArea: Qe(t, "chartArea"),
    vertical: i.concat(n).concat(l),
    horizontal: r.concat(a).concat(o)
  };
}
function _a(s, t, e, i) {
  return Math.max(s[e], t[e]) + Math.max(s[i], t[i]);
}
function Cl(s, t) {
  s.top = Math.max(s.top, t.top), s.left = Math.max(s.left, t.left), s.bottom = Math.max(s.bottom, t.bottom), s.right = Math.max(s.right, t.right);
}
function qp(s, t, e, i) {
  const { pos: n, box: r } = e, a = s.maxPadding;
  if (!U(n)) {
    e.size && (s[n] -= e.size);
    const d = i[e.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, e.horizontal ? r.height : r.width), e.size = d.size / d.count, s[n] += e.size;
  }
  r.getPadding && Cl(a, r.getPadding());
  const o = Math.max(0, t.outerWidth - _a(a, s, "left", "right")), l = Math.max(0, t.outerHeight - _a(a, s, "top", "bottom")), c = o !== s.w, u = l !== s.h;
  return s.w = o, s.h = l, e.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function Up(s) {
  const t = s.maxPadding;
  function e(i) {
    const n = Math.max(t[i] - s[i], 0);
    return s[i] += n, n;
  }
  s.y += e("top"), s.x += e("left"), e("right"), e("bottom");
}
function Np(s, t) {
  const e = t.maxPadding;
  function i(n) {
    const r = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return n.forEach((a) => {
      r[a] = Math.max(t[a], e[a]);
    }), r;
  }
  return i(s ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function ds(s, t, e, i) {
  const n = [];
  let r, a, o, l, c, u;
  for (r = 0, a = s.length, c = 0; r < a; ++r) {
    o = s[r], l = o.box, l.update(o.width || t.w, o.height || t.h, Np(o.horizontal, t));
    const { same: d, other: p } = qp(t, e, o, i);
    c |= d && n.length, u = u || p, l.fullSize || n.push(o);
  }
  return c && ds(n, t, e, i) || u;
}
function Gs(s, t, e, i, n) {
  s.top = e, s.left = t, s.right = t + i, s.bottom = e + n, s.width = i, s.height = n;
}
function ya(s, t, e, i) {
  const n = e.padding;
  let { x: r, y: a } = t;
  for (const o of s) {
    const l = o.box, c = i[o.stack] || {
      placed: 0,
      weight: 1
    }, u = o.stackWeight / c.weight || 1;
    if (o.horizontal) {
      const d = t.w * u, p = c.size || l.height;
      xs(c.start) && (a = c.start), l.fullSize ? Gs(l, n.left, a, e.outerWidth - n.right - n.left, p) : Gs(l, t.left + c.placed, a, d, p), c.start = a, c.placed += d, a = l.bottom;
    } else {
      const d = t.h * u, p = c.size || l.width;
      xs(c.start) && (r = c.start), l.fullSize ? Gs(l, r, n.top, p, e.outerHeight - n.bottom - n.top) : Gs(l, r, t.top + c.placed, p, d), c.start = r, c.placed += d, r = l.right;
    }
  }
  t.x = r, t.y = a;
}
var mt = {
  addBox(s, t) {
    s.boxes || (s.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(e) {
            t.draw(e);
          }
        }
      ];
    }, s.boxes.push(t);
  },
  removeBox(s, t) {
    const e = s.boxes ? s.boxes.indexOf(t) : -1;
    e !== -1 && s.boxes.splice(e, 1);
  },
  configure(s, t, e) {
    t.fullSize = e.fullSize, t.position = e.position, t.weight = e.weight;
  },
  update(s, t, e, i) {
    if (!s)
      return;
    const n = gt(s.options.layout.padding), r = Math.max(t - n.width, 0), a = Math.max(e - n.height, 0), o = Lp(s.boxes), l = o.vertical, c = o.horizontal;
    j(s.boxes, (_) => {
      typeof _.beforeLayout == "function" && _.beforeLayout();
    });
    const u = l.reduce((_, y) => y.box.options && y.box.options.display === !1 ? _ : _ + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: e,
      padding: n,
      availableWidth: r,
      availableHeight: a,
      vBoxMaxWidth: r / 2 / u,
      hBoxMaxHeight: a / 2
    }), p = Object.assign({}, n);
    Cl(p, gt(i));
    const h = Object.assign({
      maxPadding: p,
      w: r,
      h: a,
      x: n.left,
      y: n.top
    }, n), m = Fp(l.concat(c), d);
    ds(o.fullSize, h, d, m), ds(l, h, d, m), ds(c, h, d, m) && ds(l, h, d, m), Up(h), ya(o.leftAndTop, h, d, m), h.x += h.w, h.y += h.h, ya(o.rightAndBottom, h, d, m), s.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, j(o.chartArea, (_) => {
      const y = _.box;
      Object.assign(y, s.chartArea), y.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class wl {
  acquireContext(t, e) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, e, i) {
  }
  removeEventListener(t, e, i) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, e, i, n) {
    return e = Math.max(0, e || t.width), i = i || t.height, {
      width: e,
      height: Math.max(0, n ? Math.floor(e / n) : i)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class Bp extends wl {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const ci = "$chartjs", jp = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, ba = (s) => s === null || s === "";
function zp(s, t) {
  const e = s.style, i = s.getAttribute("height"), n = s.getAttribute("width");
  if (s[ci] = {
    initial: {
      height: i,
      width: n,
      style: {
        display: e.display,
        height: e.height,
        width: e.width
      }
    }
  }, e.display = e.display || "block", e.boxSizing = e.boxSizing || "border-box", ba(n)) {
    const r = ea(s, "width");
    r !== void 0 && (s.width = r);
  }
  if (ba(i))
    if (s.style.height === "")
      s.height = s.width / (t || 2);
    else {
      const r = ea(s, "height");
      r !== void 0 && (s.height = r);
    }
  return s;
}
const $l = Hd ? {
  passive: !0
} : !1;
function Vp(s, t, e) {
  s.addEventListener(t, e, $l);
}
function Hp(s, t, e) {
  s.canvas.removeEventListener(t, e, $l);
}
function Wp(s, t) {
  const e = jp[s.type] || s.type, { x: i, y: n } = ve(s, t);
  return {
    type: e,
    chart: t,
    native: s,
    x: i !== void 0 ? i : null,
    y: n !== void 0 ? n : null
  };
}
function vi(s, t) {
  for (const e of s)
    if (e === t || e.contains(t))
      return !0;
}
function Gp(s, t, e) {
  const i = s.canvas, n = new MutationObserver((r) => {
    let a = !1;
    for (const o of r)
      a = a || vi(o.addedNodes, i), a = a && !vi(o.removedNodes, i);
    a && e();
  });
  return n.observe(document, {
    childList: !0,
    subtree: !0
  }), n;
}
function Kp(s, t, e) {
  const i = s.canvas, n = new MutationObserver((r) => {
    let a = !1;
    for (const o of r)
      a = a || vi(o.removedNodes, i), a = a && !vi(o.addedNodes, i);
    a && e();
  });
  return n.observe(document, {
    childList: !0,
    subtree: !0
  }), n;
}
const $s = /* @__PURE__ */ new Map();
let va = 0;
function Sl() {
  const s = window.devicePixelRatio;
  s !== va && (va = s, $s.forEach((t, e) => {
    e.currentDevicePixelRatio !== s && t();
  }));
}
function Yp(s, t) {
  $s.size || window.addEventListener("resize", Sl), $s.set(s, t);
}
function Xp(s) {
  $s.delete(s), $s.size || window.removeEventListener("resize", Sl);
}
function Zp(s, t, e) {
  const i = s.canvas, n = i && Zn(i);
  if (!n)
    return;
  const r = sl((o, l) => {
    const c = n.clientWidth;
    e(o, l), c < n.clientWidth && e();
  }, window), a = new ResizeObserver((o) => {
    const l = o[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || r(c, u);
  });
  return a.observe(n), Yp(s, r), a;
}
function en(s, t, e) {
  e && e.disconnect(), t === "resize" && Xp(s);
}
function Qp(s, t, e) {
  const i = s.canvas, n = sl((r) => {
    s.ctx !== null && e(Wp(r, s));
  }, s);
  return Vp(i, t, n), n;
}
class Jp extends wl {
  acquireContext(t, e) {
    const i = t && t.getContext && t.getContext("2d");
    return i && i.canvas === t ? (zp(t, e), i) : null;
  }
  releaseContext(t) {
    const e = t.canvas;
    if (!e[ci])
      return !1;
    const i = e[ci].initial;
    [
      "height",
      "width"
    ].forEach((r) => {
      const a = i[r];
      N(a) ? e.removeAttribute(r) : e.setAttribute(r, a);
    });
    const n = i.style || {};
    return Object.keys(n).forEach((r) => {
      e.style[r] = n[r];
    }), e.width = e.width, delete e[ci], !0;
  }
  addEventListener(t, e, i) {
    this.removeEventListener(t, e);
    const n = t.$proxies || (t.$proxies = {}), a = {
      attach: Gp,
      detach: Kp,
      resize: Zp
    }[e] || Qp;
    n[e] = a(t, e, i);
  }
  removeEventListener(t, e) {
    const i = t.$proxies || (t.$proxies = {}), n = i[e];
    if (!n)
      return;
    ({
      attach: en,
      detach: en,
      resize: en
    }[e] || Hp)(t, e, n), i[e] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, e, i, n) {
    return Vd(t, e, i, n);
  }
  isAttached(t) {
    const e = Zn(t);
    return !!(e && e.isConnected);
  }
}
function th(s) {
  return !Xn() || typeof OffscreenCanvas < "u" && s instanceof OffscreenCanvas ? Bp : Jp;
}
var ii;
let ie = (ii = class {
  constructor() {
    A(this, "x");
    A(this, "y");
    A(this, "active", !1);
    A(this, "options");
    A(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: e, y: i } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: e,
      y: i
    };
  }
  hasValue() {
    return ze(this.x) && ze(this.y);
  }
  getProps(t, e) {
    const i = this.$animations;
    if (!e || !i)
      return this;
    const n = {};
    return t.forEach((r) => {
      n[r] = i[r] && i[r].active() ? i[r]._to : this[r];
    }), n;
  }
}, A(ii, "defaults", {}), A(ii, "defaultRoutes"), ii);
function eh(s, t) {
  const e = s.options.ticks, i = sh(s), n = Math.min(e.maxTicksLimit || i, i), r = e.major.enabled ? nh(t) : [], a = r.length, o = r[0], l = r[a - 1], c = [];
  if (a > n)
    return rh(t, c, r, a / n), c;
  const u = ih(r, t, n);
  if (a > 0) {
    let d, p;
    const h = a > 1 ? Math.round((l - o) / (a - 1)) : null;
    for (Ks(t, c, u, N(h) ? 0 : o - h, o), d = 0, p = a - 1; d < p; d++)
      Ks(t, c, u, r[d], r[d + 1]);
    return Ks(t, c, u, l, N(h) ? t.length : l + h), c;
  }
  return Ks(t, c, u), c;
}
function sh(s) {
  const t = s.options.offset, e = s._tickSize(), i = s._length / e + (t ? 0 : 1), n = s._maxLength / e;
  return Math.floor(Math.min(i, n));
}
function ih(s, t, e) {
  const i = ah(s), n = t.length / e;
  if (!i)
    return Math.max(n, 1);
  const r = Ku(i);
  for (let a = 0, o = r.length - 1; a < o; a++) {
    const l = r[a];
    if (l > n)
      return l;
  }
  return Math.max(n, 1);
}
function nh(s) {
  const t = [];
  let e, i;
  for (e = 0, i = s.length; e < i; e++)
    s[e].major && t.push(e);
  return t;
}
function rh(s, t, e, i) {
  let n = 0, r = e[0], a;
  for (i = Math.ceil(i), a = 0; a < s.length; a++)
    a === r && (t.push(s[a]), n++, r = e[n * i]);
}
function Ks(s, t, e, i, n) {
  const r = D(i, 0), a = Math.min(D(n, s.length), s.length);
  let o = 0, l, c, u;
  for (e = Math.ceil(e), n && (l = n - i, e = l / Math.floor(l / e)), u = r; u < 0; )
    o++, u = Math.round(r + o * e);
  for (c = Math.max(r, 0); c < a; c++)
    c === u && (t.push(s[c]), o++, u = Math.round(r + o * e));
}
function ah(s) {
  const t = s.length;
  let e, i;
  if (t < 2)
    return !1;
  for (i = s[0], e = 1; e < t; ++e)
    if (s[e] - s[e - 1] !== i)
      return !1;
  return i;
}
const oh = (s) => s === "left" ? "right" : s === "right" ? "left" : s, ka = (s, t, e) => t === "top" || t === "left" ? s[t] + e : s[t] - e, xa = (s, t) => Math.min(t || s, s);
function Ca(s, t) {
  const e = [], i = s.length / t, n = s.length;
  let r = 0;
  for (; r < n; r += i)
    e.push(s[Math.floor(r)]);
  return e;
}
function lh(s, t, e) {
  const i = s.ticks.length, n = Math.min(t, i - 1), r = s._startPixel, a = s._endPixel, o = 1e-6;
  let l = s.getPixelForTick(n), c;
  if (!(e && (i === 1 ? c = Math.max(l - r, a - l) : t === 0 ? c = (s.getPixelForTick(1) - l) / 2 : c = (l - s.getPixelForTick(n - 1)) / 2, l += n < t ? c : -c, l < r - o || l > a + o)))
    return l;
}
function ch(s, t) {
  j(s, (e) => {
    const i = e.gc, n = i.length / 2;
    let r;
    if (n > t) {
      for (r = 0; r < n; ++r)
        delete e.data[i[r]];
      i.splice(0, n);
    }
  });
}
function ts(s) {
  return s.drawTicks ? s.tickLength : 0;
}
function wa(s, t) {
  if (!s.display)
    return 0;
  const e = ot(s.font, t), i = gt(s.padding);
  return (Z(s.text) ? s.text.length : 1) * e.lineHeight + i.height;
}
function uh(s, t) {
  return he(s, {
    scale: t,
    type: "scale"
  });
}
function dh(s, t, e) {
  return he(s, {
    tick: e,
    index: t,
    type: "tick"
  });
}
function ph(s, t, e) {
  let i = Vn(s);
  return (e && t !== "right" || !e && t === "right") && (i = oh(i)), i;
}
function hh(s, t, e, i) {
  const { top: n, left: r, bottom: a, right: o, chart: l } = s, { chartArea: c, scales: u } = l;
  let d = 0, p, h, m;
  const _ = a - n, y = o - r;
  if (s.isHorizontal()) {
    if (h = ft(i, r, o), U(e)) {
      const v = Object.keys(e)[0], k = e[v];
      m = u[v].getPixelForValue(k) + _ - t;
    } else e === "center" ? m = (c.bottom + c.top) / 2 + _ - t : m = ka(s, e, t);
    p = o - r;
  } else {
    if (U(e)) {
      const v = Object.keys(e)[0], k = e[v];
      h = u[v].getPixelForValue(k) - y + t;
    } else e === "center" ? h = (c.left + c.right) / 2 - y + t : h = ka(s, e, t);
    m = ft(i, a, n), d = e === "left" ? -at : at;
  }
  return {
    titleX: h,
    titleY: m,
    maxWidth: p,
    rotation: d
  };
}
class Oe extends ie {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, e) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: e, _suggestedMin: i, _suggestedMax: n } = this;
    return t = Tt(t, Number.POSITIVE_INFINITY), e = Tt(e, Number.NEGATIVE_INFINITY), i = Tt(i, Number.POSITIVE_INFINITY), n = Tt(n, Number.NEGATIVE_INFINITY), {
      min: Tt(t, i),
      max: Tt(e, n),
      minDefined: it(t),
      maxDefined: it(e)
    };
  }
  getMinMax(t) {
    let { min: e, max: i, minDefined: n, maxDefined: r } = this.getUserBounds(), a;
    if (n && r)
      return {
        min: e,
        max: i
      };
    const o = this.getMatchingVisibleMetas();
    for (let l = 0, c = o.length; l < c; ++l)
      a = o[l].controller.getMinMax(this, t), n || (e = Math.min(e, a.min)), r || (i = Math.max(i, a.max));
    return e = r && e > i ? i : e, i = n && e > i ? e : i, {
      min: Tt(e, Tt(i, e)),
      max: Tt(i, Tt(e, i))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    W(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, e, i) {
    const { beginAtZero: n, grace: r, ticks: a } = this.options, o = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = e, this._margins = i = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, i), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + i.left + i.right : this.height + i.top + i.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = xd(this, r, n), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = o < this.ticks.length;
    this._convertTicksToLabels(l ? Ca(this.ticks, o) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = eh(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, e, i;
    this.isHorizontal() ? (e = this.left, i = this.right) : (e = this.top, i = this.bottom, t = !t), this._startPixel = e, this._endPixel = i, this._reversePixels = t, this._length = i - e, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    W(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    W(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    W(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), W(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    W(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const e = this.options.ticks;
    let i, n, r;
    for (i = 0, n = t.length; i < n; i++)
      r = t[i], r.label = W(e.callback, [
        r.value,
        i,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    W(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    W(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, e = t.ticks, i = xa(this.ticks.length, t.ticks.maxTicksLimit), n = e.minRotation || 0, r = e.maxRotation;
    let a = n, o, l, c;
    if (!this._isVisible() || !e.display || n >= r || i <= 1 || !this.isHorizontal()) {
      this.labelRotation = n;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, p = u.highest.height, h = ut(this.chart.width - d, 0, this.maxWidth);
    o = t.offset ? this.maxWidth / i : h / (i - 1), d + 6 > o && (o = h / (i - (t.offset ? 0.5 : 1)), l = this.maxHeight - ts(t.grid) - e.padding - wa(t.title, this.chart.options.font), c = Math.sqrt(d * d + p * p), a = jn(Math.min(Math.asin(ut((u.highest.height + 6) / o, -1, 1)), Math.asin(ut(l / c, -1, 1)) - Math.asin(ut(p / c, -1, 1)))), a = Math.max(n, Math.min(r, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    W(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    W(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: e, options: { ticks: i, title: n, grid: r } } = this, a = this._isVisible(), o = this.isHorizontal();
    if (a) {
      const l = wa(n, e.options.font);
      if (o ? (t.width = this.maxWidth, t.height = ts(r) + l) : (t.height = this.maxHeight, t.width = ts(r) + l), i.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: p } = this._getLabelSizes(), h = i.padding * 2, m = Ft(this.labelRotation), _ = Math.cos(m), y = Math.sin(m);
        if (o) {
          const v = i.mirror ? 0 : y * d.width + _ * p.height;
          t.height = Math.min(this.maxHeight, t.height + v + h);
        } else {
          const v = i.mirror ? 0 : _ * d.width + y * p.height;
          t.width = Math.min(this.maxWidth, t.width + v + h);
        }
        this._calculatePadding(c, u, y, _);
      }
    }
    this._handleMargins(), o ? (this.width = this._length = e.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = e.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, e, i, n) {
    const { ticks: { align: r, padding: a }, position: o } = this.options, l = this.labelRotation !== 0, c = o !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let p = 0, h = 0;
      l ? c ? (p = n * t.width, h = i * e.height) : (p = i * t.height, h = n * e.width) : r === "start" ? h = e.width : r === "end" ? p = t.width : r !== "inner" && (p = t.width / 2, h = e.width / 2), this.paddingLeft = Math.max((p - u + a) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - d + a) * this.width / (this.width - d), 0);
    } else {
      let u = e.height / 2, d = t.height / 2;
      r === "start" ? (u = 0, d = t.height) : r === "end" && (u = e.height, d = 0), this.paddingTop = u + a, this.paddingBottom = d + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    W(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: e } = this.options;
    return e === "top" || e === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let e, i;
    for (e = 0, i = t.length; e < i; e++)
      N(t[e].label) && (t.splice(e, 1), i--, e--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const e = this.options.ticks.sampleSize;
      let i = this.ticks;
      e < i.length && (i = Ca(i, e)), this._labelSizes = t = this._computeLabelSizes(i, i.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, e, i) {
    const { ctx: n, _longestTextCache: r } = this, a = [], o = [], l = Math.floor(e / xa(e, i));
    let c = 0, u = 0, d, p, h, m, _, y, v, k, w, x, C;
    for (d = 0; d < e; d += l) {
      if (m = t[d].label, _ = this._resolveTickFontOptions(d), n.font = y = _.string, v = r[y] = r[y] || {
        data: {},
        gc: []
      }, k = _.lineHeight, w = x = 0, !N(m) && !Z(m))
        w = yi(n, v.data, v.gc, w, m), x = k;
      else if (Z(m))
        for (p = 0, h = m.length; p < h; ++p)
          C = m[p], !N(C) && !Z(C) && (w = yi(n, v.data, v.gc, w, C), x += k);
      a.push(w), o.push(x), c = Math.max(w, c), u = Math.max(x, u);
    }
    ch(r, e);
    const $ = a.indexOf(c), S = o.indexOf(u), I = (R) => ({
      width: a[R] || 0,
      height: o[R] || 0
    });
    return {
      first: I(0),
      last: I(e - 1),
      widest: I($),
      highest: I(S),
      widths: a,
      heights: o
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, e) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const e = this._startPixel + t * this._length;
    return Zu(this._alignToPixels ? ge(this.chart, e, 0) : e);
  }
  getDecimalForPixel(t) {
    const e = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - e : e;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: e } = this;
    return t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0;
  }
  getContext(t) {
    const e = this.ticks || [];
    if (t >= 0 && t < e.length) {
      const i = e[t];
      return i.$context || (i.$context = dh(this.getContext(), t, i));
    }
    return this.$context || (this.$context = uh(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, e = Ft(this.labelRotation), i = Math.abs(Math.cos(e)), n = Math.abs(Math.sin(e)), r = this._getLabelSizes(), a = t.autoSkipPadding || 0, o = r ? r.widest.width + a : 0, l = r ? r.highest.height + a : 0;
    return this.isHorizontal() ? l * i > o * n ? o / i : l / n : l * n < o * i ? l / i : o / n;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const e = this.axis, i = this.chart, n = this.options, { grid: r, position: a, border: o } = n, l = r.offset, c = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), p = ts(r), h = [], m = o.setContext(this.getContext()), _ = m.display ? m.width : 0, y = _ / 2, v = function(V) {
      return ge(i, V, _);
    };
    let k, w, x, C, $, S, I, R, F, O, L, rt;
    if (a === "top")
      k = v(this.bottom), S = this.bottom - p, R = k - y, O = v(t.top) + y, rt = t.bottom;
    else if (a === "bottom")
      k = v(this.top), O = t.top, rt = v(t.bottom) - y, S = k + y, R = this.top + p;
    else if (a === "left")
      k = v(this.right), $ = this.right - p, I = k - y, F = v(t.left) + y, L = t.right;
    else if (a === "right")
      k = v(this.left), F = t.left, L = v(t.right) - y, $ = k + y, I = this.left + p;
    else if (e === "x") {
      if (a === "center")
        k = v((t.top + t.bottom) / 2 + 0.5);
      else if (U(a)) {
        const V = Object.keys(a)[0], J = a[V];
        k = v(this.chart.scales[V].getPixelForValue(J));
      }
      O = t.top, rt = t.bottom, S = k + y, R = S + p;
    } else if (e === "y") {
      if (a === "center")
        k = v((t.left + t.right) / 2);
      else if (U(a)) {
        const V = Object.keys(a)[0], J = a[V];
        k = v(this.chart.scales[V].getPixelForValue(J));
      }
      $ = k - y, I = $ - p, F = t.left, L = t.right;
    }
    const dt = D(n.ticks.maxTicksLimit, d), B = Math.max(1, Math.ceil(d / dt));
    for (w = 0; w < d; w += B) {
      const V = this.getContext(w), J = r.setContext(V), xt = o.setContext(V), lt = J.lineWidth, Wt = J.color, tt = xt.dash || [], Gt = xt.dashOffset, et = J.tickWidth, qt = J.tickColor, z = J.tickBorderDash || [], St = J.tickBorderDashOffset;
      x = lh(this, w, l), x !== void 0 && (C = ge(i, x, lt), c ? $ = I = F = L = C : S = R = O = rt = C, h.push({
        tx1: $,
        ty1: S,
        tx2: I,
        ty2: R,
        x1: F,
        y1: O,
        x2: L,
        y2: rt,
        width: lt,
        color: Wt,
        borderDash: tt,
        borderDashOffset: Gt,
        tickWidth: et,
        tickColor: qt,
        tickBorderDash: z,
        tickBorderDashOffset: St
      }));
    }
    return this._ticksLength = d, this._borderValue = k, h;
  }
  _computeLabelItems(t) {
    const e = this.axis, i = this.options, { position: n, ticks: r } = i, a = this.isHorizontal(), o = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = r, p = ts(i.grid), h = p + u, m = d ? -u : h, _ = -Ft(this.labelRotation), y = [];
    let v, k, w, x, C, $, S, I, R, F, O, L, rt = "middle";
    if (n === "top")
      $ = this.bottom - m, S = this._getXAxisLabelAlignment();
    else if (n === "bottom")
      $ = this.top + m, S = this._getXAxisLabelAlignment();
    else if (n === "left") {
      const B = this._getYAxisLabelAlignment(p);
      S = B.textAlign, C = B.x;
    } else if (n === "right") {
      const B = this._getYAxisLabelAlignment(p);
      S = B.textAlign, C = B.x;
    } else if (e === "x") {
      if (n === "center")
        $ = (t.top + t.bottom) / 2 + h;
      else if (U(n)) {
        const B = Object.keys(n)[0], V = n[B];
        $ = this.chart.scales[B].getPixelForValue(V) + h;
      }
      S = this._getXAxisLabelAlignment();
    } else if (e === "y") {
      if (n === "center")
        C = (t.left + t.right) / 2 - h;
      else if (U(n)) {
        const B = Object.keys(n)[0], V = n[B];
        C = this.chart.scales[B].getPixelForValue(V);
      }
      S = this._getYAxisLabelAlignment(p).textAlign;
    }
    e === "y" && (l === "start" ? rt = "top" : l === "end" && (rt = "bottom"));
    const dt = this._getLabelSizes();
    for (v = 0, k = o.length; v < k; ++v) {
      w = o[v], x = w.label;
      const B = r.setContext(this.getContext(v));
      I = this.getPixelForTick(v) + r.labelOffset, R = this._resolveTickFontOptions(v), F = R.lineHeight, O = Z(x) ? x.length : 1;
      const V = O / 2, J = B.color, xt = B.textStrokeColor, lt = B.textStrokeWidth;
      let Wt = S;
      a ? (C = I, S === "inner" && (v === k - 1 ? Wt = this.options.reverse ? "left" : "right" : v === 0 ? Wt = this.options.reverse ? "right" : "left" : Wt = "center"), n === "top" ? c === "near" || _ !== 0 ? L = -O * F + F / 2 : c === "center" ? L = -dt.highest.height / 2 - V * F + F : L = -dt.highest.height + F / 2 : c === "near" || _ !== 0 ? L = F / 2 : c === "center" ? L = dt.highest.height / 2 - V * F : L = dt.highest.height - O * F, d && (L *= -1), _ !== 0 && !B.showLabelBackdrop && (C += F / 2 * Math.sin(_))) : ($ = I, L = (1 - O) * F / 2);
      let tt;
      if (B.showLabelBackdrop) {
        const Gt = gt(B.backdropPadding), et = dt.heights[v], qt = dt.widths[v];
        let z = L - Gt.top, St = 0 - Gt.left;
        switch (rt) {
          case "middle":
            z -= et / 2;
            break;
          case "bottom":
            z -= et;
            break;
        }
        switch (S) {
          case "center":
            St -= qt / 2;
            break;
          case "right":
            St -= qt;
            break;
          case "inner":
            v === k - 1 ? St -= qt : v > 0 && (St -= qt / 2);
            break;
        }
        tt = {
          left: St,
          top: z,
          width: qt + Gt.width,
          height: et + Gt.height,
          color: B.backdropColor
        };
      }
      y.push({
        label: x,
        font: R,
        textOffset: L,
        options: {
          rotation: _,
          color: J,
          strokeColor: xt,
          strokeWidth: lt,
          textAlign: Wt,
          textBaseline: rt,
          translation: [
            C,
            $
          ],
          backdrop: tt
        }
      });
    }
    return y;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: e } = this.options;
    if (-Ft(this.labelRotation))
      return t === "top" ? "left" : "right";
    let n = "center";
    return e.align === "start" ? n = "left" : e.align === "end" ? n = "right" : e.align === "inner" && (n = "inner"), n;
  }
  _getYAxisLabelAlignment(t) {
    const { position: e, ticks: { crossAlign: i, mirror: n, padding: r } } = this.options, a = this._getLabelSizes(), o = t + r, l = a.widest.width;
    let c, u;
    return e === "left" ? n ? (u = this.right + r, i === "near" ? c = "left" : i === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - o, i === "near" ? c = "right" : i === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : e === "right" ? n ? (u = this.left + r, i === "near" ? c = "right" : i === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + o, i === "near" ? c = "left" : i === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, e = this.options.position;
    if (e === "left" || e === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (e === "top" || e === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: e }, left: i, top: n, width: r, height: a } = this;
    e && (t.save(), t.fillStyle = e, t.fillRect(i, n, r, a), t.restore());
  }
  getLineWidthForValue(t) {
    const e = this.options.grid;
    if (!this._isVisible() || !e.display)
      return 0;
    const n = this.ticks.findIndex((r) => r.value === t);
    return n >= 0 ? e.setContext(this.getContext(n)).lineWidth : 0;
  }
  drawGrid(t) {
    const e = this.options.grid, i = this.ctx, n = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let r, a;
    const o = (l, c, u) => {
      !u.width || !u.color || (i.save(), i.lineWidth = u.width, i.strokeStyle = u.color, i.setLineDash(u.borderDash || []), i.lineDashOffset = u.borderDashOffset, i.beginPath(), i.moveTo(l.x, l.y), i.lineTo(c.x, c.y), i.stroke(), i.restore());
    };
    if (e.display)
      for (r = 0, a = n.length; r < a; ++r) {
        const l = n[r];
        e.drawOnChartArea && o({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), e.drawTicks && o({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: e, options: { border: i, grid: n } } = this, r = i.setContext(this.getContext()), a = i.display ? r.width : 0;
    if (!a)
      return;
    const o = n.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, d, p;
    this.isHorizontal() ? (c = ge(t, this.left, a) - a / 2, u = ge(t, this.right, o) + o / 2, d = p = l) : (d = ge(t, this.top, a) - a / 2, p = ge(t, this.bottom, o) + o / 2, c = u = l), e.save(), e.lineWidth = r.width, e.strokeStyle = r.color, e.beginPath(), e.moveTo(c, d), e.lineTo(u, p), e.stroke(), e.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const i = this.ctx, n = this._computeLabelArea();
    n && Ti(i, n);
    const r = this.getLabelItems(t);
    for (const a of r) {
      const o = a.options, l = a.font, c = a.label, u = a.textOffset;
      Ae(i, c, 0, u, l, o);
    }
    n && Ii(i);
  }
  drawTitle() {
    const { ctx: t, options: { position: e, title: i, reverse: n } } = this;
    if (!i.display)
      return;
    const r = ot(i.font), a = gt(i.padding), o = i.align;
    let l = r.lineHeight / 2;
    e === "bottom" || e === "center" || U(e) ? (l += a.bottom, Z(i.text) && (l += r.lineHeight * (i.text.length - 1))) : l += a.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: p } = hh(this, l, e, o);
    Ae(t, i.text, 0, 0, r, {
      color: i.color,
      maxWidth: d,
      rotation: p,
      textAlign: ph(o, e, n),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, e = t.ticks && t.ticks.z || 0, i = D(t.grid && t.grid.z, -1), n = D(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Oe.prototype.draw ? [
      {
        z: e,
        draw: (r) => {
          this.draw(r);
        }
      }
    ] : [
      {
        z: i,
        draw: (r) => {
          this.drawBackground(), this.drawGrid(r), this.drawTitle();
        }
      },
      {
        z: n,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: e,
        draw: (r) => {
          this.drawLabels(r);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const e = this.chart.getSortedVisibleDatasetMetas(), i = this.axis + "AxisID", n = [];
    let r, a;
    for (r = 0, a = e.length; r < a; ++r) {
      const o = e[r];
      o[i] === this.id && (!t || o.type === t) && n.push(o);
    }
    return n;
  }
  _resolveTickFontOptions(t) {
    const e = this.options.ticks.setContext(this.getContext(t));
    return ot(e.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Ys {
  constructor(t, e, i) {
    this.type = t, this.scope = e, this.override = i, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const e = Object.getPrototypeOf(t);
    let i;
    gh(e) && (i = this.register(e));
    const n = this.items, r = t.id, a = this.scope + "." + r;
    if (!r)
      throw new Error("class does not have id: " + t);
    return r in n || (n[r] = t, fh(t, a, i), this.override && nt.override(t.id, t.overrides)), a;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const e = this.items, i = t.id, n = this.scope;
    i in e && delete e[i], n && i in nt[n] && (delete nt[n][i], this.override && delete Ie[i]);
  }
}
function fh(s, t, e) {
  const i = ks(/* @__PURE__ */ Object.create(null), [
    e ? nt.get(e) : {},
    nt.get(t),
    s.defaults
  ]);
  nt.set(t, i), s.defaultRoutes && mh(t, s.defaultRoutes), s.descriptors && nt.describe(t, s.descriptors);
}
function mh(s, t) {
  Object.keys(t).forEach((e) => {
    const i = e.split("."), n = i.pop(), r = [
      s
    ].concat(i).join("."), a = t[e].split("."), o = a.pop(), l = a.join(".");
    nt.route(r, n, l, o);
  });
}
function gh(s) {
  return "id" in s && "defaults" in s;
}
class _h {
  constructor() {
    this.controllers = new Ys(Lt, "datasets", !0), this.elements = new Ys(ie, "elements"), this.plugins = new Ys(Object, "plugins"), this.scales = new Ys(Oe, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, e, i) {
    [
      ...e
    ].forEach((n) => {
      const r = i || this._getRegistryForType(n);
      i || r.isForType(n) || r === this.plugins && n.id ? this._exec(t, r, n) : j(n, (a) => {
        const o = i || this._getRegistryForType(a);
        this._exec(t, o, a);
      });
    });
  }
  _exec(t, e, i) {
    const n = Bn(t);
    W(i["before" + n], [], i), e[t](i), W(i["after" + n], [], i);
  }
  _getRegistryForType(t) {
    for (let e = 0; e < this._typedRegistries.length; e++) {
      const i = this._typedRegistries[e];
      if (i.isForType(t))
        return i;
    }
    return this.plugins;
  }
  _get(t, e, i) {
    const n = e.get(t);
    if (n === void 0)
      throw new Error('"' + t + '" is not a registered ' + i + ".");
    return n;
  }
}
var jt = /* @__PURE__ */ new _h();
class yh {
  constructor() {
    this._init = [];
  }
  notify(t, e, i, n) {
    e === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const r = n ? this._descriptors(t).filter(n) : this._descriptors(t), a = this._notify(r, t, e, i);
    return e === "afterDestroy" && (this._notify(r, t, "stop"), this._notify(this._init, t, "uninstall")), a;
  }
  _notify(t, e, i, n) {
    n = n || {};
    for (const r of t) {
      const a = r.plugin, o = a[i], l = [
        e,
        n,
        r.options
      ];
      if (W(o, l, a) === !1 && n.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    N(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const e = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), e;
  }
  _createDescriptors(t, e) {
    const i = t && t.config, n = D(i.options && i.options.plugins, {}), r = bh(i);
    return n === !1 && !e ? [] : kh(t, r, n, e);
  }
  _notifyStateChanges(t) {
    const e = this._oldCache || [], i = this._cache, n = (r, a) => r.filter((o) => !a.some((l) => o.plugin.id === l.plugin.id));
    this._notify(n(e, i), t, "stop"), this._notify(n(i, e), t, "start");
  }
}
function bh(s) {
  const t = {}, e = [], i = Object.keys(jt.plugins.items);
  for (let r = 0; r < i.length; r++)
    e.push(jt.getPlugin(i[r]));
  const n = s.plugins || [];
  for (let r = 0; r < n.length; r++) {
    const a = n[r];
    e.indexOf(a) === -1 && (e.push(a), t[a.id] = !0);
  }
  return {
    plugins: e,
    localIds: t
  };
}
function vh(s, t) {
  return !t && s === !1 ? null : s === !0 ? {} : s;
}
function kh(s, { plugins: t, localIds: e }, i, n) {
  const r = [], a = s.getContext();
  for (const o of t) {
    const l = o.id, c = vh(i[l], n);
    c !== null && r.push({
      plugin: o,
      options: xh(s.config, {
        plugin: o,
        local: e[l]
      }, c, a)
    });
  }
  return r;
}
function xh(s, { plugin: t, local: e }, i, n) {
  const r = s.pluginScopeKeys(t), a = s.getOptionScopes(i, r);
  return e && t.defaults && a.push(t.defaults), s.createResolver(a, n, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function bn(s, t) {
  const e = nt.datasets[s] || {};
  return ((t.datasets || {})[s] || {}).indexAxis || t.indexAxis || e.indexAxis || "x";
}
function Ch(s, t) {
  let e = s;
  return s === "_index_" ? e = t : s === "_value_" && (e = t === "x" ? "y" : "x"), e;
}
function wh(s, t) {
  return s === t ? "_index_" : "_value_";
}
function $a(s) {
  if (s === "x" || s === "y" || s === "r")
    return s;
}
function $h(s) {
  if (s === "top" || s === "bottom")
    return "x";
  if (s === "left" || s === "right")
    return "y";
}
function vn(s, ...t) {
  if ($a(s))
    return s;
  for (const e of t) {
    const i = e.axis || $h(e.position) || s.length > 1 && $a(s[0].toLowerCase());
    if (i)
      return i;
  }
  throw new Error(`Cannot determine type of '${s}' axis. Please provide 'axis' or 'position' option.`);
}
function Sa(s, t, e) {
  if (e[t + "AxisID"] === s)
    return {
      axis: t
    };
}
function Sh(s, t) {
  if (t.data && t.data.datasets) {
    const e = t.data.datasets.filter((i) => i.xAxisID === s || i.yAxisID === s);
    if (e.length)
      return Sa(s, "x", e[0]) || Sa(s, "y", e[0]);
  }
  return {};
}
function Th(s, t) {
  const e = Ie[s.type] || {
    scales: {}
  }, i = t.scales || {}, n = bn(s.type, t), r = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach((a) => {
    const o = i[a];
    if (!U(o))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (o._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const l = vn(a, o, Sh(a, s), nt.scales[o.type]), c = wh(l, n), u = e.scales || {};
    r[a] = ms(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      o,
      u[l],
      u[c]
    ]);
  }), s.data.datasets.forEach((a) => {
    const o = a.type || s.type, l = a.indexAxis || bn(o, t), u = (Ie[o] || {}).scales || {};
    Object.keys(u).forEach((d) => {
      const p = Ch(d, l), h = a[p + "AxisID"] || p;
      r[h] = r[h] || /* @__PURE__ */ Object.create(null), ms(r[h], [
        {
          axis: p
        },
        i[h],
        u[d]
      ]);
    });
  }), Object.keys(r).forEach((a) => {
    const o = r[a];
    ms(o, [
      nt.scales[o.type],
      nt.scale
    ]);
  }), r;
}
function Tl(s) {
  const t = s.options || (s.options = {});
  t.plugins = D(t.plugins, {}), t.scales = Th(s, t);
}
function Il(s) {
  return s = s || {}, s.datasets = s.datasets || [], s.labels = s.labels || [], s;
}
function Ih(s) {
  return s = s || {}, s.data = Il(s.data), Tl(s), s;
}
const Ta = /* @__PURE__ */ new Map(), Al = /* @__PURE__ */ new Set();
function Xs(s, t) {
  let e = Ta.get(s);
  return e || (e = t(), Ta.set(s, e), Al.add(e)), e;
}
const es = (s, t, e) => {
  const i = ue(t, e);
  i !== void 0 && s.add(i);
};
class Ah {
  constructor(t) {
    this._config = Ih(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = Il(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), Tl(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Xs(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, e) {
    return Xs(`${t}.transition.${e}`, () => [
      [
        `datasets.${t}.transitions.${e}`,
        `transitions.${e}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, e) {
    return Xs(`${t}-${e}`, () => [
      [
        `datasets.${t}.elements.${e}`,
        `datasets.${t}`,
        `elements.${e}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const e = t.id, i = this.type;
    return Xs(`${i}-plugin-${e}`, () => [
      [
        `plugins.${e}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, e) {
    const i = this._scopeCache;
    let n = i.get(t);
    return (!n || e) && (n = /* @__PURE__ */ new Map(), i.set(t, n)), n;
  }
  getOptionScopes(t, e, i) {
    const { options: n, type: r } = this, a = this._cachedScopes(t, i), o = a.get(e);
    if (o)
      return o;
    const l = /* @__PURE__ */ new Set();
    e.forEach((u) => {
      t && (l.add(t), u.forEach((d) => es(l, t, d))), u.forEach((d) => es(l, n, d)), u.forEach((d) => es(l, Ie[r] || {}, d)), u.forEach((d) => es(l, nt, d)), u.forEach((d) => es(l, gn, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), Al.has(e) && a.set(e, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: e } = this;
    return [
      t,
      Ie[e] || {},
      nt.datasets[e] || {},
      {
        type: e
      },
      nt,
      gn
    ];
  }
  resolveNamedOptions(t, e, i, n = [
    ""
  ]) {
    const r = {
      $shared: !0
    }, { resolver: a, subPrefixes: o } = Ia(this._resolverCache, t, n);
    let l = a;
    if (Oh(a, e)) {
      r.$shared = !1, i = de(i) ? i() : i;
      const c = this.createResolver(t, i, o);
      l = Ve(a, i, c);
    }
    for (const c of e)
      r[c] = l[c];
    return r;
  }
  createResolver(t, e, i = [
    ""
  ], n) {
    const { resolver: r } = Ia(this._resolverCache, t, i);
    return U(e) ? Ve(r, e, void 0, n) : r;
  }
}
function Ia(s, t, e) {
  let i = s.get(t);
  i || (i = /* @__PURE__ */ new Map(), s.set(t, i));
  const n = e.join();
  let r = i.get(n);
  return r || (r = {
    resolver: Gn(t, e),
    subPrefixes: e.filter((o) => !o.toLowerCase().includes("hover"))
  }, i.set(n, r)), r;
}
const Ph = (s) => U(s) && Object.getOwnPropertyNames(s).some((t) => de(s[t]));
function Oh(s, t) {
  const { isScriptable: e, isIndexable: i } = ll(s);
  for (const n of t) {
    const r = e(n), a = i(n), o = (a || r) && s[n];
    if (r && (de(o) || Ph(o)) || a && Z(o))
      return !0;
  }
  return !1;
}
var Mh = "4.4.1";
const Rh = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Aa(s, t) {
  return s === "top" || s === "bottom" || Rh.indexOf(s) === -1 && t === "x";
}
function Pa(s, t) {
  return function(e, i) {
    return e[s] === i[s] ? e[t] - i[t] : e[s] - i[s];
  };
}
function Oa(s) {
  const t = s.chart, e = t.options.animation;
  t.notifyPlugins("afterRender"), W(e && e.onComplete, [
    s
  ], t);
}
function Eh(s) {
  const t = s.chart, e = t.options.animation;
  W(e && e.onProgress, [
    s
  ], t);
}
function Pl(s) {
  return Xn() && typeof s == "string" ? s = document.getElementById(s) : s && s.length && (s = s[0]), s && s.canvas && (s = s.canvas), s;
}
const ui = {}, Ma = (s) => {
  const t = Pl(s);
  return Object.values(ui).filter((e) => e.canvas === t).pop();
};
function Dh(s, t, e) {
  const i = Object.keys(s);
  for (const n of i) {
    const r = +n;
    if (r >= t) {
      const a = s[n];
      delete s[n], (e > 0 || r > t) && (s[r + e] = a);
    }
  }
}
function Fh(s, t, e, i) {
  return !e || s.type === "mouseout" ? null : i ? t : s;
}
function Zs(s, t, e) {
  return s.options.clip ? s[e] : t[e];
}
function Lh(s, t) {
  const { xScale: e, yScale: i } = s;
  return e && i ? {
    left: Zs(e, t, "left"),
    right: Zs(e, t, "right"),
    top: Zs(i, t, "top"),
    bottom: Zs(i, t, "bottom")
  } : t;
}
class zt {
  static register(...t) {
    jt.add(...t), Ra();
  }
  static unregister(...t) {
    jt.remove(...t), Ra();
  }
  constructor(t, e) {
    const i = this.config = new Ah(e), n = Pl(t), r = Ma(n);
    if (r)
      throw new Error("Canvas is already in use. Chart with ID '" + r.id + "' must be destroyed before the canvas with ID '" + r.canvas.id + "' can be reused.");
    const a = i.createResolver(i.chartOptionScopes(), this.getContext());
    this.platform = new (i.platform || th(n))(), this.platform.updateConfig(i);
    const o = this.platform.acquireContext(n, a.aspectRatio), l = o && o.canvas, c = l && l.height, u = l && l.width;
    if (this.id = Uu(), this.ctx = o, this.canvas = l, this.width = u, this.height = c, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new yh(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = ed((d) => this.update(d), a.resizeDelay || 0), this._dataChanges = [], ui[this.id] = this, !o || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    Zt.listen(this, "complete", Oa), Zt.listen(this, "progress", Eh), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: e }, width: i, height: n, _aspectRatio: r } = this;
    return N(t) ? e && r ? r : n ? i / n : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return jt;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : ta(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Zr(this.canvas, this.ctx), this;
  }
  stop() {
    return Zt.stop(this), this;
  }
  resize(t, e) {
    Zt.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: e
    } : this._resize(t, e);
  }
  _resize(t, e) {
    const i = this.options, n = this.canvas, r = i.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(n, t, e, r), o = i.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, ta(this, o, !0) && (this.notifyPlugins("resize", {
      size: a
    }), W(i.onResize, [
      this,
      a
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const e = this.options.scales || {};
    j(e, (i, n) => {
      i.id = n;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, e = t.scales, i = this.scales, n = Object.keys(i).reduce((a, o) => (a[o] = !1, a), {});
    let r = [];
    e && (r = r.concat(Object.keys(e).map((a) => {
      const o = e[a], l = vn(a, o), c = l === "r", u = l === "x";
      return {
        options: o,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), j(r, (a) => {
      const o = a.options, l = o.id, c = vn(l, o), u = D(o.type, a.dtype);
      (o.position === void 0 || Aa(o.position, c) !== Aa(a.dposition)) && (o.position = a.dposition), n[l] = !0;
      let d = null;
      if (l in i && i[l].type === u)
        d = i[l];
      else {
        const p = jt.getScale(u);
        d = new p({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), i[d.id] = d;
      }
      d.init(o, t);
    }), j(n, (a, o) => {
      a || delete i[o];
    }), j(i, (a) => {
      mt.configure(this, a, a.options), mt.addBox(this, a);
    });
  }
  _updateMetasets() {
    const t = this._metasets, e = this.data.datasets.length, i = t.length;
    if (t.sort((n, r) => n.index - r.index), i > e) {
      for (let n = e; n < i; ++n)
        this._destroyDatasetMeta(n);
      t.splice(e, i - e);
    }
    this._sortedMetasets = t.slice(0).sort(Pa("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: e } } = this;
    t.length > e.length && delete this._stacks, t.forEach((i, n) => {
      e.filter((r) => r === i._dataset).length === 0 && this._destroyDatasetMeta(n);
    });
  }
  buildOrUpdateControllers() {
    const t = [], e = this.data.datasets;
    let i, n;
    for (this._removeUnreferencedMetasets(), i = 0, n = e.length; i < n; i++) {
      const r = e[i];
      let a = this.getDatasetMeta(i);
      const o = r.type || this.config.type;
      if (a.type && a.type !== o && (this._destroyDatasetMeta(i), a = this.getDatasetMeta(i)), a.type = o, a.indexAxis = r.indexAxis || bn(o, this.options), a.order = r.order || 0, a.index = i, a.label = "" + r.label, a.visible = this.isDatasetVisible(i), a.controller)
        a.controller.updateIndex(i), a.controller.linkScales();
      else {
        const l = jt.getController(o), { datasetElementType: c, dataElementType: u } = nt.datasets[o];
        Object.assign(l, {
          dataElementType: jt.getElement(u),
          datasetElementType: c && jt.getElement(c)
        }), a.controller = new l(this, i), t.push(a.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    j(this.data.datasets, (t, e) => {
      this.getDatasetMeta(e).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const e = this.config;
    e.update();
    const i = this._options = e.createResolver(e.chartOptionScopes(), this.getContext()), n = this._animationsDisabled = !i.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const r = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), p = !n && r.indexOf(d) === -1;
      d.buildOrUpdateElements(p), a = Math.max(+d.getMaxOverflow(), a);
    }
    a = this._minPadding = i.layout.autoPadding ? a : 0, this._updateLayout(a), n || j(r, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(Pa("z", "_idx"));
    const { _active: o, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : o.length && this._updateHoverStyles(o, o, !0), this.render();
  }
  _updateScales() {
    j(this.scales, (t) => {
      mt.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, e = new Set(Object.keys(this._listeners)), i = new Set(t.events);
    (!jr(e, i) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, e = this._getUniformDataChanges() || [];
    for (const { method: i, start: n, count: r } of e) {
      const a = i === "_removeElements" ? -r : r;
      Dh(t, n, a);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const e = this.data.datasets.length, i = (r) => new Set(t.filter((a) => a[0] === r).map((a, o) => o + "," + a.splice(1).join(","))), n = i(0);
    for (let r = 1; r < e; r++)
      if (!jr(n, i(r)))
        return;
    return Array.from(n).map((r) => r.split(",")).map((r) => ({
      method: r[1],
      start: +r[2],
      count: +r[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    mt.update(this, this.width, this.height, t);
    const e = this.chartArea, i = e.width <= 0 || e.height <= 0;
    this._layers = [], j(this.boxes, (n) => {
      i && n.position === "chartArea" || (n.configure && n.configure(), this._layers.push(...n._layers()));
    }, this), this._layers.forEach((n, r) => {
      n._idx = r;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let e = 0, i = this.data.datasets.length; e < i; ++e)
        this.getDatasetMeta(e).controller.configure();
      for (let e = 0, i = this.data.datasets.length; e < i; ++e)
        this._updateDataset(e, de(t) ? t({
          datasetIndex: e
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, e) {
    const i = this.getDatasetMeta(t), n = {
      meta: i,
      index: t,
      mode: e,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", n) !== !1 && (i.controller._update(e), n.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", n));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (Zt.has(this) ? this.attached && !Zt.running(this) && Zt.start(this) : (this.draw(), Oa({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: i, height: n } = this._resizeBeforeDraw;
      this._resize(i, n), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this._layers;
    for (t = 0; t < e.length && e[t].z <= 0; ++t)
      e[t].draw(this.chartArea);
    for (this._drawDatasets(); t < e.length; ++t)
      e[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const e = this._sortedMetasets, i = [];
    let n, r;
    for (n = 0, r = e.length; n < r; ++n) {
      const a = e[n];
      (!t || a.visible) && i.push(a);
    }
    return i;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let e = t.length - 1; e >= 0; --e)
      this._drawDataset(t[e]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const e = this.ctx, i = t._clip, n = !i.disabled, r = Lh(t, this.chartArea), a = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", a) !== !1 && (n && Ti(e, {
      left: i.left === !1 ? 0 : r.left - i.left,
      right: i.right === !1 ? this.width : r.right + i.right,
      top: i.top === !1 ? 0 : r.top - i.top,
      bottom: i.bottom === !1 ? this.height : r.bottom + i.bottom
    }), t.controller.draw(), n && Ii(e), a.cancelable = !1, this.notifyPlugins("afterDatasetDraw", a));
  }
  isPointInArea(t) {
    return se(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, e, i, n) {
    const r = Rp.modes[e];
    return typeof r == "function" ? r(this, t, i, n) : [];
  }
  getDatasetMeta(t) {
    const e = this.data.datasets[t], i = this._metasets;
    let n = i.filter((r) => r && r._dataset === e).pop();
    return n || (n = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: e && e.order || 0,
      index: t,
      _dataset: e,
      _parsed: [],
      _sorted: !1
    }, i.push(n)), n;
  }
  getContext() {
    return this.$context || (this.$context = he(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const e = this.data.datasets[t];
    if (!e)
      return !1;
    const i = this.getDatasetMeta(t);
    return typeof i.hidden == "boolean" ? !i.hidden : !e.hidden;
  }
  setDatasetVisibility(t, e) {
    const i = this.getDatasetMeta(t);
    i.hidden = !e;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, e, i) {
    const n = i ? "show" : "hide", r = this.getDatasetMeta(t), a = r.controller._resolveAnimations(void 0, n);
    xs(e) ? (r.data[e].hidden = !i, this.update()) : (this.setDatasetVisibility(t, i), a.update(r, {
      visible: i
    }), this.update((o) => o.datasetIndex === t ? n : void 0));
  }
  hide(t, e) {
    this._updateVisibility(t, e, !1);
  }
  show(t, e) {
    this._updateVisibility(t, e, !0);
  }
  _destroyDatasetMeta(t) {
    const e = this._metasets[t];
    e && e.controller && e.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, e;
    for (this.stop(), Zt.remove(this), t = 0, e = this.data.datasets.length; t < e; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: e } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), Zr(t, e), this.platform.releaseContext(e), this.canvas = null, this.ctx = null), delete ui[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, e = this.platform, i = (r, a) => {
      e.addEventListener(this, r, a), t[r] = a;
    }, n = (r, a, o) => {
      r.offsetX = a, r.offsetY = o, this._eventHandler(r);
    };
    j(this.options.events, (r) => i(r, n));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, e = this.platform, i = (l, c) => {
      e.addEventListener(this, l, c), t[l] = c;
    }, n = (l, c) => {
      t[l] && (e.removeEventListener(this, l, c), delete t[l]);
    }, r = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let a;
    const o = () => {
      n("attach", o), this.attached = !0, this.resize(), i("resize", r), i("detach", a);
    };
    a = () => {
      this.attached = !1, n("resize", r), this._stop(), this._resize(0, 0), i("attach", o);
    }, e.isAttached(this.canvas) ? o() : a();
  }
  unbindEvents() {
    j(this._listeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._listeners = {}, j(this._responsiveListeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, e, i) {
    const n = i ? "set" : "remove";
    let r, a, o, l;
    for (e === "dataset" && (r = this.getDatasetMeta(t[0].datasetIndex), r.controller["_" + n + "DatasetHoverStyle"]()), o = 0, l = t.length; o < l; ++o) {
      a = t[o];
      const c = a && this.getDatasetMeta(a.datasetIndex).controller;
      c && c[n + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const e = this._active || [], i = t.map(({ datasetIndex: r, index: a }) => {
      const o = this.getDatasetMeta(r);
      if (!o)
        throw new Error("No dataset found at index " + r);
      return {
        datasetIndex: r,
        element: o.data[a],
        index: a
      };
    });
    !mi(i, e) && (this._active = i, this._lastEvent = null, this._updateHoverStyles(i, e));
  }
  notifyPlugins(t, e, i) {
    return this._plugins.notify(this, t, e, i);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((e) => e.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, e, i) {
    const n = this.options.hover, r = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), a = r(e, t), o = i ? t : r(t, e);
    a.length && this.updateHoverStyle(a, n.mode, !1), o.length && n.mode && this.updateHoverStyle(o, n.mode, !0);
  }
  _eventHandler(t, e) {
    const i = {
      event: t,
      replay: e,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, n = (a) => (a.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", i, n) === !1)
      return;
    const r = this._handleEvent(t, e, i.inChartArea);
    return i.cancelable = !1, this.notifyPlugins("afterEvent", i, n), (r || i.changed) && this.render(), this;
  }
  _handleEvent(t, e, i) {
    const { _active: n = [], options: r } = this, a = e, o = this._getActiveElements(t, n, i, a), l = Hu(t), c = Fh(t, this._lastEvent, i, l);
    i && (this._lastEvent = null, W(r.onHover, [
      t,
      o,
      this
    ], this), l && W(r.onClick, [
      t,
      o,
      this
    ], this));
    const u = !mi(o, n);
    return (u || e) && (this._active = o, this._updateHoverStyles(o, n, e)), this._lastEvent = c, u;
  }
  _getActiveElements(t, e, i, n) {
    if (t.type === "mouseout")
      return [];
    if (!i)
      return e;
    const r = this.options.hover;
    return this.getElementsAtEventForMode(t, r.mode, r, n);
  }
}
A(zt, "defaults", nt), A(zt, "instances", ui), A(zt, "overrides", Ie), A(zt, "registry", jt), A(zt, "version", Mh), A(zt, "getChart", Ma);
function Ra() {
  return j(zt.instances, (s) => s._plugins.invalidate());
}
function qh(s, t, e) {
  const { startAngle: i, pixelMargin: n, x: r, y: a, outerRadius: o, innerRadius: l } = t;
  let c = n / o;
  s.beginPath(), s.arc(r, a, o, i - c, e + c), l > n ? (c = n / l, s.arc(r, a, l, e + c, i - c, !0)) : s.arc(r, a, n, e + at, i - at), s.closePath(), s.clip();
}
function Uh(s) {
  return Wn(s, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function Nh(s, t, e, i) {
  const n = Uh(s.options.borderRadius), r = (e - t) / 2, a = Math.min(r, i * t / 2), o = (l) => {
    const c = (e - Math.min(r, l)) * i / 2;
    return ut(l, 0, Math.min(r, c));
  };
  return {
    outerStart: o(n.outerStart),
    outerEnd: o(n.outerEnd),
    innerStart: ut(n.innerStart, 0, a),
    innerEnd: ut(n.innerEnd, 0, a)
  };
}
function Ne(s, t, e, i) {
  return {
    x: e + s * Math.cos(t),
    y: i + s * Math.sin(t)
  };
}
function ki(s, t, e, i, n, r) {
  const { x: a, y: o, startAngle: l, pixelMargin: c, innerRadius: u } = t, d = Math.max(t.outerRadius + i + e - c, 0), p = u > 0 ? u + i + e + c : 0;
  let h = 0;
  const m = n - l;
  if (i) {
    const B = u > 0 ? u - i : 0, V = d > 0 ? d - i : 0, J = (B + V) / 2, xt = J !== 0 ? m * J / (J + i) : m;
    h = (m - xt) / 2;
  }
  const _ = Math.max(1e-3, m * d - e / K) / d, y = (m - _) / 2, v = l + y + h, k = n - y - h, { outerStart: w, outerEnd: x, innerStart: C, innerEnd: $ } = Nh(t, p, d, k - v), S = d - w, I = d - x, R = v + w / S, F = k - x / I, O = p + C, L = p + $, rt = v + C / O, dt = k - $ / L;
  if (s.beginPath(), r) {
    const B = (R + F) / 2;
    if (s.arc(a, o, d, R, B), s.arc(a, o, d, B, F), x > 0) {
      const lt = Ne(I, F, a, o);
      s.arc(lt.x, lt.y, x, F, k + at);
    }
    const V = Ne(L, k, a, o);
    if (s.lineTo(V.x, V.y), $ > 0) {
      const lt = Ne(L, dt, a, o);
      s.arc(lt.x, lt.y, $, k + at, dt + Math.PI);
    }
    const J = (k - $ / p + (v + C / p)) / 2;
    if (s.arc(a, o, p, k - $ / p, J, !0), s.arc(a, o, p, J, v + C / p, !0), C > 0) {
      const lt = Ne(O, rt, a, o);
      s.arc(lt.x, lt.y, C, rt + Math.PI, v - at);
    }
    const xt = Ne(S, v, a, o);
    if (s.lineTo(xt.x, xt.y), w > 0) {
      const lt = Ne(S, R, a, o);
      s.arc(lt.x, lt.y, w, v - at, R);
    }
  } else {
    s.moveTo(a, o);
    const B = Math.cos(R) * d + a, V = Math.sin(R) * d + o;
    s.lineTo(B, V);
    const J = Math.cos(F) * d + a, xt = Math.sin(F) * d + o;
    s.lineTo(J, xt);
  }
  s.closePath();
}
function Bh(s, t, e, i, n) {
  const { fullCircles: r, startAngle: a, circumference: o } = t;
  let l = t.endAngle;
  if (r) {
    ki(s, t, e, i, l, n);
    for (let c = 0; c < r; ++c)
      s.fill();
    isNaN(o) || (l = a + (o % G || G));
  }
  return ki(s, t, e, i, l, n), s.fill(), l;
}
function jh(s, t, e, i, n) {
  const { fullCircles: r, startAngle: a, circumference: o, options: l } = t, { borderWidth: c, borderJoinStyle: u, borderDash: d, borderDashOffset: p } = l, h = l.borderAlign === "inner";
  if (!c)
    return;
  s.setLineDash(d || []), s.lineDashOffset = p, h ? (s.lineWidth = c * 2, s.lineJoin = u || "round") : (s.lineWidth = c, s.lineJoin = u || "bevel");
  let m = t.endAngle;
  if (r) {
    ki(s, t, e, i, m, n);
    for (let _ = 0; _ < r; ++_)
      s.stroke();
    isNaN(o) || (m = a + (o % G || G));
  }
  h && qh(s, t, m), r || (ki(s, t, e, i, m, n), s.stroke());
}
class ps extends ie {
  constructor(e) {
    super();
    A(this, "circumference");
    A(this, "endAngle");
    A(this, "fullCircles");
    A(this, "innerRadius");
    A(this, "outerRadius");
    A(this, "pixelMargin");
    A(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, e && Object.assign(this, e);
  }
  inRange(e, i, n) {
    const r = this.getProps([
      "x",
      "y"
    ], n), { angle: a, distance: o } = Qo(r, {
      x: e,
      y: i
    }), { startAngle: l, endAngle: c, innerRadius: u, outerRadius: d, circumference: p } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], n), h = (this.options.spacing + this.options.borderWidth) / 2, _ = D(p, c - l) >= G || Cs(a, l, c), y = te(o, u + h, d + h);
    return _ && y;
  }
  getCenterPoint(e) {
    const { x: i, y: n, startAngle: r, endAngle: a, innerRadius: o, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], e), { offset: c, spacing: u } = this.options, d = (r + a) / 2, p = (o + l + u + c) / 2;
    return {
      x: i + Math.cos(d) * p,
      y: n + Math.sin(d) * p
    };
  }
  tooltipPosition(e) {
    return this.getCenterPoint(e);
  }
  draw(e) {
    const { options: i, circumference: n } = this, r = (i.offset || 0) / 4, a = (i.spacing || 0) / 2, o = i.circular;
    if (this.pixelMargin = i.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = n > G ? Math.floor(n / G) : 0, n === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    e.save();
    const l = (this.startAngle + this.endAngle) / 2;
    e.translate(Math.cos(l) * r, Math.sin(l) * r);
    const c = 1 - Math.sin(Math.min(K, n || 0)), u = r * c;
    e.fillStyle = i.backgroundColor, e.strokeStyle = i.borderColor, Bh(e, this, u, a, o), jh(e, this, u, a, o), e.restore();
  }
}
A(ps, "id", "arc"), A(ps, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), A(ps, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), A(ps, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash"
});
function Ol(s, t, e = t) {
  s.lineCap = D(e.borderCapStyle, t.borderCapStyle), s.setLineDash(D(e.borderDash, t.borderDash)), s.lineDashOffset = D(e.borderDashOffset, t.borderDashOffset), s.lineJoin = D(e.borderJoinStyle, t.borderJoinStyle), s.lineWidth = D(e.borderWidth, t.borderWidth), s.strokeStyle = D(e.borderColor, t.borderColor);
}
function zh(s, t, e) {
  s.lineTo(e.x, e.y);
}
function Vh(s) {
  return s.stepped ? hd : s.tension || s.cubicInterpolationMode === "monotone" ? fd : zh;
}
function Ml(s, t, e = {}) {
  const i = s.length, { start: n = 0, end: r = i - 1 } = e, { start: a, end: o } = t, l = Math.max(n, a), c = Math.min(r, o), u = n < a && r < a || n > o && r > o;
  return {
    count: i,
    start: l,
    loop: t.loop,
    ilen: c < l && !u ? i + c - l : c - l
  };
}
function Hh(s, t, e, i) {
  const { points: n, options: r } = t, { count: a, start: o, loop: l, ilen: c } = Ml(n, e, i), u = Vh(r);
  let { move: d = !0, reverse: p } = i || {}, h, m, _;
  for (h = 0; h <= c; ++h)
    m = n[(o + (p ? c - h : h)) % a], !m.skip && (d ? (s.moveTo(m.x, m.y), d = !1) : u(s, _, m, p, r.stepped), _ = m);
  return l && (m = n[(o + (p ? c : 0)) % a], u(s, _, m, p, r.stepped)), !!l;
}
function Wh(s, t, e, i) {
  const n = t.points, { count: r, start: a, ilen: o } = Ml(n, e, i), { move: l = !0, reverse: c } = i || {};
  let u = 0, d = 0, p, h, m, _, y, v;
  const k = (x) => (a + (c ? o - x : x)) % r, w = () => {
    _ !== y && (s.lineTo(u, y), s.lineTo(u, _), s.lineTo(u, v));
  };
  for (l && (h = n[k(0)], s.moveTo(h.x, h.y)), p = 0; p <= o; ++p) {
    if (h = n[k(p)], h.skip)
      continue;
    const x = h.x, C = h.y, $ = x | 0;
    $ === m ? (C < _ ? _ = C : C > y && (y = C), u = (d * u + x) / ++d) : (w(), s.lineTo(x, C), m = $, d = 0, _ = y = C), v = C;
  }
  w();
}
function kn(s) {
  const t = s.options, e = t.borderDash && t.borderDash.length;
  return !s._decimated && !s._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !e ? Wh : Hh;
}
function Gh(s) {
  return s.stepped ? Wd : s.tension || s.cubicInterpolationMode === "monotone" ? Gd : ke;
}
function Kh(s, t, e, i) {
  let n = t._path;
  n || (n = t._path = new Path2D(), t.path(n, e, i) && n.closePath()), Ol(s, t.options), s.stroke(n);
}
function Yh(s, t, e, i) {
  const { segments: n, options: r } = t, a = kn(t);
  for (const o of n)
    Ol(s, r, o.style), s.beginPath(), a(s, t, o, {
      start: e,
      end: e + i - 1
    }) && s.closePath(), s.stroke();
}
const Xh = typeof Path2D == "function";
function Zh(s, t, e, i) {
  Xh && !t.options.segment ? Kh(s, t, e, i) : Yh(s, t, e, i);
}
class oe extends ie {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, e) {
    const i = this.options;
    if ((i.tension || i.cubicInterpolationMode === "monotone") && !i.stepped && !this._pointsUpdated) {
      const n = i.spanGaps ? this._loop : this._fullLoop;
      qd(this._points, i, t, n, e), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = Jd(this, this.options.segment));
  }
  first() {
    const t = this.segments, e = this.points;
    return t.length && e[t[0].start];
  }
  last() {
    const t = this.segments, e = this.points, i = t.length;
    return i && e[t[i - 1].end];
  }
  interpolate(t, e) {
    const i = this.options, n = t[e], r = this.points, a = yl(this, {
      property: e,
      start: n,
      end: n
    });
    if (!a.length)
      return;
    const o = [], l = Gh(i);
    let c, u;
    for (c = 0, u = a.length; c < u; ++c) {
      const { start: d, end: p } = a[c], h = r[d], m = r[p];
      if (h === m) {
        o.push(h);
        continue;
      }
      const _ = Math.abs((n - h[e]) / (m[e] - h[e])), y = l(h, m, _, i.stepped);
      y[e] = t[e], o.push(y);
    }
    return o.length === 1 ? o[0] : o;
  }
  pathSegment(t, e, i) {
    return kn(this)(t, this, e, i);
  }
  path(t, e, i) {
    const n = this.segments, r = kn(this);
    let a = this._loop;
    e = e || 0, i = i || this.points.length - e;
    for (const o of n)
      a &= r(t, this, o, {
        start: e,
        end: e + i - 1
      });
    return !!a;
  }
  draw(t, e, i, n) {
    const r = this.options || {};
    (this.points || []).length && r.borderWidth && (t.save(), Zh(t, this, i, n), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
A(oe, "id", "line"), A(oe, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), A(oe, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), A(oe, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function Ea(s, t, e, i) {
  const n = s.options, { [e]: r } = s.getProps([
    e
  ], i);
  return Math.abs(t - r) < n.radius + n.hitRadius;
}
class di extends ie {
  constructor(e) {
    super();
    A(this, "parsed");
    A(this, "skip");
    A(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, e && Object.assign(this, e);
  }
  inRange(e, i, n) {
    const r = this.options, { x: a, y: o } = this.getProps([
      "x",
      "y"
    ], n);
    return Math.pow(e - a, 2) + Math.pow(i - o, 2) < Math.pow(r.hitRadius + r.radius, 2);
  }
  inXRange(e, i) {
    return Ea(this, e, "x", i);
  }
  inYRange(e, i) {
    return Ea(this, e, "y", i);
  }
  getCenterPoint(e) {
    const { x: i, y: n } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: i,
      y: n
    };
  }
  size(e) {
    e = e || this.options || {};
    let i = e.radius || 0;
    i = Math.max(i, i && e.hoverRadius || 0);
    const n = i && e.borderWidth || 0;
    return (i + n) * 2;
  }
  draw(e, i) {
    const n = this.options;
    this.skip || n.radius < 0.1 || !se(this, i, this.size(n) / 2) || (e.strokeStyle = n.borderColor, e.lineWidth = n.borderWidth, e.fillStyle = n.backgroundColor, _n(e, n, this.x, this.y));
  }
  getRange() {
    const e = this.options || {};
    return e.radius + e.hitRadius;
  }
}
A(di, "id", "point"), /**
* @type {any}
*/
A(di, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
A(di, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Rl(s, t) {
  const { x: e, y: i, base: n, width: r, height: a } = s.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let o, l, c, u, d;
  return s.horizontal ? (d = a / 2, o = Math.min(e, n), l = Math.max(e, n), c = i - d, u = i + d) : (d = r / 2, o = e - d, l = e + d, c = Math.min(i, n), u = Math.max(i, n)), {
    left: o,
    top: c,
    right: l,
    bottom: u
  };
}
function le(s, t, e, i) {
  return s ? 0 : ut(t, e, i);
}
function Qh(s, t, e) {
  const i = s.options.borderWidth, n = s.borderSkipped, r = ol(i);
  return {
    t: le(n.top, r.top, 0, e),
    r: le(n.right, r.right, 0, t),
    b: le(n.bottom, r.bottom, 0, e),
    l: le(n.left, r.left, 0, t)
  };
}
function Jh(s, t, e) {
  const { enableBorderRadius: i } = s.getProps([
    "enableBorderRadius"
  ]), n = s.options.borderRadius, r = we(n), a = Math.min(t, e), o = s.borderSkipped, l = i || U(n);
  return {
    topLeft: le(!l || o.top || o.left, r.topLeft, 0, a),
    topRight: le(!l || o.top || o.right, r.topRight, 0, a),
    bottomLeft: le(!l || o.bottom || o.left, r.bottomLeft, 0, a),
    bottomRight: le(!l || o.bottom || o.right, r.bottomRight, 0, a)
  };
}
function tf(s) {
  const t = Rl(s), e = t.right - t.left, i = t.bottom - t.top, n = Qh(s, e / 2, i / 2), r = Jh(s, e / 2, i / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: e,
      h: i,
      radius: r
    },
    inner: {
      x: t.left + n.l,
      y: t.top + n.t,
      w: e - n.l - n.r,
      h: i - n.t - n.b,
      radius: {
        topLeft: Math.max(0, r.topLeft - Math.max(n.t, n.l)),
        topRight: Math.max(0, r.topRight - Math.max(n.t, n.r)),
        bottomLeft: Math.max(0, r.bottomLeft - Math.max(n.b, n.l)),
        bottomRight: Math.max(0, r.bottomRight - Math.max(n.b, n.r))
      }
    }
  };
}
function sn(s, t, e, i) {
  const n = t === null, r = e === null, o = s && !(n && r) && Rl(s, i);
  return o && (n || te(t, o.left, o.right)) && (r || te(e, o.top, o.bottom));
}
function ef(s) {
  return s.topLeft || s.topRight || s.bottomLeft || s.bottomRight;
}
function sf(s, t) {
  s.rect(t.x, t.y, t.w, t.h);
}
function nn(s, t, e = {}) {
  const i = s.x !== e.x ? -t : 0, n = s.y !== e.y ? -t : 0, r = (s.x + s.w !== e.x + e.w ? t : 0) - i, a = (s.y + s.h !== e.y + e.h ? t : 0) - n;
  return {
    x: s.x + i,
    y: s.y + n,
    w: s.w + r,
    h: s.h + a,
    radius: s.radius
  };
}
class pi extends ie {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: e, options: { borderColor: i, backgroundColor: n } } = this, { inner: r, outer: a } = tf(this), o = ef(a.radius) ? ws : sf;
    t.save(), (a.w !== r.w || a.h !== r.h) && (t.beginPath(), o(t, nn(a, e, r)), t.clip(), o(t, nn(r, -e, a)), t.fillStyle = i, t.fill("evenodd")), t.beginPath(), o(t, nn(r, e)), t.fillStyle = n, t.fill(), t.restore();
  }
  inRange(t, e, i) {
    return sn(this, t, e, i);
  }
  inXRange(t, e) {
    return sn(this, t, null, e);
  }
  inYRange(t, e) {
    return sn(this, null, t, e);
  }
  getCenterPoint(t) {
    const { x: e, y: i, base: n, horizontal: r } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: r ? (e + n) / 2 : e,
      y: r ? i : (i + n) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
A(pi, "id", "bar"), A(pi, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), A(pi, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var nf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: ps,
  BarElement: pi,
  LineElement: oe,
  PointElement: di
});
const xn = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], Da = /* @__PURE__ */ xn.map((s) => s.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function El(s) {
  return xn[s % xn.length];
}
function Dl(s) {
  return Da[s % Da.length];
}
function rf(s, t) {
  return s.borderColor = El(t), s.backgroundColor = Dl(t), ++t;
}
function af(s, t) {
  return s.backgroundColor = s.data.map(() => El(t++)), t;
}
function of(s, t) {
  return s.backgroundColor = s.data.map(() => Dl(t++)), t;
}
function lf(s) {
  let t = 0;
  return (e, i) => {
    const n = s.getDatasetMeta(i).controller;
    n instanceof Ce ? t = af(e, t) : n instanceof bs ? t = of(e, t) : n && (t = rf(e, t));
  };
}
function Fa(s) {
  let t;
  for (t in s)
    if (s[t].borderColor || s[t].backgroundColor)
      return !0;
  return !1;
}
function cf(s) {
  return s && (s.borderColor || s.backgroundColor);
}
var uf = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(s, t, e) {
    if (!e.enabled)
      return;
    const { data: { datasets: i }, options: n } = s.config, { elements: r } = n;
    if (!e.forceOverride && (Fa(i) || cf(n) || r && Fa(r)))
      return;
    const a = lf(s);
    i.forEach(a);
  }
};
function df(s, t, e, i, n) {
  const r = n.samples || i;
  if (r >= e)
    return s.slice(t, t + e);
  const a = [], o = (e - 2) / (r - 2);
  let l = 0;
  const c = t + e - 1;
  let u = t, d, p, h, m, _;
  for (a[l++] = s[u], d = 0; d < r - 2; d++) {
    let y = 0, v = 0, k;
    const w = Math.floor((d + 1) * o) + 1 + t, x = Math.min(Math.floor((d + 2) * o) + 1, e) + t, C = x - w;
    for (k = w; k < x; k++)
      y += s[k].x, v += s[k].y;
    y /= C, v /= C;
    const $ = Math.floor(d * o) + 1 + t, S = Math.min(Math.floor((d + 1) * o) + 1, e) + t, { x: I, y: R } = s[u];
    for (h = m = -1, k = $; k < S; k++)
      m = 0.5 * Math.abs((I - y) * (s[k].y - R) - (I - s[k].x) * (v - R)), m > h && (h = m, p = s[k], _ = k);
    a[l++] = p, u = _;
  }
  return a[l++] = s[c], a;
}
function pf(s, t, e, i) {
  let n = 0, r = 0, a, o, l, c, u, d, p, h, m, _;
  const y = [], v = t + e - 1, k = s[t].x, x = s[v].x - k;
  for (a = t; a < t + e; ++a) {
    o = s[a], l = (o.x - k) / x * i, c = o.y;
    const C = l | 0;
    if (C === u)
      c < m ? (m = c, d = a) : c > _ && (_ = c, p = a), n = (r * n + o.x) / ++r;
    else {
      const $ = a - 1;
      if (!N(d) && !N(p)) {
        const S = Math.min(d, p), I = Math.max(d, p);
        S !== h && S !== $ && y.push({
          ...s[S],
          x: n
        }), I !== h && I !== $ && y.push({
          ...s[I],
          x: n
        });
      }
      a > 0 && $ !== h && y.push(s[$]), y.push(o), u = C, r = 0, m = _ = c, d = p = h = a;
    }
  }
  return y;
}
function Fl(s) {
  if (s._decimated) {
    const t = s._data;
    delete s._decimated, delete s._data, Object.defineProperty(s, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: t
    });
  }
}
function La(s) {
  s.data.datasets.forEach((t) => {
    Fl(t);
  });
}
function hf(s, t) {
  const e = t.length;
  let i = 0, n;
  const { iScale: r } = s, { min: a, max: o, minDefined: l, maxDefined: c } = r.getUserBounds();
  return l && (i = ut(ee(t, r.axis, a).lo, 0, e - 1)), c ? n = ut(ee(t, r.axis, o).hi + 1, i, e) - i : n = e - i, {
    start: i,
    count: n
  };
}
var ff = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (s, t, e) => {
    if (!e.enabled) {
      La(s);
      return;
    }
    const i = s.width;
    s.data.datasets.forEach((n, r) => {
      const { _data: a, indexAxis: o } = n, l = s.getDatasetMeta(r), c = a || n.data;
      if (us([
        o,
        s.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const u = s.scales[l.xAxisID];
      if (u.type !== "linear" && u.type !== "time" || s.options.parsing)
        return;
      let { start: d, count: p } = hf(l, c);
      const h = e.threshold || 4 * i;
      if (p <= h) {
        Fl(n);
        return;
      }
      N(a) && (n._data = c, delete n.data, Object.defineProperty(n, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(_) {
          this._data = _;
        }
      }));
      let m;
      switch (e.algorithm) {
        case "lttb":
          m = df(c, d, p, i, e);
          break;
        case "min-max":
          m = pf(c, d, p, i);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${e.algorithm}'`);
      }
      n._decimated = m;
    });
  },
  destroy(s) {
    La(s);
  }
};
function mf(s, t, e) {
  const i = s.segments, n = s.points, r = t.points, a = [];
  for (const o of i) {
    let { start: l, end: c } = o;
    c = Jn(l, c, n);
    const u = Cn(e, n[l], n[c], o.loop);
    if (!t.segments) {
      a.push({
        source: o,
        target: u,
        start: n[l],
        end: n[c]
      });
      continue;
    }
    const d = yl(t, u);
    for (const p of d) {
      const h = Cn(e, r[p.start], r[p.end], p.loop), m = _l(o, n, h);
      for (const _ of m)
        a.push({
          source: _,
          target: p,
          start: {
            [e]: qa(u, h, "start", Math.max)
          },
          end: {
            [e]: qa(u, h, "end", Math.min)
          }
        });
    }
  }
  return a;
}
function Cn(s, t, e, i) {
  if (i)
    return;
  let n = t[s], r = e[s];
  return s === "angle" && (n = It(n), r = It(r)), {
    property: s,
    start: n,
    end: r
  };
}
function gf(s, t) {
  const { x: e = null, y: i = null } = s || {}, n = t.points, r = [];
  return t.segments.forEach(({ start: a, end: o }) => {
    o = Jn(a, o, n);
    const l = n[a], c = n[o];
    i !== null ? (r.push({
      x: l.x,
      y: i
    }), r.push({
      x: c.x,
      y: i
    })) : e !== null && (r.push({
      x: e,
      y: l.y
    }), r.push({
      x: e,
      y: c.y
    }));
  }), r;
}
function Jn(s, t, e) {
  for (; t > s; t--) {
    const i = e[t];
    if (!isNaN(i.x) && !isNaN(i.y))
      break;
  }
  return t;
}
function qa(s, t, e, i) {
  return s && t ? i(s[e], t[e]) : s ? s[e] : t ? t[e] : 0;
}
function Ll(s, t) {
  let e = [], i = !1;
  return Z(s) ? (i = !0, e = s) : e = gf(s, t), e.length ? new oe({
    points: e,
    options: {
      tension: 0
    },
    _loop: i,
    _fullLoop: i
  }) : null;
}
function Ua(s) {
  return s && s.fill !== !1;
}
function _f(s, t, e) {
  let n = s[t].fill;
  const r = [
    t
  ];
  let a;
  if (!e)
    return n;
  for (; n !== !1 && r.indexOf(n) === -1; ) {
    if (!it(n))
      return n;
    if (a = s[n], !a)
      return !1;
    if (a.visible)
      return n;
    r.push(n), n = a.fill;
  }
  return !1;
}
function yf(s, t, e) {
  const i = xf(s);
  if (U(i))
    return isNaN(i.value) ? !1 : i;
  let n = parseFloat(i);
  return it(n) && Math.floor(n) === n ? bf(i[0], t, n, e) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(i) >= 0 && i;
}
function bf(s, t, e, i) {
  return (s === "-" || s === "+") && (e = t + e), e === t || e < 0 || e >= i ? !1 : e;
}
function vf(s, t) {
  let e = null;
  return s === "start" ? e = t.bottom : s === "end" ? e = t.top : U(s) ? e = t.getPixelForValue(s.value) : t.getBasePixel && (e = t.getBasePixel()), e;
}
function kf(s, t, e) {
  let i;
  return s === "start" ? i = e : s === "end" ? i = t.options.reverse ? t.min : t.max : U(s) ? i = s.value : i = t.getBaseValue(), i;
}
function xf(s) {
  const t = s.options, e = t.fill;
  let i = D(e && e.target, e);
  return i === void 0 && (i = !!t.backgroundColor), i === !1 || i === null ? !1 : i === !0 ? "origin" : i;
}
function Cf(s) {
  const { scale: t, index: e, line: i } = s, n = [], r = i.segments, a = i.points, o = wf(t, e);
  o.push(Ll({
    x: null,
    y: t.bottom
  }, i));
  for (let l = 0; l < r.length; l++) {
    const c = r[l];
    for (let u = c.start; u <= c.end; u++)
      $f(n, a[u], o);
  }
  return new oe({
    points: n,
    options: {}
  });
}
function wf(s, t) {
  const e = [], i = s.getMatchingVisibleMetas("line");
  for (let n = 0; n < i.length; n++) {
    const r = i[n];
    if (r.index === t)
      break;
    r.hidden || e.unshift(r.dataset);
  }
  return e;
}
function $f(s, t, e) {
  const i = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n], { first: a, last: o, point: l } = Sf(r, t, "x");
    if (!(!l || a && o)) {
      if (a)
        i.unshift(l);
      else if (s.push(l), !o)
        break;
    }
  }
  s.push(...i);
}
function Sf(s, t, e) {
  const i = s.interpolate(t, e);
  if (!i)
    return {};
  const n = i[e], r = s.segments, a = s.points;
  let o = !1, l = !1;
  for (let c = 0; c < r.length; c++) {
    const u = r[c], d = a[u.start][e], p = a[u.end][e];
    if (te(n, d, p)) {
      o = n === d, l = n === p;
      break;
    }
  }
  return {
    first: o,
    last: l,
    point: i
  };
}
class ql {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, e, i) {
    const { x: n, y: r, radius: a } = this;
    return e = e || {
      start: 0,
      end: G
    }, t.arc(n, r, a, e.end, e.start, !0), !i.bounds;
  }
  interpolate(t) {
    const { x: e, y: i, radius: n } = this, r = t.angle;
    return {
      x: e + Math.cos(r) * n,
      y: i + Math.sin(r) * n,
      angle: r
    };
  }
}
function Tf(s) {
  const { chart: t, fill: e, line: i } = s;
  if (it(e))
    return If(t, e);
  if (e === "stack")
    return Cf(s);
  if (e === "shape")
    return !0;
  const n = Af(s);
  return n instanceof ql ? n : Ll(n, i);
}
function If(s, t) {
  const e = s.getDatasetMeta(t);
  return e && s.isDatasetVisible(t) ? e.dataset : null;
}
function Af(s) {
  return (s.scale || {}).getPointPositionForValue ? Of(s) : Pf(s);
}
function Pf(s) {
  const { scale: t = {}, fill: e } = s, i = vf(e, t);
  if (it(i)) {
    const n = t.isHorizontal();
    return {
      x: n ? i : null,
      y: n ? null : i
    };
  }
  return null;
}
function Of(s) {
  const { scale: t, fill: e } = s, i = t.options, n = t.getLabels().length, r = i.reverse ? t.max : t.min, a = kf(e, t, r), o = [];
  if (i.grid.circular) {
    const l = t.getPointPositionForValue(0, r);
    return new ql({
      x: l.x,
      y: l.y,
      radius: t.getDistanceFromCenterForValue(a)
    });
  }
  for (let l = 0; l < n; ++l)
    o.push(t.getPointPositionForValue(l, a));
  return o;
}
function rn(s, t, e) {
  const i = Tf(t), { line: n, scale: r, axis: a } = t, o = n.options, l = o.fill, c = o.backgroundColor, { above: u = c, below: d = c } = l || {};
  i && n.points.length && (Ti(s, e), Mf(s, {
    line: n,
    target: i,
    above: u,
    below: d,
    area: e,
    scale: r,
    axis: a
  }), Ii(s));
}
function Mf(s, t) {
  const { line: e, target: i, above: n, below: r, area: a, scale: o } = t, l = e._loop ? "angle" : t.axis;
  s.save(), l === "x" && r !== n && (Na(s, i, a.top), Ba(s, {
    line: e,
    target: i,
    color: n,
    scale: o,
    property: l
  }), s.restore(), s.save(), Na(s, i, a.bottom)), Ba(s, {
    line: e,
    target: i,
    color: r,
    scale: o,
    property: l
  }), s.restore();
}
function Na(s, t, e) {
  const { segments: i, points: n } = t;
  let r = !0, a = !1;
  s.beginPath();
  for (const o of i) {
    const { start: l, end: c } = o, u = n[l], d = n[Jn(l, c, n)];
    r ? (s.moveTo(u.x, u.y), r = !1) : (s.lineTo(u.x, e), s.lineTo(u.x, u.y)), a = !!t.pathSegment(s, o, {
      move: a
    }), a ? s.closePath() : s.lineTo(d.x, e);
  }
  s.lineTo(t.first().x, e), s.closePath(), s.clip();
}
function Ba(s, t) {
  const { line: e, target: i, property: n, color: r, scale: a } = t, o = mf(e, i, n);
  for (const { source: l, target: c, start: u, end: d } of o) {
    const { style: { backgroundColor: p = r } = {} } = l, h = i !== !0;
    s.save(), s.fillStyle = p, Rf(s, a, h && Cn(n, u, d)), s.beginPath();
    const m = !!e.pathSegment(s, l);
    let _;
    if (h) {
      m ? s.closePath() : ja(s, i, d, n);
      const y = !!i.pathSegment(s, c, {
        move: m,
        reverse: !0
      });
      _ = m && y, _ || ja(s, i, u, n);
    }
    s.closePath(), s.fill(_ ? "evenodd" : "nonzero"), s.restore();
  }
}
function Rf(s, t, e) {
  const { top: i, bottom: n } = t.chart.chartArea, { property: r, start: a, end: o } = e || {};
  r === "x" && (s.beginPath(), s.rect(a, i, o - a, n - i), s.clip());
}
function ja(s, t, e, i) {
  const n = t.interpolate(e, i);
  n && s.lineTo(n.x, n.y);
}
var Ef = {
  id: "filler",
  afterDatasetsUpdate(s, t, e) {
    const i = (s.data.datasets || []).length, n = [];
    let r, a, o, l;
    for (a = 0; a < i; ++a)
      r = s.getDatasetMeta(a), o = r.dataset, l = null, o && o.options && o instanceof oe && (l = {
        visible: s.isDatasetVisible(a),
        index: a,
        fill: yf(o, a, i),
        chart: s,
        axis: r.controller.options.indexAxis,
        scale: r.vScale,
        line: o
      }), r.$filler = l, n.push(l);
    for (a = 0; a < i; ++a)
      l = n[a], !(!l || l.fill === !1) && (l.fill = _f(n, a, e.propagate));
  },
  beforeDraw(s, t, e) {
    const i = e.drawTime === "beforeDraw", n = s.getSortedVisibleDatasetMetas(), r = s.chartArea;
    for (let a = n.length - 1; a >= 0; --a) {
      const o = n[a].$filler;
      o && (o.line.updateControlPoints(r, o.axis), i && o.fill && rn(s.ctx, o, r));
    }
  },
  beforeDatasetsDraw(s, t, e) {
    if (e.drawTime !== "beforeDatasetsDraw")
      return;
    const i = s.getSortedVisibleDatasetMetas();
    for (let n = i.length - 1; n >= 0; --n) {
      const r = i[n].$filler;
      Ua(r) && rn(s.ctx, r, s.chartArea);
    }
  },
  beforeDatasetDraw(s, t, e) {
    const i = t.meta.$filler;
    !Ua(i) || e.drawTime !== "beforeDatasetDraw" || rn(s.ctx, i, s.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const za = (s, t) => {
  let { boxHeight: e = t, boxWidth: i = t } = s;
  return s.usePointStyle && (e = Math.min(e, t), i = s.pointStyleWidth || Math.min(i, t)), {
    boxWidth: i,
    boxHeight: e,
    itemHeight: Math.max(t, e)
  };
}, Df = (s, t) => s !== null && t !== null && s.datasetIndex === t.datasetIndex && s.index === t.index;
class Va extends ie {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e, i) {
    this.maxWidth = t, this.maxHeight = e, this._margins = i, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let e = W(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (e = e.filter((i) => t.filter(i, this.chart.data))), t.sort && (e = e.sort((i, n) => t.sort(i, n, this.chart.data))), this.options.reverse && e.reverse(), this.legendItems = e;
  }
  fit() {
    const { options: t, ctx: e } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const i = t.labels, n = ot(i.font), r = n.size, a = this._computeTitleHeight(), { boxWidth: o, itemHeight: l } = za(i, r);
    let c, u;
    e.font = n.string, this.isHorizontal() ? (c = this.maxWidth, u = this._fitRows(a, r, o, l) + 10) : (u = this.maxHeight, c = this._fitCols(a, n, o, l) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(u, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, e, i, n) {
    const { ctx: r, maxWidth: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], u = n + o;
    let d = t;
    r.textAlign = "left", r.textBaseline = "middle";
    let p = -1, h = -u;
    return this.legendItems.forEach((m, _) => {
      const y = i + e / 2 + r.measureText(m.text).width;
      (_ === 0 || c[c.length - 1] + y + 2 * o > a) && (d += u, c[c.length - (_ > 0 ? 0 : 1)] = 0, h += u, p++), l[_] = {
        left: 0,
        top: h,
        row: p,
        width: y,
        height: n
      }, c[c.length - 1] += y + o;
    }), d;
  }
  _fitCols(t, e, i, n) {
    const { ctx: r, maxHeight: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], u = a - t;
    let d = o, p = 0, h = 0, m = 0, _ = 0;
    return this.legendItems.forEach((y, v) => {
      const { itemWidth: k, itemHeight: w } = Ff(i, e, r, y, n);
      v > 0 && h + w + 2 * o > u && (d += p + o, c.push({
        width: p,
        height: h
      }), m += p + o, _++, p = h = 0), l[v] = {
        left: m,
        top: h,
        col: _,
        width: k,
        height: w
      }, p = Math.max(p, k), h += w + o;
    }), d += p, c.push({
      width: p,
      height: h
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: e, options: { align: i, labels: { padding: n }, rtl: r } } = this, a = je(r, this.left, this.width);
    if (this.isHorizontal()) {
      let o = 0, l = ft(i, this.left + n, this.right - this.lineWidths[o]);
      for (const c of e)
        o !== c.row && (o = c.row, l = ft(i, this.left + n, this.right - this.lineWidths[o])), c.top += this.top + t + n, c.left = a.leftForLtr(a.x(l), c.width), l += c.width + n;
    } else {
      let o = 0, l = ft(i, this.top + t + n, this.bottom - this.columnSizes[o].height);
      for (const c of e)
        c.col !== o && (o = c.col, l = ft(i, this.top + t + n, this.bottom - this.columnSizes[o].height)), c.top = l, c.left += this.left + n, c.left = a.leftForLtr(a.x(c.left), c.width), l += c.height + n;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      Ti(t, this), this._draw(), Ii(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: e, lineWidths: i, ctx: n } = this, { align: r, labels: a } = t, o = nt.color, l = je(t.rtl, this.left, this.width), c = ot(a.font), { padding: u } = a, d = c.size, p = d / 2;
    let h;
    this.drawTitle(), n.textAlign = l.textAlign("left"), n.textBaseline = "middle", n.lineWidth = 0.5, n.font = c.string;
    const { boxWidth: m, boxHeight: _, itemHeight: y } = za(a, d), v = function($, S, I) {
      if (isNaN(m) || m <= 0 || isNaN(_) || _ < 0)
        return;
      n.save();
      const R = D(I.lineWidth, 1);
      if (n.fillStyle = D(I.fillStyle, o), n.lineCap = D(I.lineCap, "butt"), n.lineDashOffset = D(I.lineDashOffset, 0), n.lineJoin = D(I.lineJoin, "miter"), n.lineWidth = R, n.strokeStyle = D(I.strokeStyle, o), n.setLineDash(D(I.lineDash, [])), a.usePointStyle) {
        const F = {
          radius: _ * Math.SQRT2 / 2,
          pointStyle: I.pointStyle,
          rotation: I.rotation,
          borderWidth: R
        }, O = l.xPlus($, m / 2), L = S + p;
        al(n, F, O, L, a.pointStyleWidth && m);
      } else {
        const F = S + Math.max((d - _) / 2, 0), O = l.leftForLtr($, m), L = we(I.borderRadius);
        n.beginPath(), Object.values(L).some((rt) => rt !== 0) ? ws(n, {
          x: O,
          y: F,
          w: m,
          h: _,
          radius: L
        }) : n.rect(O, F, m, _), n.fill(), R !== 0 && n.stroke();
      }
      n.restore();
    }, k = function($, S, I) {
      Ae(n, I.text, $, S + y / 2, c, {
        strikethrough: I.hidden,
        textAlign: l.textAlign(I.textAlign)
      });
    }, w = this.isHorizontal(), x = this._computeTitleHeight();
    w ? h = {
      x: ft(r, this.left + u, this.right - i[0]),
      y: this.top + u + x,
      line: 0
    } : h = {
      x: this.left + u,
      y: ft(r, this.top + x + u, this.bottom - e[0].height),
      line: 0
    }, fl(this.ctx, t.textDirection);
    const C = y + u;
    this.legendItems.forEach(($, S) => {
      n.strokeStyle = $.fontColor, n.fillStyle = $.fontColor;
      const I = n.measureText($.text).width, R = l.textAlign($.textAlign || ($.textAlign = a.textAlign)), F = m + p + I;
      let O = h.x, L = h.y;
      l.setWidth(this.width), w ? S > 0 && O + F + u > this.right && (L = h.y += C, h.line++, O = h.x = ft(r, this.left + u, this.right - i[h.line])) : S > 0 && L + C > this.bottom && (O = h.x = O + e[h.line].width + u, h.line++, L = h.y = ft(r, this.top + x + u, this.bottom - e[h.line].height));
      const rt = l.x(O);
      if (v(rt, L, $), O = sd(R, O + m + p, w ? O + F : this.right, t.rtl), k(l.x(O), L, $), w)
        h.x += F + u;
      else if (typeof $.text != "string") {
        const dt = c.lineHeight;
        h.y += Ul($, dt) + u;
      } else
        h.y += C;
    }), ml(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, e = t.title, i = ot(e.font), n = gt(e.padding);
    if (!e.display)
      return;
    const r = je(t.rtl, this.left, this.width), a = this.ctx, o = e.position, l = i.size / 2, c = n.top + l;
    let u, d = this.left, p = this.width;
    if (this.isHorizontal())
      p = Math.max(...this.lineWidths), u = this.top + c, d = ft(t.align, d, this.right - p);
    else {
      const m = this.columnSizes.reduce((_, y) => Math.max(_, y.height), 0);
      u = c + ft(t.align, this.top, this.bottom - m - t.labels.padding - this._computeTitleHeight());
    }
    const h = ft(o, d, d + p);
    a.textAlign = r.textAlign(Vn(o)), a.textBaseline = "middle", a.strokeStyle = e.color, a.fillStyle = e.color, a.font = i.string, Ae(a, e.text, h, u, i);
  }
  _computeTitleHeight() {
    const t = this.options.title, e = ot(t.font), i = gt(t.padding);
    return t.display ? e.lineHeight + i.height : 0;
  }
  _getLegendItemAt(t, e) {
    let i, n, r;
    if (te(t, this.left, this.right) && te(e, this.top, this.bottom)) {
      for (r = this.legendHitBoxes, i = 0; i < r.length; ++i)
        if (n = r[i], te(t, n.left, n.left + n.width) && te(e, n.top, n.top + n.height))
          return this.legendItems[i];
    }
    return null;
  }
  handleEvent(t) {
    const e = this.options;
    if (!Uf(t.type, e))
      return;
    const i = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const n = this._hoveredItem, r = Df(n, i);
      n && !r && W(e.onLeave, [
        t,
        n,
        this
      ], this), this._hoveredItem = i, i && !r && W(e.onHover, [
        t,
        i,
        this
      ], this);
    } else i && W(e.onClick, [
      t,
      i,
      this
    ], this);
  }
}
function Ff(s, t, e, i, n) {
  const r = Lf(i, s, t, e), a = qf(n, i, t.lineHeight);
  return {
    itemWidth: r,
    itemHeight: a
  };
}
function Lf(s, t, e, i) {
  let n = s.text;
  return n && typeof n != "string" && (n = n.reduce((r, a) => r.length > a.length ? r : a)), t + e.size / 2 + i.measureText(n).width;
}
function qf(s, t, e) {
  let i = s;
  return typeof t.text != "string" && (i = Ul(t, e)), i;
}
function Ul(s, t) {
  const e = s.text ? s.text.length : 0;
  return t * e;
}
function Uf(s, t) {
  return !!((s === "mousemove" || s === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (s === "click" || s === "mouseup"));
}
var Nf = {
  id: "legend",
  _element: Va,
  start(s, t, e) {
    const i = s.legend = new Va({
      ctx: s.ctx,
      options: e,
      chart: s
    });
    mt.configure(s, i, e), mt.addBox(s, i);
  },
  stop(s) {
    mt.removeBox(s, s.legend), delete s.legend;
  },
  beforeUpdate(s, t, e) {
    const i = s.legend;
    mt.configure(s, i, e), i.options = e;
  },
  afterUpdate(s) {
    const t = s.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(s, t) {
    t.replay || s.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(s, t, e) {
      const i = t.datasetIndex, n = e.chart;
      n.isDatasetVisible(i) ? (n.hide(i), t.hidden = !0) : (n.show(i), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (s) => s.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(s) {
        const t = s.data.datasets, { labels: { usePointStyle: e, pointStyle: i, textAlign: n, color: r, useBorderRadius: a, borderRadius: o } } = s.legend.options;
        return s._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(e ? 0 : void 0), u = gt(c.borderWidth);
          return {
            text: t[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: r,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: i || c.pointStyle,
            rotation: c.rotation,
            textAlign: n || c.textAlign,
            borderRadius: a && (o || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (s) => s.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (s) => !s.startsWith("on"),
    labels: {
      _scriptable: (s) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(s)
    }
  }
};
class tr extends ie {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e) {
    const i = this.options;
    if (this.left = 0, this.top = 0, !i.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = e;
    const n = Z(i.text) ? i.text.length : 1;
    this._padding = gt(i.padding);
    const r = n * ot(i.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = r : this.width = r;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: e, left: i, bottom: n, right: r, options: a } = this, o = a.align;
    let l = 0, c, u, d;
    return this.isHorizontal() ? (u = ft(o, i, r), d = e + t, c = r - i) : (a.position === "left" ? (u = i + t, d = ft(o, n, e), l = K * -0.5) : (u = r - t, d = ft(o, e, n), l = K * 0.5), c = n - e), {
      titleX: u,
      titleY: d,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const t = this.ctx, e = this.options;
    if (!e.display)
      return;
    const i = ot(e.font), r = i.lineHeight / 2 + this._padding.top, { titleX: a, titleY: o, maxWidth: l, rotation: c } = this._drawArgs(r);
    Ae(t, e.text, 0, 0, i, {
      color: e.color,
      maxWidth: l,
      rotation: c,
      textAlign: Vn(e.align),
      textBaseline: "middle",
      translation: [
        a,
        o
      ]
    });
  }
}
function Bf(s, t) {
  const e = new tr({
    ctx: s.ctx,
    options: t,
    chart: s
  });
  mt.configure(s, e, t), mt.addBox(s, e), s.titleBlock = e;
}
var jf = {
  id: "title",
  _element: tr,
  start(s, t, e) {
    Bf(s, e);
  },
  stop(s) {
    const t = s.titleBlock;
    mt.removeBox(s, t), delete s.titleBlock;
  },
  beforeUpdate(s, t, e) {
    const i = s.titleBlock;
    mt.configure(s, i, e), i.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Qs = /* @__PURE__ */ new WeakMap();
var zf = {
  id: "subtitle",
  start(s, t, e) {
    const i = new tr({
      ctx: s.ctx,
      options: e,
      chart: s
    });
    mt.configure(s, i, e), mt.addBox(s, i), Qs.set(s, i);
  },
  stop(s) {
    mt.removeBox(s, Qs.get(s)), Qs.delete(s);
  },
  beforeUpdate(s, t, e) {
    const i = Qs.get(s);
    mt.configure(s, i, e), i.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const hs = {
  average(s) {
    if (!s.length)
      return !1;
    let t, e, i = 0, n = 0, r = 0;
    for (t = 0, e = s.length; t < e; ++t) {
      const a = s[t].element;
      if (a && a.hasValue()) {
        const o = a.tooltipPosition();
        i += o.x, n += o.y, ++r;
      }
    }
    return {
      x: i / r,
      y: n / r
    };
  },
  nearest(s, t) {
    if (!s.length)
      return !1;
    let e = t.x, i = t.y, n = Number.POSITIVE_INFINITY, r, a, o;
    for (r = 0, a = s.length; r < a; ++r) {
      const l = s[r].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = mn(t, c);
        u < n && (n = u, o = l);
      }
    }
    if (o) {
      const l = o.tooltipPosition();
      e = l.x, i = l.y;
    }
    return {
      x: e,
      y: i
    };
  }
};
function Bt(s, t) {
  return t && (Z(t) ? Array.prototype.push.apply(s, t) : s.push(t)), s;
}
function Qt(s) {
  return (typeof s == "string" || s instanceof String) && s.indexOf(`
`) > -1 ? s.split(`
`) : s;
}
function Vf(s, t) {
  const { element: e, datasetIndex: i, index: n } = t, r = s.getDatasetMeta(i).controller, { label: a, value: o } = r.getLabelAndValue(n);
  return {
    chart: s,
    label: a,
    parsed: r.getParsed(n),
    raw: s.data.datasets[i].data[n],
    formattedValue: o,
    dataset: r.getDataset(),
    dataIndex: n,
    datasetIndex: i,
    element: e
  };
}
function Ha(s, t) {
  const e = s.chart.ctx, { body: i, footer: n, title: r } = s, { boxWidth: a, boxHeight: o } = t, l = ot(t.bodyFont), c = ot(t.titleFont), u = ot(t.footerFont), d = r.length, p = n.length, h = i.length, m = gt(t.padding);
  let _ = m.height, y = 0, v = i.reduce((x, C) => x + C.before.length + C.lines.length + C.after.length, 0);
  if (v += s.beforeBody.length + s.afterBody.length, d && (_ += d * c.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), v) {
    const x = t.displayColors ? Math.max(o, l.lineHeight) : l.lineHeight;
    _ += h * x + (v - h) * l.lineHeight + (v - 1) * t.bodySpacing;
  }
  p && (_ += t.footerMarginTop + p * u.lineHeight + (p - 1) * t.footerSpacing);
  let k = 0;
  const w = function(x) {
    y = Math.max(y, e.measureText(x).width + k);
  };
  return e.save(), e.font = c.string, j(s.title, w), e.font = l.string, j(s.beforeBody.concat(s.afterBody), w), k = t.displayColors ? a + 2 + t.boxPadding : 0, j(i, (x) => {
    j(x.before, w), j(x.lines, w), j(x.after, w);
  }), k = 0, e.font = u.string, j(s.footer, w), e.restore(), y += m.width, {
    width: y,
    height: _
  };
}
function Hf(s, t) {
  const { y: e, height: i } = t;
  return e < i / 2 ? "top" : e > s.height - i / 2 ? "bottom" : "center";
}
function Wf(s, t, e, i) {
  const { x: n, width: r } = i, a = e.caretSize + e.caretPadding;
  if (s === "left" && n + r + a > t.width || s === "right" && n - r - a < 0)
    return !0;
}
function Gf(s, t, e, i) {
  const { x: n, width: r } = e, { width: a, chartArea: { left: o, right: l } } = s;
  let c = "center";
  return i === "center" ? c = n <= (o + l) / 2 ? "left" : "right" : n <= r / 2 ? c = "left" : n >= a - r / 2 && (c = "right"), Wf(c, s, t, e) && (c = "center"), c;
}
function Wa(s, t, e) {
  const i = e.yAlign || t.yAlign || Hf(s, e);
  return {
    xAlign: e.xAlign || t.xAlign || Gf(s, t, e, i),
    yAlign: i
  };
}
function Kf(s, t) {
  let { x: e, width: i } = s;
  return t === "right" ? e -= i : t === "center" && (e -= i / 2), e;
}
function Yf(s, t, e) {
  let { y: i, height: n } = s;
  return t === "top" ? i += e : t === "bottom" ? i -= n + e : i -= n / 2, i;
}
function Ga(s, t, e, i) {
  const { caretSize: n, caretPadding: r, cornerRadius: a } = s, { xAlign: o, yAlign: l } = e, c = n + r, { topLeft: u, topRight: d, bottomLeft: p, bottomRight: h } = we(a);
  let m = Kf(t, o);
  const _ = Yf(t, l, c);
  return l === "center" ? o === "left" ? m += c : o === "right" && (m -= c) : o === "left" ? m -= Math.max(u, p) + n : o === "right" && (m += Math.max(d, h) + n), {
    x: ut(m, 0, i.width - t.width),
    y: ut(_, 0, i.height - t.height)
  };
}
function Js(s, t, e) {
  const i = gt(e.padding);
  return t === "center" ? s.x + s.width / 2 : t === "right" ? s.x + s.width - i.right : s.x + i.left;
}
function Ka(s) {
  return Bt([], Qt(s));
}
function Xf(s, t, e) {
  return he(s, {
    tooltip: t,
    tooltipItems: e,
    type: "tooltip"
  });
}
function Ya(s, t) {
  const e = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return e ? s.override(e) : s;
}
const Nl = {
  beforeTitle: Xt,
  title(s) {
    if (s.length > 0) {
      const t = s[0], e = t.chart.data.labels, i = e ? e.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (i > 0 && t.dataIndex < i)
        return e[t.dataIndex];
    }
    return "";
  },
  afterTitle: Xt,
  beforeBody: Xt,
  beforeLabel: Xt,
  label(s) {
    if (this && this.options && this.options.mode === "dataset")
      return s.label + ": " + s.formattedValue || s.formattedValue;
    let t = s.dataset.label || "";
    t && (t += ": ");
    const e = s.formattedValue;
    return N(e) || (t += e), t;
  },
  labelColor(s) {
    const e = s.chart.getDatasetMeta(s.datasetIndex).controller.getStyle(s.dataIndex);
    return {
      borderColor: e.borderColor,
      backgroundColor: e.backgroundColor,
      borderWidth: e.borderWidth,
      borderDash: e.borderDash,
      borderDashOffset: e.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(s) {
    const e = s.chart.getDatasetMeta(s.datasetIndex).controller.getStyle(s.dataIndex);
    return {
      pointStyle: e.pointStyle,
      rotation: e.rotation
    };
  },
  afterLabel: Xt,
  afterBody: Xt,
  beforeFooter: Xt,
  footer: Xt,
  afterFooter: Xt
};
function wt(s, t, e, i) {
  const n = s[t].call(e, i);
  return typeof n > "u" ? Nl[t].call(e, i) : n;
}
class wn extends ie {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const e = this.chart, i = this.options.setContext(this.getContext()), n = i.enabled && e.options.animation && i.animations, r = new bl(this.chart, n);
    return n._cacheable && (this._cachedAnimations = Object.freeze(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = Xf(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, e) {
    const { callbacks: i } = e, n = wt(i, "beforeTitle", this, t), r = wt(i, "title", this, t), a = wt(i, "afterTitle", this, t);
    let o = [];
    return o = Bt(o, Qt(n)), o = Bt(o, Qt(r)), o = Bt(o, Qt(a)), o;
  }
  getBeforeBody(t, e) {
    return Ka(wt(e.callbacks, "beforeBody", this, t));
  }
  getBody(t, e) {
    const { callbacks: i } = e, n = [];
    return j(t, (r) => {
      const a = {
        before: [],
        lines: [],
        after: []
      }, o = Ya(i, r);
      Bt(a.before, Qt(wt(o, "beforeLabel", this, r))), Bt(a.lines, wt(o, "label", this, r)), Bt(a.after, Qt(wt(o, "afterLabel", this, r))), n.push(a);
    }), n;
  }
  getAfterBody(t, e) {
    return Ka(wt(e.callbacks, "afterBody", this, t));
  }
  getFooter(t, e) {
    const { callbacks: i } = e, n = wt(i, "beforeFooter", this, t), r = wt(i, "footer", this, t), a = wt(i, "afterFooter", this, t);
    let o = [];
    return o = Bt(o, Qt(n)), o = Bt(o, Qt(r)), o = Bt(o, Qt(a)), o;
  }
  _createItems(t) {
    const e = this._active, i = this.chart.data, n = [], r = [], a = [];
    let o = [], l, c;
    for (l = 0, c = e.length; l < c; ++l)
      o.push(Vf(this.chart, e[l]));
    return t.filter && (o = o.filter((u, d, p) => t.filter(u, d, p, i))), t.itemSort && (o = o.sort((u, d) => t.itemSort(u, d, i))), j(o, (u) => {
      const d = Ya(t.callbacks, u);
      n.push(wt(d, "labelColor", this, u)), r.push(wt(d, "labelPointStyle", this, u)), a.push(wt(d, "labelTextColor", this, u));
    }), this.labelColors = n, this.labelPointStyles = r, this.labelTextColors = a, this.dataPoints = o, o;
  }
  update(t, e) {
    const i = this.options.setContext(this.getContext()), n = this._active;
    let r, a = [];
    if (!n.length)
      this.opacity !== 0 && (r = {
        opacity: 0
      });
    else {
      const o = hs[i.position].call(this, n, this._eventPosition);
      a = this._createItems(i), this.title = this.getTitle(a, i), this.beforeBody = this.getBeforeBody(a, i), this.body = this.getBody(a, i), this.afterBody = this.getAfterBody(a, i), this.footer = this.getFooter(a, i);
      const l = this._size = Ha(this, i), c = Object.assign({}, o, l), u = Wa(this.chart, i, c), d = Ga(i, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, r = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: o.x,
        caretY: o.y
      };
    }
    this._tooltipItems = a, this.$context = void 0, r && this._resolveAnimations().update(this, r), t && i.external && i.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: e
    });
  }
  drawCaret(t, e, i, n) {
    const r = this.getCaretPosition(t, i, n);
    e.lineTo(r.x1, r.y1), e.lineTo(r.x2, r.y2), e.lineTo(r.x3, r.y3);
  }
  getCaretPosition(t, e, i) {
    const { xAlign: n, yAlign: r } = this, { caretSize: a, cornerRadius: o } = i, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = we(o), { x: p, y: h } = t, { width: m, height: _ } = e;
    let y, v, k, w, x, C;
    return r === "center" ? (x = h + _ / 2, n === "left" ? (y = p, v = y - a, w = x + a, C = x - a) : (y = p + m, v = y + a, w = x - a, C = x + a), k = y) : (n === "left" ? v = p + Math.max(l, u) + a : n === "right" ? v = p + m - Math.max(c, d) - a : v = this.caretX, r === "top" ? (w = h, x = w - a, y = v - a, k = v + a) : (w = h + _, x = w + a, y = v + a, k = v - a), C = w), {
      x1: y,
      x2: v,
      x3: k,
      y1: w,
      y2: x,
      y3: C
    };
  }
  drawTitle(t, e, i) {
    const n = this.title, r = n.length;
    let a, o, l;
    if (r) {
      const c = je(i.rtl, this.x, this.width);
      for (t.x = Js(this, i.titleAlign, i), e.textAlign = c.textAlign(i.titleAlign), e.textBaseline = "middle", a = ot(i.titleFont), o = i.titleSpacing, e.fillStyle = i.titleColor, e.font = a.string, l = 0; l < r; ++l)
        e.fillText(n[l], c.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + o, l + 1 === r && (t.y += i.titleMarginBottom - o);
    }
  }
  _drawColorBox(t, e, i, n, r) {
    const a = this.labelColors[i], o = this.labelPointStyles[i], { boxHeight: l, boxWidth: c } = r, u = ot(r.bodyFont), d = Js(this, "left", r), p = n.x(d), h = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, m = e.y + h;
    if (r.usePointStyle) {
      const _ = {
        radius: Math.min(c, l) / 2,
        pointStyle: o.pointStyle,
        rotation: o.rotation,
        borderWidth: 1
      }, y = n.leftForLtr(p, c) + c / 2, v = m + l / 2;
      t.strokeStyle = r.multiKeyBackground, t.fillStyle = r.multiKeyBackground, _n(t, _, y, v), t.strokeStyle = a.borderColor, t.fillStyle = a.backgroundColor, _n(t, _, y, v);
    } else {
      t.lineWidth = U(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, t.strokeStyle = a.borderColor, t.setLineDash(a.borderDash || []), t.lineDashOffset = a.borderDashOffset || 0;
      const _ = n.leftForLtr(p, c), y = n.leftForLtr(n.xPlus(p, 1), c - 2), v = we(a.borderRadius);
      Object.values(v).some((k) => k !== 0) ? (t.beginPath(), t.fillStyle = r.multiKeyBackground, ws(t, {
        x: _,
        y: m,
        w: c,
        h: l,
        radius: v
      }), t.fill(), t.stroke(), t.fillStyle = a.backgroundColor, t.beginPath(), ws(t, {
        x: y,
        y: m + 1,
        w: c - 2,
        h: l - 2,
        radius: v
      }), t.fill()) : (t.fillStyle = r.multiKeyBackground, t.fillRect(_, m, c, l), t.strokeRect(_, m, c, l), t.fillStyle = a.backgroundColor, t.fillRect(y, m + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[i];
  }
  drawBody(t, e, i) {
    const { body: n } = this, { bodySpacing: r, bodyAlign: a, displayColors: o, boxHeight: l, boxWidth: c, boxPadding: u } = i, d = ot(i.bodyFont);
    let p = d.lineHeight, h = 0;
    const m = je(i.rtl, this.x, this.width), _ = function(I) {
      e.fillText(I, m.x(t.x + h), t.y + p / 2), t.y += p + r;
    }, y = m.textAlign(a);
    let v, k, w, x, C, $, S;
    for (e.textAlign = a, e.textBaseline = "middle", e.font = d.string, t.x = Js(this, y, i), e.fillStyle = i.bodyColor, j(this.beforeBody, _), h = o && y !== "right" ? a === "center" ? c / 2 + u : c + 2 + u : 0, x = 0, $ = n.length; x < $; ++x) {
      for (v = n[x], k = this.labelTextColors[x], e.fillStyle = k, j(v.before, _), w = v.lines, o && w.length && (this._drawColorBox(e, t, x, m, i), p = Math.max(d.lineHeight, l)), C = 0, S = w.length; C < S; ++C)
        _(w[C]), p = d.lineHeight;
      j(v.after, _);
    }
    h = 0, p = d.lineHeight, j(this.afterBody, _), t.y -= r;
  }
  drawFooter(t, e, i) {
    const n = this.footer, r = n.length;
    let a, o;
    if (r) {
      const l = je(i.rtl, this.x, this.width);
      for (t.x = Js(this, i.footerAlign, i), t.y += i.footerMarginTop, e.textAlign = l.textAlign(i.footerAlign), e.textBaseline = "middle", a = ot(i.footerFont), e.fillStyle = i.footerColor, e.font = a.string, o = 0; o < r; ++o)
        e.fillText(n[o], l.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + i.footerSpacing;
    }
  }
  drawBackground(t, e, i, n) {
    const { xAlign: r, yAlign: a } = this, { x: o, y: l } = t, { width: c, height: u } = i, { topLeft: d, topRight: p, bottomLeft: h, bottomRight: m } = we(n.cornerRadius);
    e.fillStyle = n.backgroundColor, e.strokeStyle = n.borderColor, e.lineWidth = n.borderWidth, e.beginPath(), e.moveTo(o + d, l), a === "top" && this.drawCaret(t, e, i, n), e.lineTo(o + c - p, l), e.quadraticCurveTo(o + c, l, o + c, l + p), a === "center" && r === "right" && this.drawCaret(t, e, i, n), e.lineTo(o + c, l + u - m), e.quadraticCurveTo(o + c, l + u, o + c - m, l + u), a === "bottom" && this.drawCaret(t, e, i, n), e.lineTo(o + h, l + u), e.quadraticCurveTo(o, l + u, o, l + u - h), a === "center" && r === "left" && this.drawCaret(t, e, i, n), e.lineTo(o, l + d), e.quadraticCurveTo(o, l, o + d, l), e.closePath(), e.fill(), n.borderWidth > 0 && e.stroke();
  }
  _updateAnimationTarget(t) {
    const e = this.chart, i = this.$animations, n = i && i.x, r = i && i.y;
    if (n || r) {
      const a = hs[t.position].call(this, this._active, this._eventPosition);
      if (!a)
        return;
      const o = this._size = Ha(this, t), l = Object.assign({}, a, this._size), c = Wa(e, t, l), u = Ga(t, l, c, e);
      (n._to !== u.x || r._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = o.width, this.height = o.height, this.caretX = a.x, this.caretY = a.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const e = this.options.setContext(this.getContext());
    let i = this.opacity;
    if (!i)
      return;
    this._updateAnimationTarget(e);
    const n = {
      width: this.width,
      height: this.height
    }, r = {
      x: this.x,
      y: this.y
    };
    i = Math.abs(i) < 1e-3 ? 0 : i;
    const a = gt(e.padding), o = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    e.enabled && o && (t.save(), t.globalAlpha = i, this.drawBackground(r, t, n, e), fl(t, e.textDirection), r.y += a.top, this.drawTitle(r, t, e), this.drawBody(r, t, e), this.drawFooter(r, t, e), ml(t, e.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, e) {
    const i = this._active, n = t.map(({ datasetIndex: o, index: l }) => {
      const c = this.chart.getDatasetMeta(o);
      if (!c)
        throw new Error("Cannot find a dataset at index " + o);
      return {
        datasetIndex: o,
        element: c.data[l],
        index: l
      };
    }), r = !mi(i, n), a = this._positionChanged(n, e);
    (r || a) && (this._active = n, this._eventPosition = e, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, e, i = !0) {
    if (e && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const n = this.options, r = this._active || [], a = this._getActiveElements(t, r, e, i), o = this._positionChanged(a, t), l = e || !mi(a, r) || o;
    return l && (this._active = a, (n.enabled || n.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, e))), l;
  }
  _getActiveElements(t, e, i, n) {
    const r = this.options;
    if (t.type === "mouseout")
      return [];
    if (!n)
      return e.filter((o) => this.chart.data.datasets[o.datasetIndex] && this.chart.getDatasetMeta(o.datasetIndex).controller.getParsed(o.index) !== void 0);
    const a = this.chart.getElementsAtEventForMode(t, r.mode, r, i);
    return r.reverse && a.reverse(), a;
  }
  _positionChanged(t, e) {
    const { caretX: i, caretY: n, options: r } = this, a = hs[r.position].call(this, t, e);
    return a !== !1 && (i !== a.x || n !== a.y);
  }
}
A(wn, "positioners", hs);
var Zf = {
  id: "tooltip",
  _element: wn,
  positioners: hs,
  afterInit(s, t, e) {
    e && (s.tooltip = new wn({
      chart: s,
      options: e
    }));
  },
  beforeUpdate(s, t, e) {
    s.tooltip && s.tooltip.initialize(e);
  },
  reset(s, t, e) {
    s.tooltip && s.tooltip.initialize(e);
  },
  afterDraw(s) {
    const t = s.tooltip;
    if (t && t._willRender()) {
      const e = {
        tooltip: t
      };
      if (s.notifyPlugins("beforeTooltipDraw", {
        ...e,
        cancelable: !0
      }) === !1)
        return;
      t.draw(s.ctx), s.notifyPlugins("afterTooltipDraw", e);
    }
  },
  afterEvent(s, t) {
    if (s.tooltip) {
      const e = t.replay;
      s.tooltip.handleEvent(t.event, e, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (s, t) => t.bodyFont.size,
    boxWidth: (s, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Nl
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (s) => s !== "filter" && s !== "itemSort" && s !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, Qf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: uf,
  Decimation: ff,
  Filler: Ef,
  Legend: Nf,
  SubTitle: zf,
  Title: jf,
  Tooltip: Zf
});
const Jf = (s, t, e, i) => (typeof t == "string" ? (e = s.push(t) - 1, i.unshift({
  index: e,
  label: t
})) : isNaN(t) && (e = null), e);
function tm(s, t, e, i) {
  const n = s.indexOf(t);
  if (n === -1)
    return Jf(s, t, e, i);
  const r = s.lastIndexOf(t);
  return n !== r ? e : n;
}
const em = (s, t) => s === null ? null : ut(Math.round(s), 0, t);
function Xa(s) {
  const t = this.getLabels();
  return s >= 0 && s < t.length ? t[s] : s;
}
class $n extends Oe {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const e = this._addedLabels;
    if (e.length) {
      const i = this.getLabels();
      for (const { index: n, label: r } of e)
        i[n] === r && i.splice(n, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, e) {
    if (N(t))
      return null;
    const i = this.getLabels();
    return e = isFinite(e) && i[e] === t ? e : tm(i, t, D(e, t), this._addedLabels), em(e, i.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let { min: i, max: n } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (i = 0), e || (n = this.getLabels().length - 1)), this.min = i, this.max = n;
  }
  buildTicks() {
    const t = this.min, e = this.max, i = this.options.offset, n = [];
    let r = this.getLabels();
    r = t === 0 && e === r.length - 1 ? r : r.slice(t, e + 1), this._valueRange = Math.max(r.length - (i ? 0 : 1), 1), this._startValue = this.min - (i ? 0.5 : 0);
    for (let a = t; a <= e; a++)
      n.push({
        value: a
      });
    return n;
  }
  getLabelForValue(t) {
    return Xa.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
A($n, "id", "category"), A($n, "defaults", {
  ticks: {
    callback: Xa
  }
});
function sm(s, t) {
  const e = [], { bounds: n, step: r, min: a, max: o, precision: l, count: c, maxTicks: u, maxDigits: d, includeBounds: p } = s, h = r || 1, m = u - 1, { min: _, max: y } = t, v = !N(a), k = !N(o), w = !N(c), x = (y - _) / (d + 1);
  let C = Vr((y - _) / m / h) * h, $, S, I, R;
  if (C < 1e-14 && !v && !k)
    return [
      {
        value: _
      },
      {
        value: y
      }
    ];
  R = Math.ceil(y / C) - Math.floor(_ / C), R > m && (C = Vr(R * C / m / h) * h), N(l) || ($ = Math.pow(10, l), C = Math.ceil(C * $) / $), n === "ticks" ? (S = Math.floor(_ / C) * C, I = Math.ceil(y / C) * C) : (S = _, I = y), v && k && r && Yu((o - a) / r, C / 1e3) ? (R = Math.round(Math.min((o - a) / C, u)), C = (o - a) / R, S = a, I = o) : w ? (S = v ? a : S, I = k ? o : I, R = c - 1, C = (I - S) / R) : (R = (I - S) / C, gs(R, Math.round(R), C / 1e3) ? R = Math.round(R) : R = Math.ceil(R));
  const F = Math.max(Hr(C), Hr(S));
  $ = Math.pow(10, N(l) ? F : l), S = Math.round(S * $) / $, I = Math.round(I * $) / $;
  let O = 0;
  for (v && (p && S !== a ? (e.push({
    value: a
  }), S < a && O++, gs(Math.round((S + O * C) * $) / $, a, Za(a, x, s)) && O++) : S < a && O++); O < R; ++O) {
    const L = Math.round((S + O * C) * $) / $;
    if (k && L > o)
      break;
    e.push({
      value: L
    });
  }
  return k && p && I !== o ? e.length && gs(e[e.length - 1].value, o, Za(o, x, s)) ? e[e.length - 1].value = o : e.push({
    value: o
  }) : (!k || I === o) && e.push({
    value: I
  }), e;
}
function Za(s, t, { horizontal: e, minRotation: i }) {
  const n = Ft(i), r = (e ? Math.sin(n) : Math.cos(n)) || 1e-3, a = 0.75 * t * ("" + s).length;
  return Math.min(t / r, a);
}
class xi extends Oe {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    return N(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: e, maxDefined: i } = this.getUserBounds();
    let { min: n, max: r } = this;
    const a = (l) => n = e ? n : l, o = (l) => r = i ? r : l;
    if (t) {
      const l = Vt(n), c = Vt(r);
      l < 0 && c < 0 ? o(0) : l > 0 && c > 0 && a(0);
    }
    if (n === r) {
      let l = r === 0 ? 1 : Math.abs(r * 0.05);
      o(r + l), t || a(n - l);
    }
    this.min = n, this.max = r;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: e, stepSize: i } = t, n;
    return i ? (n = Math.ceil(this.max / i) - Math.floor(this.min / i) + 1, n > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${i} would result generating up to ${n} ticks. Limiting to 1000.`), n = 1e3)) : (n = this.computeTickLimit(), e = e || 11), e && (n = Math.min(e, n)), n;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, e = t.ticks;
    let i = this.getTickLimit();
    i = Math.max(2, i);
    const n = {
      maxTicks: i,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: e.precision,
      step: e.stepSize,
      count: e.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: e.minRotation || 0,
      includeBounds: e.includeBounds !== !1
    }, r = this._range || this, a = sm(n, r);
    return t.bounds === "ticks" && Zo(a, this, "value"), t.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  configure() {
    const t = this.ticks;
    let e = this.min, i = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const n = (i - e) / Math.max(t.length - 1, 1) / 2;
      e -= n, i += n;
    }
    this._startValue = e, this._endValue = i, this._valueRange = i - e;
  }
  getLabelForValue(t) {
    return As(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Sn extends xi {
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = it(t) ? t : 0, this.max = it(e) ? e : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), e = t ? this.width : this.height, i = Ft(this.options.ticks.minRotation), n = (t ? Math.sin(i) : Math.cos(i)) || 1e-3, r = this._resolveTickFontOptions(0);
    return Math.ceil(e / Math.min(40, r.lineHeight / n));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
A(Sn, "id", "linear"), A(Sn, "defaults", {
  ticks: {
    callback: Si.formatters.numeric
  }
});
const Ss = (s) => Math.floor(ae(s)), ye = (s, t) => Math.pow(10, Ss(s) + t);
function Qa(s) {
  return s / Math.pow(10, Ss(s)) === 1;
}
function Ja(s, t, e) {
  const i = Math.pow(10, e), n = Math.floor(s / i);
  return Math.ceil(t / i) - n;
}
function im(s, t) {
  const e = t - s;
  let i = Ss(e);
  for (; Ja(s, t, i) > 10; )
    i++;
  for (; Ja(s, t, i) < 10; )
    i--;
  return Math.min(i, Ss(s));
}
function nm(s, { min: t, max: e }) {
  t = Tt(s.min, t);
  const i = [], n = Ss(t);
  let r = im(t, e), a = r < 0 ? Math.pow(10, Math.abs(r)) : 1;
  const o = Math.pow(10, r), l = n > r ? Math.pow(10, n) : 0, c = Math.round((t - l) * a) / a, u = Math.floor((t - l) / o / 10) * o * 10;
  let d = Math.floor((c - u) / Math.pow(10, r)), p = Tt(s.min, Math.round((l + u + d * Math.pow(10, r)) * a) / a);
  for (; p < e; )
    i.push({
      value: p,
      major: Qa(p),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (r++, d = 2, a = r >= 0 ? 1 : a), p = Math.round((l + u + d * Math.pow(10, r)) * a) / a;
  const h = Tt(s.max, p);
  return i.push({
    value: h,
    major: Qa(h),
    significand: d
  }), i;
}
class Tn extends Oe {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    const i = xi.prototype.parse.apply(this, [
      t,
      e
    ]);
    if (i === 0) {
      this._zero = !0;
      return;
    }
    return it(i) && i > 0 ? i : null;
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = it(t) ? Math.max(0, t) : null, this.max = it(e) ? Math.max(0, e) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !it(this._userMin) && (this.min = t === ye(this.min, 0) ? ye(this.min, -1) : ye(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let i = this.min, n = this.max;
    const r = (o) => i = t ? i : o, a = (o) => n = e ? n : o;
    i === n && (i <= 0 ? (r(1), a(10)) : (r(ye(i, -1)), a(ye(n, 1)))), i <= 0 && r(ye(n, -1)), n <= 0 && a(ye(i, 1)), this.min = i, this.max = n;
  }
  buildTicks() {
    const t = this.options, e = {
      min: this._userMin,
      max: this._userMax
    }, i = nm(e, this);
    return t.bounds === "ticks" && Zo(i, this, "value"), t.reverse ? (i.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), i;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : As(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = ae(t), this._valueRange = ae(this.max) - ae(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (ae(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const e = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + e * this._valueRange);
  }
}
A(Tn, "id", "logarithmic"), A(Tn, "defaults", {
  ticks: {
    callback: Si.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function In(s) {
  const t = s.ticks;
  if (t.display && s.display) {
    const e = gt(t.backdropPadding);
    return D(t.font && t.font.size, nt.font.size) + e.height;
  }
  return 0;
}
function rm(s, t, e) {
  return e = Z(e) ? e : [
    e
  ], {
    w: pd(s, t.string, e),
    h: e.length * t.lineHeight
  };
}
function to(s, t, e, i, n) {
  return s === i || s === n ? {
    start: t - e / 2,
    end: t + e / 2
  } : s < i || s > n ? {
    start: t - e,
    end: t
  } : {
    start: t,
    end: t + e
  };
}
function am(s) {
  const t = {
    l: s.left + s._padding.left,
    r: s.right - s._padding.right,
    t: s.top + s._padding.top,
    b: s.bottom - s._padding.bottom
  }, e = Object.assign({}, t), i = [], n = [], r = s._pointLabels.length, a = s.options.pointLabels, o = a.centerPointLabels ? K / r : 0;
  for (let l = 0; l < r; l++) {
    const c = a.setContext(s.getPointLabelContext(l));
    n[l] = c.padding;
    const u = s.getPointPosition(l, s.drawingArea + n[l], o), d = ot(c.font), p = rm(s.ctx, d, s._pointLabels[l]);
    i[l] = p;
    const h = It(s.getIndexAngle(l) + o), m = Math.round(jn(h)), _ = to(m, u.x, p.w, 0, 180), y = to(m, u.y, p.h, 90, 270);
    om(e, t, h, _, y);
  }
  s.setCenterPoint(t.l - e.l, e.r - t.r, t.t - e.t, e.b - t.b), s._pointLabelItems = um(s, i, n);
}
function om(s, t, e, i, n) {
  const r = Math.abs(Math.sin(e)), a = Math.abs(Math.cos(e));
  let o = 0, l = 0;
  i.start < t.l ? (o = (t.l - i.start) / r, s.l = Math.min(s.l, t.l - o)) : i.end > t.r && (o = (i.end - t.r) / r, s.r = Math.max(s.r, t.r + o)), n.start < t.t ? (l = (t.t - n.start) / a, s.t = Math.min(s.t, t.t - l)) : n.end > t.b && (l = (n.end - t.b) / a, s.b = Math.max(s.b, t.b + l));
}
function lm(s, t, e) {
  const i = s.drawingArea, { extra: n, additionalAngle: r, padding: a, size: o } = e, l = s.getPointPosition(t, i + n + a, r), c = Math.round(jn(It(l.angle + at))), u = hm(l.y, o.h, c), d = dm(c), p = pm(l.x, o.w, d);
  return {
    visible: !0,
    x: l.x,
    y: u,
    textAlign: d,
    left: p,
    top: u,
    right: p + o.w,
    bottom: u + o.h
  };
}
function cm(s, t) {
  if (!t)
    return !0;
  const { left: e, top: i, right: n, bottom: r } = s;
  return !(se({
    x: e,
    y: i
  }, t) || se({
    x: e,
    y: r
  }, t) || se({
    x: n,
    y: i
  }, t) || se({
    x: n,
    y: r
  }, t));
}
function um(s, t, e) {
  const i = [], n = s._pointLabels.length, r = s.options, { centerPointLabels: a, display: o } = r.pointLabels, l = {
    extra: In(r) / 2,
    additionalAngle: a ? K / n : 0
  };
  let c;
  for (let u = 0; u < n; u++) {
    l.padding = e[u], l.size = t[u];
    const d = lm(s, u, l);
    i.push(d), o === "auto" && (d.visible = cm(d, c), d.visible && (c = d));
  }
  return i;
}
function dm(s) {
  return s === 0 || s === 180 ? "center" : s < 180 ? "left" : "right";
}
function pm(s, t, e) {
  return e === "right" ? s -= t : e === "center" && (s -= t / 2), s;
}
function hm(s, t, e) {
  return e === 90 || e === 270 ? s -= t / 2 : (e > 270 || e < 90) && (s -= t), s;
}
function fm(s, t, e) {
  const { left: i, top: n, right: r, bottom: a } = e, { backdropColor: o } = t;
  if (!N(o)) {
    const l = we(t.borderRadius), c = gt(t.backdropPadding);
    s.fillStyle = o;
    const u = i - c.left, d = n - c.top, p = r - i + c.width, h = a - n + c.height;
    Object.values(l).some((m) => m !== 0) ? (s.beginPath(), ws(s, {
      x: u,
      y: d,
      w: p,
      h,
      radius: l
    }), s.fill()) : s.fillRect(u, d, p, h);
  }
}
function mm(s, t) {
  const { ctx: e, options: { pointLabels: i } } = s;
  for (let n = t - 1; n >= 0; n--) {
    const r = s._pointLabelItems[n];
    if (!r.visible)
      continue;
    const a = i.setContext(s.getPointLabelContext(n));
    fm(e, a, r);
    const o = ot(a.font), { x: l, y: c, textAlign: u } = r;
    Ae(e, s._pointLabels[n], l, c + o.lineHeight / 2, o, {
      color: a.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function Bl(s, t, e, i) {
  const { ctx: n } = s;
  if (e)
    n.arc(s.xCenter, s.yCenter, t, 0, G);
  else {
    let r = s.getPointPosition(0, t);
    n.moveTo(r.x, r.y);
    for (let a = 1; a < i; a++)
      r = s.getPointPosition(a, t), n.lineTo(r.x, r.y);
  }
}
function gm(s, t, e, i, n) {
  const r = s.ctx, a = t.circular, { color: o, lineWidth: l } = t;
  !a && !i || !o || !l || e < 0 || (r.save(), r.strokeStyle = o, r.lineWidth = l, r.setLineDash(n.dash), r.lineDashOffset = n.dashOffset, r.beginPath(), Bl(s, e, a, i), r.closePath(), r.stroke(), r.restore());
}
function _m(s, t, e) {
  return he(s, {
    label: e,
    index: t,
    type: "pointLabel"
  });
}
class fs extends xi {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = gt(In(this.options) / 2), e = this.width = this.maxWidth - t.width, i = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + e / 2 + t.left), this.yCenter = Math.floor(this.top + i / 2 + t.top), this.drawingArea = Math.floor(Math.min(e, i) / 2);
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!1);
    this.min = it(t) && !isNaN(t) ? t : 0, this.max = it(e) && !isNaN(e) ? e : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / In(this.options));
  }
  generateTickLabels(t) {
    xi.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((e, i) => {
      const n = W(this.options.pointLabels.callback, [
        e,
        i
      ], this);
      return n || n === 0 ? n : "";
    }).filter((e, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? am(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, e, i, n) {
    this.xCenter += Math.floor((t - e) / 2), this.yCenter += Math.floor((i - n) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, e, i, n));
  }
  getIndexAngle(t) {
    const e = G / (this._pointLabels.length || 1), i = this.options.startAngle || 0;
    return It(t * e + Ft(i));
  }
  getDistanceFromCenterForValue(t) {
    if (N(t))
      return NaN;
    const e = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * e : (t - this.min) * e;
  }
  getValueForDistanceFromCenter(t) {
    if (N(t))
      return NaN;
    const e = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - e : this.min + e;
  }
  getPointLabelContext(t) {
    const e = this._pointLabels || [];
    if (t >= 0 && t < e.length) {
      const i = e[t];
      return _m(this.getContext(), t, i);
    }
  }
  getPointPosition(t, e, i = 0) {
    const n = this.getIndexAngle(t) - at + i;
    return {
      x: Math.cos(n) * e + this.xCenter,
      y: Math.sin(n) * e + this.yCenter,
      angle: n
    };
  }
  getPointPositionForValue(t, e) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(e));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: e, top: i, right: n, bottom: r } = this._pointLabelItems[t];
    return {
      left: e,
      top: i,
      right: n,
      bottom: r
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: e } } = this.options;
    if (t) {
      const i = this.ctx;
      i.save(), i.beginPath(), Bl(this, this.getDistanceFromCenterForValue(this._endValue), e, this._pointLabels.length), i.closePath(), i.fillStyle = t, i.fill(), i.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, e = this.options, { angleLines: i, grid: n, border: r } = e, a = this._pointLabels.length;
    let o, l, c;
    if (e.pointLabels.display && mm(this, a), n.display && this.ticks.forEach((u, d) => {
      if (d !== 0) {
        l = this.getDistanceFromCenterForValue(u.value);
        const p = this.getContext(d), h = n.setContext(p), m = r.setContext(p);
        gm(this, h, l, a, m);
      }
    }), i.display) {
      for (t.save(), o = a - 1; o >= 0; o--) {
        const u = i.setContext(this.getPointLabelContext(o)), { color: d, lineWidth: p } = u;
        !p || !d || (t.lineWidth = p, t.strokeStyle = d, t.setLineDash(u.borderDash), t.lineDashOffset = u.borderDashOffset, l = this.getDistanceFromCenterForValue(e.ticks.reverse ? this.min : this.max), c = this.getPointPosition(o, l), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, e = this.options, i = e.ticks;
    if (!i.display)
      return;
    const n = this.getIndexAngle(0);
    let r, a;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(n), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((o, l) => {
      if (l === 0 && !e.reverse)
        return;
      const c = i.setContext(this.getContext(l)), u = ot(c.font);
      if (r = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = u.string, a = t.measureText(o.label).width, t.fillStyle = c.backdropColor;
        const d = gt(c.backdropPadding);
        t.fillRect(-a / 2 - d.left, -r - u.size / 2 - d.top, a + d.width, u.size + d.height);
      }
      Ae(t, o.label, 0, -r, u, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
A(fs, "id", "radialLinear"), A(fs, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Si.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), A(fs, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), A(fs, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const Oi = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, $t = /* @__PURE__ */ Object.keys(Oi);
function eo(s, t) {
  return s - t;
}
function so(s, t) {
  if (N(t))
    return null;
  const e = s._adapter, { parser: i, round: n, isoWeekday: r } = s._parseOpts;
  let a = t;
  return typeof i == "function" && (a = i(a)), it(a) || (a = typeof i == "string" ? e.parse(a, i) : e.parse(a)), a === null ? null : (n && (a = n === "week" && (ze(r) || r === !0) ? e.startOf(a, "isoWeek", r) : e.startOf(a, n)), +a);
}
function io(s, t, e, i) {
  const n = $t.length;
  for (let r = $t.indexOf(s); r < n - 1; ++r) {
    const a = Oi[$t[r]], o = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((e - t) / (o * a.size)) <= i)
      return $t[r];
  }
  return $t[n - 1];
}
function ym(s, t, e, i, n) {
  for (let r = $t.length - 1; r >= $t.indexOf(e); r--) {
    const a = $t[r];
    if (Oi[a].common && s._adapter.diff(n, i, a) >= t - 1)
      return a;
  }
  return $t[e ? $t.indexOf(e) : 0];
}
function bm(s) {
  for (let t = $t.indexOf(s) + 1, e = $t.length; t < e; ++t)
    if (Oi[$t[t]].common)
      return $t[t];
}
function no(s, t, e) {
  if (!e)
    s[t] = !0;
  else if (e.length) {
    const { lo: i, hi: n } = zn(e, t), r = e[i] >= t ? e[i] : e[n];
    s[r] = !0;
  }
}
function vm(s, t, e, i) {
  const n = s._adapter, r = +n.startOf(t[0].value, i), a = t[t.length - 1].value;
  let o, l;
  for (o = r; o <= a; o = +n.add(o, 1, i))
    l = e[o], l >= 0 && (t[l].major = !0);
  return t;
}
function ro(s, t, e) {
  const i = [], n = {}, r = t.length;
  let a, o;
  for (a = 0; a < r; ++a)
    o = t[a], n[o] = a, i.push({
      value: o,
      major: !1
    });
  return r === 0 || !e ? i : vm(s, i, n, e);
}
class Ts extends Oe {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, e = {}) {
    const i = t.time || (t.time = {}), n = this._adapter = new Ip._date(t.adapters.date);
    n.init(e), ms(i.displayFormats, n.formats()), this._parseOpts = {
      parser: i.parser,
      round: i.round,
      isoWeekday: i.isoWeekday
    }, super.init(t), this._normalized = e.normalized;
  }
  parse(t, e) {
    return t === void 0 ? null : so(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, e = this._adapter, i = t.time.unit || "day";
    let { min: n, max: r, minDefined: a, maxDefined: o } = this.getUserBounds();
    function l(c) {
      !a && !isNaN(c.min) && (n = Math.min(n, c.min)), !o && !isNaN(c.max) && (r = Math.max(r, c.max));
    }
    (!a || !o) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), n = it(n) && !isNaN(n) ? n : +e.startOf(Date.now(), i), r = it(r) && !isNaN(r) ? r : +e.endOf(Date.now(), i) + 1, this.min = Math.min(n, r - 1), this.max = Math.max(n + 1, r);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let e = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY;
    return t.length && (e = t[0], i = t[t.length - 1]), {
      min: e,
      max: i
    };
  }
  buildTicks() {
    const t = this.options, e = t.time, i = t.ticks, n = i.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && n.length && (this.min = this._userMin || n[0], this.max = this._userMax || n[n.length - 1]);
    const r = this.min, a = this.max, o = Ju(n, r, a);
    return this._unit = e.unit || (i.autoSkip ? io(e.minUnit, this.min, this.max, this._getLabelCapacity(r)) : ym(this, o.length, e.minUnit, this.min, this.max)), this._majorUnit = !i.major.enabled || this._unit === "year" ? void 0 : bm(this._unit), this.initOffsets(n), t.reverse && o.reverse(), ro(this, o, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let e = 0, i = 0, n, r;
    this.options.offset && t.length && (n = this.getDecimalForValue(t[0]), t.length === 1 ? e = 1 - n : e = (this.getDecimalForValue(t[1]) - n) / 2, r = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? i = r : i = (r - this.getDecimalForValue(t[t.length - 2])) / 2);
    const a = t.length < 3 ? 0.5 : 0.25;
    e = ut(e, 0, a), i = ut(i, 0, a), this._offsets = {
      start: e,
      end: i,
      factor: 1 / (e + 1 + i)
    };
  }
  _generate() {
    const t = this._adapter, e = this.min, i = this.max, n = this.options, r = n.time, a = r.unit || io(r.minUnit, e, i, this._getLabelCapacity(e)), o = D(n.ticks.stepSize, 1), l = a === "week" ? r.isoWeekday : !1, c = ze(l) || l === !0, u = {};
    let d = e, p, h;
    if (c && (d = +t.startOf(d, "isoWeek", l)), d = +t.startOf(d, c ? "day" : a), t.diff(i, e, a) > 1e5 * o)
      throw new Error(e + " and " + i + " are too far apart with stepSize of " + o + " " + a);
    const m = n.ticks.source === "data" && this.getDataTimestamps();
    for (p = d, h = 0; p < i; p = +t.add(p, o, a), h++)
      no(u, p, m);
    return (p === i || n.bounds === "ticks" || h === 1) && no(u, p, m), Object.keys(u).sort(eo).map((_) => +_);
  }
  getLabelForValue(t) {
    const e = this._adapter, i = this.options.time;
    return i.tooltipFormat ? e.format(t, i.tooltipFormat) : e.format(t, i.displayFormats.datetime);
  }
  format(t, e) {
    const n = this.options.time.displayFormats, r = this._unit, a = e || n[r];
    return this._adapter.format(t, a);
  }
  _tickFormatFunction(t, e, i, n) {
    const r = this.options, a = r.ticks.callback;
    if (a)
      return W(a, [
        t,
        e,
        i
      ], this);
    const o = r.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && o[l], d = c && o[c], p = i[e], h = c && d && p && p.major;
    return this._adapter.format(t, n || (h ? d : u));
  }
  generateTickLabels(t) {
    let e, i, n;
    for (e = 0, i = t.length; e < i; ++e)
      n = t[e], n.label = this._tickFormatFunction(n.value, e, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const e = this._offsets, i = this.getDecimalForValue(t);
    return this.getPixelForDecimal((e.start + i) * e.factor);
  }
  getValueForPixel(t) {
    const e = this._offsets, i = this.getDecimalForPixel(t) / e.factor - e.end;
    return this.min + i * (this.max - this.min);
  }
  _getLabelSize(t) {
    const e = this.options.ticks, i = this.ctx.measureText(t).width, n = Ft(this.isHorizontal() ? e.maxRotation : e.minRotation), r = Math.cos(n), a = Math.sin(n), o = this._resolveTickFontOptions(0).size;
    return {
      w: i * r + o * a,
      h: i * a + o * r
    };
  }
  _getLabelCapacity(t) {
    const e = this.options.time, i = e.displayFormats, n = i[e.unit] || i.millisecond, r = this._tickFormatFunction(t, 0, ro(this, [
      t
    ], this._majorUnit), n), a = this._getLabelSize(r), o = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return o > 0 ? o : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], e, i;
    if (t.length)
      return t;
    const n = this.getMatchingVisibleMetas();
    if (this._normalized && n.length)
      return this._cache.data = n[0].controller.getAllParsedValues(this);
    for (e = 0, i = n.length; e < i; ++e)
      t = t.concat(n[e].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let e, i;
    if (t.length)
      return t;
    const n = this.getLabels();
    for (e = 0, i = n.length; e < i; ++e)
      t.push(so(this, n[e]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return tl(t.sort(eo));
  }
}
A(Ts, "id", "time"), A(Ts, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function ti(s, t, e) {
  let i = 0, n = s.length - 1, r, a, o, l;
  e ? (t >= s[i].pos && t <= s[n].pos && ({ lo: i, hi: n } = ee(s, "pos", t)), { pos: r, time: o } = s[i], { pos: a, time: l } = s[n]) : (t >= s[i].time && t <= s[n].time && ({ lo: i, hi: n } = ee(s, "time", t)), { time: r, pos: o } = s[i], { time: a, pos: l } = s[n]);
  const c = a - r;
  return c ? o + (l - o) * (t - r) / c : o;
}
class An extends Ts {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), e = this._table = this.buildLookupTable(t);
    this._minPos = ti(e, this.min), this._tableRange = ti(e, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: e, max: i } = this, n = [], r = [];
    let a, o, l, c, u;
    for (a = 0, o = t.length; a < o; ++a)
      c = t[a], c >= e && c <= i && n.push(c);
    if (n.length < 2)
      return [
        {
          time: e,
          pos: 0
        },
        {
          time: i,
          pos: 1
        }
      ];
    for (a = 0, o = n.length; a < o; ++a)
      u = n[a + 1], l = n[a - 1], c = n[a], Math.round((u + l) / 2) !== c && r.push({
        time: c,
        pos: a / (o - 1)
      });
    return r;
  }
  _generate() {
    const t = this.min, e = this.max;
    let i = super.getDataTimestamps();
    return (!i.includes(t) || !i.length) && i.splice(0, 0, t), (!i.includes(e) || i.length === 1) && i.push(e), i.sort((n, r) => n - r);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const e = this.getDataTimestamps(), i = this.getLabelTimestamps();
    return e.length && i.length ? t = this.normalize(e.concat(i)) : t = e.length ? e : i, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (ti(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const e = this._offsets, i = this.getDecimalForPixel(t) / e.factor - e.end;
    return ti(this._table, i * this._tableRange + this._minPos, !0);
  }
}
A(An, "id", "timeseries"), A(An, "defaults", Ts.defaults);
var km = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: $n,
  LinearScale: Sn,
  LogarithmicScale: Tn,
  RadialLinearScale: fs,
  TimeScale: Ts,
  TimeSeriesScale: An
});
const xm = [
  Tp,
  nf,
  Qf,
  km
];
zt.register(...xm);
const Cm = g({
  name: "BarChart",
  props: {
    data: {
      type: Object,
      required: !0
    },
    legendPosition: {
      type: String
    }
  },
  mounted() {
    const s = this.$refs["bar-chart"];
    new zt(s, {
      type: "bar",
      data: this.data,
      options: this.chartOptions
    });
  },
  computed: {
    showLegend() {
      return !!this.legendPosition;
    },
    chartOptions() {
      return {
        indexAxis: "y",
        // Elements options apply to all the options unless overridden in a dataset
        // In this case, we are setting the border of each horizontal bar to be 2px wide
        elements: {
          bar: {
            borderWidth: 2
          }
        },
        responsive: !0,
        plugins: {
          legend: {
            display: this.showLegend,
            position: this.legendPosition
          },
          title: {
            display: !1
          }
        }
      };
    }
  }
});
function f(s, t, e, i, n, r, a, o) {
  var l = typeof s == "function" ? s.options : s;
  return t && (l.render = t, l.staticRenderFns = e, l._compiled = !0), r && (l._scopeId = "data-v-" + r), {
    exports: s,
    options: l
  };
}
var wm = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("canvas", { ref: "bar-chart" });
}, $m = [], Sm = /* @__PURE__ */ f(
  Cm,
  wm,
  $m,
  !1,
  null,
  null
);
const Tm = Sm.exports, Im = g({
  name: "LineChart",
  props: {
    data: {
      type: Object,
      required: !0
    },
    fillLine: {
      type: Boolean,
      required: !1
    },
    legendPosition: {
      type: String,
      required: !1
    }
  },
  mounted() {
    const s = this.$refs["line-chart"];
    new zt(s, {
      type: "line",
      data: this.data,
      options: this.chartOptions
    });
  },
  computed: {
    showLegend() {
      return !!this.legendPosition;
    },
    chartOptions() {
      return {
        // Elements options apply to all the options unless overridden in a dataset
        // In this case, we are setting the border of each horizontal bar to be 2px wide
        elements: {
          bar: {
            borderWidth: 2
          },
          point: {
            pointStyle: this.fillLine ? !1 : "circle"
          },
          line: {
            fill: this.fillLine
          }
        },
        responsive: !0,
        plugins: {
          legend: {
            display: this.showLegend,
            position: this.legendPosition
          },
          filler: {
            propagate: !0
          },
          title: {
            display: !1
          }
        }
      };
    }
  }
});
var Am = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("canvas", { ref: "line-chart" });
}, Pm = [], Om = /* @__PURE__ */ f(
  Im,
  Am,
  Pm,
  !1,
  null,
  null
);
const Mm = Om.exports, Rm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BarChart: Tm,
  LineChart: Mm
}, Symbol.toStringTag, { value: "Module" })), Em = g({
  props: {
    value: {
      type: Boolean,
      required: !0
    }
  },
  computed: {
    faIcon() {
      return this.value ? "fa-regular fa-window-restore" : "fa-regular fa-arrow-up-right-from-square";
    }
  },
  methods: {
    onClickExpand() {
      this.$emit("input", !this.value);
    },
    onClickClose() {
      this.$emit("chat-close");
    }
  }
});
var Dm = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-chat-header" }, [e("img", { staticClass: "rready-ai-logo", attrs: { src: "/img/rready-ai-logo.svg", alt: "rreadyAI" } }), e("div", { staticClass: "spacer" }), e("app-icon-button", { attrs: { size: 26, padding: 2 }, on: { click: t.onClickExpand } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: t.faIcon } })], 1), e("app-icon-button", { staticClass: "icon", attrs: { size: 26, padding: 2 }, on: { click: t.onClickClose } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1)], 1);
}, Fm = [], Lm = /* @__PURE__ */ f(
  Em,
  Dm,
  Fm,
  !1,
  null,
  "909cb2f9"
);
const qm = Lm.exports, Um = g({
  data() {
    return {
      input: ""
    };
  },
  computed: {
    sendEnabled() {
      return !!this.input.trim();
    }
  },
  methods: {
    onSendMessage() {
      const s = this.input.trim();
      s && (this.$emit("send-message", s), this.input = "");
    }
  }
});
var Nm = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("base-input-text", { staticClass: "app-chat-input", on: { keydown: function(i) {
    return !i.type.indexOf("key") && t._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : t.onSendMessage.apply(null, arguments);
  } }, scopedSlots: t._u([{ key: "end", fn: function() {
    return [e("app-icon-button", { attrs: { size: 26, padding: 0, enabled: t.sendEnabled }, on: { click: t.onSendMessage } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-solid fa-circle-arrow-up" } })], 1)];
  }, proxy: !0 }]), model: { value: t.input, callback: function(i) {
    t.input = i;
  }, expression: "input" } });
}, Bm = [], jm = /* @__PURE__ */ f(
  Um,
  Nm,
  Bm,
  !1,
  null,
  "6c556f78"
);
const zm = jm.exports, Vm = "/img/profile-placeholder.svg", Hm = g({
  props: {
    chatUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {};
  },
  computed: {
    avatarDecorator() {
      if (this.chatUser.ai)
        return "/img/rready-ai-icon-mini.png";
    },
    avatarImage() {
      return this.chatUser.avatar || Vm;
    },
    cssClass() {
      return {
        self: this.chatUser.self,
        other: !this.chatUser.self
      };
    }
  }
});
var Wm = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-chat-message-avatar", class: t.cssClass }, [t.avatarDecorator ? e("img", { staticClass: "ai-icon", attrs: { src: t.avatarDecorator } }) : t._e(), e("img", { staticClass: "avatar-image", attrs: { src: t.avatarImage } })]);
}, Gm = [], Km = /* @__PURE__ */ f(
  Hm,
  Wm,
  Gm,
  !1,
  null,
  "657d920b"
);
const Ym = Km.exports, Xm = g({
  props: {
    message: {
      type: Object,
      required: !0
    }
  }
});
var Zm = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "chat-message-content" }, [e("span", [t._v(t._s(t.$t("aiChat.errorResponse")))])]);
}, Qm = [], Jm = /* @__PURE__ */ f(
  Xm,
  Zm,
  Qm,
  !1,
  null,
  "8485ce9a"
);
const tg = Jm.exports, eg = g({
  props: {
    message: {
      type: Object,
      required: !0
    }
  }
});
var sg = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "chat-message-content" }, [e("span", [t._v(t._s(t.$t("aiChat.processingResponse")))]), e("app-bounce-loading", { staticClass: "app-bounce-loading" })], 1);
}, ig = [], ng = /* @__PURE__ */ f(
  eg,
  sg,
  ig,
  !1,
  null,
  "a0b2b61e"
);
const rg = ng.exports, ag = g({
  props: {
    message: {
      type: Object,
      required: !0
    },
    actionType: {
      type: String,
      required: !0
    }
  },
  computed: {
    buttonText() {
      return this.actionType === "copy" ? this.$t("aiChat.buttonCopy").toString() : this.$t("aiChat.buttonApply").toString();
    }
  },
  methods: {
    onAcceptAction() {
      this.$emit("accept-action", { message: this.message });
    }
  }
});
var og = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "chat-message-content" }, [e("div", { staticClass: "suggestions-label" }, [t._v(t._s(t.$t("aiChat.labelActions")))]), e("app-markdown-text", { attrs: { text: t.message.text } }), e("div", { staticClass: "chat-message-suggestion" }, [e("button", { staticClass: "apply-button", on: { click: t.onAcceptAction } }, [e("img", { attrs: { src: "/img/rready-ai-icon-mini.png" } }), t._v(" " + t._s(t.buttonText) + " ")])])], 1);
}, lg = [], cg = /* @__PURE__ */ f(
  ag,
  og,
  lg,
  !1,
  null,
  "9e89fefe"
);
const ug = cg.exports, dg = g({
  props: {
    message: {
      type: Object,
      required: !0
    }
  },
  computed: {
    suggestions() {
      var s;
      return ((s = this.message.suggestions) == null ? void 0 : s.filter(({ text: t }) => !!t)) || [];
    }
  },
  methods: {
    onSelectSuggestion(s) {
      this.$emit("select-suggestion", { message: this.message, index: s });
    }
  }
});
var pg = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "chat-message-content" }, [e("app-markdown-text", { attrs: { text: t.message.text } }), t.suggestions.length ? e("div", { staticClass: "chat-message-suggestion" }, [e("div", { staticClass: "suggestions-label" }, [t._v(t._s(t.$t("aiChat.labelSuggestions")))]), t._l(t.suggestions, function(i, n) {
    return e("div", { key: n }, [e("button", { staticClass: "suggestion-button", on: { click: function(r) {
      return t.onSelectSuggestion(n);
    } } }, [t._v(" " + t._s(i.text) + " ")])]);
  })], 2) : t._e()], 1);
}, hg = [], fg = /* @__PURE__ */ f(
  dg,
  pg,
  hg,
  !1,
  null,
  "d00c8ff7"
);
const mg = fg.exports, gg = g({
  components: {
    ChatMessageAvatar: Ym,
    ChatMessageContentError: tg,
    ChatMessageContentLoading: rg,
    ChatMessageContentText: mg,
    ChatMessageContentAction: ug
  },
  props: {
    message: {
      type: Object,
      required: !0
    }
  },
  computed: {
    cssClass() {
      return {
        self: this.message.owner.self,
        other: !this.message.owner.self
      };
    }
  }
});
var _g = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-chat-message", class: t.cssClass }, [t.message.status === "loading" ? e("chat-message-content-loading", { staticClass: "message-content", attrs: { message: t.message } }) : t.message.status === "error" ? e("chat-message-content-error", { staticClass: "message-content", attrs: { message: t.message } }) : ["action", "copy"].includes(t.message.template) ? e("chat-message-content-action", t._g({ staticClass: "message-content", attrs: { message: t.message, "action-type": t.message.template } }, t.$listeners)) : t.message.template === "text" ? e("chat-message-content-text", t._g({ staticClass: "message-content", attrs: { message: t.message } }, t.$listeners)) : t._e(), e("chat-message-avatar", { attrs: { "chat-user": t.message.owner } })], 1);
}, yg = [], bg = /* @__PURE__ */ f(
  gg,
  _g,
  yg,
  !1,
  null,
  "302403d2"
);
const vg = bg.exports, kg = g({
  components: {
    ChatMessage: vg
  },
  mounted() {
    this.$el.scrollTo(0, this.$el.scrollHeight);
  },
  props: {
    messages: {
      type: Array,
      required: !0
    }
  },
  watch: {
    messages: {
      handler() {
        pe(() => {
          this.$el.scrollTo({ top: this.$el.scrollHeight, behavior: "smooth" });
        });
      },
      deep: !0
    }
  }
});
var xg = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "chat-tab" }, [e("div", { staticClass: "flex-trick" }), t._l(t.messages, function(i, n) {
    return e("chat-message", t._g({ key: n, attrs: { message: i } }, t.$listeners));
  })], 2);
}, Cg = [], wg = /* @__PURE__ */ f(
  kg,
  xg,
  Cg,
  !1,
  null,
  "bd924d5b"
);
const $g = wg.exports, Sg = g({
  components: {
    ChatHeader: qm,
    ChatInput: zm,
    ChatTab: $g
  },
  props: {
    sessions: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      expanded: !1,
      currentTab: ""
    };
  },
  created() {
    var s;
    this.currentTab = ((s = this.sessions) == null ? void 0 : s[0].key) ?? "";
  },
  watch: {
    expanded(s) {
      this.$emit("chat-expand-toggle", s);
    }
  },
  computed: {
    tabOptions() {
      return this.sessions.map((s) => ({
        tabKey: s.key,
        label: s.title
      }));
    },
    currentSession() {
      return this.sessions.find((s) => s.key === this.currentTab);
    },
    messages() {
      var s;
      return ((s = this.currentSession) == null ? void 0 : s.messages) ?? [];
    }
  },
  methods: {
    onSendMessage(s) {
      this.$emit("send-message", {
        sessionKey: this.currentTab,
        text: s
      });
    },
    onSelectSuggestion(s) {
      this.$emit("select-suggestion", {
        sessionKey: this.currentTab,
        message: s.message,
        suggestionIndex: s.index
      });
    },
    onAcceptAction(s) {
      this.$emit("accept-action", {
        sessionKey: this.currentTab,
        message: s.message
      });
    },
    onClickClose() {
      this.$emit("chat-close");
    }
  }
});
var Tg = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-chat-area" }, [e("chat-header", { staticClass: "header-area", on: { "chat-close": t.onClickClose }, model: { value: t.expanded, callback: function(i) {
    t.expanded = i;
  }, expression: "expanded" } }), t.sessions.length > 1 ? e("app-tabs", { staticClass: "app-tabs", attrs: { tabs: t.tabOptions }, model: { value: t.currentTab, callback: function(i) {
    t.currentTab = i;
  }, expression: "currentTab" } }) : t._e(), e("chat-tab", { key: t.currentTab, staticClass: "chat-tab", attrs: { messages: t.messages }, on: { "select-suggestion": t.onSelectSuggestion, "accept-action": t.onAcceptAction } }), e("div", { staticClass: "chat-input-area" }, [e("chat-input", { on: { "send-message": t.onSendMessage } })], 1)], 1);
}, Ig = [], Ag = /* @__PURE__ */ f(
  Sg,
  Tg,
  Ig,
  !1,
  null,
  "e7844e17"
);
const Pg = Ag.exports;
var Og = 5, Mg = function(s, t) {
  return Promise.resolve(s.amountStarted < t.length);
}, Rg = { maxInProgress: Og, failFast: !1, nextCheck: Mg, ignoreIsFunctionCheck: !1 };
function Eg(s, t) {
  return new Promise(function(e, i) {
    var n = Object.assign({}, Rg, t), r = { amountDone: 0, amountStarted: 0, amountResolved: 0, amountRejected: 0, amountNextCheckFalsey: 0, rejectedIndexes: [], resolvedIndexes: [], nextCheckFalseyIndexes: [], taskResults: [] };
    if (s.length === 0) return e(r);
    for (var a = !1, o = 0, l = function() {
      if (a !== !0) {
        if (r.amountDone++, typeof n.progressCallback == "function" && n.progressCallback(r), r.amountDone === s.length) return e(r);
        o < s.length && c(o++);
      }
    }, c = function(d) {
      n.nextCheck(r, s).then(function(p) {
        p === !0 ? function(h) {
          if (r.amountStarted++, typeof s[h] == "function") s[h]().then(function(m) {
            r.taskResults[h] = m, r.resolvedIndexes.push(h), r.amountResolved++, l();
          }, function(m) {
            if (r.taskResults[h] = m, r.rejectedIndexes.push(h), r.amountRejected++, n.failFast === !0) return a = !0, i(r);
            l();
          });
          else {
            if (n.ignoreIsFunctionCheck !== !0) return a = !0, i(new Error("tasks[" + h + "]: " + s[h] + ", is supposed to be of type function"));
            r.taskResults[h] = s[h], r.resolvedIndexes.push(h), r.amountResolved++, l();
          }
        }(d) : (r.amountNextCheckFalsey++, r.nextCheckFalseyIndexes.push(d), l());
      }, i);
    }, u = 0; u < Math.min(n.maxInProgress, s.length); u++) c(o++);
  });
}
function Dg(s, t) {
  return new Promise(function(e, i) {
    Eg(s, t).then(function(n) {
      e(n.taskResults);
    }, function(n) {
      n instanceof Error ? i(n) : i(n.taskResults[n.rejectedIndexes[0]]);
    });
  });
}
function Fg(s, t) {
  return Dg(s, Object.assign({}, { failFast: !0 }, t));
}
const an = 5 * 1024 * 1024, Lg = 3;
function qg(s) {
  const t = Math.ceil(s.size / an), e = [];
  for (let i = 0; i < t; i += 1) {
    const n = i * an, r = Math.min(n + an, s.size);
    e.push({
      file: s,
      partNumber: i + 1,
      getSlice: () => s.slice(n, r, s.type)
    });
  }
  return e;
}
function Ug(s, t) {
  const e = st("IDLE"), i = st(0), n = st(0), r = st(null), a = async (c, u, d) => {
    const p = await s.getSignedUrl("ticket", {
      key: c,
      uploadId: u,
      contentType: d.file.type,
      partNumber: d.partNumber
    });
    n.value += 1;
    const h = await fetch(p, {
      method: "PUT",
      body: d.getSlice()
    });
    return n.value += 1, h.headers.get("etag") ?? "";
  }, o = async (c, u) => {
    try {
      e.value = "IN_PROGRESS";
      const d = qg(c);
      i.value = 2 + d.length * 2;
      const p = await s.start("ticket", t, {
        contentType: c.type,
        contentDisposition: `attachment; filename="${c.name}"`
      });
      n.value += 1;
      const { key: h } = p, { uploadId: m } = p, _ = d.map(
        (k) => () => a(h, m, k)
      ), y = await Fg(_, {
        maxInProgress: Lg,
        failFast: !0
      }), v = await s.stop("ticket", t, {
        key: h,
        uploadId: m,
        contentType: c.type,
        parts: y,
        category: u,
        originalFilename: c.name
      });
      n.value += 1, e.value = "SUCCESS", r.value = v.file;
    } catch (d) {
      console.error(`Could not upload file '${c.name}'`, d), e.value = "ERROR";
    }
  }, l = Q(
    () => i.value ? n.value / i.value : 0
  );
  return { upload: o, status: e, progress: l, result: r };
}
function Ng() {
  return { getUserReference: (s) => {
    const t = s.split(":");
    if (t.length !== 4) {
      console.warn(
        "Malformed canonical string. Expected format: context:entity:key:value"
      );
      return;
    }
    const [e, i, n, r] = t;
    if (i !== "user") {
      console.warn(`Unsupported entity: ${i}. Only 'user' is supported.`);
      return;
    }
    if (!e || !n || !r) {
      console.warn("Missing context, key, or value in the canonical string.");
      return;
    }
    return {
      context: e,
      entity: i,
      key: n,
      value: r
    };
  }, referenceToCanonical: (s) => {
    const { context: t, entity: e, key: i, value: n } = s;
    if (!t || !e || !i || !n) {
      console.warn(
        "Incomplete reference. Expected all fields to be non-empty."
      );
      return;
    }
    return `${t}:${e}:${i}:${n}`;
  } };
}
function Bg(s, t) {
  return t.reduce((e, i) => (e == null ? void 0 : e[i]) ?? null, s);
}
function jg(s, t) {
  const e = /* @__PURE__ */ new Map();
  for (const i of s) {
    const n = Bg(i, t);
    typeof n != "string" ? console.warn("Data grouping must use 'string' values", { groupKey: n }) : e.has(n) ? e.get(n).push(i) : e.set(n, [i]);
  }
  return e;
}
function jl(s, t, e) {
  const i = Be(e), n = Q(() => {
    const o = jg(Be(s), Be(t));
    return i.reduce((l, c) => (l[c] = o.get(c) ?? [], l), {});
  }), r = Q(() => i), a = Q(
    () => i.filter((o) => {
      var l;
      return ((l = n.value[o]) == null ? void 0 : l.length) > 0;
    })
  );
  return { groupedData: n, groups: r, nonEmptyGroups: a };
}
function zg(s) {
  const t = st(""), e = st(""), i = Q(() => {
    if (!(!t.value || !e.value))
      return {
        field: t.value,
        direction: e.value
      };
  }), n = () => {
    e.value === "ASC" ? e.value = "DESC" : e.value === "DESC" ? e.value = "" : e.value = "ASC";
  };
  return { sortStatus: i, toggleSort: (r) => {
    t.value === r ? n() : (t.value = r, e.value = "ASC");
  } };
}
function Mi(s, t) {
  const e = st(s), i = st(t), n = Q(() => e.value.length), r = Q(
    () => i.value.reduce((o, l) => {
      const c = e.value.some((u) => u.id === l) ? 1 : 0;
      return o + c;
    }, 0)
  ), a = Q(() => r.value === 0 ? "no" : e.value.some((o) => !i.value.includes(o.id)) ? "partial" : "yes");
  return {
    countFound: n,
    countSelected: r,
    selection: i,
    selectionStatus: a,
    itemStatus: (o) => i.value.includes(o) ? "yes" : "no",
    toggleAll: () => {
      a.value === "yes" ? i.value = [] : i.value = e.value.map((o) => o.id);
    },
    toggleItem: (o) => {
      if (i.value === void 0) {
        console.warn("Error selecting item, no selection array provided");
        return;
      }
      const l = i.value.indexOf(o);
      if (l === -1)
        i.value = [o, ...i.value];
      else {
        const c = [...i.value];
        c.splice(l, 1), i.value = c;
      }
    }
  };
}
function zl() {
  const s = pu("maxFileUploadSize", 52428800), t = Q(
    () => (
      // Default 50MB
      s ?? 52428800
    )
  ), e = (n) => {
    const r = ["Bytes", "KB", "MB", "GB", "TB"];
    if (n === 0) return "0 Byte";
    const a = Math.floor(Math.log(n) / Math.log(1024));
    return `${parseFloat((n / 1024 ** a).toFixed(2))} ${r[a]}`;
  }, i = Q(
    () => e(t.value)
  );
  return {
    allowFileSize: (n) => !t.value || n.size <= t.value,
    bytesToReadableValue: e,
    maxFileUploadSize: t,
    readableMaxFileUploadSize: i
  };
}
function Vl(s, t, e) {
  const i = Q(
    () => e.includes("ADMIN_TICKET_USER_FIELD_LIST")
  ), n = Q(
    () => t.value && i.value ? Be(t) : Be(s)
  ), r = (l, c) => {
    var u;
    return n.value ? (u = n.value) != null && u.audience ? e.includes(c) : e.includes(l) : !1;
  }, a = Q(
    () => r("USER_TICKET_USER_FIELD_LIST", "ADMIN_TICKET_USER_FIELD_LIST")
  ), o = Q(
    () => r(
      "USER_TICKET_USER_FIELD_WRITE_OWN",
      "ADMIN_TICKET_USER_FIELD_WRITE_OWN"
    )
  );
  return {
    firstCitizen: n,
    hasFirstCitizenReadPermission: a,
    hasFirstCitizenWritePermission: o
  };
}
const Vg = /{\s*[\w.]+\s*}/g, Hg = /{{\s*[\w.]+\s*}}/g, ao = /[\w.]+/;
function Wg(s, t) {
  const e = s.split(".");
  let i = t;
  for (const n of e)
    if (i = i[n], !i)
      return;
  return i;
}
function Gg(s, t) {
  const e = { mustache: "double", ...t }.mustache === "single" ? Vg : Hg, i = s.match(e) ?? [];
  return { replace: (n) => {
    let r = s;
    return i.forEach((a) => {
      var o;
      const l = (o = a == null ? void 0 : a.match(ao)) == null ? void 0 : o[0], c = l ? n[l] : void 0;
      c !== void 0 && (r = r.replace(a, c));
    }), r;
  }, replaceNested: (n) => {
    let r = s;
    return i.forEach((a) => {
      var o;
      const l = (o = a == null ? void 0 : a.match(ao)) == null ? void 0 : o[0], c = l ? Wg(l, n) : void 0;
      c !== void 0 && typeof c == "string" && (r = r.replace(a, c));
    }), r;
  } };
}
function Kg(s, t) {
  const e = Q(() => s.value.filter((r) => !r.groupKey)), i = Q(
    () => t.value.filter((r) => s.value.find((a) => a.groupKey === r.key))
  ), n = Q(() => i.value.length > 0);
  return { ungrouped: e, nonEmptyGroups: i, hasGroups: n, groupedItems: (r) => s.value.filter((a) => a.groupKey === r.key) };
}
function Ht(s, t = ["main"]) {
  const e = s.enabledProducts.map((r) => ({
    productId: r,
    productType: "main",
    customization: s.productCustomization[r]
  })).filter(
    (r) => t.includes(r.productType)
  ), i = Q(() => e), n = Q(() => e.map((r) => r.productId));
  return { productsData: i, productIds: n, _allProductIds: () => (console.log("[DEPRECATED] _allProductIds"), [
    ...n.value,
    "task",
    "feedback",
    "service_order",
    "campaign"
  ]) };
}
function Ge(s) {
  var t, e, i;
  const n = (t = s.product) == null ? void 0 : t.icons, r = (e = s.product) == null ? void 0 : e.resources, a = (i = s.product) == null ? void 0 : i.ticketCard;
  return n || console.error("workflow.product?.icons cannot be empty"), r || console.error("workflow.product?.resources cannot be empty"), a || console.error("workflow.product?.ticketCard cannot be empty"), { resources: r, icons: n, ticketCard: a };
}
function er(s, t) {
  var e, i;
  const n = (i = (e = s == null ? void 0 : s.site) == null ? void 0 : e[t]) == null ? void 0 : i.views;
  function r(a) {
    return n == null ? void 0 : n[a];
  }
  return { page: r };
}
function Ri(s, t) {
  const e = (r) => r.roles ? r.roles.some(
    (a) => {
      var o;
      return (o = t.userRoles) == null ? void 0 : o.includes(a);
    }
  ) : !0, i = (r) => r.actions ? r.actions.every(
    (a) => {
      var o;
      return (o = t.userActions) == null ? void 0 : o.includes(a);
    }
  ) : !0, n = (r) => !!(!r.actor || r.actor.includes("creator") && t.userId === t.creatorId || r.actor.includes("assignee") && t.userId === t.assigneeId);
  return {
    accessGranted: !s.length || s.some(
      (r) => e(r) && i(r) && n(r)
    ),
    checkActionAccess: i,
    checkActorAccess: n,
    checkRoleAccess: e
  };
}
function Hl(s, t, e) {
  const i = t.settings[e];
  if (!i) {
    console.warn(`Could not find ${e} '${s}'`);
    return;
  }
  return e === "phases" ? i.find(
    (n) => s === n.name
  ) : i == null ? void 0 : i[s];
}
function Y(s, t, e = "status") {
  const i = Hl(s, t, e);
  return i == null ? void 0 : i.resources;
}
function Ps(s, t, e = "status") {
  var i;
  const n = Hl(s, t, e);
  return ((i = n == null ? void 0 : n.settings) == null ? void 0 : i.colour) || void 0;
}
function Yg(s, t, e) {
  return {
    title: s,
    meta: Xg(t, e),
    delegate: Zg(t),
    assignee: Qg(t)
  };
}
function Xg(s, t) {
  const e = (t == null ? void 0 : t.meta) ?? {};
  return Object.values(s).filter((i) => i.ref.startsWith("meta.")).forEach((i) => {
    const n = i.ref.split(".")[1];
    e[n] = i.state.empty ? null : i.value;
  }), e;
}
function Zg(s) {
  return Object.values(s).filter((t) => t.ref.startsWith("ticket.delegate.") && t.value).map((t) => t.value) ?? [];
}
function Qg(s) {
  var t;
  return (t = s["ticket.assignee"]) == null ? void 0 : t.value;
}
function E(s) {
  const t = () => {
    const { firstName: a, lastName: o } = s.user;
    return a && o ? `${a} ${o}`.trim() : a ?? o ?? "";
  }, e = () => {
    const a = i();
    return a ? `https://teams.microsoft.com/l/chat/0/0?users=${a}` : void 0;
  }, i = () => s.user.email ? s.user.email : void 0, n = () => {
    var a;
    return ((a = s.team) == null ? void 0 : a.name) ?? s.user.departmentName;
  }, r = (a) => {
    const o = (l) => l.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/_/g, " ").split(" ").map(
      (c) => c.charAt(0).toUpperCase() + c.slice(1).toLowerCase()
    ).join(" ");
    return Object.entries(a).map(([l, c]) => ({
      label: o(l),
      value: c
    }));
  };
  return {
    displayName: t,
    microsoftTeamsLink: e,
    userDepartment: n,
    displayEmail: i,
    getPublicSettings: () => r(s.user.public ?? {}),
    getPrivateSettings: () => r(s.user.private ?? {})
  };
}
function Ot(s, t) {
  return {
    teamName: () => {
      var e, i;
      return !s.resources || !Object.keys(s.resources).length ? s.name : (e = t(s.resources)) != null && e.name ? (i = t(s.resources)) == null ? void 0 : i.name : s.name;
    },
    teamDescription: () => {
      var e, i;
      return !s.resources || !Object.keys(s.resources).length ? s.description : (e = t(s.resources)) != null && e.description ? (i = t(s.resources)) == null ? void 0 : i.description : s.description;
    }
  };
}
function Jg(s) {
  const t = s.settings.mailCoachingPhase ?? [], e = s.settings.disableTimeline ?? [], i = s.settings.creationStatus, n = s.settings.deleteStatus ?? [], r = Object.keys(s.settings.status).filter((a) => a !== i).filter((a) => !n.includes(a));
  return { mailCoachingPhase: t, disableTimeline: e, activeStatus: r };
}
function t_(s) {
  const t = st(""), e = Q(
    () => {
      var r, a;
      return (a = (r = s.settings) == null ? void 0 : r.status) == null ? void 0 : a[t.value];
    }
  ), i = Q(
    () => {
      var r;
      return ((r = s.transitions) == null ? void 0 : r.filter(
        (a) => a.transitionFrom === t.value
      )) ?? [];
    }
  ), n = Q(() => {
    var r, a;
    const o = (a = (r = e.value) == null ? void 0 : r.settings) == null ? void 0 : a.preferredNext;
    return i.value.find((l) => l.transitionTo === o);
  });
  return { fromStatus: t, available: i, preferred: n };
}
const e_ = [
  "length",
  "mass",
  "volume",
  "temperature",
  "currency"
], s_ = [
  "meter",
  "centimeter",
  "millimeter",
  "kilometer",
  "mile",
  "yard",
  "foot",
  "inch"
], i_ = [
  "kilogram",
  "gram",
  "milligram",
  "tonne",
  "ounce",
  "pound"
], n_ = [
  "cubic-meter",
  "liter",
  "milliliter",
  "us-fluid-ounce",
  "us-gallon",
  "us-pint"
], r_ = [
  "kelvin",
  "celsius",
  "fahrenheit",
  "rankine"
], a_ = [
  "us-dollar",
  "euro",
  "japanese-yen",
  "british-pound-sterling",
  "australian-dollar",
  "canadian-dollar",
  "swiss-franc",
  "chinese-yuan-renminbi",
  "hong-kong-dollar",
  "new-zealand-dollar",
  "swedish-krona",
  "south-korean-won",
  "singapore-dollar",
  "norwegian-krone",
  "mexican-peso",
  "indian-rupee",
  "russian-ruble",
  "south-african-rand",
  "brazilian-real",
  "turkish-lira"
], o_ = {
  length: s_,
  mass: i_,
  volume: n_,
  temperature: r_,
  currency: a_
}, l_ = {
  meter: {
    dimension: "length",
    system: "si",
    unit: "meter",
    symbol: "m",
    convert: {
      fromBase: (s) => s,
      toBase: (s) => s
    }
  },
  centimeter: {
    dimension: "length",
    system: "si",
    unit: "centimeter",
    symbol: "cm",
    convert: {
      fromBase: (s) => s * 100,
      toBase: (s) => s * 0.01
    }
  },
  millimeter: {
    dimension: "length",
    system: "si",
    unit: "millimeter",
    symbol: "mm",
    convert: {
      fromBase: (s) => s * 1e3,
      toBase: (s) => s * 1e-3
    }
  },
  kilometer: {
    dimension: "length",
    system: "si",
    unit: "kilometer",
    symbol: "km",
    convert: {
      fromBase: (s) => s * 1e-3,
      toBase: (s) => s * 1e3
    }
  },
  mile: {
    dimension: "length",
    system: "imperial",
    unit: "mile",
    symbol: "mi",
    convert: {
      fromBase: (s) => s * 6213712e-10,
      toBase: (s) => s * 1609.344
    }
  },
  yard: {
    dimension: "length",
    system: "imperial",
    unit: "yard",
    symbol: "yd",
    convert: {
      fromBase: (s) => s * 1.093613,
      toBase: (s) => s * 0.9144
    }
  },
  foot: {
    dimension: "length",
    system: "imperial",
    unit: "foot",
    symbol: "ft",
    convert: {
      fromBase: (s) => s * 3.28084,
      toBase: (s) => s * 0.3048
    }
  },
  inch: {
    dimension: "length",
    system: "imperial",
    unit: "inch",
    symbol: "in",
    convert: {
      fromBase: (s) => s * 39.37008,
      toBase: (s) => s * 0.0254
    }
  }
}, c_ = {
  kilogram: {
    dimension: "mass",
    system: "si",
    unit: "kilogram",
    symbol: "kg",
    convert: {
      fromBase: (s) => s,
      toBase: (s) => s
    }
  },
  gram: {
    dimension: "mass",
    system: "si",
    unit: "gram",
    symbol: "g",
    convert: {
      fromBase: (s) => s * 1e3,
      toBase: (s) => s * 1e-3
    }
  },
  milligram: {
    dimension: "mass",
    system: "si",
    unit: "milligram",
    symbol: "mg",
    convert: {
      fromBase: (s) => s * 1e6,
      toBase: (s) => s * 1e-6
    }
  },
  tonne: {
    dimension: "mass",
    system: "si",
    unit: "tonne",
    symbol: "t",
    convert: {
      fromBase: (s) => s * 1e-3,
      toBase: (s) => s * 1e3
    }
  },
  ounce: {
    dimension: "mass",
    system: "imperial",
    unit: "ounce",
    symbol: "oz",
    convert: {
      fromBase: (s) => s * 35.27396,
      toBase: (s) => s * 0.02834952
    }
  },
  pound: {
    dimension: "mass",
    system: "imperial",
    unit: "pound",
    symbol: "lb",
    convert: {
      fromBase: (s) => s * 2.204623,
      toBase: (s) => s * 0.4535924
    }
  }
}, u_ = {
  "cubic-meter": {
    dimension: "volume",
    system: "si",
    unit: "cubic-meter",
    symbol: "m³",
    convert: {
      fromBase: (s) => s,
      toBase: (s) => s
    }
  },
  liter: {
    dimension: "volume",
    system: "si",
    unit: "liter",
    symbol: "l",
    convert: {
      fromBase: (s) => s * 1e3,
      toBase: (s) => s * 1e-3
    }
  },
  milliliter: {
    dimension: "volume",
    system: "si",
    unit: "milliliter",
    symbol: "ml",
    convert: {
      fromBase: (s) => s * 1e6,
      toBase: (s) => s * 1e-6
    }
  },
  "us-fluid-ounce": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-fluid-ounce",
    symbol: "fl oz",
    convert: {
      fromBase: (s) => s * 33814.13,
      toBase: (s) => s * 2957344e-11
    }
  },
  "us-gallon": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-gallon",
    symbol: "gal",
    convert: {
      fromBase: (s) => s * 264.1729,
      toBase: (s) => s * 37854e-7
    }
  },
  "us-pint": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-pint",
    symbol: "pt",
    convert: {
      fromBase: (s) => s * 2113.376,
      toBase: (s) => s * 4731765e-10
    }
  }
}, d_ = {
  kelvin: {
    dimension: "temperature",
    system: void 0,
    unit: "kelvin",
    symbol: "K",
    convert: {
      fromBase: (s) => s,
      toBase: (s) => s
    }
  },
  celsius: {
    dimension: "temperature",
    system: "si",
    unit: "celsius",
    symbol: "°C",
    convert: {
      fromBase: (s) => s - 273.15,
      toBase: (s) => s + 273.15
    }
  },
  fahrenheit: {
    dimension: "temperature",
    system: "imperial",
    unit: "fahrenheit",
    symbol: "°F",
    convert: {
      fromBase: (s) => s * 9 / 5 - 459.67,
      toBase: (s) => 5 / 9 * (s + 459.67)
    }
  },
  rankine: {
    dimension: "temperature",
    system: void 0,
    unit: "rankine",
    symbol: "°R",
    convert: {
      fromBase: (s) => 9 / 5 * s,
      toBase: (s) => 5 / 9 * s
    }
  }
};
function p_(s) {
  switch (s) {
    case "length":
      return l_;
    case "mass":
      return c_;
    case "volume":
      return u_;
    case "temperature":
      return d_;
    default:
      throw new Error(`Unknown unit system '${s}'`);
  }
}
function h_(s, t, e) {
  const i = new Intl.NumberFormat(void 0, {
    style: "decimal",
    signDisplay: "auto",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(s.value);
  if (s.dimension === "currency")
    return `${t(`measure.unit.${s.unit}.symbol`)} ${i}`;
  const n = p_(s.dimension)[s.unit];
  return `${i} ${(n == null ? void 0 : n.symbol) ?? ""}`;
}
function Wl(s) {
  var t;
  const e = s.settings.phases ?? [], i = Object.entries((t = s.settings) == null ? void 0 : t.status);
  function n(a) {
    return i.filter((o) => o[1].phase === a).map((o) => o[0]);
  }
  const r = [];
  return e.forEach((a) => {
    const o = n(a.name);
    o.length && r.push({
      phase: a.name,
      status: o
    });
  }), r;
}
function f_() {
  function s(n, r, a) {
    return n === r ? !0 : Math.abs(n - r) < a;
  }
  function t(n) {
    return Math.floor(n * 1e4) / 1e4;
  }
  function e(n, r = 100) {
    let a = n.reduce(
      (u, d) => u + d.share,
      0
    ), o = r - a, l = n.filter((u) => u.share === 0);
    if (o < 0 || s(o, 0, 0.01) && l.length > 0)
      return n.forEach((u) => {
        u.share = 0;
      }), e(n, r);
    l.length === 0 && o > 0 && (l = n);
    const c = o / l.length;
    if (l.forEach((u) => {
      u.share += t(c);
    }), !i(n, r)) {
      const u = n.reduce((p, h) => p + h.share, 0), d = (r - u) / n.length;
      n.forEach((p) => {
        p.share = t(p.share - d);
      });
    }
    return n;
  }
  function i(n, r) {
    const a = n.reduce((l, c) => l + c.share, 0), o = n.every((l) => l.share > 0);
    return a <= r && s(a, r, 0.01) && o;
  }
  return {
    distributeShares: e,
    checkShareDivide: i
  };
}
const m_ = {
  type: "function",
  function: {
    name: "updateTicketField",
    description: "Updates one field of the current idea, returning which field key to update, which value and the reason why to update this field with this value",
    parameters: {
      type: "object",
      properties: {
        fieldKey: {
          type: "string",
          description: 'Json key to update, used in the full key format like "a.b.c"'
        },
        fieldValue: {
          type: "string",
          description: "Value to update the key with"
        },
        reason: {
          type: "string",
          description: 'Human readable explanation of this tool calling in the format: "Update {field} with {very short description of the value chosen and why}"'
        }
      },
      additionalProperties: !1,
      required: ["fieldKey", "fieldValue", "reason"]
    }
  },
  strict: !0
};
function g_(s, t, e) {
  if (!s || !t)
    return;
  const i = s.split(".");
  let n = t;
  for (let r = 0; r < i.length; r += 1) {
    const a = i[r];
    Object.hasOwn(n, a) || (n[a] = {}), r === i.length - 1 ? n[a] = e : n = n[a];
  }
}
const __ = (s, t) => {
  g_(s.fieldKey, t, s.fieldValue);
}, y_ = {
  type: "function",
  function: {
    name: "suggestTicketImprovement",
    description: "Given a ticket and a set of similar or duplicate idea in the system, suggest a way to improve the idea to make it more likely to be accepted.",
    parameters: {
      type: "object",
      properties: {
        reason: {
          type: "string",
          description: "The text of the improvements to be made to my ticket. This should be a human readable text that explains what to change and why."
        }
      },
      additionalProperties: !1,
      required: ["improvementText"]
    }
  },
  strict: !0
}, b_ = (s) => {
  navigator.clipboard.writeText(s.reason);
};
function Ci(s) {
  const t = { ...s.meta, title: s.title };
  return t.title = t.title ?? "", t;
}
const v_ = [
  "text",
  "textarea",
  "textareaMarkdown"
];
function Gl(s, t) {
  return s.externalFields.flatMap((e) => e.fields).filter((e) => v_.includes(e.type)).map((e) => Kl(e, t));
}
function Kl(s, t) {
  var e;
  return {
    key: s.ref,
    type: s.type,
    label: t(((e = s.options) == null ? void 0 : e.resources) ?? {}).label
  };
}
function k_(s, t, e, i, n) {
  const r = Yg(
    t.title,
    t.dynamicState
  ), a = {
    groupId: "title",
    groupLabel: "title",
    fields: [
      {
        ref: "title",
        type: "text",
        required: !0,
        options: {
          resources: {
            en: { label: "Title" },
            fr: { label: "Titre" },
            it: { label: "Titolo" },
            de: { label: "Titel" },
            az: { label: "Başlıq" }
          }
        }
      }
    ]
  };
  return {
    ticketSource: s,
    user: i,
    ticket: r,
    ticketJson: JSON.stringify(Ci(r)),
    fieldsJson: JSON.stringify(
      Gl(
        {
          ...e,
          externalFields: [a, ...e.externalFields]
        },
        n
      )
    )
  };
}
function x_(s, t, e) {
  return {
    user: e,
    ticketJson: JSON.stringify(Ci(s)),
    similarTicketsJson: JSON.stringify(t.map(Ci))
  };
}
const Yl = {
  updateTicketFieldDefinition: m_,
  suggestTicketImprovementDefinition: y_
}, C_ = {
  type: "object",
  properties: {
    answer: {
      type: "string"
    }
  },
  required: ["answer"],
  additionalProperties: !1
};
function w_(s) {
  return {
    id: s.id,
    name: E({ user: s }).displayName(),
    avatar: s.avatar,
    self: !0,
    ai: !1
  };
}
function Xl(s, t) {
  const e = s(t.resources);
  return {
    id: t.id,
    name: e.label,
    avatar: t.avatarUrl,
    self: !1,
    ai: !0
  };
}
function $_(s, t) {
  const e = s(t.messages);
  return {
    owner: Xl(s, t),
    text: e.message,
    suggestions: e.suggestedPrompts.map((i) => ({
      text: i.label
    })),
    template: "text",
    status: "ok",
    dateCreated: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function S_(s, t) {
  var i, n, r, a;
  let e = ((i = t.message) == null ? void 0 : i.answer) ?? "";
  e = e && `${e}
`, (n = t.tools) == null || n.forEach((o) => {
    e += `- ${o.arguments.reason}
`;
  }), s.text = e, s.meta = { tools: t.tools }, (r = t.tools) != null && r.some(({ name: o }) => o === "updateTicketField") ? s.template = "action" : (a = t.tools) != null && a.some(({ name: o }) => o === "suggestTicketImprovement") ? s.template = "copy" : s.template = "text";
}
function T_(s, t, e, i, n, r) {
  const a = (p) => {
    const h = n.getContext(p), m = t(e.messages).prePrompt, { replaceNested: _ } = Gg(m);
    return _(h);
  }, o = (p) => {
    const h = {
      role: "system",
      content: a(p.key)
    }, m = p.messages.map(
      (_) => ({
        role: _.owner.ai ? "assistant" : "user",
        content: _.text
      })
    );
    return [h, ...m];
  }, l = (p) => {
    const h = p.users.find((v) => v.self), m = p.users.find((v) => v.ai);
    return { sendMessage: async (v) => {
      const { pushMessage: k } = r;
      k(p.key, {
        owner: h,
        text: v,
        status: "ok",
        template: "text",
        dateCreated: (/* @__PURE__ */ new Date()).toISOString()
      });
      const w = o(p), x = e.functions.map((I) => I.type), C = Object.entries(Yl).filter((I) => x.includes(I[0])).map((I) => I[1]), $ = s.completePrompt(
        C_,
        w,
        C
      ), S = {
        owner: m,
        text: "",
        status: "loading",
        template: "text",
        dateCreated: (/* @__PURE__ */ new Date()).toISOString()
      };
      setTimeout(async () => {
        k(p.key, S);
        try {
          const I = await $;
          S_(S, I), S.status = "ok";
        } catch {
          S.status = "error";
        }
      }, 700);
    }, acceptAction: async (v, k) => {
      var C;
      const w = ((C = v.meta) == null ? void 0 : C.tools) ?? [], x = n.getContext(k);
      w.forEach(($) => {
        $.name === "updateTicketField" ? __(
          $.arguments,
          x.ticketSource
        ) : $.name === "suggestTicketImprovement" && b_(
          $.arguments
        );
      }), n.contextUpdated();
    } };
  };
  return { createSession: (p) => {
    const h = w_(i), m = Xl(t, e), _ = {
      key: p,
      title: t(e.resources).label,
      users: [h, m],
      messages: [$_(t, e)]
    }, y = r.createSession(_);
    return l(y);
  }, openSession: (p) => {
    const h = r.loadSession(p);
    return l(h);
  }, hasSession: (p) => r.hasSession(p) };
}
const I_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChatWindow: Pg,
  aiAgentTools: Yl,
  createSimilarTicketImprovementContext: x_,
  createTicketEditContext: k_,
  dynamicField: Kl,
  dynamicFieldSummary: Gl,
  ticketCleanup: Ci,
  useAiChatProvider: T_
}, Symbol.toStringTag, { value: "Module" })), A_ = g({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    user: {
      type: Object,
      required: !0
    }
  },
  computed: {
    icon() {
      var s;
      return ((s = this.ticket.meta) == null ? void 0 : s.feedbackIcon) ?? "/img/review-icon.svg";
    },
    title() {
      return this.ticket.title;
    },
    subtitle() {
      return this.$t("common.byName", {
        name: E({ user: this.user }).displayName()
      }).toString();
    }
  }
});
var P_ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "feedback-activity-card" }, [e("app-icon", { staticClass: "feedback-icon", attrs: { size: 33, src: t.icon, frame: "square" } }), e("div", { staticClass: "content" }, [e("div", { staticClass: "feedback-title" }, [t._v(t._s(t.title))]), e("div", { staticClass: "feedback-creator" }, [t._v(t._s(t.subtitle))])])], 1);
}, O_ = [], M_ = /* @__PURE__ */ f(
  A_,
  P_,
  O_,
  !1,
  null,
  "7ae78c79"
);
const Zl = M_.exports, R_ = g({
  props: {
    tickets: {
      type: Array,
      required: !0
    },
    editMode: {
      type: Boolean,
      default: !1
    },
    productId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      showFeedbackResultModal: !1,
      feedbackTickets: [],
      selectedTicketId: ""
    };
  },
  watch: {
    tickets: {
      async handler() {
        this.getFeedbackTickets();
      },
      immediate: !0
    }
  },
  methods: {
    allowEdit(s) {
      return this.editMode && s.group !== "first_citizen";
    },
    async onButtonClick(s) {
      const t = this.tickets.find((n) => n.canonicalId === s);
      if (!t)
        return;
      if (!await this.$gateway.feedback.isFeedbackAllowed(
        t,
        this.currentUser.id
      )) {
        this.onViewResult({ ticketId: s });
        return;
      }
      const e = t.meta.feedbackDialogue, i = this.$res(e);
      this.$modal(t.meta["feedback-type"], i), this.$route.query.reload !== "false" && this.$router.replace({ query: { reload: "false" } });
    },
    onEditTicket({ ticketId: s }) {
      this.$emit("edit:feedback", s);
    },
    onDeleteTicket({ ticketId: s }) {
      this.$emit("delete:feedback", s);
    },
    onViewResult({ ticketId: s }) {
      this.showFeedbackResultModal = !0, this.selectedTicketId = s;
    },
    async getFeedbackTickets() {
      this.feedbackTickets = await Promise.all(
        this.tickets.map(async (s) => (s.allowFeedback = await this.$gateway.feedback.isFeedbackAllowed(
          s,
          this.currentUser.id
        ), s))
      );
    }
  }
});
var E_ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "feedback-list" }, [t._l(t.feedbackTickets, function(i) {
    return e("feedback-ticket", { key: i.canonicalId, attrs: { "edit-mode": t.allowEdit(i), ticket: i, "user-id": t.currentUser.id }, on: { "click:button": t.onButtonClick, "click:edit-ticket": t.onEditTicket, "click:delete-ticket": t.onDeleteTicket, "click:view-result": t.onViewResult } });
  }), t.showFeedbackResultModal ? e("feedback-result-modal", { attrs: { "product-id": t.productId, "ticket-id": t.selectedTicketId, "current-user": t.currentUser }, on: { close: function(i) {
    t.showFeedbackResultModal = !1;
  } } }) : t._e()], 2);
}, D_ = [], F_ = /* @__PURE__ */ f(
  R_,
  E_,
  D_,
  !1,
  null,
  "a6a5015a"
);
const L_ = F_.exports, q_ = g({
  props: {
    parentTicketId: {
      type: String,
      required: !0
    },
    tickets: {
      type: Array,
      required: !0
    },
    defaultTickets: {
      type: Array,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    allowCreation: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      ticketList: this.tickets,
      showChoiceFeedbackModal: !1,
      showFeedbackFormModal: !1,
      selectedTicketId: "",
      selectedTicketType: "",
      showDeleteFeedbackModal: !1,
      deleteInProgress: !1
    };
  },
  methods: {
    choiceFeedbackType() {
      this.showChoiceFeedbackModal = !0;
    },
    editFeedbackTicket(s) {
      this.selectedTicketId = s, this.showFeedbackFormModal = !0;
    },
    newFeedbackTicket(s) {
      this.showChoiceFeedbackModal = !1, this.selectedTicketId = "", this.selectedTicketType = s, this.showFeedbackFormModal = !0;
    },
    markForDeletion(s) {
      this.selectedTicketId = s, this.showDeleteFeedbackModal = !0;
    },
    saveFeedbackTicket(s) {
      this.selectedTicketId ? this.ticketList = this.ticketList.map(
        (t) => t.canonicalId === this.selectedTicketId ? s : t
      ) : this.ticketList = [...this.ticketList, s], this.$emit("refresh"), this.closeFeedbackFormModal();
    },
    closeChoiceFeedbackModal() {
      this.selectedTicketId = "", this.selectedTicketType = "", this.showChoiceFeedbackModal = !1;
    },
    closeFeedbackFormModal() {
      this.selectedTicketId = "", this.selectedTicketType = "", this.showFeedbackFormModal = !1;
    },
    removeFeedbackTicket() {
      try {
        this.deleteInProgress = !0, this.$datasource.ticket.updateStatus(
          this.productId,
          this.selectedTicketId,
          "ARCHIVED"
        ), this.ticketList = this.ticketList.filter(
          (s) => s.canonicalId !== this.selectedTicketId
        );
      } catch (s) {
        s.message ? this.$toast(s.message) : this.$toast(this.$t("error.general").toString());
      } finally {
        this.deleteInProgress = !1, this.showDeleteFeedbackModal = !1, this.selectedTicketId = "";
      }
      this.$emit("refresh");
    }
  }
});
var U_ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "feedback-manager-container" }, [t.label ? e("div", { staticClass: "container-label" }, [t._v(" " + t._s(t.label) + " ")]) : t._e(), e("feedback-list", { staticClass: "feedback-list", attrs: { "current-user": t.currentUser, "edit-mode": !0, organization: t.organization, "product-id": t.productId, tickets: t.ticketList, "user-id": t.currentUser.id }, on: { "edit:feedback": t.editFeedbackTicket, "delete:feedback": t.markForDeletion } }), t.showDeleteFeedbackModal ? e("app-modal-confirmation", { attrs: { description: t.$t("form.feedback.remove.title"), loading: t.deleteInProgress, "primary-label": t.$t("common.form.confirm"), "secondary-label": t.$t("common.form.cancel"), title: t.$t("form.feedback.remove.description") }, on: { "click-primary": t.removeFeedbackTicket, "click-secondary": function(i) {
    t.showDeleteFeedbackModal = !1;
  } } }) : t._e(), t.showChoiceFeedbackModal ? e("feedback-selection-modal", { attrs: { "default-tickets": t.defaultTickets, "ticket-id": t.parentTicketId }, on: { addFeedback: t.newFeedbackTicket, close: t.closeChoiceFeedbackModal } }) : t._e(), t.showFeedbackFormModal ? e("feedback-form-modal", { attrs: { "current-user": t.currentUser, organization: t.organization, "parent-ticket-id": t.parentTicketId, "product-id": t.productId, "ticket-id": t.selectedTicketId, "ticket-type": t.selectedTicketType }, on: { close: t.closeFeedbackFormModal, saveFeedback: t.saveFeedbackTicket } }) : t._e(), t.allowCreation ? e("add-button", { staticClass: "add-button", attrs: { text: t.$t("form.feedback.requestFeedback") }, on: { click: t.choiceFeedbackType } }) : t._e()], 1);
}, N_ = [], B_ = /* @__PURE__ */ f(
  q_,
  U_,
  N_,
  !1,
  null,
  "2c5dbc8f"
);
const j_ = B_.exports, z_ = g({
  name: "FeedbackSelectionModal",
  props: {
    parentTicketId: {
      type: String,
      required: !0
    },
    ticketId: {
      type: String,
      required: !1
    },
    ticketType: {
      type: String,
      required: !1
    },
    organization: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      ticket: {},
      type: "",
      form: {
        title: "",
        text: "",
        delegate: []
      },
      error: {
        title: !1,
        text: !1,
        delegate: !1
      },
      teamConfiguration: {
        class: "team",
        types: ["VIRTUAL_TEAM"],
        operations: ["create", "select"]
      }
    };
  },
  async created() {
    var s, t;
    this.loading = !0, this.ticketId && (this.ticket = await this.loadTicket(this.ticketId), this.prefillForm()), this.type = ((t = (s = this.ticket) == null ? void 0 : s.meta) == null ? void 0 : t["feedback-type"]) || this.ticketType, this.loading = !1;
  },
  computed: {
    formTitle() {
      const s = this.$t(`form.feedback.${this.type}.title`);
      return this.$t("form.feedback.formFields.title", { type: s }).toString();
    },
    teamIds() {
      return this.form.delegate.map((s) => s.id);
    }
  },
  methods: {
    async loadTicket(s) {
      return this.$gateway.feedback.loadFeedbackTicketById(
        this.productId,
        s
      );
    },
    prefillForm() {
      this.form = {
        title: this.ticket.title,
        text: this.ticket.meta.text,
        delegate: this.ticket.delegate
      };
    },
    validateForm() {
      return this.error = {
        title: !this.form.title.length,
        text: !this.form.text.length,
        delegate: !this.form.delegate.length
      }, !Object.values(this.error).some((s) => s);
    },
    setDelegate(s) {
      this.form.delegate = s.map((t) => ({
        context: "",
        domain: "team",
        id: t
      }));
    },
    async saveFeedbackTicket() {
      if (!this.validateForm())
        return;
      this.loading = !0;
      const s = {
        ...this.form,
        type: this.type,
        product: this.productId,
        parentTicketId: this.parentTicketId,
        // TODO: Remove this and find a better way to work with multiple languages
        languages: this.organization.language.available
      }, t = await this.$gateway.feedback.saveFeedbackTicket(
        s,
        this.ticketId
      );
      this.$emit("saveFeedback", t);
    },
    onClose() {
      this.$emit("close");
    }
  }
});
var V_ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [t.loading ? t._e() : e("div", { staticClass: "modal-content" }, [e("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: t.onClose } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), e("h2", { staticClass: "modal-title" }, [t._v(" " + t._s(t.formTitle) + " ")]), e("app-form", { staticClass: "feedback-form", attrs: { form: t.form } }, [e("app-text-input", { attrs: { error: t.error.title, label: t.$t("form.feedback.formFields.titleLabel"), placeholder: t.$t("form.feedback.formFields.titlePlaceholder"), tooltip: t.$t("form.feedback.formFields.titleHelpText"), required: "" }, model: { value: t.form.title, callback: function(i) {
    t.$set(t.form, "title", i);
  }, expression: "form.title" } }), e("app-text-area", { attrs: { error: t.error.text, label: t.$t("form.feedback.formFields.descriptionLabel"), placeholder: t.$t("form.feedback.formFields.descriptionPlaceholder"), tooltip: t.$t("form.feedback.formFields.descriptionHelpText"), required: "" }, model: { value: t.form.text, callback: function(i) {
    t.$set(t.form, "text", i);
  }, expression: "form.text" } }), e("team-selector", { attrs: { label: t.$t("form.selectTeam.label"), placeholder: t.$t("form.selectTeam.placeholder"), configuration: t.teamConfiguration, organization: t.organization, error: t.error.delegate, "initial-team-ids": t.teamIds, multiselect: !0, required: !0, "user-id": t.currentUser.id }, on: { input: t.setDelegate } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { label: t.$t("common.form.save") }, on: { click: t.saveFeedbackTicket } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onClose } })], 1)], 1)], 1)]);
}, H_ = [], W_ = /* @__PURE__ */ f(
  z_,
  V_,
  H_,
  !1,
  null,
  "cec7df6f"
);
const G_ = W_.exports;
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */
const {
  entries: Ql,
  setPrototypeOf: oo,
  isFrozen: K_,
  getPrototypeOf: Y_,
  getOwnPropertyDescriptor: X_
} = Object;
let {
  freeze: bt,
  seal: Mt,
  create: Jl
} = Object, {
  apply: Pn,
  construct: On
} = typeof Reflect < "u" && Reflect;
bt || (bt = function(t) {
  return t;
});
Mt || (Mt = function(t) {
  return t;
});
Pn || (Pn = function(t, e, i) {
  return t.apply(e, i);
});
On || (On = function(t, e) {
  return new t(...e);
});
const ei = vt(Array.prototype.forEach), Z_ = vt(Array.prototype.lastIndexOf), lo = vt(Array.prototype.pop), ss = vt(Array.prototype.push), Q_ = vt(Array.prototype.splice), hi = vt(String.prototype.toLowerCase), on = vt(String.prototype.toString), co = vt(String.prototype.match), is = vt(String.prototype.replace), J_ = vt(String.prototype.indexOf), ty = vt(String.prototype.trim), Dt = vt(Object.prototype.hasOwnProperty), yt = vt(RegExp.prototype.test), ns = ey(TypeError);
function vt(s) {
  return function(t) {
    for (var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
      i[n - 1] = arguments[n];
    return Pn(s, t, i);
  };
}
function ey(s) {
  return function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return On(s, e);
  };
}
function q(s, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : hi;
  oo && oo(s, null);
  let i = t.length;
  for (; i--; ) {
    let n = t[i];
    if (typeof n == "string") {
      const r = e(n);
      r !== n && (K_(t) || (t[i] = r), n = r);
    }
    s[n] = !0;
  }
  return s;
}
function sy(s) {
  for (let t = 0; t < s.length; t++)
    Dt(s, t) || (s[t] = null);
  return s;
}
function xe(s) {
  const t = Jl(null);
  for (const [e, i] of Ql(s))
    Dt(s, e) && (Array.isArray(i) ? t[e] = sy(i) : i && typeof i == "object" && i.constructor === Object ? t[e] = xe(i) : t[e] = i);
  return t;
}
function rs(s, t) {
  for (; s !== null; ) {
    const i = X_(s, t);
    if (i) {
      if (i.get)
        return vt(i.get);
      if (typeof i.value == "function")
        return vt(i.value);
    }
    s = Y_(s);
  }
  function e() {
    return null;
  }
  return e;
}
const uo = bt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), ln = bt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), cn = bt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), iy = bt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), un = bt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), ny = bt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), po = bt(["#text"]), ho = bt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), dn = bt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), fo = bt(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), si = bt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), ry = Mt(/\{\{[\w\W]*|[\w\W]*\}\}/gm), ay = Mt(/<%[\w\W]*|[\w\W]*%>/gm), oy = Mt(/\$\{[\w\W]*/gm), ly = Mt(/^data-[\-\w.\u00B7-\uFFFF]+$/), cy = Mt(/^aria-[\-\w]+$/), tc = Mt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), uy = Mt(/^(?:\w+script|data):/i), dy = Mt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), ec = Mt(/^html$/i), py = Mt(/^[a-z][.\w]*(-[.\w]+)+$/i);
var mo = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: cy,
  ATTR_WHITESPACE: dy,
  CUSTOM_ELEMENT: py,
  DATA_ATTR: ly,
  DOCTYPE_NAME: ec,
  ERB_EXPR: ay,
  IS_ALLOWED_URI: tc,
  IS_SCRIPT_OR_DATA: uy,
  MUSTACHE_EXPR: ry,
  TMPLIT_EXPR: oy
});
const as = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, hy = function() {
  return typeof window > "u" ? null : window;
}, fy = function(t, e) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let i = null;
  const n = "data-tt-policy-suffix";
  e && e.hasAttribute(n) && (i = e.getAttribute(n));
  const r = "dompurify" + (i ? "#" + i : "");
  try {
    return t.createPolicy(r, {
      createHTML(a) {
        return a;
      },
      createScriptURL(a) {
        return a;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + r + " could not be created."), null;
  }
}, go = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function sc() {
  let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : hy();
  const t = (M) => sc(M);
  if (t.version = "3.2.4", t.removed = [], !s || !s.document || s.document.nodeType !== as.document || !s.Element)
    return t.isSupported = !1, t;
  let {
    document: e
  } = s;
  const i = e, n = i.currentScript, {
    DocumentFragment: r,
    HTMLTemplateElement: a,
    Node: o,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: u = s.NamedNodeMap || s.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: p,
    trustedTypes: h
  } = s, m = l.prototype, _ = rs(m, "cloneNode"), y = rs(m, "remove"), v = rs(m, "nextSibling"), k = rs(m, "childNodes"), w = rs(m, "parentNode");
  if (typeof a == "function") {
    const M = e.createElement("template");
    M.content && M.content.ownerDocument && (e = M.content.ownerDocument);
  }
  let x, C = "";
  const {
    implementation: $,
    createNodeIterator: S,
    createDocumentFragment: I,
    getElementsByTagName: R
  } = e, {
    importNode: F
  } = i;
  let O = go();
  t.isSupported = typeof Ql == "function" && typeof w == "function" && $ && $.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: L,
    ERB_EXPR: rt,
    TMPLIT_EXPR: dt,
    DATA_ATTR: B,
    ARIA_ATTR: V,
    IS_SCRIPT_OR_DATA: J,
    ATTR_WHITESPACE: xt,
    CUSTOM_ELEMENT: lt
  } = mo;
  let {
    IS_ALLOWED_URI: Wt
  } = mo, tt = null;
  const Gt = q({}, [...uo, ...ln, ...cn, ...un, ...po]);
  let et = null;
  const qt = q({}, [...ho, ...dn, ...fo, ...si]);
  let z = Object.seal(Jl(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), St = null, Fi = null, gr = !0, Li = !0, _r = !1, yr = !0, Re = !1, qi = !0, fe = !1, Ui = !1, Ni = !1, Ee = !1, Es = !1, Ds = !1, br = !0, vr = !1;
  const su = "user-content-";
  let Bi = !0, Ke = !1, De = {}, Fe = null;
  const kr = q({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let xr = null;
  const Cr = q({}, ["audio", "video", "img", "source", "image", "track"]);
  let ji = null;
  const wr = q({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Fs = "http://www.w3.org/1998/Math/MathML", Ls = "http://www.w3.org/2000/svg", Kt = "http://www.w3.org/1999/xhtml";
  let Le = Kt, zi = !1, Vi = null;
  const iu = q({}, [Fs, Ls, Kt], on);
  let qs = q({}, ["mi", "mo", "mn", "ms", "mtext"]), Us = q({}, ["annotation-xml"]);
  const nu = q({}, ["title", "style", "font", "a", "script"]);
  let Ye = null;
  const ru = ["application/xhtml+xml", "text/html"], au = "text/html";
  let ct = null, qe = null;
  const ou = e.createElement("form"), $r = function(b) {
    return b instanceof RegExp || b instanceof Function;
  }, Hi = function() {
    let b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(qe && qe === b)) {
      if ((!b || typeof b != "object") && (b = {}), b = xe(b), Ye = // eslint-disable-next-line unicorn/prefer-includes
      ru.indexOf(b.PARSER_MEDIA_TYPE) === -1 ? au : b.PARSER_MEDIA_TYPE, ct = Ye === "application/xhtml+xml" ? on : hi, tt = Dt(b, "ALLOWED_TAGS") ? q({}, b.ALLOWED_TAGS, ct) : Gt, et = Dt(b, "ALLOWED_ATTR") ? q({}, b.ALLOWED_ATTR, ct) : qt, Vi = Dt(b, "ALLOWED_NAMESPACES") ? q({}, b.ALLOWED_NAMESPACES, on) : iu, ji = Dt(b, "ADD_URI_SAFE_ATTR") ? q(xe(wr), b.ADD_URI_SAFE_ATTR, ct) : wr, xr = Dt(b, "ADD_DATA_URI_TAGS") ? q(xe(Cr), b.ADD_DATA_URI_TAGS, ct) : Cr, Fe = Dt(b, "FORBID_CONTENTS") ? q({}, b.FORBID_CONTENTS, ct) : kr, St = Dt(b, "FORBID_TAGS") ? q({}, b.FORBID_TAGS, ct) : {}, Fi = Dt(b, "FORBID_ATTR") ? q({}, b.FORBID_ATTR, ct) : {}, De = Dt(b, "USE_PROFILES") ? b.USE_PROFILES : !1, gr = b.ALLOW_ARIA_ATTR !== !1, Li = b.ALLOW_DATA_ATTR !== !1, _r = b.ALLOW_UNKNOWN_PROTOCOLS || !1, yr = b.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Re = b.SAFE_FOR_TEMPLATES || !1, qi = b.SAFE_FOR_XML !== !1, fe = b.WHOLE_DOCUMENT || !1, Ee = b.RETURN_DOM || !1, Es = b.RETURN_DOM_FRAGMENT || !1, Ds = b.RETURN_TRUSTED_TYPE || !1, Ni = b.FORCE_BODY || !1, br = b.SANITIZE_DOM !== !1, vr = b.SANITIZE_NAMED_PROPS || !1, Bi = b.KEEP_CONTENT !== !1, Ke = b.IN_PLACE || !1, Wt = b.ALLOWED_URI_REGEXP || tc, Le = b.NAMESPACE || Kt, qs = b.MATHML_TEXT_INTEGRATION_POINTS || qs, Us = b.HTML_INTEGRATION_POINTS || Us, z = b.CUSTOM_ELEMENT_HANDLING || {}, b.CUSTOM_ELEMENT_HANDLING && $r(b.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (z.tagNameCheck = b.CUSTOM_ELEMENT_HANDLING.tagNameCheck), b.CUSTOM_ELEMENT_HANDLING && $r(b.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (z.attributeNameCheck = b.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), b.CUSTOM_ELEMENT_HANDLING && typeof b.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (z.allowCustomizedBuiltInElements = b.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Re && (Li = !1), Es && (Ee = !0), De && (tt = q({}, po), et = [], De.html === !0 && (q(tt, uo), q(et, ho)), De.svg === !0 && (q(tt, ln), q(et, dn), q(et, si)), De.svgFilters === !0 && (q(tt, cn), q(et, dn), q(et, si)), De.mathMl === !0 && (q(tt, un), q(et, fo), q(et, si))), b.ADD_TAGS && (tt === Gt && (tt = xe(tt)), q(tt, b.ADD_TAGS, ct)), b.ADD_ATTR && (et === qt && (et = xe(et)), q(et, b.ADD_ATTR, ct)), b.ADD_URI_SAFE_ATTR && q(ji, b.ADD_URI_SAFE_ATTR, ct), b.FORBID_CONTENTS && (Fe === kr && (Fe = xe(Fe)), q(Fe, b.FORBID_CONTENTS, ct)), Bi && (tt["#text"] = !0), fe && q(tt, ["html", "head", "body"]), tt.table && (q(tt, ["tbody"]), delete St.tbody), b.TRUSTED_TYPES_POLICY) {
        if (typeof b.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw ns('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof b.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw ns('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        x = b.TRUSTED_TYPES_POLICY, C = x.createHTML("");
      } else
        x === void 0 && (x = fy(h, n)), x !== null && typeof C == "string" && (C = x.createHTML(""));
      bt && bt(b), qe = b;
    }
  }, Sr = q({}, [...ln, ...cn, ...iy]), Tr = q({}, [...un, ...ny]), lu = function(b) {
    let T = w(b);
    (!T || !T.tagName) && (T = {
      namespaceURI: Le,
      tagName: "template"
    });
    const P = hi(b.tagName), X = hi(T.tagName);
    return Vi[b.namespaceURI] ? b.namespaceURI === Ls ? T.namespaceURI === Kt ? P === "svg" : T.namespaceURI === Fs ? P === "svg" && (X === "annotation-xml" || qs[X]) : !!Sr[P] : b.namespaceURI === Fs ? T.namespaceURI === Kt ? P === "math" : T.namespaceURI === Ls ? P === "math" && Us[X] : !!Tr[P] : b.namespaceURI === Kt ? T.namespaceURI === Ls && !Us[X] || T.namespaceURI === Fs && !qs[X] ? !1 : !Tr[P] && (nu[P] || !Sr[P]) : !!(Ye === "application/xhtml+xml" && Vi[b.namespaceURI]) : !1;
  }, Ut = function(b) {
    ss(t.removed, {
      element: b
    });
    try {
      w(b).removeChild(b);
    } catch {
      y(b);
    }
  }, Ns = function(b, T) {
    try {
      ss(t.removed, {
        attribute: T.getAttributeNode(b),
        from: T
      });
    } catch {
      ss(t.removed, {
        attribute: null,
        from: T
      });
    }
    if (T.removeAttribute(b), b === "is")
      if (Ee || Es)
        try {
          Ut(T);
        } catch {
        }
      else
        try {
          T.setAttribute(b, "");
        } catch {
        }
  }, Ir = function(b) {
    let T = null, P = null;
    if (Ni)
      b = "<remove></remove>" + b;
    else {
      const pt = co(b, /^[\r\n\t ]+/);
      P = pt && pt[0];
    }
    Ye === "application/xhtml+xml" && Le === Kt && (b = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + b + "</body></html>");
    const X = x ? x.createHTML(b) : b;
    if (Le === Kt)
      try {
        T = new p().parseFromString(X, Ye);
      } catch {
      }
    if (!T || !T.documentElement) {
      T = $.createDocument(Le, "template", null);
      try {
        T.documentElement.innerHTML = zi ? C : X;
      } catch {
      }
    }
    const ht = T.body || T.documentElement;
    return b && P && ht.insertBefore(e.createTextNode(P), ht.childNodes[0] || null), Le === Kt ? R.call(T, fe ? "html" : "body")[0] : fe ? T.documentElement : ht;
  }, Ar = function(b) {
    return S.call(
      b.ownerDocument || b,
      b,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, Wi = function(b) {
    return b instanceof d && (typeof b.nodeName != "string" || typeof b.textContent != "string" || typeof b.removeChild != "function" || !(b.attributes instanceof u) || typeof b.removeAttribute != "function" || typeof b.setAttribute != "function" || typeof b.namespaceURI != "string" || typeof b.insertBefore != "function" || typeof b.hasChildNodes != "function");
  }, Pr = function(b) {
    return typeof o == "function" && b instanceof o;
  };
  function Yt(M, b, T) {
    ei(M, (P) => {
      P.call(t, b, T, qe);
    });
  }
  const Or = function(b) {
    let T = null;
    if (Yt(O.beforeSanitizeElements, b, null), Wi(b))
      return Ut(b), !0;
    const P = ct(b.nodeName);
    if (Yt(O.uponSanitizeElement, b, {
      tagName: P,
      allowedTags: tt
    }), b.hasChildNodes() && !Pr(b.firstElementChild) && yt(/<[/\w]/g, b.innerHTML) && yt(/<[/\w]/g, b.textContent) || b.nodeType === as.progressingInstruction || qi && b.nodeType === as.comment && yt(/<[/\w]/g, b.data))
      return Ut(b), !0;
    if (!tt[P] || St[P]) {
      if (!St[P] && Rr(P) && (z.tagNameCheck instanceof RegExp && yt(z.tagNameCheck, P) || z.tagNameCheck instanceof Function && z.tagNameCheck(P)))
        return !1;
      if (Bi && !Fe[P]) {
        const X = w(b) || b.parentNode, ht = k(b) || b.childNodes;
        if (ht && X) {
          const pt = ht.length;
          for (let Ct = pt - 1; Ct >= 0; --Ct) {
            const Nt = _(ht[Ct], !0);
            Nt.__removalCount = (b.__removalCount || 0) + 1, X.insertBefore(Nt, v(b));
          }
        }
      }
      return Ut(b), !0;
    }
    return b instanceof l && !lu(b) || (P === "noscript" || P === "noembed" || P === "noframes") && yt(/<\/no(script|embed|frames)/i, b.innerHTML) ? (Ut(b), !0) : (Re && b.nodeType === as.text && (T = b.textContent, ei([L, rt, dt], (X) => {
      T = is(T, X, " ");
    }), b.textContent !== T && (ss(t.removed, {
      element: b.cloneNode()
    }), b.textContent = T)), Yt(O.afterSanitizeElements, b, null), !1);
  }, Mr = function(b, T, P) {
    if (br && (T === "id" || T === "name") && (P in e || P in ou))
      return !1;
    if (!(Li && !Fi[T] && yt(B, T))) {
      if (!(gr && yt(V, T))) {
        if (!et[T] || Fi[T]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Rr(b) && (z.tagNameCheck instanceof RegExp && yt(z.tagNameCheck, b) || z.tagNameCheck instanceof Function && z.tagNameCheck(b)) && (z.attributeNameCheck instanceof RegExp && yt(z.attributeNameCheck, T) || z.attributeNameCheck instanceof Function && z.attributeNameCheck(T)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            T === "is" && z.allowCustomizedBuiltInElements && (z.tagNameCheck instanceof RegExp && yt(z.tagNameCheck, P) || z.tagNameCheck instanceof Function && z.tagNameCheck(P)))
          ) return !1;
        } else if (!ji[T]) {
          if (!yt(Wt, is(P, xt, ""))) {
            if (!((T === "src" || T === "xlink:href" || T === "href") && b !== "script" && J_(P, "data:") === 0 && xr[b])) {
              if (!(_r && !yt(J, is(P, xt, "")))) {
                if (P)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Rr = function(b) {
    return b !== "annotation-xml" && co(b, lt);
  }, Er = function(b) {
    Yt(O.beforeSanitizeAttributes, b, null);
    const {
      attributes: T
    } = b;
    if (!T || Wi(b))
      return;
    const P = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: et,
      forceKeepAttr: void 0
    };
    let X = T.length;
    for (; X--; ) {
      const ht = T[X], {
        name: pt,
        namespaceURI: Ct,
        value: Nt
      } = ht, Xe = ct(pt);
      let _t = pt === "value" ? Nt : ty(Nt);
      if (P.attrName = Xe, P.attrValue = _t, P.keepAttr = !0, P.forceKeepAttr = void 0, Yt(O.uponSanitizeAttribute, b, P), _t = P.attrValue, vr && (Xe === "id" || Xe === "name") && (Ns(pt, b), _t = su + _t), qi && yt(/((--!?|])>)|<\/(style|title)/i, _t)) {
        Ns(pt, b);
        continue;
      }
      if (P.forceKeepAttr || (Ns(pt, b), !P.keepAttr))
        continue;
      if (!yr && yt(/\/>/i, _t)) {
        Ns(pt, b);
        continue;
      }
      Re && ei([L, rt, dt], (Fr) => {
        _t = is(_t, Fr, " ");
      });
      const Dr = ct(b.nodeName);
      if (Mr(Dr, Xe, _t)) {
        if (x && typeof h == "object" && typeof h.getAttributeType == "function" && !Ct)
          switch (h.getAttributeType(Dr, Xe)) {
            case "TrustedHTML": {
              _t = x.createHTML(_t);
              break;
            }
            case "TrustedScriptURL": {
              _t = x.createScriptURL(_t);
              break;
            }
          }
        try {
          Ct ? b.setAttributeNS(Ct, pt, _t) : b.setAttribute(pt, _t), Wi(b) ? Ut(b) : lo(t.removed);
        } catch {
        }
      }
    }
    Yt(O.afterSanitizeAttributes, b, null);
  }, cu = function M(b) {
    let T = null;
    const P = Ar(b);
    for (Yt(O.beforeSanitizeShadowDOM, b, null); T = P.nextNode(); )
      Yt(O.uponSanitizeShadowNode, T, null), Or(T), Er(T), T.content instanceof r && M(T.content);
    Yt(O.afterSanitizeShadowDOM, b, null);
  };
  return t.sanitize = function(M) {
    let b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, T = null, P = null, X = null, ht = null;
    if (zi = !M, zi && (M = "<!-->"), typeof M != "string" && !Pr(M))
      if (typeof M.toString == "function") {
        if (M = M.toString(), typeof M != "string")
          throw ns("dirty is not a string, aborting");
      } else
        throw ns("toString is not a function");
    if (!t.isSupported)
      return M;
    if (Ui || Hi(b), t.removed = [], typeof M == "string" && (Ke = !1), Ke) {
      if (M.nodeName) {
        const Nt = ct(M.nodeName);
        if (!tt[Nt] || St[Nt])
          throw ns("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (M instanceof o)
      T = Ir("<!---->"), P = T.ownerDocument.importNode(M, !0), P.nodeType === as.element && P.nodeName === "BODY" || P.nodeName === "HTML" ? T = P : T.appendChild(P);
    else {
      if (!Ee && !Re && !fe && // eslint-disable-next-line unicorn/prefer-includes
      M.indexOf("<") === -1)
        return x && Ds ? x.createHTML(M) : M;
      if (T = Ir(M), !T)
        return Ee ? null : Ds ? C : "";
    }
    T && Ni && Ut(T.firstChild);
    const pt = Ar(Ke ? M : T);
    for (; X = pt.nextNode(); )
      Or(X), Er(X), X.content instanceof r && cu(X.content);
    if (Ke)
      return M;
    if (Ee) {
      if (Es)
        for (ht = I.call(T.ownerDocument); T.firstChild; )
          ht.appendChild(T.firstChild);
      else
        ht = T;
      return (et.shadowroot || et.shadowrootmode) && (ht = F.call(i, ht, !0)), ht;
    }
    let Ct = fe ? T.outerHTML : T.innerHTML;
    return fe && tt["!doctype"] && T.ownerDocument && T.ownerDocument.doctype && T.ownerDocument.doctype.name && yt(ec, T.ownerDocument.doctype.name) && (Ct = "<!DOCTYPE " + T.ownerDocument.doctype.name + `>
` + Ct), Re && ei([L, rt, dt], (Nt) => {
      Ct = is(Ct, Nt, " ");
    }), x && Ds ? x.createHTML(Ct) : Ct;
  }, t.setConfig = function() {
    let M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Hi(M), Ui = !0;
  }, t.clearConfig = function() {
    qe = null, Ui = !1;
  }, t.isValidAttribute = function(M, b, T) {
    qe || Hi({});
    const P = ct(M), X = ct(b);
    return Mr(P, X, T);
  }, t.addHook = function(M, b) {
    typeof b == "function" && ss(O[M], b);
  }, t.removeHook = function(M, b) {
    if (b !== void 0) {
      const T = Z_(O[M], b);
      return T === -1 ? void 0 : Q_(O[M], T, 1)[0];
    }
    return lo(O[M]);
  }, t.removeHooks = function(M) {
    O[M] = [];
  }, t.removeAllHooks = function() {
    O = go();
  }, t;
}
var my = sc(), gy = { "": ["<em>", "</em>"], _: ["<strong>", "</strong>"], "*": ["<strong>", "</strong>"], "~": ["<s>", "</s>"], "\n": ["<br />"], " ": ["<br />"], "-": ["<hr />"] };
function _o(s) {
  return s.replace(RegExp("^" + (s.match(/^(\t| )+/) || "")[0], "gm"), "");
}
function os(s) {
  return (s + "").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Mn(s, t) {
  var e, i, n, r, a, o = /((?:^|\n+)(?:\n---+|\* \*(?: \*)+)\n)|(?:^``` *(\w*)\n([\s\S]*?)\n```$)|((?:(?:^|\n+)(?:\t|  {2,}).+)+\n*)|((?:(?:^|\n)([>*+-]|\d+\.)\s+.*)+)|(?:!\[([^\]]*?)\]\(([^)]+?)\))|(\[)|(\](?:\(([^)]+?)\))?)|(?:(?:^|\n+)([^\s].*)\n(-{3,}|={3,})(?:\n+|$))|(?:(?:^|\n+)(#{1,6})\s*(.+)(?:\n+|$))|(?:`([^`].*?)`)|(  \n\n*|\n{2,}|__|\*\*|[_*]|~~)/gm, l = [], c = "", u = t || {}, d = 0;
  function p(m) {
    var _ = gy[m[1] || ""], y = l[l.length - 1] == m;
    return _ ? _[1] ? (y ? l.pop() : l.push(m), _[0 | y]) : _[0] : m;
  }
  function h() {
    for (var m = ""; l.length; ) m += p(l[l.length - 1]);
    return m;
  }
  for (s = s.replace(/^\[(.+?)\]:\s*(.+)$/gm, function(m, _, y) {
    return u[_.toLowerCase()] = y, "";
  }).replace(/^\n+|\n+$/g, ""); n = o.exec(s); ) i = s.substring(d, n.index), d = o.lastIndex, e = n[0], i.match(/[^\\](\\\\)*\\$/) || ((a = n[3] || n[4]) ? e = '<pre class="code ' + (n[4] ? "poetry" : n[2].toLowerCase()) + '"><code' + (n[2] ? ' class="language-' + n[2].toLowerCase() + '"' : "") + ">" + _o(os(a).replace(/^\n+|\n+$/g, "")) + "</code></pre>" : (a = n[6]) ? (a.match(/\./) && (n[5] = n[5].replace(/^\d+/gm, "")), r = Mn(_o(n[5].replace(/^\s*[>*+.-]/gm, ""))), a == ">" ? a = "blockquote" : (a = a.match(/\./) ? "ol" : "ul", r = r.replace(/^(.*)(\n|$)/gm, "<li>$1</li>")), e = "<" + a + ">" + r + "</" + a + ">") : n[8] ? e = '<img src="' + os(n[8]) + '" alt="' + os(n[7]) + '">' : n[10] ? (c = c.replace("<a>", '<a href="' + os(n[11] || u[i.toLowerCase()]) + '">'), e = h() + "</a>") : n[9] ? e = "<a>" : n[12] || n[14] ? e = "<" + (a = "h" + (n[14] ? n[14].length : n[13] > "=" ? 1 : 2)) + ">" + Mn(n[12] || n[15], u) + "</" + a + ">" : n[16] ? e = "<code>" + os(n[16]) + "</code>" : (n[17] || n[1]) && (e = p(n[17] || "--"))), c += i, c += e;
  return (c + s.substring(d) + h()).replace(/^\n+|\n+$/g, "");
}
const _y = g({
  props: {
    text: {
      type: String,
      default: ""
    },
    sanitizeOptions: {
      type: Object,
      default: () => ({
        USE_PROFILES: { html: !0 },
        ADD_ATTR: ["target"]
      })
    }
  },
  computed: {
    htmlText() {
      const s = Mn(this.text).replaceAll("><", "> <");
      return this.processText(my.sanitize(s, this.sanitizeOptions));
    }
  },
  methods: {
    processText(s) {
      return /^\s*#\s+/.test(s) ? s : s.replaceAll(new RegExp("\\n(?!\\n)|(?<!\\\\)\\\\n", "g"), `
<br>`);
    }
  }
});
var yy = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "markdown-container" }, [e("div", { domProps: { innerHTML: t._s(t.htmlText) } })]);
}, by = [], vy = /* @__PURE__ */ f(
  _y,
  yy,
  by,
  !1,
  null,
  "7ad989f1"
);
const Et = vy.exports, ky = g({
  name: "FeedbackSelectionModal",
  components: { AppMarkdownText: Et },
  props: {
    defaultTickets: {
      type: Array,
      required: !0
    }
  },
  methods: {
    async addFeedbackTicket(s) {
      this.$emit("addFeedback", s);
    },
    onClose() {
      this.$emit("close");
    }
  }
});
var xy = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", [e("div", { staticClass: "modal-content" }, [e("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: t.onClose } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), e("h2", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("form.feedback.selectFeedbackType")) + " ")]), e("div", { staticClass: "modal-description" }, [t._v(" " + t._s(t.$t("form.feedback.describeFeedbackTypes")) + " ")]), e("div", { staticClass: "feedback-list" }, t._l(t.defaultTickets, function(i) {
    return e("feedback-selection-card", { key: i.id, staticClass: "feedback-type-card", attrs: { ticket: i }, nativeOn: { click: function(n) {
      return t.addFeedbackTicket(i.meta["feedback-type"]);
    } } });
  }), 1), e("div", { staticClass: "footer" }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-solid fa-paper-plane" } }), e("app-markdown-text", { attrs: { text: t.$t("form.feedback.footerText", { email: "cs@rready.com" }) } })], 1)], 1)]);
}, Cy = [], wy = /* @__PURE__ */ f(
  ky,
  xy,
  Cy,
  !1,
  null,
  "65dfe34c"
);
const $y = wy.exports, Sy = g({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    editMode: {
      type: Boolean,
      default: !1
    },
    userId: {
      type: String,
      required: !0
    }
  },
  computed: {
    menuOptions() {
      const s = [
        {
          label: this.$t("form.feedback.viewResults").toString(),
          tabKey: "view-result"
        }
      ];
      return this.ticket.meta.allowEdit !== !1 && s.push({
        label: this.$t("menu.edit").toString(),
        tabKey: "edit-ticket",
        visible: this.editMode
      }), this.ticket.meta.allowDelete !== !1 && s.push({
        label: this.$t("menu.delete").toString(),
        tabKey: "delete-ticket",
        visible: !this.ticket.group && this.editMode
      }), s;
    }
  },
  methods: {
    feedbackComponentType(s) {
      return (s.meta["feedback-type"] ?? "unknown") === "rating" ? "feedback-rating-ticket" : "feedback-multi-question-ticket";
    }
  }
});
var Ty = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e(t.feedbackComponentType(t.ticket), t._g({ tag: "component", attrs: { "menu-options": t.menuOptions, ticket: t.ticket, "user-id": t.userId } }, t.$listeners));
}, Iy = [], Ay = /* @__PURE__ */ f(
  Sy,
  Ty,
  Iy,
  !1,
  null,
  "7ac0cffd"
);
const Py = Ay.exports, Oy = g({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    iconText: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonEnabled: {
      type: Boolean,
      default: !1
    },
    menuOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    icon() {
      return this.ticket.meta.feedbackIcon ?? "/img/transparent-pixel.png";
    },
    title() {
      return this.ticket.title;
    },
    teamCount() {
      return this.ticket.delegate.filter((t) => t.domain === "team").length;
    }
  },
  methods: {
    clickButton() {
      this.$emit("click:button", this.ticket.canonicalId);
    }
  }
});
var My = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "feedback-container" }, [e("div", { staticClass: "container-left" }, [e("app-icon", { staticClass: "feedback-icon", attrs: { size: 33, src: t.icon, frame: "square" } }), e("div", { staticClass: "feedback-icon-text" }, [t._v(" " + t._s(t.iconText) + " ")])], 1), e("div", { staticClass: "container-middle" }, [e("div", { staticClass: "feedback-title", attrs: { title: t.title } }, [t._v(" " + t._s(t.title) + " ")]), e("div", { staticClass: "feedback-subtitle" }, [t._v(" " + t._s(t.subtitle) + " ")])]), e("div", { staticClass: "container-right" }, [e("div", { staticClass: "container-top-right" }, [e("fa-icon-compat", { staticClass: "feedback-team-icon", attrs: { icon: "fa-light fa-user-friends" } }), e("div", { staticClass: "feedback-team-count" }, [t._v(" " + t._s(t.teamCount) + " ")]), e("app-ellipsis-menu", t._g({ attrs: { "menu-options": t.menuOptions, reference: { ticketId: t.ticket.canonicalId } } }, t.$listeners))], 1), t.buttonText ? e("button", { staticClass: "feedback-button", attrs: { disabled: !t.buttonEnabled, type: "button" }, on: { click: t.clickButton } }, [t._v(" " + t._s(t.buttonText) + " ")]) : t._e()])]);
}, Ry = [], Ey = /* @__PURE__ */ f(
  Oy,
  My,
  Ry,
  !1,
  null,
  "f0ca137f"
);
const Dy = Ey.exports, Fy = g({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    menuOptions: {
      type: Array,
      default: () => []
    },
    userId: {
      type: String,
      required: !0
    }
  },
  computed: {
    buttonText() {
      return this.$t(`form.feedback.${this.buttonKey}`).toString();
    },
    buttonKey() {
      return this.ticket.allowFeedback ? this.hasCurrentUserFeedback ? this.ticket.meta.allowResubmission ? "resubmitFeedback" : "feedbackAdded" : "addFeedback" : "feedbackClosed";
    },
    isButtonEnabled() {
      return (!this.hasCurrentUserFeedback || this.ticket.meta.allowResubmission) && this.ticket.allowFeedback;
    },
    hasCurrentUserFeedback() {
      return Object.keys(this.feedbackEntries).some(
        (s) => s === this.userId
      );
    },
    feedbackFieldName() {
      return this.ticket.meta.feedbackFieldName ?? "";
    },
    feedbackVoteFieldName() {
      return this.ticket.meta.feedbackFieldContent[0] ?? "";
    },
    feedbackEntries() {
      var s;
      return ((s = this.ticket.userFields) == null ? void 0 : s[this.feedbackFieldName]) ?? {};
    },
    feedbackCount() {
      return Object.keys(this.feedbackEntries).length;
    },
    averageVote() {
      if (!this.feedbackFieldName || !this.feedbackVoteFieldName || !this.feedbackCount)
        return;
      const s = Object.entries(this.feedbackEntries).reduce(
        (t, [, e]) => {
          const n = e.content ?? {};
          return t + Number.parseInt(n[this.feedbackVoteFieldName], 10);
        },
        0
      );
      return this.formatNumber(s / this.feedbackCount);
    },
    responseCount() {
      return this.$tc("form.feedback.responseAverageText", this.feedbackCount, {
        count: this.feedbackCount,
        averageVote: this.averageVote
      }).toString();
    }
  },
  methods: {
    formatNumber(s) {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }).format(s);
    }
  }
});
var Ly = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("feedback-ticket-card", t._g({ attrs: { "button-enabled": t.isButtonEnabled, "button-text": t.buttonText, "icon-text": t.averageVote, "menu-options": t.menuOptions, subtitle: t.responseCount, ticket: t.ticket } }, t.$listeners));
}, qy = [], Uy = /* @__PURE__ */ f(
  Fy,
  Ly,
  qy,
  !1,
  null,
  null
);
const Ny = Uy.exports, By = g({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    menuOptions: {
      type: Array,
      default: () => []
    },
    userId: {
      type: String,
      required: !0
    }
  },
  computed: {
    buttonText() {
      return this.$t(`form.feedback.${this.buttonKey}`).toString();
    },
    buttonKey() {
      return this.ticket.allowFeedback ? this.hasCurrentUserFeedback ? this.ticket.meta.allowResubmission ? "resubmitFeedback" : "feedbackAdded" : "addFeedback" : "feedbackClosed";
    },
    isButtonEnabled() {
      return (!this.hasCurrentUserFeedback || this.ticket.meta.allowResubmission) && this.ticket.allowFeedback;
    },
    hasCurrentUserFeedback() {
      var s;
      return !!((s = Object.values(this.feedbackEntries)[0]) != null && s[this.userId]);
    },
    feedbackEntries() {
      return this.ticket.userFields ?? {};
    },
    feedbackCount() {
      return new Set(
        Object.values(this.feedbackEntries).map(Object.keys).flat()
      ).size;
    },
    subtitle() {
      return this.$tc("form.feedback.responseCountText", this.feedbackCount, {
        count: this.feedbackCount
      }).toString();
    }
  }
});
var jy = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("feedback-ticket-card", t._g({ attrs: { "button-enabled": t.isButtonEnabled, "button-text": t.buttonText, "menu-options": t.menuOptions, subtitle: t.subtitle, ticket: t.ticket } }, t.$listeners));
}, zy = [], Vy = /* @__PURE__ */ f(
  By,
  jy,
  zy,
  !1,
  null,
  null
);
const Hy = Vy.exports, Wy = g({
  components: { AppMarkdownText: Et },
  props: {
    ticket: {
      type: Object,
      required: !0
    }
  },
  computed: {
    icon() {
      return this.ticket.meta.feedbackIcon ?? "";
    },
    title() {
      return this.$t(`form.feedback.${this.type}.title`).toString();
    },
    description() {
      return this.$t(`form.feedback.${this.type}.description`).toString();
    },
    type() {
      return this.ticket.meta["feedback-type"];
    }
  }
});
var Gy = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "feedback-container" }, [e("div", { staticClass: "container-left" }, [e("app-icon", { staticClass: "feedback-icon", attrs: { size: 33, src: t.icon, frame: "square" } })], 1), e("div", { staticClass: "container-right" }, [e("div", { staticClass: "feedback-title" }, [t._v(" " + t._s(t.title) + " ")]), e("div", { staticClass: "feedback-subtitle" }, [t._v(" " + t._s(t.description) + " ")])])]);
}, Ky = [], Yy = /* @__PURE__ */ f(
  Wy,
  Gy,
  Ky,
  !1,
  null,
  "c8845baa"
);
const Xy = Yy.exports;
function ic(s, t) {
  return [...new Set(s.map(t))].filter((e) => !!e);
}
function Zy(s, t) {
  const e = /* @__PURE__ */ new Map();
  for (const i of s) {
    const n = t(i);
    e.has(n) || e.set(n, []), e.get(n).push(i);
  }
  return e;
}
function sr(s, t) {
  const e = /* @__PURE__ */ new Map();
  for (const i of s) {
    const n = t(i);
    if (!e.has(n))
      e.set(n, i);
    else
      throw new Error("Could not mapBy: Multiple values with the same key");
  }
  return e;
}
const Qy = "/img/profile-placeholder.svg", Jy = g({
  name: "MultipleChoiceResultList",
  props: {
    question: {
      type: Object,
      required: !0
    },
    userMap: {
      type: Map,
      default: () => ({})
    },
    answers: {
      type: Object,
      default: () => ({})
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  computed: {
    isMultipleChoice() {
      return this.question.type === "multiple-choice";
    },
    questionWithIndexes() {
      var t;
      const s = (t = this.question.options) == null ? void 0 : t.map(
        (e, i) => ({
          ...e,
          value: i,
          actualValue: e.value
        })
      );
      return {
        ...this.question,
        options: s
      };
    },
    allAnswers() {
      const s = Object.entries(this.answers).reduce(
        (e, [i, n]) => ((n.contentIndexes ?? n.content).forEach(
          (r) => {
            e[r] = e[r] || { userIds: [], answerCount: 0 }, e[r].userIds.push(i), e[r].answerCount++;
          }
        ), e),
        {}
      ), t = Object.keys(this.answers).length;
      return Object.entries(s).map(([e, { userIds: i, answerCount: n }]) => {
        const r = this.formatNumber(
          n / t * 100
        );
        return {
          answer: `${this.getAnswerText(e)}: ${r}%`,
          userIds: i,
          percentage: r
        };
      }).sort((e, i) => i.percentage - e.percentage);
    }
  },
  methods: {
    formatNumber(s) {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }).format(s);
    },
    getAnswerText(s) {
      var t;
      return ((t = this.questionWithIndexes.options.find(
        (e) => e.value == s
      )) == null ? void 0 : t.text) ?? s;
    },
    getUserName(s) {
      return s === this.currentUser.id ? this.$t("form.feedback.results.yourFeedback").toString() : E({
        user: this.userMap.get(s) ?? {}
      }).displayName();
    },
    userAvatar(s) {
      var t;
      return ((t = this.userMap.get(s)) == null ? void 0 : t.avatar) || Qy;
    }
  }
});
var tb = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "multiple-choice-list" }, t._l(t.allAnswers, function({ userIds: i, answer: n }, r) {
    return e("div", { key: r, staticClass: "answer-container" }, [e("div", { staticClass: "answer" }, [t._v(" " + t._s(n) + " ")]), t._l(i, function(a) {
      return e("div", { key: a, staticClass: "user", class: { highlighted: a === t.currentUser.id } }, [e("app-image", { staticClass: "user-image", attrs: { src: t.userAvatar(a), height: "25px", type: "circle", width: "25px" } }), e("span", [t._v(t._s(t.getUserName(a)))])], 1);
    })], 2);
  }), 0);
}, eb = [], sb = /* @__PURE__ */ f(
  Jy,
  tb,
  eb,
  !1,
  null,
  "5e2deacc"
);
const ib = sb.exports, nb = "/img/profile-placeholder.svg", rb = g({
  name: "RatingResult",
  props: {
    rating: {
      type: Number,
      required: !0
    },
    highlighted: {
      type: Boolean,
      required: !1
    },
    maxRating: {
      type: Number,
      required: !0
    },
    img: {
      type: String,
      required: !0
    },
    userName: {
      type: String,
      required: !0
    },
    userAvatar: {
      type: String,
      default: nb
    }
  }
});
var ab = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "rating-container" }, [e("div", { staticClass: "rating-result" }, t._l(t.maxRating, function(i) {
    return e("img", { key: i, staticClass: "rating-img", class: { selected: i <= t.rating }, attrs: { src: t.img } });
  }), 0), e("app-image", { staticClass: "user-image", attrs: { src: t.userAvatar, height: "25px", type: "circle", width: "25px" } }), e("div", { staticClass: "user-name", class: { highlighted: t.highlighted } }, [t._v(t._s(t.userName))])], 1);
}, ob = [], lb = /* @__PURE__ */ f(
  rb,
  ab,
  ob,
  !1,
  null,
  "b3f31183"
);
const nc = lb.exports, cb = "/img/profile-placeholder.svg", ub = g({
  name: "RatingResultList",
  components: { RatingResult: nc },
  props: {
    question: {
      type: Object,
      required: !0
    },
    userMap: {
      type: Map,
      default: () => ({})
    },
    answers: {
      type: Object,
      default: () => ({})
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  computed: {
    totalRatings() {
      return Object.entries(this.answers).map(
        ([s, { content: t }]) => ({
          user: this.userMap.get(s),
          rating: Number.parseInt(t, 10)
        })
      );
    },
    ratingImg() {
      return this.question.valueImageUrl;
    },
    maxRating() {
      return this.question.values.length;
    }
  },
  methods: {
    getUserName(s) {
      return s.id === this.currentUser.id ? this.$t("form.feedback.results.yourFeedback").toString() : E({ user: s }).displayName();
    },
    userAvatar(s) {
      return s.avatar || cb;
    }
  }
});
var db = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "rating-list" }, t._l(t.totalRatings, function({ user: i, rating: n }) {
    return e("rating-result", { key: i.id, attrs: { highlighted: i.id === t.currentUser.id, img: t.ratingImg, "max-rating": t.maxRating, rating: n, "user-avatar": t.userAvatar(i), "user-name": t.getUserName(i) } });
  }), 1);
}, pb = [], hb = /* @__PURE__ */ f(
  ub,
  db,
  pb,
  !1,
  null,
  "10ff9508"
);
const fb = hb.exports, mb = "/img/profile-placeholder.svg", gb = g({
  name: "TextResultList",
  props: {
    question: {
      type: Object,
      required: !0
    },
    userMap: {
      type: Map,
      default: () => ({})
    },
    answers: {
      type: Object,
      default: () => ({})
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  computed: {
    allAnswers() {
      return Object.entries(this.answers).map(
        ([s, { content: t }]) => ({
          user: this.userMap.get(s),
          answer: t ?? "-"
        })
      );
    }
  },
  methods: {
    getUserName(s) {
      return s.id === this.currentUser.id ? this.$t("form.feedback.results.yourFeedback").toString() : E({ user: s }).displayName();
    },
    userAvatar(s) {
      return s.avatar || mb;
    }
  }
});
var _b = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "text-list" }, t._l(t.allAnswers, function({ user: i, answer: n }) {
    return e("div", { key: i.id, staticClass: "answer-container" }, [e("div", { staticClass: "user", class: { highlighted: i.id === t.currentUser.id } }, [e("app-image", { staticClass: "user-image", attrs: { src: t.userAvatar(i), height: "25px", type: "circle", width: "25px" } }), e("span", [t._v(t._s(t.getUserName(i)))])], 1), e("div", { staticClass: "answer" }, [t._v(" " + t._s(n) + " ")])]);
  }), 0);
}, yb = [], bb = /* @__PURE__ */ f(
  gb,
  _b,
  yb,
  !1,
  null,
  "8bbe7a76"
);
const vb = bb.exports, kb = g({
  name: "MultiQuestionResultModalContent",
  components: {
    MultipleChoiceResultList: ib,
    RatingResultList: fb,
    TextResultList: vb
  },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !0,
      userMap: /* @__PURE__ */ new Map()
    };
  },
  async created() {
    await this.loadUserMap(), this.loading = !1;
  },
  computed: {
    questions() {
      return this.totalNumberOfResponses ? this.resource.questions : [];
    },
    feedbackEntries() {
      return this.ticket.userFields ?? {};
    },
    totalNumberOfResponses() {
      return new Set(
        Object.values(this.feedbackEntries).map(Object.keys).flat()
      ).size;
    },
    resource() {
      const s = this.ticket.meta.feedbackDialogue;
      return this.$res(s);
    }
  },
  methods: {
    getAnswerText(s, t) {
      return s.map(
        (e) => {
          var i;
          return ((i = t.find((n) => n.value === e)) == null ? void 0 : i.text) ?? e;
        }
      );
    },
    async loadUserMap() {
      var e;
      const s = Object.keys(
        ((e = Object.values(this.feedbackEntries)) == null ? void 0 : e[0]) ?? {}
      ), t = await this.$datasource.user.listBatch(s);
      this.userMap = sr(t, (i) => i.id);
    },
    resultListType(s) {
      switch (s) {
        case "rating":
          return "RatingResultList";
        case "multiple-choice":
          return "MultipleChoiceResultList";
        case "text":
        default:
          return "TextResultList";
      }
    },
    formatNumber(s) {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }).format(s);
    },
    questionImage(s) {
      switch (s) {
        case "rating":
          return "/img/feedback_star_rating.svg";
        case "multiple-choice":
          return "/img/feedback_abtest.svg";
        case "text":
        default:
          return "/img/feedback_text.svg";
      }
    },
    questionResultSummary(s, t) {
      const e = this.feedbackEntries[s] ?? {}, i = Object.keys(e).length;
      if (t === "rating") {
        const n = Object.values(e), r = this.formatNumber(
          n.reduce(
            (a, o) => a + Number.parseInt(o.content, 10),
            0
          ) / i
        );
        return this.$tc("form.feedback.responseAverageText", i, {
          count: i,
          averageVote: r
        });
      }
      return this.$tc(
        "form.feedback.responseCountText",
        i
      ).toString();
    }
  }
});
var xb = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.loading ? t._e() : e("div", { staticClass: "rating-container" }, [e("div", { staticClass: "rating-text" }, [t._v(" " + t._s(t.$t("form.feedback.results.amountOfResponses")) + " " + t._s(t.totalNumberOfResponses) + " ")]), t._l(t.questions, function(i) {
    return e("app-accordion", { key: i.id, staticClass: "response-container", attrs: { name: "results" }, scopedSlots: t._u([{ key: "summary", fn: function() {
      return [e("div", { staticClass: "question-container" }, [e("img", { staticClass: "question-image", attrs: { src: t.questionImage(i.type) } }), e("div", { staticClass: "question-text-container" }, [e("div", { staticClass: "question-title" }, [t._v(" " + t._s(i.title ?? i.description) + " ")]), e("div", { staticClass: "question-result-summary" }, [e("user-avatar-list", { attrs: { users: Array.from(t.userMap.values()), "max-display": 4 } }), t._v(" " + t._s(t.questionResultSummary(i.id, i.type)) + " ")], 1)])])];
    }, proxy: !0 }, { key: "content", fn: function() {
      return [e(t.resultListType(i.type), { tag: "component", attrs: { answers: t.feedbackEntries[i.id], "current-user": t.currentUser, question: i, userMap: t.userMap } })];
    }, proxy: !0 }], null, !0) });
  })], 2);
}, Cb = [], wb = /* @__PURE__ */ f(
  kb,
  xb,
  Cb,
  !1,
  null,
  "cb535b80"
);
const $b = wb.exports, Sb = g({
  name: "RatingResultModalContent",
  components: { RatingResult: nc },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      userMap: /* @__PURE__ */ new Map()
    };
  },
  async created() {
    this.loading = !0, await this.loadUserMap(), this.loading = !1;
  },
  computed: {
    resource() {
      const s = this.ticket.meta.feedbackDialogue;
      return this.$res(s);
    },
    allRatings() {
      return this.resource.options.map((s) => s.values).flat();
    },
    maxRating() {
      return this.allRatings.length;
    },
    ratingImg() {
      return this.resource.options[0].valueImageUrl;
    },
    totalRatings() {
      return Object.entries(this.feedbackEntries).filter(([s]) => s !== this.currentUser.id).map(([s, t]) => {
        var e;
        return {
          user: this.userMap.get(s),
          rating: Number.parseInt(
            ((e = t == null ? void 0 : t.content) == null ? void 0 : e[this.feedbackVoteFieldName]) ?? "0",
            10
          )
        };
      });
    },
    currentUserRating() {
      var t;
      const s = this.feedbackEntries[this.currentUser.id];
      return Number.parseInt(
        ((t = s == null ? void 0 : s.content) == null ? void 0 : t[this.feedbackVoteFieldName]) ?? "0",
        10
      );
    },
    feedbackFieldName() {
      return this.ticket.meta.feedbackFieldName ?? "";
    },
    feedbackVoteFieldName() {
      return this.ticket.meta.feedbackFieldContent[0] ?? "";
    },
    feedbackEntries() {
      var s;
      return ((s = this.ticket.userFields) == null ? void 0 : s[this.feedbackFieldName]) ?? {};
    },
    numberOfVotes() {
      return Object.keys(this.feedbackEntries).length;
    },
    averageRating() {
      if (!this.feedbackVoteFieldName || !this.numberOfVotes)
        return;
      const s = Object.entries(this.feedbackEntries).reduce(
        (t, [, e]) => {
          const n = e.content ?? {};
          return t + Number.parseInt(n[this.feedbackVoteFieldName], 10);
        },
        0
      );
      return this.formatNumber(s / this.numberOfVotes);
    }
  },
  methods: {
    getUserName(s) {
      return s ? E({ user: s }).displayName() : "";
    },
    async loadUserMap() {
      var e;
      const s = Object.keys(
        ((e = this.ticket.userFields) == null ? void 0 : e[this.ticket.meta.feedbackFieldName]) ?? {}
      ), t = await this.$datasource.user.listBatch(s);
      this.userMap = sr(t, (i) => i.id);
    },
    formatNumber(s) {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }).format(s);
    }
  }
});
var Tb = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.loading ? t._e() : e("div", { staticClass: "rating-container" }, [e("div", { staticClass: "rating-text" }, [t._v(" " + t._s(t.$t("form.feedback.results.amountOfVotes")) + " " + t._s(t.numberOfVotes) + " "), t.averageRating ? [e("span", { staticClass: "rating-separator" }, [t._v(" | ")]), t._v(" " + t._s(t.$t("form.feedback.results.averageRating")) + " " + t._s(t.averageRating) + " ")] : t._e()], 2), e("div", { staticClass: "review-rating" }, [t.currentUserRating ? e("rating-result", { attrs: { highlighted: !0, img: t.ratingImg, "max-rating": t.maxRating, rating: t.currentUserRating, "user-avatar": t.currentUser.avatar, "user-name": t.$t("form.feedback.results.yourFeedback") } }) : t._e(), t._l(t.totalRatings, function({ user: i, rating: n }) {
    return e("rating-result", { key: i == null ? void 0 : i.id, attrs: { img: t.ratingImg, "max-rating": t.maxRating, rating: n, "user-avatar": i == null ? void 0 : i.avatar, "user-name": t.getUserName(i) } });
  })], 2)]);
}, Ib = [], Ab = /* @__PURE__ */ f(
  Sb,
  Tb,
  Ib,
  !1,
  null,
  "da864909"
);
const Pb = Ab.exports, Ob = g({
  name: "FeedbackResultModal",
  components: {
    MultiQuestionResultModalContent: $b,
    RatingResultModalContent: Pb
  },
  props: {
    ticketId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      ticket: {},
      loading: !1
    };
  },
  async created() {
    this.loading = !0, await this.loadResultDate(), this.loading = !1;
  },
  computed: {
    resource() {
      const s = this.ticket.meta.feedbackDialogue;
      return this.$res(s, {});
    },
    componentType() {
      switch (this.ticket.meta["feedback-type"]) {
        case "multi-question":
          return "MultiQuestionResultModalContent";
        case "rating":
        default:
          return "RatingResultModalContent";
      }
    }
  },
  methods: {
    async loadResultDate() {
      this.ticket = await this.$gateway.feedback.loadFeedbackTicketById(
        this.productId,
        this.ticketId
      );
    },
    onClose() {
      this.$emit("close");
    }
  }
});
var Mb = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading }, on: { "click-outside": t.onClose } }, [t.loading ? t._e() : e("div", { staticClass: "result-container" }, [e("app-icon-button", { staticClass: "close-button", attrs: { size: 26 }, on: { click: t.onClose } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), e("div", { staticClass: "result-title", attrs: { title: t.resource.title } }, [t._v(" " + t._s(t.resource.title) + " ")]), e("app-markdown-text", { staticClass: "result-description", attrs: { text: t.resource.text } }), e(t.componentType, { tag: "component", attrs: { "current-user": t.currentUser, ticket: t.ticket } })], 1)]);
}, Rb = [], Eb = /* @__PURE__ */ f(
  Ob,
  Mb,
  Rb,
  !1,
  null,
  "1870cfba"
);
const Db = Eb.exports, Fb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FeedbackActivityCard: Zl,
  FeedbackFormModal: G_,
  FeedbackList: L_,
  FeedbackManager: j_,
  FeedbackMultiQuestionTicket: Hy,
  FeedbackRatingTicket: Ny,
  FeedbackResultModal: Db,
  FeedbackSelectionCard: Xy,
  FeedbackSelectionModal: $y,
  FeedbackTicket: Py,
  FeedbackTicketCard: Dy
}, Symbol.toStringTag, { value: "Module" })), Lb = g({
  props: {
    scanResult: {
      type: String,
      default: ""
    }
  },
  computed: {
    icon() {
      switch (this.scanResult) {
        case "NO_THREATS_FOUND":
          return {
            icon: "fa-regular fa-shield-check",
            color: "#00987E"
          };
        case "THREATS_FOUND":
          return {
            icon: "fa-regular fa-shield-xmark",
            color: "#FF4A4A"
          };
        default:
          return {
            icon: "",
            color: ""
          };
      }
    }
  }
});
var qb = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "icon-container" }, [e("fa-icon-compat", { staticClass: "icon", style: { color: t.icon.color }, attrs: { icon: t.icon.icon } })], 1);
}, Ub = [], Nb = /* @__PURE__ */ f(
  Lb,
  qb,
  Ub,
  !1,
  null,
  "b811aa8e"
);
const rc = Nb.exports, Bb = g({
  components: { AppFileScanIcon: rc },
  props: {
    file: {
      type: Object,
      required: !0
    }
  },
  computed: {
    galleryStyle() {
      return {
        border: "1px solid var(--color-grey)",
        backgroundColor: "var(--color-grey-light)",
        backgroundImage: this.coverSrc ? `url(${this.coverSrc})` : "none"
      };
    },
    coverSrc() {
      var s;
      return (s = this.file.contentType) != null && s.startsWith("image") ? this.file.src : void 0;
    },
    fileIconSrc() {
      var s;
      if ((s = this.file.contentType) != null && s.startsWith("video"))
        return "/img/video.svg";
    },
    fileLabel() {
      var s;
      if (!((s = this.file.contentType) != null && s.startsWith("image")))
        return this.file.label || this.file.filename;
    },
    hint() {
      const s = this.file.createdDate ? `| ${this.file.createdDate}` : "";
      return `${this.file.filename} ${s}`.trim();
    }
  }
});
var jb = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-file-gallery-preview", style: t.galleryStyle, attrs: { title: t.hint } }, [t.fileIconSrc ? e("img", { staticClass: "icon", attrs: { src: t.fileIconSrc } }) : t._e(), t.fileLabel ? e("div", { staticClass: "label" }, [t._v(t._s(t.fileLabel))]) : t._e(), t.file.scanResult ? e("app-file-scan-icon", { staticClass: "scan-icon", attrs: { "scan-result": t.file.scanResult } }) : t._e()], 1);
}, zb = [], Vb = /* @__PURE__ */ f(
  Bb,
  jb,
  zb,
  !1,
  null,
  "0af5fc3d"
);
const Hb = Vb.exports;
function Wb(s) {
  const { createdDate: t } = s;
  if (!t)
    return "";
  const e = new Date(t), i = {
    year: "numeric",
    month: "short",
    day: "2-digit"
  };
  return e.toLocaleDateString(void 0, i);
}
function We(s) {
  if (!s)
    throw new Error("Could not buildUserFile, legacy file is undefined");
  return {
    id: s.id,
    contentType: s.contentType,
    src: s.url,
    filename: s.filename,
    label: s.name,
    roles: s.roles,
    createdDate: Wb(s),
    scanResult: s.scanResult
  };
}
const Gb = g({
  props: {
    file: {
      type: Object,
      required: !1
    }
  },
  computed: {
    extension() {
      var e;
      return (/(?:\.([^.]+))?$/.exec(((e = this.file) == null ? void 0 : e.filename) ?? "")[1] ?? "???").substring(0, 3).toUpperCase();
    }
  }
});
var Kb = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("svg", { staticStyle: { zoom: "1" }, attrs: { xmlns: "http://www.w3.org/2000/svg", width: "42", height: "46", viewBox: "0 0 42 46", fill: "none" } }, [e("path", { attrs: { d: `M4.39185 20.3065C4.39185 20.6802 4.69417 20.9796 5.06495
              20.9796C5.43858 20.9796 5.73806 20.6773 5.73806 20.3065V1.34833H29.3393L35.5027
              7.51177V20.309C35.5027 20.6826 35.805 20.9821 36.1758 20.9821C36.5494 20.9821
              36.8489 20.6798 36.8489 20.309V7.23212C36.8489 7.06099 36.7833 6.88701 36.6521
              6.75582L30.0979 0.201603C29.9753 0.078961 29.807 0.00195312 29.6187
              0.00195312H5.06471C4.69108 0.00195312 4.3916 0.304277
              4.3916 0.675059V20.3094L4.39185 20.3065ZM36.8519 38.2038C36.8519 37.8302
              36.5496 37.5307 36.1788 37.5307C35.8052 37.5307 35.5057 37.8331 35.5057
              38.2038V43.8083H5.74061V38.2038C5.74061 37.8302 5.43828 37.5307
              5.0675 37.5307C4.69387 37.5307 4.3944 37.8331 4.3944
              38.2038V44.4814C4.3944 44.855 4.69673 45.1545 5.0675 45.1545H36.1812C36.5548
              45.1545 36.8543 44.8522 36.8543 44.4814V38.2038H36.8519Z`, fill: "#B3B3B3" } }), e("path", { attrs: { d: `M30.2949 0.673106C30.2949 0.299477 29.9926 0 29.6218 0C29.2482 0 28.9487
              0.302324 28.9487 0.673106V3.95306C28.9487 5.03974 29.3937 6.02945
              30.1095 6.74528C30.8254 7.46117 31.8151 7.90606 32.9017 7.90606H36.1817C36.5553
              7.90606 36.8548 7.60374 36.8548 7.23296C36.8548 6.85933 36.5525 6.55985 36.1817
              6.55985H32.9017C32.1858 6.55985 31.5356 6.26609 31.0621 5.79546C30.5887 5.32201
              30.2977 4.6717 30.2977 3.95587V0.67591L30.2949 0.673106Z`, fill: "#B3B3B3" } }), e("path", { attrs: { d: `M1.34557 37.5292H39.9009V20.9812H1.34557V37.5292ZM40.5741
              38.8783H0.673106C0.299477 38.8783 0 38.576 0 38.2052V20.3079C0 19.9342
              0.302324 19.6348 0.673106 19.6348H40.5741C40.9477 19.6348 41.2472 19.9371
              41.2472 20.3079V38.2052C41.2472 38.5788 40.9448
              38.8783 40.5741 38.8783Z`, fill: "#B3B3B3" } }), e("path", { attrs: { d: `M10.4006 7.72266C10.027 7.72266 9.72754 8.02498 9.72754 8.39576C9.72754
              8.76939 10.0299 9.06887 10.4006 9.06887H24.921C25.2947 9.06887 25.5941 8.76654
              25.5941 8.39576C25.5941 8.02213 25.2918
              7.72266 24.921 7.72266H10.4006Z`, fill: "#B3B3B3" } }), e("path", { attrs: { d: `M10.4006 11.4434C10.027 11.4434 9.72754 11.7457 9.72754 12.1165C9.72754
              12.4901 10.0299 12.7896 10.4006 12.7896H30.8476C31.2212 12.7896 31.5207 12.4872
              31.5207 12.1165C31.5207 11.7428 31.2184 11.4434
              30.8476 11.4434H10.4006Z`, fill: "#B3B3B3" } }), e("path", { attrs: { d: `M10.4006 15.1602C10.027 15.1602 9.72754 15.4625 9.72754 15.8333C9.72754
              16.2069 10.0299 16.5064 10.4006 16.5064H30.8476C31.2212 16.5064 31.5207 16.204
              31.5207 15.8333C31.5207 15.4596 31.2184 15.1602
              30.8476 15.1602H10.4006Z`, fill: "#B3B3B3" } }), e("g", [e("text", { staticClass: "file-extension", attrs: { x: "50%", y: "33" } }, [t._v(t._s(t.extension))])])]);
}, Yb = [], Xb = /* @__PURE__ */ f(
  Gb,
  Kb,
  Yb,
  !1,
  null,
  "096313ea"
);
const ac = Xb.exports, Zb = g({
  components: {
    AppFileUploadPreviewIcon: ac
  },
  props: {
    file: {
      type: Object,
      required: !1
    }
  },
  computed: {
    previewVisible() {
      var s;
      return ((s = this.file) == null ? void 0 : s.contentType.startsWith("image")) ?? !1;
    },
    previewSrc() {
      var s;
      return (s = this.file) == null ? void 0 : s.src;
    }
  }
});
var Qb = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-file-upload-preview" }, [t.previewVisible ? e("img", { staticClass: "image-preview", attrs: { src: t.previewSrc } }) : e("app-file-upload-preview-icon", { staticClass: "image-preview", attrs: { file: t.file } })], 1);
}, Jb = [], tv = /* @__PURE__ */ f(
  Zb,
  Qb,
  Jb,
  !1,
  null,
  "131724f0"
);
const ev = tv.exports, sv = g({
  components: {
    AppFileUploadPreview: ev
  },
  props: {
    file: {
      type: Object,
      required: !0
    }
  },
  computed: {
    hasSlotControls() {
      return !!this.$slots.controls;
    }
  }
});
var iv = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-file-upload-item" }, [e("app-file-upload-preview", { staticClass: "file-preview", attrs: { file: t.file } }), e("div", { staticClass: "file-name" }, [t._v(t._s(t.file.filename))]), t.hasSlotControls ? e("div", { staticClass: "controls" }, [t._t("controls")], 2) : t._e()], 1);
}, nv = [], rv = /* @__PURE__ */ f(
  sv,
  iv,
  nv,
  !1,
  null,
  "b23505b7"
);
const Os = rv.exports, av = g({
  props: {
    dynamicGroup: {
      type: Object,
      required: !0
    },
    label: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      expanded: !0
    };
  },
  created() {
    this.expanded = this.displayConfig.collapse !== "collapsed";
  },
  computed: {
    displayConfig() {
      const { display: s } = this.dynamicGroup.options ?? {};
      return { ...s == null ? void 0 : s.all, ...s == null ? void 0 : s.view };
    },
    toggleEnabled() {
      const { collapse: s } = this.displayConfig;
      return s === "expanded" || s === "collapsed";
    },
    headerIcon() {
      return this.expanded ? "fa-regular fa-chevron-up" : "fa-regular fa-chevron-down";
    }
  },
  methods: {
    onToggleGroup() {
      this.expanded = !this.expanded;
    }
  }
});
var ov = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "legacy-field-view" }, [t.label ? e("div", { staticClass: "legacy-field-label" }, [t.toggleEnabled ? e("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: t.onToggleGroup } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: t.headerIcon } })], 1) : t._e(), e("div", { staticClass: "legacy-field-label-title" }, [t._v(t._s(t.label) + " ")])], 1) : t._e(), e("div", { directives: [{ name: "show", rawName: "v-show", value: t.expanded, expression: "expanded" }], staticClass: "legacy-field-content" }, [t._t("default")], 2)]);
}, lv = [], cv = /* @__PURE__ */ f(
  av,
  ov,
  lv,
  !1,
  null,
  "a56f4603"
);
const uv = cv.exports, dv = g({
  components: { AppFileScanIcon: rc, AppFileUploadPreviewIcon: ac },
  props: {
    item: {
      type: Object,
      required: !0
    }
  }
});
var pv = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("div", { staticClass: "separator" }), e("div", { staticClass: "gallery-item-container" }, [e("app-file-upload-preview-icon", { staticClass: "icon", attrs: { file: t.item } }), e("div", { staticClass: "filename" }, [t._v(t._s(t.item.filename))]), t.item.createdDate ? e("div", { staticClass: "date" }, [t._v(t._s(t.item.createdDate))]) : t._e(), t.item.scanResult ? e("app-file-scan-icon", { attrs: { "scan-result": t.item.scanResult } }) : t._e()], 1)]);
}, hv = [], fv = /* @__PURE__ */ f(
  dv,
  pv,
  hv,
  !1,
  null,
  "98cce130"
);
const mv = fv.exports, gv = g({
  components: {
    AppFileGalleryItem: mv,
    LegacyFieldLabel: uv,
    AppFileUploadItem: Os,
    AppFileGalleryPreview: Hb
  },
  props: {
    files: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentFiles: [],
      view: "grid"
    };
  },
  created() {
    this.currentFiles = this.files.map(We);
  },
  computed: {
    gridConfig() {
      return {
        summary: "disabled",
        item: {
          minWidth: 150,
          maxWidth: 200
        }
      };
    },
    listConfig() {
      return {
        summary: "disabled",
        display: {
          separators: "disabled"
        }
      };
    }
  },
  methods: {
    hrefFile(s) {
      return s || void 0;
    }
  }
});
var _v = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-file-gallery" }, [e("div", { staticClass: "gallery-header" }, [e("div", { staticClass: "gallery-label" }, [t._v(t._s(t.label))]), e("app-data-view-switcher-icons", { attrs: { available: ["grid", "list"] }, model: { value: t.view, callback: function(i) {
    t.view = i;
  }, expression: "view" } })], 1), e("app-data-view", { staticClass: "app-data-view", attrs: { "grid-config": t.gridConfig, "list-config": t.listConfig, view: t.view, data: t.currentFiles }, scopedSlots: t._u([{ key: "grid-item", fn: function({ item: i }) {
    return [e("a", { attrs: { download: i.filename, href: t.hrefFile(i.src), target: "_blank" } }, [e("app-file-gallery-preview", { staticClass: "app-file-gallery-preview", attrs: { file: i } })], 1)];
  } }, { key: "list-item", fn: function({ item: i }) {
    return [e("a", { attrs: { download: i.filename, href: t.hrefFile(i.src), target: "_blank" } }, [e("app-file-gallery-item", { attrs: { item: i } })], 1)];
  } }]) })], 1);
}, yv = [], bv = /* @__PURE__ */ f(
  gv,
  _v,
  yv,
  !1,
  null,
  "647190b2"
);
const vv = bv.exports, kv = g({
  props: {
    label: {
      type: String,
      required: !0
    },
    acceptFilter: {
      type: String,
      required: !1
    }
  },
  setup() {
    return zl();
  },
  methods: {
    onClickInput() {
      this.$refs.fileInput.click();
    },
    checkFileSize(s) {
      return this.allowFileSize(s) ? !0 : (console.error(`File size is too big, ${s.size}`), this.$toast(
        this.$t("error.maxFileSize", {
          size: this.readableMaxFileUploadSize
        }).toString()
      ), !1);
    },
    onFileChange(s) {
      const t = s == null ? void 0 : s.target, e = t == null ? void 0 : t.files;
      (e == null ? void 0 : e.length) === 1 && this.checkFileSize(e[0]) ? this.$emit("pick-file", e[0]) : console.error("Error picking file to upload");
    }
  }
});
var xv = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-file-upload-picker" }, [e("add-button", { attrs: { text: t.label }, on: { click: t.onClickInput, keydown: function(i) {
    return !i.type.indexOf("key") && t._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : (i.stopPropagation(), t.onClickInput.apply(null, arguments));
  } } }), e("input", { ref: "fileInput", staticClass: "hidden-file-input", attrs: { type: "file", accept: t.acceptFilter }, on: { change: t.onFileChange } })], 1);
}, Cv = [], wv = /* @__PURE__ */ f(
  kv,
  xv,
  Cv,
  !1,
  null,
  "8736ecc3"
);
const ir = wv.exports, $v = g({
  name: "SelectTeamMembers",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      search: "",
      loading: !1,
      users: [],
      selection: [],
      selectedUsers: [],
      reloadKey: 0
    };
  },
  created() {
    this.selection = [...this.value];
  },
  watch: {
    async selection(s) {
      await this.updateModel(s), await this.onUpdateSelection(s);
    }
  },
  computed: {
    isEmpty() {
      return this.users.length === 0;
    },
    emptyViewMessage() {
      return this.search.length && !this.users.length && !this.loading ? this.$t("common.no-result-found").toString() : this.$t("page.userSearchModal.searchByName").toString();
    },
    gridConfig() {
      return {
        selection: {
          mode: "multiple",
          selectAllButton: !1
        },
        item: { minWidth: 200 }
      };
    },
    mappedUsers() {
      return this.users.map((s) => ({ ...s, id: s.user.id }));
    }
  },
  methods: {
    async onDebounced(s) {
      this.search = s, await this.onSearch();
    },
    async onSearch() {
      try {
        this.loading = !0;
        const s = await this.$gateway.search.searchUserIds({
          query: this.search,
          filter: {
            active: !0
          },
          limit: 100
        });
        this.users = await this.$gateway.portal.findUsersById(s);
      } catch (s) {
        console.error("Error loading users", s);
      } finally {
        this.loading = !1;
      }
    },
    removeSelection(s) {
      this.selection = this.selection.filter((t) => t !== s), this.reloadKey += 1;
    },
    async onUpdateSelection(s) {
      try {
        this.selectedUsers = await this.$gateway.portal.findUsersById(
          s
        );
      } catch (t) {
        console.error("Error loading selected users", t);
      }
    },
    updateModel(s) {
      this.$emit("input", s);
    }
  }
});
var Sv = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "select-team-members" }, [t.selectedUsers.length ? e("base-input-item", { attrs: { label: t.$t("page.userSearchModal.selected") } }, [e("app-data-grid", { attrs: { data: t.selectedUsers, config: { summary: "disabled", item: { minWidth: 200 } } }, scopedSlots: t._u([{ key: "default", fn: function({ item: i }) {
    return [e("team-member-card", { staticClass: "clickable-card", attrs: { "user-data": i }, nativeOn: { click: function(n) {
      return t.removeSelection(i.id);
    } } })];
  } }], null, !1, 111531775) })], 1) : t._e(), e("app-search-input", { staticClass: "app-search-input", attrs: { "debounce-timeout": 500, label: t.$t("modal.createTeam.searchLabel"), placeholder: t.$t("common.searchUserByNameEmail") }, on: { debounced: t.onDebounced } }), t.loading ? e("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [e("app-loading")], 1) : t._e(), t.isEmpty ? e("app-empty-view", { attrs: { theme: "white", title: t.emptyViewMessage, "fa-icon": "fa-regular fa-magnifying-glass" } }) : e("app-data-grid", { key: t.reloadKey, staticClass: "search-results-grid", attrs: { data: t.mappedUsers, config: t.gridConfig }, scopedSlots: t._u([{ key: "default", fn: function({ item: i }) {
    return [e("team-member-card", { attrs: { "user-data": i } })];
  } }]), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } })], 1);
}, Tv = [], Iv = /* @__PURE__ */ f(
  $v,
  Sv,
  Tv,
  !1,
  null,
  "40bdb1c0"
);
const oc = Iv.exports, Av = g({
  props: {
    value: {
      type: Array,
      required: !0
    },
    catalog: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      query: "",
      selection: []
    };
  },
  watch: {
    value(s) {
      this.selection = s;
    }
  },
  computed: {
    optionsAll() {
      return [...this.catalog].sort().map((t) => ({
        text: t,
        value: t
      }));
    },
    optionsFiltered() {
      const s = this.query.toUpperCase();
      return this.optionsAll.filter(
        (t) => t.text.toUpperCase().includes(s)
      );
    },
    permissionGlobalOption() {
      return {
        text: this.$t("modal.uploadPermissions.allRoles"),
        value: "*"
      };
    }
  },
  methods: {
    onToggleOpen(s) {
      s || (this.query = "");
    },
    onUpdate(s) {
      this.$emit("input", s);
    }
  }
});
var Pv = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-multiselect", { staticClass: "selector", attrs: { placeholder: t.placeholder, options: t.optionsFiltered, "options-pool": t.optionsAll, "global-selection": t.permissionGlobalOption, "search-enabled": !0 }, on: { "toggle-open": t.onToggleOpen, "update-multiple": t.onUpdate }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [e("app-search-input", { staticClass: "inner-search", attrs: { placeholder: t.searchPlaceholder }, model: { value: t.query, callback: function(i) {
      t.query = i;
    }, expression: "query" } })];
  }, proxy: !0 }]), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } });
}, Ov = [], Mv = /* @__PURE__ */ f(
  Av,
  Pv,
  Ov,
  !1,
  null,
  "0e13a8e7"
);
const lc = Mv.exports, Rv = g({
  components: {
    PermissionsMultiselect: lc,
    SelectTeamMembers: oc
  },
  props: {
    productId: {
      type: String,
      required: !0
    },
    ticketId: {
      type: String,
      required: !0
    },
    file: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      selectedPermissions: [],
      allPermissions: []
    };
  },
  async created() {
    var s;
    await this.loadPermissions(), this.selectedPermissions = (s = this.file.roles) != null && s.length ? this.file.roles : ["*"];
  },
  methods: {
    async loadPermissions() {
      const s = await this.$api.role.fetchAllRoles();
      this.allPermissions = s.map((t) => t.name);
    },
    async onUploadPermissions() {
      const s = this.selectedPermissions[0] === "*" ? [] : this.selectedPermissions;
      await this.$api.ticketFileUpload.updateTicketFilePermissions(
        this.productId,
        this.ticketId,
        this.file.id,
        s
      ), this.$emit("permissions-updated");
    }
  }
});
var Ev = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { staticClass: "modal", on: { "click-outside": function(i) {
    return t.$emit("close");
  } } }, [e("div", { staticClass: "modal-container" }, [e("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: function(i) {
    return t.$emit("close");
  } } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), e("h3", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("modal.uploadPermissions.title")) + " ")]), e("div", { staticClass: "modal-description" }, [t._v(t._s(t.$t("modal.uploadPermissions.description")))]), e("permissions-multiselect", { attrs: { "search-placeholder": t.$t("modal.uploadPermissions.searchPlaceholder"), placeholder: t.$t("modal.uploadPermissions.placeholder"), catalog: t.allPermissions }, model: { value: t.selectedPermissions, callback: function(i) {
    t.selectedPermissions = i;
  }, expression: "selectedPermissions" } }), e("div", { staticClass: "modal-footer" }, [e("app-button", { staticClass: "button", attrs: { label: t.$t("common.form.apply") }, on: { click: t.onUploadPermissions } })], 1)], 1)]);
}, Dv = [], Fv = /* @__PURE__ */ f(
  Rv,
  Ev,
  Dv,
  !1,
  null,
  "086bea78"
);
const cc = Fv.exports, Lv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppFileGallery: vv,
  AppFileUploadItem: Os,
  AppFileUploadPermissionsModal: cc,
  AppFileUploadPicker: ir,
  PermissionsMultiselect: lc
}, Symbol.toStringTag, { value: "Module" })), qv = g({
  name: "Countdown",
  props: {
    endDate: {
      type: Date,
      required: !0
    }
  },
  data() {
    return {
      intervalId: 0,
      timeRemaining: 0
    };
  },
  mounted() {
    this.timeRemaining = this.endDate.getTime() - Date.now(), this.intervalId = window.setInterval(() => {
      this.timeRemaining = this.endDate.getTime() - Date.now();
    }, 1e3);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  computed: {
    totalSeconds() {
      return Math.floor(this.timeRemaining / 1e3);
    },
    days() {
      return Math.floor(this.totalSeconds / 3600 / 24).toString().padStart(2, "0");
    },
    hours() {
      return (Math.floor(this.totalSeconds / 3600) % 24).toString().padStart(2, "0");
    },
    minutes() {
      return (Math.floor(this.totalSeconds / 60) % 60).toString().padStart(2, "0");
    },
    seconds() {
      return (this.totalSeconds % 60).toString().padStart(2, "0");
    }
  }
});
var Uv = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "countdown-container" }, [e("div", { staticClass: "section" }, [e("div", { staticClass: "numbers" }, [t._v(t._s(t.days))]), e("div", { staticClass: "label" }, [t._v(t._s(t.$t("common.days")))])]), t._v(" : "), e("div", { staticClass: "section" }, [e("div", { staticClass: "numbers" }, [t._v(t._s(t.hours))]), e("div", { staticClass: "label" }, [t._v(t._s(t.$t("common.hours")))])]), t._v(" : "), e("div", { staticClass: "section" }, [e("div", { staticClass: "numbers" }, [t._v(t._s(t.minutes))]), e("div", { staticClass: "label" }, [t._v(t._s(t.$t("common.minutes")))])]), t._v(" : "), e("div", { staticClass: "section" }, [e("div", { staticClass: "numbers" }, [t._v(t._s(t.seconds))]), e("div", { staticClass: "label" }, [t._v(t._s(t.$t("common.seconds")))])])]);
}, Nv = [], Bv = /* @__PURE__ */ f(
  qv,
  Uv,
  Nv,
  !1,
  null,
  "1a501b52"
);
const jv = Bv.exports, zv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppCountdown: jv
}, Symbol.toStringTag, { value: "Module" })), Vv = g({
  props: {
    image: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    date: {
      type: Date,
      required: !0
    }
  },
  computed: {
    displayDate() {
      return Intl.DateTimeFormat(void 0, {
        dateStyle: "medium"
      }).format(new Date(this.date));
    },
    //Testing relative formatting on dev
    displayRelativeDate() {
      const s = Math.round(
        (this.date.getTime() - Date.now()) / 1e3
      ), t = [60, 3600, 86400, 86400 * 30, 86400 * 365, 1 / 0], e = [
        "second",
        "minute",
        "hour",
        "day",
        "month",
        "year"
      ], i = t.findIndex(
        (a) => a > Math.abs(s)
      ), n = i ? t[i - 1] : 1;
      return new Intl.RelativeTimeFormat(void 0, {
        numeric: "auto"
      }).format(
        Math.round(s / n),
        e[i]
      );
    }
  }
});
var Hv = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "activity-feed-item" }, [e("div", { staticClass: "feed-item-header" }, [e("img", { staticClass: "item-header-image", attrs: { src: t.image } }), e("div", { staticClass: "item-header-content" }, [e("div", { staticClass: "item-header-title" }, [t._v(t._s(t.title))]), e("div", { staticClass: "item-header-date" }, [t._v(t._s(t.displayRelativeDate))])])]), e("div", { staticClass: "feed-item-content" }, [t._t("content")], 2)]);
}, Wv = [], Gv = /* @__PURE__ */ f(
  Vv,
  Hv,
  Wv,
  !1,
  null,
  "921924d9"
);
const Ms = Gv.exports, Kv = "/img/profile-placeholder.svg", Yv = g({
  components: {
    ActivityItem: Ms
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    data: {
      type: [],
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    }
  },
  computed: {
    eventType() {
      return this.data[0];
    },
    entry() {
      return this.data[1];
    },
    ticketResponse() {
      return this.data[2];
    },
    user() {
      return this.data[3];
    },
    userName() {
      return E({ user: this.user }).displayName();
    },
    activityTitle() {
      const s = this.$t("activityFeed.commentAddTitle", {
        userName: this.userName
      }).toString();
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    activityImage() {
      return this.user.avatar || Kv;
    },
    activityDate() {
      return new Date(this.entry["@timestamp"]);
    },
    routeToTicket() {
      return {
        name: "TicketDetails",
        params: { id: this.ticketResponse.ticket.canonicalId }
      };
    }
  }
});
var Xv = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("router-link", { attrs: { to: t.routeToTicket } }, [e("activity-item", { staticClass: "activity-item-comment-added", attrs: { title: t.activityTitle, image: t.activityImage, date: t.activityDate }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("ticket-activity-card", { attrs: { organization: t.organization, "current-user-id": t.currentUserId, "ticket-response": t.ticketResponse } })];
  }, proxy: !0 }]) })], 1);
}, Zv = [], Qv = /* @__PURE__ */ f(
  Yv,
  Xv,
  Zv,
  !1,
  null,
  "722505fe"
);
const Jv = Qv.exports, tk = "/img/profile-placeholder.svg", ek = g({
  components: {
    ActivityItem: Ms,
    FeedbackActivityCard: Zl
  },
  props: {
    data: {
      type: [],
      required: !0
    }
  },
  computed: {
    eventType() {
      return this.data[0];
    },
    entry() {
      return this.data[1];
    },
    parentTicket() {
      return this.data[2];
    },
    feedbackTicket() {
      return this.data[3];
    },
    user() {
      return this.data[4];
    },
    userName() {
      return E({ user: this.user }).displayName();
    },
    activityTitle() {
      const s = this.$t("activityFeed.feedbackCreatedTitle", {
        userName: this.userName,
        ticketTitle: this.parentTicket.title
      }).toString();
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    activityImage() {
      return this.user.avatar || tk;
    },
    activityDate() {
      return new Date(this.entry["@timestamp"]);
    },
    routeToTicket() {
      return {
        name: "TicketDetails",
        params: { id: this.parentTicket.canonicalId }
      };
    }
  },
  methods: {
    getTicketImage(s) {
      const t = s.meta.cover;
      if (t)
        return t;
      const i = s.files.find((n) => n.category === "ticket-cover");
      return (i == null ? void 0 : i.url) || "";
    }
  }
});
var sk = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("router-link", { attrs: { to: t.routeToTicket } }, [e("activity-item", { staticClass: "activity-item-feedback-created", attrs: { title: t.activityTitle, image: t.activityImage, date: t.activityDate }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("feedback-activity-card", { attrs: { ticket: t.feedbackTicket, user: t.user } })];
  }, proxy: !0 }]) })], 1);
}, ik = [], nk = /* @__PURE__ */ f(
  ek,
  sk,
  ik,
  !1,
  null,
  "2ff90faa"
);
const rk = nk.exports, ak = "/img/profile-placeholder.svg", ok = g({
  components: {
    ActivityItem: Ms
  },
  props: {
    data: {
      type: [],
      required: !0
    }
  },
  computed: {
    eventType() {
      return this.data[0];
    },
    entry() {
      return this.data[1];
    },
    offer() {
      return this.data[2];
    },
    workgroup() {
      return this.data[3];
    },
    ticket() {
      return this.data[4];
    },
    user() {
      return this.data[5];
    },
    userName() {
      return E({ user: this.user }).displayName();
    },
    activityTitle() {
      const s = this.$t("activityFeed.offerPurchasedTitle", {
        userName: this.userName,
        ticketTitle: this.ticket.title
      }).toString();
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    activityImage() {
      return this.user.avatar || ak;
    },
    activityDate() {
      return new Date(this.entry["@timestamp"]);
    },
    routeToTicket() {
      return {
        name: "TicketDetails",
        params: { id: this.ticket.canonicalId }
      };
    }
  }
});
var lk = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("router-link", { attrs: { to: t.routeToTicket } }, [e("activity-item", { staticClass: "activity-item-offer-purchase", attrs: { title: t.activityTitle, image: t.activityImage, date: t.activityDate }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("offer-card", { attrs: { offer: t.offer, workgroup: t.workgroup, "show-price": !1 } })];
  }, proxy: !0 }]) })], 1);
}, ck = [], uk = /* @__PURE__ */ f(
  ok,
  lk,
  ck,
  !1,
  null,
  "72022d47"
);
const dk = uk.exports, pk = "/img/profile-placeholder.svg", hk = g({
  components: {
    ActivityItem: Ms
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    data: {
      type: [],
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    eventType() {
      return this.data[0];
    },
    entry() {
      return this.data[1];
    },
    ticketResponse() {
      return this.data[2];
    },
    user() {
      return this.data[3];
    },
    userName() {
      return E({ user: this.user }).displayName();
    },
    activityTitle() {
      const s = this.$t("activityFeed.statusChangeTitle", {
        userName: this.userName,
        ticketTitle: this.ticketResponse.ticket.title,
        statusFrom: this.previousStatus,
        statusTo: this.nextStatus
      }).toString();
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    activityImage() {
      return this.user.avatar || pk;
    },
    activityDate() {
      return new Date(this.entry["@timestamp"]);
    },
    previousStatus() {
      var t;
      const s = Y(
        this.entry.meta.oldStatus,
        this.ticketResponse.workflow
      );
      return ((t = this.$res(s)) == null ? void 0 : t.label) ?? this.entry.meta.status;
    },
    nextStatus() {
      var t;
      const s = Y(
        this.entry.meta.status,
        this.ticketResponse.workflow
      );
      return ((t = this.$res(s)) == null ? void 0 : t.label) ?? this.entry.meta.status;
    },
    routeToTicket() {
      return {
        name: "TicketDetails",
        params: { id: this.ticketResponse.ticket.canonicalId }
      };
    }
  }
});
var fk = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("router-link", { attrs: { to: t.routeToTicket } }, [e("activity-item", { staticClass: "activity-item-status-updated", attrs: { title: t.activityTitle, image: t.activityImage, date: t.activityDate }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("ticket-activity-card", { attrs: { organization: t.organization, "current-user-id": t.currentUserId, "ticket-response": t.ticketResponse, "user-actions": t.userActions } })];
  }, proxy: !0 }]) })], 1);
}, mk = [], gk = /* @__PURE__ */ f(
  hk,
  fk,
  mk,
  !1,
  null,
  "3437cbd1"
);
const _k = gk.exports, yk = g({
  props: {
    feed: {
      type: Array,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    organization: {
      type: Object,
      required: !0
    }
  },
  computed: {
    empty() {
      return this.feed.length === 0;
    }
  },
  methods: {
    activityItemComponent(s) {
      switch (s[0]) {
        case "status-updated":
          return "activity-item-status-updated";
        case "comment-added":
          return "activity-item-comment-added";
        case "offer-purchased":
          return "activity-item-offer-purchased";
        case "feedback-created":
          return "activity-item-feedback-created";
        default:
          throw new Error(`Unknown activity item type: '${s[0]}'`);
      }
    }
  }
});
var bk = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "widget-content" }, [t.empty ? e("app-empty-view", { staticClass: "widget-empty", attrs: { title: t.$t("activityFeed.activityList.emptyViewTitle"), "fa-icon": "fa-light fa-list-timeline" } }) : e("div", { staticClass: "feed-activity-list" }, t._l(t.feed, function(i, n) {
    return e("div", { key: n }, [e(t.activityItemComponent(i), { tag: "component", attrs: { organization: t.organization, "current-user-id": t.currentUserId, data: i, "user-actions": t.userActions } })], 1);
  }), 0)], 1);
}, vk = [], kk = /* @__PURE__ */ f(
  yk,
  bk,
  vk,
  !1,
  null,
  "caba81f4"
);
const xk = kk.exports, Ck = "/img/profile-placeholder.svg", wk = g({
  props: {
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      data: []
    };
  },
  async created() {
    try {
      this.loading = !0, this.data = await this.$gateway.activity.loadTopCommenters(
        this.productId,
        5
      );
    } catch (s) {
      console.error("Could not load top commenters", s), this.$toast(this.$t("error.general").toString());
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    viewState() {
      return this.loading ? "loading" : this.data.length === 0 ? "empty" : "ready";
    }
  },
  methods: {
    getUserAvatar(s) {
      return s.avatar || Ck;
    },
    getUserName(s) {
      return E({ user: s }).displayName();
    },
    getActivityDescription(s) {
      return this.$tc(
        "activityFeed.topCommenters.itemDescription",
        s.activityCount
      ).toString();
    },
    routeToUser(s) {
      return {
        name: "UserProfile",
        params: { userId: s.id }
      };
    }
  }
});
var $k = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-widget", { staticClass: "app-widget", attrs: { title: t.$t("activityFeed.topCommenters.sectionTitle"), "view-state": t.viewState }, scopedSlots: t._u([{ key: "empty", fn: function() {
    return [e("app-empty-view", { attrs: { title: t.$t("activityFeed.topCommenters.emptyViewTitle"), "fa-icon": "fa-light fa-trophy" } })];
  }, proxy: !0 }, { key: "ready", fn: function() {
    return [e("div", { staticClass: "top-commenters-list" }, t._l(t.data, function(i, n) {
      return e("router-link", { key: n, attrs: { to: t.routeToUser(i.user) } }, [e("app-list-item", { attrs: { image: t.getUserAvatar(i.user), title: t.getUserName(i.user), description: t.getActivityDescription(i) } })], 1);
    }), 1)];
  }, proxy: !0 }]) });
}, Sk = [], Tk = /* @__PURE__ */ f(
  wk,
  $k,
  Sk,
  !1,
  null,
  "9356314d"
);
const Ik = Tk.exports, Ak = "/img/profile-placeholder.svg", Pk = g({
  props: {
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      data: []
    };
  },
  async created() {
    try {
      this.loading = !0, this.data = await this.$gateway.activity.loadTopReactors(
        this.productId,
        5
      );
    } catch (s) {
      console.error("Could not load top reactors", s), this.$toast(this.$t("error.general").toString());
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    viewState() {
      return this.loading ? "loading" : this.data.length === 0 ? "empty" : "ready";
    }
  },
  methods: {
    getUserAvatar(s) {
      return s.avatar || Ak;
    },
    getUserName(s) {
      return E({ user: s }).displayName();
    },
    getActivityDescription(s) {
      return this.$tc(
        "activityFeed.topReactors.itemDescription",
        s.activityCount
      ).toString();
    },
    routeToUser(s) {
      return {
        name: "UserProfile",
        params: { userId: s.id }
      };
    }
  }
});
var Ok = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-widget", { staticClass: "app-widget", attrs: { title: t.$t("activityFeed.topReactors.sectionTitle"), "view-state": t.viewState }, scopedSlots: t._u([{ key: "empty", fn: function() {
    return [e("app-empty-view", { attrs: { title: t.$t("activityFeed.topReactors.emptyViewTitle"), "fa-icon": "fa-light fa-trophy" } })];
  }, proxy: !0 }, { key: "ready", fn: function() {
    return [e("div", { staticClass: "top-reactors-list" }, t._l(t.data, function(i, n) {
      return e("router-link", { key: n, attrs: { to: t.routeToUser(i.user) } }, [e("app-list-item", { attrs: { image: t.getUserAvatar(i.user), title: t.getUserName(i.user), description: t.getActivityDescription(i) } })], 1);
    }), 1)];
  }, proxy: !0 }]) });
}, Mk = [], Rk = /* @__PURE__ */ f(
  Pk,
  Ok,
  Mk,
  !1,
  null,
  "9abf3875"
);
const Ek = Rk.exports, Dk = "/img/profile-placeholder.svg", Fk = g({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: !0,
      data: []
    };
  },
  async mounted() {
    try {
      this.loading = !0, this.data = await this.$gateway.portal.loadActivityTickets(
        this.contextId,
        this.productId,
        10
      );
    } catch (s) {
      console.error("Could not load latest ideas", s), this.$toast(this.$t("error.general").toString());
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    viewState() {
      return this.loading ? "loading" : this.data.length === 0 ? "empty" : "ready";
    }
  },
  methods: {
    userName(s) {
      return s ? E({ user: s }).displayName() : "";
    },
    activityTitle(s) {
      const t = this.$t("activityFeed.ticketCreatedTitle", {
        userName: this.userName(s)
      }).toString();
      return t.charAt(0).toUpperCase() + t.slice(1);
    },
    activityImage(s) {
      return (s == null ? void 0 : s.avatar) || Dk;
    },
    activityDate(s) {
      return new Date(s.createdDate);
    },
    routeToTicket(s) {
      return {
        name: "TicketDetails",
        params: { id: s.canonicalId }
      };
    }
  }
});
var Lk = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-widget", { staticClass: "app-widget", attrs: { title: t.$t("page.dashboard.latestIdeas"), level: 1, "view-state": t.viewState }, scopedSlots: t._u([{ key: "empty", fn: function() {
    return [e("app-empty-view", { attrs: { title: t.$t("common.noDataAvailable"), "fa-icon": "fa-light fa-list-timeline" } })];
  }, proxy: !0 }, { key: "loading", fn: function() {
    return [e("div", { staticClass: "latest-ideas-loading" }, [t._l(3, function(i) {
      return e("scary-skeleton-card", { key: i });
    }), e("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [e("app-loading")], 1)], 2)];
  }, proxy: !0 }, { key: "ready", fn: function() {
    return [e("div", { staticClass: "latest-ideas-list" }, t._l(t.data, function(i, n) {
      var r, a;
      return e("router-link", { key: n, attrs: { to: t.routeToTicket(i.ticket) } }, [e("activity-item", { attrs: { title: t.activityTitle((r = i.creator) == null ? void 0 : r.user), image: t.activityImage((a = i.creator) == null ? void 0 : a.user), date: t.activityDate(i.ticket) }, scopedSlots: t._u([{ key: "content", fn: function() {
        return [e("ticket-activity-card", { staticClass: "ticket-activity-card", attrs: { organization: t.organization, "current-user-id": t.currentUserId, "ticket-response": i, "user-actions": t.userActions } })];
      }, proxy: !0 }], null, !0) })], 1);
    }), 1)];
  }, proxy: !0 }]) });
}, qk = [], Uk = /* @__PURE__ */ f(
  Fk,
  Lk,
  qk,
  !1,
  null,
  "6f8711d9"
);
const Nk = Uk.exports, Bk = g({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: !0,
      data: []
    };
  },
  async created() {
    try {
      this.loading = !0, this.data = await this.$gateway.activity.loadPopularTickets(
        this.productId,
        this.contextId,
        3
      );
    } catch (s) {
      console.error("Could not load popular tickets", s), this.$toast(this.$t("error.general").toString());
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    visible() {
      return this.viewState === "ready";
    },
    viewState() {
      return this.loading ? "loading" : this.data.length === 0 ? "empty" : "ready";
    }
  },
  methods: {
    routeToTicket(s) {
      return {
        name: "TicketDetails",
        params: { id: s.ticket.canonicalId }
      };
    }
  }
});
var jk = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-widget", { directives: [{ name: "show", rawName: "v-show", value: t.visible, expression: "visible" }], staticClass: "app-widget", attrs: { title: t.$t("page.dashboard.popularIdeas"), "view-state": t.viewState }, scopedSlots: t._u([{ key: "empty", fn: function() {
    return [e("app-empty-view", { attrs: { title: t.$t("common.noDataAvailable"), "fa-icon": "fa-light fa-list-timeline" } })];
  }, proxy: !0 }, { key: "ready", fn: function() {
    return [e("div", { staticClass: "popular-tickets-list" }, t._l(t.data, function(i, n) {
      return e("router-link", { key: n, attrs: { to: t.routeToTicket(i) } }, [e("app-ticket-card", { attrs: { organization: t.organization, "current-user-id": t.currentUserId, "ticket-response": i, "user-actions": t.userActions } })], 1);
    }), 1)];
  }, proxy: !0 }]) });
}, zk = [], Vk = /* @__PURE__ */ f(
  Bk,
  jk,
  zk,
  !1,
  null,
  "02b294b9"
);
const Hk = Vk.exports, Wk = g({
  props: {
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !0,
      data: [],
      allStats: {}
    };
  },
  async mounted() {
    try {
      this.loading = !0;
      const s = await this.$datasource.topic.listPopular(
        this.productId,
        6
      ), t = ic(s, (e) => e.id);
      this.allStats = await this.$api.stats.fetchTopicStatsByBatch(
        t,
        this.productId
      ), this.data = s;
    } catch (s) {
      console.error("Could not load popular topics", s), this.$toast(this.$t("error.general").toString());
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    visible() {
      return this.viewState === "ready";
    },
    viewState() {
      return this.loading ? "loading" : this.data.length === 0 ? "empty" : "ready";
    }
  },
  methods: {
    getTopicStats(s) {
      return this.allStats[s.id];
    },
    routeToTopic(s) {
      return {
        name: "TopicDetails",
        params: { id: s.id }
      };
    },
    goToTopicsPage() {
      this.$router.push({ name: "TopicOverview" });
    }
  }
});
var Gk = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-widget", { directives: [{ name: "show", rawName: "v-show", value: t.visible, expression: "visible" }], staticClass: "app-widget", attrs: { overflow: !1, title: t.$t("page.dashboard.popularTopics"), "view-state": t.viewState }, scopedSlots: t._u([{ key: "action", fn: function() {
    return [e("view-all-button", { attrs: { level: 2 }, on: { click: t.goToTopicsPage } })];
  }, proxy: !0 }, { key: "empty", fn: function() {
    return [e("app-empty-view", { attrs: { title: t.$t("common.noDataAvailable"), "fa-icon": "fa-light fa-list-timeline" } })];
  }, proxy: !0 }, { key: "ready", fn: function() {
    return [e("div", { staticClass: "popular-topic-list" }, t._l(t.data, function(i, n) {
      return e("router-link", { key: n, attrs: { to: t.routeToTopic(i) } }, [e("topic-card", { attrs: { stats: t.getTopicStats(i), topic: i } })], 1);
    }), 1)];
  }, proxy: !0 }]) });
}, Kk = [], Yk = /* @__PURE__ */ f(
  Wk,
  Gk,
  Kk,
  !1,
  null,
  "6710b7d1"
);
const Xk = Yk.exports, Zk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityItem: Ms,
  ActivityItemCommentAdded: Jv,
  ActivityItemFeedbackCreated: rk,
  ActivityItemOfferPurchased: dk,
  ActivityItemStatusUpdated: _k,
  FeedActivityList: xk,
  LatestTicketsWidget: Nk,
  PopularTicketsWidget: Hk,
  PopularTopicsWidget: Xk,
  TopCommentersWidget: Ik,
  TopReactorsWidget: Ek
}, Symbol.toStringTag, { value: "Module" })), Qk = Rt.extend({
  name: "AddButton",
  props: {
    text: {
      type: String,
      default: "Add"
    },
    icon: {
      type: String,
      default: "fa-solid fa-plus"
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    onClick() {
      this.enabled && this.$emit("click");
    }
  }
});
var Jk = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "add-button-container", class: { disabled: !t.enabled }, on: { click: t.onClick } }, [e("div", { staticClass: "button-text" }, [e("fa-icon-compat", { attrs: { icon: t.icon } }), t._v(" " + t._s(t.text) + " ")], 1)]);
}, tx = [], ex = /* @__PURE__ */ f(
  Qk,
  Jk,
  tx,
  !1,
  null,
  "9690e33e"
);
const uc = ex.exports;
var yo = function(s, t, e, i) {
  if (e === "a" && !i) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? s !== t || !i : !t.has(s)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e === "m" ? i : e === "a" ? i.call(s) : i ? i.value : t.get(s);
}, fi, Rn;
const sx = [
  "[data-md-button]",
  "md-header",
  "md-bold",
  "md-italic",
  "md-quote",
  "md-code",
  "md-link",
  "md-image",
  "md-unordered-list",
  "md-ordered-list",
  "md-task-list",
  "md-mention",
  "md-ref",
  "md-strikethrough"
];
function dc(s) {
  const t = [];
  for (const e of s.querySelectorAll(sx.join(", ")))
    e.hidden || e.offsetWidth <= 0 && e.offsetHeight <= 0 || e.closest("markdown-toolbar") === s && t.push(e);
  return t;
}
function pc(s) {
  return function(t) {
    (t.key === " " || t.key === "Enter") && s(t);
  };
}
const kt = /* @__PURE__ */ new WeakMap(), ix = {
  "header-1": { prefix: "# " },
  "header-2": { prefix: "## " },
  "header-3": { prefix: "### " },
  "header-4": { prefix: "#### " },
  "header-5": { prefix: "##### " },
  "header-6": { prefix: "###### " },
  bold: { prefix: "**", suffix: "**", trimFirst: !0 },
  italic: { prefix: "_", suffix: "_", trimFirst: !0 },
  quote: { prefix: "> ", multiline: !0, surroundWithNewlines: !0 },
  code: {
    prefix: "`",
    suffix: "`",
    blockPrefix: "```",
    blockSuffix: "```"
  },
  link: { prefix: "[", suffix: "](url)", replaceNext: "url", scanFor: "https?://" },
  image: { prefix: "![", suffix: "](url)", replaceNext: "url", scanFor: "https?://" },
  "unordered-list": {
    prefix: "- ",
    multiline: !0,
    unorderedList: !0
  },
  "ordered-list": {
    prefix: "1. ",
    multiline: !0,
    orderedList: !0
  },
  "task-list": { prefix: "- [ ] ", multiline: !0, surroundWithNewlines: !0 },
  mention: { prefix: "@", prefixSpace: !0 },
  ref: { prefix: "#", prefixSpace: !0 },
  strikethrough: { prefix: "~~", suffix: "~~", trimFirst: !0 }
};
class At extends HTMLElement {
  constructor() {
    super();
    const t = (e) => {
      const i = kt.get(this);
      i && (e.preventDefault(), Dn(this, i));
    };
    this.addEventListener("keydown", pc(t)), this.addEventListener("click", t);
  }
  connectedCallback() {
    this.hasAttribute("role") || this.setAttribute("role", "button");
  }
  click() {
    const t = kt.get(this);
    t && Dn(this, t);
  }
}
class bo extends At {
  constructor() {
    super(...arguments), fi.add(this);
  }
  connectedCallback() {
    const t = parseInt(this.getAttribute("level") || "3", 10);
    yo(this, fi, "m", Rn).call(this, t);
  }
  static get observedAttributes() {
    return ["level"];
  }
  attributeChangedCallback(t, e, i) {
    if (t !== "level")
      return;
    const n = parseInt(i || "3", 10);
    yo(this, fi, "m", Rn).call(this, n);
  }
}
fi = /* @__PURE__ */ new WeakSet(), Rn = function(t) {
  if (t < 1 || t > 6)
    return;
  const e = `${"#".repeat(t)} `;
  kt.set(this, {
    prefix: e
  });
};
window.customElements.get("md-header") || (window.MarkdownHeaderButtonElement = bo, window.customElements.define("md-header", bo));
class vo extends At {
  connectedCallback() {
    kt.set(this, { prefix: "**", suffix: "**", trimFirst: !0 });
  }
}
window.customElements.get("md-bold") || (window.MarkdownBoldButtonElement = vo, window.customElements.define("md-bold", vo));
class ko extends At {
  connectedCallback() {
    kt.set(this, { prefix: "_", suffix: "_", trimFirst: !0 });
  }
}
window.customElements.get("md-italic") || (window.MarkdownItalicButtonElement = ko, window.customElements.define("md-italic", ko));
class xo extends At {
  connectedCallback() {
    kt.set(this, { prefix: "> ", multiline: !0, surroundWithNewlines: !0 });
  }
}
window.customElements.get("md-quote") || (window.MarkdownQuoteButtonElement = xo, window.customElements.define("md-quote", xo));
class Co extends At {
  connectedCallback() {
    kt.set(this, { prefix: "`", suffix: "`", blockPrefix: "```", blockSuffix: "```" });
  }
}
window.customElements.get("md-code") || (window.MarkdownCodeButtonElement = Co, window.customElements.define("md-code", Co));
class wo extends At {
  connectedCallback() {
    kt.set(this, { prefix: "[", suffix: "](url)", replaceNext: "url", scanFor: "https?://" });
  }
}
window.customElements.get("md-link") || (window.MarkdownLinkButtonElement = wo, window.customElements.define("md-link", wo));
class $o extends At {
  connectedCallback() {
    kt.set(this, { prefix: "![", suffix: "](url)", replaceNext: "url", scanFor: "https?://" });
  }
}
window.customElements.get("md-image") || (window.MarkdownImageButtonElement = $o, window.customElements.define("md-image", $o));
class So extends At {
  connectedCallback() {
    kt.set(this, { prefix: "- ", multiline: !0, unorderedList: !0 });
  }
}
window.customElements.get("md-unordered-list") || (window.MarkdownUnorderedListButtonElement = So, window.customElements.define("md-unordered-list", So));
class To extends At {
  connectedCallback() {
    kt.set(this, { prefix: "1. ", multiline: !0, orderedList: !0 });
  }
}
window.customElements.get("md-ordered-list") || (window.MarkdownOrderedListButtonElement = To, window.customElements.define("md-ordered-list", To));
class Io extends At {
  connectedCallback() {
    kt.set(this, { prefix: "- [ ] ", multiline: !0, surroundWithNewlines: !0 });
  }
}
window.customElements.get("md-task-list") || (window.MarkdownTaskListButtonElement = Io, window.customElements.define("md-task-list", Io));
class Ao extends At {
  connectedCallback() {
    kt.set(this, { prefix: "@", prefixSpace: !0 });
  }
}
window.customElements.get("md-mention") || (window.MarkdownMentionButtonElement = Ao, window.customElements.define("md-mention", Ao));
class Po extends At {
  connectedCallback() {
    kt.set(this, { prefix: "#", prefixSpace: !0 });
  }
}
window.customElements.get("md-ref") || (window.MarkdownRefButtonElement = Po, window.customElements.define("md-ref", Po));
class Oo extends At {
  connectedCallback() {
    kt.set(this, { prefix: "~~", suffix: "~~", trimFirst: !0 });
  }
}
window.customElements.get("md-strikethrough") || (window.MarkdownStrikethroughButtonElement = Oo, window.customElements.define("md-strikethrough", Oo));
function Mo(s) {
  const { target: t, currentTarget: e } = s;
  if (!(t instanceof Element))
    return;
  const i = t.closest("[data-md-button]");
  if (!i || i.closest("markdown-toolbar") !== e)
    return;
  const n = i.getAttribute("data-md-button"), r = ix[n];
  r && (s.preventDefault(), Dn(t, r));
}
function Ro(s) {
  s.addEventListener("keydown", fc), s.setAttribute("tabindex", "0"), s.addEventListener("focus", hc, { once: !0 });
}
function Eo(s) {
  s.removeEventListener("keydown", fc), s.removeAttribute("tabindex"), s.removeEventListener("focus", hc);
}
class wi extends HTMLElement {
  connectedCallback() {
    this.hasAttribute("role") || this.setAttribute("role", "toolbar"), this.hasAttribute("data-no-focus") || Ro(this), this.addEventListener("keydown", pc(Mo)), this.addEventListener("click", Mo);
  }
  attributeChangedCallback(t, e, i) {
    t === "data-no-focus" && (i === null ? Ro(this) : Eo(this));
  }
  disconnectedCallback() {
    Eo(this);
  }
  get field() {
    const t = this.getAttribute("for");
    if (!t)
      return null;
    const e = "getRootNode" in this ? this.getRootNode() : document;
    let i;
    return (e instanceof Document || e instanceof ShadowRoot) && (i = e.getElementById(t)), i instanceof HTMLTextAreaElement ? i : null;
  }
}
wi.observedAttributes = ["data-no-focus"];
function hc({ target: s }) {
  if (!(s instanceof Element))
    return;
  s.removeAttribute("tabindex");
  let t = "0";
  for (const e of dc(s))
    e.setAttribute("tabindex", t), t === "0" && (e.focus(), t = "-1");
}
function fc(s) {
  const t = s.key;
  if (t !== "ArrowRight" && t !== "ArrowLeft" && t !== "Home" && t !== "End")
    return;
  const e = s.currentTarget;
  if (!(e instanceof HTMLElement))
    return;
  const i = dc(e), n = i.indexOf(s.target), r = i.length;
  if (n === -1)
    return;
  let a = 0;
  t === "ArrowLeft" && (a = n - 1), t === "ArrowRight" && (a = n + 1), t === "End" && (a = r - 1), a < 0 && (a = r - 1), a > r - 1 && (a = 0);
  for (let o = 0; o < r; o += 1)
    i[o].setAttribute("tabindex", o === a ? "0" : "-1");
  s.preventDefault(), i[a].focus();
}
window.customElements.get("markdown-toolbar") || (window.MarkdownToolbarElement = wi, window.customElements.define("markdown-toolbar", wi));
function En(s) {
  return s.trim().split(`
`).length > 1;
}
function Do(s, t) {
  return Array(t + 1).join(s);
}
function nx(s, t) {
  let e = t;
  for (; s[e] && s[e - 1] != null && !s[e - 1].match(/\s/); )
    e--;
  return e;
}
function rx(s, t, e) {
  let i = t;
  const n = e ? /\n/ : /\s/;
  for (; s[i] && !s[i].match(n); )
    i++;
  return i;
}
let be = null;
function ax(s, { text: t, selectionStart: e, selectionEnd: i }) {
  const n = s.selectionStart, r = s.value.slice(0, n), a = s.value.slice(s.selectionEnd);
  if (be === null || be === !0) {
    s.contentEditable = "true";
    try {
      be = document.execCommand("insertText", !1, t);
    } catch {
      be = !1;
    }
    s.contentEditable = "false";
  }
  if (be && !s.value.slice(0, s.selectionStart).endsWith(t) && (be = !1), !be) {
    try {
      document.execCommand("ms-beginUndoUnit");
    } catch {
    }
    s.value = r + t + a;
    try {
      document.execCommand("ms-endUndoUnit");
    } catch {
    }
    s.dispatchEvent(new CustomEvent("input", { bubbles: !0, cancelable: !0 }));
  }
  e != null && i != null ? s.setSelectionRange(e, i) : s.setSelectionRange(n, s.selectionEnd);
}
function ox(s, t) {
  const e = s.value.slice(s.selectionStart, s.selectionEnd);
  let i;
  t.orderedList || t.unorderedList ? i = hx(s, t) : t.multiline && En(e) ? i = dx(s, t) : i = ux(s, t), ax(s, i);
}
function lx(s) {
  const t = s.value.split(`
`);
  let e = 0;
  for (let i = 0; i < t.length; i++) {
    const n = t[i].length + 1;
    s.selectionStart >= e && s.selectionStart < e + n && (s.selectionStart = e), s.selectionEnd >= e && s.selectionEnd < e + n && (s.selectionEnd = e + n - 1), e += n;
  }
}
function cx(s, t, e, i = !1) {
  if (s.selectionStart === s.selectionEnd)
    s.selectionStart = nx(s.value, s.selectionStart), s.selectionEnd = rx(s.value, s.selectionEnd, i);
  else {
    const n = s.selectionStart - t.length, r = s.selectionEnd + e.length, a = s.value.slice(n, s.selectionStart) === t, o = s.value.slice(s.selectionEnd, r) === e;
    a && o && (s.selectionStart = n, s.selectionEnd = r);
  }
  return s.value.slice(s.selectionStart, s.selectionEnd);
}
function nr(s) {
  const t = s.value.slice(0, s.selectionStart), e = s.value.slice(s.selectionEnd), i = t.match(/\n*$/), n = e.match(/^\n*/), r = i ? i[0].length : 0, a = n ? n[0].length : 0;
  let o, l;
  return t.match(/\S/) && r < 2 && (o = Do(`
`, 2 - r)), e.match(/\S/) && a < 2 && (l = Do(`
`, 2 - a)), o == null && (o = ""), l == null && (l = ""), { newlinesToAppend: o, newlinesToPrepend: l };
}
function ux(s, t) {
  let e, i;
  const { prefix: n, suffix: r, blockPrefix: a, blockSuffix: o, replaceNext: l, prefixSpace: c, scanFor: u, surroundWithNewlines: d } = t, p = s.selectionStart, h = s.selectionEnd;
  let m = s.value.slice(s.selectionStart, s.selectionEnd), _ = En(m) && a.length > 0 ? `${a}
` : n, y = En(m) && o.length > 0 ? `
${o}` : r;
  if (c) {
    const x = s.value[s.selectionStart - 1];
    s.selectionStart !== 0 && x != null && !x.match(/\s/) && (_ = ` ${_}`);
  }
  m = cx(s, _, y, t.multiline);
  let v = s.selectionStart, k = s.selectionEnd;
  const w = l.length > 0 && y.indexOf(l) > -1 && m.length > 0;
  if (d) {
    const x = nr(s);
    e = x.newlinesToAppend, i = x.newlinesToPrepend, _ = e + n, y += i;
  }
  if (m.startsWith(_) && m.endsWith(y)) {
    const x = m.slice(_.length, m.length - y.length);
    if (p === h) {
      let C = p - _.length;
      C = Math.max(C, v), C = Math.min(C, v + x.length), v = k = C;
    } else
      k = v + x.length;
    return { text: x, selectionStart: v, selectionEnd: k };
  } else if (w)
    if (u.length > 0 && m.match(u)) {
      y = y.replace(l, m);
      const x = _ + y;
      return v = k = v + _.length, { text: x, selectionStart: v, selectionEnd: k };
    } else {
      const x = _ + m + y;
      return v = v + _.length + m.length + y.indexOf(l), k = v + l.length, { text: x, selectionStart: v, selectionEnd: k };
    }
  else {
    let x = _ + m + y;
    v = p + _.length, k = h + _.length;
    const C = m.match(/^\s*|\s*$/g);
    if (t.trimFirst && C) {
      const $ = C[0] || "", S = C[1] || "";
      x = $ + _ + m.trim() + y + S, v += $.length, k -= S.length;
    }
    return { text: x, selectionStart: v, selectionEnd: k };
  }
}
function dx(s, t) {
  const { prefix: e, suffix: i, surroundWithNewlines: n } = t;
  let r = s.value.slice(s.selectionStart, s.selectionEnd), a = s.selectionStart, o = s.selectionEnd;
  const l = r.split(`
`);
  if (l.every((u) => u.startsWith(e) && u.endsWith(i)))
    r = l.map((u) => u.slice(e.length, u.length - i.length)).join(`
`), o = a + r.length;
  else if (r = l.map((u) => e + u + i).join(`
`), n) {
    const { newlinesToAppend: u, newlinesToPrepend: d } = nr(s);
    a += u.length, o = a + r.length, r = u + r + d;
  }
  return { text: r, selectionStart: a, selectionEnd: o };
}
function Fo(s) {
  const t = s.split(`
`), e = /^\d+\.\s+/, i = t.every((r) => e.test(r));
  let n = t;
  return i && (n = t.map((r) => r.replace(e, ""))), {
    text: n.join(`
`),
    processed: i
  };
}
function Lo(s) {
  const t = s.split(`
`), e = "- ", i = t.every((r) => r.startsWith(e));
  let n = t;
  return i && (n = t.map((r) => r.slice(e.length, r.length))), {
    text: n.join(`
`),
    processed: i
  };
}
function ls(s, t) {
  return t ? "- " : `${s + 1}. `;
}
function px(s, t) {
  let e, i, n;
  return s.orderedList ? (i = Fo(t), e = Lo(i.text), n = e.text) : (i = Lo(t), e = Fo(i.text), n = e.text), [i, e, n];
}
function hx(s, t) {
  const e = s.selectionStart === s.selectionEnd;
  let i = s.selectionStart, n = s.selectionEnd;
  lx(s);
  const r = s.value.slice(s.selectionStart, s.selectionEnd), [a, o, l] = px(t, r), c = l.split(`
`).map((_, y) => `${ls(y, t.unorderedList)}${_}`), u = c.reduce((_, y, v) => _ + ls(v, t.unorderedList).length, 0), d = c.reduce((_, y, v) => _ + ls(v, !t.unorderedList).length, 0);
  if (a.processed)
    return e ? (i = Math.max(i - ls(0, t.unorderedList).length, 0), n = i) : (i = s.selectionStart, n = s.selectionEnd - u), { text: l, selectionStart: i, selectionEnd: n };
  const { newlinesToAppend: p, newlinesToPrepend: h } = nr(s), m = p + c.join(`
`) + h;
  return e ? (i = Math.max(i + ls(0, t.unorderedList).length + p.length, 0), n = i) : o.processed ? (i = Math.max(s.selectionStart + p.length, 0), n = s.selectionEnd + p.length + u - d) : (i = Math.max(s.selectionStart + p.length, 0), n = s.selectionEnd + p.length + u), { text: m, selectionStart: i, selectionEnd: n };
}
function Dn(s, t) {
  const e = s.closest("markdown-toolbar");
  if (!(e instanceof wi))
    return;
  const n = Object.assign(Object.assign({}, {
    prefix: "",
    suffix: "",
    blockPrefix: "",
    blockSuffix: "",
    multiline: !1,
    replaceNext: "",
    prefixSpace: !1,
    scanFor: "",
    surroundWithNewlines: !1,
    orderedList: !1,
    unorderedList: !1,
    trimFirst: !1
  }), t), r = e.field;
  r && (r.focus(), ox(r, n));
}
const fx = g({
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  components: {
    AppMarkdownText: Et
  },
  methods: {
    closeModal() {
      this.$emit("close");
    }
  }
});
var mx = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { on: { "click-outside": t.closeModal } }, [e("div", { staticClass: "modal-content" }, [e("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: t.closeModal } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), e("app-markdown-text", { attrs: { text: t.text } })], 1)]);
}, gx = [], _x = /* @__PURE__ */ f(
  fx,
  mx,
  gx,
  !1,
  null,
  "a6e954d9"
);
const yx = _x.exports, bx = g({
  components: { AppMarkdownPreviewModal: yx },
  props: {
    showHint: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Array,
      default: () => []
    },
    textAreaId: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showPreview: !1
    };
  },
  methods: {
    getIcon(s) {
      switch (s) {
        case "unordered-list":
          return "fa-solid fa-list-ul";
        case "ordered-list":
          return "fa-solid fa-list-ol";
        default:
          return `fa-solid fa-${s}`;
      }
    },
    getTooltip(s) {
      return this.$t(`common.markdown.tooltip.${s}`).toString();
    },
    closeModal() {
      this.showPreview = !1;
    }
  }
});
var vx = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [t.showHint ? e("div", { staticClass: "markdown-hint" }, [e("span", [t._v(t._s(t.$t("common.markdown.supported")))]), e("a", { attrs: { href: "https://www.markdownguide.org/basic-syntax/", target: "_blank" } }, [t._v(" " + t._s(t.$t("common.markdown.here")) + " ")])]) : t._e(), e("div", { staticClass: "markdown-toolbar-container" }, [e("markdown-toolbar", { staticClass: "markdown-toolbar", attrs: { for: t.textAreaId } }, t._l(t.options, function(i) {
    return e(`md-${i}`, { key: i, tag: "component", attrs: { title: i } }, [e("app-tooltip", { attrs: { tooltip: t.getTooltip(i), placement: "top" } }, [e("app-icon-button", { attrs: { padding: 6 } }, [e("fa-icon-compat", { attrs: { icon: t.getIcon(i) } })], 1)], 1)], 1);
  }), 1), e("app-icon-button", { staticClass: "icon-preview", attrs: { enabled: !!t.text }, on: { click: function(i) {
    t.showPreview = !0;
  } } }, [t._v(" " + t._s(t.$t("common.markdown.preview")) + " ")]), t.showPreview ? e("app-markdown-preview-modal", { attrs: { text: t.text }, on: { close: function(i) {
    t.showPreview = !1;
  } } }) : t._e()], 1)]);
}, kx = [], xx = /* @__PURE__ */ f(
  bx,
  vx,
  kx,
  !1,
  null,
  "d26b1388"
);
const mc = xx.exports, Cx = g({
  components: {
    AppMarkdownToolbar: mc
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      required: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 4
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      text: "",
      options: [
        "header",
        "bold",
        "italic",
        "link",
        "image",
        "code",
        "unordered-list",
        "ordered-list"
      ],
      textAreaId: self.crypto.randomUUID()
    };
  },
  watch: {
    value(s) {
      this.text = s;
    }
  },
  created() {
    this.text = this.value;
  },
  methods: {
    onKeydown(s) {
      this.$emit("keydown", s);
      const t = this.$el.querySelector(".app-text-area .text-area");
      t && this.$emit("selection", { selectionStart: t.selectionStart + 1 });
    }
  }
});
var wx = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("base-input-label", { attrs: { error: t.error, label: t.label, required: t.required, tooltip: t.tooltip } }), e("app-markdown-toolbar", { attrs: { options: t.options, text: t.text, "text-area-id": t.textAreaId } }), e("app-text-area", { staticClass: "toolbar", attrs: { id: t.textAreaId, enabled: t.enabled, error: t.error, placeholder: t.placeholder, required: t.required, rows: t.rows }, on: { blur: function(i) {
    return t.$emit("onBlur");
  }, input: function(i) {
    return t.$emit("input", t.text);
  }, keydown: t.onKeydown }, model: { value: t.text, callback: function(i) {
    t.text = i;
  }, expression: "text" } })], 1);
}, $x = [], Sx = /* @__PURE__ */ f(
  Cx,
  wx,
  $x,
  !1,
  null,
  null
);
const Tx = Sx.exports, Ix = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppMarkdownInput: Tx,
  AppMarkdownText: Et,
  AppMarkdownToolbar: mc
}, Symbol.toStringTag, { value: "Module" })), Ax = g({
  components: { AppMarkdownText: Et },
  props: {
    title: {
      type: String,
      required: !1
    },
    description: {
      type: String,
      required: !0
    },
    bannerStyle: {
      type: String,
      default: "warning"
    }
  },
  computed: {
    bannerIcon() {
      switch (this.bannerStyle) {
        case "error":
          return "fa-light fa-ban";
        case "warning":
          return "fa-light fa-triangle-exclamation";
        case "notice":
          return "fa-light fa-circle-info";
        default:
          return "";
      }
    }
  }
});
var Px = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-banner", class: t.bannerStyle }, [t.title ? e("div", { staticClass: "ticket-banner-title" }, [t._v(" " + t._s(t.title) + " ")]) : t._e(), e("div", { staticClass: "ticket-banner-description-container" }, [e("fa-icon-compat", { staticClass: "banner-icon", attrs: { icon: t.bannerIcon } }), e("app-markdown-text", { staticClass: "ticket-banner-description", attrs: { text: t.description } })], 1)]);
}, Ox = [], Mx = /* @__PURE__ */ f(
  Ax,
  Px,
  Ox,
  !1,
  null,
  "997bc9a1"
);
const Rx = Mx.exports, Ex = g({});
var Dx = function() {
  var t = this;
  return t._self._c, t._self._setupProxy, t._m(0);
}, Fx = [function() {
  var s = this, t = s._self._c;
  return s._self._setupProxy, t("div", { staticClass: "app-bounce-loading" }, [t("div"), t("div"), t("div")]);
}], Lx = /* @__PURE__ */ f(
  Ex,
  Dx,
  Fx,
  !1,
  null,
  null
);
const qx = Lx.exports, Ux = g({
  name: "AppDeleteButton",
  props: {
    label: {
      type: String,
      required: !0
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    onClick(s) {
      this.$emit("click", s);
    }
  }
});
var Nx = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-action-button", { staticClass: "delete-button", attrs: { enabled: t.enabled, label: t.label, "fa-icon": "fa-regular fa-trash-alt" }, on: { click: t.onClick } });
}, Bx = [], jx = /* @__PURE__ */ f(
  Ux,
  Nx,
  Bx,
  !1,
  null,
  "c67f9774"
);
const zx = jx.exports, Vx = g({
  props: {
    value: String,
    enabled: {
      type: Boolean,
      default: !0
    },
    debounceTimeout: {
      type: Number,
      required: !1
    }
  },
  data() {
    return {
      iconSize: 20
    };
  },
  methods: {
    copyInput() {
      navigator.clipboard.writeText(this.value ?? ""), this.$toast(this.$t("common.copiedToClipboard"));
    }
  }
});
var Hx = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("base-input-item", t._b({ staticClass: "app-copy-input" }, "base-input-item", t.$attrs, !1), [e("base-input-text", t._g(t._b({ staticClass: "input-field", attrs: { enabled: !1, value: t.value }, nativeOn: { click: function(i) {
    return t.copyInput.apply(null, arguments);
  } }, scopedSlots: t._u([{ key: "end", fn: function() {
    return [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-clone" } })];
  }, proxy: !0 }]) }, "base-input-text", t.$attrs, !1), t.$listeners))], 1);
}, Wx = [], Gx = /* @__PURE__ */ f(
  Vx,
  Hx,
  Wx,
  !1,
  null,
  "4b510a2b"
);
const Kx = Gx.exports, Yx = g({
  name: "AppImageUpload",
  props: {
    value: {
      type: String,
      required: !1
    },
    filePrefix: {
      type: String,
      default: "other/"
    },
    maxImageHeight: {
      type: Number,
      required: !0
    },
    maxImageWidth: {
      type: Number,
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    returnBlob: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      reloadKey: 0,
      imageCropInput: {}
    };
  },
  computed: {
    ratio() {
      return this.maxImageWidth / this.maxImageHeight;
    }
  },
  methods: {
    setImageUrl(s) {
      this.$emit("input", s ?? ""), this.resetInput();
    },
    onImageInput(s) {
      this.imageCropInput = s;
    },
    async onAcceptImageCrop(s) {
      if (this.returnBlob) {
        this.$emit("crop-accept", s), this.setImageUrl();
        return;
      }
      const t = await this.$api.fileUpload.uploadFile(
        s,
        this.filePrefix
      );
      this.setImageUrl(t.payload.location);
    },
    onRejectImageCrop() {
      this.resetInput();
    },
    onChangeImage() {
      var t, e;
      const s = (e = (t = this.$refs.imageInput) == null ? void 0 : t.$refs) == null ? void 0 : e.file;
      s ? s.click() : console.error("Could trigger inner file input to replace user image");
    },
    onRemoveImage() {
      this.setImageUrl();
    },
    resetInput() {
      this.imageCropInput = {}, this.reloadKey += 1;
    }
  }
});
var Xx = function() {
  var i, n;
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-form", { staticClass: "image-upload-container" }, [e("div", { staticClass: "image-container" }, [e("app-image-input", { ref: "imageInput", staticClass: "image-input", class: { rounded: t.rounded }, attrs: { "current-image": t.value, error: t.error, label: t.label, placeholder: t.placeholder, ratio: t.ratio, required: t.required }, on: { click: t.onChangeImage, "image-loaded": t.onImageInput } }), (i = t.imageCropInput) != null && i.src ? e("app-cropper-overlay", { key: t.reloadKey, attrs: { image: (n = t.imageCropInput) == null ? void 0 : n.src, "max-image-height": t.maxImageHeight, "max-image-width": t.maxImageWidth }, on: { "crop-accept": t.onAcceptImageCrop, "crop-cancel": t.onRejectImageCrop } }) : t._e()], 1), !t.required && t.value ? e("app-icon-button", { staticClass: "icon-container", attrs: { padding: 2, size: 38, frame: "square" }, on: { click: t.onRemoveImage } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-trash-can" } })], 1) : t._e()], 1);
}, Zx = [], Qx = /* @__PURE__ */ f(
  Yx,
  Xx,
  Zx,
  !1,
  null,
  "a5e39448"
);
const Jx = Qx.exports, tC = Rt.extend({
  name: "AppItemCard",
  props: {
    image: {
      type: String,
      required: !1
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !1
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    shadow: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasSlotControls() {
      return !!this.$slots.control;
    }
  }
});
var eC = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", t._g({ staticClass: "app-item-card", class: { clickable: t.clickable, shadow: t.shadow } }, t.$listeners), [t._t("image", function() {
    return [e("img", { staticClass: "card-image", attrs: { src: t.image } })];
  }), e("div", { staticClass: "card-content" }, [t.title ? e("div", { staticClass: "card-title" }, [t._v(" " + t._s(t.title) + " ")]) : t._e(), t.description ? e("div", { staticClass: "card-description" }, [t._t("description", function() {
    return [t._v(" " + t._s(t.description) + " ")];
  })], 2) : t._e()]), t.hasSlotControls ? e("div", { staticClass: "card-control" }, [t._t("control")], 2) : t._e()], 2);
}, sC = [], iC = /* @__PURE__ */ f(
  tC,
  eC,
  sC,
  !1,
  null,
  "f1fb7692"
);
const rr = iC.exports, nC = g({
  props: {
    icon: {
      type: String,
      required: !1
    },
    image: {
      type: String,
      required: !1
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !1
    }
  },
  computed: {
    hasSlotControls() {
      return !!this.$slots.controls;
    }
  }
});
var rC = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-list-item" }, [t.image ? e("img", { staticClass: "item-image", attrs: { src: t.image } }) : t.icon ? e("div", { staticClass: "icon-container" }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: t.icon } })], 1) : t._e(), e("div", { staticClass: "content" }, [e("div", { staticClass: "item-title" }, [t._v(t._s(t.title))]), t._t("description", function() {
    return [t.description ? e("div", { staticClass: "item-description" }, [t._v(" " + t._s(t.description) + " ")]) : t._e()];
  })], 2), t.hasSlotControls ? e("div", { staticClass: "controls" }, [t._t("controls")], 2) : t._e()]);
}, aC = [], oC = /* @__PURE__ */ f(
  nC,
  rC,
  aC,
  !1,
  null,
  "6fe92df4"
);
const lC = oC.exports, cC = g({
  props: {
    value: {
      type: Object,
      required: !1
    },
    fixedDimension: {
      type: String,
      required: !1
    },
    fractionDigits: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      innerValue: 0,
      dimension: "",
      unit: ""
    };
  },
  created() {
    this.dimension = this.fixedDimension ?? "", this.validateMeasurement(this.value) && this.applyMeasurement(this.value);
  },
  watch: {
    dimension() {
      this.unit = "";
    }
  },
  computed: {
    dimensionSelectorEnabled() {
      return !this.fixedDimension;
    },
    dimensionOptions() {
      return e_.map((s) => ({
        text: this.$t(`measure.dimension.${s}`).toString(),
        value: s
      }));
    },
    unitOptions() {
      return this.dimension ? o_[this.dimension].map((t) => ({
        text: this.$t(`measure.unit.${t}.name`).toString(),
        value: t
      })) : [];
    },
    measure() {
      return {
        dimension: this.dimension,
        unit: this.unit,
        value: this.innerValue
      };
    }
  },
  methods: {
    validateMeasurement(s) {
      return this.fixedDimension && (s == null ? void 0 : s.dimension) !== this.fixedDimension ? (console.error(
        `MeasurementInput is configured to allow only '${this.fixedDimension}'`
      ), !1) : !0;
    },
    applyMeasurement(s) {
      this.innerValue = (s == null ? void 0 : s.value) ?? 0, this.dimension = (s == null ? void 0 : s.dimension) ?? "", pe(() => {
        this.unit = (s == null ? void 0 : s.unit) ?? "";
      });
    },
    onUpdateValues() {
      const { dimension: s, unit: t } = this.measure;
      s && t ? this.$emit("input", this.measure) : this.$emit("input", void 0);
    }
  }
});
var uC = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("base-input-item", t._b({ staticClass: "app-measurement-input" }, "base-input-item", t.$attrs, !1), [e("div", { staticClass: "container" }, [e("app-number-input", { staticClass: "number-input", attrs: { "fraction-digits": t.fractionDigits }, on: { input: t.onUpdateValues }, model: { value: t.innerValue, callback: function(i) {
    t.innerValue = i;
  }, expression: "innerValue" } }), e("app-singleselect", { staticClass: "dimension-input", attrs: { enabled: t.dimensionSelectorEnabled, placeholder: t.$t("measure.dimension-label"), options: t.dimensionOptions, required: !0 }, on: { input: t.onUpdateValues }, model: { value: t.dimension, callback: function(i) {
    t.dimension = i;
  }, expression: "dimension" } }), t.dimension ? e("app-singleselect", { staticClass: "unit-input", attrs: { placeholder: t.$t("measure.unit-label"), options: t.unitOptions, required: !0 }, on: { input: t.onUpdateValues }, model: { value: t.unit, callback: function(i) {
    t.unit = i;
  }, expression: "unit" } }) : t._e()], 1)]);
}, dC = [], pC = /* @__PURE__ */ f(
  cC,
  uC,
  dC,
  !1,
  null,
  "4158bc2c"
);
const hC = pC.exports, fC = Rt.extend({
  name: "grid-layout",
  props: {
    columnsLg: {
      type: Number
    },
    columnsMd: {
      type: Number
    },
    columnsSm: {
      type: Number
    },
    columnsXs: {
      type: Number,
      default: 1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    columnCount() {
      switch (this.$breakpoint.name()) {
        case "xs":
          return this._columnsXs;
        case "sm":
          return this._columnsSm;
        case "md":
          return this._columnsMd;
        case "lg":
          return this._columnsLg;
        default:
          return this._columnsLg;
      }
    },
    _columnsXs() {
      return this.columnsXs;
    },
    _columnsSm() {
      return this.columnsSm || this._columnsXs;
    },
    _columnsMd() {
      return this.columnsMd || this._columnsSm;
    },
    _columnsLg() {
      return this.columnsLg || this._columnsMd;
    },
    hasPrependSlot() {
      return !!this.$slots.prepend;
    },
    style() {
      return {
        gridTemplateColumns: `repeat(${this.columnCount}, minmax(0, 1fr))`
      };
    }
  }
});
var mC = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.loading ? e("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [e("app-loading")], 1) : e("div", { staticClass: "grid-layout", style: t.style }, [t.hasPrependSlot ? e("div", { staticClass: "grid-layout-item" }, [t._t("prepend")], 2) : t._e(), t._l(t.data, function(i) {
    return e("div", { key: i.id, staticClass: "grid-layout-item" }, [t._t("default", null, { item: i })], 2);
  })], 2);
}, gC = [], _C = /* @__PURE__ */ f(
  fC,
  mC,
  gC,
  !1,
  null,
  null
);
const gc = _C.exports, yC = g({
  props: {
    title: {
      type: String,
      required: !1
    },
    data: {
      type: Array,
      default: () => []
    },
    displayCount: {
      type: Number,
      default: 3
    },
    level: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      displayAll: !1
    };
  },
  computed: {
    detail() {
      return this.showDisplayAllButton ? this.data.length.toString() : "";
    },
    displayData() {
      return this.displayAll ? this.data : this.data.slice(0, this.displayCount);
    },
    showDisplayAllButton() {
      return this.data.length > this.displayCount;
    },
    viewAllText() {
      const s = this.displayAll ? "common.viewLess" : "common.viewAll";
      return this.$t(s).toString();
    }
  },
  methods: {
    toggleDisplayAllItems() {
      this.displayAll = !this.displayAll;
    }
  }
});
var bC = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("section", { staticClass: "app-section-list" }, [e("app-heading", { attrs: { detail: t.detail, level: t.level, title: t.title }, scopedSlots: t._u([t.showDisplayAllButton ? { key: "action", fn: function() {
    return [e("view-all-button", { attrs: { text: t.viewAllText }, on: { click: t.toggleDisplayAllItems } })];
  }, proxy: !0 } : null], null, !0) }), e("div", { staticClass: "app-section-list-items" }, t._l(t.displayData, function(i, n) {
    return e("div", { key: n }, [t._t("default", null, { item: i })], 2);
  }), 0)], 1);
}, vC = [], kC = /* @__PURE__ */ f(
  yC,
  bC,
  vC,
  !1,
  null,
  "6ed8c69f"
);
const xC = kC.exports, qo = 2, CC = 40, wC = g({
  props: {
    value: {
      type: Array,
      required: !0
    },
    skillCatalog: {
      type: Array,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      required: !0
    },
    createItemLabel: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      reloadKey: 0,
      loading: !1,
      query: "",
      selection: []
    };
  },
  watch: {
    value(s) {
      this.selection = s;
    }
  },
  computed: {
    optionsAll() {
      return [...this.skillCatalog].sort().map((t) => ({
        text: t,
        value: t
      }));
    },
    optionsFiltered() {
      if (this.query.length < qo)
        return [];
      const s = this.query.toUpperCase();
      return this.optionsAll.filter(
        (t) => t.text.toUpperCase().includes(s)
      );
    },
    candidate() {
      const s = this.query.trim();
      if (!(s.length < qo || s.length > CC || this.skillCatalog.some(
        (e) => e.toUpperCase() === s.toUpperCase()
      )))
        return s;
    }
  },
  methods: {
    onToggleOpen(s) {
      s || (this.query = "");
    },
    onClickCreate() {
      this.$emit("create-skill", this.candidate);
    },
    onAddItem(s) {
      this.$emit("add-skill", s);
    },
    onRemoveItem(s) {
      this.$emit("remove-skill", s);
    }
  }
});
var $C = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-multiselect", { key: t.reloadKey, attrs: { label: t.label, placeholder: t.placeholder, options: t.optionsFiltered, "options-pool": t.optionsAll, loading: t.loading }, on: { "toggle-open": t.onToggleOpen, "selection-item-added": t.onAddItem, "selection-item-removed": t.onRemoveItem }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [e("app-search-input", { staticClass: "inner-search", attrs: { placeholder: t.searchPlaceholder }, model: { value: t.query, callback: function(i) {
      t.query = i;
    }, expression: "query" } })];
  }, proxy: !0 }, t.candidate ? { key: "controls", fn: function() {
    return [e("div", { staticClass: "candidate-item", on: { click: function(i) {
      return i.stopPropagation(), t.onClickCreate.apply(null, arguments);
    } } }, [t._v(" " + t._s(t.createItemLabel) + " "), e("span", { staticClass: "candidate-tag" }, [t._v(t._s(t.candidate))])])];
  }, proxy: !0 } : null], null, !0), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } });
}, SC = [], TC = /* @__PURE__ */ f(
  wC,
  $C,
  SC,
  !1,
  null,
  "6dac1c90"
);
const IC = TC.exports, AC = Rt.extend({
  name: "ViewAllButton",
  props: {
    level: {
      type: Number,
      default: 2
    },
    text: {
      type: String,
      required: !1
    }
  },
  computed: {
    levelClass() {
      return `level-${this.level}`;
    },
    buttonText() {
      return this.text ?? this.$t("common.viewAll").toString();
    }
  }
});
var PC = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("button", { staticClass: "view-all-button", class: t.levelClass, attrs: { name: "view-all-button" }, on: { click: function(i) {
    return t.$emit("click");
  } } }, [t._v(" " + t._s(t.buttonText) + " ")]);
}, OC = [], MC = /* @__PURE__ */ f(
  AC,
  PC,
  OC,
  !1,
  null,
  "30bd47dd"
);
const RC = MC.exports, EC = Rt.extend({
  props: {
    value: {
      type: Array,
      default: () => []
    },
    item: null
  }
});
var DC = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-ellipsis-menu", t._g({ attrs: { reference: t.item, "menu-options": t.value } }, t.$listeners));
}, FC = [], LC = /* @__PURE__ */ f(
  EC,
  DC,
  FC,
  !1,
  null,
  "f17bf594"
);
const qC = LC.exports, UC = g({
  name: "TableIcon",
  props: {
    header: Object,
    value: null,
    item: null
  }
});
var NC = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("fa-icon-compat", { staticClass: "table-icon", attrs: { icon: t.value } });
}, BC = [], jC = /* @__PURE__ */ f(
  UC,
  NC,
  BC,
  !1,
  null,
  "cdbc86a3"
);
const zC = jC.exports, VC = g({
  name: "ProductDropdown",
  props: {
    value: {
      type: String
    },
    context: {
      type: String,
      required: !0
    },
    products: {
      type: Array,
      required: !0
    },
    additionalSelectors: {
      type: Array,
      default: () => [],
      validator(s) {
        return s.every(
          (t) => ["all-products", "no-products"].includes(t)
        );
      }
    },
    workflows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filterSelection: this.value
    };
  },
  computed: {
    filterOptions() {
      const s = this.products.map((t) => ({
        text: t.toUpperCase(),
        value: t,
        image: this.getIcon(t)
      }));
      return this.additionalSelectors.includes("no-products") && s.unshift({
        text: this.$t("common.noProducts").toString(),
        value: "no-products",
        image: "/img/filter-none.svg"
      }), this.additionalSelectors.includes("all-products") && s.unshift({
        text: this.$t("common.allProducts").toString(),
        value: "all-products",
        image: "/img/filter-all.svg"
      }), s;
    }
  },
  methods: {
    getIcon(s) {
      const t = this.workflows.find(
        (i) => {
          var n;
          return ((n = i.product) == null ? void 0 : n.ticketType) === s;
        }
      );
      if (!t)
        return;
      const { icons: e } = Ge(t);
      return e.solid;
    },
    updatedSelections(s) {
      this.$emit("input", s);
    }
  }
});
var HC = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-singleselect", t._b({ staticClass: "filter-dropdown", attrs: { options: t.filterOptions }, on: { input: t.updatedSelections }, model: { value: t.filterSelection, callback: function(i) {
    t.filterSelection = i;
  }, expression: "filterSelection" } }, "app-singleselect", t.$attrs, !1));
}, WC = [], GC = /* @__PURE__ */ f(
  VC,
  HC,
  WC,
  !1,
  null,
  "abe4381e"
);
const ar = GC.exports, KC = g({});
var YC = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("img", { staticClass: "scary-skeleton-card", attrs: { src: "/img/skeleton-large.png" } });
}, XC = [], ZC = /* @__PURE__ */ f(
  KC,
  YC,
  XC,
  !1,
  null,
  "0825e214"
);
const QC = ZC.exports, JC = g({
  props: {
    value: {
      type: String,
      required: !0
    },
    rows: {
      type: Number,
      default: 2
    },
    mode: {
      type: String,
      default: "view"
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      text: ""
    };
  },
  watch: {
    value(s) {
      this.text !== s && (this.text = s, this.updateSize());
    }
  },
  created() {
    this.text = this.value;
  },
  mounted() {
    this.updateSize(), setTimeout(() => {
      this.updateSize();
    }, 500), setTimeout(() => {
      this.updateSize();
    }, 1e3);
  },
  computed: {
    disabled() {
      return !this.enabled || this.mode === "view";
    }
  },
  methods: {
    onUpdateModel(s) {
      var t;
      this.$emit("input", (t = s == null ? void 0 : s.target) == null ? void 0 : t.value), this.updateSize();
    },
    updateSize() {
      const s = this.$el, { clientHeight: t, scrollHeight: e } = s;
      e > t && (s.style.height = `${s.scrollHeight + 2}px`);
    },
    onBlur(s) {
      this.$emit("blur", s);
    },
    onKeydown(s) {
      this.$emit("keydown", s);
    }
  }
});
var tw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("textarea", { directives: [{ name: "model", rawName: "v-model", value: t.text, expression: "text" }], staticClass: "editable-text-area", class: [t.mode], attrs: { disabled: t.disabled, placeholder: t.placeholder, rows: t.rows }, domProps: { value: t.text }, on: { input: [function(i) {
    i.target.composing || (t.text = i.target.value);
  }, t.onUpdateModel], blur: t.onBlur, keydown: t.onKeydown } });
}, ew = [], sw = /* @__PURE__ */ f(
  JC,
  tw,
  ew,
  !1,
  null,
  "651f8024"
);
const or = sw.exports, iw = g({
  props: {
    label: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      required: !1
    },
    backgroundColor: {
      type: String,
      required: !1
    }
  },
  computed: {
    pillColour() {
      return {
        color: this.color,
        borderColor: this.color,
        backgroundColor: this.backgroundColor
      };
    }
  }
});
var nw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("span", { staticClass: "app-pill-container", style: t.pillColour }, [t._v(" " + t._s(t.label) + " ")]);
}, rw = [], aw = /* @__PURE__ */ f(
  iw,
  nw,
  rw,
  !1,
  null,
  "6fa48969"
);
const ow = aw.exports, lw = g({
  name: "TranslationBanner",
  props: {
    language: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      closed: !1
    };
  },
  computed: {
    text() {
      const s = this.$t(
        `translated-language.${this.language.original}`
      );
      return this.$t("common.translation.pageTranslated", {
        translatedLanguage: s
      }).toString();
    },
    show() {
      var s, t;
      return !!((s = this.language) != null && s.translatedTo) && ((t = this.language) == null ? void 0 : t.translatedTo) !== "none" && !this.closed;
    }
  },
  methods: {
    close() {
      this.closed = !0;
    }
  }
});
var cw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.show ? e("div", { staticClass: "translation-warning-container" }, [e("span", { staticClass: "translation-warning-text" }, [t._v(t._s(t.text))]), e("button", { staticClass: "button-close", on: { click: t.close } }, [e("fa-icon-compat", { attrs: { icon: "fal fa-times" } })], 1)]) : t._e();
}, uw = [], dw = /* @__PURE__ */ f(
  lw,
  cw,
  uw,
  !1,
  null,
  null
);
const pw = dw.exports, hw = g({
  props: {
    value: {
      type: String,
      default: ""
    },
    languages: {
      type: Array,
      default: () => []
    },
    defaultLanguage: {
      type: String,
      default: "EN"
    },
    error: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      required: !1
    },
    singleLanguageMode: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    currentTabKey() {
      this.$emit("input", this.currentTabKey);
    },
    value() {
      this.currentTabKey = this.value;
    }
  },
  data() {
    return {
      currentTabKey: this.defaultLanguage
    };
  },
  computed: {
    tabs() {
      let { languages: s } = this;
      s = this.languages.filter((e) => e !== this.defaultLanguage);
      const t = s.sort().map((e) => ({
        label: e.toUpperCase(),
        tabKey: e
      }));
      return t.unshift({
        label: `${this.defaultLanguage.toUpperCase()}*`,
        tabKey: this.defaultLanguage,
        error: this.error
      }), t;
    }
  }
});
var fw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-language-container", class: { singleLanguageMode: t.singleLanguageMode } }, [e("div", { staticClass: "wrapper" }, [t.title ? e("div", { staticClass: "title" }, [t._v(" " + t._s(t.title) + " ")]) : t._e(), e("app-tabs", { staticClass: "tabs", attrs: { tabs: t.tabs }, model: { value: t.currentTabKey, callback: function(i) {
    t.currentTabKey = i;
  }, expression: "currentTabKey" } })], 1), t._t("default")], 2);
}, mw = [], gw = /* @__PURE__ */ f(
  hw,
  fw,
  mw,
  !1,
  null,
  "4ed958cf"
);
const _c = gw.exports, _w = g({
  props: {
    methods: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    imageSelectorItems: {
      type: Array,
      default: () => []
    },
    itemsPerPage: {
      type: Number,
      default: 3
    },
    value: {
      type: String,
      default: ""
    },
    uploadMaxHeight: {
      type: Number,
      default: 350
    },
    uploadMaxWidth: {
      type: Number,
      default: 350
    },
    filePrefix: {
      type: String,
      default: ""
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      inputOptions: [
        {
          label: `${this.$t("form.imageInputContainer.upload")}`,
          value: "upload"
        },
        {
          label: `${this.$t("form.imageInputContainer.selectFromGallery")}`,
          value: "select"
        }
      ],
      radioInput: "upload",
      selectedInput: this.value,
      uploadInput: this.value
    };
  },
  computed: {
    hasUploadInputPermission() {
      return this.hasPermission("UPLOAD");
    },
    hasSelectInputPermission() {
      return this.hasPermission("GALLERY");
    },
    showUploadInput() {
      return this.showInputOptions && this.radioInput === "upload" || !this.showInputOptions && this.hasUploadInputPermission;
    },
    showSelectInput() {
      return this.showInputOptions && this.radioInput === "select" || !this.showInputOptions && this.hasSelectInputPermission;
    },
    showInputOptions() {
      return this.hasSelectInputPermission && this.hasUploadInputPermission;
    }
  },
  methods: {
    hasPermission(s) {
      return this.methods.includes(s);
    },
    radioChanged() {
      this.radioInput === "upload" && this.$emit("input", this.uploadInput), this.radioInput === "select" && this.$emit("input", this.selectedInput);
    }
  }
});
var yw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("base-input-label", { attrs: { required: t.required, label: t.label, tooltip: t.tooltip } }), t.showInputOptions ? e("div", { staticClass: "radio-buttons" }, t._l(t.inputOptions, function(i, n) {
    return e("label", { key: n }, [e("input", { directives: [{ name: "model", rawName: "v-model", value: t.radioInput, expression: "radioInput" }], attrs: { type: "radio" }, domProps: { value: i.value, checked: t._q(t.radioInput, i.value) }, on: { change: [function(r) {
      t.radioInput = i.value;
    }, t.radioChanged] } }), t._v(" " + t._s(i.label) + " ")]);
  }), 0) : t._e(), t.showUploadInput ? e("app-image-upload", { attrs: { "max-image-height": t.uploadMaxHeight, "max-image-width": t.uploadMaxWidth, required: t.required, "file-prefix": t.filePrefix, placeholder: t.$t("form.imageInputContainer.placeholderUploadImage"), rounded: t.rounded }, on: { input: function(i) {
    return t.$emit("input", i);
  } }, model: { value: t.uploadInput, callback: function(i) {
    t.uploadInput = i;
  }, expression: "uploadInput" } }) : t._e(), t.showSelectInput ? e("app-image-selector", { attrs: { items: t.imageSelectorItems, "items-per-page": t.itemsPerPage, rounded: t.rounded }, on: { input: function(i) {
    return t.$emit("input", i);
  } }, model: { value: t.selectedInput, callback: function(i) {
    t.selectedInput = i;
  }, expression: "selectedInput" } }) : t._e()], 1);
}, bw = [], vw = /* @__PURE__ */ f(
  _w,
  yw,
  bw,
  !1,
  null,
  "1e998fd6"
);
const kw = vw.exports, xw = g({
  props: {
    methods: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    imageSelectorItems: {
      type: Array,
      default: () => []
    },
    imageTicketItems: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ""
    },
    uploadMaxHeight: {
      type: Number,
      default: 350
    },
    uploadMaxWidth: {
      type: Number,
      default: 350
    },
    filePrefix: {
      type: String,
      default: ""
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    ticket: {
      type: Object,
      required: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      selectedInput: this.value,
      imageCropInput: {},
      showAiModal: !1,
      itemsPerPage: 3
    };
  },
  mounted() {
    window.addEventListener("resize", this.setItemsPerPage), setTimeout(this.setItemsPerPage, 400);
  },
  destroyed() {
    window.removeEventListener("resize", this.setItemsPerPage);
  },
  computed: {
    showAddImageCard() {
      return this.hasPermission("UPLOAD") || this.hasPermission("AI");
    },
    imageItems() {
      return this.hasPermission("GALLERY") ? this.imageTicketItems.concat(this.imageSelectorItems) : this.imageTicketItems;
    }
  },
  methods: {
    hasPermission(s) {
      return this.methods.includes(s);
    },
    onClickInput() {
      this.$refs.file.click();
    },
    onClickAi() {
      this.showAiModal = !0;
    },
    loadImage(s) {
      const t = this, { files: e } = s.target;
      e && e[0] && (t.src && URL.revokeObjectURL(t.src), t.src = URL.createObjectURL(e[0]), t.type = e[0].type, this.imageCropInput = { src: t.src, type: t.type }, t.$refs.file.value = "");
    },
    async onAcceptImageCrop(s) {
      const t = new File([s], "image.jpeg", {
        type: s.type
      });
      this.$emit("crop-accept", t), this.resetInput();
    },
    onRejectImageCrop() {
      this.resetInput();
    },
    resetInput() {
      this.imageCropInput = {};
    },
    setItemsPerPage() {
      const s = this.$el.querySelector(".carousel"), t = (s == null ? void 0 : s.offsetWidth) || 650, e = 215;
      this.itemsPerPage = Math.floor(t / e);
    }
  }
});
var Cw = function() {
  var i, n;
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("base-input-label", { attrs: { required: t.required, label: t.label, tooltip: t.tooltip, error: t.error } }), e("app-image-selector", { attrs: { items: t.imageItems, "items-per-page": t.itemsPerPage, "items-per-scroll": t.itemsPerPage, rounded: t.rounded, error: t.error }, on: { blur: function(r) {
    return t.$emit("blur", r);
  }, input: function(r) {
    return t.$emit("input", r);
  } }, scopedSlots: t._u([{ key: "add", fn: function() {
    return [t.showAddImageCard ? e("app-add-image-card", { attrs: { methods: t.methods, rounded: t.rounded, width: `${80 / t.itemsPerPage}%` }, on: { upload: t.onClickInput, ai: t.onClickAi } }) : t._e()];
  }, proxy: !0 }]), model: { value: t.selectedInput, callback: function(r) {
    t.selectedInput = r;
  }, expression: "selectedInput" } }), e("input", { ref: "file", staticClass: "hidden-file-input", attrs: { type: "file" }, on: { change: function(r) {
    return t.loadImage(r);
  } } }), (i = t.imageCropInput) != null && i.src ? e("app-cropper-overlay", { attrs: { image: (n = t.imageCropInput) == null ? void 0 : n.src, "max-image-height": t.uploadMaxHeight, "max-image-width": t.uploadMaxWidth }, on: { "crop-accept": t.onAcceptImageCrop, "crop-cancel": t.onRejectImageCrop } }) : t._e(), t.showAiModal ? e("app-image-ai-modal", { attrs: { ticket: t.ticket }, on: { close: function(r) {
    t.showAiModal = !1;
  }, generated: function(r) {
    return t.$emit("ai-generated");
  } } }) : t._e()], 1);
}, ww = [], $w = /* @__PURE__ */ f(
  xw,
  Cw,
  ww,
  !1,
  null,
  "d2ada205"
);
const Sw = $w.exports, Tw = g({
  props: {
    faIcon: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    theme: {
      type: String,
      default: "grey",
      validator(s) {
        return ["white", "grey"].includes(s);
      }
    }
  }
});
var Iw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-empty-view", class: [t.theme] }, [e("div", { staticClass: "empty-view-image" }, [e("fa-icon-compat", { staticClass: "fa-icon", attrs: { icon: t.faIcon } })], 1), e("div", { staticClass: "empty-view-title" }, [t._v(t._s(t.title))])]);
}, Aw = [], Pw = /* @__PURE__ */ f(
  Tw,
  Iw,
  Aw,
  !1,
  null,
  "df300cc3"
);
const Ow = Pw.exports, Mw = g({
  name: "EmptyCard",
  props: {
    resource: {
      type: Object,
      required: !0
    }
  },
  computed: {
    title() {
      return this.resource.title;
    },
    description() {
      return this.resource.text;
    },
    imageSrc() {
      return this.resource.image;
    },
    hasSlotActions() {
      return !!this.$slots.actions;
    }
  }
});
var Rw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "empty-card" }, [t.imageSrc ? e("img", { staticClass: "empty-card-image", attrs: { src: t.imageSrc } }) : t._e(), e("span", { staticClass: "empty-card-title" }, [t._v(t._s(t.title))]), t.description ? e("app-markdown-text", { staticClass: "empty-card-description", attrs: { text: t.description } }) : t._e(), t.hasSlotActions ? e("div", { staticClass: "empty-card-actions" }, [t._t("actions")], 2) : t._e()], 1);
}, Ew = [], Dw = /* @__PURE__ */ f(
  Mw,
  Rw,
  Ew,
  !1,
  null,
  "a5f15333"
);
const Fw = Dw.exports, Lw = g({
  props: {
    title: {
      type: String,
      required: !0
    },
    level: {
      type: Number,
      default: 2
    },
    viewState: {
      type: String,
      required: !0,
      validator(s) {
        return ["loading", "empty", "ready"].includes(s);
      }
    },
    overflow: {
      type: Boolean,
      default: !0
    }
  }
});
var qw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("section", { staticClass: "app-widget", class: { overflow: t.overflow } }, [e("app-heading", { staticClass: "widget-heading", attrs: { title: t.title, level: t.level }, scopedSlots: t._u([{ key: "action", fn: function() {
    return [t._t("action")];
  }, proxy: !0 }], null, !0) }), t.viewState === "loading" ? e("div", { staticClass: "widget-body widget-loading" }, [t._t("loading", function() {
    return [e("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [e("app-loading")], 1)];
  })], 2) : t.viewState === "empty" ? e("div", { staticClass: "widget-body widget-empty" }, [t._t("empty", function() {
    return [e("app-empty-view", { attrs: { title: t.$t("dashboard.noResultsFound"), "fa-icon": "fa-light fa-list-timeline" } })];
  })], 2) : t.viewState === "ready" ? e("div", { staticClass: "widget-body widget-ready" }, [t._t("ready")], 2) : t._e()], 1);
}, Uw = [], Nw = /* @__PURE__ */ f(
  Lw,
  qw,
  Uw,
  !1,
  null,
  "47e1e0ea"
);
const Bw = Nw.exports, jw = g({
  props: {
    methods: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      required: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      smallSlide: !1
    };
  },
  mounted() {
    window.addEventListener("resize", this.checkSlideWidth), setTimeout(this.checkSlideWidth, 400);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkSlideWidth);
  },
  computed: {
    slideWidth() {
      return {
        width: this.width
      };
    },
    showUpload() {
      return this.methods.includes("UPLOAD");
    },
    showAI() {
      return this.methods.includes("AI");
    },
    showOr() {
      return this.showUpload && this.showAI;
    }
  },
  methods: {
    checkSlideWidth() {
      const s = document.getElementById("text-container");
      this.smallSlide = (s == null ? void 0 : s.offsetWidth) < 185;
    }
  }
});
var zw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "slide", style: t.slideWidth }, [e("div", { staticClass: "image-wrapper" }, [e("app-image", { class: { "image-rounded": t.rounded }, attrs: { src: "/img/add-image-card.svg", height: "fit-content", width: "fit-content" } }), e("div", { staticClass: "text-container", class: { "small-slide": t.smallSlide }, attrs: { id: "text-container" } }, [t.showUpload ? e("span", { staticClass: "link", on: { click: function(i) {
    return t.$emit("upload");
  } } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-light fa-cloud-arrow-up" } }), e("button", [t._v(t._s(t.$t("page.addImageCard.uploadImage")))])], 1) : t._e(), t.showOr ? e("div", { staticClass: "or" }, [t._v(t._s(t.$t("page.addImageCard.or")))]) : t._e(), t.showAI ? e("span", { staticClass: "link", on: { click: function(i) {
    return t.$emit("ai");
  } } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-light fa-robot" } }), e("button", [t._v(t._s(t.$t("page.addImageCard.generateWithAI")))])], 1) : t._e()])], 1)]);
}, Vw = [], Hw = /* @__PURE__ */ f(
  jw,
  zw,
  Vw,
  !1,
  null,
  "98954df5"
);
const Ww = Hw.exports, Gw = g({
  props: {
    ticket: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      prompt: "",
      step: 1,
      imageUrl: [],
      selectedStyle: ""
    };
  },
  computed: {
    title() {
      switch (this.step) {
        case 1:
          return this.$t("modal.imageAiModal.titles.step1");
        case 2:
          return this.$t("modal.imageAiModal.titles.step2");
        case 3:
          return this.$t("modal.imageAiModal.titles.step3");
        default:
          return "";
      }
    },
    styleOptions() {
      const s = this.$t(
        "modal.imageAiModal.styles.options"
      ), t = [];
      for (const [e, i] of Object.entries(s))
        t.push({
          text: i,
          value: this.$t(
            `modal.imageAiModal.styles.options.${e}`,
            "en"
          ).toString()
        });
      return t;
    }
  },
  methods: {
    async generateImage() {
      const s = {
        prompt: `${this.prompt} in Style ${this.selectedStyle} `,
        n: 1,
        aspectRation: 1.537037037,
        category: "cover/ai"
      };
      try {
        this.step = 2, this.imageUrl = await this.$api.ticket.generateTicketAi(
          this.ticket.type,
          this.ticket.canonicalId,
          s
        ), this.step = 3, this.$toast(this.$t("common.toast.imageToGallery").toString());
      } catch (t) {
        t.status === 400 ? this.$toast(
          this.$t("modal.imageAiModal.toastErrorMessage").toString()
        ) : this.$toast(this.$t("error.general").toString()), this.onClose();
      }
    },
    onClose() {
      this.$emit("close");
    },
    done() {
      this.$emit("generated");
    }
  }
});
var Kw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { on: { "click-outside": t.onClose } }, [e("div", { staticClass: "modal-content" }, [e("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: t.onClose } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), e("h2", { staticClass: "modal-title" }, [t._v(" " + t._s(t.title))]), t.step === 1 ? e("div", { staticClass: "content-container step-1" }, [e("app-text-area", { staticClass: "textarea", attrs: { label: t.$t("modal.imageAiModal.textarea.label"), placeholder: t.$t("modal.imageAiModal.textarea.placeholder"), required: !0, rows: 4 }, model: { value: t.prompt, callback: function(i) {
    t.prompt = i;
  }, expression: "prompt" } }), e("app-singleselect", { staticClass: "select-options", attrs: { placeholder: t.$t("modal.imageAiModal.styles.placeholder"), options: t.styleOptions, label: t.$t("modal.imageAiModal.styles.label") }, model: { value: t.selectedStyle, callback: function(i) {
    t.selectedStyle = i;
  }, expression: "selectedStyle" } }), e("div", [e("app-button", { staticClass: "generate-button", attrs: { label: t.$t("modal.imageAiModal.buttons.generateImage"), enabled: !!t.prompt }, on: { click: t.generateImage } })], 1)], 1) : t._e(), t.step === 2 ? e("div", { staticClass: "content-container step-2" }, [e("div", { staticClass: "loader" }), e("div", { staticClass: "content" }, [t._v(t._s(t.$t("modal.imageAiModal.generatingImage")))])]) : t._e(), t.step === 3 ? e("div", { staticClass: "content-container step-3" }, [e("app-image", { staticClass: "app-image", attrs: { src: t.imageUrl[0], type: "square", width: "250px", height: "148px" } }), e("div", [e("app-button", { attrs: { label: t.$t("modal.imageAiModal.buttons.done") }, on: { click: function(i) {
    return t.done();
  } } })], 1)], 1) : t._e()], 1)]);
}, Yw = [], Xw = /* @__PURE__ */ f(
  Gw,
  Kw,
  Yw,
  !1,
  null,
  "28b63696"
);
const Zw = Xw.exports, Qw = g({
  props: {},
  data() {
    return {
      sidePanelVisible: !0
    };
  },
  computed: {
    toggleIcon() {
      return this.sidePanelVisible ? "fa-solid fa-chevron-left" : "fa-solid fa-chevron-right";
    },
    panelToggleCssClass() {
      return this.sidePanelVisible ? ["side-panel-visible"] : ["side-panel-hidden"];
    }
  },
  methods: {
    toggleSidePanel() {
      this.sidePanelVisible = !this.sidePanelVisible;
    }
  }
});
var Jw = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-collapsible-panels" }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.sidePanelVisible, expression: "sidePanelVisible" }], staticClass: "panel-side" }, [t._t("side-panel")], 2), e("div", { staticClass: "panel-main" }, [e("div", { staticClass: "panel-toggle", class: t.panelToggleCssClass }, [e("app-icon-button", { staticClass: "app-icon-button", attrs: { padding: 4, size: 24 }, on: { click: t.toggleSidePanel } }, [e("fa-icon-compat", { attrs: { icon: t.toggleIcon } })], 1)], 1), t._t("main-panel")], 2)]);
}, t$ = [], e$ = /* @__PURE__ */ f(
  Qw,
  Jw,
  t$,
  !1,
  null,
  "c4e16d3e"
);
const s$ = e$.exports, i$ = Rt.extend({
  props: {
    label: null
  }
});
var n$ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "label-value-container" }, [e("div", { staticClass: "label" }, [t._v(t._s(t.label))]), e("div", { staticClass: "value" }, [t._t("default")], 2)]);
}, r$ = [], a$ = /* @__PURE__ */ f(
  i$,
  n$,
  r$,
  !1,
  null,
  "587b135d"
);
const lr = a$.exports, o$ = Rt.extend({
  name: "AppAccordion",
  props: {
    // Only one element with the same name can be opened at the same time
    name: {
      type: String,
      default: ""
    },
    open: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mounted: !1
    };
  },
  mounted() {
    this.mounted = !0;
  }
});
var l$ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.mounted ? e("details", { attrs: { name: t.name, open: t.open } }, [e("summary", [e("div", { staticClass: "summary-slot" }, [t._t("summary")], 2)]), e("article", [t._t("content")], 2)]) : t._e();
}, c$ = [], u$ = /* @__PURE__ */ f(
  o$,
  l$,
  c$,
  !1,
  null,
  "8fcb6848"
);
const d$ = u$.exports, p$ = g({
  props: {
    label: {
      type: String,
      required: !1
    },
    searchLabel: {
      type: String,
      required: !1
    },
    searchEnabled: {
      type: Boolean,
      required: !1,
      default: !0
    },
    value: {
      type: Array,
      required: !0
    },
    availableOptions: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      searchText: ""
    };
  },
  computed: {
    labelCounter() {
      return `${this.label} (${this.value.length})`;
    },
    filteredOptions() {
      const s = this.searchText.toLowerCase();
      return this.availableOptions.forEach((t) => {
        t.selected = this.value.includes(t.value);
      }), this.availableOptions.filter((t) => {
        var e;
        return t.value.toLowerCase().includes(s.replaceAll(" ", "_")) || ((e = t.description) == null ? void 0 : e.toLowerCase().includes(s));
      }).sort((t, e) => t.selected && !e.selected ? -1 : !t.selected && e.selected ? 1 : 0);
    }
  },
  methods: {
    toggleOption(s) {
      s.selected ? this.removeOption(s) : this.addOption(s), this.$emit("input", this.value);
    },
    removeOption(s) {
      const t = this.value.indexOf(s.value);
      t !== -1 && this.value.splice(t, 1);
    },
    addOption(s) {
      this.availableOptions.indexOf(s) !== -1 && this.value.push(s.value);
    }
  }
});
var h$ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("div", { staticClass: "label" }, [t._v(" " + t._s(t.labelCounter) + " ")]), t.searchEnabled ? t._t("search", function() {
    return [e("app-search-input", { staticClass: "search-input", attrs: { placeholder: t.searchLabel || "Search" }, model: { value: t.searchText, callback: function(i) {
      t.searchText = i;
    }, expression: "searchText" } })];
  }) : t._e(), e("ul", { staticClass: "list" }, t._l(t.filteredOptions, function(i) {
    return e("li", { key: i.value, staticClass: "list-item", class: i.selected ? "selected" : "" }, [e("div", { staticClass: "item-content" }, [e("div", { staticClass: "name" }, [t._v(t._s(i.value))]), e("div", { staticClass: "description" }, [t._v(t._s(i.description))])]), e("button", { staticClass: "action-button", on: { click: function(n) {
      return t.toggleOption(i);
    } } }, [e("fa-icon-compat", { attrs: { icon: `fa-regular fa-${i.selected ? "xmark" : "plus"}` } })], 1)]);
  }), 0)], 2);
}, f$ = [], m$ = /* @__PURE__ */ f(
  p$,
  h$,
  f$,
  !1,
  null,
  "d21c0db8"
);
const g$ = m$.exports, Uo = 2, _$ = 40, y$ = g({
  props: {
    value: {
      type: Array,
      required: !0
    },
    catalog: {
      type: Array,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      required: !0
    },
    createItemLabel: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      reloadKey: 0,
      loading: !1,
      query: "",
      selection: []
    };
  },
  watch: {
    value(s) {
      this.selection = s;
    }
  },
  computed: {
    optionsAll() {
      return [...this.catalog].sort().map((t) => ({
        text: t,
        value: t
      }));
    },
    optionsFiltered() {
      if (this.query.length < Uo)
        return [];
      const s = this.query.toUpperCase();
      return this.optionsAll.filter(
        (t) => t.text.toUpperCase().includes(s)
      );
    },
    candidate() {
      const s = this.query.trim();
      if (!(s.length < Uo || s.length > _$ || this.catalog.some(
        (e) => e.toUpperCase() === s.toUpperCase()
      )))
        return s;
    }
  },
  methods: {
    onToggleOpen(s) {
      s || (this.query = "");
    },
    onClickCreate() {
      this.$emit("create-tag", this.candidate);
    },
    onAddItem(s) {
      this.$emit("add-tag", s);
    },
    onRemoveItem(s) {
      this.$emit("remove-tag", s);
    }
  }
});
var b$ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-multiselect", { key: t.reloadKey, attrs: { label: t.label, placeholder: t.placeholder, options: t.optionsFiltered, "options-pool": t.optionsAll, loading: t.loading }, on: { "toggle-open": t.onToggleOpen, "selection-item-added": t.onAddItem, "selection-item-removed": t.onRemoveItem }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [e("app-search-input", { staticClass: "inner-search", attrs: { placeholder: t.searchPlaceholder }, model: { value: t.query, callback: function(i) {
      t.query = i;
    }, expression: "query" } })];
  }, proxy: !0 }, t.candidate ? { key: "controls", fn: function() {
    return [e("div", { staticClass: "candidate-item", on: { click: function(i) {
      return i.stopPropagation(), t.onClickCreate.apply(null, arguments);
    } } }, [t._v(" " + t._s(t.createItemLabel) + " "), e("span", { staticClass: "candidate-tag" }, [t._v(t._s(t.candidate))])])];
  }, proxy: !0 } : null], null, !0), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } });
}, v$ = [], k$ = /* @__PURE__ */ f(
  y$,
  b$,
  v$,
  !1,
  null,
  "5f181f1a"
);
const x$ = k$.exports, C$ = g({
  props: {
    title: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      required: !0
    },
    provider: {
      type: Function,
      required: !0
    }
  },
  computed: {
    content() {
      return this.provider(this.path);
    }
  }
});
var w$ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-accordion", { staticClass: "app-accordion", scopedSlots: t._u([{ key: "summary", fn: function() {
    return [e("div", { staticClass: "app-documentation-title" }, [t._v(t._s(t.title))])];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [e("app-markdown-text", { attrs: { text: t.content } })];
  }, proxy: !0 }]) });
}, $$ = [], S$ = /* @__PURE__ */ f(
  C$,
  w$,
  $$,
  !1,
  null,
  "b342d788"
);
const T$ = S$.exports, I$ = /* @__PURE__ */ g({
  __name: "PlaceholderDescription",
  props: {
    placeholders: null
  },
  setup(s) {
    return { __sfc: !0 };
  }
});
var A$ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-section", { attrs: { level: 2, title: t.$t("page.admin.editPrompt.placeholders") } }, t._l(t.placeholders, function(i) {
    return e("div", { key: i.key, staticClass: "placeholders-container" }, [e("div", { staticClass: "title" }, [e("span", [t._v(t._s(i.key))]), i.required ? e("span", [t._v("*")]) : t._e()]), e("div", { staticClass: "description" }, [t._v(t._s(i.description))])]);
  }), 0);
}, P$ = [], O$ = /* @__PURE__ */ f(
  I$,
  A$,
  P$,
  !1,
  null,
  "ed367cb5"
);
const M$ = O$.exports, R$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddButton: uc,
  AppAccordion: d$,
  AppAddImageCard: Ww,
  AppBanner: Rx,
  AppBounceLoading: qx,
  AppCollapsiblePanels: s$,
  AppCopyInput: Kx,
  AppDeleteButton: zx,
  AppDocumentation: T$,
  AppEmptyView: Ow,
  AppEmptyViewResource: Fw,
  AppImageAiModal: Zw,
  AppImageInputContainer: kw,
  AppImageInputSelectorContainer: Sw,
  AppImageUpload: Jx,
  AppItemCard: rr,
  AppLabelValue: lr,
  AppLanguageSection: _c,
  AppListItem: lC,
  AppMeasurementInput: hC,
  AppPill: ow,
  AppSectionList: xC,
  AppWidget: Bw,
  EditableTextArea: or,
  GenericTagsMultiselect: x$,
  GridLayout: gc,
  ListMultiSelect: g$,
  PlaceholderDescription: M$,
  ProductDropdown: ar,
  ScarySkeletonCard: QC,
  SkillsMultiselect: IC,
  TableActions: qC,
  TableIcon: zC,
  TranslationBanner: pw,
  ViewAllButton: RC
}, Symbol.toStringTag, { value: "Module" })), E$ = Rt.extend({
  name: "TeamMemberCard",
  components: { AppItemCard: rr },
  props: {
    userData: {
      type: Object,
      required: !0
    },
    menuOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    id() {
      return this.userData.user.id;
    },
    image() {
      return this.userData.user.avatar;
    },
    displayName() {
      return E(this.userData).displayName();
    },
    userDepartment() {
      return E(this.userData).userDepartment();
    }
  }
});
var D$ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-item-card", { staticClass: "team-member-card", attrs: { description: t.userDepartment, image: t.image, shadow: !0, title: t.displayName }, scopedSlots: t._u([t.image ? null : { key: "image", fn: function() {
    return [e("div", { staticClass: "avatar" }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-solid fa-user" } })], 1)];
  }, proxy: !0 }, { key: "control", fn: function() {
    return [t.menuOptions.filter((i) => i.visible || i.visible === void 0).length ? e("app-ellipsis-menu", t._g({ attrs: { "menu-options": t.menuOptions, reference: { id: t.id } } }, t.$listeners)) : t._e()];
  }, proxy: !0 }], null, !0) });
}, F$ = [], L$ = /* @__PURE__ */ f(
  E$,
  D$,
  F$,
  !1,
  null,
  "f7b0e3d2"
);
const yc = L$.exports, q$ = "/img/profile-placeholder.svg", U$ = 180, N$ = g({
  props: {
    value: {
      type: Array,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    userCountLabel: {
      type: String,
      default: ""
    },
    additionalHeaders: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        query: "",
        filters: {
          teams: [],
          languages: [],
          active: !1
        }
      },
      loading: !1,
      loadingUserBatch: !1,
      users: [],
      userIds: [],
      selection: [],
      isFiltersSlotVisible: !0,
      currentPage: 0,
      pageSize: 100,
      scrollElement: null
    };
  },
  created() {
    this.selection = [...this.value];
  },
  mounted() {
    var s;
    this.scrollElement = this.$refs["user-table-container"], (s = this.scrollElement) == null || s.addEventListener("scroll", this.scrollListener, {
      passive: !0
    });
  },
  destroyed() {
    var s;
    (s = this.scrollElement) == null || s.removeEventListener("scroll", this.scrollListener);
  },
  watch: {
    value(s) {
      this.selection = [...s];
    }
  },
  computed: {
    tableData() {
      return this.users.map((s) => ({
        ...s.user,
        id: s.user.id,
        avatar: s.user.avatar || q$,
        name: this.displayName(s),
        unitName: this.userDepartment(s)
      }));
    },
    tableHeaders() {
      return [
        {
          key: "avatar",
          label: "",
          width: "50px",
          component: "table-image-avatar"
        },
        {
          key: "name",
          label: this.$t("common.name"),
          width: "100%"
        },
        ...this.additionalHeaders
      ];
    },
    tableConfig() {
      return {
        selection: {
          mode: "multiple",
          selectAllButton: !0
        }
      };
    },
    hasSlotFilters() {
      return !!this.$scopedSlots.filters;
    },
    isEmpty() {
      return !this.loading && this.users.length === 0;
    },
    showUserCount() {
      return !!this.userCountLabel;
    },
    lastPage() {
      const s = Math.ceil(this.userIds.length / this.pageSize);
      return this.currentPage >= s;
    },
    loadingMore() {
      return !this.lastPage && this.userIds.length > 0 && this.currentPage > 0;
    }
  },
  methods: {
    onToggleFiltersSlot() {
      this.isFiltersSlotVisible = !this.isFiltersSlotVisible;
    },
    onDirty() {
      this.loading = !0;
    },
    async onSubmit() {
      const s = this.form.query, t = this.form.filters;
      try {
        if (this.filterIsEmpty(s, t)) {
          this.users = [];
          return;
        }
        this.loading = !0, this.users = [], this.userIds = await this.$gateway.search.searchUserIds({
          query: s,
          filter: {
            unit: t.teams,
            skills: [],
            language: t.languages,
            active: t.active
          },
          limit: 1e4
          // It's over 9000!!!
        }), this.currentPage = 0, this.loadUsers();
      } catch {
        console.error("Error searching for users"), this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1;
      }
    },
    filterIsEmpty(s, t) {
      return s.length > 2 ? !1 : !Object.values(t).some((e) => typeof e == "string" && e.length > 2 ? !0 : Array.isArray(e) && e.length > 0);
    },
    displayName(s) {
      return E(s).displayName();
    },
    userDepartment(s) {
      return E(s).userDepartment();
    },
    onConfirm() {
      this.$emit("input", [...this.selection]), this.$emit("save");
    },
    onCancel() {
      this.$emit("close");
    },
    async loadUsers() {
      try {
        this.loadingUserBatch = !0;
        const s = this.currentPage * this.pageSize, t = s + this.pageSize, e = await this.$gateway.portal.findUsersById(
          this.userIds.slice(s, t)
        );
        this.users = [...this.users, ...e];
      } catch {
        console.error("Error loading users"), this.$toast(this.$t("error.general").toString());
      } finally {
        this.loadingUserBatch = !1;
      }
    },
    scrollListener() {
      if (this.lastPage || this.loading || this.loadingUserBatch)
        return;
      const { scrollTop: s, scrollHeight: t, clientHeight: e } = this.scrollElement;
      t - (s + e) < U$ && this.loadMore();
    },
    loadMore() {
      this.lastPage || this.loading || this.loadingUserBatch || (this.currentPage += 1, this.loadUsers());
    }
  }
});
var B$ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { staticClass: "user-list-modal", on: { "click-outside": t.onCancel } }, [e("app-form", { staticClass: "search-form", attrs: { form: t.form, "auto-submit": !0 }, on: { dirty: t.onDirty, submit: t.onSubmit } }, [e("div", { staticClass: "search-filters-container" }, [e("app-search-input", { staticClass: "app-search-input", attrs: { placeholder: t.searchPlaceholder }, model: { value: t.form.query, callback: function(i) {
    t.$set(t.form, "query", i);
  }, expression: "form.query" } }), t.hasSlotFilters ? e("app-icon-button", { staticClass: "toggle-filters-button", attrs: { size: 32 }, on: { click: t.onToggleFiltersSlot } }, [e("fa-icon-compat", { attrs: { icon: "fa-solid fa-sliders" } })], 1) : t._e()], 1), t.isFiltersSlotVisible ? e("div", [t._t("filters", null, { filters: t.form.filters })], 2) : t._e(), t.showUserCount ? e("div", { staticClass: "user-selection-label" }, [t._v(" " + t._s(t.userCountLabel) + ": "), e("span", { staticClass: "user-selection-count" }, [t._v(t._s(t.selected.size))])]) : t._e()]), e("div", { ref: "user-table-container", staticClass: "user-table-container" }, [t.loading ? e("app-overlay", { attrs: { theme: "light", "center-content": !0, "full-page": !1 } }, [e("app-loading")], 1) : t.isEmpty ? e("app-empty-view", { staticClass: "widget-empty", attrs: { title: t.$t("error.nothingFound"), "fa-icon": "fa-regular fa-user-check" } }) : e("app-data-table", { attrs: { data: t.tableData, headers: t.tableHeaders, config: t.tableConfig }, model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } }), t.loadingMore ? e("div", { staticClass: "load-more" }, [t._v(" " + t._s(t.$t("search.label-loading-more")) + " ")]) : t._e()], 1), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center", theme: "gray" } }, [e("app-button", { attrs: { label: t.$t("common.form.confirm") }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1);
}, j$ = [], z$ = /* @__PURE__ */ f(
  N$,
  B$,
  j$,
  !1,
  null,
  "7150c23a"
);
const cr = z$.exports, V$ = g({
  components: {
    GridLayout: gc,
    AddButton: uc,
    UserSelectionModal: cr,
    TeamMemberCard: yc
  },
  props: {
    labelAddButton: {
      type: String,
      required: !1
    },
    users: {
      type: Array,
      required: !0
    },
    minimumUserCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    menuOptions() {
      return [
        {
          label: this.$t("common.form.delete").toString(),
          tabKey: "delete",
          visible: this.users.length > this.minimumUserCount
        }
      ];
    },
    gridConfig() {
      return { summary: "disabled", item: { minWidth: 270, maxWidth: 339 } };
    }
  },
  methods: {
    onDelete({ id: s }) {
      this.$emit("remove-member", s);
    },
    onClickAdd() {
      this.$emit("select-members");
    }
  }
});
var H$ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-data-grid", { attrs: { data: t.users, config: t.gridConfig }, scopedSlots: t._u([{ key: "prepend", fn: function() {
    return [e("add-button", { staticClass: "add-button", attrs: { text: t.labelAddButton }, on: { click: t.onClickAdd } })];
  }, proxy: !0 }, { key: "default", fn: function({ item: i }) {
    return [e("team-member-card", { staticClass: "team-member-card", attrs: { "user-data": i, "menu-options": t.menuOptions }, on: { "click:delete": t.onDelete } })];
  } }]) });
}, W$ = [], G$ = /* @__PURE__ */ f(
  V$,
  H$,
  W$,
  !1,
  null,
  "64641936"
);
const K$ = G$.exports, Y$ = g({
  components: {
    TeamMemberList: K$,
    UserSelectionModal: cr
  },
  props: {
    teamId: {
      type: String,
      required: !0
    },
    teamType: {
      type: String,
      required: !0
    },
    labelOwners: {
      type: String,
      required: !0
    },
    labelMembers: {
      type: String,
      required: !0
    },
    buttonAddOwner: {
      type: String,
      required: !0
    },
    buttonAddMember: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      teamMembers: [],
      users: [],
      selection: null
    };
  },
  async created() {
    await this.reload();
  },
  computed: {
    additionalHeaders() {
      return [
        {
          key: "unitName",
          label: this.$t("common.unit"),
          align: "end",
          width: "200px"
        }
      ];
    }
  },
  methods: {
    async reload() {
      const s = await this.$api.team.fetchTeamMembers(
        this.teamId
      ), t = s.map(({ userId: i }) => i), e = await this.$gateway.portal.findUsersById(t);
      this.teamMembers = s, this.users = e.sort(
        (i, n) => i.user.firstName.localeCompare(n.user.firstName)
      );
    },
    getUserIds(s) {
      return this.teamMembers.filter((t) => t.roles.includes(s)).map((t) => t.userId);
    },
    getUserList(s) {
      const t = this.getUserIds(s);
      return this.users.filter((e) => t.includes(e.user.id));
    },
    onMemberSelection(s) {
      this.selection = {
        role: s,
        ids: this.getUserIds(s)
      };
    },
    async onRemoveMember(s, t) {
      try {
        await this.$gateway.team.removeTeamMembers({
          teamId: this.teamId,
          role: s,
          userIds: [t]
        });
      } catch {
        console.error("Could not remove team member"), this.$toast(this.$t("error.general").toString());
      } finally {
        await this.reload();
      }
    },
    async onSaveSelection() {
      var s, t;
      if (this.selection) {
        try {
          await this.$gateway.team.updateTeamMembers({
            teamId: this.teamId,
            role: (s = this.selection) == null ? void 0 : s.role,
            userIds: (t = this.selection) == null ? void 0 : t.ids,
            teamType: this.teamType
          });
        } catch (e) {
          console.error("Could not update team members", e), this.$toast(this.$t("error.general").toString());
        } finally {
          await this.reload();
        }
        this.selection = null;
      }
    },
    onCancelSelection() {
      this.selection = null;
    }
  }
});
var X$ = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "team-container" }, [e("base-input-item", { attrs: { label: t.labelOwners } }, [e("team-member-list", { attrs: { "label-add-button": t.buttonAddOwner, users: t.getUserList("owner"), "minimum-user-count": 1 }, on: { "select-members": function(i) {
    return t.onMemberSelection("owner");
  }, "remove-member": function(i) {
    return t.onRemoveMember("owner", i);
  } } })], 1), e("base-input-item", { attrs: { label: t.labelMembers } }, [e("team-member-list", { attrs: { "label-add-button": t.buttonAddMember, users: t.getUserList("member") }, on: { "select-members": function(i) {
    return t.onMemberSelection("member");
  }, "remove-member": function(i) {
    return t.onRemoveMember("member", i);
  } } })], 1), t.selection ? e("user-selection-modal", { attrs: { "additional-headers": t.additionalHeaders }, on: { save: t.onSaveSelection, close: t.onCancelSelection }, model: { value: t.selection.ids, callback: function(i) {
    t.$set(t.selection, "ids", i);
  }, expression: "selection.ids" } }) : t._e()], 1);
}, Z$ = [], Q$ = /* @__PURE__ */ f(
  Y$,
  X$,
  Z$,
  !1,
  null,
  "cf5820df"
);
const bc = Q$.exports, J$ = g({
  name: "TeamForm",
  components: {
    AppLanguageSection: _c,
    TeamMemberManagement: bc
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    team: {
      type: Object,
      default: () => ({})
    },
    teamType: {
      type: String,
      required: !1
    },
    tagsVisible: {
      type: Boolean,
      default: !0
    },
    validationKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: !1,
      form: {
        resources: {}
      },
      error: {
        resources: {
          name: !1,
          description: !1,
          publicDescription: !1
        }
      },
      selectedGenericTags: [],
      allGenericTags: [],
      selectedLanguage: ""
    };
  },
  watch: {
    validationKey(s) {
      s > 0 && this.onUpdate();
    }
  },
  async created() {
    this.loading = !0, this.tagsVisible && ([this.allGenericTags, this.selectedGenericTags] = await Promise.all([
      this.$api.genericTags.fetchGenericTagsCatalog("team"),
      this.$api.genericTags.fetchGenericTags("team", this.team.id)
    ])), this.selectedLanguage = this.defaultLanguage, this.form.resources = this.languages.reduce(
      (s, t) => (s[t] = {}, s),
      {}
    ), this.form.resources = Object.assign(
      this.form.resources,
      this.team.resources
    ), this.migrateFieldsCompat(), this.loading = !1;
  },
  computed: {
    teamData() {
      const s = {
        ...this.team,
        resources: this.form.resources
      };
      return s.name = this.form.resources[this.defaultLanguage].name, s.description = this.form.resources[this.defaultLanguage].description ?? "", {
        team: s,
        actions: [],
        tags: this.tagsVisible ? this.selectedGenericTags : void 0
      };
    },
    requiresCurrentLanguage() {
      return this.selectedLanguage === this.defaultLanguage;
    },
    languages() {
      return this.organization.language.available;
    },
    defaultLanguage() {
      return this.organization.language.default;
    }
  },
  methods: {
    validate() {
      var s, t, e;
      return this.error.resources.name = !this.validateNotEmpty(
        (s = this.form.resources[this.defaultLanguage]) == null ? void 0 : s.name
      ), this.error.resources.description = !this.validateNotEmpty(
        (t = this.form.resources[this.defaultLanguage]) == null ? void 0 : t.description
      ), this.error.resources.publicDescription = this.teamType === "WORKGROUP" && !this.validateNotEmpty(
        (e = this.form.resources[this.defaultLanguage]) == null ? void 0 : e.publicDescription
      ), !this.error.resources.name && !this.error.resources.description && !this.error.resources.publicDescription;
    },
    validateNotEmpty(s) {
      return !!(s ?? "").trim();
    },
    migrateFieldsCompat() {
      const s = this.form.resources[this.selectedLanguage];
      s.name || (s.name = this.team.name || ""), s.description || (s.description = this.team.description || "");
    },
    onUpdate() {
      this.validate() ? this.$emit("input", this.teamData) : this.$emit("input", null);
    },
    addGenericTag(s) {
      this.selectedGenericTags.push(s), this.allGenericTags.push(s), this.allGenericTags = [...new Set(this.allGenericTags)], this.onUpdate();
    },
    removeGenericTag(s) {
      this.selectedGenericTags = this.selectedGenericTags.filter(
        (t) => t !== s
      ), this.onUpdate();
    }
  }
});
var tS = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "team-container" }, [e("app-form", [t.languages.length && !t.loading ? e("app-language-section", { attrs: { error: t.error.resources.name, "default-language": t.defaultLanguage, languages: t.languages }, model: { value: t.selectedLanguage, callback: function(i) {
    t.selectedLanguage = i;
  }, expression: "selectedLanguage" } }, [e("app-text-input", { attrs: { error: t.error.resources.name && t.requiresCurrentLanguage, label: t.$t("form.teamForm.teamName"), placeholder: t.$t("form.teamForm.teamName"), required: !0 }, model: { value: t.form.resources[t.selectedLanguage].name, callback: function(i) {
    t.$set(t.form.resources[t.selectedLanguage], "name", i);
  }, expression: "form.resources[selectedLanguage].name" } }), e("app-text-area", { attrs: { error: t.error.resources.description && t.requiresCurrentLanguage, label: t.$t("form.teamForm.teamDescription"), placeholder: t.$t("form.teamForm.teamDescription"), required: !0, rows: 8 }, model: { value: t.form.resources[t.selectedLanguage].description, callback: function(i) {
    t.$set(t.form.resources[t.selectedLanguage], "description", i);
  }, expression: "form.resources[selectedLanguage].description" } }), t.teamType === "WORKGROUP" ? e("app-text-area", { attrs: { error: t.error.resources.publicDescription && t.requiresCurrentLanguage, label: t.$t("form.teamForm.publicDescription"), placeholder: t.$t("form.teamForm.publicDescription"), required: !0, rows: 8 }, model: { value: t.form.resources[t.selectedLanguage].publicDescription, callback: function(i) {
    t.$set(t.form.resources[t.selectedLanguage], "publicDescription", i);
  }, expression: "form.resources[selectedLanguage].publicDescription" } }) : t._e(), t.teamType === "WORKGROUP" ? e("app-image-upload", { staticClass: "app-image-upload", attrs: { "file-prefix": "team/avatar/", label: t.$t("form.teamForm.teamImage"), "max-image-height": 350, "max-image-width": 350 }, model: { value: t.form.resources[t.selectedLanguage].image, callback: function(i) {
    t.$set(t.form.resources[t.selectedLanguage], "image", i);
  }, expression: "form.resources[selectedLanguage].image" } }) : t._e()], 1) : t._e(), t.tagsVisible ? e("generic-tags-multiselect", { attrs: { catalog: t.allGenericTags, "create-item-label": t.$t("common.form.create"), label: t.$t("form.teamManagement.tags.label"), placeholder: t.$t("form.teamManagement.tags.placeholder"), "search-placeholder": t.$t("common.form.search") }, on: { "create-tag": t.addGenericTag, "add-tag": t.addGenericTag, "remove-tag": t.removeGenericTag }, model: { value: t.selectedGenericTags, callback: function(i) {
    t.selectedGenericTags = i;
  }, expression: "selectedGenericTags" } }) : t._e()], 1), t.team.id ? e("team-member-management", { attrs: { "button-add-member": t.$t("form.teamForm.addMember"), "button-add-owner": t.$t("form.teamForm.addOwner"), "label-members": t.$t("form.teamManagement.members"), "label-owners": t.$t("form.teamManagement.owners"), "team-id": t.team.id, "team-type": t.team.type } }) : t._e()], 1);
}, eS = [], sS = /* @__PURE__ */ f(
  J$,
  tS,
  eS,
  !1,
  null,
  "ba1c272c"
);
const iS = sS.exports, nS = g({
  name: "TeamItem",
  props: {
    team: {
      type: Object,
      required: !0
    }
  },
  computed: {
    title() {
      return Ot(this.team, this.$res).teamName();
    },
    description() {
      return this.$t("common.team").toString();
    },
    isVirtualTeam() {
      return this.team.type === "VIRTUAL_TEAM";
    }
  }
});
var rS = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-list-item", { attrs: { description: t.description, title: t.title, icon: "fal fa-user-friends" }, scopedSlots: t._u([{ key: "controls", fn: function() {
    return [t.isVirtualTeam ? e("div", { staticClass: "pill" }, [t._v(" " + t._s(t.$t("page.teams.virtualTeam")) + " ")]) : t._e()];
  }, proxy: !0 }]) });
}, aS = [], oS = /* @__PURE__ */ f(
  nS,
  rS,
  aS,
  !1,
  null,
  "902ab25a"
);
const lS = oS.exports, cS = g({
  name: "WorkgroupItem",
  props: {
    team: {
      type: Object,
      required: !0
    }
  },
  computed: {
    title() {
      return Ot(this.team, this.$res).teamName();
    },
    description() {
      return this.$t("form.teamManagement.WORKGROUP").toString().toUpperCase();
    }
  }
});
var uS = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-list-item", { attrs: { description: t.description, title: t.title, icon: "fal fa-user-friends" } });
}, dS = [], pS = /* @__PURE__ */ f(
  cS,
  uS,
  dS,
  !1,
  null,
  "121e92bb"
);
const hS = pS.exports, fS = g({
  name: "TeamItemCard",
  props: {
    team: {
      type: Object,
      required: !0
    }
  }
});
var mS = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "team-item-card" }, [e("team-item", { attrs: { team: t.team } })], 1);
}, gS = [], _S = /* @__PURE__ */ f(
  fS,
  mS,
  gS,
  !1,
  null,
  "086bf079"
);
const yS = _S.exports, bS = g({
  name: "TeamMembersWidget",
  props: {
    currentUserId: {
      type: String,
      required: !0
    },
    teamId: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    allowJoining: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      PROFILE_PLACEHOLDER_IMAGE: "/img/add-user-placeholder.svg",
      memberIds: [],
      users: []
    };
  },
  computed: {
    showJoinAction() {
      return this.allowJoining && !this.memberIds.includes(this.currentUserId);
    }
  },
  async created() {
    await this.setMembers();
  },
  methods: {
    routeToUser(s) {
      return {
        name: "UserProfile",
        params: { userId: s.user.id }
      };
    },
    async setMembers() {
      const s = await this.$api.team.fetchTeamMembers(this.teamId) ?? [];
      this.memberIds = ic(
        s,
        (t) => t.userId
      ), this.users = await this.$gateway.portal.findUsersById(this.memberIds);
    },
    async joinTeam() {
      await this.$api.team.addTeamMember({
        type: "member",
        teamId: this.teamId,
        userId: this.currentUserId
      }), await this.setMembers();
    },
    goToUserProfile(s) {
      this.$router.push({
        name: "UserProfile",
        params: { userId: s }
      });
    }
  }
});
var vS = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "team-members-container" }, [e("app-section-list", { attrs: { data: t.users, level: 3, title: t.label }, scopedSlots: t._u([{ key: "default", fn: function({ item: i }) {
    return [e("router-link", { attrs: { to: t.routeToUser(i) } }, [e("user-item", { staticClass: "team-member-item", attrs: { "user-data": i }, on: { "click-user": t.goToUserProfile } })], 1)];
  } }]) }), t.showJoinAction ? e("app-list-item", { staticClass: "join-team-item", attrs: { image: t.PROFILE_PLACEHOLDER_IMAGE, title: t.$t("team.join") }, nativeOn: { "~click": function(i) {
    return t.joinTeam.apply(null, arguments);
  } } }) : t._e()], 1);
}, kS = [], xS = /* @__PURE__ */ f(
  bS,
  vS,
  kS,
  !1,
  null,
  "93463412"
);
const CS = xS.exports, No = "/img/team-placeholder.svg", wS = g({
  props: {
    value: {
      type: Array,
      required: !0
    },
    multiselect: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    tooltip: {
      type: String,
      required: !1
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    previewOptions: {
      type: Array,
      default: () => []
    },
    previewGroups: {
      type: Array,
      default: () => []
    },
    teamTypes: {
      type: Array,
      required: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    tags: {
      type: Array,
      required: !1
    }
  },
  data() {
    return {
      loading: !1,
      optionsPool: [],
      selection: [],
      query: "",
      searchOptions: []
    };
  },
  async created() {
    if (this.value) {
      this.loading = !0;
      const s = await this.$datasource.team.listBatch(this.value);
      this.optionsPool = s.map((t) => ({
        text: Ot(t, this.$res).teamName(),
        value: t.id,
        image: No
      })), this.selection = this.value, this.loading = !1;
    }
  },
  computed: {
    selectionMode() {
      return this.multiselect ? "multiple" : "single";
    },
    options() {
      return this.query ? this.searchOptions : this.previewOptions;
    },
    groups() {
      return this.query ? void 0 : this.previewGroups;
    }
  },
  methods: {
    onUpdate(s) {
      this.$emit("input", s);
    },
    onDirty() {
      this.loading = !!this.query;
    },
    onToggleOpen(s) {
      s || (this.query = "", this.$emit("blur"));
    },
    async onSearchDebounced(s) {
      if (!s.length) {
        this.searchOptions = [];
        return;
      }
      this.loading = !0;
      const t = await this.$gateway.search.searchTeamIds(
        {
          query: s,
          filter: {
            type: this.teamTypes,
            tags: this.tags
          }
        },
        this.$res
      ), e = await this.$datasource.team.listBatch(t);
      this.searchOptions = e.map((i) => ({
        text: Ot(i, this.$res).teamName(),
        value: i.id,
        image: No
      })), this.loading = !1;
    }
  }
});
var $S = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-dropdown", { attrs: { enabled: t.enabled, error: t.error, label: t.label, loading: t.loading, options: t.options, "options-groups": t.groups, "options-pool": t.optionsPool, placeholder: t.placeholder, required: t.required, "selection-mode": t.selectionMode, tooltip: t.tooltip, value: t.selection }, on: { input: t.onUpdate, "toggle-open": t.onToggleOpen }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [e("app-search-input", { staticClass: "inner-search", attrs: { "debounce-timeout": 500, placeholder: t.searchPlaceholder }, on: { debounced: t.onSearchDebounced, dirty: t.onDirty }, model: { value: t.query, callback: function(i) {
      t.query = i;
    }, expression: "query" } })];
  }, proxy: !0 }, { key: "controls", fn: function() {
    return [t._t("controls")];
  }, proxy: !0 }], null, !0) });
}, SS = [], TS = /* @__PURE__ */ f(
  wS,
  $S,
  SS,
  !1,
  null,
  "089afe80"
);
const IS = TS.exports, AS = Rt.extend({
  props: {
    header: Object,
    value: null,
    item: null
  }
});
var PS = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-image", { attrs: { type: "circle", width: "25px", height: "25px", src: t.value } });
}, OS = [], MS = /* @__PURE__ */ f(
  AS,
  PS,
  OS,
  !1,
  null,
  "4b4d1283"
);
const RS = MS.exports, ES = g({
  props: {
    value: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      form: {
        query: ""
      },
      loading: !1,
      allTeams: [],
      teams: [],
      selection: []
    };
  },
  async created() {
    this.loading = !0, this.selection = [...this.value], await this.loadTeams(), this.loading = !1;
  },
  computed: {
    tableData() {
      return this.teams.map((s) => ({
        id: s.id,
        name: Ot(s, this.$res).teamName()
      }));
    },
    tableHeaders() {
      return [
        {
          key: "name",
          label: this.$t("common.name"),
          width: "100%"
        }
      ];
    },
    tableConfig() {
      return {
        summary: "simple",
        selection: {
          mode: "multiple",
          selectAllButton: !0
        }
      };
    },
    isEmpty() {
      return !this.loading && this.teams.length === 0;
    }
  },
  methods: {
    async loadTeams() {
      const s = await this.$gateway.search.searchTeamIds(
        {
          filter: {
            type: ["ORGANIZATIONAL_TEAM", "VIRTUAL_TEAM"]
          }
        },
        this.$res
      );
      this.allTeams = await this.$datasource.team.listBatch(s), this.teams = this.allTeams;
    },
    async onSubmit() {
      const s = this.form.query.toLocaleLowerCase();
      this.teams = this.allTeams.filter(
        ({ name: t }) => t == null ? void 0 : t.toLowerCase().includes(s)
      );
    },
    onConfirm() {
      this.$emit("input", this.selection), this.$emit("save");
    },
    onCancel() {
      this.$emit("close");
    }
  }
});
var DS = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { staticClass: "team-list-modal", on: { "click-outside": t.onCancel } }, [e("app-form", { staticClass: "search-form", attrs: { form: t.form, "auto-submit": !0 }, on: { submit: t.onSubmit } }, [e("app-search-input", { staticClass: "app-search-input", attrs: { placeholder: t.$t("form.search.placeholder") }, model: { value: t.form.query, callback: function(i) {
    t.$set(t.form, "query", i);
  }, expression: "form.query" } })], 1), e("app-section", { staticClass: "app-section", attrs: { title: t.$t("common.teams"), level: 2 } }, [t.loading ? e("app-overlay", { attrs: { theme: "light", "center-content": !0, "full-page": !1 } }, [e("app-loading")], 1) : t.isEmpty ? e("app-empty-view", { staticClass: "widget-empty", attrs: { title: t.$t("error.nothingFound"), "fa-icon": "fa-regular fa-team-check" } }) : e("app-data-table", { attrs: { data: t.tableData, headers: t.tableHeaders, config: t.tableConfig }, model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } })], 1), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center", theme: "gray" } }, [e("app-button", { attrs: { label: t.$t("common.form.confirm") }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1);
}, FS = [], LS = /* @__PURE__ */ f(
  ES,
  DS,
  FS,
  !1,
  null,
  "80454188"
);
const qS = LS.exports, US = g({
  name: "BaseCreateTeamModal",
  components: {
    SelectTeamMembers: oc
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    userId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      teamName: "",
      selectedUsers: []
    };
  },
  computed: {
    isFormValid() {
      return !!(this.teamName && this.selectedUsers.length);
    }
  },
  methods: {
    async createTeam() {
      const s = this.organization.language.default, t = {
        team: {
          name: this.teamName,
          context: "",
          description: "",
          resources: {
            [s]: {
              name: this.teamName,
              description: ""
            }
          },
          type: "VIRTUAL_TEAM"
        },
        actions: this.selectedUsers.map(
          (e) => ({
            action: "add",
            role: "member",
            userId: e
          })
        )
      };
      try {
        const e = await this.$gateway.team.createTeam(t);
        this.$emit("teamCreated", e);
      } catch (e) {
        console.error(e), this.$toast(this.$t("error.general").toString());
      }
    }
  }
});
var NS = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { staticClass: "modal", on: { "click-outside": function(i) {
    return t.$emit("close");
  } } }, [e("div", { staticClass: "modal-container" }, [e("h2", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("modal.createTeam.title")) + " ")]), e("app-form", { staticClass: "modal-content" }, [e("app-text-input", { attrs: { label: t.$t("modal.createTeam.name"), required: !0 }, model: { value: t.teamName, callback: function(i) {
    t.teamName = i;
  }, expression: "teamName" } }), e("select-team-members", { model: { value: t.selectedUsers, callback: function(i) {
    t.selectedUsers = i;
  }, expression: "selectedUsers" } })], 1), e("div", { staticClass: "modal-footer" }, [e("app-button-sheet", { staticClass: "buttons" }, [e("app-button", { attrs: { disabled: !t.isFormValid, label: t.$t("common.form.create") }, on: { click: t.createTeam } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: function(i) {
    return t.$emit("close");
  } } })], 1)], 1)], 1)]);
}, BS = [], jS = /* @__PURE__ */ f(
  US,
  NS,
  BS,
  !1,
  null,
  "0d72012b"
);
const zS = jS.exports, VS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CreateTeamModal: zS,
  TableImageAvatar: RS,
  TeamDropdown: IS,
  TeamForm: iS,
  TeamItem: lS,
  TeamItemCard: yS,
  TeamMemberCard: yc,
  TeamMemberManagement: bc,
  TeamMembersWidget: CS,
  TeamSelectionModal: qS,
  WorkgroupItem: hS
}, Symbol.toStringTag, { value: "Module" })), HS = g({
  props: {
    user: {
      type: Object
    },
    title: {
      type: String,
      required: !0
    },
    icon: {
      type: String,
      required: !0
    },
    date: {
      type: Number,
      required: !0
    }
  },
  computed: {
    historicalDate() {
      return Intl.DateTimeFormat(void 0, {
        dateStyle: "medium",
        timeStyle: "short"
      }).format(new Date(this.date));
    },
    username() {
      return this.user ? E({ user: this.user }).displayName() : this.$t("common.deletedUser").toString();
    }
  }
});
var WS = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "history-item" }, [e("div", { staticClass: "history-header" }, [e("div", { staticClass: "history-icon-container" }, [e("fa-icon-compat", { staticClass: "history-icon", attrs: { icon: t.icon } })], 1), e("div", { staticClass: "content" }, [e("div", { staticClass: "history-title" }, [e("span", { staticClass: "username" }, [t._v(t._s(t.username))]), t._v(" " + t._s(t.title) + " ")]), e("div", { staticClass: "history-date" }, [t._v(" " + t._s(t.historicalDate) + " ")]), t._t("content")], 2)])]);
}, GS = [], KS = /* @__PURE__ */ f(
  HS,
  WS,
  GS,
  !1,
  null,
  "f53cf0dd"
);
const YS = KS.exports, XS = g({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      previousAssignee: "",
      nextAssignee: ""
    };
  },
  async created() {
    this.previousAssignee = await this.setPreviousAssignee(), this.nextAssignee = await this.setNextAssignee();
  },
  methods: {
    async setPreviousAssignee() {
      return this.history.previousValue && this.history.previousValue !== "null" ? await this.getUserName(this.history.previousValue) : this.$t("page.ticketHistory.none").toString();
    },
    async setNextAssignee() {
      return this.history.newValue && this.history.newValue !== "null" ? await this.getUserName(this.history.newValue) : this.$t("page.ticketHistory.none").toString();
    },
    async getUserName(s) {
      const t = await this.$datasource.user.findById(s);
      return t ? E({ user: t }).displayName() ?? t.email ?? this.$t("common.deletedUser").toString() : this.$t("page.ticketHistory.none").toString();
    }
  }
});
var ZS = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("history-item", { attrs: { date: t.history.createdDate, title: this.$t("page.ticketHistory.changedAssignee").toString(), user: t.user, icon: "fal fa-user-plus" }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("span", { staticClass: "value-text" }, [t._v(t._s(t.previousAssignee))]), e("fa-icon-compat", { staticClass: "arrow-icon", attrs: { icon: "fal fa-arrow-right" } }), e("span", { staticClass: "value-text" }, [t._v(t._s(t.nextAssignee))])];
  }, proxy: !0 }]) });
}, QS = [], JS = /* @__PURE__ */ f(
  XS,
  ZS,
  QS,
  !1,
  null,
  "7f3f418a"
);
const t0 = JS.exports, e0 = g({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    }
  }
});
var s0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("history-item", { attrs: { date: t.history.createdDate, title: t.$t("page.ticketHistory.createdTicket").toString(), user: t.user, icon: "fal fa-plus" } });
}, i0 = [], n0 = /* @__PURE__ */ f(
  e0,
  s0,
  i0,
  !1,
  null,
  null
);
const r0 = n0.exports, a0 = g({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    userRoles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: !1,
      externalFields: [],
      previousValue: "",
      nextValue: ""
    };
  },
  async created() {
    this.loading = !0, [
      { externalFields: this.externalFields },
      this.previousValue,
      this.nextValue
    ] = await Promise.all([
      this.$datasource.dynamicField.find(
        this.ticket.type,
        this.ticket.context
      ),
      this.setPreviousValue(),
      this.setNextValue()
    ]), this.loading = !1;
  },
  computed: {
    accessProvider() {
      return {
        userId: this.currentUser.id,
        userRoles: this.userRoles,
        userActions: this.userActions,
        creatorId: this.ticket.creator,
        assigneeId: this.ticket.assignee
      };
    },
    title() {
      return `${this.$t("page.ticketHistory.changed")} ${this.label} ${this.$t(
        "page.ticketHistory.field"
      )}`;
    },
    dynamicField() {
      return this.externalFields.flatMap((s) => s.fields).find(({ ref: s }) => s === this.history.field);
    },
    visibilityAllowed() {
      var e, i;
      const s = ((i = (e = this.dynamicField) == null ? void 0 : e.accessPolicy) == null ? void 0 : i.view) ?? [], { accessGranted: t } = Ri(s, this.accessProvider);
      return t;
    },
    label() {
      var n;
      const s = this.findResourceByRef(this.history.field), t = (n = this.$res(s)) == null ? void 0 : n.label;
      if (t)
        return t;
      const e = this.history.field.replace("meta.", ""), i = `page.ticketHistory.${e}`;
      return this.$te(i) ? this.$t(i).toString() : e;
    }
  },
  methods: {
    async setPreviousValue() {
      const s = await this.getStringValue("previousValue");
      return this.convertToDate(s);
    },
    async setNextValue() {
      const s = await this.getStringValue("newValue");
      return this.convertToDate(s);
    },
    convertToDate(s) {
      const t = s.replaceAll('"', ""), e = new Date(t);
      return e instanceof Date && !isNaN(e.getTime()) && isNaN(Number(t)) ? Intl.DateTimeFormat(void 0, {
        dateStyle: "medium"
      }).format(e) : s;
    },
    async getStringValue(s) {
      return !this.history[s] || this.history[s] === "null" ? this.$t("page.ticketHistory.none").toString() : this.history.field === "delegate" && this.history[s] ? await this.getDelegateName(this.history[s]) : ["creator", "creatorTeam"].includes(this.history.field) ? await this.getUserName(this.history[s]) : this.maybeJsonValueParse(this.history[s] ?? "");
    },
    maybeJsonValueParse(s) {
      try {
        const t = JSON.parse(s);
        return (t == null ? void 0 : t._dfType) === "measurement" ? h_(
          t.value,
          (e) => this.$t(e).toString()
        ) : s;
      } catch {
        return s;
      }
    },
    convertDelegateData(s) {
      try {
        return JSON.parse(s);
      } catch (t) {
        return console.error(`Error parsing delegate data: ${t}`), [];
      }
    },
    async getDelegateName(s) {
      const t = this.convertDelegateData(s), e = t.length > 0 ? t[0] : void 0;
      if (!e)
        return this.$t("page.ticketHistory.none").toString();
      if (e.domain === "team") {
        const i = await this.$datasource.team.find(e.id);
        return (i == null ? void 0 : i.name) ?? "--";
      }
      if (e.domain === "topic") {
        const i = await this.$datasource.topic.find(e.id);
        return this.$res(i == null ? void 0 : i.resources).title ?? "--";
      }
      return console.warn(`Unknown Delegate domain [domain=${e.domain}]`), "--";
    },
    async getUserName(s) {
      const t = await this.$datasource.user.findById(s);
      return t ? E({ user: t }).displayName() ?? t.email ?? this.$t("common.deletedUser").toString() : this.$t("page.ticketHistory.none").toString();
    },
    findResourceByRef(s) {
      var t;
      for (let e of this.externalFields)
        for (let i of e.fields)
          if (i.ref === s)
            return ((t = i.options) == null ? void 0 : t.resources) ?? {};
      return {};
    }
  }
});
var o0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, !t.loading && t.visibilityAllowed ? e("history-item", { attrs: { date: t.history.createdDate, title: t.title, user: t.user, icon: "fal fa-pen-alt" }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("span", { staticClass: "value-text" }, [t._v(t._s(t.previousValue))]), e("fa-icon-compat", { staticClass: "arrow-icon", attrs: { icon: "fal fa-arrow-right" } }), e("span", { staticClass: "value-text" }, [t._v(t._s(t.nextValue))])];
  }, proxy: !0 }], null, !1, 739364274) }) : t._e();
}, l0 = [], c0 = /* @__PURE__ */ f(
  a0,
  o0,
  l0,
  !1,
  null,
  null
);
const u0 = c0.exports, d0 = g({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      imgError: !1,
      currentTime: -1
    };
  },
  computed: {
    icon() {
      var s;
      switch ((s = this.history) == null ? void 0 : s.eventType) {
        case "FILE_REMOVED":
          return "fal fa-trash";
        case "FILE_UPDATED":
          return "fal fa-pen-alt";
        case "FILE_ADDED":
        default:
          return "fal fa-arrow-to-top";
      }
    },
    fileUrl() {
      return !this.history.newValue || this.history.newValue === "null" ? "" : this.history.newValue.split(",")[1].split("=")[1];
    },
    title() {
      var s;
      switch ((s = this.history) == null ? void 0 : s.eventType) {
        case "FILE_REMOVED":
          return this.$t("page.ticketHistory.removedFile").toString();
        case "FILE_UPDATED":
          return this.$t("page.ticketHistory.updatedFile").toString();
        case "FILE_ADDED":
        default:
          return this.$t("page.ticketHistory.uploadedNewFile").toString();
      }
    }
  },
  methods: {
    onImgError() {
      this.imgError = !0;
    },
    isVideoByURL(s) {
      var e, i;
      const t = ((i = (e = s.split(/[#?]/)[0]) == null ? void 0 : e.split(".").pop()) == null ? void 0 : i.trim()) || "";
      return t ? t.includes("video") : !1;
    },
    resume() {
      if (this.currentTime !== -1) {
        const s = this.$refs.video;
        s.currentTime = this.currentTime, s.play(), this.currentTime = -1;
      }
    }
  }
});
var p0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("history-item", { attrs: { date: t.history.createdDate, title: t.title, user: t.user, icon: t.icon }, scopedSlots: t._u([t.fileUrl ? { key: "content", fn: function() {
    return [!t.imgError && !t.isVideoByURL(t.fileUrl) ? e("img", { staticClass: "history-file", attrs: { src: t.fileUrl }, on: { error: function(i) {
      return t.onImgError();
    } } }) : t._e(), t.isVideoByURL(t.fileUrl) ? e("video", { ref: "video", staticClass: "history-file", attrs: { src: t.fileUrl, controls: "" }, on: { canplay: t.resume } }, [t._t("videoFormatUnsupportedErrorMessage")], 2) : t._e()];
  }, proxy: !0 } : null], null, !0) });
}, h0 = [], f0 = /* @__PURE__ */ f(
  d0,
  p0,
  h0,
  !1,
  null,
  "bed324b0"
);
const m0 = f0.exports, g0 = g({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    }
  },
  computed: {
    previousStatus() {
      var t;
      if (!this.history.previousValue)
        return "";
      const s = Y(this.history.previousValue, this.workflow);
      return ((t = this.$res(s)) == null ? void 0 : t.label) ?? this.history.previousValue;
    },
    nextStatus() {
      var t;
      if (!this.history.newValue)
        return "";
      const s = Y(this.history.newValue, this.workflow);
      return ((t = this.$res(s)) == null ? void 0 : t.label) ?? this.history.newValue;
    }
  }
});
var _0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("history-item", { attrs: { date: t.history.createdDate, title: this.$t("page.ticketHistory.changedPhase").toString(), user: t.user, icon: "fal fa-arrow-right" }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("span", { staticClass: "value-text" }, [t._v(t._s(t.previousStatus))]), e("fa-icon-compat", { staticClass: "arrow-icon", attrs: { icon: "fal fa-arrow-right" } }), e("span", { staticClass: "value-text" }, [t._v(t._s(t.nextStatus))])];
  }, proxy: !0 }]) });
}, y0 = [], b0 = /* @__PURE__ */ f(
  g0,
  _0,
  y0,
  !1,
  null,
  "ec1f835a"
);
const v0 = b0.exports, k0 = g({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    }
  },
  computed: {
    icon() {
      var s;
      switch ((s = this.history) == null ? void 0 : s.eventType) {
        case "TASK_DELETED":
          return "fal fa-trash";
        default:
          return "fal fa-pen-alt";
      }
    },
    title() {
      const s = this.history.eventType === "TASK_DELETED" ? "deletedTask" : "updatedTask";
      return this.$t(`page.ticketHistory.${s}`).toString();
    }
  }
});
var x0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("history-item", { attrs: { date: t.history.createdDate, icon: t.icon, title: t.title, user: t.user } });
}, C0 = [], w0 = /* @__PURE__ */ f(
  k0,
  x0,
  C0,
  !1,
  null,
  null
);
const $0 = w0.exports, S0 = g({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      relationType: "",
      linkedTicketId: "",
      linkedTicket: void 0
    };
  },
  async created() {
    this.loading = !0, [, this.relationType, this.linkedTicketId] = this.history.newValue.split(" "), this.linkedTicket = await this.$datasource.ticket.find(
      this.ticket.type,
      this.linkedTicketId
    ), this.loading = !1;
  },
  computed: {
    title() {
      return this.$t("page.ticketHistory.linkCreated").toString();
    },
    relation() {
      return this.$t(`linking.${this.relationType}`).toString();
    },
    description() {
      return this.$t("page.ticketHistory.linkAsDescription", {
        relation: this.relation
      }).toString();
    }
  }
});
var T0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.loading ? t._e() : e("history-item", { attrs: { date: t.history.createdDate, title: t.title, user: t.user, icon: "fal fa-pen-alt" }, scopedSlots: t._u([{ key: "content", fn: function() {
    var i;
    return [e("span", { staticClass: "value-text" }, [t._v(" " + t._s(t.description) + " "), e("router-link", { attrs: { to: {
      name: "TicketDetails",
      params: {
        id: t.linkedTicketId
      }
    } } }, [t._v(" " + t._s((i = t.linkedTicket) == null ? void 0 : i.title) + " ")])], 1)];
  }, proxy: !0 }], null, !1, 1536874939) });
}, I0 = [], A0 = /* @__PURE__ */ f(
  S0,
  T0,
  I0,
  !1,
  null,
  null
);
const P0 = A0.exports, O0 = g({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      relationType: "",
      linkedTicketId: "",
      linkedTicket: void 0
    };
  },
  async created() {
    this.loading = !0, [, this.relationType, this.linkedTicketId] = this.history.previousValue.split(" "), this.linkedTicket = await this.$datasource.ticket.find(
      this.ticket.type,
      this.linkedTicketId
    ), this.loading = !1;
  },
  computed: {
    title() {
      return this.$t("page.ticketHistory.linkRemoved").toString();
    },
    relation() {
      return this.$t(`linking.${this.relationType}`).toString();
    },
    description() {
      return this.$t("page.ticketHistory.removedLinkAsDescription", {
        relation: this.relation
      }).toString();
    }
  }
});
var M0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.loading ? t._e() : e("history-item", { attrs: { date: t.history.createdDate, title: t.title, user: t.user, icon: "fal fa-pen-alt" }, scopedSlots: t._u([{ key: "content", fn: function() {
    var i;
    return [e("span", { staticClass: "value-text" }, [t._v(" " + t._s(t.description) + " "), e("router-link", { attrs: { to: {
      name: "TicketDetails",
      params: {
        id: t.linkedTicketId
      }
    } } }, [t._v(" " + t._s((i = t.linkedTicket) == null ? void 0 : i.title) + " ")])], 1)];
  }, proxy: !0 }], null, !1, 1536874939) });
}, R0 = [], E0 = /* @__PURE__ */ f(
  O0,
  M0,
  R0,
  !1,
  null,
  null
);
const D0 = E0.exports, F0 = g({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    ticketId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    userRoles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ticketHistory: [],
      ticket: {},
      loading: !1
    };
  },
  async created() {
    this.loading = !0, this.ticketHistory = await this.$gateway.portal.loadTicketHistory(
      this.contextId,
      this.productId,
      this.ticketId
    ), this.ticket = this.ticketHistory[0].ticket, this.ticketHistory = this.ticketHistory.map(
      (s) => ({
        ...s,
        user: this.filterCreatorName(s.user, s.history.creatorUser)
      })
    ), this.loading = !1;
  },
  computed: {
    componentLookup() {
      return {
        ASSIGNEE_CHANGED: "HistoryItemAssigneeChanged",
        DETAILS_UPDATED: "HistoryItemDetailsUpdated",
        FILE_ADDED: "HistoryItemFile",
        FILE_REMOVED: "HistoryItemFile",
        FILE_UPDATED: "HistoryItemFile",
        TASK_UPDATED: "HistoryItemTaskChanged",
        LINK_CREATED: "HistoryItemLinkCreated",
        LINK_REMOVED: "HistoryItemLinkRemoved",
        TASK_DELETED: "HistoryItemTaskChanged",
        TICKET_CREATED: "HistoryItemCreated",
        STATUS_UPDATED: "HistoryItemStatusUpdated"
      };
    },
    productCustomization() {
      var t, e;
      const { productsData: s } = Ht(this.organization, [
        "main",
        "subproduct"
      ]);
      return (e = (t = s.value) == null ? void 0 : t.find(
        ({ productId: i }) => i === this.ticket.type
      )) == null ? void 0 : e.customization;
    },
    accessProvider() {
      return {
        userId: this.currentUser.id,
        userActions: this.userActions,
        userRoles: this.userRoles,
        creatorId: this.ticket.creator,
        assigneeId: this.ticket.assignee
      };
    },
    showCreator() {
      var e, i, n;
      const s = ((n = (i = (e = this.productCustomization) == null ? void 0 : e.accessPolicy) == null ? void 0 : i.creator) == null ? void 0 : n.view) ?? [], { accessGranted: t } = Ri(s, this.accessProvider);
      return t;
    },
    creatorTitle() {
      const s = er(
        this.ticketHistory[0].workflow,
        "app"
      ).page("TicketDetails"), t = this.$res(s == null ? void 0 : s.resources) ?? {};
      return t == null ? void 0 : t.creator;
    }
  },
  methods: {
    filterCreatorName(s = {}, t) {
      return t === "webhook" ? {
        firstName: this.$t("common.automation").toString(),
        lastName: ""
      } : this.showCreator || s.id !== this.ticket.creator ? s : {
        ...s,
        firstName: this.creatorTitle || this.$t("page.ticketHistory.creator").toString(),
        lastName: ""
      };
    },
    historyTypeComponent(s) {
      return this.componentLookup[s];
    }
  }
});
var L0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.loading ? e("app-loading", { staticClass: "app-loading" }) : e("div", { staticClass: "ticket-history" }, t._l(t.ticketHistory, function(i, n) {
    return e(t.historyTypeComponent(i.history.eventType), { key: n, tag: "component", attrs: { "current-user": t.currentUser, history: i.history, ticket: i.ticket, user: i.user, "user-actions": t.userActions, "user-roles": t.userRoles, workflow: i.workflow } });
  }), 1);
}, q0 = [], U0 = /* @__PURE__ */ f(
  F0,
  L0,
  q0,
  !1,
  null,
  "ab429265"
);
const vc = U0.exports, N0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  HistoryItem: YS,
  HistoryItemAssigneeChanged: t0,
  HistoryItemCreated: r0,
  HistoryItemDetailsUpdated: u0,
  HistoryItemFile: m0,
  HistoryItemLinkCreated: P0,
  HistoryItemLinkRemoved: D0,
  HistoryItemStatusUpdated: v0,
  HistoryItemTaskChanged: $0,
  TicketHistoryWidget: vc
}, Symbol.toStringTag, { value: "Module" })), B0 = g({
  props: {
    value: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !1
    },
    workflow: {
      type: Object,
      required: !0
    },
    statusList: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      selection: ""
    };
  },
  async mounted() {
    this.selection = this.value;
  },
  watch: {
    value(s) {
      this.selection = s;
    },
    selection(s) {
      this.$emit("input", s);
    }
  },
  computed: {
    options() {
      return this.statusList.map((s) => {
        var e;
        const t = Y(s, this.workflow);
        return {
          text: ((e = this.$res(t)) == null ? void 0 : e.label) ?? s,
          value: s
        };
      });
    }
  }
});
var j0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-singleselect", { attrs: { label: t.label, placeholder: t.placeholder, options: t.options }, model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } });
}, z0 = [], V0 = /* @__PURE__ */ f(
  B0,
  j0,
  z0,
  !1,
  null,
  "fd5280f0"
);
const H0 = V0.exports, W0 = "/img/profile-placeholder.svg", G0 = g({
  props: {
    // pass just the user that now use the new IUserResponse
    userData: {
      type: Object,
      required: !0
    }
  },
  computed: {
    userAvatar() {
      return this.userData.user.avatar || W0;
    },
    displayName() {
      return E(this.userData).displayName();
    },
    userDepartment() {
      return E(this.userData).userDepartment();
    }
  }
});
var K0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-list-item", { attrs: { image: t.userAvatar, title: t.displayName, description: t.userDepartment }, scopedSlots: t._u([{ key: "controls", fn: function() {
    return [t._t("controls")];
  }, proxy: !0 }], null, !0) });
}, Y0 = [], X0 = /* @__PURE__ */ f(
  G0,
  K0,
  Y0,
  !1,
  null,
  "e2a9c97f"
);
const Ei = X0.exports, Z0 = g({
  components: {
    UserItem: Ei
  },
  props: {
    options: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      open: !1,
      dirty: !1,
      loading: !1,
      searchQuery: "",
      reloadKey: 0
    };
  },
  watch: {
    options() {
      this.reloadKey += 1;
    },
    open(s) {
      s || this.$nextTick(() => {
        this.onHideFloating();
      });
    }
  },
  computed: {
    hasSlotPrepend() {
      return !!this.$slots.prepend;
    }
  },
  methods: {
    onDirty() {
      this.dirty = !0, this.loading = !0;
    },
    async onDebouncedSearch(s) {
      this.loading = !0, this.$emit("update-search", s), this.loading = !1;
    },
    onHideFloating() {
      this.$emit("hide-floating");
    },
    onSelectItem(s) {
      this.$emit("select-item", s.user.id), this.open = !1;
    }
  }
});
var Q0 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-floating", { scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("app-search-input", { attrs: { placeholder: t.$t("common.search"), "debounce-timeout": 300 }, on: { dirty: t.onDirty, debounced: t.onDebouncedSearch }, model: { value: t.searchQuery, callback: function(i) {
      t.searchQuery = i;
    }, expression: "searchQuery" } })];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [t.options.length || t.hasSlotPrepend ? e("div", { key: t.reloadKey, staticClass: "user-selection-results" }, [t.hasSlotPrepend ? e("div", { staticClass: "item" }, [t._t("prepend")], 2) : t._e(), t._l(t.options, function(i) {
      return e("user-item", { key: i.user.id, staticClass: "item", attrs: { "user-data": i }, nativeOn: { click: function(n) {
        return t.onSelectItem(i);
      } } });
    })], 2) : t._e()];
  }, proxy: !0 }], null, !0), model: { value: t.open, callback: function(i) {
    t.open = i;
  }, expression: "open" } });
}, J0 = [], t1 = /* @__PURE__ */ f(
  Z0,
  Q0,
  J0,
  !1,
  null,
  "1765ebf1"
);
const Di = t1.exports, e1 = g({
  components: {
    UserItem: Ei,
    UserSelectionInput: Di
  },
  props: {
    currentUser: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    routeToUser: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      ready: !1,
      searchOpen: !1,
      currentSelection: void 0,
      searchOptions: []
    };
  },
  watch: {
    ticket() {
      this.load();
    }
  },
  async created() {
    await this.load(), this.ready = !0;
  },
  computed: {
    canUpdate() {
      var t;
      const s = ((t = this.ticket.type) == null ? void 0 : t.toUpperCase()) ?? "";
      return this.userActions.includes(
        `${s}_ADMIN_TICKET_CREATOR_WRITE`
      );
    },
    ticketIdOrType() {
      return this.ticket.canonicalId ?? this.ticket.type;
    },
    currentSelectionId() {
      return this.ticket.creator;
    },
    display() {
      return this.searchOpen ? "search" : this.currentSelection ? "selected" : "empty";
    },
    menuOptions() {
      return [
        {
          label: this.$t("menu.changeToMe").toString(),
          tabKey: "assign-to-self",
          visible: this.currentSelectionId !== this.currentUser.id
        },
        {
          label: this.$t("menu.changeToSomeone").toString(),
          tabKey: "assign-to-other"
        }
      ];
    }
  },
  methods: {
    async load() {
      try {
        if (!this.currentSelectionId) {
          this.currentSelection = void 0;
          return;
        }
        const s = await this.$gateway.portal.findUserById(
          this.currentSelectionId
        );
        this.currentSelection = s ?? void 0, this.currentSelection || console.error(
          `Error loading ticket assignee [userId=${this.currentSelectionId}]`
        );
      } finally {
        this.onCloseSearch();
      }
    },
    onSelectUser(s) {
      this.$emit("update-assignee", s);
    },
    async onUpdateSearch(s) {
      const t = await this.$gateway.search.searchUserIds({ query: s }), e = await this.$gateway.portal.findUsersById(t);
      this.searchOptions = e.filter((i) => i.user.enabled && !i.user.deleted).filter((i) => !!i.user.firstName || i.user.lastName);
    },
    onRemoveAssignee() {
      this.$emit("update-assignee", void 0);
    },
    onSelectSelf() {
      this.onSelectUser(this.currentUser.id);
    },
    onOpenSearch() {
      this.searchOptions = [], this.searchOpen = !0;
    },
    onCloseSearch() {
      this.searchOpen = !1;
    }
  }
});
var s1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-creator-selection" }, [t.ready ? e("transition", { attrs: { mode: "out-in", name: "slide-fade" } }, [t.display === "empty" ? e("app-list-item", { staticClass: "empty-item", attrs: { image: "/img/add-user-placeholder.svg", title: t.$t("menu.changeCreator") }, nativeOn: { click: function(i) {
    return t.onOpenSearch.apply(null, arguments);
  } } }) : t.display === "selected" ? e("a", { attrs: { href: t.routeToUser(t.currentSelection.user), target: "_blank" } }, [e("user-item", { staticClass: "user-item", attrs: { "user-data": t.currentSelection }, scopedSlots: t._u([{ key: "controls", fn: function() {
    return [t.canUpdate ? e("app-ellipsis-menu", { attrs: { "menu-options": t.menuOptions }, on: { "click:assign-to-self": function(i) {
      return t.onSelectUser(t.currentUser.id);
    }, "click:assign-to-other": t.onOpenSearch, "click:remove-assignee": t.onRemoveAssignee } }) : t._e()];
  }, proxy: !0 }], null, !1, 1968392141) })], 1) : t.display === "search" ? e("user-selection-input", { attrs: { options: t.searchOptions }, on: { "hide-floating": t.onCloseSearch, "update-search": t.onUpdateSearch, "select-item": t.onSelectUser }, scopedSlots: t._u([t.currentUser.id !== t.ticket.creator ? { key: "prepend", fn: function() {
    return [e("app-list-item", { attrs: { image: t.currentUser.avatar, title: t.$t("menu.assignToMe") }, nativeOn: { click: function(i) {
      return t.onSelectSelf.apply(null, arguments);
    } } })];
  }, proxy: !0 } : null], null, !0) }) : t._e()], 1) : t._e()], 1);
}, i1 = [], n1 = /* @__PURE__ */ f(
  e1,
  s1,
  i1,
  !1,
  null,
  "eb011e8a"
);
const r1 = n1.exports, a1 = g({
  name: "TicketBreadcrumb",
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      parent: {},
      workflows: []
    };
  },
  computed: {
    product() {
      var s;
      return ((s = this.parent) == null ? void 0 : s.type) ?? this.ticket.type;
    },
    productText() {
      return this.product.replaceAll(/_/g, " ");
    },
    productRoute() {
      switch (this.product) {
        case "campaign":
          return { name: "CampaignOverview" };
        case "service_order":
          return { name: "ServiceOverview" };
        default:
          return {
            name: "TicketOverview",
            params: { product: this.product }
          };
      }
    }
  },
  async created() {
    await this.load();
  },
  methods: {
    getCanonicalNumber(s) {
      return s.split("-")[2];
    },
    async load() {
      var s;
      try {
        this.loading = !0;
        const { parent: t } = this.ticket;
        t && (this.parent = await this.$datasource.ticket.find(
          this.productId,
          t
        ));
        const e = [this.ticket.type, (s = this.parent) == null ? void 0 : s.type].filter(
          Boolean
        );
        this.workflows = await this.$gateway.portal.fetchWorkflowsByBatch(
          e,
          this.contextId
        );
      } catch (t) {
        console.error(t), this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1;
      }
    },
    getIcon(s) {
      const t = this.workflows.find(
        (i) => {
          var n;
          return ((n = i.product) == null ? void 0 : n.ticketType) === s;
        }
      );
      if (!t)
        return "";
      const { icons: e } = Ge(t);
      return e.solid ?? "/img/transparent-pixel.png";
    },
    getTicketRoute(s) {
      return {
        name: "TicketDetails",
        params: {
          product: this.productId,
          id: s
        }
      };
    }
  }
});
var o1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "container" }, [t.ticket.canonicalId ? [e("router-link", { staticClass: "product-link", attrs: { to: t.productRoute } }, [t._v(" " + t._s(t.productText) + " ")]), t.parent.canonicalId ? [e("span", { staticClass: "slash" }, [t._v("/")]), e("router-link", { staticClass: "ticket-link", attrs: { to: t.getTicketRoute(t.parent.canonicalId) } }, [e("img", { staticClass: "item-icon", class: [t.parent.type], attrs: { src: t.getIcon(t.parent.type) } }), t._v(" " + t._s(t.parent.title) + " ")])] : t._e(), e("span", { staticClass: "slash" }, [t._v("/")]), t.ticket.status === "SCRATCH" ? [e("img", { staticClass: "item-icon", class: [t.ticket.type], attrs: { src: t.getIcon(t.ticket.type) } }), e("div", { staticClass: "ticket-link" }, [t._v(" " + t._s(t.$t("ticket.yourTicket")) + " ")])] : [e(t.ticket.type === "feedback" ? "span" : "router-link", { tag: "component", staticClass: "ticket-link", attrs: { to: t.getTicketRoute(t.ticket.canonicalId) } }, [e("img", { staticClass: "item-icon", class: [t.ticket.type], attrs: { src: t.getIcon(t.ticket.type) } }), t._v(" #" + t._s(t.getCanonicalNumber(t.ticket.canonicalId)) + " ")])]] : t._e()], 2);
}, l1 = [], c1 = /* @__PURE__ */ f(
  a1,
  o1,
  l1,
  !1,
  null,
  "acec3b1e"
);
const kc = c1.exports, u1 = g({
  name: "TicketBalance",
  props: {
    balance: {
      type: Number,
      default: 0
    },
    compact: {
      type: Boolean,
      default: !1
    },
    menuOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    displayBalance() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "auto",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.balance);
    }
  },
  methods: {
    openTransactions() {
      this.$emit("openTransactions");
    }
  }
});
var d1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-balance", class: { compact: t.compact } }, [e("div", { staticClass: "ticket-balance-text" }, [e("span", [t._v(t._s(t.displayBalance))]), e("div", { staticClass: "ticket-balance-group" }, [e("fa-icon-compat", { staticClass: "ticket-balance-icon", attrs: { icon: "fal fa-coins" } }), t.menuOptions.length ? e("app-ellipsis-menu", { staticClass: "ticket-balance-menu", attrs: { "menu-options": t.menuOptions }, on: { "click:open-transactions": t.openTransactions } }) : t._e()], 1)]), e("div", { staticClass: "ticket-balance-link" }, [t._t("default")], 2)]);
}, p1 = [], h1 = /* @__PURE__ */ f(
  u1,
  d1,
  p1,
  !1,
  null,
  "f923558b"
);
const f1 = h1.exports, m1 = g({
  name: "TicketTransactions",
  props: {
    ticketId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !0,
      walletTransactions: [],
      walletOwners: {}
    };
  },
  async created() {
    const s = await this.$gateway.portal.loadTicketWalletTransactions(this.ticketId);
    s && ([, this.walletTransactions, this.walletOwners] = s), this.loading = !1, this.scrollToTransactions();
  },
  methods: {
    scrollToTransactions() {
      setTimeout(() => {
        var t;
        const { hash: s } = window.location;
        s === "#transactions" && ((t = document.getElementById(s.slice(1))) == null || t.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start"
        }));
      }, 50);
    }
  }
});
var g1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.loading ? e("app-loading", { staticClass: "app-loading" }) : e("wallet-transactions", { attrs: { id: "transactions", owners: t.walletOwners, transactions: t.walletTransactions } });
}, _1 = [], y1 = /* @__PURE__ */ f(
  m1,
  g1,
  _1,
  !1,
  null,
  "5d3d5bd8"
);
const xc = y1.exports, b1 = g({
  props: {
    workflow: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    transition: {
      type: Object,
      required: !0
    }
  },
  computed: {
    faIcon() {
      return `fal fa-${this.transition.icon}`;
    },
    label() {
      const s = this.transition.transitionTo, t = this.$res(this.transition.resources, {});
      if (t.transitionLabel)
        return t.transitionLabel;
      const e = Y(s, this.workflow), { label: i } = this.$res(e);
      return this.$t("common.moveTo", { label: i }).toString();
    },
    hasPermission() {
      return this.checkPermission(this.transition.requiredActions ?? []);
    }
  },
  methods: {
    checkPermission(s) {
      return s.length === 0 ? !0 : s.some((t) => this.userActions.includes(t));
    },
    onTransition(s) {
      s.stopPropagation(), this.$emit("execute-transition", this.transition);
    }
  }
});
var v1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-action-button", { staticClass: "action-button", attrs: { enabled: t.hasPermission, "fa-icon": t.faIcon, label: t.label }, on: { click: t.onTransition } });
}, k1 = [], x1 = /* @__PURE__ */ f(
  b1,
  v1,
  k1,
  !1,
  null,
  "8dc20a37"
);
const Cc = x1.exports, C1 = g({
  components: { TicketQuickTransition: Cc },
  props: {
    workflow: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    transitions: {
      type: Array,
      required: !0
    }
  },
  methods: {
    onTransition(s) {
      this.$emit("execute-transition", s);
    }
  }
});
var w1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-section", { attrs: { level: 2, title: t.$t("page.editTicket.sideOptions") } }, t._l(t.transitions, function(i, n) {
    return e("ticket-quick-transition", { key: n, attrs: { transition: i, "user-actions": t.userActions, workflow: t.workflow }, on: { "execute-transition": t.onTransition } });
  }), 1);
}, $1 = [], S1 = /* @__PURE__ */ f(
  C1,
  w1,
  $1,
  !1,
  null,
  "dcc07ef7"
);
const ur = S1.exports, T1 = g({
  props: {
    autocomplete: {
      type: String,
      required: !1
    }
  }
});
var I1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("base-input-item", t._b({ staticClass: "app-text-input" }, "base-input-item", t.$attrs, !1), [e("base-input-text", t._g(t._b({ attrs: { autocomplete: t.autocomplete } }, "base-input-text", t.$attrs, !1), t.$listeners))], 1);
}, A1 = [], P1 = /* @__PURE__ */ f(
  T1,
  I1,
  A1,
  !1,
  null,
  "490ccb70"
);
const O1 = P1.exports, M1 = g({
  props: {
    align: {
      type: String,
      default: "start",
      validator(s) {
        return ["start", "center", "end"].includes(s);
      }
    },
    theme: {
      type: String,
      default: "white",
      validator(s) {
        return ["white", "gray"].includes(s);
      }
    }
  }
});
var R1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-button-sheet", class: [t.theme, t.align] }, [t._t("default")], 2);
}, E1 = [], D1 = /* @__PURE__ */ f(
  M1,
  R1,
  E1,
  !1,
  null,
  "b25a6a7e"
);
const F1 = D1.exports, L1 = g({
  components: {
    AppButtonSheet: F1,
    TicketAvailableTransitions: ur,
    TicketQuickTransition: Cc
  },
  props: {
    workflow: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    availableTransitions: {
      type: Array,
      required: !0
    },
    preferredTransition: {
      type: Object,
      required: !1
    },
    theme: {
      type: String,
      default: "primary"
    },
    showDescription: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      visible: !1
    };
  },
  computed: {
    currentStatus() {
      var s;
      return ((s = this.preferredTransition) == null ? void 0 : s.transitionFrom) ?? this.availableTransitions[0].transitionFrom;
    },
    buttonLabel() {
      if (this.currentStatus) {
        const e = Y(this.currentStatus, this.workflow), { buttonLabel: i } = this.$res(e);
        if (i)
          return i;
      }
      if (!this.preferredTransition)
        return this.$t("page.editTicket.sideOptions").toString();
      const s = Y(
        this.preferredTransition.transitionTo,
        this.workflow
      ), { label: t } = this.$res(s);
      return this.$t("common.goTo", { label: t }).toString();
    },
    transitionTipTitle() {
      return this.showDescription ? this.resources.transitionTipTitle : "";
    },
    resources() {
      var i;
      const s = {
        transitionTipTitle: this.$t("page.editTicket.moveToNextPhase.title"),
        transitionTipMessage: this.$t("page.editTicket.moveToNextPhase.text")
      };
      if (!this.preferredTransition)
        return s;
      const t = Y(
        this.preferredTransition.transitionTo,
        this.workflow
      ), e = this.$res(t);
      return (e != null && e.transitionTipTitle || e != null && e.transitionTipMessage) && console.warn("[DEPRECATED] Using deprecated status translation"), this.$res(
        ((i = this.preferredTransition) == null ? void 0 : i.resources) ?? t,
        s
      );
    },
    hasPermission() {
      var s;
      return this.checkPermission(
        ((s = this.preferredTransition) == null ? void 0 : s.requiredActions) ?? []
      );
    }
  },
  methods: {
    pressMainButton() {
      this.preferredTransition ? this.onTransition(this.preferredTransition) : this.visible = !this.visible;
    },
    checkPermission(s) {
      return s.length === 0 ? !0 : s.some((t) => this.userActions.includes(t));
    },
    onTransition(s) {
      this.$emit("execute-transition", s);
    }
  }
});
var q1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-section", { attrs: { level: 2, title: t.transitionTipTitle } }, [t.showDescription ? e("span", { staticClass: "transition-description" }, [t._v(" " + t._s(t.resources.transitionTipMessage) + " ")]) : t._e(), t.availableTransitions.length || t.preferredTransition ? e("div", { staticClass: "button-container", class: {
    [`${t.theme}-theme`]: !0,
    "hide-trigger": !t.preferredTransition
  } }, [e("app-button", { staticClass: "app-button", attrs: { disabled: !t.hasPermission, label: t.buttonLabel }, on: { click: t.pressMainButton } }), t.availableTransitions.length ? e("app-floating", { style: { position: "static" }, attrs: { "floating-style": { width: "unset", zIndex: "50" }, placement: "bottom-start" }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [t.preferredTransition ? e("app-icon-button", { staticClass: "app-icon-button", attrs: { size: 48, frame: "square" }, on: { "!click": function(i) {
      i.stopPropagation(), i.preventDefault();
    } } }, [e("fa-icon-compat", { staticClass: "open-icon", attrs: { icon: "fa-solid fa-ellipsis-vertical" } })], 1) : t._e()];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [e("ticket-available-transitions", { staticClass: "side-options", attrs: { transitions: t.availableTransitions, "user-actions": t.userActions, workflow: t.workflow }, on: { "execute-transition": t.onTransition } })];
  }, proxy: !0 }], null, !1, 4065610175), model: { value: t.visible, callback: function(i) {
    t.visible = i;
  }, expression: "visible" } }) : t._e()], 1) : t._e()]);
}, U1 = [], N1 = /* @__PURE__ */ f(
  L1,
  q1,
  U1,
  !1,
  null,
  "ebc24cea"
);
const wc = N1.exports, B1 = g({
  components: { TicketPreferredTransition: wc },
  props: {
    statusHistory: {
      type: Array,
      required: !0
    },
    status: {
      type: String,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    availableTransitions: {
      type: Array,
      required: !0
    },
    preferredTransition: {
      type: Object,
      required: !1
    }
  },
  computed: {
    config() {
      return this.phaseConfig.map(({ phase: s }) => s);
    },
    phaseConfig() {
      return Wl(this.workflow);
    },
    currentProgress() {
      return this.isFinalStatus ? this.phaseConfig[this.currentPhaseIndex].status.length : this.currentStatusIndex;
    },
    currentStatusIndex() {
      const s = this.phaseConfig[this.currentPhaseIndex].status.findIndex(
        (t) => t === this.status
      );
      return s === -1 ? 0 : s;
    },
    currentPhaseIndex() {
      for (let s = this.phaseConfig.length - 1; s >= 0; s--)
        if (this.phaseConfig[s].status.includes(this.status))
          return s;
      return 0;
    },
    phase() {
      const s = Y(
        this.phaseConfig[this.currentPhaseIndex].phase,
        this.workflow,
        "phases"
      );
      return this.$res(s, {});
    },
    phaseCompleteTitle() {
      return this.phase.completeTitle ?? this.$t("ticket.completePhase", { phase: this.phase.label }).toString();
    },
    progressStyle() {
      return `--color-custom: ${Ps(
        this.phaseConfig[this.currentPhaseIndex].phase,
        this.workflow,
        "phases"
      )}`;
    },
    buttonTheme() {
      return this.currentStatusIndex === this.phaseConfig[this.currentPhaseIndex].status.length - 1 ? "primary" : "secondary";
    },
    finalStatus() {
      var s, t, e;
      return ((e = (t = (s = this.workflow) == null ? void 0 : s.settings) == null ? void 0 : t.finalStatus) == null ? void 0 : e[0]) ?? "";
    },
    isFinalStatus() {
      return this.status === this.finalStatus;
    }
  },
  methods: {
    statusRes(s) {
      return this.$res(Y(s, this.workflow, "status"), {});
    },
    iconClass(s, t) {
      return this.currentStatusIndex > s && this.statusHistory.includes(t) || this.currentStatusIndex === s && t === this.finalStatus ? "fa-regular fa-check" : this.currentStatusIndex === s ? "fa-regular fa-dash" : "fa-regular fa-question";
    },
    onExecuteTransition(s) {
      this.$emit("execute-transition", s);
    }
  }
});
var j1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-progress" }, [e("div", { staticClass: "phase-title" }, [t._v(" " + t._s(t.phase.title) + " ")]), e("div", { staticClass: "phase-description" }, [t._v(" " + t._s(t.phase.description) + " ")]), e("div", { staticClass: "phase-center" }, [t.phase.image ? e("img", { staticClass: "phase-image", attrs: { alt: t.phase.label, src: t.phase.image } }) : t._e(), e("div", { staticClass: "phase-complete" }, [t._v(" " + t._s(t.phaseCompleteTitle) + " ")]), e("div", { staticClass: "phase-progress" }, [e("progress", { style: t.progressStyle, attrs: { max: t.phaseConfig[t.currentPhaseIndex].status.length }, domProps: { value: t.currentProgress } }), e("div", { staticClass: "progress-text" }, [t._v(" " + t._s(t.currentProgress) + " / " + t._s(t.phaseConfig[t.currentPhaseIndex].status.length) + " " + t._s(t.$t("ticket.completed")) + " ")])])]), t._l(t.phaseConfig[t.currentPhaseIndex].status, function(i, n) {
    return e("app-accordion", { key: i, staticClass: "status-container", attrs: { name: i, open: n === t.currentStatusIndex }, scopedSlots: t._u([{ key: "summary", fn: function() {
      return [e("div", { staticClass: "question-container" }, [e("fa-icon-compat", { staticClass: "status-icon", attrs: { icon: t.iconClass(n, i) } }), t._v(" " + t._s(t.statusRes(i).label) + " ")], 1)];
    }, proxy: !0 }, { key: "content", fn: function() {
      return [e("div", { staticClass: "status-question" }, [t._v(" " + t._s(t.statusRes(i).question) + " ")]), e("div", { staticClass: "status-description" }, [t._v(" " + t._s(t.statusRes(i).description) + " "), t.currentStatusIndex === n ? e("ticket-preferred-transition", { attrs: { "available-transitions": t.availableTransitions, "preferred-transition": t.preferredTransition, "show-description": !1, theme: t.buttonTheme, "user-actions": t.userActions, workflow: t.workflow }, on: { "execute-transition": t.onExecuteTransition } }) : t._e()], 1)];
    }, proxy: !0 }], null, !0) });
  })], 2);
}, z1 = [], V1 = /* @__PURE__ */ f(
  B1,
  j1,
  z1,
  !1,
  null,
  "8ee8b896"
);
const H1 = V1.exports, W1 = g({
  props: {
    value: {
      type: String,
      required: !1
    },
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    productId: {
      type: String,
      required: !0
    },
    products: {
      type: Array,
      required: !0
    },
    context: {
      type: String,
      required: !0
    },
    excludeTicketId: {
      type: String,
      required: !1
    }
  },
  async created() {
    if (this.value) {
      const s = await this.fetchTicketsByIds([this.value]);
      this.options = this.mapDataToDropdown(s), this.ticketSelected = this.value;
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      ticketSelected: ""
    };
  },
  methods: {
    onUpdate(s) {
      this.$emit("input", s);
    },
    onToggleOpen(s) {
      s || (this.options = [], this.$emit("blur"));
    },
    async fetchTicketsByIds(s) {
      return this.$gateway.ticket.loadTicketsByBatch(
        this.context,
        this.productId,
        s
      );
    },
    mapDataToDropdown(s) {
      return s.map((t) => {
        const e = Y(t.ticket.status, t.workflow), i = this.$res(e).label;
        return {
          text: t.ticket.title,
          value: t.ticket.canonicalId,
          description: `${t.ticket.canonicalId} (${i})`,
          image: Ge(t.workflow).icons.solid
        };
      });
    },
    async onSearchDebounced(s) {
      if (s.length < 3) {
        this.options = [];
        return;
      }
      this.loading = !0;
      const t = 30, i = (await this.$gateway.search.searchTicketIds({
        query: s,
        filter: {
          type: this.products
        },
        limit: t
      })).filter((r) => r !== this.excludeTicketId).slice(0, t), n = await this.fetchTicketsByIds(i);
      this.options = this.mapDataToDropdown(n), this.loading = !1;
    }
  }
});
var G1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-singleselect", { staticClass: "ticket-dropdown", attrs: { label: t.label, placeholder: t.placeholder, options: t.options, loading: t.loading, required: t.required, error: t.error }, on: { "toggle-open": t.onToggleOpen, "update-single": t.onUpdate }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [e("app-search-input", { staticClass: "inner-search", attrs: { placeholder: t.searchPlaceholder, "debounce-timeout": 500 }, on: { debounced: t.onSearchDebounced } })];
  }, proxy: !0 }]), model: { value: t.ticketSelected, callback: function(i) {
    t.ticketSelected = i;
  }, expression: "ticketSelected" } });
}, K1 = [], Y1 = /* @__PURE__ */ f(
  W1,
  G1,
  K1,
  !1,
  null,
  "e6f0f9e8"
);
const X1 = Y1.exports;
class Se {
  constructor(t, e) {
    A(this, "class");
    A(this, "tag");
    this.class = t, this.tag = e;
  }
  static build(t) {
    if (typeof t == "string") {
      const [e, i] = t.split(":");
      return (!e || !i) && console.error(`Could not parse malformed tag '${t}'`), new Se(e, i);
    } else
      return new Se(t.class, t.tag);
  }
  toString() {
    return `${this.class}:${this.tag}`;
  }
}
class $i {
  constructor(t) {
    A(this, "tagList");
    A(this, "classList");
    const e = new Set(t);
    this.tagList = [...e].map(Se.build), this.classList = new Set(this.tagList.map((i) => i.tag));
  }
  get classes() {
    return [...this.classList];
  }
  get tagsAsString() {
    return this.tagList.map((t) => t.toString());
  }
  get tags() {
    return this.tagList;
  }
  static build(t) {
    return new $i(t);
  }
  addTag(t) {
    const e = Se.build(t);
    this.tagList.push(e), this.classList.add(e.class);
  }
  removeTag(t) {
    const e = Se.build(t);
    this.tagList = this.tagList.filter((i) => i.toString() !== t), this.filterClass(e.class) && this.classList.delete(e.class);
  }
  filterClass(t) {
    return this.tagList.filter((e) => e.class === t);
  }
  includesSomeTag(t) {
    return t.some((e) => this.tags.some((i) => i.toString() === e));
  }
  includesEveryTag(t) {
    return t.every((e) => this.tags.some((i) => i.toString() === e));
  }
  includesSomeClass(t) {
    return t.some((e) => this.classes.includes(e));
  }
  includesEveryClass(t) {
    return t.every((e) => this.classes.includes(e));
  }
}
const Z1 = g({
  props: {
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    productId: {
      type: String,
      required: !0
    },
    offerGroup: {
      type: String,
      required: !1
    },
    context: {
      type: String,
      required: !0
    }
  },
  async created() {
    try {
      this.loading = !0;
      const s = await this.$gateway.offer.loadAvailableOffers(this.offerGroup);
      this.data = s.filter(
        ([t]) => !$i.build(t.tags).includesSomeClass(["product"]) || $i.build(t.tags).includesSomeTag([this.productId])
      ), this.options = this.mapDataToDropdown(this.data);
    } catch (s) {
      this.$toast(this.$t("error.general").toString()), console.error("Error loading Service Overview", s);
    } finally {
      this.loading = !1;
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      data: [],
      selectedOffer: ""
    };
  },
  methods: {
    onUpdate(s) {
      const t = this.data.find(([e]) => e.id === s);
      this.$emit("input", t == null ? void 0 : t[0]);
    },
    mapDataToDropdown(s) {
      return s.map(([t, e]) => {
        const i = this.$res(t.resources, {});
        return {
          text: i.title,
          value: t.id,
          description: `${this.$t(
            "bulkActions.purchaseOfferModal.offerPriceLabel"
          )}: ${t.price} ${e ? ` - ${e.name}` : ""}`,
          image: i.image
        };
      });
    }
  }
});
var Q1 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-singleselect", { staticClass: "offer-dropdown", attrs: { error: t.error, label: t.label, loading: t.loading, options: t.options, placeholder: t.placeholder, required: t.required, "search-enabled": !0 }, on: { "update-single": t.onUpdate }, model: { value: t.selectedOffer, callback: function(i) {
    t.selectedOffer = i;
  }, expression: "selectedOffer" } });
}, J1 = [], tT = /* @__PURE__ */ f(
  Z1,
  Q1,
  J1,
  !1,
  null,
  "839ca462"
);
const eT = tT.exports, sT = g({
  props: {
    status: {
      type: String,
      default: ""
    },
    workflow: {
      type: Object
    }
  },
  computed: {
    statusLabel() {
      var t;
      const s = Y(this.status, this.workflow);
      return ((t = this.$res(s)) == null ? void 0 : t.label) ?? this.status;
    }
  }
});
var iT = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "status" }, [t._v(" " + t._s(t.statusLabel) + " ")]);
}, nT = [], rT = /* @__PURE__ */ f(
  sT,
  iT,
  nT,
  !1,
  null,
  "d48bc6dc"
);
const $c = rT.exports, aT = "/img/profile-placeholder.svg", oT = g({
  props: {
    comment: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !1
    },
    threadOwnerId: {
      type: String,
      required: !1
    },
    threadOwnerLabel: {
      type: String,
      required: !1
    },
    allowEdit: {
      type: Boolean,
      default: !1
    },
    allowDelete: {
      type: Boolean,
      default: !1
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      text: "",
      showText: !1,
      showEdit: !1
    };
  },
  created() {
    this.text = this.comment.content ?? "", this.parsingMentionsOnComment();
  },
  computed: {
    commentIdHtml() {
      return `comment_${this.comment.commentId}`;
    },
    authorAvatar() {
      var s, t;
      return ((t = (s = this.comment.author) == null ? void 0 : s.user) == null ? void 0 : t.avatar) || aT;
    },
    displayName() {
      const s = this.comment.author;
      if (s)
        return E(s).displayName();
    },
    userDepartment() {
      const s = this.comment.author;
      if (s)
        return E(s).userDepartment();
    },
    commentTitle() {
      return [this.displayName, this.userDepartment].filter((s) => !!s).join(", ");
    },
    displayThreadOwnerLabel() {
      var s, t;
      if (this.threadOwnerId && this.threadOwnerId === ((t = (s = this.comment.author) == null ? void 0 : s.user) == null ? void 0 : t.id))
        return this.threadOwnerLabel;
    },
    commentDate() {
      var i;
      const s = (i = this.comment) == null ? void 0 : i.createdAt;
      if (!s)
        return "";
      const t = new Date(s), e = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      };
      return t.toLocaleDateString(void 0, e);
    },
    routeToUser() {
      var s, t;
      return {
        name: "UserProfile",
        params: { userId: ((t = (s = this.comment.author) == null ? void 0 : s.user) == null ? void 0 : t.id) ?? "" }
      };
    },
    useRouterLink() {
      var t, e;
      const s = (t = this.$router.options.routes) == null ? void 0 : t.find(
        (i) => i.path.includes("product")
      );
      return !!((e = s == null ? void 0 : s.children) != null && e.find((i) => i.name === "UserProfile"));
    }
  },
  methods: {
    onDeleteComment() {
      var s;
      this.$emit("delete-comment", (s = this.comment) == null ? void 0 : s.commentId);
    },
    onEditComment() {
      this.showEdit = !0;
    },
    onCancelEditComment() {
      this.showEdit = !1;
    },
    onUpdateComment(s) {
      this.showEdit = !1, this.$emit("update-comment", {
        comment: this.comment,
        text: s
      });
    },
    async parsingMentionsOnComment() {
      const s = /@{(.*?)}/g, t = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g, e = this.text.match(s), i = this.text.match(t), n = e == null ? void 0 : e.map((r) => r.slice(2, -1)).map((r) => `mail:${r}`);
      if (n != null && n.length) {
        const r = await this.$api.users.fetchUriByBatch(n), a = await this.$datasource.user.listBatch(i), o = sr(a, (l) => l.id);
        e == null || e.forEach((l) => {
          const c = l.slice(2, -1), u = Ng().getUserReference(c), d = r[`mail:${c}`] ?? o.get((u == null ? void 0 : u.value) ?? "");
          if (d) {
            const p = `${d.firstName} ${d.lastName}`;
            this.productId ? this.text = this.text.replace(
              l,
              `[@${p}](/${this.productId}/profile/${d.id}/tickets)`
            ) : this.text = this.text.replace(l, `*@${p}*`);
          } else
            this.text = this.text.replace(l, `**@${c}**`);
        });
      }
      this.showText = !0;
    }
  }
});
var lT = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "classic-comment-item", attrs: { id: t.commentIdHtml } }, [e(t.useRouterLink ? "router-link" : "div", { tag: "component", staticClass: "comment-header", attrs: { to: t.routeToUser } }, [e("img", { staticClass: "author-avatar", attrs: { src: t.authorAvatar } }), e("div", { staticClass: "content" }, [e("div", { staticClass: "comment-title" }, [e("span", [t._v(t._s(t.commentTitle))]), t.displayThreadOwnerLabel ? e("span", { staticClass: "thread-owner" }, [t._v(" " + t._s(t.displayThreadOwnerLabel) + " ")]) : t._e()]), e("div", { staticClass: "comment-date" }, [t._v(" " + t._s(t.commentDate) + " ")])]), e("div", { staticClass: "controls" }, [t.allowEdit ? e("app-icon-button", { staticClass: "edit-comment-button", attrs: { size: 26 }, on: { click: function(i) {
    return i.preventDefault(), t.onEditComment.apply(null, arguments);
  } } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-pencil" } })], 1) : t._e(), t.allowDelete ? e("app-icon-button", { staticClass: "delete-comment-button", attrs: { size: 26 }, on: { click: function(i) {
    return i.preventDefault(), t.onDeleteComment.apply(null, arguments);
  } } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1) : t._e()], 1)]), t.showEdit ? e("div", { staticClass: "text-area-wrapper" }, [e("classic-comment-area", { attrs: { "original-text": t.comment.content, "context-id": t.contextId }, on: { "cancel-comment": t.onCancelEditComment, "save-comment": t.onUpdateComment } })], 1) : t.showText ? e("app-markdown-text", { staticClass: "comment-text", attrs: { text: t.text } }) : t._e()], 1);
}, cT = [], uT = /* @__PURE__ */ f(
  oT,
  lT,
  cT,
  !1,
  null,
  "f35d9ed1"
);
const Sc = uT.exports, dT = g({
  components: { ClassicCommentItem: Sc },
  props: {
    commentIdPrefix: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !1
    },
    comments: {
      type: Array,
      default: () => []
    },
    threadOwnerId: {
      type: String,
      default: ""
    },
    threadOwnerLabel: {
      type: String,
      default: ""
    },
    permissions: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      newCommentText: "",
      showDeleteCommentModal: !1,
      currentComment: {}
    };
  },
  mounted() {
    this.scrollToComment();
  },
  computed: {
    newestComments() {
      return [...this.comments].sort(
        (s, t) => t.createdAt - s.createdAt
      );
    }
  },
  methods: {
    scrollToComment() {
      setTimeout(() => {
        const s = this.$route.hash.split("_");
        if (s.length === 2 && s[0] === `#${this.commentIdPrefix}`) {
          const t = document.getElementById(`comment_${s[1]}`);
          t == null || t.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "start"
          });
        }
      }, 1e3);
    },
    allowAction(s, t) {
      var n, r;
      if (!this.permissions)
        return !1;
      const { admin: e, user: i } = this.permissions;
      return e[t] || i[t] && this.currentUser.id === ((r = (n = s.author) == null ? void 0 : n.user) == null ? void 0 : r.id);
    },
    onCreateComment(s) {
      this.$emit("post-comment", s);
    },
    onUpdateComment(s) {
      this.$emit("update-comment", s);
    },
    onDeleteComment(s) {
      const t = this.comments.find((e) => e.commentId === s);
      t && this.openDeleteCommentModal(t);
    },
    openDeleteCommentModal(s) {
      this.currentComment = s, this.showDeleteCommentModal = !0;
    },
    closeDeleteCommentModal() {
      this.showDeleteCommentModal = !1;
    },
    deleteComment() {
      this.closeDeleteCommentModal(), this.$emit("delete-comment", this.currentComment);
    }
  }
});
var pT = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-form", { staticClass: "base-comment-container" }, [e("classic-comment-area", { attrs: { "context-id": t.contextId }, on: { "save-comment": t.onCreateComment } }), t._l(t.newestComments, function(i) {
    return e("div", { key: i.id }, [e("classic-comment-item", { attrs: { "allow-delete": t.allowAction(i, "delete"), "allow-edit": t.allowAction(i, "edit"), comment: i, "product-id": t.productId, "thread-owner-id": t.threadOwnerId, "thread-owner-label": t.threadOwnerLabel, "context-id": t.contextId }, on: { "delete-comment": t.onDeleteComment, "update-comment": t.onUpdateComment } })], 1);
  }), t.showDeleteCommentModal ? e("app-modal-confirmation", { attrs: { title: t.$t("modal.deleteComment.title"), description: t.$t("modal.deleteComment.description"), "primary-label": t.$t("form.button.confirm"), "secondary-label": t.$t("form.button.cancel") }, on: { "click-primary": t.deleteComment, "click-secondary": t.closeDeleteCommentModal } }) : t._e()], 2);
}, hT = [], fT = /* @__PURE__ */ f(
  dT,
  pT,
  hT,
  !1,
  null,
  "df27714b"
);
const Tc = fT.exports, mT = g({
  props: {
    targetId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !1
    },
    threadOwnerId: {
      type: String,
      required: !0
    },
    threadOwnerLabel: {
      type: String,
      default: ""
    },
    userActions: {
      type: Array,
      default: () => []
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  components: {
    BaseComments: Tc
  },
  data() {
    return {
      reloadKey: 0,
      comments: [],
      commentPermissions: {
        admin: {
          delete: !1,
          edit: !1
        },
        user: {
          delete: !1,
          edit: !1
        }
      }
    };
  },
  async created() {
    this.commentPermissions = {
      admin: {
        delete: this.userActions.includes("ADMIN_COMMENT_DELETE"),
        edit: this.userActions.includes("ADMIN_COMMENT_UPDATE")
      },
      user: {
        delete: this.userActions.includes("USER_COMMENT_DELETE"),
        edit: this.userActions.includes("USER_COMMENT_WRITE")
      }
    }, await this.loadComments();
  },
  methods: {
    async loadComments() {
      this.comments = await this.$gateway.portal.getPublicComments(
        this.targetId
      );
    },
    updateComment(s) {
      var r, a, o, l;
      const { comment: t, text: e } = s, i = this.currentUser.id === ((a = (r = t.author) == null ? void 0 : r.user) == null ? void 0 : a.id), n = { author: (l = (o = t.author) == null ? void 0 : o.user) == null ? void 0 : l.id, content: e };
      i ? this.$api.comment.updateOwnComment(
        this.targetId,
        t.commentId,
        n
      ) : this.$api.comment.adminUpdateComment(
        this.targetId,
        t.commentId,
        n
      ), this.comments = this.comments.map(
        (c) => c.commentId === t.commentId ? { ...c, content: e } : c
      ), this.reloadKey += 1, this.refreshReactionBoard();
    },
    async deleteComment(s) {
      var i, n;
      const t = this.currentUser.id === ((n = (i = s.author) == null ? void 0 : i.user) == null ? void 0 : n.id);
      let e;
      t ? e = this.$api.comment.deleteOwnComment(
        this.targetId,
        s.commentId
      ) : e = this.$api.comment.adminDeleteComment(
        this.targetId,
        s.commentId
      ), this.comments = this.comments.filter(
        (r) => r.commentId !== s.commentId
      ), await e, this.reloadKey += 1, this.refreshReactionBoard();
    },
    async postNewComment(s) {
      await this.$gateway.portal.createPublicComment(this.targetId, {
        author: this.currentUser.id,
        content: s
      }), await this.loadComments(), this.reloadKey += 1, this.refreshReactionBoard();
    },
    refreshReactionBoard() {
      this.$datasource.reaction.refreshReactionBoard(this.targetId);
    }
  }
});
var gT = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("base-comments", { key: t.reloadKey, attrs: { "comment-id-prefix": "comment", "current-user": t.currentUser, "product-id": t.productId, comments: t.comments, "thread-owner-id": t.threadOwnerId, "thread-owner-label": t.threadOwnerLabel, permissions: t.commentPermissions, "context-id": t.contextId }, on: { "delete-comment": t.deleteComment, "post-comment": t.postNewComment, "update-comment": t.updateComment } });
}, _T = [], yT = /* @__PURE__ */ f(
  mT,
  gT,
  _T,
  !1,
  null,
  null
);
const Ic = yT.exports, bT = g({
  props: {
    targetId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !1
    },
    threadOwnerId: {
      type: String,
      required: !1
    },
    threadOwnerLabel: {
      type: String,
      required: !1
    },
    userActions: {
      type: Array,
      default: () => []
    },
    targetType: {
      type: String,
      default: "TICKET"
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  components: {
    BaseComments: Tc
  },
  data() {
    return {
      reloadKey: 0,
      commentPermissions: {
        admin: {
          delete: !1,
          edit: !1
        },
        user: {
          delete: !1,
          edit: !1
        }
      },
      comments: []
    };
  },
  async created() {
    this.commentPermissions = {
      admin: {
        delete: this.userActions.includes("ADMIN_PRIVATE_COMMENT_DELETE"),
        edit: this.userActions.includes("ADMIN_PRIVATE_COMMENT_WRITE")
      },
      user: {
        delete: this.userActions.includes("ADMIN_PRIVATE_COMMENT_DELETE_OWN"),
        edit: this.userActions.includes("ADMIN_PRIVATE_COMMENT_WRITE")
      }
    }, await this.loadComments();
  },
  methods: {
    async loadComments() {
      this.comments = await this.$gateway.portal.getPrivateComments(
        this.targetId,
        this.targetType
      );
    },
    updateComment(s) {
      var r, a, o, l;
      const { comment: t, text: e } = s, i = this.currentUser.id === ((a = (r = t.author) == null ? void 0 : r.user) == null ? void 0 : a.id), n = { author: (l = (o = t.author) == null ? void 0 : o.user) == null ? void 0 : l.id, content: e };
      i ? this.$api.privateComment.adminUpdateOwnComment(
        this.targetId,
        t.commentId,
        n,
        this.targetType
      ) : this.$api.privateComment.adminUpdateComment(
        this.targetId,
        t.commentId,
        n,
        this.targetType
      ), this.comments = this.comments.map(
        (c) => c.commentId === t.commentId ? { ...c, content: e } : c
      ), this.reloadKey += 1;
    },
    deleteComment(s) {
      var e, i;
      this.currentUser.id === ((i = (e = s.author) == null ? void 0 : e.user) == null ? void 0 : i.id) ? this.$api.privateComment.deleteOwnComment(
        this.targetId,
        s.commentId,
        this.targetType
      ) : this.$api.privateComment.deleteComment(
        this.targetId,
        s.commentId,
        this.targetType
      ), this.comments = this.comments.filter(
        (n) => n.commentId !== s.commentId
      ), this.reloadKey += 1, this.$emit("delete-comment");
    },
    async postNewComment(s) {
      await this.$api.privateComment.createComment(
        this.targetId,
        this.targetType,
        {
          author: this.currentUser.id,
          content: s
        }
      ), await this.loadComments(), this.reloadKey += 1, this.$emit("post-comment");
    }
  }
});
var vT = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("base-comments", { key: t.reloadKey, attrs: { "comment-id-prefix": "privatecomment", "product-id": t.productId, "current-user": t.currentUser, comments: t.comments, "thread-owner-id": t.threadOwnerId, "thread-owner-label": t.threadOwnerLabel, permissions: t.commentPermissions, "context-id": t.contextId }, on: { "delete-comment": t.deleteComment, "post-comment": t.postNewComment, "update-comment": t.updateComment } });
}, kT = [], xT = /* @__PURE__ */ f(
  bT,
  vT,
  kT,
  !1,
  null,
  null
);
const Ac = xT.exports, CT = g({
  components: {
    PublicCommentsWidget: Ic,
    PrivateCommentsWidget: Ac,
    TicketHistoryWidget: vc,
    TicketTransactionsWidget: xc
  },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    value: {
      type: String,
      required: !1
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    userRoles: {
      type: Array,
      required: !0
    },
    showTransactions: {
      type: Boolean,
      default: !1
    },
    contextId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      tabs: {
        comments: !0,
        privateComments: !1,
        history: !1,
        transactions: !1
      },
      currentTab: "comments",
      publicCreatorTitle: ""
    };
  },
  async created() {
    this.publicCreatorTitle = await this.getPublicCreatorTitle(this.ticket);
  },
  watch: {
    value(s) {
      this.currentTab !== s && this.goToTab(s);
    }
  },
  async mounted() {
    this.$route.hash.startsWith("#privatecomment") && this.goToTab("privateComments"), this.$route.hash === "#transactions" && this.goToTab("transactions");
  },
  computed: {
    showPrivateNotes() {
      return this.userActions.some(
        (s) => s === "ADMIN_PRIVATE_COMMENT_READ"
      );
    },
    tabOptions() {
      return [
        {
          label: this.$t("common.comments").toString(),
          tabKey: "comments"
        },
        {
          label: this.$t("common.history").toString(),
          tabKey: "history"
        },
        {
          label: this.$t("common.privateNotes").toString(),
          tabKey: "privateComments",
          visible: this.showPrivateNotes
        },
        {
          label: this.$t("common.transactions").toString(),
          tabKey: "transactions",
          visible: this.showTransactions
        }
      ];
    }
  },
  methods: {
    goToTab(s) {
      this.hideTabs(), this.tabs[s] = !0, this.currentTab = s, this.$emit("input", s);
    },
    hideTabs() {
      Object.keys(this.tabs).forEach((s) => {
        this.tabs[s] = !1;
      });
    },
    async getPublicCreatorTitle(s) {
      var i;
      const t = await this.$datasource.workflow.find(
        s.type,
        s.context
      ), e = er(t, this.appId).page(
        this.$router.currentRoute.name
      );
      return ((i = this.$res(e == null ? void 0 : e.resources)) == null ? void 0 : i.creator) ?? "";
    }
  }
});
var wT = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.userActions.length ? e("div", [e("app-tabs", { staticClass: "tabs", attrs: { tabs: t.tabOptions }, on: { input: t.goToTab }, model: { value: t.currentTab, callback: function(i) {
    t.currentTab = i;
  }, expression: "currentTab" } }), e("transition", { attrs: { mode: "out-in", name: "slide-fade-fast" } }, [t.tabs.comments ? e("public-comments-widget", { attrs: { "current-user": t.currentUser, "product-id": t.ticket.type, "target-id": t.ticket.canonicalId, "thread-owner-id": t.ticket.creator, "thread-owner-label": t.publicCreatorTitle, "user-actions": t.userActions, "context-id": t.contextId } }) : t._e(), t.tabs.privateComments ? e("private-comments-widget", { attrs: { "current-user": t.currentUser, "product-id": t.ticket.type, "target-id": t.ticket.canonicalId, "user-actions": t.userActions, "context-id": t.contextId } }) : t._e(), t.tabs.history ? e("ticket-history-widget", { attrs: { "context-id": t.ticket.context, organization: t.organization, "product-id": t.ticket.type, "ticket-id": t.ticket.canonicalId, "current-user": t.currentUser, "user-actions": t.userActions, "user-roles": t.userRoles } }) : t._e(), t.tabs.transactions ? e("ticket-transactions-widget", { attrs: { "ticket-id": t.ticket.id } }) : t._e()], 1)], 1) : t._e();
}, $T = [], ST = /* @__PURE__ */ f(
  CT,
  wT,
  $T,
  !1,
  null,
  "3abc71e3"
);
const TT = ST.exports, IT = g({
  components: {
    ProductDropdown: ar
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    ticketId: {
      type: String,
      required: !0
    },
    action: {
      type: String,
      default: "copy"
    }
  },
  data() {
    return {
      loading: !1,
      targetProduct: "",
      workflows: []
    };
  },
  async created() {
    this.workflows = await this.$gateway.admin.fetchWorkflowsByBatch(
      this.productIds,
      this.organization.name
    ), this.targetProduct = this.productIds[0];
  },
  computed: {
    productIds() {
      const { productsData: s } = Ht(this.organization);
      return s.value.filter(
        ({ customization: t }) => {
          var e;
          return !!((e = t.ticketCopyMapping) != null && e[this.productId]);
        }
      ).filter(
        ({ productId: t }) => !(this.action === "move" && t === this.productId)
      ).map(({ productId: t }) => t).flat();
    }
  },
  methods: {
    async executeAction() {
      try {
        this.loading = !0;
        let s;
        return this.action === "copy" ? s = await this.$api.ticket.copyTicket(
          this.productId,
          this.targetProduct,
          this.ticketId
        ) : s = await this.$api.ticket.moveTicket(
          this.productId,
          this.targetProduct,
          this.ticketId
        ), s == null ? void 0 : s.canonicalId;
      } catch (s) {
        console.error(`Could not execute ${this.action} action`, s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const s = await this.executeAction();
      if (s) {
        this.$emit("confirm", s);
        return;
      }
      this.onCancel();
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var AT = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t(`ticket.${t.action}.title`)) + " ")]), e("div", { staticClass: "modal-description" }, [t._v(" " + t._s(t.$t(`ticket.${t.action}.description`)) + " ")]), e("product-dropdown", { staticClass: "product-dropdown", attrs: { context: t.organization.name, placeholder: t.$t("form.placeholder.productSelect"), products: t.productIds, workflows: t.workflows }, model: { value: t.targetProduct, callback: function(i) {
    t.targetProduct = i;
  }, expression: "targetProduct" } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { enabled: !!t.targetProduct, label: t.$t("common.form.confirm") }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, PT = [], OT = /* @__PURE__ */ f(
  IT,
  AT,
  PT,
  !1,
  null,
  "c0cef0bd"
);
const MT = OT.exports, RT = g({
  components: {
    TicketCopyMoveModal: MT
  },
  props: {
    userActions: {
      type: Array,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    ticketId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      showResult: !1,
      showActionModal: !1,
      action: void 0,
      targetProduct: "",
      newTicketId: ""
    };
  },
  computed: {
    menuItems() {
      return [
        {
          label: this.$t("common.copy").toString(),
          tabKey: "copy",
          visible: this.showCopyOption
        },
        {
          label: this.$t("common.move").toString(),
          tabKey: "move",
          visible: this.showMoveOption
        }
      ].filter(({ visible: s }) => s);
    },
    showCopyOption() {
      return this.checkPermission("USER_TICKET_COPY") && this.hasDuplicationSettings;
    },
    showMoveOption() {
      return this.checkPermission("USER_TICKET_MOVE") && this.hasDuplicationSettings;
    },
    hasDuplicationSettings() {
      const { productsData: s } = Ht(this.organization);
      return s.value.some(
        ({ customization: t }) => {
          var e;
          return !!((e = t.ticketCopyMapping) != null && e[this.productId]);
        }
      );
    }
  },
  methods: {
    checkPermission(s) {
      const t = `${this.productId.toUpperCase()}_${s}`;
      return this.userActions.includes(s) || this.userActions.includes(t);
    },
    onMove() {
      this.action = "move", this.showActionModal = !0;
    },
    onCopy() {
      this.action = "copy", this.showActionModal = !0;
    },
    onCancel() {
      this.reset();
    },
    onConfirm(s) {
      this.showActionModal = !1, this.showResult = !0, this.newTicketId = s;
    },
    reset() {
      this.showResult = !1, this.showActionModal = !1, this.action = void 0, this.newTicketId = "", this.targetProduct = "";
    },
    onGoToTicket() {
      this.$router.push({
        name: "TicketDetails",
        params: { id: this.newTicketId }
      });
    }
  }
});
var ET = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.menuItems.length ? e("div", [e("app-ellipsis-menu", { staticClass: "menu-button", attrs: { "menu-options": t.menuItems }, on: { "click:copy": t.onCopy, "click:move": t.onMove }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("fa-icon-compat", { attrs: { icon: "fa-solid fa-ellipsis-vertical" } })];
  }, proxy: !0 }], null, !1, 92845945) }), t.action && t.showActionModal ? e("ticket-copy-move-modal", { attrs: { action: t.action, organization: t.organization, "product-id": t.productId, "ticket-id": t.ticketId }, on: { cancel: t.onCancel, confirm: t.onConfirm } }) : t._e(), t.showResult ? e("app-modal-confirmation", { attrs: { description: t.$t(`ticket.${t.action}.success.description`), "primary-label": t.$t("ticket.viewTicket"), "secondary-label": t.$t("common.form.close"), title: t.$t(`ticket.${t.action}.success.title`) }, on: { "click-primary": t.onGoToTicket, "click-secondary": t.onCancel } }) : t._e()], 1) : t._e();
}, DT = [], FT = /* @__PURE__ */ f(
  RT,
  ET,
  DT,
  !1,
  null,
  "7896e2d5"
);
const LT = FT.exports, qT = g({
  props: {
    assignee: {
      type: Object,
      required: !0
    }
  },
  computed: {
    assigneeAvatar() {
      return this.assignee.user.avatar ?? "";
    },
    displayName() {
      return E(this.assignee).displayName();
    }
  }
});
var UT = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "assignee-indicator", attrs: { title: t.displayName } }, [t.assigneeAvatar ? e("img", { staticClass: "user-avatar", attrs: { src: t.assigneeAvatar } }) : e("fa-icon-compat", { staticClass: "user-icon", attrs: { icon: "fal fa-user" } })], 1);
}, NT = [], BT = /* @__PURE__ */ f(
  qT,
  UT,
  NT,
  !1,
  null,
  "76d71f23"
);
const jT = BT.exports, Bo = "/img/profile-placeholder.svg", zT = g({
  props: {
    value: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    excludeUserIds: {
      type: Array,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      optionsPool: [],
      enabled: !1,
      selection: ""
    };
  },
  async created() {
    const s = await this.$gateway.portal.fetchTicketAssigneePermissions(
      this.ticketIdOrType,
      this.productId
    );
    if (this.enabled = s.update, this.value) {
      const t = await this.$gateway.portal.findUsersById([this.value]);
      this.optionsPool = t.map((e) => ({
        text: E(e).displayName(),
        value: e.user.id,
        image: e.user.avatar || Bo,
        description: E(e).userDepartment()
      })), this.selection = this.value;
    }
  },
  computed: {
    ticketIdOrType() {
      return this.ticket.canonicalId ?? this.ticket.type;
    }
  },
  methods: {
    onUpdate(s) {
      this.$emit("input", s), this.$emit("update-assignee", s);
    },
    onToggleOpen(s) {
      s || (this.options = [], this.$emit("blur"));
    },
    async onSearchDebounced(s) {
      if (s.length < 3) {
        this.options = [];
        return;
      }
      this.loading = !0;
      const t = await this.$gateway.portal.fetchTicketAssigneeAudience(
        s,
        this.ticketIdOrType,
        this.productId
      );
      this.options = t.filter(({ user: e }) => e.firstName || e.lastName).filter(
        ({ user: e }) => {
          var i;
          return !((i = this.excludeUserIds) != null && i.includes(e.id));
        }
      ).map((e) => ({
        text: E(e).displayName(),
        value: e.user.id,
        image: e.user.avatar || Bo,
        description: E(e).userDepartment()
      })), this.loading = !1;
    }
  }
});
var VT = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-singleselect", { attrs: { label: t.label, placeholder: t.placeholder, options: t.options, "options-pool": t.optionsPool, loading: t.loading, enabled: t.enabled, required: t.required, tooltip: t.tooltip, error: t.error }, on: { "toggle-open": t.onToggleOpen, "update-single": t.onUpdate }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [e("app-search-input", { staticClass: "inner-search", attrs: { placeholder: t.searchPlaceholder, "debounce-timeout": 500 }, on: { debounced: t.onSearchDebounced } })];
  }, proxy: !0 }]), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } });
}, HT = [], WT = /* @__PURE__ */ f(
  zT,
  VT,
  HT,
  !1,
  null,
  "39f6760e"
);
const GT = WT.exports, KT = g({
  components: {
    UserItem: Ei,
    UserSelectionInput: Di
  },
  props: {
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    routeToUser: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      ready: !1,
      canUpdate: !1,
      searchOpen: !1,
      currentSelection: void 0,
      searchOptions: []
    };
  },
  watch: {
    ticket() {
      this.load();
    }
  },
  async created() {
    await this.loadPermission(), await this.load(), this.ready = !0;
  },
  computed: {
    ticketIdOrType() {
      return this.ticket.canonicalId ?? this.ticket.type;
    },
    currentSelectionId() {
      return this.ticket.assignee;
    },
    display() {
      return this.searchOpen ? "search" : this.currentSelection ? "selected" : "empty";
    },
    menuOptions() {
      return [
        {
          label: this.$t("menu.changeToMe").toString(),
          tabKey: "assign-to-self",
          visible: this.ticket.assignee !== this.currentUser.id
        },
        {
          label: this.$t("menu.changeToSomeone").toString(),
          tabKey: "assign-to-other"
        },
        {
          label: this.$t("menu.unassign").toString(),
          tabKey: "remove-assignee"
        }
      ];
    }
  },
  methods: {
    async loadPermission() {
      try {
        const s = await this.$gateway.portal.fetchTicketAssigneePermissions(
          this.ticketIdOrType,
          this.productId
        );
        this.canUpdate = (s == null ? void 0 : s.update) ?? !1;
      } catch (s) {
        console.error("Error loading assignement permissions", s);
      }
    },
    async load() {
      try {
        if (!this.currentSelectionId) {
          this.currentSelection = void 0;
          return;
        }
        const s = await this.$gateway.portal.findUserById(
          this.currentSelectionId
        );
        this.currentSelection = s ?? void 0, this.currentSelection || console.error(
          `Error loading ticket assignee [userId=${this.currentSelectionId}]`
        );
      } finally {
        this.onCloseSearch();
      }
    },
    async onUpdateSearch(s) {
      this.searchOptions = await this.$gateway.portal.fetchTicketAssigneeAudience(
        s,
        this.ticketIdOrType,
        this.productId
      );
    },
    onRemoveAssignee() {
      this.$emit("update-assignee");
    },
    onSelectUser(s) {
      this.$emit("update-assignee", s);
    },
    onSelectSelf() {
      this.onSelectUser(this.currentUser.id);
    },
    onOpenSearch() {
      this.searchOptions = [], this.searchOpen = !0;
    },
    onCloseSearch() {
      this.searchOpen = !1;
    }
  }
});
var YT = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-assignment-selection" }, [t.ready ? e("transition", { attrs: { mode: "out-in", name: "slide-fade" } }, [t.display === "empty" && t.canUpdate ? e("app-list-item", { staticClass: "empty-item", attrs: { image: "/img/add-user-placeholder.svg", title: t.$t("page.ticketDetails.assignToPerson") }, nativeOn: { click: function(i) {
    return t.onOpenSearch.apply(null, arguments);
  } } }) : t._e(), t.display === "empty" && !t.canUpdate ? e("app-list-item", { attrs: { image: "/img/profile-placeholder.svg", title: t.$t("page.ticketDetails.notAssigned") } }) : t.display === "selected" ? e("a", { attrs: { href: t.routeToUser(t.currentSelection.user), target: "_blank" } }, [e("user-item", { staticClass: "user-item", attrs: { "user-data": t.currentSelection }, scopedSlots: t._u([{ key: "controls", fn: function() {
    return [t.canUpdate ? e("app-ellipsis-menu", { attrs: { "menu-options": t.menuOptions }, on: { "click:assign-to-self": function(i) {
      return t.onSelectUser(t.currentUser.id);
    }, "click:assign-to-other": t.onOpenSearch, "click:remove-assignee": t.onRemoveAssignee } }) : t._e()];
  }, proxy: !0 }], null, !1, 1968392141) })], 1) : t.display === "search" ? e("user-selection-input", { attrs: { options: t.searchOptions }, on: { "hide-floating": t.onCloseSearch, "update-search": t.onUpdateSearch, "select-item": t.onSelectUser }, scopedSlots: t._u([t.currentUser.id !== t.ticket.assignee ? { key: "prepend", fn: function() {
    return [e("app-list-item", { attrs: { image: t.currentUser.avatar, title: t.$t("menu.assignToMe") }, nativeOn: { click: function(i) {
      return t.onSelectSelf.apply(null, arguments);
    } } })];
  }, proxy: !0 } : null], null, !0) }) : t._e()], 1) : t._e()], 1);
}, XT = [], ZT = /* @__PURE__ */ f(
  KT,
  YT,
  XT,
  !1,
  null,
  "5fec165d"
);
const QT = ZT.exports, JT = g({
  name: "CampaignGalleryCard",
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    creator: {
      type: Object,
      required: !0
    }
  },
  computed: {
    statusLabel() {
      var t;
      const s = Y(this.ticket.status, this.workflow);
      return ((t = this.$res(s)) == null ? void 0 : t.label) ?? this.ticket.status;
    },
    statusColour() {
      return Ps(this.ticket.status, this.workflow) ?? "";
    },
    coverImage() {
      return this.ticket.meta.cover || this.fileImage;
    },
    fileImage() {
      const t = this.ticket.files.find(
        (e) => e.category === "ticket-cover"
      );
      return (t == null ? void 0 : t.url) || "";
    },
    creatorUserNameAndUnit() {
      if (!this.creator)
        return "";
      const { displayName: s, userDepartment: t } = E(this.creator);
      return t() ? `${this.$t("common.by")} ${s()}, ${t()}` : `${this.$t("common.by")} ${s()}`;
    }
  }
});
var tI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "campaign-gallery-card" }, [e("div", { staticClass: "ticket-cover", style: `background-image: url(${t.coverImage});` }, [e("div", { staticClass: "ticket-phase", style: `color: ${t.statusColour}` }, [t._v(" " + t._s(t.statusLabel) + " ")])]), e("div", { staticClass: "ticket-card-body" }, [e("div", { staticClass: "ticket-title" }, [t._v(" " + t._s(t.ticket.title) + " ")]), e("div", { staticClass: "ticket-tagline" }, [t._v(" " + t._s(t.creatorUserNameAndUnit) + " ")])])]);
}, eI = [], sI = /* @__PURE__ */ f(
  JT,
  tI,
  eI,
  !1,
  null,
  "b7c202ed"
);
const iI = sI.exports, nI = g({
  name: "TicketCardCampaign",
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    creator: {
      type: Object,
      required: !1
    },
    reactionBoard: {
      type: Object,
      required: !1
    },
    showEmojiViewer: {
      type: Boolean,
      default: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    creatorVisibility: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    statusLabel() {
      var t;
      const s = Y(this.ticket.status, this.workflow);
      return ((t = this.$res(s)) == null ? void 0 : t.label) ?? this.ticket.status;
    },
    statusColour() {
      return Ps(this.ticket.status, this.workflow) ?? "";
    },
    coverImage() {
      return this.ticket.meta.cover || this.fileImage;
    },
    fileImage() {
      const t = this.ticket.files.find(
        (e) => e.category === "ticket-cover"
      );
      return (t == null ? void 0 : t.url) || "";
    },
    creatorUserNameAndUnit() {
      if (!this.creator || !this.creatorVisibility)
        return "";
      const { displayName: s, userDepartment: t } = E(this.creator);
      return t() ? `${this.$t("common.by")} ${s()}, ${t()}` : `${this.$t("common.by")} ${s()}`;
    }
  }
});
var rI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-card-campaign" }, [e("div", { staticClass: "ticket-cover", style: `background-image: url(${t.coverImage});` }, [e("div", { staticClass: "ticket-phase", style: `background-color: ${t.statusColour}` }, [t._v(" " + t._s(t.statusLabel) + " ")])]), e("div", { staticClass: "ticket-card-body" }, [e("div", { staticClass: "ticket-title" }, [t._v(" " + t._s(t.ticket.title) + " ")]), e("div", { staticClass: "ticket-tagline" }, [t._v(" " + t._s(t.creatorUserNameAndUnit) + " ")])]), e("div", { staticClass: "ticket-card-bottom" }, [t.reactionBoard ? e("social-action-bar", { attrs: { board: t.reactionBoard, "current-user-id": t.currentUserId, "show-emoji-viewer": t.showEmojiViewer, "ticket-id": t.ticket.canonicalId, "visible-reactions": 1 } }) : t._e()], 1)]);
}, aI = [], oI = /* @__PURE__ */ f(
  nI,
  rI,
  aI,
  !1,
  null,
  "3edb8d82"
);
const lI = oI.exports, cI = g({
  props: {
    resources: {
      type: Object,
      required: !0
    },
    firstCitizenAggregation: {
      type: Object,
      required: !1
    },
    imagePath: {
      type: String,
      required: !0
    }
  },
  computed: {
    amount() {
      return this.average && !isNaN(this.average) ? this.average.toFixed(1) : "-";
    },
    average() {
      var s;
      return (s = this.firstCitizenAggregation) == null ? void 0 : s.average;
    },
    userReviewsAmount() {
      var s;
      return ((s = this.firstCitizenAggregation) == null ? void 0 : s.userFieldsUserCount) ?? 0;
    },
    questions() {
      const { questions: s } = this.resources;
      return s.filter((t) => t.type === "rating").map((t) => {
        var i;
        const e = ((i = this.firstCitizenAggregation) == null ? void 0 : i.averagePerQuestion[t.id]) ?? 0;
        return {
          title: t.title,
          id: t.id,
          valueImageUrl: t.valueImageUrl,
          value: e.toFixed(1)
        };
      });
    },
    firstCitizenLabel() {
      var s;
      return (s = this.firstCitizenAggregation) != null && s.audience ? this.$t("firstCitizen.adminReviews").toString() : this.$t("firstCitizen.userReviews").toString();
    }
  }
});
var uI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "floating-container", class: { "no-responses": !t.average } }, [t.average ? e("div", [e("div", { staticClass: "content header" }, [e("span", [t._v(" " + t._s(t.firstCitizenLabel) + " (" + t._s(t.userReviewsAmount) + ") ")]), e("span", { staticClass: "rating" }, [e("img", { attrs: { height: 16, src: t.imagePath, alt: "rating" } }), e("span", { staticClass: "amount" }, [t._v(" " + t._s(t.amount))])])]), e("hr", { staticClass: "line-break" }), t._l(t.questions, function(i) {
    return e("div", { key: i.id, staticClass: "content" }, [e("div", { staticClass: "content-label" }, [t._v(t._s(i.title))]), e("div", { staticClass: "rating" }, [e("img", { attrs: { height: 14, src: i.valueImageUrl, alt: "rating" } }), e("span", { staticClass: "amount" }, [t._v(t._s(i.value))])])]);
  })], 2) : e("div", [t._v(" " + t._s(t.$t("firstCitizen.noResponses")) + " ")])]);
}, dI = [], pI = /* @__PURE__ */ f(
  cI,
  uI,
  dI,
  !1,
  null,
  "423b33ee"
);
const hI = pI.exports, fI = g({
  props: {
    firstCitizenAggregation: {
      type: Object,
      required: !0
    },
    floatingPlacement: {
      type: String,
      default: "left"
    },
    ticket: {
      type: Object,
      required: !1
    },
    productId: {
      type: String,
      required: !1
    },
    currentUser: {
      type: Object,
      required: !1
    },
    enableClick: {
      type: Boolean,
      default: !1
    },
    hasWriteAction: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    FirstCitizenHover: hI
  },
  data() {
    return {
      openFeedbackResultModal: !1
    };
  },
  computed: {
    hasCurrentUserFeedback() {
      var s;
      return this.currentUser ? !!((s = Object.values(this.feedbackEntries)[0]) != null && s[this.currentUser.id]) : !1;
    },
    feedbackEntries() {
      return this.firstCitizenAggregation.userFields ?? {};
    },
    amount() {
      const { average: s = void 0 } = this.firstCitizenAggregation || {};
      return s && !isNaN(s) ? s.toFixed(1) : "-";
    },
    resources() {
      const s = this.$gateway.feedback.parseFeedbackDialogue(
        this.firstCitizenAggregation.meta.feedback,
        this.firstCitizenAggregation.resources,
        this.firstCitizenAggregation.canonicalId,
        this.firstCitizenAggregation.group
      );
      return this.$res(s);
    },
    imagePath() {
      return "/img/star.svg";
    }
  },
  methods: {
    async manageRatingPopup() {
      var s;
      this.enableClick && (!this.hasCurrentUserFeedback && this.hasWriteAction ? (this.$modal(
        (s = this.firstCitizenAggregation.meta) == null ? void 0 : s["feedback-type"],
        this.resources
      ), this.$router.replace({ query: { reload: "false" } })) : this.openFeedbackResultModal = !0);
    }
  }
});
var mI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("app-floating-hover", { class: { pointer: t.enableClick }, style: { position: "static" }, attrs: { enabled: !!t.firstCitizenAggregation, placement: t.floatingPlacement }, nativeOn: { click: function(i) {
    return t.manageRatingPopup.apply(null, arguments);
  } }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("social-rating-button", { attrs: { amount: t.amount, "image-path": t.imagePath } })];
  }, proxy: !0 }, { key: "floating", fn: function() {
    return [t.resources ? e("first-citizen-hover", { attrs: { resources: t.resources, "first-citizen-aggregation": t.firstCitizenAggregation, "image-path": t.imagePath } }) : t._e()];
  }, proxy: !0 }]) }), t.openFeedbackResultModal && t.productId && t.currentUser ? e("feedback-result-modal", { attrs: { "product-id": t.productId, "ticket-id": t.firstCitizenAggregation.canonicalId, "current-user": t.currentUser }, on: { close: function(i) {
    t.openFeedbackResultModal = !1;
  } } }) : t._e()], 1);
}, gI = [], _I = /* @__PURE__ */ f(
  fI,
  mI,
  gI,
  !1,
  null,
  "a028fad4"
);
const Pc = _I.exports, yI = g({
  name: "TicketCardVerticalDefault",
  components: {
    FirstCitizenPill: Pc
  },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    creator: {
      type: Object,
      required: !0
    },
    reactionBoard: {
      type: Object,
      required: !1
    },
    showEmojiViewer: {
      type: Boolean,
      default: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    publicFirstCitizen: {
      type: Object,
      required: !1
    },
    adminFirstCitizen: {
      type: Object,
      required: !1
    },
    userActions: {
      type: Array,
      default: () => []
    },
    creatorVisibility: {
      type: Boolean,
      default: !0
    }
  },
  setup(s) {
    const { firstCitizen: t, hasFirstCitizenReadPermission: e } = Vl(
      st(s.publicFirstCitizen),
      st(s.adminFirstCitizen),
      s.userActions
    );
    return { firstCitizen: t, hasFirstCitizenReadPermission: e };
  },
  computed: {
    statusLabel() {
      const s = Y(this.ticket.status, this.workflow);
      return this.$res(s ?? {}).label;
    },
    statusColour() {
      return Ps(this.ticket.status, this.workflow) ?? "";
    },
    coverImage() {
      return this.ticket.meta.cover || this.fileImage;
    },
    fileImage() {
      const t = this.ticket.files.find(
        (e) => e.category === "ticket-cover"
      );
      return (t == null ? void 0 : t.url) || "";
    },
    creatorUserNameAndUnit() {
      if (!this.creator || !this.creatorVisibility)
        return "";
      const { displayName: s, userDepartment: t } = E(this.creator);
      return t() ? `${this.$t("common.by")} ${s()}, ${t()}` : `${this.$t("common.by")} ${s()}`;
    }
  }
});
var bI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-card-vertical" }, [e("div", { staticClass: "ticket-cover", style: `background-image: url(${t.coverImage});` }, [e("div", { staticClass: "ticket-phase", style: `color: ${t.statusColour}` }, [t._v(" " + t._s(t.statusLabel) + " ")])]), e("div", { staticClass: "ticket-card-body" }, [e("div", { staticClass: "ticket-title" }, [t._v(" " + t._s(t.ticket.title) + " ")]), e("div", { staticClass: "ticket-tagline" }, [t._v(" " + t._s(t.creatorUserNameAndUnit) + " ")])]), t.hasFirstCitizenReadPermission && t.firstCitizen ? e("first-citizen-pill", { staticClass: "first-citizen", attrs: { "first-citizen-aggregation": t.firstCitizen, floatingPlacement: "auto" } }) : t._e(), e("div", { staticClass: "ticket-card-bottom" }, [t.reactionBoard ? e("social-action-bar", { attrs: { board: t.reactionBoard, "current-user-id": t.currentUserId, "show-emoji-viewer": t.showEmojiViewer, "ticket-id": t.ticket.canonicalId, "visible-reactions": 1 } }) : t._e()], 1)], 1);
}, vI = [], kI = /* @__PURE__ */ f(
  yI,
  bI,
  vI,
  !1,
  null,
  "5fa14bc0"
);
const xI = kI.exports, CI = g({
  props: {
    delegates: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    delegatesDisplay() {
      return this.delegates.map(({ type: s, data: t }) => {
        if (["workgroup"].includes(s))
          return this.getTeamDelegate(t);
        if (s === "topic")
          return this.getTopicDelegate(t);
      }).filter((s) => !!s);
    }
  },
  methods: {
    getTopicDelegate(s) {
      return {
        name: this.$res(s.resources).title,
        color: s.meta.color,
        type: "topic-type"
      };
    },
    getTeamDelegate(s) {
      return {
        name: Ot(s, this.$res).teamName(),
        color: "",
        type: "team-type"
      };
    }
  }
});
var wI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "delegate-list" }, t._l(t.delegatesDisplay, function(i) {
    return e("div", { key: i.id, class: `card-delegate ${i.type}`, style: { "background-color": i.color } }, [t._v(" " + t._s(i.name) + " ")]);
  }), 0);
}, $I = [], SI = /* @__PURE__ */ f(
  CI,
  wI,
  $I,
  !1,
  null,
  "281b1133"
);
const dr = SI.exports, TI = g({
  components: {
    DelegateTagList: dr
  },
  name: "TicketCardHorizontalDefault",
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    creator: {
      type: Object,
      required: !0
    },
    assignee: {
      type: Object,
      required: !1
    },
    delegates: {
      type: Array,
      default: () => []
    },
    reactionBoard: {
      type: Object,
      required: !1
    },
    showEmojiViewer: {
      type: Boolean,
      default: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    creatorVisibility: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    creatorUserNameAndUnit() {
      if (!this.creator || !this.creatorVisibility)
        return "";
      const { displayName: s, userDepartment: t } = E(this.creator);
      return t() ? `${this.$t("common.by")} ${s()}, ${t()}` : `${this.$t("common.by")} ${s()}`;
    }
  }
});
var II = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-card-container" }, [e("div", { staticClass: "card-info" }, [e("div", { staticClass: "ticket-card-row" }, [e("div", { staticClass: "ticket-card-title" }, [t._v(" " + t._s(t.ticket.title) + " ")])]), e("div", { staticClass: "ticket-card-creator" }, [t._v(" " + t._s(t.creatorUserNameAndUnit) + " ")]), e("div", { staticClass: "spacer" }), e("delegate-tag-list", { staticClass: "delegate-list", attrs: { delegates: t.delegates } }), e("div", { staticClass: "ticket-card-bottom" }, [t.reactionBoard ? e("social-action-bar", { staticClass: "social-action-bar", attrs: { board: t.reactionBoard, "current-user-id": t.currentUserId, "show-emoji-viewer": t.showEmojiViewer, "ticket-id": t.ticket.canonicalId, "visible-reactions": 1 } }) : t._e(), t.assignee ? e("assignee-indicator", { attrs: { assignee: t.assignee } }) : t._e()], 1)], 1)]);
}, AI = [], PI = /* @__PURE__ */ f(
  TI,
  II,
  AI,
  !1,
  null,
  "46911cb8"
);
const OI = PI.exports, MI = g({
  name: "AppTicketCard",
  props: {
    ticketResponse: {
      type: Object,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    cardStyle() {
      const { ticketCard: s } = Ge(
        this.ticketResponse.workflow
      );
      return s.style ?? "HorizontalDefault";
    },
    componentType() {
      switch (this.cardStyle) {
        case "HorizontalDefault":
          return "TicketCardHorizontalDefault";
        case "VerticalDefault":
          return "TicketCardVerticalDefault";
        case "Campaign":
          return "TicketCardCampaign";
        default:
          throw new Error(`Unknown ticket card style: '${this.cardStyle}'`);
      }
    },
    publicFirstCitizen() {
      var s;
      return (s = this.ticketResponse.firstCitizen) == null ? void 0 : s.children[0];
    },
    adminFirstCitizen() {
      var s;
      return (s = this.ticketResponse.adminFirstCitizen) == null ? void 0 : s.children[0];
    },
    productCustomization() {
      var t, e;
      const { productsData: s } = Ht(this.organization, [
        "main",
        "subproduct"
      ]);
      return (e = (t = s.value) == null ? void 0 : t.find(
        ({ productId: i }) => i === this.ticketResponse.ticket.type
      )) == null ? void 0 : e.customization;
    },
    accessProvider() {
      return {
        userId: this.currentUserId,
        // userRoles: this.userRoles,
        userActions: this.userActions,
        creatorId: this.ticketResponse.ticket.creator,
        assigneeId: this.ticketResponse.ticket.assignee
      };
    },
    creatorPolicyVisibility() {
      var e, i, n;
      const s = ((n = (i = (e = this.productCustomization) == null ? void 0 : e.accessPolicy) == null ? void 0 : i.creator) == null ? void 0 : n.view) ?? [], { accessGranted: t } = Ri(s, this.accessProvider);
      return t;
    }
  }
});
var RI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e(t.componentType, t._g(t._b({ tag: "component", attrs: { assignee: t.ticketResponse.assignee, "current-user-id": t.currentUserId, creator: t.ticketResponse.creator, delegates: t.ticketResponse.delegates, "reaction-board": t.ticketResponse.board, ticket: t.ticketResponse.ticket, workflow: t.ticketResponse.workflow, "public-first-citizen": t.publicFirstCitizen, "admin-first-citizen": t.adminFirstCitizen, "user-actions": t.userActions, "creator-visibility": t.creatorPolicyVisibility } }, "component", t.$attrs, !1), t.$listeners));
}, EI = [], DI = /* @__PURE__ */ f(
  MI,
  RI,
  EI,
  !1,
  null,
  null
);
const FI = DI.exports, LI = g({
  props: {
    text: {
      type: String,
      required: !0
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
});
var qI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-card-add", on: { click: t.onClick } }, [e("fa-icon-compat", { attrs: { icon: "fa-solid fa-plus" } }), t._v(" " + t._s(t.text) + " ")], 1);
}, UI = [], NI = /* @__PURE__ */ f(
  LI,
  qI,
  UI,
  !1,
  null,
  "50adf413"
);
const BI = NI.exports, jI = g({
  components: {
    FirstCitizenPill: Pc,
    DelegateTagList: dr,
    TicketStatusPill: $c
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    ticketResponse: {
      type: Object,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  setup(s) {
    var r, a;
    const t = (r = s.ticketResponse.firstCitizen) == null ? void 0 : r.children[0], e = (a = s.ticketResponse.adminFirstCitizen) == null ? void 0 : a.children[0], { firstCitizen: i, hasFirstCitizenReadPermission: n } = Vl(
      st(t),
      st(e),
      s.userActions
    );
    return { firstCitizen: i, hasFirstCitizenReadPermission: n };
  },
  computed: {
    ticket() {
      return this.ticketResponse.ticket;
    },
    workflow() {
      return this.ticketResponse.workflow;
    },
    creator() {
      return this.ticketResponse.creator;
    },
    imageUrl() {
      const s = this.ticket.meta.cover;
      if (s)
        return s;
      const e = this.ticket.files.find((i) => i.category === "ticket-cover");
      return e == null ? void 0 : e.url;
    },
    creatorUserNameAndUnit() {
      if (!this.creator || !this.creatorPolicyVisibility)
        return "";
      const { displayName: s, userDepartment: t } = E(this.creator);
      return t() ? `${this.$t("common.by")} ${s()}, ${t()}` : `${this.$t("common.by")} ${s()}`;
    },
    productCustomization() {
      var t, e;
      const { productsData: s } = Ht(this.organization, [
        "main",
        "subproduct"
      ]);
      return (e = (t = s.value) == null ? void 0 : t.find(
        ({ productId: i }) => i === this.ticketResponse.ticket.type
      )) == null ? void 0 : e.customization;
    },
    accessProvider() {
      return {
        userId: this.currentUserId,
        // userRoles: this.userRoles,
        userActions: this.userActions,
        creatorId: this.ticketResponse.ticket.creator,
        assigneeId: this.ticketResponse.ticket.assignee
      };
    },
    creatorPolicyVisibility() {
      var e, i, n;
      const s = ((n = (i = (e = this.productCustomization) == null ? void 0 : e.accessPolicy) == null ? void 0 : i.creator) == null ? void 0 : n.view) ?? [], { accessGranted: t } = Ri(s, this.accessProvider);
      return t;
    }
  }
});
var zI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-activity-card" }, [t.imageUrl ? e("div", { staticClass: "image" }, [e("img", { staticClass: "cover", attrs: { src: t.imageUrl } })]) : t._e(), e("div", { staticClass: "content" }, [t._t("ai-icon"), t.hasFirstCitizenReadPermission && t.firstCitizen ? e("first-citizen-pill", { staticClass: "first-citizen", attrs: { "first-citizen-aggregation": t.firstCitizen } }) : t._e(), e("div", { staticClass: "title" }, [t._v(" " + t._s(t.ticket.title) + " ")]), e("div", { staticClass: "creator" }, [t._v(" " + t._s(t.creatorUserNameAndUnit) + " ")]), e("div", { staticClass: "spacer" }), e("div", { staticClass: "tags" }, [e("delegate-tag-list", { attrs: { delegates: t.ticketResponse.delegates } }), e("ticket-status-pill", { staticClass: "status", attrs: { status: t.ticket.status, workflow: t.workflow } })], 1), e("div", { staticClass: "social" }, [e("social-action-bar", { attrs: { board: t.ticketResponse.board, "current-user-id": t.currentUserId, "show-emoji-viewer": !0, "ticket-id": t.ticket.canonicalId, "visible-reactions": 3 } }), e("div", { staticClass: "spacer" }), t.ticketResponse.assignee ? e("assignee-indicator", { attrs: { assignee: t.ticketResponse.assignee } }) : t._e()], 1)], 2)]);
}, VI = [], HI = /* @__PURE__ */ f(
  jI,
  zI,
  VI,
  !1,
  null,
  "e8fad874"
);
const WI = HI.exports, GI = g({
  props: {
    ticketId: {
      type: String,
      required: !0
    },
    category: {
      type: String,
      default: ""
    },
    file: {
      type: File,
      required: !0
    },
    randomFileId: {
      type: String,
      required: !0
    }
  },
  async mounted() {
    await this.uploadFile();
  },
  data() {
    return {
      status: "IDLE",
      progress: 0
    };
  },
  methods: {
    async uploadFile() {
      if (!this.file)
        return;
      const { upload: s, status: t, progress: e, result: i } = Ug(
        this.$api.fileAttachment,
        this.ticketId
      );
      Te(t, (n) => {
        n === "SUCCESS" ? this.$emit("upload-success", {
          randomFileId: this.randomFileId,
          userFile: We(i.value)
        }) : n === "ERROR" && this.$toast(this.$t("error.general").toString());
      }), Te(e, (n) => {
        this.progress = n;
      }), s(this.file, this.category);
    }
  }
});
var KI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-file-upload-item-progress" }, [e("fa-icon-compat", { staticClass: "file-preview-icon", attrs: { icon: "fa-light fa-file-arrow-up" } }), e("div", { staticClass: "file-details" }, [e("span", [t._v(t._s(t.file.name))]), e("progress", { attrs: { min: "0", max: "1" }, domProps: { value: t.progress } })])], 1);
}, YI = [], XI = /* @__PURE__ */ f(
  GI,
  KI,
  YI,
  !1,
  null,
  "c10fd75e"
);
const Oc = XI.exports, ZI = g({
  components: {
    AppFileUploadPermissionsModal: cc,
    AppFileUploadItem: Os,
    AppFileUploadItemProgress: Oc,
    AppFileUploadPicker: ir
  },
  props: {
    ticketId: {
      type: String,
      required: !0
    },
    files: {
      type: Array,
      default: () => []
    },
    acceptedExtensions: {
      type: Array,
      default: () => []
    },
    maxFileCount: {
      type: Number,
      required: !1
    },
    maxFileSize: {
      type: Number,
      required: !1
    },
    category: {
      type: String,
      default: ""
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      currentFiles: [],
      uploading: [],
      uploadPermissionVisible: !1,
      currentFile: void 0
    };
  },
  watch: {
    files() {
      this.currentFiles = this.files.map(We);
    }
  },
  created() {
    this.currentFiles = this.files.map(We), this.maxFileSize && hu("maxFileUploadSize", this.maxFileSize);
  },
  computed: {
    allowMoreFiles() {
      return !this.maxFileCount || this.currentFiles.length + this.uploading.length < this.maxFileCount;
    },
    menuOptions() {
      return [
        {
          label: this.$t("common.roles").toString(),
          tabKey: "roles"
        },
        {
          label: this.$t("menu.remove").toString(),
          tabKey: "remove"
        }
      ];
    },
    acceptFilter() {
      return this.acceptedExtensions.length === 0 ? void 0 : this.acceptedExtensions.join(",");
    }
  },
  methods: {
    onFilePicked(s) {
      this.uploading.push([self.crypto.randomUUID(), s]);
    },
    onUploadSuccess(s) {
      this.uploading = this.uploading.filter(
        (t) => t[0] !== s.randomFileId
      ), this.currentFiles.push(s.userFile), this.onAttachmentChange();
    },
    async onRemoveFile(s) {
      await this.$api.fileAttachment.remove("ticket", this.ticketId, s.id), this.currentFiles = this.currentFiles.filter((t) => t.id !== s.id), this.onAttachmentChange();
    },
    onAttachmentChange() {
      this.$emit("attachment-updated");
    },
    onUpdatePermissions(s) {
      this.currentFile = s, this.uploadPermissionVisible = !0;
    },
    onClosePermissions() {
      this.uploadPermissionVisible = !1;
    },
    onPermissionsUpdated() {
      this.onClosePermissions(), this.$emit("permissions-updated");
    }
  }
});
var QI = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-attachment-container" }, [t._l(t.currentFiles, function(i, n) {
    return e("app-file-upload-item", { key: n, attrs: { file: i }, scopedSlots: t._u([{ key: "controls", fn: function() {
      return [e("app-ellipsis-menu", { attrs: { reference: i, "menu-options": t.menuOptions }, on: { "click:remove": t.onRemoveFile, "click:roles": t.onUpdatePermissions } })];
    }, proxy: !0 }], null, !0) });
  }), t._l(t.uploading, function([i, n]) {
    return e("app-file-upload-item-progress", { key: i, attrs: { "random-file-id": i, file: n, "ticket-id": t.ticketId, category: t.category }, on: { "upload-success": t.onUploadSuccess } });
  }), t.allowMoreFiles ? e("app-file-upload-picker", { attrs: { label: t.$t("page.createTicket.addFiles"), "accept-filter": t.acceptFilter }, on: { "pick-file": t.onFilePicked } }) : t._e(), t.uploadPermissionVisible ? e("app-file-upload-permissions-modal", { attrs: { "product-id": t.productId, "ticket-id": t.ticketId, file: t.currentFile }, on: { "permissions-updated": t.onPermissionsUpdated, close: t.onClosePermissions } }) : t._e()], 2);
}, JI = [], tA = /* @__PURE__ */ f(
  ZI,
  QI,
  JI,
  !1,
  null,
  "8e3e6dc0"
);
const eA = tA.exports, sA = g({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedStatus: "",
      optionsStatus: []
    };
  },
  async created() {
    await this.loadStatus();
  },
  methods: {
    async loadStatus() {
      const s = await this.$gateway.search.status(
        this.contextId,
        this.productId,
        this.appId
      );
      this.optionsStatus = s[0].map((t) => ({
        text: this.$res(Y(t, s[1]), { label: t }).label,
        value: t
      }));
    },
    async executeBulkAction() {
      try {
        this.loading = !0;
        const s = await this.$api.ticket.bulkUpdateStatus(this.productId, {
          canonicalIds: this.selection,
          ticketRequest: { status: this.selectedStatus }
        });
        return this.$datasource.ticket.dirtyBatch(this.selection), s.id;
      } catch (s) {
        console.error("Could not execute bulk action", s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const s = await this.executeBulkAction();
      this.$emit("confirm", s);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var iA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("bulkActions.actions.setStatus")) + " ")]), e("app-singleselect", { attrs: { options: t.optionsStatus, placeholder: t.$t("search.filter.status.placeholder") }, model: { value: t.selectedStatus, callback: function(i) {
    t.selectedStatus = i;
  }, expression: "selectedStatus" } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { label: t.$t("common.form.confirm"), enabled: !!t.selectedStatus }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, nA = [], rA = /* @__PURE__ */ f(
  sA,
  iA,
  nA,
  !1,
  null,
  "34bda6a3"
);
const aA = rA.exports, oA = g({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedStatus: "",
      optionsStatus: []
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        this.loading = !0;
        const s = await this.$api.ticket.bulkDeleteTickets(
          this.productId,
          this.selection
        );
        return this.$datasource.ticket.dirtyBatch(this.selection), s.id;
      } catch (s) {
        console.error("Could not execute bulk action", s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const s = await this.executeBulkAction();
      this.$emit("confirm", s);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var lA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal-confirmation", { attrs: { "confirmation-label": t.$t("bulkActions.deleteTickets.conformationLabel"), description: t.$t("bulkActions.deleteTickets.description"), "extra-confirmation": !0, "primary-label": t.$t("common.form.confirm"), "secondary-label": t.$t("common.form.cancel"), title: t.$t("bulkActions.actions.deleteTickets") }, on: { "click-outside": t.onCancel, "click-primary": t.onConfirm, "click-secondary": t.onCancel } });
}, cA = [], uA = /* @__PURE__ */ f(
  oA,
  lA,
  cA,
  !1,
  null,
  "dfe00d82"
);
const dA = uA.exports, pA = g({
  components: {
    ProductDropdown: ar
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    },
    action: {
      type: String,
      default: "copy"
    }
  },
  data() {
    return {
      loading: !1,
      targetProduct: "",
      triggerWebhooks: !1,
      useAuthorAsCreator: !1,
      workflows: []
    };
  },
  async created() {
    this.workflows = await this.$gateway.admin.fetchWorkflowsByBatch(
      this.productIds,
      this.contextId
    ), this.targetProduct = this.productIds[0];
  },
  computed: {
    productIds() {
      const { productsData: s } = Ht(this.organization);
      return s.value.filter(
        ({ customization: t }) => {
          var e;
          return !!((e = t.ticketCopyMapping) != null && e[this.productId]);
        }
      ).map(({ productId: t }) => t).flat();
    },
    copyMoveRequest() {
      return {
        canonicalIds: this.selection,
        sourceProduct: this.productId,
        triggerWebhooks: this.triggerWebhooks,
        useAuthorAsCreator: this.useAuthorAsCreator
      };
    }
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, this.action === "copy" ? this.copyTickets() : this.moveTickets();
      } catch (s) {
        console.error("Could not execute bulk action", s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async copyTickets() {
      return (await this.$api.ticket.bulkCopyTicket(
        this.copyMoveRequest,
        this.targetProduct
      )).id;
    },
    async moveTickets() {
      return (await this.$api.ticket.bulkMoveTicket(
        this.copyMoveRequest,
        this.targetProduct
      )).id;
    },
    async onConfirm() {
      const s = await this.executeBulkAction();
      this.$emit("confirm", s);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var hA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t(`bulkActions.${t.action}Tickets.title`)) + " ")]), e("product-dropdown", { staticClass: "product-dropdown", attrs: { context: t.contextId, label: t.$t(`bulkActions.${t.action}Tickets.productSelector`), placeholder: t.$t("form.placeholder.productSelect"), products: t.productIds, workflows: t.workflows }, model: { value: t.targetProduct, callback: function(i) {
    t.targetProduct = i;
  }, expression: "targetProduct" } }), e("app-checkbox", { attrs: { label: t.$t("bulkActions.actions.triggerWebhooks") }, model: { value: t.triggerWebhooks, callback: function(i) {
    t.triggerWebhooks = i;
  }, expression: "triggerWebhooks" } }), e("app-checkbox", { attrs: { label: t.$t("bulkActions.actions.useAuthorAsCreator") }, model: { value: t.useAuthorAsCreator, callback: function(i) {
    t.useAuthorAsCreator = i;
  }, expression: "useAuthorAsCreator" } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { enabled: !!t.targetProduct, label: t.$t(`bulkActions.${t.action}Tickets.title`) }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, fA = [], mA = /* @__PURE__ */ f(
  pA,
  hA,
  fA,
  !1,
  null,
  "855a3964"
);
const gA = mA.exports, _A = g({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedTicket: ""
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.ticket.bulkUpdateTicket(this.productId, {
          canonicalIds: this.selection,
          ticketRequest: {
            parent: this.selectedTicket
          }
        })).id;
      } catch (s) {
        console.error("Could not execute bulk action", s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const s = await this.executeBulkAction();
      this.$emit("confirm", s);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var yA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("bulkActions.actions.setParent")) + " ")]), e("ticket-dropdown", { attrs: { context: t.contextId, "product-id": t.productId, products: [t.productId], placeholder: t.$t("bulkActions.setParentModal.placeholder") }, model: { value: t.selectedTicket, callback: function(i) {
    t.selectedTicket = i;
  }, expression: "selectedTicket" } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { label: t.$t("common.form.confirm"), enabled: !!t.selectedTicket }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, bA = [], vA = /* @__PURE__ */ f(
  _A,
  yA,
  bA,
  !1,
  null,
  "41ba2772"
);
const kA = vA.exports, xA = g({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedUser: ""
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        this.loading = !0;
        const s = await this.$api.ticket.bulkUpdateTicket(this.productId, {
          canonicalIds: this.selection,
          ticketRequest: {
            assignee: this.selectedUser
          }
        });
        return this.$datasource.ticket.dirtyBatch(this.selection), s.id;
      } catch (s) {
        console.error("Could not execute bulk action", s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const s = await this.executeBulkAction();
      this.$emit("confirm", s);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var CA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("bulkActions.actions.setAssignee")) + " ")]), e("user-dropdown", { attrs: { context: t.contextId, "product-id": t.productId, products: [t.productId], placeholder: t.$t("bulkActions.setAssigneeModal.placeholder") }, model: { value: t.selectedUser, callback: function(i) {
    t.selectedUser = i;
  }, expression: "selectedUser" } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { label: t.$t("common.form.confirm"), enabled: !!t.selectedUser }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, wA = [], $A = /* @__PURE__ */ f(
  xA,
  CA,
  wA,
  !1,
  null,
  "92cf5383"
);
const SA = $A.exports, TA = g({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedTicket: ""
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.ticket.bulkUpdateTicket(this.productId, {
          canonicalIds: this.selection,
          ticketRequest: {
            parent: this.selectedTicket
          }
        })).id;
      } catch (s) {
        console.error("Could not execute bulk action", s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const s = await this.executeBulkAction();
      this.$emit("confirm", s);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var IA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("bulkActions.actions.setCampaign")) + " ")]), e("ticket-dropdown", { attrs: { context: t.contextId, "product-id": t.productId, products: ["campaign"], placeholder: t.$t("bulkActions.setCampaignModal.placeholder") }, model: { value: t.selectedTicket, callback: function(i) {
    t.selectedTicket = i;
  }, expression: "selectedTicket" } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { label: t.$t("common.form.confirm"), enabled: !!t.selectedTicket }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, AA = [], PA = /* @__PURE__ */ f(
  TA,
  IA,
  AA,
  !1,
  null,
  "f22e038d"
);
const OA = PA.exports, MA = g({
  components: { AppLabelValue: lr },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      contextFunding: !1,
      companyWallet: null,
      selectedOffer: null
    };
  },
  async created() {
    [this.companyWallet] = await this.$api.juoco.fetchCompanyWallet(
      this.contextId
    );
  },
  computed: {
    showCalculation() {
      return this.contextFunding && !!this.selectedOffer;
    },
    totalPrice() {
      return this.selectedOffer ? this.selectedOffer.price * this.selection.length : 0;
    },
    companyWalletBalanceAfter() {
      var s;
      return (((s = this.companyWallet) == null ? void 0 : s.balance) ?? 0) - this.totalPrice;
    },
    companyWalletBalance() {
      var s;
      return ((s = this.companyWallet) == null ? void 0 : s.balance) ?? 0;
    },
    selectedOfferPrice() {
      var s;
      return ((s = this.selectedOffer) == null ? void 0 : s.price) ?? 0;
    }
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.juoco.bulkPurchaseOffer({
          offerId: this.selectedOffer.id,
          contextFunding: this.contextFunding,
          batchRequest: {
            targets: this.selection,
            context: this.contextId
          }
        })).id;
      } catch (s) {
        console.error("Could not execute bulk action", s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    priceDisplay(s = 0) {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "auto",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(s);
    },
    async onConfirm() {
      const s = await this.executeBulkAction();
      this.$emit("confirm", s);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var RA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("bulkActions.purchaseOfferModal.title")) + " ")]), e("div", { staticClass: "modal-description" }, [t._v(" " + t._s(t.$t("bulkActions.purchaseOfferModal.description")) + " ")]), e("offer-dropdown", { attrs: { context: t.contextId, group: "TICKET", label: t.$t("bulkActions.purchaseOfferModal.offerLabel"), placeholder: t.$t("bulkActions.purchaseOfferModal.offerPlaceholder"), "product-id": t.productId }, model: { value: t.selectedOffer, callback: function(i) {
    t.selectedOffer = i;
  }, expression: "selectedOffer" } }), e("app-checkbox", { attrs: { label: t.$t("bulkActions.purchaseOfferModal.contextFunding") }, model: { value: t.contextFunding, callback: function(i) {
    t.contextFunding = i;
  }, expression: "contextFunding" } }), t.totalPrice ? e("div", { staticClass: "price-container" }, [e("div", { staticClass: "price-group" }, [e("span", { staticClass: "label" }, [t._v(" " + t._s(t.$t("bulkActions.purchaseOfferModal.offerPrice")) + " ")]), e("span", { staticClass: "price" }, [t._v(t._s(t.priceDisplay(t.selectedOfferPrice)))])]), e("div", { staticClass: "price-group" }, [e("span", { staticClass: "label" }, [t._v(" " + t._s(t.$t("bulkActions.purchaseOfferModal.totalPrice")) + " ")]), e("span", { staticClass: "price" }, [t._v(t._s(t.priceDisplay(t.totalPrice)))])]), t.showCalculation ? [e("div", { staticClass: "price-group" }, [e("span", { staticClass: "label" }, [t._v(" " + t._s(t.$t("bulkActions.purchaseOfferModal.companyBalance")) + " ")]), e("span", { staticClass: "price" }, [t._v(t._s(t.priceDisplay(t.companyWalletBalance)))])]), e("div", { staticClass: "price-group" }, [e("span", { staticClass: "label" }, [t._v(" " + t._s(t.$t("bulkActions.purchaseOfferModal.companyBalanceAfter")) + " ")]), e("span", { staticClass: "price" }, [t._v(t._s(t.priceDisplay(t.companyWalletBalanceAfter)))])])] : t._e()], 2) : t._e(), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { enabled: !!t.selectedOffer, label: t.$t("bulkActions.purchaseOfferModal.purchaseButton") }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, EA = [], DA = /* @__PURE__ */ f(
  MA,
  RA,
  EA,
  !1,
  null,
  "cf023000"
);
const FA = DA.exports, LA = g({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      fileName: `export-${this.contextId}`,
      appendDate: !0
    };
  },
  computed: {
    fileNamePreview() {
      return this.$gateway.search.createExportFilename({
        file: {
          name: this.fileName,
          appendDate: this.appendDate
        }
      });
    }
  },
  methods: {
    executeBulkAction() {
      const s = {
        file: {
          name: this.fileName,
          appendDate: this.appendDate
        }
      };
      this.$emit("export-selected", s);
    },
    onConfirm() {
      this.executeBulkAction(), this.onCancel();
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var qA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("bulkActions.actions.exportData")) + " ")]), e("app-text-input", { attrs: { label: t.$t("bulkActions.exportDataModal.fileNameLabel"), required: !0 }, model: { value: t.fileName, callback: function(i) {
    t.fileName = i;
  }, expression: "fileName" } }), e("app-checkbox", { attrs: { label: t.$t("bulkActions.exportDataModal.appendDateLabel") }, model: { value: t.appendDate, callback: function(i) {
    t.appendDate = i;
  }, expression: "appendDate" } }), e("app-text-input", { attrs: { value: t.fileNamePreview, label: t.$t("bulkActions.exportDataModal.previewLabel"), enabled: !1 } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { label: t.$t("common.form.confirm"), enabled: !!t.fileName }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, UA = [], NA = /* @__PURE__ */ f(
  LA,
  qA,
  UA,
  !1,
  null,
  "7974a35e"
);
const Mc = NA.exports, BA = g({
  props: {
    bulkId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      bulkResponse: void 0
    };
  },
  async created() {
    await this.reload();
  },
  computed: {
    refreshVisible() {
      var s;
      return ((s = this.bulkResponse) == null ? void 0 : s.status) !== "FINISHED";
    },
    failedListVisible() {
      var s, t;
      return (((t = (s = this.bulkResponse) == null ? void 0 : s.report.failedActions) == null ? void 0 : t.length) ?? 0) > 0;
    },
    totalActions() {
      var s;
      return ((s = this.bulkResponse) == null ? void 0 : s.report.totalJobs) ?? 0;
    },
    completedActions() {
      var e, i;
      const s = ((e = this.bulkResponse) == null ? void 0 : e.report.failedActions.length) ?? 0, t = ((i = this.bulkResponse) == null ? void 0 : i.report.completedIds.length) ?? 0;
      return s + t;
    },
    failedIds() {
      var s;
      return (((s = this.bulkResponse) == null ? void 0 : s.report.failedActions) ?? []).map(
        (t) => t.canonicalId
      );
    }
  },
  methods: {
    async reload() {
      try {
        this.loading = !0, this.bulkResponse = await this.$api.ticket.fetchBulkAction(this.bulkId);
      } catch (s) {
        console.error("Could not check bulk action status", s);
      } finally {
        this.loading = !1;
      }
    },
    async onRefresh() {
      await this.reload();
    },
    onClose() {
      this.$emit("close");
    }
  }
});
var jA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("bulkActions.resultsModal.title")) + " ")]), t.bulkResponse ? e("div", [e("div", [t._v(" " + t._s(t.$t("bulkActions.resultsModal.processId")) + ": " + t._s(t.bulkResponse.id) + " ")]), e("div", [t._v(" " + t._s(t.$t("bulkActions.resultsModal.completion", { completed: t.completedActions, total: t.totalActions })) + " ")]), t.failedListVisible ? [t._v(" " + t._s(t.$t("bulkActions.resultsModal.failed")) + ": "), e("ul", { staticClass: "failed-list" }, t._l(t.failedIds, function(i) {
    return e("li", { key: i }, [t._v(" " + t._s(i) + " ")]);
  }), 0)] : t._e()], 2) : t._e()]), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t.refreshVisible ? e("app-button", { attrs: { label: t.$t("common.form.refresh") }, on: { click: t.onRefresh } }) : t._e(), e("app-secondary-button", { attrs: { label: t.$t("common.form.close") }, on: { click: t.onClose } })], 1)], 1);
}, zA = [], VA = /* @__PURE__ */ f(
  BA,
  jA,
  zA,
  !1,
  null,
  "bd0f2712"
);
const Rc = VA.exports, HA = g({
  components: {
    BulkModalSetStatus: aA,
    BulkModalDeleteTickets: dA,
    BulkModalCopyMoveTickets: gA,
    BulkModalSetParent: kA,
    BulkModalSetAssignee: SA,
    BulkModalSetCampaign: OA,
    BulkModalPurchaseOffer: FA,
    BulkModalExportData: Mc,
    BulkModalResults: Rc
  },
  props: {
    value: {
      type: String,
      required: !1
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  watch: {
    value(s) {
      this.bulkAction = s;
    }
  },
  data() {
    return {
      bulkAction: void 0,
      bulkId: void 0
    };
  },
  created() {
    this.bulkAction = this.value;
  },
  methods: {
    onConfirm(s) {
      this.bulkId = s, this.bulkAction = void 0;
    },
    onCloseResults() {
      this.onCancel(), this.$emit("reload");
    },
    onCancel() {
      this.bulkId = void 0, this.bulkAction = void 0, this.$emit("input", void 0);
    },
    componentType(s) {
      switch (s) {
        case "deleteTickets":
          return "bulk-modal-delete-tickets";
        case "setParent":
          return "bulk-modal-set-parent";
        case "copyTickets":
        case "moveTickets":
          return "bulk-modal-copy-move-tickets";
        case "setAssignee":
          return "bulk-modal-set-assignee";
        case "setCampaign":
          return "bulk-modal-set-campaign";
        case "purchaseOffer":
          return "bulk-modal-purchase-offer";
        case "exportData":
          return "bulk-modal-export-data";
        case "setStatus":
          return "bulk-modal-set-status";
        default:
          return "";
      }
    },
    getActionType(s) {
      switch (s) {
        case "copyTickets":
          return "copy";
        case "moveTickets":
          return "move";
        default:
          return;
      }
    }
  }
});
var WA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "container" }, [e(t.componentType(t.bulkAction), t._g({ tag: "component", attrs: { action: t.getActionType(t.bulkAction), "app-id": t.appId, "context-id": t.contextId, organization: t.organization, "product-id": t.productId, selection: t.selection }, on: { cancel: t.onCancel, confirm: t.onConfirm } }, t.$listeners)), t.bulkId ? e("bulk-modal-results", { attrs: { "bulk-id": t.bulkId }, on: { close: t.onCloseResults } }) : t._e()], 1);
}, GA = [], KA = /* @__PURE__ */ f(
  HA,
  WA,
  GA,
  !1,
  null,
  null
);
const YA = KA.exports, XA = g({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      selected: ""
    };
  },
  computed: {
    filteredOptions() {
      return this.options.filter(({ availabilityCheck: s }) => s !== !1).filter(
        ({ requiredAction: s }) => !s || this.checkPermission(s)
      ).map(({ option: s }) => s);
    },
    options() {
      return [
        {
          requiredAction: "ADMIN_BULK_TICKET_UPDATE",
          option: {
            value: "setStatus",
            text: this.$t("bulkActions.actions.setStatus").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_TICKET_UPDATE",
          option: {
            value: "setAssignee",
            text: this.$t("bulkActions.actions.setAssignee").toString()
          }
        },
        {
          requiredAction: "Hidden for IP-6902 - ADMIN_BULK_TICKET_UPDATE",
          option: {
            value: "setParent",
            text: this.$t("bulkActions.actions.setParent").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_TICKET_UPDATE",
          option: {
            value: "setCampaign",
            text: this.$t("bulkActions.actions.setCampaign").toString()
          }
        },
        {
          requiredAction: "ADMIN_TICKET_COPY",
          availabilityCheck: this.hasDuplicationSettings(),
          option: {
            value: "copyTickets",
            text: this.$t("bulkActions.actions.copyTickets").toString()
          }
        },
        {
          requiredAction: "ADMIN_TICKET_MOVE",
          availabilityCheck: this.hasDuplicationSettings(),
          option: {
            value: "moveTickets",
            text: this.$t("bulkActions.actions.moveTickets").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_TICKET_DELETE",
          option: {
            value: "deleteTickets",
            text: this.$t("bulkActions.actions.deleteTickets").toString()
          }
        },
        {
          requiredAction: "ADMIN_OFFER_WRITE",
          option: {
            value: "purchaseOffer",
            text: this.$t("bulkActions.actions.purchaseOffer").toString()
          }
        },
        {
          requiredAction: "USER_TICKET_LIST",
          option: {
            value: "exportData",
            text: this.$t("bulkActions.actions.exportData").toString()
          }
        }
      ];
    }
  },
  methods: {
    checkPermission(s) {
      const t = `${this.productId.toUpperCase()}_${s}`;
      return this.userActions.checkPermission([t, s]);
    },
    hasDuplicationSettings() {
      const { productsData: s } = Ht(this.organization);
      return s.value.some(
        ({ customization: t }) => {
          var e;
          return !!((e = t.ticketCopyMapping) != null && e[this.productId]);
        }
      );
    },
    onUpdateSingle(s) {
      s && this.$emit("select-action", s), pe(() => {
        this.selected = "";
      });
    }
  }
});
var ZA = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-singleselect", { attrs: { options: t.filteredOptions, placeholder: t.$t("bulkActions.selectAction"), "search-enabled": !0, "search-label": t.$t("form.search.placeholder") }, on: { "update-single": t.onUpdateSingle }, model: { value: t.selected, callback: function(i) {
    t.selected = i;
  }, expression: "selected" } });
}, QA = [], JA = /* @__PURE__ */ f(
  XA,
  ZA,
  QA,
  !1,
  null,
  null
);
const t2 = JA.exports, e2 = g({
  name: "TicketDelegationWidget",
  props: {
    delegate: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      empty: !1,
      loading: !0,
      team: void 0,
      topic: void 0
    };
  },
  async created() {
    try {
      ["workgroup", "team"].includes(this.delegate.type) ? this.team = this.delegate.data : this.delegate.type === "topic" && (this.topic = this.delegate.data), !this.team && !this.topic && (this.empty = !0, console.warn(
        "Could not find Delegation item:",
        this.delegate.type,
        this.delegate.data
      ));
    } catch (s) {
      this.empty = !0, console.error(s);
    }
    this.loading = !1;
  }
});
var s2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, !t.loading && !t.empty ? e("div", { staticClass: "ticket-delegation-widget" }, [t.topic ? e("router-link", { attrs: { to: {
    name: "TopicTickets",
    params: { id: t.topic.id }
  } } }, [e("topic-item", { staticClass: "ticket-delegation-card", attrs: { topic: t.topic } })], 1) : t.delegate.type === "team" && t.team ? e("router-link", { attrs: { to: {
    name: "TeamDetails",
    params: { id: t.team.id }
  } } }, [e("team-item", { staticClass: "ticket-delegation-card", attrs: { clickable: !0, team: t.team } })], 1) : t.delegate.type === "workgroup" && t.team ? e("workgroup-item", { staticClass: "ticket-delegation-card", attrs: { team: t.team } }) : t._e()], 1) : t._e();
}, i2 = [], n2 = /* @__PURE__ */ f(
  e2,
  s2,
  i2,
  !1,
  null,
  "c102cc28"
);
const r2 = n2.exports, a2 = "/img/team-placeholder.svg", o2 = g({
  props: {
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      required: !1
    },
    favoritesLabel: {
      type: String,
      required: !1
    },
    configuration: {
      type: Object,
      required: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    userId: {
      type: String,
      required: !1
    },
    tags: {
      type: Array,
      required: !1
    },
    multiselect: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    initialTeamIds: {
      type: Array,
      default: () => []
    },
    organization: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      reloadKey: 0,
      loading: !1,
      userTeams: [],
      selected: [],
      errorState: !1,
      createTeamModalVisible: !1
    };
  },
  async created() {
    this.tags || await this.loadUserTeams(), this.selected = this.initialTeamIds, this.selected.length || this.$emit("input", []), this.reloadKey += 1;
  },
  computed: {
    teamTypes() {
      return this.configuration.types ?? ["VIRTUAL_TEAM"];
    },
    previewOptions() {
      return this.userTeams.map((s) => ({
        text: Ot(s, this.$res).teamName(),
        value: s.id,
        image: a2,
        groupKey: "favorites"
      }));
    },
    previewGroups() {
      return this.userTeams.length ? [
        {
          key: "favorites",
          label: this.favoritesLabel ?? this.$t("page.teams.myTeams").toString()
        }
      ] : [];
    },
    createTeamEnabled() {
      var s, t;
      return !!((t = (s = this.configuration) == null ? void 0 : s.operations) != null && t.includes("create") && this.userId);
    }
  },
  watch: {
    selected(s) {
      this.$emit("input", s);
    }
  },
  methods: {
    async loadUserTeams() {
      try {
        this.loading = !0;
        const s = this.userId ? await this.$datasource.team.fetchSubscribedTeams(this.userId) : [];
        this.userTeams = s.filter(
          ({ type: t }) => this.teamTypes.includes(t)
        );
      } catch {
        console.error("Error loading subscribed teams"), this.userTeams = [];
      } finally {
        this.loading = !1;
      }
    },
    onBlur() {
      this.validate();
    },
    validate() {
      this.required ? this.errorState = this.multiselect ? !this.selected.length : !this.selected : this.errorState = !1;
    },
    onCloseTeamModal() {
      this.createTeamModalVisible = !1;
    },
    onOpenTeamModal() {
      this.createTeamModalVisible = !0;
    },
    onTeamCreated(s) {
      this.selected = this.multiselect ? [s.id, ...this.selected] : [s.id], this.errorState = !1, this.userTeams = [s, ...this.userTeams], this.reloadKey += 1, this.onCloseTeamModal();
    }
  }
});
var l2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("team-dropdown", { key: t.reloadKey, attrs: { error: t.error || t.errorState, label: t.label, multiselect: t.multiselect, placeholder: t.placeholder, "preview-groups": t.previewGroups, "preview-options": t.previewOptions, required: t.required, tags: t.tags, "team-types": t.teamTypes, tooltip: t.tooltip }, on: { blur: t.onBlur }, scopedSlots: t._u([t.createTeamEnabled ? { key: "controls", fn: function() {
    return [e("button", { staticClass: "create-team-button", on: { click: t.onOpenTeamModal } }, [e("fa-icon-compat", { attrs: { icon: "fa-regular fa-plus" } }), t._v(" " + t._s(t.$t("page.createTeam.createTeam")) + " ")], 1)];
  }, proxy: !0 } : null], null, !0), model: { value: t.selected, callback: function(i) {
    t.selected = i;
  }, expression: "selected" } }), t.error ? e("div", { staticClass: "error-label" }, [t._v(" " + t._s(t.$t("error.requiredField")) + " ")]) : t._e(), t.createTeamModalVisible ? e("create-team-modal", { attrs: { organization: t.organization, "user-id": t.userId }, on: { close: t.onCloseTeamModal, teamCreated: t.onTeamCreated } }) : t._e()], 1);
}, c2 = [], u2 = /* @__PURE__ */ f(
  o2,
  l2,
  c2,
  !1,
  null,
  "72f6829c"
);
const d2 = u2.exports, jo = "#6B778C", p2 = g({
  props: {
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      required: !1
    },
    user: {
      type: Object,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    initialTopicId: {
      type: String,
      required: !1
    },
    product: {
      type: String,
      required: !0
    },
    tags: {
      type: Array,
      required: !1
    }
  },
  data() {
    return {
      loading: !1,
      allTopics: [],
      relatedTopics: [],
      reloadKey: 0,
      selected: "",
      error: !1,
      customTopicIcons: /* @__PURE__ */ new Map()
    };
  },
  async created() {
    await this.loadTopics(), this.selected = this.initialTopicId ?? "", this.selected === "" && this.$emit("input", ""), this.reloadKey += 1;
  },
  destroyed() {
    Object.values(this.customTopicIcons).forEach((s) => {
      URL.revokeObjectURL(s);
    });
  },
  computed: {
    previewOptions() {
      return this.allTopics.map((s) => ({
        text: this.$res(s == null ? void 0 : s.resources).title,
        value: s.id,
        image: this.getTopicIcon(s),
        groupKey: this.getTopicGroup(s)
      }));
    },
    previewGroups() {
      const s = [
        {
          key: "all",
          label: this.$t("page.topicOverview.relationTypes.other").toString()
        }
      ];
      return this.relatedTopics.length > 0 && s.unshift({
        key: "favorites",
        label: this.$t("page.topicOverview.relationTypes.relates").toString()
      }), s;
    },
    topicFilter() {
      var t;
      const s = ((t = this.tags) == null ? void 0 : t.map((e) => ({ tag: e, class: "tag" }))) ?? [];
      return {
        tags: [{ tag: this.product, class: "product" }, ...s]
      };
    }
  },
  watch: {
    selected(s) {
      this.$emit("input", s);
    }
  },
  methods: {
    async loadTopics() {
      var s;
      try {
        this.loading = !0, this.allTopics = await this.$gateway.topic.filterByTags(
          this.topicFilter
        ), this.allTopics.forEach((e) => this.createTopicIcon(e));
        const t = (s = this.user) == null ? void 0 : s.unit;
        if (t) {
          const e = await this.$api.topic.getTopicByTeam(t, "relates");
          this.relatedTopics = e.topicIds.filter(
            (i) => this.allTopics.some((n) => n.id === i)
          );
        }
      } catch {
        console.error("Error loading subscribed teams");
      } finally {
        this.loading = !1;
      }
    },
    createTopicIcon(s) {
      const t = (s == null ? void 0 : s.meta.color) ?? jo;
      if (this.customTopicIcons.has(t))
        return;
      const e = `
        <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="3.5" fill="${t}" />
        </svg>
      `, i = new Blob([e], { type: "image/svg+xml" }), n = URL.createObjectURL(i);
      this.customTopicIcons.set(t, n);
    },
    getTopicIcon(s) {
      var e;
      const t = ((e = s == null ? void 0 : s.meta) == null ? void 0 : e.color) ?? jo;
      return this.customTopicIcons.get(t);
    },
    getTopicGroup(s) {
      return this.relatedTopics.includes(s.id) ? "favorites" : "all";
    },
    onBlur() {
      this.validate();
    },
    validate() {
      this.required ? this.error = !this.selected : this.error = !1;
    }
  }
});
var h2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("topic-dropdown", { key: t.reloadKey, attrs: { label: t.label, placeholder: t.placeholder, tooltip: t.tooltip, required: t.required, error: t.error, "preview-groups": t.previewGroups, "preview-options": t.previewOptions, "topic-filter": t.topicFilter }, on: { blur: t.onBlur }, model: { value: t.selected, callback: function(i) {
    t.selected = i;
  }, expression: "selected" } }), t.error ? e("div", { staticClass: "error-label" }, [t._v(" " + t._s(t.$t("error.requiredField")) + " ")]) : t._e()], 1);
}, f2 = [], m2 = /* @__PURE__ */ f(
  p2,
  h2,
  f2,
  !1,
  null,
  "c7295cb8"
);
const g2 = m2.exports, _2 = g({
  props: {
    ownerIds: {
      type: Array,
      required: !0
    },
    initialCoCreatorIds: {
      type: Array,
      required: !0
    },
    team: {
      type: Object,
      required: !0
    },
    allowTeamEdit: {
      type: Boolean,
      default: !0
    }
  },
  setup(s, { emit: t }) {
    const { distributeShares: e, checkShareDivide: i } = f_(), n = st(!1), r = st(0), a = st({}), o = st(s.initialCoCreatorIds), l = st(!1), c = st([]), u = Fn(), { $gateway: d } = u.proxy, p = Q(() => (r.value, c.value.map((x) => ({
      id: x.userInfo.user.id,
      share: a.value[x.userInfo.user.id]
    })))), h = () => {
      a.value = [...s.ownerIds, ...o.value].reduce(
        (x, C) => {
          var S, I;
          const $ = ((I = (S = s.team) == null ? void 0 : S.meta) == null ? void 0 : I[`shares_${C}`]) ?? 0;
          return x[C] = a.value[C] || parseFloat($), x;
        },
        a.value
      );
    }, m = () => {
      r.value++, l.value = i(p.value, 100);
    }, _ = async () => {
      const x = c.value.map((C) => ({
        ...C,
        share: a.value[C.userInfo.user.id]
      }));
      t("confirm", x);
    }, y = () => {
      t("cancel");
    }, v = async () => {
      await k(), h(), m();
    }, k = async () => {
      const x = await d.portal.findUsersById([
        ...s.ownerIds,
        ...o.value
      ]);
      c.value = x.reduce(
        (C, $) => {
          const S = $.user.id;
          return C.push({
            userInfo: $,
            share: a.value[S] ?? 0
          }), C;
        },
        []
      );
    }, w = () => {
      const x = e(p.value, 100);
      a.value = x.reduce(
        (C, $) => (C[$.id] = $.share, C),
        {}
      ), m();
    };
    return Ln(async () => {
      h(), await k();
    }), {
      loading: n,
      reloadKey: r,
      enableSaveButton: l,
      shares: a,
      coCreatorIds: o,
      userList: c,
      shareItems: p,
      validateForm: m,
      onDistributeShares: w,
      checkShareDivide: i,
      onConfirm: _,
      onCancel: y,
      onInput: v
    };
  }
});
var y2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("modal.coCreatorShares.title")) + " ")]), e("div", { staticClass: "modal-description" }, [t._v(" " + t._s(t.$t("modal.coCreatorShares.description")) + " ")]), e("user-dropdown", { attrs: { enabled: t.allowTeamEdit, label: t.$t("form.coCreator.label"), placeholder: t.$t("form.coCreator.placeholder"), "selection-mode": "multiple" }, on: { blur: t.onInput, input: t.onInput }, model: { value: t.coCreatorIds, callback: function(i) {
    t.coCreatorIds = i;
  }, expression: "coCreatorIds" } }), e("div", { staticClass: "co-creator-list" }, t._l(t.userList, function({ userInfo: i }) {
    return e("user-item", { key: i.user.id, staticClass: "co-creator-item", attrs: { "user-data": i }, scopedSlots: t._u([{ key: "controls", fn: function() {
      return [e("app-number-input", { staticClass: "share-input", attrs: { "fraction-digits": 4 }, on: { blur: t.validateForm }, model: { value: t.shares[i.user.id], callback: function(n) {
        t.$set(t.shares, i.user.id, n);
      }, expression: "shares[userInfo.user.id]" } })];
    }, proxy: !0 }], null, !0) });
  }), 1), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "end" } }, [e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } }), e("app-secondary-button", { attrs: { label: t.$t("modal.coCreatorShares.distributeButton") }, on: { click: t.onDistributeShares } }), e("app-button", { attrs: { enabled: t.enableSaveButton, label: t.$t("common.form.save") }, on: { click: t.onConfirm } })], 1)], 1)]);
}, b2 = [], v2 = /* @__PURE__ */ f(
  _2,
  y2,
  b2,
  !1,
  null,
  "acf95b3f"
);
const k2 = v2.exports, x2 = g({
  components: {
    CoCreatorModal: k2
  },
  props: {
    userId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    teamId: {
      type: String,
      required: !0
    },
    enabled: {
      type: Boolean,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      team: {},
      teamMembers: [],
      coCreators: [],
      showModal: !1,
      error: !1,
      loading: !0
    };
  },
  async created() {
    this.loading = !0, this.teamId && ([this.team, this.teamMembers] = await Promise.all([
      this.$api.team.fetchCoCreatorTeamById(this.teamId),
      this.$api.team.fetchTeamMembers(this.teamId)
    ]), await this.fetchCoCreators()), this.loading = !1;
  },
  computed: {
    coCreatorIds() {
      return this.teamMembers.filter(({ roles: s }) => s.includes("member")).map(({ userId: s }) => s);
    },
    allowTeamEdit() {
      return this.userActions.includes("USER_COCREATOR_TEAM_WRITE") && this.coCreators.some(({ userInfo: s }) => s.user.id === this.userId);
    },
    ownerIds() {
      return this.teamMembers.filter(({ roles: s }) => s.includes("owner")).map(({ userId: s }) => s);
    }
  },
  methods: {
    async fetchCoCreators() {
      const s = await this.$gateway.portal.findUsersById(
        this.teamMembers.map(({ userId: t }) => t)
      );
      this.coCreators = s.reduce((t, e) => {
        var i, n;
        return t.push({
          userInfo: e,
          share: ((n = (i = this.team) == null ? void 0 : i.meta) == null ? void 0 : n[`shares_${e.user.id}`]) ?? 0
        }), t;
      }, []).sort(
        (t) => this.ownerIds.includes(t.userInfo.user.id) ? -1 : 1
      );
    },
    async updateTeamMembers(s) {
      const t = s.map((e) => e.userInfo.user.id);
      await this.$gateway.team.updateTeamMembers({
        teamId: this.teamId,
        role: "member",
        userIds: t,
        teamType: this.team.type
      }), this.teamMembers = await this.$api.team.fetchTeamMembers(this.teamId);
    },
    async saveShares(s) {
      const t = Object.entries(this.team.meta ?? {}).filter(
        ([e]) => !e.startsWith("shares_")
      );
      this.team = await this.$datasource.team.updateCoCreator({
        ...this.team,
        meta: {
          ...t,
          ...s.reduce(
            (e, i) => (e[`shares_${i.userInfo.user.id}`] = i.share, e),
            {}
          )
        }
      });
    },
    async saveCoCreators(s) {
      this.toggleModal(), this.coCreators = s, await Promise.all([
        this.saveShares(s),
        this.updateTeamMembers(s)
      ]);
    },
    toggleModal() {
      this.showModal = !this.showModal;
    }
  }
});
var C2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("base-input-item", t._b({ staticClass: "co-creator-list", attrs: { enabled: t.enabled, error: t.error } }, "base-input-item", t.$attrs, !1), [t._l(t.coCreators, function(i) {
    return e("user-item", { key: i.userInfo.user.id, attrs: { "user-data": i.userInfo }, scopedSlots: t._u([{ key: "controls", fn: function() {
      return [e("div", { staticClass: "co-creator-share" }, [t._v(" " + t._s(i.share) + "%")])];
    }, proxy: !0 }], null, !0) });
  }), t.enabled ? e("app-secondary-button", { attrs: { label: t.$t("common.form.edit") }, on: { click: t.toggleModal } }) : t._e(), t.showModal ? e("co-creator-modal", { attrs: { "allow-team-edit": t.allowTeamEdit, "initial-co-creator-ids": t.coCreatorIds, "owner-ids": t.ownerIds, team: t.team }, on: { cancel: t.toggleModal, confirm: t.saveCoCreators } }) : t._e()], 2);
}, w2 = [], $2 = /* @__PURE__ */ f(
  x2,
  C2,
  w2,
  !1,
  null,
  "15d26d25"
);
const S2 = $2.exports, T2 = g({
  props: {
    statusName: {
      type: String,
      required: !0
    },
    statusType: {
      type: String,
      required: !0
    },
    state: {
      type: String,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    }
  },
  computed: {
    cssClass() {
      return `style-${this.state}`;
    },
    cssStyle() {
      if (this.state === "completed")
        return {
          color: this.color,
          borderColor: this.color
        };
    },
    label() {
      var t;
      const s = Y(this.statusName, this.workflow, this.statusType);
      return ((t = this.$res(s)) == null ? void 0 : t.label) ?? this.statusName;
    },
    color() {
      const s = Ps(
        this.statusName,
        this.workflow,
        this.statusType
      );
      return s != null && s.endsWith(";") ? s.substring(0, s.length - 1) : s;
    }
  }
});
var I2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "timeline-item", class: t.cssClass, style: t.cssStyle }, [t._v(" " + t._s(t.label) + " ")]);
}, A2 = [], P2 = /* @__PURE__ */ f(
  T2,
  I2,
  A2,
  !1,
  null,
  "e2f35e5e"
);
const O2 = P2.exports, M2 = g({
  components: {
    TicketTimelineItem: O2
  },
  props: {
    statusHistory: {
      type: Array,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    showStatus: {
      type: Boolean,
      default: !0
    },
    showCurrent: {
      type: Boolean,
      default: !1
    },
    showPhase: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    status() {
      return this.ticket.status;
    },
    displayStatusType() {
      return this.showStatus || this.showCurrentPhaseStatuses ? "status" : "phases";
    },
    statusType() {
      return this.showStatus ? "status" : "phases";
    },
    config() {
      return this.showCurrentPhaseStatuses ? this.phaseConfig[this.currentIndex].status : this.statusType === "phases" ? this.phaseConfig.map(({ phase: s }) => s) : this.statusConfig;
    },
    showCurrentPhaseStatuses() {
      return this.showCurrent && this.currentIndex !== void 0;
    },
    phaseConfig() {
      return Wl(this.workflow);
    },
    statusConfig() {
      var s;
      return ((s = this.workflow.settings) == null ? void 0 : s.timelineStatuses) ?? [];
    },
    currentIndex() {
      if (this.statusType === "phases") {
        for (let s = this.phaseConfig.length - 1; s >= 0; s--)
          if (this.phaseConfig[s].status.includes(this.status))
            return s;
        return;
      }
      return this.statusConfig.findIndex((s) => s === this.status);
    },
    disableTimeline() {
      const { disableTimeline: s } = Jg(this.workflow);
      return s.includes(this.status);
    }
  },
  methods: {
    itemState(s) {
      return this.showCurrentPhaseStatuses ? this.config.findIndex((t) => t === this.status) >= s ? "completed" : "waiting" : this.currentIndex === void 0 ? "disabled" : this.statusType === "phases" && s <= this.currentIndex && this.phaseConfig[s].status.some(
        (t) => this.statusHistory.includes(t)
      ) || s <= this.currentIndex && this.statusHistory.includes(this.statusConfig[s]) ? "completed" : "waiting";
    }
  }
});
var R2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-timeline" }, t._l(t.config, function(i, n) {
    return e("ticket-timeline-item", { key: i, staticClass: "ticket-timeline-item", attrs: { state: t.itemState(n), statusName: i, statusType: t.displayStatusType, workflow: t.workflow } });
  }), 1);
}, E2 = [], D2 = /* @__PURE__ */ f(
  M2,
  R2,
  E2,
  !1,
  null,
  "c8d89b60"
);
const F2 = D2.exports, L2 = g({
  components: {
    AppFileUploadItem: Os,
    AppFileUploadItemProgress: Oc,
    AppFileUploadPicker: ir
  },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    config: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      currentFiles: [],
      uploading: []
    };
  },
  created() {
    var s;
    this.currentFiles = ((s = this.ticket.files) == null ? void 0 : s.filter((t) => t.category === this.config.uploadCategory).map(We)) ?? [];
  },
  computed: {
    contextId() {
      return this.ticket.context;
    },
    productId() {
      return this.ticket.type;
    },
    ticketId() {
      return this.ticket.canonicalId;
    },
    fileFilter() {
      return ".mp4,.avi,.m4v,.mpg,.mpeg,.mov";
    },
    menuOptions() {
      return [
        {
          label: this.$t("menu.remove").toString(),
          tabKey: "remove"
        }
      ];
    },
    uploadAllowed() {
      const s = this.config.upload === "never", t = this.config.upload === "always", e = this.currentFiles.length + this.uploading.length;
      return s ? !1 : t ? !0 : this.config.upload === "single" ? e === 0 : !1;
    }
  },
  methods: {
    onFilePicked(s) {
      this.uploading.push([self.crypto.randomUUID(), s]);
    },
    onUploadSuccess(s) {
      this.uploading = this.uploading.filter(
        (t) => t[0] !== s.randomFileId
      ), this.currentFiles.push(s.userFile), this.onAttachmentChange();
    },
    async onRemoveFile(s) {
      await this.$api.fileAttachment.remove("ticket", this.ticketId, s.id), this.currentFiles = this.currentFiles.filter((t) => t.id !== s.id), this.onAttachmentChange();
    },
    onAttachmentChange() {
      this.$emit("attachment-updated");
    }
  }
});
var q2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-pitch-upload-group" }, [t._l(t.currentFiles, function(i, n) {
    return e("app-file-upload-item", { key: n, attrs: { file: i }, scopedSlots: t._u([{ key: "controls", fn: function() {
      return [e("app-ellipsis-menu", { attrs: { reference: i, "menu-options": t.menuOptions }, on: { "click:remove": t.onRemoveFile } })];
    }, proxy: !0 }], null, !0) });
  }), t._l(t.uploading, function([i, n]) {
    return e("app-file-upload-item-progress", { key: i, attrs: { "random-file-id": i, file: n, category: t.config.uploadCategory, "ticket-id": t.ticketId }, on: { "upload-success": t.onUploadSuccess } });
  }), t.uploadAllowed ? e("app-file-upload-picker", { attrs: { label: t.$t("common.upload"), "accept-filter": t.fileFilter }, on: { "pick-file": t.onFilePicked } }) : t._e()], 2);
}, U2 = [], N2 = /* @__PURE__ */ f(
  L2,
  q2,
  U2,
  !1,
  null,
  "0299db4b"
);
const B2 = N2.exports, j2 = g({
  components: {
    AppFileItem: Os,
    TicketPitchUploadGroup: B2
  },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    pitchConfig: {
      type: Array,
      required: !0
    }
  },
  computed: {
    contextId() {
      return this.ticket.context;
    },
    productId() {
      return this.ticket.type;
    },
    menuOptions() {
      return [[this.$t("menu.remove").toString(), "remove-file"]];
    },
    filteredPitches() {
      return this.pitchConfig.filter((s) => {
        const t = s.visibility === "never", e = s.visibility === "always", i = this.pitchFiles(s).length > 0, n = s.associatedStatus.includes(this.ticket.status);
        return t ? !1 : e || i || n;
      });
    }
  },
  methods: {
    groupLabelStyle(s) {
      return { color: s.color };
    },
    pitchFiles(s) {
      var t;
      return ((t = this.ticket.files) == null ? void 0 : t.filter((e) => e.category === s.uploadCategory).map(We)) ?? [];
    }
  }
});
var z2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-pitch-upload-container" }, t._l(t.filteredPitches, function(i, n) {
    return e("div", { key: n }, [e("div", { staticClass: "pitch-label", style: t.groupLabelStyle(i) }, [t._v(" " + t._s(t.$res(i.resources).label) + " ")]), e("div", { staticClass: "pitch-description" }, [t._v(" " + t._s(t.$res(i.resources).description) + " ")]), e("ticket-pitch-upload-group", { staticClass: "ticket-pitch-upload-group", attrs: { ticket: t.ticket, config: i } })], 1);
  }), 0);
}, V2 = [], H2 = /* @__PURE__ */ f(
  j2,
  z2,
  V2,
  !1,
  null,
  "3a44cee2"
);
const W2 = H2.exports, G2 = g({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    pitchConfig: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      currentTab: "",
      tabList: []
    };
  },
  async created() {
    await this.loadTabs();
  },
  watch: {
    async pitchConfig() {
      await this.loadTabs();
    }
  },
  computed: {
    videoSrc() {
      var t;
      const s = (t = this.ticket.files) == null ? void 0 : t.find(
        (e) => e.category === this.currentTab
      );
      return s ? s.url : void 0;
    }
  },
  methods: {
    loadTabs() {
      var t;
      this.tabList = this.pitchConfig.filter((e) => {
        var i;
        return (i = this.ticket.files) == null ? void 0 : i.some(
          (n) => n.category === e.uploadCategory
        );
      }).map((e) => ({
        key: e.uploadCategory,
        label: this.$res(e.resources).label,
        color: e.color
      }));
      const s = this.tabList.length - 1;
      s > -1 && (this.currentTab = (t = this.tabList[s]) == null ? void 0 : t.key);
    },
    tabStyle(s) {
      return s.key === this.currentTab ? { borderColor: s.color } : { borderColor: "transparent" };
    },
    onSelectTab(s) {
      this.currentTab = s.key;
    }
  }
});
var K2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-pitch-gallery" }, [e("video", { staticClass: "pitch-video-player", attrs: { src: t.videoSrc, controls: "", controlsList: "nodownload" } }), e("div", { staticClass: "pitch-tab-container" }, t._l(t.tabList, function(i) {
    return e("div", { key: i.key, staticClass: "pitch-tab", style: t.tabStyle(i), on: { click: function(n) {
      return t.onSelectTab(i);
    } } }, [t._v(" " + t._s(i.label) + " ")]);
  }), 0)]);
}, Y2 = [], X2 = /* @__PURE__ */ f(
  G2,
  K2,
  Y2,
  !1,
  null,
  "2b905417"
);
const Z2 = X2.exports, Q2 = g({
  props: {
    label: {
      type: String,
      required: !0
    },
    count: {
      type: Number,
      default: 0
    }
  }
});
var J2 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-stats-pill" }, [e("div", { staticClass: "stats-count" }, [t._v(t._s(t.count))]), e("div", { staticClass: "stats-title" }, [t._v(t._s(t.label))])]);
}, tP = [], eP = /* @__PURE__ */ f(
  Q2,
  J2,
  tP,
  !1,
  null,
  "4eb38814"
);
const sP = eP.exports, iP = g({
  components: {
    TicketStatsPill: sP
  },
  props: {
    ticketStats: {
      type: Object,
      default: () => ({})
    },
    workflow: {
      type: Object,
      required: !0
    },
    activeStatuses: {
      type: Array,
      default: null
    }
  },
  computed: {
    totalAmount() {
      return this.activeStatuses.reduce(
        (s, t) => {
          var e, i;
          return s + (((i = (e = this.ticketStats) == null ? void 0 : e.byStatus) == null ? void 0 : i[t]) ?? 0);
        },
        0
      );
    }
  },
  methods: {
    statusLabel(s) {
      var e;
      const t = Y(s, this.workflow);
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? "";
    },
    ticketCountPerStatus(s) {
      var t, e;
      return ((e = (t = this.ticketStats) == null ? void 0 : t.byStatus) == null ? void 0 : e[s]) ?? 0;
    }
  }
});
var nP = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-stats-container" }, [t._l(t.activeStatuses, function(i) {
    return e("ticket-stats-pill", { key: i, staticClass: "ticket-stats-pill", attrs: { label: t.statusLabel(i), count: t.ticketCountPerStatus(i) } });
  }), e("ticket-stats-pill", { staticClass: "ticket-stats-pill", attrs: { label: t.$t("page.topicDetails.total"), count: t.totalAmount } })], 2);
}, rP = [], aP = /* @__PURE__ */ f(
  iP,
  nP,
  rP,
  !1,
  null,
  "a4facbd1"
);
const oP = aP.exports, lP = g({
  components: {
    TicketPreferredTransition: wc,
    TicketAvailableTransitions: ur
  },
  props: {
    statusHistory: {
      type: Array,
      required: !0
    },
    status: {
      type: String,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      preferredTransition: void 0,
      availableTransitions: []
    };
  },
  created() {
    const { fromStatus: s, available: t, preferred: e } = t_(this.workflow);
    Te(e, (i) => {
      this.preferredTransition = i;
    }), Te(t, (i) => {
      this.availableTransitions = i ?? [];
    }), s.value = this.status;
  },
  computed: {
    hasPhase() {
      var s, t, e;
      return !!((e = (t = (s = this.workflow) == null ? void 0 : s.settings) == null ? void 0 : t.status[this.status]) != null && e.phase);
    }
  },
  methods: {
    onExecuteTransition(s) {
      this.$emit("execute-transition", s);
    }
  }
});
var cP = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "workflow-transition-actions" }, [t.hasPhase ? e("phase-progress", { attrs: { "available-transitions": t.availableTransitions, "preferred-transition": t.preferredTransition, status: t.status, "status-history": t.statusHistory, "user-actions": t.userActions, workflow: t.workflow }, on: { "execute-transition": t.onExecuteTransition } }) : t.preferredTransition ? e("ticket-preferred-transition", { attrs: { "available-transitions": t.availableTransitions, "preferred-transition": t.preferredTransition, "user-actions": t.userActions, workflow: t.workflow, theme: "primary" }, on: { "execute-transition": t.onExecuteTransition } }) : t.availableTransitions.length ? e("ticket-available-transitions", { attrs: { transitions: t.availableTransitions, "user-actions": t.userActions, workflow: t.workflow }, on: { "execute-transition": t.onExecuteTransition } }) : t._e()], 1);
}, uP = [], dP = /* @__PURE__ */ f(
  lP,
  cP,
  uP,
  !1,
  null,
  null
);
const pP = dP.exports, hP = g({
  props: {
    transitionDialogSettings: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      reasonText: ""
    };
  },
  computed: {
    replacements() {
      return [
        ["@:common.ticket", this.$t("common.ticket").toString()],
        ["@common.ticket", this.$t("common.ticket").toString()]
      ];
    },
    showStatusMessage() {
      return this.transitionDialogSettings.statusMessage && this.transitionDialogSettings.statusMessage !== "DISABLED";
    },
    statusMessageLabel() {
      return this.resources.statusMessageLabel;
    },
    isConfirmEnabled() {
      return this.transitionDialogSettings.statusMessage !== "REQUIRED" || !!this.reasonText;
    },
    resources() {
      const s = this.transitionDialogSettings.resources;
      return this.$res(s);
    },
    title() {
      return this.replaceTranslations(this.resources.title ?? "");
    },
    description() {
      return this.replaceTranslations(this.resources.description ?? "");
    }
  },
  methods: {
    replaceTranslations(s) {
      return this.replacements.reduce((t, e) => t.replaceAll(e[0], e[1]), s);
    },
    onConfirm() {
      this.$emit("click-primary", this.reasonText);
    },
    onCancel() {
      this.$emit("click-secondary");
    }
  }
});
var fP = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { staticClass: "modal-container", on: { "click-outside": t.onCancel } }, [t.title || t.description ? e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.title) + " ")]), e("app-markdown-text", { staticClass: "modal-description", attrs: { text: t.description } })], 1) : t._e(), t.showStatusMessage ? e("app-markdown-input", { staticClass: "modal-reason-input", attrs: { label: t.statusMessageLabel, required: !0 }, model: { value: t.reasonText, callback: function(i) {
    t.reasonText = typeof i == "string" ? i.trim() : i;
  }, expression: "reasonText" } }) : t._e(), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { enabled: t.isConfirmEnabled, label: t.$t("form.button.confirm") }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("form.button.cancel") }, on: { click: t.onCancel } })], 1)], 1);
}, mP = [], gP = /* @__PURE__ */ f(
  hP,
  fP,
  mP,
  !1,
  null,
  "6a40e28e"
);
const _P = gP.exports, yP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppAttachmentContainer: eA,
  AppTicketCard: FI,
  AppTicketStats: oP,
  AssignCoCreators: S2,
  AssigneeIndicator: jT,
  AssigneeSingleselect: GT,
  CampaignGalleryCard: iI,
  DelegateTagList: dr,
  OfferDropdown: eT,
  PhaseProgress: H1,
  StatusSelectionSingle: H0,
  TeamSelector: d2,
  TicketActivityCard: WI,
  TicketAssigneeSelection: QT,
  TicketAvailableTransitions: ur,
  TicketBalance: f1,
  TicketBreadcrumb: kc,
  TicketBulkActionsContainer: YA,
  TicketBulkActionsDropdown: t2,
  TicketCardCampaign: lI,
  TicketCardHorizontalDefault: OI,
  TicketCardPlaceholderButton: BI,
  TicketCardVerticalDefault: xI,
  TicketCopyMoveMenu: LT,
  TicketCreatorSelection: r1,
  TicketDelegationWidget: r2,
  TicketDetailTabs: TT,
  TicketDropdown: X1,
  TicketModalTransition: _P,
  TicketPitchGallery: Z2,
  TicketPitchUploadContainer: W2,
  TicketStatusPill: $c,
  TicketTimeline: F2,
  TicketTransactionsWidget: xc,
  TopicSelector: g2,
  WorkflowTransitionActions: pP
}, Symbol.toStringTag, { value: "Module" })), bP = "/img/profile-placeholder.svg", vP = g({
  components: {
    EditableTextArea: or,
    UserSelectionInput: Di
  },
  props: {
    productId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    task: {
      type: Object,
      required: !0
    },
    comments: {
      type: Array,
      required: !0
    },
    mode: {
      type: String,
      default: "view"
    }
  },
  data() {
    return {
      checked: !1,
      title: "",
      deadline: void 0,
      assignee: null,
      userSelectionOpen: !1,
      searchOptions: []
    };
  },
  async created() {
    this.checked = this.task.ticket.status === "COMPLETED", this.title = this.task.ticket.title;
    const s = this.task.ticket.deadLine;
    this.deadline = s ? new Date(s) : void 0, this.task.assignee && (this.assignee = this.task.assignee.user ?? null);
  },
  computed: {
    ticketIdOrType() {
      return this.task.ticket.canonicalId ?? this.task.ticket.type;
    },
    deadlineText() {
      var t;
      const s = {
        year: void 0,
        month: "short",
        day: "numeric"
      };
      return ((t = this.deadline) == null ? void 0 : t.toLocaleDateString(void 0, s)) ?? "";
    },
    expired() {
      return this.deadline ? this.deadline < /* @__PURE__ */ new Date() : !1;
    },
    commentsCount() {
      return this.comments.length ? `${this.comments.length}` : "";
    },
    commentsIcon() {
      return this.commentsCount ? "fa-light fa-comment" : "fa-light fa-comment-plus";
    },
    assigneeAvatar() {
      var s;
      return ((s = this.assignee) == null ? void 0 : s.avatar) || bP;
    },
    menuOptions() {
      return [
        {
          label: this.$t("menu.removeTask").toString(),
          tabKey: "remove-task"
        }
      ];
    }
  },
  methods: {
    onToggleUserSelection() {
      this.userSelectionOpen = !this.userSelectionOpen;
    },
    async onUpdateSearch(s) {
      this.searchOptions = await this.$gateway.portal.fetchTicketAssigneeAudience(
        s,
        this.ticketIdOrType,
        this.productId
      );
    },
    removeTask() {
      this.$emit("remove-task");
    },
    onUpdateStatus(s) {
      this.$emit("update-status", s);
    },
    onUpdateTitle(s) {
      s.code === "Escape" && (s.preventDefault(), this.title = this.task.ticket.title), s.code === "Enter" && !s.shiftKey && (s.preventDefault(), this.$emit("update-title", this.title.trim()));
    },
    onBlurTitle(s) {
      this.$emit("update-title", this.title.trim());
    },
    onChangeDeadline(s) {
      if (s) {
        this.$emit("update-deadline", s.toISOString());
        const t = new Date(s.getTime());
        t.setHours(23), t.setMinutes(59), this.deadline = t;
      } else
        this.deadline = void 0;
    },
    async onChangeAssignee(s) {
      this.$emit("update-assignee", s);
      try {
        const t = await this.$datasource.user.findById(s);
        this.assignee = t ?? null;
      } catch (t) {
        console.error("Could not load assignee", t);
      }
    },
    onChangeAssigneeSelf() {
      this.onChangeAssignee(this.currentUser.id);
    },
    onToggleComments() {
      this.$emit("toggle-comments");
    }
  }
});
var kP = function() {
  var i;
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "task-item-content" }, [e("div", { staticClass: "inner-container" }, [e("app-checkbox", { staticClass: "completed-checkbox", on: { input: t.onUpdateStatus }, model: { value: t.checked, callback: function(n) {
    t.checked = n;
  }, expression: "checked" } })], 1), e("editable-text-area", { staticClass: "task-title", attrs: { rows: 1, mode: t.mode }, on: { keydown: t.onUpdateTitle, blur: t.onBlurTitle }, model: { value: t.title, callback: function(n) {
    t.title = n;
  }, expression: "title" } }), e("div", { staticClass: "inner-container deadline-container" }, [e("app-datepicker-button", { on: { input: t.onChangeDeadline }, scopedSlots: t._u([{ key: "default", fn: function({ toggle: n }) {
    return [t.deadline ? e("div", { staticClass: "deadline-date", class: { expired: t.expired }, on: { click: n } }, [t._v(" " + t._s(t.deadlineText) + " ")]) : e("app-icon-button", { attrs: { size: 30 }, on: { click: n } }, [e("fa-icon-compat", { staticClass: "inner-icon", attrs: { icon: "fa-light fa-calendar" } })], 1)];
  } }]) })], 1), e("div", { staticClass: "inner-container assignee-container" }, [t.assignee ? e("img", { staticClass: "assignee-image", attrs: { src: t.assigneeAvatar }, on: { click: t.onToggleUserSelection } }) : e("app-icon-button", { attrs: { size: 30 }, on: { click: t.onToggleUserSelection } }, [e("fa-icon-compat", { staticClass: "inner-icon", attrs: { icon: "fa-light fa-user-plus" } })], 1), t.userSelectionOpen ? e("div", { staticClass: "assignee-selection" }, [e("user-selection-input", { attrs: { options: t.searchOptions }, on: { "hide-floating": t.onToggleUserSelection, "update-search": t.onUpdateSearch, "select-item": t.onChangeAssignee }, scopedSlots: t._u([t.currentUser.id !== ((i = t.assignee) == null ? void 0 : i.id) ? { key: "prepend", fn: function() {
    return [e("app-list-item", { attrs: { image: t.currentUser.avatar, title: t.$t("menu.assignToMe") }, nativeOn: { click: function(n) {
      return t.onChangeAssigneeSelf.apply(null, arguments);
    } } })];
  }, proxy: !0 } : null], null, !0) })], 1) : t._e()], 1), e("div", { staticClass: "inner-container" }, [e("app-icon-button", { attrs: { size: 30 }, on: { click: t.onToggleComments } }, [e("fa-icon-compat", { staticClass: "inner-icon comments-icon", attrs: { icon: t.commentsIcon } })], 1), e("span", { staticClass: "comments-count" }, [t._v(" " + t._s(t.commentsCount) + " ")])], 1), e("div", { staticClass: "inner-container" }, [e("app-ellipsis-menu", { staticClass: "task-menu", attrs: { "menu-options": t.menuOptions }, on: { "click:remove-task": t.removeTask } })], 1)], 1);
}, xP = [], CP = /* @__PURE__ */ f(
  vP,
  kP,
  xP,
  !1,
  null,
  "00591a4c"
);
const wP = CP.exports, zo = "/img/profile-placeholder.svg", $P = g({
  props: {
    mode: {
      type: String,
      default: "view"
    },
    comment: {
      type: Object,
      required: !1
    },
    placeholder: {
      type: String,
      required: !1
    },
    currentUser: {
      type: Object,
      required: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      text: ""
    };
  },
  created() {
    var s;
    this.text = ((s = this.comment) == null ? void 0 : s.content) ?? "";
  },
  computed: {
    authorAvatar() {
      var s, t, e;
      return this.comment ? ((t = (s = this.comment.author) == null ? void 0 : s.user) == null ? void 0 : t.avatar) || zo : ((e = this.currentUser) == null ? void 0 : e.avatar) || zo;
    },
    routeToUser() {
      var s, t, e;
      return {
        name: "UserProfile",
        params: {
          userId: ((e = (t = (s = this.comment) == null ? void 0 : s.author) == null ? void 0 : t.user) == null ? void 0 : e.id) ?? this.currentUser.id
        }
      };
    }
  },
  methods: {
    onKeydown(s) {
      s.code === "Enter" && !s.shiftKey && (this.$emit("confirmComment", this.text.trim()), s.preventDefault());
    }
  }
});
var SP = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "compact-comment-item" }, [e("router-link", { attrs: { to: t.routeToUser } }, [e("img", { staticClass: "author-avatar", attrs: { src: t.authorAvatar } })]), e("editable-text-area", { staticClass: "comment-text", attrs: { placeholder: t.placeholder, rows: t.rows, mode: t.mode }, on: { keydown: t.onKeydown }, model: { value: t.text, callback: function(i) {
    t.text = i;
  }, expression: "text" } })], 1);
}, TP = [], IP = /* @__PURE__ */ f(
  $P,
  SP,
  TP,
  !1,
  null,
  "c9bb1e6e"
);
const Ec = IP.exports, AP = g({
  components: {
    CompactCommentItem: Ec
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    currentUser: {
      type: Object,
      required: !0
    },
    comments: {
      type: Array,
      required: !0
    },
    threadOwnerId: {
      type: Object,
      required: !1
    }
  },
  methods: {
    getCommentMode(s) {
      var t, e;
      return ((e = (t = s.author) == null ? void 0 : t.user) == null ? void 0 : e.id) !== this.currentUser.id, "view";
    },
    onCreateComment(s) {
      this.$emit("commentCreate", s);
    },
    onUpdateComment(s, t) {
      this.$emit("commentUpdate", { id: s, text: t });
    }
  }
});
var PP = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "compact-comment-area" }, [e("compact-comment-item", { attrs: { "current-user": t.currentUser, placeholder: t.$t("page.ticketDetails.leaveComment"), rows: 2, mode: "edit" }, on: { confirmComment: t.onCreateComment } }), t._l(t.comments, function(i) {
    return e("div", { key: i.id }, [e("compact-comment-item", { attrs: { comment: i, mode: t.getCommentMode(i) }, on: { confirmComment: function(n) {
      return t.onUpdateComment(i.id, n);
    } } })], 1);
  })], 2);
}, OP = [], MP = /* @__PURE__ */ f(
  AP,
  PP,
  OP,
  !1,
  null,
  "dbf1d93f"
);
const Dc = MP.exports, RP = g({
  components: {
    TaskItemContent: wP,
    CompactCommentArea: Dc
  },
  props: {
    productId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    taskResponse: {
      type: Object,
      required: !0
    },
    comments: {
      type: Array,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      reloadKey: 0,
      commentsVisible: !1,
      currentComments: []
    };
  },
  created() {
    this.currentComments = this.comments;
  },
  computed: {
    task() {
      return this.taskResponse.ticket;
    }
  },
  methods: {
    onToggleComments() {
      this.commentsVisible = !this.commentsVisible;
    },
    async onUpdateStatus(s) {
      const t = s ? "COMPLETED" : "DRAFT";
      try {
        await this.$datasource.ticket.updateStatus(
          this.productId,
          this.task.canonicalId,
          t
        ), this.task.status = t, this.onTaskUpdated(), t === "COMPLETED" ? this.$toast(this.$t("page.tasks.completed").toString()) : this.$toast(this.$t("common.saved").toString());
      } catch (e) {
        console.error(`Could not update status [${this.task.canonicalId}]`, e), this.$toast(this.$t("error.general").toString());
      }
    },
    async onUpdateTitle(s) {
      if (s.length && this.task.title !== s)
        try {
          await this.$datasource.ticket.update(
            this.productId,
            this.task.canonicalId,
            {
              title: s
            }
          ), this.task.title = s, this.onTaskUpdated(), this.$toast(this.$t("common.saved").toString());
        } catch (t) {
          console.error(`Could not update title [${this.task.canonicalId}]`, t), this.$toast(this.$t("error.general").toString());
        }
    },
    async onUpdateDeadline(s) {
      const t = new Date(Date.parse(s));
      t.setHours(23), t.setMinutes(59);
      try {
        const e = t.getTime();
        await this.$datasource.ticket.update(
          this.productId,
          this.task.canonicalId,
          {
            deadLine: e
          }
        ), this.task.deadLine = e, this.onTaskUpdated(), this.$toast(this.$t("common.saved").toString());
      } catch (e) {
        console.error(
          `Could not update deadline [${this.task.canonicalId}]`,
          e
        ), this.$toast(this.$t("error.general").toString());
      }
    },
    async onUpdateAssignee(s) {
      try {
        await this.$datasource.ticket.update(
          this.productId,
          this.task.canonicalId,
          {
            assignee: s
          }
        ), this.task.assignee = s, this.$toast(this.$t("common.saved").toString()), this.onTaskUpdated();
      } catch (t) {
        console.error(
          `Could not update assignee [${this.task.canonicalId}]`,
          t
        ), this.$toast(this.$t("error.general").toString());
      }
    },
    async onRemoveTask() {
      try {
        await this.$gateway.portal.removeTask(
          this.productId,
          this.task.canonicalId
        ), this.onTaskRemoved();
      } catch (s) {
        console.error(`Could not remove task [${this.task.canonicalId}]`, s), this.$toast(this.$t("error.general").toString());
      }
    },
    async onCreateComment(s) {
      if (s.length)
        try {
          const t = this.task.canonicalId, e = await this.$gateway.portal.createPublicComment(
            t,
            {
              author: this.currentUser.id,
              content: s
            }
          );
          this.currentComments = [e, ...this.currentComments], this.reloadKey += 1;
        } catch (t) {
          console.error("Could not create comment", t), this.$toast(this.$t("error.general").toString());
        }
    },
    async onUpdateComment(s) {
      console.warn("Update comment not implemented", s);
    },
    onTaskUpdated() {
      this.$emit("task-updated", this.task.canonicalId);
    },
    onTaskRemoved() {
      this.$emit("task-removed", this.task.canonicalId);
    }
  }
});
var EP = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "task-item" }, [e("task-item-content", { attrs: { "product-id": t.productId, "current-user": t.currentUser, task: t.taskResponse, comments: t.currentComments, mode: t.mode }, on: { "update-status": t.onUpdateStatus, "update-title": t.onUpdateTitle, "update-deadline": t.onUpdateDeadline, "update-assignee": t.onUpdateAssignee, "toggle-comments": t.onToggleComments, "remove-task": t.onRemoveTask } }), e("transition", { attrs: { mode: "out-in", name: "slide-fade-vertical" } }, [t.commentsVisible ? e("compact-comment-area", { key: t.reloadKey, staticClass: "compact-comment-area", attrs: { mode: t.mode, "current-user": t.currentUser, comments: t.currentComments, "thread-owner-id": void 0 }, on: { commentCreate: t.onCreateComment, commentUpdate: t.onUpdateComment } }) : t._e()], 1)], 1);
}, DP = [], FP = /* @__PURE__ */ f(
  RP,
  EP,
  DP,
  !1,
  null,
  "d994ea5e"
);
const Fc = FP.exports, LP = g({
  components: {
    EditableTextArea: or
  },
  props: {
    productId: {
      type: String,
      required: !0
    },
    parentCanonicalId: {
      type: String,
      required: !0
    },
    taskGroup: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      title: "",
      loading: !1
    };
  },
  computed: {
    enabled() {
      return !this.loading;
    }
  },
  methods: {
    async onUpdateTitle(s) {
      s.code === "Enter" && !s.shiftKey && (s.preventDefault(), await this.createTask(this.title.trim()));
    },
    async createTask(s) {
      if (s.length)
        try {
          this.loading = !0;
          const t = await this.$gateway.portal.createTask(
            this.productId,
            this.parentCanonicalId,
            this.taskGroup,
            s
          );
          this.$emit("task-created", t), this.title = "";
        } catch (t) {
          console.error("Could not create task", t), this.$toast(this.$t("error.general").toString());
        } finally {
          this.loading = !1;
        }
    }
  }
});
var qP = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("editable-text-area", { staticClass: "task-item-create", attrs: { rows: 1, mode: "edit", enabled: t.enabled, placeholder: t.$t("page.tasks.add-placeholder") }, on: { keydown: t.onUpdateTitle }, model: { value: t.title, callback: function(i) {
    t.title = i;
  }, expression: "title" } });
}, UP = [], NP = /* @__PURE__ */ f(
  LP,
  qP,
  UP,
  !1,
  null,
  "eae998e0"
);
const BP = NP.exports, jP = g({
  components: {
    TaskItem: Fc,
    TaskItemCreate: BP
  },
  props: {
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    parentCanonicalId: {
      type: String,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    },
    taskGroup: {
      type: String,
      required: !1
    },
    actionsCreateTask: {
      type: Boolean,
      default: !0
    },
    tasks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentTasks: []
    };
  },
  created() {
    this.currentTasks = [...this.tasks];
  },
  computed: {
    createTaskVisible() {
      return this.actionsCreateTask && this.mode === "edit";
    }
  },
  methods: {
    onTaskUpdated() {
      this.$datasource.ticket.dirty(this.parentCanonicalId);
    },
    onTaskRemoved(s) {
      this.$datasource.ticket.dirty(this.parentCanonicalId), this.currentTasks = this.currentTasks.filter(
        ([{ ticket: t }]) => t.canonicalId !== s
      ), this.$toast(this.$t("common.removed").toString()), this.$emit("update-task-list");
    },
    onTaskCreated(s) {
      this.$datasource.ticket.dirty(this.parentCanonicalId), this.currentTasks = [...this.currentTasks, [s, []]], this.$toast(this.$t("common.created").toString()), this.$emit("update-task-list");
    }
  }
});
var zP = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "task-list" }, [t._l(t.currentTasks, function([i, n]) {
    return e("task-item", { key: i.ticket.canonicalId, attrs: { "product-id": t.productId, "current-user": t.currentUser, comments: n, "task-response": i, mode: t.mode }, on: { "task-updated": t.onTaskUpdated, "task-removed": t.onTaskRemoved } });
  }), t.createTaskVisible ? e("task-item-create", { attrs: { "product-id": t.productId, "parent-canonical-id": t.parentCanonicalId, "task-group": t.taskGroup }, on: { "task-created": t.onTaskCreated } }) : t._e()], 2);
}, VP = [], HP = /* @__PURE__ */ f(
  jP,
  zP,
  VP,
  !1,
  null,
  "972f376c"
);
const WP = HP.exports, GP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TaskItem: Fc,
  TaskList: WP
}, Symbol.toStringTag, { value: "Module" })), KP = g({
  props: {
    currentImage: {
      type: String,
      required: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      src: "",
      type: ""
    };
  },
  setup() {
    return zl();
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  },
  methods: {
    onClickInput() {
      const s = this;
      s.enabled && s.$refs.file.click();
    },
    loadImage(s) {
      const t = this, { files: e } = s.target;
      if (e != null && e[0] && !this.allowFileSize(e[0])) {
        console.error(`File size is too big, ${e[0].size}`), this.$toast(
          this.$t("error.maxFileSize", {
            size: this.readableMaxFileUploadSize
          }).toString()
        );
        return;
      } else if (e != null && e[0]) {
        t.src && URL.revokeObjectURL(t.src);
        const i = URL.createObjectURL(e[0]);
        this.$emit("blob-loaded", e[0]), t.src = i, t.type = e[0].type, this.$emit("image-loaded", { src: t.src, type: t.type });
      }
    }
  }
});
var YP = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "input-content", attrs: { role: "input" }, on: { click: t.onClickInput, keypress: function(i) {
    return !i.type.indexOf("key") && t._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : (i.stopPropagation(), t.onClickInput.apply(null, arguments));
  } } }, [e("app-icon-button", { attrs: { size: 48, frame: "square" } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-paperclip" } })], 1), e("input", { ref: "file", staticClass: "hidden-file-input", attrs: { type: "file" }, on: { change: function(i) {
    return t.loadImage(i);
  } } })], 1);
}, XP = [], ZP = /* @__PURE__ */ f(
  KP,
  YP,
  XP,
  !1,
  null,
  "56ac7775"
);
const QP = ZP.exports, JP = g({
  components: {
    CommentFileInput: QP
  },
  props: {
    originalText: {
      type: String,
      required: !1
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      text: this.originalText ?? "",
      open: !1,
      lastCaretPosition: 0,
      dirty: !1,
      loading: !1,
      reloadKey: 0,
      options: [],
      search: "",
      commentImage: ""
    };
  },
  mounted() {
    document.addEventListener("keyup", this.listenerKeyup);
  },
  unmounted() {
    document.removeEventListener("keyup", this.listenerKeyup);
  },
  computed: {
    postButtonEnabled() {
      return this.text.trim().length > 0;
    }
  },
  methods: {
    onCancelComment() {
      this.text = "", this.$emit("cancel-comment");
    },
    insertText(s) {
      const t = this.lastCaretPosition;
      this.text = `${this.text.substring(
        0,
        t
      )}{${s}} ${this.text.substring(t)}`;
    },
    async onImageInput(s) {
      const t = await this.$api.fileUpload.uploadFile(
        s,
        "comment-file",
        s.name
      );
      this.text = `${this.text} [${s.name}](${t.payload.location}) `;
    },
    onCommentSelection(s) {
      this.lastCaretPosition = s.selectionStart;
    },
    onCommentKeydown(s) {
      s.key === "@" && (this.open = !0, setTimeout(() => {
        const t = this.$el.querySelector(".user-list-search input");
        t == null || t.focus();
      }, 100));
    },
    onDirty() {
      this.dirty = !0, this.loading = !0;
    },
    onSelectItem(s) {
      const t = E({ user: s.user }).displayEmail(), e = t || `${this.contextId}:user:id:${s.user.id}`;
      this.insertText(e), this.open = !1, setTimeout(() => {
        const i = this.$el.querySelector(".app-text-area textarea");
        i == null || i.focus();
      }, 100), this.search = "", this.options = [];
    },
    async onDebouncedSearch(s) {
      this.loading = !0;
      const t = await this.$gateway.search.searchUserIds({ query: s }), e = await this.$gateway.portal.findUsersById(
        t
      );
      this.options = e.filter(
        (i) => !!i.user.firstName || i.user.lastName
      ), this.loading = !1;
    },
    onCancelMention() {
      this.open = !1, this.search = "", this.options = [], setTimeout(() => {
        const s = this.$el.querySelector(".app-text-area textarea");
        s == null || s.focus();
      }, 500);
    },
    listenerKeyup(s) {
      var t;
      ((t = s.key) == null ? void 0 : t.toUpperCase()) === "ESCAPE" && this.onCancelMention();
    },
    saveComment() {
      this.$emit("save-comment", this.text.trim()), this.text = "";
    }
  }
});
var tO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "classic-comment-area" }, [e("div", { staticClass: "text-area-wrapper" }, [e("app-markdown-input", { staticClass: "app-text-area", attrs: { placeholder: t.$t("common.addYourComment"), rows: 5 }, on: { keydown: t.onCommentKeydown, selection: t.onCommentSelection }, model: { value: t.text, callback: function(i) {
    t.text = i;
  }, expression: "text" } })], 1), e("div", { staticClass: "comment-button-sheet" }, [e("app-button", { staticClass: "post-comment-button", attrs: { enabled: t.postButtonEnabled, label: t.$t("common.post") }, on: { "~click": function(i) {
    return t.saveComment.apply(null, arguments);
  } } }), t.originalText ? e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancelComment } }) : t._e(), e("comment-file-input", { staticClass: "comment-image", attrs: { "current-image": t.commentImage, ratio: 16 / 9, required: !0 }, on: { "blob-loaded": t.onImageInput } })], 1), t.open ? e("app-modal", { staticClass: "user-list-modal", on: { "click-outside": t.onCancelMention } }, [e("div", { staticClass: "user-mention-title" }, [t._v(" " + t._s(t.$t("modal.addCommentMention.title")) + " ")]), e("app-search-input", { staticClass: "user-list-search", attrs: { "debounce-timeout": 500, placeholder: t.$t("common.search") }, on: { debounced: t.onDebouncedSearch }, model: { value: t.search, callback: function(i) {
    t.search = i;
  }, expression: "search" } }), e("div", { staticClass: "user-content" }, t._l(t.options, function(i) {
    return e("user-item", { key: i.user.id, staticClass: "item", attrs: { "user-data": i }, nativeOn: { click: function(n) {
      return t.onSelectItem(i);
    } } });
  }), 1), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancelMention } })], 1) : t._e()], 1);
}, eO = [], sO = /* @__PURE__ */ f(
  JP,
  tO,
  eO,
  !1,
  null,
  "73e1fae5"
);
const iO = sO.exports, nO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClassicCommentArea: iO,
  ClassicCommentItem: Sc,
  CompactCommentArea: Dc,
  CompactCommentItem: Ec,
  PrivateCommentsWidget: Ac,
  PublicCommentsWidget: Ic
}, Symbol.toStringTag, { value: "Module" })), rO = g({
  name: "LinkItemTicket",
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    link: {
      type: Object,
      required: !0
    },
    deleteEnabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      ticket: null,
      workflow: null
    };
  },
  async mounted() {
    this.loading = !0;
    try {
      const s = await this.$gateway.ticket.loadTicket(
        this.contextId,
        this.productId,
        this.link.destination.id
      );
      this.ticket = s.ticket, this.workflow = s.workflow;
    } catch (s) {
      console.error(s);
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    title() {
      var s;
      return ((s = this.ticket) == null ? void 0 : s.title) ?? "";
    },
    status() {
      var s;
      return ((s = this.ticket) == null ? void 0 : s.status) ?? "";
    },
    createdDate() {
      const s = new Date(this.ticket.createdDate);
      return (s == null ? void 0 : s.toLocaleDateString(void 0, {
        day: "2-digit",
        month: "short",
        year: "numeric"
      })) || "";
    },
    statusLabel() {
      var t;
      const s = Y(this.ticket.status, this.workflow);
      return ((t = this.$res(s)) == null ? void 0 : t.label) ?? "";
    },
    targetRoute() {
      var s;
      return {
        name: "TicketDetails",
        params: { id: (s = this.ticket) == null ? void 0 : s.canonicalId }
      };
    },
    menuOptions() {
      return [
        {
          label: this.$t("common.form.delete").toString(),
          tabKey: "delete"
        }
      ];
    },
    image() {
      if (!this.workflow)
        return "";
      const { icons: s } = Ge(this.workflow);
      return s.solid ?? "";
    }
  },
  methods: {
    onDelete() {
      this.$emit("delete", this.link);
    }
  }
});
var aO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.ticket ? e("router-link", { attrs: { to: t.targetRoute } }, [e("app-list-item", { attrs: { description: t.createdDate, image: t.image, title: t.title }, scopedSlots: t._u([{ key: "description", fn: function() {
    return [e("div", { staticClass: "description-container" }, [e("div", { staticClass: "item-description" }, [t._v(t._s(t.createdDate))]), e("div", { staticClass: "item-status" }, [t._v(t._s(t.statusLabel))])])];
  }, proxy: !0 }, { key: "controls", fn: function() {
    return [t.deleteEnabled ? e("app-ellipsis-menu", { attrs: { "menu-options": t.menuOptions }, on: { "click:delete": t.onDelete } }) : t._e()];
  }, proxy: !0 }], null, !1, 2079526083) })], 1) : t._e();
}, oO = [], lO = /* @__PURE__ */ f(
  rO,
  aO,
  oO,
  !1,
  null,
  "76751eee"
);
const Lc = lO.exports, cO = g({
  name: "LinkItem",
  components: {
    LinkItemTicket: Lc
  },
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    link: {
      type: Object,
      required: !0
    },
    deleteEnabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    target() {
      return this.link.destination;
    },
    linkItemComponent() {
      var s, t;
      switch ((s = this.target) == null ? void 0 : s.class) {
        case "SERVICE_ORDER":
          return "LinkItemTicket";
        case "TICKET":
          return "LinkItemTicket";
        default:
          return console.error(`Unknown link target class: '${(t = this.target) == null ? void 0 : t.class}'`), "";
      }
    }
  }
});
var uO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e(t.linkItemComponent, t._g({ tag: "component", attrs: { "context-id": t.contextId, "product-id": t.productId, link: t.link, "delete-enabled": t.deleteEnabled } }, t.$listeners));
}, dO = [], pO = /* @__PURE__ */ f(
  cO,
  uO,
  dO,
  !1,
  null,
  null
);
const qc = pO.exports, hO = Rt.extend({
  props: {
    link: {
      type: Object,
      required: !0
    },
    relation: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1
    };
  },
  methods: {
    async onConfirmDelete() {
      try {
        this.loading = !0, await this.$api.link.deleteLink({
          sourceId: this.link.source.id,
          destinationId: this.link.destination.id,
          class: this.link.destination.class,
          relation: this.relation
        }), this.$toast(
          this.$t("modal.linkItemDelete.toast-delete-success").toString()
        ), this.$emit("updated");
      } catch (s) {
        s.message ? this.$toast(s.message) : this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1, this.onClose();
      }
    },
    onClose() {
      this.$emit("close");
    }
  }
});
var fO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal-confirmation", { attrs: { title: t.$t("modal.linkItemDelete.title"), description: t.$t("modal.linkItemDelete.message"), "primary-label": t.$t("form.button.confirm"), "secondary-label": t.$t("form.button.cancel"), loading: t.loading }, on: { "click-primary": t.onConfirmDelete, "click-secondary": t.onClose } });
}, mO = [], gO = /* @__PURE__ */ f(
  hO,
  fO,
  mO,
  !1,
  null,
  null
);
const _O = gO.exports, yO = g({
  name: "LinkGroup",
  components: {
    LinkItem: qc,
    LinkItemDelete: _O
  },
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    relation: {
      type: String,
      required: !0
    },
    links: {
      type: Array,
      required: !0
    },
    deleteEnabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      link: {},
      openLinkDeleteModal: !1
    };
  },
  computed: {
    relationTitle() {
      return this.$t(`linking.${this.relation}`).toString();
    }
  },
  methods: {
    manageDeleteModal(s) {
      this.link = s, this.openLinkDeleteModal = !0;
    }
  }
});
var bO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("app-section-list", { staticClass: "link-group", attrs: { data: t.links, level: 3, title: t.relationTitle }, scopedSlots: t._u([{ key: "default", fn: function({ item: i }) {
    return [e("link-item", { staticClass: "link-item", attrs: { "context-id": t.contextId, "product-id": t.productId, link: i, "delete-enabled": t.deleteEnabled }, on: { delete: t.manageDeleteModal } })];
  } }]) }), t.openLinkDeleteModal ? e("link-item-delete", { attrs: { relation: t.relation, link: t.link }, on: { close: function(i) {
    t.openLinkDeleteModal = !1;
  }, updated: function(i) {
    return t.$emit("updated");
  } } }) : t._e()], 1);
}, vO = [], kO = /* @__PURE__ */ f(
  yO,
  bO,
  vO,
  !1,
  null,
  "bb7ff8a3"
);
const Uc = kO.exports, xO = g({
  name: "TicketLinkWidget",
  components: {
    LinkGroup: Uc
  },
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    links: {
      type: Array,
      required: !0
    }
  },
  computed: {
    availableTargets() {
      return ["TICKET", "SERVICE_ORDER"];
    },
    availableRelations() {
      return [
        { name: "COPY_TO", deleteEnabled: !1 },
        { name: "COPIED_FROM", deleteEnabled: !1 },
        { name: "MOVED", deleteEnabled: !1 },
        { name: "MOVED_FROM", deleteEnabled: !1 },
        { name: "PURCHASED", deleteEnabled: !1 },
        { name: "IS_PURCHASED_BY", deleteEnabled: !1 },
        { name: "CONTINUED_FROM", deleteEnabled: !0 },
        { name: "CONTINUED_AS", deleteEnabled: !0 },
        { name: "RELATED_TO", deleteEnabled: !0 },
        { name: "RELATED_FROM", deleteEnabled: !0 }
      ];
    },
    validLinks() {
      return this.links.filter((s) => this.availableTargets.includes(s.destination.class)).filter(
        (s) => this.availableRelations.some((t) => t.name === s.relation)
      );
    },
    linkByRelation() {
      return Zy(this.validLinks, (s) => s.relation);
    },
    relationList() {
      return [...this.linkByRelation.keys()];
    }
  },
  methods: {
    linkRelationObjects(s) {
      return this.linkByRelation.get(s);
    },
    isDeleteEnabled(s) {
      return this.availableRelations.find((t) => t.name === s).deleteEnabled;
    }
  }
});
var CO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "ticket-link-widget" }, t._l(t.relationList, function(i) {
    return e("link-group", { key: i, attrs: { "context-id": t.contextId, "product-id": t.productId, relation: i, "delete-enabled": t.isDeleteEnabled(i), links: t.linkRelationObjects(i) }, on: { updated: function(n) {
      return t.$emit("updated");
    } } });
  }), 1);
}, wO = [], $O = /* @__PURE__ */ f(
  xO,
  CO,
  wO,
  !1,
  null,
  "09f20adf"
);
const SO = $O.exports, TO = g({
  props: {
    ticketId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      ticketSelected: "",
      relationSelected: "",
      relationOptions: [
        {
          text: this.$t("linking.CONTINUED_FROM").toString().toUpperCase(),
          value: "CONTINUED_FROM"
        },
        {
          text: this.$t("linking.CONTINUED_AS").toString().toUpperCase(),
          value: "CONTINUED_AS"
        },
        {
          text: this.$t("linking.RELATED_TO").toString().toUpperCase(),
          value: "RELATED_TO"
        }
      ]
    };
  },
  computed: {
    submitButtonEnabled() {
      return !!this.ticketSelected && !!this.relationSelected;
    },
    productIds() {
      const { productIds: s } = Ht(this.organization);
      return s.value;
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    updatedLink() {
      this.$emit("updated"), this.closeModal();
    },
    async addLinkButton() {
      const s = {
        source: {
          id: this.ticketId,
          class: "TICKET"
        },
        destination: {
          id: this.ticketSelected,
          class: "TICKET"
        },
        relation: this.relationSelected
      };
      await this.$api.link.addLink(s), this.$toast(
        this.$t("modal.ticketLinkingModal.toast-add-success").toString()
      ), this.updatedLink();
    }
  }
});
var IO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { on: { "click-outside": t.closeModal } }, [e("div", { staticClass: "modal-content" }, [e("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: t.closeModal } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), e("h2", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("modal.ticketLinkingModal.title")) + " ")]), e("p", { staticClass: "modal-description" }, [t._v(" " + t._s(t.$t("modal.ticketLinkingModal.description")) + " ")]), e("div", { staticClass: "dropdown-container" }, [e("app-singleselect", { staticClass: "relation-dropdown", attrs: { options: t.relationOptions, placeholder: t.$t("modal.ticketLinkingModal.relationPlaceholder") }, model: { value: t.relationSelected, callback: function(i) {
    t.relationSelected = i;
  }, expression: "relationSelected" } }), e("ticket-dropdown", { staticClass: "ticket-dropdown", attrs: { context: t.organization.context, "exclude-ticket-id": t.ticketId, placeholder: t.$t("modal.ticketLinkingModal.ticketPlaceholder"), "product-id": t.productId, products: t.productIds }, model: { value: t.ticketSelected, callback: function(i) {
    t.ticketSelected = i;
  }, expression: "ticketSelected" } })], 1), e("app-button-sheet", { staticClass: "buttons" }, [e("app-button", { attrs: { enabled: t.submitButtonEnabled, label: t.$t("common.add") }, on: { click: t.addLinkButton } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.closeModal } })], 1)], 1)]);
}, AO = [], PO = /* @__PURE__ */ f(
  TO,
  IO,
  AO,
  !1,
  null,
  "ae0b7913"
);
const OO = PO.exports, MO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LinkGroup: Uc,
  LinkItem: qc,
  LinkItemTicket: Lc,
  TicketLinkWidget: SO,
  TicketLinkingModal: OO
}, Symbol.toStringTag, { value: "Module" })), RO = g({
  name: "AvatarList",
  props: {
    users: {
      type: Array,
      required: !0
    },
    maxDisplay: {
      type: Number,
      default: 4
    }
  },
  computed: {
    displayUsers() {
      return this.users.slice(0, this.maxDisplay);
    },
    otherUserCount() {
      return `+${this.users.length - this.maxDisplay}`;
    }
  },
  methods: {
    getAvatar(s) {
      return s.avatar || "/img/profile-placeholder.svg";
    },
    displayName(s) {
      return E({ user: s }).displayName();
    }
  }
});
var EO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "avatar-list" }, [t._l(t.displayUsers, function(i) {
    return e("div", { key: i.id, staticClass: "avatar" }, [e("img", { staticClass: "user-avatar", attrs: { src: t.getAvatar(i), alt: t.displayName(i) } })]);
  }), t.users.length > t.maxDisplay ? e("div", { staticClass: "avatar other-users-count" }, [t._v(" " + t._s(t.otherUserCount) + " ")]) : t._e()], 2);
}, DO = [], FO = /* @__PURE__ */ f(
  RO,
  EO,
  DO,
  !1,
  null,
  "9b782353"
);
const LO = FO.exports, qO = g({
  name: "UserItemCard",
  props: {
    userData: {
      type: Object,
      required: !0
    }
  }
});
var UO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "user-item-card" }, [e("user-item", { attrs: { "user-data": t.userData } })], 1);
}, NO = [], BO = /* @__PURE__ */ f(
  qO,
  UO,
  NO,
  !1,
  null,
  "056d3cc6"
);
const jO = BO.exports, zO = g({
  props: {
    userData: {
      type: Object,
      required: !0
    }
  },
  computed: {
    avatar() {
      var s;
      return (s = this.userData.user) == null ? void 0 : s.avatar;
    },
    displayName() {
      return E(this.userData).displayName();
    },
    userDepartment() {
      return E(this.userData).userDepartment();
    }
  }
});
var VO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "user-card" }, [t.avatar ? e("img", { staticClass: "user-avatar", attrs: { src: t.avatar } }) : e("div", { staticClass: "user-avatar empty" }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fal fa-user" } })], 1), e("div", { staticClass: "user-name" }, [t._v(t._s(t.displayName))]), e("div", { staticClass: "unit-name" }, [t._v(t._s(t.userDepartment))])]);
}, HO = [], WO = /* @__PURE__ */ f(
  zO,
  VO,
  HO,
  !1,
  null,
  "75cab1d9"
);
const GO = WO.exports, Vo = "/img/profile-placeholder.svg", KO = g({
  props: {
    value: {
      type: [String, Array],
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    selectionMode: {
      type: String,
      default: "single"
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    filter: {
      type: Object,
      required: !1
    },
    excludeUserIds: {
      type: Array,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      optionsPool: [],
      selection: []
    };
  },
  async created() {
    if (this.value) {
      const s = Array.isArray(this.value) ? this.value : [this.value];
      this.loading = !0;
      const t = await this.$gateway.portal.findUsersById(s);
      this.optionsPool = t.map((e) => ({
        text: E(e).displayName(),
        value: e.user.id,
        image: e.user.avatar || Vo,
        description: E(e).userDepartment()
      })), this.selection = s, this.loading = !1;
    }
  },
  computed: {
    isSingleSelectionMode() {
      return this.selectionMode === "single";
    }
  },
  methods: {
    onUpdate(s) {
      let t = s;
      this.isSingleSelectionMode && (t = Array.isArray(s) ? s[0] : s), this.$emit("input", t);
    },
    onToggleOpen(s) {
      s || (this.options = [], this.$emit("blur"));
    },
    async onSearchDebounced(s) {
      var n, r, a;
      if (s.length < 3) {
        this.options = [];
        return;
      }
      this.loading = !0;
      const e = (await this.$gateway.search.searchUserIds({
        query: s,
        context: (n = this.filter) == null ? void 0 : n.context,
        filter: {
          teams: (r = this.filter) == null ? void 0 : r.teamIds,
          topics: (a = this.filter) == null ? void 0 : a.topicIds
        }
      })).filter(
        (o) => {
          var l;
          return !((l = this.excludeUserIds) != null && l.includes(o));
        }
      ), i = await this.$gateway.portal.findUsersById(e);
      this.options = i.filter(({ user: o }) => o.firstName || o.lastName).map((o) => ({
        text: E(o).displayName(),
        value: o.user.id,
        image: o.user.avatar || Vo,
        description: E(o).userDepartment()
      })), this.loading = !1;
    }
  }
});
var YO = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-dropdown", { attrs: { enabled: t.enabled, error: t.error, label: t.label, loading: t.loading, options: t.options, "options-pool": t.optionsPool, placeholder: t.placeholder, required: t.required, "selection-mode": t.selectionMode, tooltip: t.tooltip }, on: { "toggle-open": t.onToggleOpen, "update-single": t.onUpdate, "update-multiple": t.onUpdate }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [e("app-search-input", { staticClass: "inner-search", attrs: { "debounce-timeout": 500, placeholder: t.searchPlaceholder }, on: { debounced: t.onSearchDebounced } })];
  }, proxy: !0 }]), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } });
}, XO = [], ZO = /* @__PURE__ */ f(
  KO,
  YO,
  XO,
  !1,
  null,
  "7610ef2a"
);
const QO = ZO.exports, Ho = "/img/profile-placeholder.svg", JO = g({
  props: {
    value: {
      type: Array,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    filter: {
      type: Object,
      required: !1
    },
    excludeUserIds: {
      type: Array,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      optionsPool: [],
      selection: []
    };
  },
  async created() {
    if (this.value.length > 0) {
      this.loading = !0;
      const s = await this.$gateway.portal.findUsersById(this.value);
      this.optionsPool = s.map((t) => ({
        text: E(t).displayName(),
        value: t.user.id,
        image: t.user.avatar || Ho,
        description: E(t).userDepartment()
      })), this.selection = [...this.value], this.loading = !1;
    }
  },
  methods: {
    onUpdate(s) {
      this.$emit("input", s);
    },
    onToggleOpen(s) {
      s || (this.options = [], this.$emit("blur"));
    },
    async onSearchDebounced(s) {
      var n, r, a;
      if (s.length < 3) {
        this.options = [];
        return;
      }
      this.loading = !0;
      const e = (await this.$gateway.search.searchUserIds({
        query: s,
        context: (n = this.filter) == null ? void 0 : n.context,
        filter: {
          teams: (r = this.filter) == null ? void 0 : r.teamIds,
          topics: (a = this.filter) == null ? void 0 : a.topicIds
        }
      })).filter(
        (o) => {
          var l;
          return !((l = this.excludeUserIds) != null && l.includes(o));
        }
      ), i = await this.$gateway.portal.findUsersById(e);
      this.options = i.filter(({ user: o }) => o.firstName || o.lastName).map((o) => ({
        text: E(o).displayName(),
        value: o.user.id,
        image: o.user.avatar || Ho,
        description: E(o).userDepartment()
      })), this.loading = !1;
    }
  }
});
var tM = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-multiselect", { attrs: { error: t.error, label: t.label, loading: t.loading, options: t.options, "options-pool": t.optionsPool, placeholder: t.placeholder, required: t.required, tooltip: t.tooltip }, on: { "toggle-open": t.onToggleOpen, "update-multiple": t.onUpdate }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [e("app-search-input", { staticClass: "inner-search", attrs: { "debounce-timeout": 500, placeholder: t.searchPlaceholder }, on: { debounced: t.onSearchDebounced } })];
  }, proxy: !0 }]), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } });
}, eM = [], sM = /* @__PURE__ */ f(
  JO,
  tM,
  eM,
  !1,
  null,
  "956165af"
);
const iM = sM.exports, nM = g({
  components: { AppTextInput: O1 },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedTicket: "",
      title: "",
      description: ""
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.ticket.bulkInspirePeople(
          this.productId,
          {
            campaignCanonicalId: this.selectedTicket,
            ticketSuggestion: {
              title: this.title,
              description: this.description
            },
            audience: this.selection
          }
        )).id;
      } catch (s) {
        console.error("Could not execute bulk action", s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const s = await this.executeBulkAction();
      this.$emit("confirm", s);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var rM = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [e("fa-icon-compat", { staticClass: "ai-icon", attrs: { icon: "fa-solid fa-sparkles" } }), t._v(" " + t._s(t.$t("bulkActions.actions.inspireUsers")) + " ")], 1), e("app-text-input", { attrs: { label: t.$t("bulkActions.inspireUsersModal.title"), placeholder: t.$t("bulkActions.inspireUsersModal.titlePlaceholder") }, model: { value: t.title, callback: function(i) {
    t.title = i;
  }, expression: "title" } }), e("app-text-area", { attrs: { label: t.$t("bulkActions.inspireUsersModal.description"), placeholder: t.$t("bulkActions.inspireUsersModal.descriptionPlaceholder") }, model: { value: t.description, callback: function(i) {
    t.description = i;
  }, expression: "description" } }), e("ticket-dropdown", { attrs: { context: t.contextId, label: t.$t("bulkActions.inspireUsersModal.campaign"), "product-id": t.productId, products: ["campaign"], placeholder: t.$t("bulkActions.setCampaignModal.placeholder"), required: !0 }, model: { value: t.selectedTicket, callback: function(i) {
    t.selectedTicket = i;
  }, expression: "selectedTicket" } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { label: t.$t("common.form.confirm"), enabled: !!t.selectedTicket }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, aM = [], oM = /* @__PURE__ */ f(
  nM,
  rM,
  aM,
  !1,
  null,
  "33e5f1aa"
);
const lM = oM.exports, cM = g({
  props: {
    selection: {
      type: Array,
      required: !0
    },
    action: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      allRoles: [],
      selectedRoles: []
    };
  },
  async created() {
    await this.fetchAvailableRoles();
  },
  computed: {
    title() {
      const s = this.action === "ADD" ? "addUserRoles" : "removeUserRoles";
      return this.$t(`bulkActions.actions.${s}`).toString();
    },
    roleOptions() {
      return this.allRoles.map((s) => {
        var e;
        return {
          description: `${((e = s == null ? void 0 : s.roleActions) == null ? void 0 : e.length) || 0} actions`,
          text: s.name,
          value: s.name
        };
      });
    }
  },
  methods: {
    async fetchAvailableRoles() {
      this.loading = !0;
      try {
        this.allRoles = await this.$api.role.adminFetchAllRoles();
      } catch (s) {
        console.warn(s), this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1;
      }
    },
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.users.bulkUpdateUserRoles(
          this.selectedRoles,
          this.selection,
          this.action
        )).id;
      } catch (s) {
        console.error("Could not execute bulk action", s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const s = await this.executeBulkAction();
      this.$emit("confirm", s);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var uM = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.title) + " ")]), e("app-multiselect", { attrs: { label: t.$t("form.roles.label"), options: t.roleOptions, placeholder: t.$t("form.roles.placeholder"), "search-enabled": !0, "search-label": t.$t("common.form.search") }, model: { value: t.selectedRoles, callback: function(i) {
    t.selectedRoles = i;
  }, expression: "selectedRoles" } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { label: t.$t("common.form.confirm"), enabled: !!t.selectedRoles.length }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, dM = [], pM = /* @__PURE__ */ f(
  cM,
  uM,
  dM,
  !1,
  null,
  "03b3c219"
);
const hM = pM.exports, fM = g({
  props: {
    selection: {
      type: Array,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      teamConfiguration: {
        class: "team",
        types: ["ORGANIZATIONAL_TEAM", "VIRTUAL_TEAM", "WORKGROUP"],
        operations: ["select"]
      },
      teamIds: []
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.team.bulkAddUserToTeam(
          this.teamIds[0],
          this.selection
        )).id;
      } catch (s) {
        console.error("Could not execute bulk action", s);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const s = await this.executeBulkAction();
      this.$emit("confirm", s);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var mM = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading } }, [e("div", { staticClass: "modal-content" }, [e("div", { staticClass: "modal-title" }, [t._v(" " + t._s(t.$t("bulkActions.actions.addUserToTeam")) + " ")]), e("team-selector", { attrs: { configuration: t.teamConfiguration, organization: t.organization, label: t.$t("form.selectTeam.label"), placeholder: t.$t("form.selectTeam.placeholder"), required: !0 }, model: { value: t.teamIds, callback: function(i) {
    t.teamIds = i;
  }, expression: "teamIds" } }), e("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e("app-button", { attrs: { label: t.$t("common.form.confirm"), enabled: !!t.teamIds.length }, on: { click: t.onConfirm } }), e("app-secondary-button", { attrs: { label: t.$t("common.form.cancel") }, on: { click: t.onCancel } })], 1)], 1)]);
}, gM = [], _M = /* @__PURE__ */ f(
  fM,
  mM,
  gM,
  !1,
  null,
  "74edfb72"
);
const yM = _M.exports, bM = g({
  components: {
    BulkModalManageUserRoles: hM,
    BulkModalAddUserToTeam: yM,
    BulkModalInspireUsers: lM,
    BulkModalExportData: Mc,
    BulkModalResults: Rc
  },
  props: {
    value: {
      type: String,
      required: !1
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  watch: {
    value(s) {
      this.bulkAction = s;
    }
  },
  data() {
    return {
      bulkAction: void 0,
      bulkId: void 0
    };
  },
  created() {
    this.bulkAction = this.value;
  },
  methods: {
    componentType(s) {
      switch (s) {
        case "exportData":
          return "bulk-modal-export-data";
        case "inspireUsers":
          return "bulk-modal-inspire-users";
        case "addUserRoles":
        case "removeUserRoles":
          return "bulk-modal-manage-user-roles";
        case "addUserToTeam":
          return "bulk-modal-add-user-to-team";
        default:
          return "";
      }
    },
    getActionType(s) {
      switch (s) {
        case "addUserRoles":
          return "ADD";
        case "removeUserRoles":
          return "REMOVE";
        default:
          return;
      }
    },
    onConfirm(s) {
      this.bulkId = s, this.bulkAction = void 0;
    },
    onCancel() {
      this.bulkId = void 0, this.bulkAction = void 0, this.$emit("input", void 0);
    }
  }
});
var vM = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "container" }, [e(t.componentType(t.bulkAction), t._g({ tag: "component", attrs: { action: t.getActionType(t.bulkAction), "context-id": t.contextId, organization: t.organization, "product-id": t.productId, selection: t.selection }, on: { cancel: t.onCancel, confirm: t.onConfirm } }, t.$listeners)), t.bulkId ? e("bulk-modal-results", { attrs: { "bulk-id": t.bulkId }, on: { close: t.onCancel } }) : t._e()], 1);
}, kM = [], xM = /* @__PURE__ */ f(
  bM,
  vM,
  kM,
  !1,
  null,
  null
);
const CM = xM.exports, wM = g({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      selected: ""
    };
  },
  computed: {
    filteredOptions() {
      return this.options.filter(({ availabilityCheck: s }) => s !== !1).filter(
        ({ requiredAction: s }) => !s || this.checkPermission(s)
      ).map(({ option: s }) => s);
    },
    options() {
      return [
        {
          requiredAction: "ADMIN_EXPORT_USERS",
          option: {
            value: "exportData",
            text: this.$t("bulkActions.actions.exportData").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_USER_ROLES_UPDATE",
          option: {
            value: "addUserRoles",
            text: this.$t("bulkActions.actions.addUserRoles").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_USER_ROLES_UPDATE",
          option: {
            value: "removeUserRoles",
            text: this.$t("bulkActions.actions.removeUserRoles").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_USER_TEAM_UPDATE",
          option: {
            value: "addUserToTeam",
            text: this.$t("bulkActions.actions.addUserToTeam").toString()
          }
        },
        {
          requiredAction: "USER_AI_GENERATION",
          availabilityCheck: this.enableInspirePeople,
          option: {
            value: "inspireUsers",
            text: this.$t("bulkActions.actions.inspireUsers").toString()
          }
        }
      ];
    },
    enableInspirePeople() {
      var s;
      return !!(this.organization.productCustomization[this.productId].enableAiContentGeneration && ((s = this.organization.settings) != null && s.inspirePeople));
    }
  },
  methods: {
    checkPermission(s) {
      const t = `${this.productId.toUpperCase()}_${s}`;
      return this.userActions.checkPermission([t, s]);
    },
    onUpdateSingle(s) {
      s && this.$emit("select-action", s), pe(() => {
        this.selected = "";
      });
    }
  }
});
var $M = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-singleselect", { attrs: { options: t.filteredOptions, placeholder: t.$t("bulkActions.selectAction"), "search-enabled": !0, "search-label": t.$t("form.search.placeholder") }, on: { "update-single": t.onUpdateSingle }, model: { value: t.selected, callback: function(i) {
    t.selected = i;
  }, expression: "selected" } });
}, SM = [], TM = /* @__PURE__ */ f(
  wM,
  $M,
  SM,
  !1,
  null,
  null
);
const IM = TM.exports, AM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UserAvatarList: LO,
  UserBulkActionsContainer: CM,
  UserBulkActionsDropdown: IM,
  UserCard: GO,
  UserDropdown: QO,
  UserItem: Ei,
  UserItemCard: jO,
  UserMultiselect: iM,
  UserSelectionInput: Di,
  UserSelectionModal: cr
}, Symbol.toStringTag, { value: "Module" })), PM = g({
  name: "ModalLauncher",
  props: {
    type: {
      type: String,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userId: {
      type: String,
      required: !0
    }
  },
  computed: {
    modalType() {
      switch (this.type) {
        case "multi-question":
          return "MultiQuestionModal";
        case "rating":
        case "review":
          return "ReviewModal";
      }
      return "BasicModal";
    }
  },
  methods: {
    closeModal() {
      this.$modalClose();
    }
  }
});
var OM = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e(t.modalType, { tag: "component", attrs: { resource: t.content, "context-id": t.contextId, "product-id": t.productId, "user-id": t.userId }, on: { close: t.closeModal } });
}, MM = [], RM = /* @__PURE__ */ f(
  PM,
  OM,
  MM,
  !1,
  null,
  null
);
const EM = RM.exports, DM = g({
  components: { AppMarkdownText: Et },
  props: {
    notification: {
      type: Object,
      required: !0
    }
  },
  computed: {
    notificationResource() {
      const s = JSON.parse(this.notification.body);
      return this.$res(s);
    },
    isUnread() {
      return !this.notification.readAt;
    },
    image() {
      return this.notificationResource.imageUrl ?? "/img/comment-notification-icon.svg";
    },
    type() {
      return this.notification.contentType ?? "";
    },
    title() {
      return this.notificationResource.title ?? "";
    },
    description() {
      return this.notificationResource.text ?? "";
    },
    date() {
      return new Date(this.notification.createdAt).toLocaleDateString();
    }
  },
  methods: {
    onDelete() {
      this.$emit("delete", this.notification);
    }
  }
});
var FM = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "notification-item" }, [t.image ? e("img", { staticClass: "item-image", attrs: { src: t.image } }) : t._e(), e("div", { staticClass: "content" }, [e("div", { staticClass: "item-title" }, [t._v(" " + t._s(t.title) + " ")]), t.description ? e("app-markdown-text", { staticClass: "item-description", attrs: { text: t.description } }) : t._e(), t.date ? e("div", { staticClass: "item-date" }, [t._v(" " + t._s(t.date) + " ")]) : t._e()], 1), e("div", { staticClass: "controls" }, [e("app-icon-button", { staticClass: "close", attrs: { size: 24 }, on: { "~click": function(i) {
    return i.preventDefault(), i.stopPropagation(), t.onDelete.apply(null, arguments);
  } } }, [e("fa-icon-compat", { attrs: { icon: "fa-regular fa-xmark" } })], 1), t.isUnread ? e("div", { staticClass: "indicator" }, [e("fa-icon-compat", { staticClass: "unread-icon", attrs: { icon: "fa-solid fa-circle" } })], 1) : t._e()], 1)]);
}, LM = [], qM = /* @__PURE__ */ f(
  DM,
  FM,
  LM,
  !1,
  null,
  "a4cac3e6"
);
const UM = qM.exports, NM = g({
  name: "MultipleChoiceInput",
  components: { AppMarkdownText: Et },
  props: {
    value: {
      type: [Array, String, Number],
      default: () => []
    },
    selectionType: {
      type: String,
      default: "single"
    },
    layout: {
      type: String,
      default: "vertical"
    },
    columns: {
      type: Number,
      default: 2
    },
    options: {
      type: Array,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    value: {
      handler() {
        this.selectionType === "single" ? this.singleAnswer = this.value[0] : this.answer = this.value;
      },
      immediate: !0
    }
  },
  data() {
    return {
      answer: [],
      singleAnswer: ""
    };
  },
  computed: {
    alignment() {
      return this.layout === "horizontal" ? "row" : "column";
    }
  },
  methods: {
    updateValue(s) {
      this.answer = Array.isArray(s) ? s : [s], this.$emit("input", this.answer);
    }
  }
});
var BM = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "multiple-choice-input" }, [e("div", { staticClass: "title" }, [t._v(" " + t._s(t.label) + " ")]), t.description ? e("app-markdown-text", { staticClass: "description", attrs: { text: t.description } }) : t._e(), e("div", { staticClass: "multiple-choice", class: t.alignment }, [t.selectionType === "multiple" ? e("app-checkbox-group", { attrs: { alignment: t.alignment, error: t.error, options: t.options }, on: { input: t.updateValue }, model: { value: t.answer, callback: function(i) {
    t.answer = i;
  }, expression: "answer" } }) : e("app-radio-buttons", { attrs: { alignment: t.alignment, error: t.error, options: t.options }, on: { input: t.updateValue }, model: { value: t.singleAnswer, callback: function(i) {
    t.singleAnswer = i;
  }, expression: "singleAnswer" } })], 1)], 1);
}, jM = [], zM = /* @__PURE__ */ f(
  NM,
  BM,
  jM,
  !1,
  null,
  "b81d8c53"
);
const VM = zM.exports, HM = g({
  components: {
    AppMarkdownText: Et,
    AppLabelValue: lr
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    values: {
      type: Array,
      default: () => []
    },
    valueImageUrl: {
      type: String,
      default: "/img/star.svg"
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    value: {
      handler() {
        this.hoverRating = this.value, this.rating = this.value;
      },
      immediate: !0
    }
  },
  data() {
    return {
      rating: 0,
      hoverRating: 0
    };
  },
  computed: {
    totalRatings() {
      return this.values.length;
    }
  },
  methods: {
    setRating(s) {
      this.rating = s, this.$emit("input", this.rating);
    }
  }
});
var WM = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("base-input-label", { staticClass: "label", attrs: { error: t.error, label: t.label } }), t.description ? e("app-markdown-text", { staticClass: "description", attrs: { text: t.description } }) : t._e(), t.error ? e("div", { staticClass: "rating-error" }, [t._v(" " + t._s(t.$t("error.voteIsRequired")) + " ")]) : t._e(), e("div", { staticClass: "review-rating" }, t._l(t.totalRatings, function(i) {
    return e("img", { key: i, staticClass: "rating-img", class: { selected: i <= t.hoverRating }, attrs: { src: t.valueImageUrl }, on: { click: function(n) {
      return t.setRating(i);
    }, mouseenter: function(n) {
      t.hoverRating = i;
    }, mouseleave: function(n) {
      t.hoverRating = t.rating;
    } } });
  }), 0)], 1);
}, GM = [], KM = /* @__PURE__ */ f(
  HM,
  WM,
  GM,
  !1,
  null,
  "2ced4e4e"
);
const Nc = KM.exports, YM = g({
  components: { AppMarkdownText: Et },
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    value: {
      handler() {
        this.answer = this.value;
      },
      immediate: !0
    }
  },
  data() {
    return {
      answer: ""
    };
  }
});
var XM = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "text-input" }, [e("div", { staticClass: "title" }, [t._v(" " + t._s(t.label) + " ")]), t.description ? e("app-markdown-text", { staticClass: "description", attrs: { text: t.description } }) : t._e(), e("app-text-area", { attrs: { error: t.error, placeholder: t.$t("common.enterYourReply"), required: !0, rows: 6 }, on: { input: () => t.$emit("input", t.answer) }, model: { value: t.answer, callback: function(i) {
    t.answer = i;
  }, expression: "answer" } })], 1);
}, ZM = [], QM = /* @__PURE__ */ f(
  YM,
  XM,
  ZM,
  !1,
  null,
  "85da021c"
);
const JM = QM.exports, tR = g({
  name: "QuestionWizard",
  props: {
    steps: {
      type: Array,
      required: !0
    },
    validation: {
      type: Function,
      default: () => (console.warn("No validation function provided"), !0)
    }
  },
  data() {
    return {
      currentStep: 0
    };
  },
  computed: {
    item() {
      return this.steps[this.currentStep];
    },
    isLastStep() {
      return this.currentStep === this.steps.length - 1;
    },
    isFirstStep() {
      return this.currentStep === 0;
    },
    nextButtonLabel() {
      const s = this.isLastStep ? "finish" : "continue";
      return this.$t(`common.${s}`).toString();
    }
  },
  methods: {
    nextStep() {
      this.validation(this.currentStep + 1) && !this.isLastStep ? this.currentStep++ : this.validation(this.currentStep + 1) && this.$emit("finish");
    },
    previousStep() {
      this.currentStep > 0 && this.currentStep--;
    }
  }
});
var eR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "question-wizard" }, [e("div", { staticClass: "steps" }, t._l(t.steps, function(i, n) {
    return e("div", { key: n, staticClass: "step", class: {
      active: n === t.currentStep,
      done: n <= t.currentStep
    } }, [e("span", { staticClass: "current-step" }, [t._v(t._s(n + 1))])]);
  }), 0), e("div", { staticClass: "content" }, [t._t("default", null, { item: t.item })], 2), e("div", { staticClass: "button-container", class: { "justify-end": t.isFirstStep } }, [t.isFirstStep ? t._e() : e("app-icon-button", { staticClass: "back-button", attrs: { size: 48, frame: "square" }, on: { click: t.previousStep } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-chevron-left" } })], 1), e("app-button", { class: { "justify-end": t.isFirstStep }, attrs: { label: t.nextButtonLabel }, on: { click: t.nextStep } })], 1)]);
}, sR = [], iR = /* @__PURE__ */ f(
  tR,
  eR,
  sR,
  !1,
  null,
  "f0605691"
);
const nR = iR.exports, rR = g({
  components: { AppMarkdownText: Et },
  props: {
    resource: {
      type: Object,
      required: !0
    },
    buttonAction: {
      type: Function,
      required: !1
    },
    centerContent: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    buttonComponent() {
      var s;
      return ((s = this.resource.button) == null ? void 0 : s.style) === "secondary" ? "app-secondary-button" : "app-button";
    },
    buttonLabel() {
      var s;
      return ((s = this.resource.button) == null ? void 0 : s.label) ?? "";
    },
    imageSrc() {
      return this.resource.modalImageUrl ?? "";
    },
    title() {
      return this.resource.modalTitle ?? this.resource.title;
    },
    tagline() {
      return this.resource.tagline ?? "";
    },
    description() {
      return this.resource.description ?? this.resource.text ?? "";
    }
  },
  methods: {
    buttonPressed() {
      var s, t, e;
      this.buttonAction ? this.buttonAction() : ((t = (s = this.resource.button) == null ? void 0 : s.action) != null && t.fetch && this.apiCall(this.resource.button.action.fetch), (e = this.resource.button) != null && e.url && window.open(this.resource.button.url, "_blank"), this.$emit("close"));
    },
    apiCall({ url: s, method: t, body: e }) {
      fetch(s, {
        method: t,
        body: e
      });
    }
  }
});
var aR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "basic-content", class: { centerContent: t.centerContent } }, [t.resource.modalType ? e("app-markdown-text", { staticClass: "basic-type", attrs: { text: t.resource.modalType } }) : t._e(), t.imageSrc ? e("img", { staticClass: "basic-image", attrs: { src: t.imageSrc } }) : t._e(), e("div", [e("div", { staticClass: "basic-title", attrs: { title: t.title } }, [t._v(" " + t._s(t.title) + " ")]), t.tagline ? e("div", { staticClass: "basic-subtitle", attrs: { title: t.tagline } }, [t._v(" " + t._s(t.tagline) + " ")]) : t._e()]), e("app-markdown-text", { staticClass: "basic-description", attrs: { text: t.description } }), t._t("default"), t.buttonLabel ? e("div", { staticClass: "button-container", class: { centerContent: t.centerContent } }, [e(t.buttonComponent, { tag: "component", staticClass: "basic-button", attrs: { label: t.buttonLabel }, on: { click: t.buttonPressed } })], 1) : t._e(), t.resource.link ? e("app-link", { staticClass: "link", attrs: { "external-path": t.resource.link.url, label: t.resource.link.label, target: "_blank" } }) : t._e()], 2);
}, oR = [], lR = /* @__PURE__ */ f(
  rR,
  aR,
  oR,
  !1,
  null,
  "585e63f3"
);
const Bc = lR.exports, cR = g({
  components: {
    TextInput: JM,
    RatingInput: Nc,
    MultipleChoiceInput: VM,
    TicketBreadcrumb: kc,
    QuestionWizard: nR,
    BasicContent: Bc
  },
  props: {
    resource: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      answers: {},
      errors: {},
      loading: !1,
      showQuestions: !1,
      showIntro: !0,
      ticket: null
    };
  },
  async created() {
    this.resource.ticketId && (this.ticket = await this.$datasource.ticket.find(
      this.productId,
      this.resource.ticketId
    ), this.setInitialAnswers());
  },
  computed: {
    questionsWithIndexes() {
      var s;
      return (s = this.resource.questions) == null ? void 0 : s.map((t) => {
        var i;
        const e = (i = t.options) == null ? void 0 : i.map(
          (n, r) => ({
            ...n,
            value: r,
            actualValue: n.value
          })
        );
        return {
          ...t,
          options: e
        };
      });
    },
    modalResource() {
      return {
        ...this.resource,
        button: { label: this.$t("common.start").toString() }
      };
    }
  },
  methods: {
    setInitialAnswers() {
      var s;
      this.answers = (s = this.resource.questions) == null ? void 0 : s.reduce(
        (t, { id: e, options: i, type: n }) => {
          var o, l, c;
          const r = (c = (l = (o = this.ticket) == null ? void 0 : o.userFields) == null ? void 0 : l[e]) == null ? void 0 : c[this.userId], a = (r == null ? void 0 : r.contentIndexes) ?? (i == null ? void 0 : i.findIndex(
            ({ value: u }) => u == (r == null ? void 0 : r.content)
          )) ?? -1;
          return a === -1 ? t[e] = r == null ? void 0 : r.content : t[e] = Array.isArray(a) ? a : [a], t;
        },
        this.answers
      );
    },
    prepareAnswerPayload(s) {
      var t;
      return (t = this.resource.questions) == null ? void 0 : t.reduce(
        (e, { id: i, options: n, type: r }) => {
          if (r === "multiple-choice") {
            if (s[i] !== void 0) {
              const a = s[i].map(
                (l) => Number(l)
              );
              e.contentIndexes[i] = a;
              const o = Object.values(n);
              e.content[i] = a.map(
                (l) => o[l].value
              );
            }
          } else
            e.content[i] = s[i];
          return e;
        },
        { content: {}, contentIndexes: {} }
      );
    },
    startQuestions() {
      this.showIntro = !1, this.showQuestions = !0;
    },
    questionComponent(s) {
      switch (s) {
        case "rating":
          return "rating-input";
        case "multiple-choice":
          return "multiple-choice-input";
        case "text":
          return "text-input";
        default:
          return "text-input";
      }
    },
    isValid(s) {
      let t = !1;
      const e = {};
      return this.resource.questions.slice(0, s ?? this.resource.questions.length).forEach(({ id: i, required: n }) => {
        e[i] = !this.answers[i] && // Required is true by default
        n !== !1, t = t || e[i];
      }), this.$set(this, "errors", e), !t;
    },
    async saveAnswers() {
      var t, e;
      if (!this.isValid(2))
        return;
      this.showQuestions = !1, (e = (t = this.resource.button) == null ? void 0 : t.action) != null && e.fetch && await this.apiCall(this.resource.button.action.fetch);
      const s = this.resource.response;
      s ? this.$modal("basic", s) : this.onClose();
    },
    async apiCall({ url: s, method: t }) {
      var e, i, n, r, a, o;
      try {
        this.loading = !0;
        const l = this.prepareAnswerPayload(this.answers), c = {
          group: (e = this.resource) == null ? void 0 : e.group,
          audience: (i = this.resource) == null ? void 0 : i.audience
        };
        await this.$api.dynamicFields.callCustomUrl(
          s,
          t,
          l,
          c
        ), this.$datasource.ticket.clearCache([
          (n = this.ticket) == null ? void 0 : n.canonicalId,
          (r = this.ticket) == null ? void 0 : r.parent
        ]), this.$datasource.firstCitizen.clearCache([(a = this.ticket) == null ? void 0 : a.parent]), this.$datasource.adminFirstCitizen.clearCache([(o = this.ticket) == null ? void 0 : o.parent]);
      } catch (l) {
        this.$sentry.captureException(l), l.message ? this.$toast(l.message) : this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1;
      }
    },
    onClose() {
      this.$emit("close");
    }
  }
});
var uR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading }, on: { "click-outside": t.onClose } }, [e("div", { staticClass: "basic-container" }, [e("app-icon-button", { staticClass: "close-button", attrs: { size: 26 }, on: { click: t.onClose } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), t.ticket ? e("ticket-breadcrumb", { attrs: { "context-id": t.contextId, "product-id": t.productId, ticket: t.ticket } }) : t._e(), t.showIntro ? e("basic-content", { staticClass: "multi-question-modal", attrs: { "button-action": t.startQuestions, resource: t.modalResource }, on: { close: t.onClose } }) : t._e(), t.showQuestions ? e("question-wizard", { staticClass: "wizard", attrs: { steps: t.questionsWithIndexes, validation: t.isValid }, on: { finish: t.saveAnswers }, scopedSlots: t._u([{ key: "default", fn: function({ item: i }) {
    return [e(t.questionComponent(i.type), t._b({ key: i.id, tag: "component", attrs: { error: t.errors[i.id] }, model: { value: t.answers[i.id], callback: function(n) {
      t.$set(t.answers, i.id, n);
    }, expression: "answers[question.id]" } }, "component", i, !1))];
  } }], null, !1, 2106226971) }) : t._e()], 1)]);
}, dR = [], pR = /* @__PURE__ */ f(
  cR,
  uR,
  dR,
  !1,
  null,
  "ca621bf6"
);
const hR = pR.exports, fR = g({
  components: { RatingInput: Nc },
  props: {
    resource: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      rating: 0,
      loading: !1,
      showRatingError: !1
    };
  },
  computed: {
    allRatings() {
      return this.resource.options.map((s) => s.values).flat();
    },
    ratingImg() {
      return this.resource.options[0].valueImageUrl;
    }
  },
  methods: {
    async saveRating() {
      var t, e;
      if (this.rating === 0) {
        this.showRatingError = !0;
        return;
      }
      this.showRatingError = !1, (e = (t = this.resource.button) == null ? void 0 : t.action) != null && e.fetch && await this.apiCall(this.resource.button.action.fetch);
      const s = this.findRatingModal(this.resource);
      s ? this.$modal("basic", s) : this.onClose();
    },
    findRatingModal(s) {
      const t = this.rating - 1, e = s.options.find(({ values: i }) => i.includes(this.allRatings[t]));
      return e == null ? void 0 : e.response;
    },
    async apiCall({ url: s, method: t, body: e }) {
      var i;
      try {
        this.loading = !0;
        const n = (e == null ? void 0 : e.replace(/{{VALUE}}/g, this.rating.toString())) ?? "", r = JSON.parse(n), a = (i = this.resource) != null && i.group ? { group: this.resource.group } : {};
        await this.$api.dynamicFields.callCustomUrl(
          s,
          t,
          r,
          a
        ), this.loading = !1;
      } catch (n) {
        this.$sentry.captureException(n), n.message ? this.$toast(n.message) : this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1;
      }
    },
    onClose() {
      this.$emit("close");
    }
  }
});
var mR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("basic-modal", { attrs: { "button-action": t.saveRating, "center-content": !1, loading: t.loading, resource: t.resource }, on: { close: t.onClose } }, [e("rating-input", { attrs: { error: t.showRatingError, "value-image-url": t.ratingImg, values: t.allRatings }, model: { value: t.rating, callback: function(i) {
    t.rating = i;
  }, expression: "rating" } })], 1);
}, gR = [], _R = /* @__PURE__ */ f(
  fR,
  mR,
  gR,
  !1,
  null,
  null
);
const yR = _R.exports, bR = g({
  components: {
    AppMarkdownText: Et,
    BasicContent: Bc
  },
  props: {
    resource: {
      type: Object,
      required: !0
    },
    buttonAction: {
      type: Function,
      required: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    centerContent: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    onClose() {
      this.$router.replace({ query: { reload: "true" } }), this.$emit("close");
    }
  }
});
var vR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-modal", { attrs: { loading: t.loading }, on: { "click-outside": t.onClose } }, [e("div", { staticClass: "basic-container", class: { centerContent: t.centerContent } }, [e("app-icon-button", { staticClass: "close-button", attrs: { size: 26 }, on: { click: t.onClose } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), e("basic-content", { attrs: { "button-action": t.buttonAction, "center-content": t.centerContent, resource: t.resource }, on: { close: t.onClose } }, [t._t("default")], 2)], 1)]);
}, kR = [], xR = /* @__PURE__ */ f(
  bR,
  vR,
  kR,
  !1,
  null,
  "c028bd12"
);
const CR = xR.exports, wR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BasicModal: CR,
  ModalLauncher: EM,
  MultiQuestionModal: hR,
  NotificationItem: UM,
  ReviewModal: yR
}, Symbol.toStringTag, { value: "Module" })), $R = g({
  props: {
    offer: {
      type: Object,
      required: !0
    },
    workgroup: {
      type: Object,
      required: !0
    },
    showProvider: {
      type: Boolean,
      default: !0
    },
    showPrice: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    image() {
      return this.$res(this.offer.resources).image;
    },
    title() {
      return this.$res(this.offer.resources).title;
    },
    label() {
    },
    subtitle() {
      const s = Ot(this.workgroup, this.$res).teamName();
      return this.$t("common.byName", { name: s }).toString();
    },
    price() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "auto",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.offer.price ?? 0);
    }
  }
});
var SR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "offer-card" }, [e("img", { staticClass: "app-image", attrs: { src: t.image } }), e("div", { staticClass: "content" }, [e("div", { staticClass: "offer-title" }, [t._v(t._s(t.title))]), t.showProvider ? e("div", { staticClass: "offer-subtitle" }, [t._v(t._s(t.subtitle))]) : t._e(), e("div", { staticClass: "spacer" }), e("div", { staticClass: "card-bottom" }, [t.showPrice ? e("div", { staticClass: "offer-price" }, [t._v(" " + t._s(t.price) + " ")]) : t._e(), t.label ? e("app-pill", { staticClass: "offer-label", attrs: { label: t.label, color: "var(--offer-pill-colour)" } }) : t._e()], 1)])]);
}, TR = [], IR = /* @__PURE__ */ f(
  $R,
  SR,
  TR,
  !1,
  null,
  "8bb591bb"
);
const AR = IR.exports, PR = g({
  props: {
    offer: {
      type: Object,
      required: !0
    },
    workgroup: {
      type: Object,
      required: !0
    },
    showProvider: {
      type: Boolean,
      default: !0
    },
    showPrice: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    image() {
      return this.$res(this.offer.resources).image;
    },
    title() {
      return this.$res(this.offer.resources).title;
    },
    label() {
      return this.$t("page.admin.services.highlightedOffer").toString();
    },
    subtitle() {
      const s = Ot(this.workgroup, this.$res).teamName();
      return this.$t("common.byName", { name: s }).toString();
    },
    price() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "auto",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.offer.price ?? 0);
    }
  }
});
var OR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "offer-card-highlighted" }, [e("img", { staticClass: "app-image", attrs: { src: t.image } }), e("div", { staticClass: "content" }, [e("div", { staticClass: "card-top" }, [e("div", { staticClass: "offer-title" }, [t._v(t._s(t.title))]), t.showProvider ? e("div", { staticClass: "offer-subtitle" }, [t._v(t._s(t.subtitle))]) : t._e(), t.showPrice ? e("div", { staticClass: "offer-price" }, [t._v(" " + t._s(t.price))]) : t._e()]), e("div", { staticClass: "card-bottom" }, [t.label ? e("app-pill", { staticClass: "offer-label", attrs: { label: t.label, color: "var(--offer-pill-colour)" } }) : t._e()], 1)])]);
}, MR = [], RR = /* @__PURE__ */ f(
  PR,
  OR,
  MR,
  !1,
  null,
  "f9028b7a"
);
const ER = RR.exports, DR = g({
  props: {
    offer: {
      type: Object,
      required: !0
    },
    workgroup: {
      type: Object,
      required: !0
    },
    buttonLabel: {
      type: String,
      required: !0
    }
  },
  computed: {
    offerResources() {
      return this.$res(this.offer.resources);
    },
    priceDisplay() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "auto",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.offer.price);
    },
    workgroupName() {
      return Ot(this.workgroup, this.$res).teamName();
    }
  },
  methods: {
    onClickPurchase() {
      this.$emit("click:purchase", this.offer.id);
    }
  }
});
var FR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "offer-detail-header" }, [e("div", { staticClass: "offer-image" }, [e("app-image", { staticClass: "app-image", attrs: { ratio: 16 / 9, src: t.offerResources.image, fallback: "/img/offer-image-empty.svg", height: "240px", type: "rounded", width: "410px" } })], 1), e("div", { staticClass: "header-content" }, [e("div", [e("div", { staticClass: "offer-title" }, [t._v(t._s(t.offerResources.title))]), t.workgroup ? e("div", { staticClass: "offer-subtitle" }, [e("span", [t._v(t._s(t.$t("common.by")) + " " + t._s(t.workgroupName))])]) : t._e()]), e("div", { staticClass: "offer-price-container" }, [e("label", { staticClass: "offer-price-label" }, [t._v(" " + t._s(t.$t("page.services.details.price")) + " ")]), e("label", { staticClass: "offer-price" }, [t._v(t._s(t.priceDisplay))])]), e("app-button", { staticClass: "purchase-button", attrs: { label: t.buttonLabel }, on: { click: t.onClickPurchase } })], 1)]);
}, LR = [], qR = /* @__PURE__ */ f(
  DR,
  FR,
  LR,
  !1,
  null,
  "65a72f8d"
);
const UR = qR.exports, NR = g({
  props: {
    enabled: {
      type: Boolean,
      default: !0
    },
    selectionStatus: {
      type: String,
      default: "no"
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    },
    checked() {
      return this.selectionStatus !== "no";
    },
    mark() {
      return this.selectionStatus === "partial" ? "partial" : "full";
    }
  },
  methods: {
    onClick(s) {
      this.$emit("click", s);
    }
  }
});
var BR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("button", { staticClass: "data-control-checkbox", attrs: { disabled: t.disabled }, on: { click: t.onClick } }, [e("base-checkmark", { attrs: { enabled: t.enabled, checked: t.checked, mark: t.mark } })], 1);
}, jR = [], zR = /* @__PURE__ */ f(
  NR,
  BR,
  jR,
  !1,
  null,
  "77e5b11d"
);
const Rs = zR.exports, VR = g({
  components: {
    DataControlCheckbox: Rs
  },
  props: {
    selection: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      required: !0
    }
  },
  setup(s) {
    const { data: t, selection: e } = Pe(s), { selectionStatus: i, countFound: n, countSelected: r } = Mi(
      t,
      e
    );
    return { selectionStatus: i, countFound: n, countSelected: r };
  },
  computed: {
    buttonSelectAll() {
      return this.config.mode === "multiple" && this.config.selectAllButton;
    },
    foundLabel() {
      return this.$tc("common.resultsFound", this.countFound, {
        countFound: this.countFound
      }).toString();
    },
    selectionLabel() {
      return this.$t("common.resultsSelected", {
        countSelected: this.countSelected,
        countFound: this.countFound
      }).toString();
    }
  },
  methods: {
    onToggleSelectAll() {
      this.$emit("select-all");
    }
  }
});
var HR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "data-control-summary" }, [t.buttonSelectAll ? e("data-control-checkbox", { attrs: { "selection-status": t.selectionStatus }, on: { click: t.onToggleSelectAll } }) : t._e(), t.selectionStatus === "no" ? e("div", [t._v(t._s(t.foundLabel))]) : e("div", [t._v(t._s(t.selectionLabel))])], 1);
}, WR = [], GR = /* @__PURE__ */ f(
  VR,
  HR,
  WR,
  !1,
  null,
  "54a8b129"
);
const pr = GR.exports, KR = g({
  components: {
    DataControlCheckbox: Rs
  },
  props: {
    selectionEnabled: {
      type: Boolean,
      required: !0
    },
    selectionStatus: {
      type: String,
      default: "no"
    },
    overflow: {
      type: String,
      default: "visible"
    }
  },
  computed: {
    cssStyle() {
      return {
        overflowX: this.overflow
      };
    }
  },
  methods: {
    onToggleCheckbox() {
      this.$emit("click:select");
    }
  }
});
var YR = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "data-item-container" }, [t.selectionEnabled ? e("data-control-checkbox", { staticClass: "data-control-checkbox", attrs: { "selection-status": t.selectionStatus }, on: { click: function(i) {
    return i.stopPropagation(), t.onToggleCheckbox.apply(null, arguments);
  } } }) : t._e(), e("div", { staticClass: "item-slot", style: t.cssStyle }, [t._t("default")], 2)], 1);
}, XR = [], ZR = /* @__PURE__ */ f(
  KR,
  YR,
  XR,
  !1,
  null,
  "d3c3552c"
);
const QR = ZR.exports, JR = {
  summary: "simple",
  selection: {
    mode: "disabled",
    selectAllButton: !1
  },
  item: {
    minWidth: 300,
    maxWidth: void 0
  },
  display: {
    itemOverflow: "visible",
    itemDecoration: "disabled"
  }
}, tE = g({
  components: {
    DataControlSummary: pr,
    AppDataGridItem: QR
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      required: !1
    }
  },
  setup(s) {
    const { data: t, value: e } = Pe(s), { selection: i, selectionStatus: n, itemStatus: r, toggleAll: a, toggleItem: o } = Mi(t.value, e.value);
    return { selection: i, selectionStatus: n, itemStatus: r, toggleAll: a, toggleItem: o };
  },
  computed: {
    innerConfig() {
      return { ...JR, ...this.config };
    },
    summaryEnabled() {
      return this.innerConfig.summary === "simple";
    },
    appDataGridItemWastedSpace() {
      const s = this.selectionEnabled ? 22 : 0, t = this.selectionEnabled ? 12 : 0;
      return s + t;
    },
    gridStyle() {
      const s = this.innerConfig.item.minWidth, t = this.appDataGridItemWastedSpace;
      return {
        gridTemplateColumns: `repeat(auto-fill, minmax(${s + t}px, 1fr))`
      };
    },
    itemContainerStyle() {
      const s = this.innerConfig.item.maxWidth;
      return {
        maxWidth: s ? `${s}px` : void 0
      };
    },
    itemContainerCssClass() {
      return {
        panel: this.innerConfig.display.itemDecoration === "shadow"
      };
    },
    hasPrependSlot() {
      return !!this.$slots.prepend;
    },
    selectionEnabled() {
      return this.innerConfig.selection.mode === "multiple";
    }
  },
  methods: {
    onToggleSelectAll() {
      this.toggleAll(), this.updateModel(), this.$emit("click:all");
    },
    onToggleCheckbox(s) {
      this.toggleItem(s), this.updateModel(), this.$emit("click:select", s);
    },
    updateModel() {
      this.$emit("input", [...this.selection]);
    }
  }
});
var eE = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-data-grid-container" }, [t.summaryEnabled ? e("data-control-summary", { staticClass: "data-control-summary", attrs: { selection: t.selection, data: t.data, config: t.innerConfig.selection }, on: { "select-all": t.onToggleSelectAll } }) : t._e(), e("div", { staticClass: "app-data-grid", style: t.gridStyle }, [t.hasPrependSlot ? e("div", { staticClass: "item-container slot-prepend" }, [e("app-data-grid-item", { style: t.itemContainerStyle, attrs: { "selection-enabled": !1 } }, [t._t("prepend")], 2)], 1) : t._e(), t._l(t.data, function(i) {
    return e("div", { key: i.id, staticClass: "item-container" }, [e("app-data-grid-item", { class: t.itemContainerCssClass, style: t.itemContainerStyle, attrs: { "selection-enabled": t.selectionEnabled, "selection-status": t.itemStatus(i.id), overflow: t.innerConfig.display.itemOverflow }, on: { "click:select": function(n) {
      return t.onToggleCheckbox(i.id);
    } } }, [t._t("default", null, { item: i })], 2)], 1);
  })], 2)], 1);
}, sE = [], iE = /* @__PURE__ */ f(
  tE,
  eE,
  sE,
  !1,
  null,
  "a8476b03"
);
const hr = iE.exports, nE = g({
  components: {
    AppDataGrid: hr
  },
  props: {
    offers: {
      type: Array,
      default: () => []
    },
    label: {
      type: String
    },
    showProvider: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    routeToOffer(s) {
      return {
        name: "ServiceDetails",
        params: {
          id: s.id
        }
      };
    }
  },
  computed: {
    gridConfig() {
      return { summary: "disabled", item: { minWidth: 231 } };
    }
  }
});
var rE = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.offers.length ? e("div", [e("app-heading", { attrs: { level: 2, title: t.label } }), e("app-data-grid", { attrs: { data: t.offers, config: t.gridConfig }, scopedSlots: t._u([{ key: "default", fn: function({ item: i }) {
    return [e("router-link", { attrs: { to: t.routeToOffer(i[0]) } }, [e("offer-card", { attrs: { offer: i[0], workgroup: i[1], "show-provider": t.showProvider } })], 1)];
  } }], null, !1, 1854330360) })], 1) : t._e();
}, aE = [], oE = /* @__PURE__ */ f(
  nE,
  rE,
  aE,
  !1,
  null,
  "5278b00f"
);
const lE = oE.exports, cE = g({
  props: {
    workgroup: {
      type: Object,
      required: !1
    }
  },
  computed: {
    /**
     * @todo Use `useTeam`
     */
    workgroupResource() {
      var s;
      return this.$res(((s = this.workgroup) == null ? void 0 : s.resources) ?? {}) ?? {};
    }
  }
});
var uE = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "workgroup-card" }, [e("app-image", { staticClass: "workgroup-image", attrs: { src: t.workgroupResource.image, fallback: "/img/offer-image-empty.svg", height: "120px", type: "circle", width: "120px" } }), e("div", { staticClass: "workgroup-content" }, [e("div", { staticClass: "workgroup-title" }, [t._v(" " + t._s(t.workgroup.name) + " ")]), e("div", { staticClass: "workgroup-subtitle" }, [t._v(" " + t._s(t.workgroupResource.publicDescription) + " ")])])], 1);
}, dE = [], pE = /* @__PURE__ */ f(
  cE,
  uE,
  dE,
  !1,
  null,
  "081b112c"
);
const hE = pE.exports, fE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  OfferCard: AR,
  OfferCardHighlighted: ER,
  OfferDetailHeader: UR,
  ServiceGroup: lE,
  ServiceWorkgroupCard: hE
}, Symbol.toStringTag, { value: "Module" })), mE = g({
  props: {
    value: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !0
    },
    tooltip: {
      type: String,
      required: !1
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    previewOptions: {
      type: Array,
      default: () => []
    },
    previewGroups: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    topicFilter: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      optionsPool: [],
      selection: "",
      query: "",
      searchOptions: []
    };
  },
  async created() {
    if (this.value)
      try {
        this.loading = !0;
        const s = await this.$datasource.topic.find(this.value);
        this.optionsPool = [
          {
            text: this.$res(s == null ? void 0 : s.resources).title,
            value: s.id
          }
        ], this.selection = this.value;
      } catch (s) {
        console.error(s);
      } finally {
        this.loading = !1;
      }
  },
  computed: {
    options() {
      return this.query ? this.searchOptions : this.previewOptions;
    },
    groups() {
      return this.query ? void 0 : this.previewGroups;
    }
  },
  methods: {
    onUpdate(s) {
      this.$emit("input", s);
    },
    onDirty() {
      this.loading = !!this.query;
    },
    onToggleOpen(s) {
      s || (this.query = "", this.$emit("blur"));
    },
    async onSearchDebounced(s) {
      if (!s.length) {
        this.searchOptions = [];
        return;
      }
      this.loading = !0;
      const t = await this.searchTopics(s);
      this.searchOptions = t.map((e) => ({
        text: this.$res(e == null ? void 0 : e.resources).title,
        value: e.id
      })), this.loading = !1;
    },
    async searchTopics(s) {
      const t = await this.$datasource.topic.filterByTags(
        this.topicFilter
      );
      if (s) {
        const e = s.toUpperCase();
        return t.filter((i) => {
          var n;
          return (n = this.$res(i == null ? void 0 : i.resources).title) == null ? void 0 : n.toUpperCase().includes(e);
        });
      } else
        return t;
    }
  }
});
var gE = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-singleselect", { attrs: { label: t.label, placeholder: t.placeholder, tooltip: t.tooltip, options: t.options, "options-pool": t.optionsPool, "options-groups": t.groups, loading: t.loading, required: t.required, error: t.error }, on: { "toggle-open": t.onToggleOpen, "update-single": t.onUpdate }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [e("app-search-input", { staticClass: "inner-search", attrs: { placeholder: t.searchPlaceholder, "debounce-timeout": 500 }, on: { debounced: t.onSearchDebounced, dirty: t.onDirty }, model: { value: t.query, callback: function(i) {
      t.query = i;
    }, expression: "query" } })];
  }, proxy: !0 }, { key: "controls", fn: function() {
    return [t._t("controls")];
  }, proxy: !0 }], null, !0), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } });
}, _E = [], yE = /* @__PURE__ */ f(
  mE,
  gE,
  _E,
  !1,
  null,
  "6a2bfb5c"
);
const bE = yE.exports, vE = g({
  name: "TopicMultiselect",
  props: {
    value: {
      type: Array,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      optionsPool: [],
      options: [],
      selection: [],
      query: "",
      searchOptions: []
    };
  },
  async created() {
    if (this.value)
      try {
        this.loading = !0;
        const s = await this.$datasource.topic.list();
        this.optionsPool = s.map((t) => ({
          text: this.$res(t == null ? void 0 : t.resources).title,
          value: t.id
        })), this.options = this.optionsPool, this.selection = this.value;
      } catch (s) {
        console.error(s);
      } finally {
        this.loading = !1;
      }
  },
  methods: {
    onUpdate(s) {
      this.$emit("input", s);
    },
    onToggleOpen(s) {
      s || (this.query = "", this.$emit("blur"));
    },
    onSearchDebounced(s) {
      if (!s)
        this.options = this.optionsPool;
      else {
        const t = s.toUpperCase();
        this.options = this.optionsPool.filter(
          ({ text: e }) => e == null ? void 0 : e.toUpperCase().includes(t)
        );
      }
    }
  }
});
var kE = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-multiselect", { attrs: { enabled: t.enabled, error: t.error, label: t.label, loading: t.loading, options: t.options, placeholder: t.placeholder, required: t.required }, on: { input: t.onUpdate, "toggle-open": t.onToggleOpen }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [e("app-search-input", { staticClass: "inner-search", attrs: { "debounce-timeout": 500, placeholder: t.searchPlaceholder }, on: { debounced: t.onSearchDebounced }, model: { value: t.query, callback: function(i) {
      t.query = i;
    }, expression: "query" } })];
  }, proxy: !0 }, { key: "controls", fn: function() {
    return [t._t("controls")];
  }, proxy: !0 }], null, !0), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } });
}, xE = [], CE = /* @__PURE__ */ f(
  vE,
  kE,
  xE,
  !1,
  null,
  "8d49ec62"
);
const wE = CE.exports, $E = g({
  name: "TopicItem",
  props: {
    topic: {
      type: Object,
      required: !1
    }
  },
  computed: {
    color() {
      var s;
      return ((s = this.topic) == null ? void 0 : s.meta.color) ?? "";
    },
    title() {
      var s;
      return this.$res((s = this.topic) == null ? void 0 : s.resources).title;
    },
    description() {
      return this.$t("common.topic").toString();
    },
    initial() {
      return this.title ? this.title[0].toUpperCase() : "";
    }
  }
});
var SE = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "topic-item" }, [e("div", { staticClass: "initial-container", style: `background-color: ${t.color}` }, [e("div", { staticClass: "topic-initial" }, [t._v(" " + t._s(t.initial) + " ")])]), e("div", { staticClass: "content" }, [e("div", { staticClass: "topic-title" }, [t._v(t._s(t.title))]), e("div", { staticClass: "topic-description" }, [t._v(" " + t._s(t.description) + " ")])])]);
}, TE = [], IE = /* @__PURE__ */ f(
  $E,
  SE,
  TE,
  !1,
  null,
  "491f4ae6"
);
const AE = IE.exports, PE = g({
  name: "TopicCard",
  props: {
    topic: {
      type: Object,
      required: !0
    },
    stats: {
      type: Object,
      required: !1
    }
  },
  computed: {
    resources() {
      return this.$res(this.topic.resources);
    },
    image() {
      var s;
      return ((s = this.resources) == null ? void 0 : s.imageUrl) ?? "";
    },
    appPillStyle() {
      return {
        backgroundColor: this.topic.meta.color ?? "#2b94fc",
        color: "#ffffff",
        border: "0"
      };
    },
    numberOfExperts() {
      var s;
      return ((s = this.stats) == null ? void 0 : s.numberOfExperts) ?? 0;
    },
    numberOfTickets() {
      var t, e;
      const s = (t = this.stats) == null ? void 0 : t.ticketStats;
      return this.stats && s ? s.total - (((e = s.byStatus) == null ? void 0 : e.ARCHIVED) || 0) : 0;
    }
  }
});
var OE = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "base-topic-card" }, [e("div", { staticClass: "topic-image-wrapper" }, [t.image ? e("img", { staticClass: "topic-image", attrs: { src: t.image } }) : t._e()]), e("div", { staticClass: "topic-info-wrapper" }, [e("app-tooltip", { attrs: { tooltip: t.resources.title, placement: "bottom" } }, [e("app-pill", { staticClass: "topic-name", style: t.appPillStyle, attrs: { label: t.resources.title } })], 1), e("span", { staticClass: "topic-info" }, [t._v(" " + t._s(t.numberOfTickets) + " " + t._s(t.$t("common.tickets")) + " • " + t._s(t.$tc("common.owners", t.numberOfExperts)) + " ")])], 1)]);
}, ME = [], RE = /* @__PURE__ */ f(
  PE,
  OE,
  ME,
  !1,
  null,
  "56becaee"
);
const EE = RE.exports, DE = g({
  props: {
    stats: {
      type: Object,
      required: !0
    },
    activeStatuses: {
      type: Array,
      required: !0
    },
    ticketFaIcon: {
      type: String,
      required: !0
    }
  },
  computed: {
    faIcon() {
      return `fa-light ${this.ticketFaIcon}`;
    },
    memberCount() {
      return this.stats.numberOfExperts ?? 0;
    },
    ticketCount() {
      return this.activeStatuses.reduce(
        (s, t) => {
          var e;
          return s + (((e = this.stats.ticketStats) == null ? void 0 : e.byStatus[t]) ?? 0);
        },
        0
      );
    }
  }
});
var FE = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "stats-summary" }, [e("div", [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-light fa-user" } }), e("span", [t._v(t._s(t.memberCount))])], 1), e("div", [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: t.faIcon } }), e("span", [t._v(t._s(t.ticketCount))])], 1)]);
}, LE = [], qE = /* @__PURE__ */ f(
  DE,
  FE,
  LE,
  !1,
  null,
  "eb3ad6fb"
);
const UE = qE.exports, NE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TopicCard: EE,
  TopicDropdown: bE,
  TopicItem: AE,
  TopicMultiselect: wE,
  TopicStatsSummary: UE
}, Symbol.toStringTag, { value: "Module" })), BE = g({
  name: "BadgeListItem",
  components: {
    AppItemCard: rr
  },
  props: {
    resources: {
      type: Object,
      required: !0
    }
  },
  computed: {
    resource() {
      return this.$res(this.resources);
    }
  }
});
var jE = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-list-item", { attrs: { description: t.resource.tagline, title: t.resource.title, image: t.resource.icon } });
}, zE = [], VE = /* @__PURE__ */ f(
  BE,
  jE,
  zE,
  !1,
  null,
  null
);
const HE = VE.exports, WE = g({
  name: "Badge",
  components: {
    AppMarkdownText: Et
  },
  props: {
    resources: {
      type: Object,
      required: !0
    }
  },
  computed: {
    resource() {
      return this.$res(this.resources);
    },
    showButton() {
      var s;
      return !!((s = this.resource.button) != null && s.href);
    },
    showLink() {
      var s;
      return !!((s = this.resource.link) != null && s.href);
    }
  },
  methods: {
    doButtonAction() {
      const s = this.resource.button.href;
      window.open(s, "_blank");
    }
  }
});
var GE = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "badge-card" }, [e("app-markdown-text", { staticClass: "badge-type", attrs: { text: t.resource.badgeType } }), e("app-image", { staticClass: "app-image", attrs: { src: t.resource.image, width: "fit-content" } }), e("div", { staticClass: "badge-title" }, [t._v(t._s(t.resource.title))]), t.resource.tagline ? e("div", { staticClass: "badge-subtitle" }, [t._v(t._s(t.resource.tagline))]) : t._e(), e("app-markdown-text", { staticClass: "badge-description", attrs: { text: t.resource.description } }), t.showButton ? e("app-button", { staticClass: "button", attrs: { label: t.resource.button.label }, on: { click: t.doButtonAction } }) : t._e(), t.showLink ? e("app-link", { staticClass: "link", attrs: { "external-path": t.resource.link.href, label: t.resource.link.label, target: "_blank" } }) : t._e()], 1);
}, KE = [], YE = /* @__PURE__ */ f(
  WE,
  GE,
  KE,
  !1,
  null,
  "d5d18e15"
);
const XE = YE.exports, ZE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Badge: XE,
  BadgeListItem: HE
}, Symbol.toStringTag, { value: "Module" }));
Rt.util.warn;
function jc(s) {
  return fu() ? (mu(s), !0) : !1;
}
function fr(s) {
  return typeof s == "function" ? s() : Be(s);
}
const QE = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const JE = Object.prototype.toString, tD = (s) => JE.call(s) === "[object Object]", eD = () => {
};
function sD(s) {
  return Fn();
}
function iD(s, t = !0, e) {
  sD() ? Ln(s, e) : t ? s() : pe(s);
}
const mr = QE ? window : void 0;
function nD(s) {
  var t;
  const e = fr(s);
  return (t = e == null ? void 0 : e.$el) != null ? t : e;
}
function rD(...s) {
  let t, e, i, n;
  if (typeof s[0] == "string" || Array.isArray(s[0]) ? ([e, i, n] = s, t = mr) : [t, e, i, n] = s, !t)
    return eD;
  Array.isArray(e) || (e = [e]), Array.isArray(i) || (i = [i]);
  const r = [], a = () => {
    r.forEach((u) => u()), r.length = 0;
  }, o = (u, d, p, h) => (u.addEventListener(d, p, h), () => u.removeEventListener(d, p, h)), l = Te(
    () => [nD(t), fr(n)],
    ([u, d]) => {
      if (a(), !u)
        return;
      const p = tD(d) ? { ...d } : d;
      r.push(
        ...e.flatMap((h) => i.map((m) => o(u, h, m, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), a();
  };
  return jc(c), c;
}
function aD() {
  const s = st(!1);
  return Fn() && Ln(() => {
    s.value = !0;
  }, void 0), s;
}
function oD(s) {
  const t = aD();
  return Q(() => (t.value, !!s()));
}
function lD(s, t = {}) {
  const { window: e = mr } = t, i = oD(() => e && "matchMedia" in e && typeof e.matchMedia == "function");
  let n;
  const r = st(!1), a = (c) => {
    r.value = c.matches;
  }, o = () => {
    n && ("removeEventListener" in n ? n.removeEventListener("change", a) : n.removeListener(a));
  }, l = gu(() => {
    i.value && (o(), n = e.matchMedia(fr(s)), "addEventListener" in n ? n.addEventListener("change", a) : n.addListener(a), r.value = n.matches);
  });
  return jc(() => {
    l(), o(), n = void 0;
  }), r;
}
function cD(s = {}) {
  const {
    window: t = mr,
    initialWidth: e = Number.POSITIVE_INFINITY,
    initialHeight: i = Number.POSITIVE_INFINITY,
    listenOrientation: n = !0,
    includeScrollbar: r = !0,
    type: a = "inner"
  } = s, o = st(e), l = st(i), c = () => {
    t && (a === "outer" ? (o.value = t.outerWidth, l.value = t.outerHeight) : r ? (o.value = t.innerWidth, l.value = t.innerHeight) : (o.value = t.document.documentElement.clientWidth, l.value = t.document.documentElement.clientHeight));
  };
  if (c(), iD(c), rD("resize", c, { passive: !0 }), n) {
    const u = lD("(orientation: portrait)");
    Te(u, () => c());
  }
  return { width: o, height: l };
}
const uD = g({
  props: {
    maxWidth: {
      type: Number,
      required: !1
    },
    collapseWidth: {
      type: Number,
      default: 920
    }
  },
  data() {
    return {
      windowWidth: 0
    };
  },
  created() {
    pe(() => {
      const { width: s } = cD();
      this.windowWidth = s.value, Te(s, (t) => {
        this.windowWidth = t;
      });
    });
  },
  computed: {
    headerContentStyle() {
      return {
        width: this.maxWidth ? `${this.maxWidth}px` : "100%"
      };
    },
    collapsed() {
      return this.windowWidth <= this.collapseWidth;
    },
    hasSlotStart() {
      return !!this.$slots["header-start"] || !!this.$scopedSlots["header-start"];
    },
    hasSlotMain() {
      return !!this.$slots["header-main"] || !!this.$scopedSlots["header-main"];
    },
    hasSlotEnd() {
      return !!this.$slots["header-end"] || !!this.$scopedSlots["header-end"];
    }
  },
  methods: {}
});
var dD = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-header" }, [e("div", { staticClass: "header-content", style: t.headerContentStyle }, [t.hasSlotStart ? e("div", { staticClass: "header-slot slot-start" }, [t._t("header-start", null, { collapsed: t.collapsed })], 2) : t._e(), t.hasSlotMain ? e("div", { staticClass: "header-slot slot-main" }, [t._t("header-main", null, { collapsed: t.collapsed })], 2) : t._e(), t.hasSlotEnd ? e("div", { staticClass: "header-slot slot-end" }, [t._t("header-end", null, { collapsed: t.collapsed })], 2) : t._e()])]);
}, pD = [], hD = /* @__PURE__ */ f(
  uD,
  dD,
  pD,
  !1,
  null,
  "1344dbc8"
);
const fD = hD.exports, mD = g({
  props: {
    label: {
      type: String,
      required: !0
    },
    routeName: {
      type: String,
      required: !0
    }
  },
  computed: {
    location() {
      return {
        name: this.routeName
      };
    }
  }
});
var gD = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("router-link", { staticClass: "header-navigation-link", attrs: { to: t.location } }, [t._v(" " + t._s(t.label) + " ")]);
}, _D = [], yD = /* @__PURE__ */ f(
  mD,
  gD,
  _D,
  !1,
  null,
  "e8b40ce5"
);
const zc = yD.exports, bD = g({
  components: {
    HeaderNavigationLink: zc
  },
  props: {
    options: {
      type: Array,
      required: !0
    }
  }
});
var vD = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "header-navigation" }, t._l(t.options, function(i, n) {
    return e("header-navigation-link", { key: n, attrs: { label: i.label, "route-name": i.routeName } });
  }), 1);
}, kD = [], xD = /* @__PURE__ */ f(
  bD,
  vD,
  kD,
  !1,
  null,
  "7193e375"
);
const CD = xD.exports, wD = g({
  props: {
    productLogo: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    productTitle: {
      type: String,
      required: !0
    },
    productTagline: {
      type: String,
      required: !1
    },
    selected: {
      type: Boolean,
      required: !0
    }
  },
  data() {
    return {
      optionsVisible: !1
    };
  }
});
var $D = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "header-product-link" }, [e("div", { staticClass: "product-link-content" }, [e("img", { staticClass: "product-image", attrs: { src: t.productLogo } }), t.productTagline ? e("div", { staticClass: "product-tagline" }, [t._v(" " + t._s(t.productTagline) + " ")]) : t._e()]), t.selected ? e("fa-icon-compat", { staticClass: "selection-indicator", attrs: { icon: "fa-solid fa-check" } }) : t._e()], 1);
}, SD = [], TD = /* @__PURE__ */ f(
  wD,
  $D,
  SD,
  !1,
  null,
  "2933c44b"
);
const Vc = TD.exports, ID = g({
  components: {
    HeaderProductLink: Vc
  },
  props: {
    productId: {
      type: String,
      required: !1
    },
    productList: {
      type: Array,
      required: !0
    },
    portalSwitchLabel: {
      type: String,
      required: !1
    },
    portalSwitchUrl: {
      type: String,
      required: !1
    },
    companySwitchLabel: {
      type: String,
      required: !1
    },
    companySwitchUrl: {
      type: String,
      required: !1
    },
    homeRouteName: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      optionsVisible: !1
    };
  },
  computed: {
    portalSwitcherVisible() {
      return !!this.portalSwitchLabel && !!this.portalSwitchUrl;
    },
    companySwitcherVisible() {
      return !!this.companySwitchLabel && !!this.companySwitchUrl;
    }
  },
  methods: {
    routeTo(s) {
      return {
        name: this.homeRouteName,
        params: {
          product: s.productId
        }
      };
    }
  }
});
var AD = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "header-selector-floating" }, [t.portalSwitcherVisible ? e("div", { staticClass: "portal-switch" }, [e("span", { staticClass: "portal-switch-label" }, [t._v(" " + t._s(t.$t("structure.header.labelSwitchTo")) + " ")]), e("a", { staticClass: "portal-switch-link", attrs: { href: t.portalSwitchUrl } }, [e("span", [t._v(t._s(t.portalSwitchLabel))]), e("fa-icon-compat", { attrs: { icon: "fa-regular fa-arrow-up-right-from-square" } })], 1)]) : t._e(), t._l(t.productList, function(i, n) {
    return e("router-link", { key: n, attrs: { to: t.routeTo(i) } }, [e("header-product-link", { attrs: { "product-id": i.productId, "product-logo": i.customization.logo, "product-title": i.customization.name, "product-tagline": i.customization.tagline, selected: t.productId === i.productId } })], 1);
  }), t.companySwitcherVisible ? e("div", { staticClass: "company-switch-separator" }) : t._e(), t.companySwitcherVisible ? e("div", { staticClass: "portal-switch" }, [e("a", { staticClass: "portal-switch-link", attrs: { href: t.companySwitchUrl } }, [e("fa-icon-compat", { attrs: { icon: "fa-solid fa-arrows-repeat" } }), e("span", [t._v(t._s(t.companySwitchLabel))])], 1)]) : t._e()], 2);
}, PD = [], OD = /* @__PURE__ */ f(
  ID,
  AD,
  PD,
  !1,
  null,
  "7ce0d6b6"
);
const Hc = OD.exports, MD = g({
  components: {
    HeaderSelectorFloating: Hc
  },
  props: {
    portalSwitchLabel: {
      type: String,
      required: !1
    },
    portalSwitchUrl: {
      type: String,
      required: !1
    },
    companySwitchLabel: {
      type: String,
      required: !1
    },
    companySwitchUrl: {
      type: String,
      required: !1
    },
    productId: {
      type: String,
      required: !1
    },
    productList: {
      type: Array,
      required: !0
    },
    homeRouteName: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      optionsVisible: !1
    };
  },
  methods: {
    onToggleFloating() {
      this.optionsVisible = !this.optionsVisible;
    },
    onHideFloating() {
      this.optionsVisible = !1;
    }
  }
});
var RD = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-floating", { attrs: { placement: "bottom-start", "floating-style": { width: "unset" }, control: "manual" }, on: { "hide-floating": t.onHideFloating }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("button", { staticClass: "header-selector-button", class: { on: t.optionsVisible }, on: { click: t.onToggleFloating } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-solid fa-grid" } })], 1)];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [e("header-selector-floating", { staticClass: "header-selector-floating", attrs: { "product-id": t.productId, "product-list": t.productList, "portal-switch-label": t.portalSwitchLabel, "portal-switch-url": t.portalSwitchUrl, "home-route-name": t.homeRouteName, "company-switch-label": t.companySwitchLabel, "company-switch-url": t.companySwitchUrl } })];
  }, proxy: !0 }]), model: { value: t.optionsVisible, callback: function(i) {
    t.optionsVisible = i;
  }, expression: "optionsVisible" } });
}, ED = [], DD = /* @__PURE__ */ f(
  MD,
  RD,
  ED,
  !1,
  null,
  "18fe6af1"
);
const FD = DD.exports, LD = g({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !1
    },
    homeRouteName: {
      type: String,
      required: !0
    }
  },
  computed: {
    contextId() {
      return this.organization.context;
    },
    contextLogo() {
      return this.organization.logo;
    },
    productLogo() {
      return this.organization.productCustomization[this.productId].logo;
    },
    separatorVisible() {
      return !!this.contextId && !!this.productId;
    },
    contextVisible() {
      return !!this.contextId && !!this.contextLogo;
    },
    reverse() {
      var s;
      return !!((s = this.organization.productCustomization[this.productId]) != null && s.contextLogoFirst);
    }
  }
});
var qD = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "product-indicator", class: { reverse: t.reverse } }, [t.productId ? e("router-link", { staticClass: "product-image", attrs: { to: { name: t.homeRouteName } } }, [e("img", { attrs: { src: t.productLogo } })]) : t._e(), t.separatorVisible ? e("div", { staticClass: "separator" }) : t._e(), e("router-link", { staticClass: "context-image", attrs: { to: { name: t.homeRouteName } } }, [t.contextVisible ? e("img", { attrs: { src: t.contextLogo } }) : t._e()])], 1);
}, UD = [], ND = /* @__PURE__ */ f(
  LD,
  qD,
  UD,
  !1,
  null,
  "438804f6"
);
const BD = ND.exports, jD = g({
  props: {
    user: {
      type: Object,
      required: !1
    },
    navigation: {
      type: Array,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    collapsed: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      optionsVisible: !1
    };
  },
  watch: {
    $route() {
      this.onHideFloating();
    }
  },
  computed: {
    userAvatar() {
      var s;
      return (s = this.user) == null ? void 0 : s.avatar;
    },
    allOptions() {
      return [...this.collapsed ? this.navigation : [], ...this.options];
    }
  },
  methods: {
    onToggleFloating() {
      this.optionsVisible = !this.optionsVisible;
    },
    onHideFloating() {
      this.optionsVisible = !1;
    }
  }
});
var zD = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-floating", { attrs: { placement: "bottom-end", "floating-style": { width: "unset" }, control: "manual" }, on: { "hide-floating": t.onHideFloating }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("button", { staticClass: "header-profile-button", class: { on: t.optionsVisible }, on: { click: t.onToggleFloating } }, [t.userAvatar ? e("img", { staticClass: "profile-avatar", attrs: { src: t.userAvatar } }) : e("fa-icon-compat", { staticClass: "profile-icon", attrs: { icon: "fa-solid fa-user" } }), e("fa-icon-compat", { staticClass: "profile-chevron", attrs: { icon: "fa-solid fa-chevron-down" } })], 1)];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [e("div", { staticClass: "header-profile-floating" }, t._l(t.allOptions, function(i, n) {
      return e("app-menu-item", { key: n, staticClass: "profile-floating-item", attrs: { title: i.label, "fa-icon": i.faIcon, "route-name": i.routeName, "route-params": i.routeParams } });
    }), 1)];
  }, proxy: !0 }]), model: { value: t.optionsVisible, callback: function(i) {
    t.optionsVisible = i;
  }, expression: "optionsVisible" } });
}, VD = [], HD = /* @__PURE__ */ f(
  jD,
  zD,
  VD,
  !1,
  null,
  "2f208869"
);
const WD = HD.exports, GD = g({
  props: {
    ticketResponse: {
      type: Object,
      required: !0
    }
  },
  computed: {
    ticket() {
      return this.ticketResponse.ticket;
    },
    ticketIcon() {
      const { icons: s } = Ge(this.ticketResponse.workflow);
      return s.solid;
    },
    statusLabel() {
      var t;
      const s = Y(
        this.ticket.status,
        this.ticketResponse.workflow
      );
      return ((t = this.$res(s)) == null ? void 0 : t.label) ?? this.ticket.status;
    },
    statusVisible() {
      return this.ticketResponse.ticket.type !== "task";
    }
  }
});
var KD = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "quick-search-ticket-item" }, [e("img", { staticClass: "item-icon", class: [t.ticket.type], attrs: { src: t.ticketIcon } }), e("div", { staticClass: "item-title" }, [t._v(" " + t._s(t.ticket.title) + " ")]), t.statusVisible ? e("div", { staticClass: "tag status" }, [t._v(" " + t._s(t.statusLabel) + " ")]) : e("div", { staticClass: "canonical-id" }, [t._v(" " + t._s(t.ticket.parent) + " ")])]);
}, YD = [], XD = /* @__PURE__ */ f(
  GD,
  KD,
  YD,
  !1,
  null,
  "885fd733"
);
const Wc = XD.exports, ZD = g({
  props: {
    userData: {
      type: Object,
      required: !0
    }
  },
  computed: {
    displayName() {
      return E(this.userData).displayName();
    },
    userDepartment() {
      return E(this.userData).userDepartment();
    },
    avatar() {
      return this.userData.user.avatar;
    }
  }
});
var QD = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "quick-search-user-item" }, [e("div", { staticClass: "item-avatar" }, [t.avatar ? e("app-image", { attrs: { src: t.avatar, height: "18px", width: "18px", type: "circle" } }) : e("div", { staticClass: "avatar-fallback" }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-light fa-user" } })], 1)], 1), e("div", { staticClass: "item-title" }, [t._v(" " + t._s(t.displayName) + " ")]), e("div", { staticClass: "item-subtitle" }, [t._v(" " + t._s(t.userDepartment) + " ")])]);
}, JD = [], tF = /* @__PURE__ */ f(
  ZD,
  QD,
  JD,
  !1,
  null,
  "ff86ff81"
);
const Gc = tF.exports, eF = g({
  components: {
    QuickSearchTicketItem: Wc,
    QuickSearchUserItem: Gc
  },
  inject: ["quickSearchConfig"],
  props: {
    productId: {
      type: String,
      required: !0
    },
    query: {
      type: String,
      required: !0
    },
    emptyInput: {
      type: Boolean,
      required: !0
    },
    dirty: {
      type: Boolean,
      required: !0
    },
    ticketCount: {
      type: Number,
      required: !0
    },
    tickets: {
      type: Array,
      required: !0
    },
    userCount: {
      type: Number,
      required: !0
    },
    users: {
      type: Array,
      required: !0
    }
  },
  computed: {
    quickSearchConfig() {
      return this.quickSearchConfig ?? {};
    },
    loading() {
      return this.dirty && !this.emptyInput;
    },
    emptyResult() {
      return !this.ticketCount && !this.userCount;
    },
    searchTicketLink() {
      return {
        name: this.quickSearchConfig.tickets,
        query: { query: this.query }
      };
    },
    searchUserLink() {
      return {
        name: this.quickSearchConfig.users,
        query: { query: this.query }
      };
    },
    ticketCountText() {
      return this.ticketCount >= 1e3 ? "1000+" : this.ticketCount.toString();
    },
    userCountText() {
      return this.userCount >= 1e3 ? "1000+" : this.userCount.toString();
    }
  },
  methods: {
    ticketRouterLink(s) {
      const t = s.parent && s.type === "task" ? s.parent : s.canonicalId;
      return this.generatePortalUrl(`/${this.productId}/ticket/${t}`);
    },
    userRouterLink(s) {
      return this.generatePortalUrl(
        `/${this.productId}/profile/${s.user.id}`
      );
    },
    generatePortalUrl(s) {
      return new URL(s, this.quickSearchConfig.portalUrl).href;
    }
  }
});
var sF = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "quick-search-results" }, [t.emptyInput ? e("div", { staticClass: "no-results" }, [t._v(" " + t._s(t.$t("search.quick.label-instructions")) + " ")]) : t.emptyResult && !t.loading ? e("div", { staticClass: "no-results" }, [t._v(" " + t._s(t.$t("search.quick.label-empty")) + " ")]) : t._e(), (t.emptyInput || t.emptyResult) && !t.loading ? e("div", { staticClass: "search-links" }, [e("router-link", { attrs: { to: { name: t.quickSearchConfig.users } } }, [t._v(" " + t._s(t.$t("menu.users")) + " ")]), e("router-link", { attrs: { to: { name: t.quickSearchConfig.tickets } } }, [t._v(" " + t._s(t.$t("common.ideas")) + " ")])], 1) : [t.ticketCount ? [e("div", { staticClass: "result-group" }, [e("div", { staticClass: "group-header" }, [e("span", { staticClass: "group-title" }, [t._v(t._s(t.$t("common.ideas")))]), e("span", { staticClass: "group-count" }, [t._v(t._s(t.ticketCountText))])]), t._l(t.tickets, function(i) {
    return e("a", { key: i.ticket.id, staticClass: "result-link", attrs: { target: t.quickSearchConfig.target, href: t.ticketRouterLink(i.ticket) } }, [e("quick-search-ticket-item", { attrs: { "ticket-response": i } })], 1);
  }), e("router-link", { staticClass: "view-all", attrs: { to: t.searchTicketLink } }, [t._v(" " + t._s(t.$t("common.viewAll")) + " ")])], 2)] : t._e(), t.userCount ? [e("div", { staticClass: "result-group" }, [e("div", { staticClass: "group-header" }, [e("span", { staticClass: "group-title" }, [t._v(t._s(t.$t("menu.people")))]), e("span", { staticClass: "group-count" }, [t._v(t._s(t.userCountText))])]), t._l(t.users, function(i) {
    return e("a", { key: i.user.id, staticClass: "result-link", attrs: { href: t.userRouterLink(i) } }, [e("quick-search-user-item", { attrs: { "user-data": i } })], 1);
  }), e("router-link", { staticClass: "view-all", attrs: { to: t.searchUserLink } }, [t._v(" " + t._s(t.$t("common.viewAll")) + " ")])], 2)] : t._e()], e("transition", { attrs: { mode: "out-in", name: "modal-fade" } }, [t.loading ? e("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [e("app-loading")], 1) : t._e()], 1)], 2);
}, iF = [], nF = /* @__PURE__ */ f(
  eF,
  sF,
  iF,
  !1,
  null,
  "969e9061"
);
const Kc = nF.exports, rF = g({
  components: {
    QuickSearchResults: Kc
  },
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      open: !1,
      dirty: !1,
      loading: !1,
      query: "",
      ticketCount: 0,
      tickets: [],
      userCount: 0,
      users: []
    };
  },
  watch: {
    $route() {
      this.open = !1, this.query = "";
    }
  },
  computed: {
    emptyInput() {
      return this.query.length < 3;
    }
  },
  methods: {
    onDirty() {
      this.dirty = !0, this.loading = !0;
    },
    async onDebouncedSearch(s) {
      if (this.emptyInput) {
        this.dirty = !1, this.loading = !1, this.clearResults();
        return;
      }
      const t = 5, e = await this.$gateway.search.quickSearch({
        query: s,
        filter: { excludeTicketTypes: ["feedback"] }
      }), i = e.ticketIds.slice(0, t), n = e.userIds.slice(0, t);
      this.ticketCount = e.ticketIds.length, this.userCount = e.userIds.length, [this.tickets, this.users] = await Promise.all([
        this.$gateway.ticket.loadTicketsByBatch(
          this.contextId,
          this.productId,
          i
        ),
        this.$gateway.portal.findUsersById(n)
      ]), this.dirty = !1, this.loading = !1;
    },
    clearResults() {
      this.ticketCount = 0, this.tickets = [], this.userCount = 0, this.users = [];
    }
  }
});
var aF = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-floating", { scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("app-search-input", { attrs: { "debounce-timeout": 300, placeholder: t.$t("common.search") }, on: { debounced: t.onDebouncedSearch, dirty: t.onDirty }, model: { value: t.query, callback: function(i) {
      t.query = i;
    }, expression: "query" } })];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [e("quick-search-results", { attrs: { "product-id": t.productId, dirty: t.dirty, "empty-input": t.emptyInput, loading: t.loading, query: t.query, tickets: t.tickets, "ticket-count": t.ticketCount, users: t.users, "user-count": t.userCount } })];
  }, proxy: !0 }]), model: { value: t.open, callback: function(i) {
    t.open = i;
  }, expression: "open" } });
}, oF = [], lF = /* @__PURE__ */ f(
  rF,
  aF,
  oF,
  !1,
  null,
  "b89bc0e2"
);
const Yc = lF.exports, cF = g({
  components: {
    QuickSearchInput: Yc
  },
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    expanded: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    focusSearchInput() {
      const s = this.$el.querySelector(
        ".quick-search-input .text-input"
      );
      s == null || s.focus();
    }
  }
});
var uF = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "header-search" }, [e("button", { staticClass: "quick-search-button", on: { click: t.focusSearchInput, focus: t.focusSearchInput } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-magnifying-glass" } })], 1), e("quick-search-input", { staticClass: "quick-search-input", class: { expanded: t.expanded }, attrs: { "context-id": t.contextId, "product-id": t.productId } })], 1);
}, dF = [], pF = /* @__PURE__ */ f(
  cF,
  uF,
  dF,
  !1,
  null,
  "a631be1f"
);
const hF = pF.exports, fF = g({
  props: {
    options: {
      type: Array,
      required: !0
    }
  }
});
var mF = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "footer-navigation" }, t._l(t.options, function(i, n) {
    return e("a", { key: n, staticClass: "footer-navigation-link", attrs: { href: i.href, target: "_blank" } }, [t._v(" " + t._s(i.label) + " ")]);
  }), 0);
}, gF = [], _F = /* @__PURE__ */ f(
  fF,
  mF,
  gF,
  !1,
  null,
  "0b72db0f"
);
const yF = _F.exports, bF = g({
  props: {
    version: {
      type: String,
      required: !1
    }
  }
});
var vF = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "footer-indicator" }, [e("a", { staticClass: "footer-logo", attrs: { href: "https://rready.com/", target: "_blank" } }, [e("svg", { staticClass: "footer-logo-image", attrs: { width: "78", height: "18", viewBox: "0 0 78 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("path", { attrs: { fill: "#cccccc", d: "M19.7011 3.97647C17.782 3.97647 16.3824 5.03202 15.8177 6.67517V4.24036H12.1628V14.0236H15.8203V10.7769C15.8203 9.70198 16.0462 8.781 16.4753 8.01309C16.9262 7.22142 17.5813 6.82823 18.4614 6.82823C19.6133 6.82823 20.2449 7.53193 20.2449 8.58749C20.2514 8.79495 20.2286 9.00229 20.1772 9.20323L23.429 8.01924V7.94448C23.4264 5.57827 22.0711 3.97647 19.7011 3.97647ZM7.53831 3.97647C5.6192 3.97647 4.21961 5.03202 3.65491 6.67517V4.24036H0V14.0236H3.65752V10.7769C3.65752 9.70198 3.8834 8.781 4.31257 8.01309C4.76346 7.22142 5.41852 6.82823 6.29858 6.82823C7.45057 6.82823 8.08216 7.53193 8.08216 8.58749C8.08861 8.79495 8.06579 9.00229 8.0144 9.20323L11.2662 8.01924V7.94448C11.2662 5.57827 9.91093 3.97647 7.54092 3.97647H7.53831ZM30.0394 3.97647C28.3688 3.97647 26.9692 4.48137 25.8624 5.49031C24.7565 6.47725 24.2117 7.75008 24.2117 9.28503C24.2117 10.7769 24.7536 11.9834 25.8372 12.9047C26.9214 13.8257 28.3436 14.2866 30.082 14.2866C32.9264 14.2866 34.6865 13.319 35.3876 11.3689L32.4077 10.6652C32.0463 11.3891 31.3235 11.7401 30.2401 11.7401C28.818 11.7401 27.8945 10.9071 27.8693 9.70022H35.4371V8.86809C35.4371 7.4642 34.9631 6.30162 34.0149 5.38036C33.0888 4.43739 31.757 3.97647 30.0412 3.97647H30.0394ZM27.9414 8.14415C28.1447 7.0886 28.8675 6.38489 30.0412 6.38489C31.1923 6.38489 31.8925 7.10883 31.9603 8.14415H27.9414ZM67.7223 10.4074H67.6355L65.1708 4.24036H61.1527L65.8032 14.1802L65.6903 14.4001C65.4418 14.9041 65.0352 15.1671 64.5166 15.1671C63.8163 15.1671 63.3194 14.5971 63.3194 13.6542L60.7913 14.9921C60.8378 15.3944 60.9686 15.782 61.1749 16.1291C61.3812 16.4762 61.6583 16.7747 61.9876 17.0047C62.6878 17.5324 63.5233 17.7963 64.494 17.7963C66.9318 17.7963 68.3774 16.2605 69.664 13.2997L73.6604 4.23948H70.2513L67.7223 10.4074ZM76.9513 5.65744C76.9513 5.41378 76.8105 5.24929 76.5673 5.24929C76.4799 5.24542 76.3936 5.27056 76.3216 5.3209C76.2497 5.37124 76.1959 5.44401 76.1685 5.52813V5.28096H75.7915V6.28725H76.1676V5.95299C76.1648 5.85408 76.1876 5.75615 76.2337 5.66887C76.2529 5.63113 76.2823 5.59964 76.3184 5.57802C76.3545 5.55639 76.3959 5.54551 76.4378 5.54661C76.4618 5.54404 76.4859 5.54675 76.5087 5.55453C76.5315 5.56231 76.5524 5.575 76.5699 5.59171C76.5874 5.60842 76.6011 5.62876 76.6101 5.65134C76.6191 5.67392 76.6232 5.69821 76.622 5.72253C76.6225 5.74386 76.6202 5.76517 76.6151 5.78586L76.9495 5.66272L76.9513 5.65744ZM75.7932 3.98614C75.4738 3.98614 75.1616 4.08209 74.8961 4.26183C74.6305 4.44157 74.4237 4.69703 74.3016 4.99587C74.1795 5.29471 74.1477 5.62351 74.2103 5.94064C74.2729 6.25777 74.427 6.54897 74.653 6.7774C74.8791 7.00583 75.1671 7.16121 75.4804 7.22387C75.7938 7.28653 76.1185 7.25367 76.4133 7.12943C76.7082 7.00519 76.9601 6.79516 77.137 6.52593C77.314 6.2567 77.4081 5.94037 77.4074 5.61698C77.4065 5.18413 77.236 4.76933 76.9334 4.46359C76.6308 4.15785 76.2207 3.98614 75.7932 3.98614ZM75.7932 6.92762C75.5379 6.92762 75.2883 6.85096 75.076 6.70733C74.8637 6.5637 74.6982 6.35956 74.6005 6.12071C74.5028 5.88187 74.4772 5.61904 74.527 5.36549C74.5768 5.11193 74.6998 4.87902 74.8803 4.69621C75.0609 4.51341 75.2909 4.38892 75.5413 4.33848C75.7918 4.28805 76.0514 4.31393 76.2873 4.41286C76.5231 4.5118 76.7248 4.67934 76.8666 4.89429C77.0085 5.10925 77.0842 5.36197 77.0842 5.62049C77.0828 5.96641 76.9463 6.29771 76.7043 6.54199C76.4624 6.78626 76.1349 6.92364 75.7932 6.92411V6.92762ZM47.2897 11.9617C46.8614 11.9617 46.6356 11.7638 46.6356 11.3689V7.66212C46.6356 5.20531 45.123 3.97647 42.118 3.97647C39.3865 3.97647 37.5352 5.11999 36.7898 6.96017L39.9956 7.72809C40.0633 6.96017 40.8087 6.43327 41.9147 6.43327C42.7504 6.43327 43.1796 6.78512 43.1796 7.48883V7.68059L39.9287 8.5136C37.6699 9.10647 36.4293 9.83304 36.4293 11.4313C36.4293 13.1642 37.7611 14.1731 39.748 14.1731C41.3986 14.1731 42.6601 13.5152 43.2699 12.3743C43.5175 13.4932 44.6695 14.2831 46.1369 14.2831C46.9944 14.2831 47.8301 14.0192 48.665 13.5152L48.4174 11.4973C48.1127 11.7904 47.71 11.9563 47.2897 11.9617ZM43.1779 9.96762C43.1779 11.2185 42.2066 11.9424 41.0555 11.9424C40.423 11.9424 39.9938 11.6354 39.9938 11.0425C39.9938 10.4945 40.4004 10.0996 41.191 9.85855L43.1779 9.28503V9.96762ZM56.7724 5.95123C56.1654 4.63414 55.0592 3.97588 53.4537 3.97647C52.0089 3.97647 50.8569 4.45938 50.022 5.44633C49.1871 6.43327 48.758 7.66212 48.758 9.13198C48.758 10.6018 49.1863 11.8298 50.022 12.8167C50.8578 13.8037 52.0089 14.2866 53.4537 14.2866C55.0568 14.2866 56.1631 13.6286 56.7724 12.3127V14.0236H60.4299V0.203735H56.7724V5.95123ZM56.8401 9.32901C56.8401 10.7364 55.9149 11.6539 54.65 11.6539C53.273 11.6539 52.4381 10.5983 52.4381 9.13198C52.4381 7.66563 53.273 6.6092 54.65 6.6092C55.9149 6.6092 56.8401 7.53017 56.8401 8.93406V9.32901ZM75.788 5.11207C75.6464 4.91503 75.4405 4.86489 75.2407 5.01003C75.1676 5.05878 75.1123 5.13036 75.0831 5.21389C75.0539 5.29741 75.0525 5.3883 75.0791 5.47272L74.9331 5.26952L74.6273 5.49383L75.212 6.30749L75.5161 6.08318L75.3223 5.81313C75.2626 5.7349 75.2246 5.642 75.212 5.54397C75.2052 5.50194 75.2105 5.45883 75.2271 5.41971C75.2437 5.38059 75.271 5.3471 75.3058 5.32318C75.324 5.30661 75.3455 5.29429 75.3689 5.28708C75.3923 5.27988 75.417 5.27797 75.4412 5.2815C75.4654 5.28502 75.4886 5.29389 75.509 5.30748C75.5294 5.32107 75.5467 5.33904 75.5595 5.36012C75.5723 5.37696 75.5826 5.39564 75.5899 5.41554L75.7897 5.11735L75.788 5.11207Z" } })])]), t.version ? e("span", { staticClass: "app-version" }, [t._v(t._s(t.version))]) : t._e()]);
}, kF = [], xF = /* @__PURE__ */ f(
  bF,
  vF,
  kF,
  !1,
  null,
  "24fae575"
);
const CF = xF.exports, wF = g({
  props: {
    title: {
      type: String,
      required: !0
    },
    faIcon: {
      type: String,
      required: !0
    },
    routeName: {
      type: String,
      required: !0
    },
    routeParams: {
      type: Object,
      required: !1
    }
  }
});
var $F = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-menu-item", { staticClass: "menu-bar-item", attrs: { title: t.title, "fa-icon": t.faIcon, "route-name": t.routeName, "route-params": t.routeParams } });
}, SF = [], TF = /* @__PURE__ */ f(
  wF,
  $F,
  SF,
  !1,
  null,
  "6381f596"
);
const Xc = TF.exports, IF = g({
  props: {
    label: {
      type: String,
      required: !0
    }
  }
});
var AF = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "menu-group-header" }, [e("div", { staticClass: "menu-group-title" }, [t._v(t._s(t.label))])]);
}, PF = [], OF = /* @__PURE__ */ f(
  IF,
  AF,
  PF,
  !1,
  null,
  "c94a5d19"
);
const MF = OF.exports, RF = g({
  components: {
    MenuBarGroupHeader: MF,
    MenuBarItem: Xc
  },
  props: {
    menuGroup: {
      type: Object,
      required: !1
    },
    menuItems: {
      type: Array,
      default: () => []
    }
  }
});
var EF = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "menu-bar-group" }, [t.menuGroup ? e("menu-bar-group-header", { attrs: { label: t.menuGroup.label } }) : t._e(), t._l(t.menuItems, function(i, n) {
    return e("menu-bar-item", { key: n, attrs: { title: i.label, "fa-icon": i.faIcon, "route-name": i.routeName, "route-params": i.routeParams } });
  })], 2);
}, DF = [], FF = /* @__PURE__ */ f(
  RF,
  EF,
  DF,
  !1,
  null,
  "82eeefb7"
);
const LF = FF.exports, qF = g({
  components: {
    MenuBarGroup: LF,
    MenuBarItem: Xc
  },
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    menuGroups: {
      type: Array,
      default: () => []
    }
  },
  setup(s) {
    const { menuItems: t, menuGroups: e } = Pe(s), { ungrouped: i, nonEmptyGroups: n, groupedItems: r } = Kg(
      t,
      e
    );
    return { ungrouped: i, nonEmptyGroups: n, groupedItems: r };
  }
});
var UF = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "menu-bar" }, [t.ungrouped.length ? e("menu-bar-group", { attrs: { "menu-items": t.ungrouped } }) : t._e(), t._l(t.nonEmptyGroups, function(i, n) {
    return e("menu-bar-group", { key: n, attrs: { "menu-group": i, "menu-items": t.groupedItems(i) } });
  })], 2);
}, NF = [], BF = /* @__PURE__ */ f(
  qF,
  UF,
  NF,
  !1,
  null,
  "ff1990d2"
);
const jF = BF.exports, zF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseHeader: fD,
  FooterIndicator: CF,
  FooterNavigation: yF,
  HeaderNavigation: CD,
  HeaderNavigationLink: zc,
  HeaderProductIndicator: BD,
  HeaderProductLink: Vc,
  HeaderProfile: WD,
  HeaderSearch: hF,
  HeaderSelector: FD,
  HeaderSelectorFloating: Hc,
  MenuBar: jF
}, Symbol.toStringTag, { value: "Module" })), VF = Rt.extend({
  props: {
    tag: {
      type: Object,
      required: !0
    },
    tagsSelected: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    searchEnabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      selected: []
    };
  },
  created() {
    this.selected = this.tagsSelected;
  },
  computed: {
    options() {
      return this.tag.tags.map((s) => ({
        text: s.tag,
        value: Se.build(s).toString()
      }));
    }
  },
  methods: {
    onUpdateMultiple(s) {
      this.$emit("update-tags", s);
    },
    onAddTag(s) {
      this.$emit("addTag", s);
    },
    onRemoveTag(s) {
      this.$emit("removeTag", s);
    }
  }
});
var HF = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-multiselect", { attrs: { label: t.label, placeholder: t.placeholder, options: t.options, "search-enabled": t.searchEnabled, "search-label": t.$t("common.form.search") }, on: { "selection-item-added": t.onAddTag, "selection-item-removed": t.onRemoveTag, "update-multiple": t.onUpdateMultiple }, model: { value: t.selected, callback: function(i) {
    t.selected = i;
  }, expression: "selected" } });
}, WF = [], GF = /* @__PURE__ */ f(
  VF,
  HF,
  WF,
  !1,
  null,
  null
);
const KF = GF.exports, YF = g({
  name: "AppTagCloud",
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  }
});
var XF = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-tag-cloud" }, t._l(t.tags, function(i) {
    return e("div", { key: i, staticClass: "tag", on: { click: function(n) {
      return t.$emit("click", i);
    } } }, [t._v(" " + t._s(i) + " ")]);
  }), 0);
}, ZF = [], QF = /* @__PURE__ */ f(
  YF,
  XF,
  ZF,
  !1,
  null,
  "0d4af8d7"
);
const JF = QF.exports, t3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppTagCloud: JF,
  TagsMultiselect: KF
}, Symbol.toStringTag, { value: "Module" })), e3 = g({
  props: {
    highlight: {
      type: Boolean,
      default: !1
    },
    emojiPath: {
      type: String
    },
    amount: {
      type: Number,
      default: 0
    },
    emojiHeight: {
      type: Number,
      default: 18
    }
  },
  methods: {
    onClick(s) {
      this.$emit("click", s);
    }
  }
});
var s3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("button", { class: { highlight: t.highlight }, attrs: { type: "button" }, on: { click: t.onClick } }, [t._t("default", function() {
    return [e("div", { staticClass: "social-emoji-button-container" }, [e("img", { staticClass: "emoji", attrs: { src: t.emojiPath, height: t.emojiHeight } }), e("span", { staticClass: "amount" }, [t._v(t._s(t.amount))])])];
  })], 2);
}, i3 = [], n3 = /* @__PURE__ */ f(
  e3,
  s3,
  i3,
  !1,
  null,
  "394f7191"
);
const Me = n3.exports, r3 = g({
  props: {
    emoji: {
      type: Object
    }
  }
});
var a3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", [e("button", { staticClass: "emojis-list-item", attrs: { type: "button" }, on: { click: function(i) {
    return i.preventDefault(), t.$emit("click", t.emoji);
  } } }, [e("img", { staticClass: "emoji", attrs: { src: t.emoji.path, alt: "emoji" } })])]);
}, o3 = [], l3 = /* @__PURE__ */ f(
  r3,
  a3,
  o3,
  !1,
  null,
  "abbbc1aa"
);
const c3 = l3.exports, u3 = g({
  components: {
    SocialButton: Me,
    EmojiButton: c3
  },
  props: {
    shortListEmojis: {
      type: Array,
      default: () => []
    },
    otherEmojis: {
      type: Array,
      default: () => []
    },
    columnCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: !1,
      menuExpanded: !1
    };
  },
  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.otherEmojis.length ? this.columnCount : this.columnCount - 1}, minmax(0, 1fr))`
      };
    }
  },
  methods: {
    onEmojiSelect(s) {
      this.$emit("input", s), this.visible = !1;
    }
  }
});
var d3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-floating", { style: { position: "static" }, attrs: { "floating-style": { width: "320px", zIndex: "50" }, placement: "bottom-end" }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("social-button", { staticClass: "add-reactions-button", on: { click: function(i) {
      i.preventDefault();
    } } }, [e("fa-icon-compat", { staticClass: "smile-icon", attrs: { icon: "fa-regular fa-smile" } }), e("img", { staticClass: "emoji", attrs: { height: 12, src: "/img/plus-solid.svg" } })], 1)];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [e("div", { staticClass: "base-emoji-picker-container" }, [e("div", { staticClass: "emoji-list-grid emojis-list", style: t.gridStyle }, [t._l(t.shortListEmojis, function(i) {
      return e("emoji-button", { key: i.key, attrs: { "data-ruid": i.key, emoji: i }, on: { click: t.onEmojiSelect } });
    }), t.otherEmojis.length ? e("emoji-button", { attrs: { emoji: { key: "", path: "/img/emojis/emoji_dots.svg" } }, on: { click: function(i) {
      t.menuExpanded = !t.menuExpanded;
    } } }) : t._e()], 2), t.menuExpanded ? e("div", { staticClass: "emoji-list-grid emojis-list other-emojis", style: t.gridStyle }, t._l(t.otherEmojis, function(i) {
      return e("emoji-button", { key: i.key, attrs: { emoji: i }, on: { click: t.onEmojiSelect } });
    }), 1) : t._e()])];
  }, proxy: !0 }]), model: { value: t.visible, callback: function(i) {
    t.visible = i;
  }, expression: "visible" } });
}, p3 = [], h3 = /* @__PURE__ */ f(
  u3,
  d3,
  p3,
  !1,
  null,
  "04383953"
);
const f3 = h3.exports, m3 = [
  {
    // 👍
    path: "/img/emojis/emoji_thumb_up.svg",
    key: "thumbUp"
  },
  {
    // 🙂
    path: "/img/emojis/emoji_smiling.svg",
    key: "smiling"
  },
  {
    // 😎
    path: "/img/emojis/emoji_sunglasses.svg",
    key: "sunglasses"
  },
  {
    // 😮
    path: "/img/emojis/emoji_wow.svg",
    key: "wow"
  },
  {
    // 💪
    path: "/img/emojis/emoji_strong.svg",
    key: "strong"
  },
  {
    // ❤️
    path: "/img/emojis/emoji_heart.svg",
    key: "heart"
  },
  {
    // 🔥
    path: "/img/emojis/emoji_fire.svg",
    key: "fire"
  }
], g3 = [
  {
    // 😉
    path: "/img/emojis/emoji_wink.svg",
    key: "wink"
  },
  {
    // 😜
    path: "/img/emojis/emoji_tongue.svg",
    key: "tongue"
  },
  {
    // 😍
    path: "/img/emojis/emoji_heart_eyes.svg",
    key: "heartEyes"
  },
  {
    // 😂
    path: "/img/emojis/smile_joy_tears.svg",
    key: "joyTears"
  },
  {
    // 🥰
    path: "/img/emojis/emoji_loved.svg",
    key: "loved"
  },
  {
    // 😣
    path: "/img/emojis/emoji_dead_eyes.svg",
    key: "deadEyes"
  },
  {
    // 😬
    path: "/img/emojis/emoji_grymacing.svg",
    key: "grymacing"
  },
  {
    // 😘
    path: "/img/emojis/emoji_send_heart_kiss.svg",
    key: "kisses"
  },
  {
    // 😋
    path: "/img/emojis/emoji_tongue_smile.svg",
    key: "tongueSmile"
  },
  {
    // 🤗
    path: "/img/emojis/emoji_hugging_face.svg",
    key: "huggingFace"
  },
  {
    // 😭
    path: "/img/emojis/emoji_crying.svg",
    key: "crying"
  },
  {
    // ☺️
    path: "/img/emojis/emoji_smiley.svg",
    key: "smiley"
  },
  {
    // 🙏
    path: "/img/emojis/emoji_folded_hands.svg",
    key: "foldedHands"
  },
  {
    // ✌️
    path: "/img/emojis/emoji_vctory_hand.svg",
    key: "victoryHand"
  },
  {
    // 🙌
    path: "/img/emojis/emoji_rasing_hands.svg",
    key: "raisngHands"
  },
  {
    // 👀
    path: "/img/emojis/emoji_eyes.svg",
    key: "eyes"
  },
  {
    // 💯
    path: "/img/emojis/emoji_100.svg",
    key: "hundred"
  },
  {
    // 🎉
    path: "/img/emojis/emoji_party.svg",
    key: "party"
  },
  {
    // 🏆
    path: "/img/emojis/emoji_trophy.svg",
    key: "trophy"
  },
  {
    // 🦄
    path: "/img/emojis/emoji_unicorn.svg",
    key: "unicorn"
  },
  {
    // ✅
    path: "/img/emojis/emoji_checked.svg",
    key: "checked"
  },
  {
    // 👑
    path: "/img/emojis/emoji_crown.svg",
    key: "crown"
  },
  {
    // 🍒
    path: "/img/emojis/emoji_cherries.svg",
    key: "cherries"
  },
  {
    // 💩
    path: "/img/emojis/emoji_poop.svg",
    key: "poop"
  }
], _3 = g({
  components: {
    EmojiSelection: f3,
    SocialButton: Me
  },
  props: {
    reactions: {
      type: Array,
      default: () => []
    },
    visibleReactions: {
      type: Number
    },
    userId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      shortListEmojis: m3,
      otherEmojis: g3,
      allEmojis: [],
      emojis: {}
    };
  },
  computed: {
    hiddenReactionsCount() {
      return this.reactions.length - this.partialReactions.length;
    },
    partialReactions() {
      return this.visibleReactions === void 0 ? this.reactions : this.reactions.slice(0, this.visibleReactions);
    }
  },
  created() {
    this.allEmojis = this.shortListEmojis.concat(this.otherEmojis), this.allEmojis.forEach((s) => {
      this.emojis[s.key] = s.path;
    });
  },
  methods: {
    hasUserIdReacted(s) {
      return s.events.filter((t) => t.author === this.userId).length > 0;
    },
    clickEmoji(s) {
      this.$emit("updateReaction", s.key);
    },
    updateReaction(s) {
      this.$emit("updateReaction", s.reactionKey);
    }
  }
});
var y3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "emoji-list-container" }, [t._l(t.partialReactions, function(i) {
    return e("social-button", { key: i.reactionKey, attrs: { "emoji-path": t.emojis[i.reactionKey], amount: i.events.length, highlight: t.hasUserIdReacted(i) }, on: { click: function(n) {
      return n.preventDefault(), t.updateReaction(i);
    } } });
  }), t.hiddenReactionsCount > 0 ? e("social-button", { attrs: { amount: t.hiddenReactionsCount, "emoji-height": 12, "emoji-path": "/img/plus-solid.svg" } }) : t._e(), e("emoji-selection", { attrs: { shortListEmojis: t.shortListEmojis, otherEmojis: t.otherEmojis, columnCount: 8 }, on: { input: t.clickEmoji } })], 2);
}, b3 = [], v3 = /* @__PURE__ */ f(
  _3,
  y3,
  b3,
  !1,
  null,
  "4ed7a8a0"
);
const k3 = v3.exports, x3 = g({
  components: {
    EmojiViewer: k3,
    SocialButton: Me
  },
  props: {
    ticketId: {
      type: String,
      required: !0
    },
    showEmojiViewer: {
      type: Boolean,
      default: !0
    },
    visibleReactions: {
      type: Number
    },
    board: {
      type: Object,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      reactionBoard: void 0
    };
  },
  created() {
    this.reactionBoard = this.board;
  },
  computed: {
    reactions() {
      var t;
      return (((t = this.reactionBoard) == null ? void 0 : t.reactions) ?? []).filter((e) => e.events.length);
    },
    numberOfComments() {
      var s;
      return ((s = this.reactionBoard) == null ? void 0 : s.comments.length) ?? 0;
    }
  },
  methods: {
    async onUpdateReaction(s) {
      if (s)
        try {
          const t = await this.$gateway.admin.updateReaction(
            this.reactionBoard,
            s,
            this.ticketId,
            this.currentUserId
          );
          this.reactionBoard = t;
        } catch (t) {
          console.error("Could not update reaction board", t);
        }
    }
  }
});
var C3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "social-action-bar" }, [e("social-button", { attrs: { "emoji-path": "/img/comment-regular.svg", amount: t.numberOfComments, "emoji-height": 15 }, on: { click: function(i) {
    return t.$emit("click", "#comments");
  } } }), t.showEmojiViewer ? e("emoji-viewer", { attrs: { "user-id": t.currentUserId, reactions: t.reactions, "visible-reactions": t.visibleReactions }, on: { updateReaction: t.onUpdateReaction, click: function(i) {
    i.preventDefault();
  } } }) : t._e()], 1);
}, w3 = [], $3 = /* @__PURE__ */ f(
  x3,
  C3,
  w3,
  !1,
  null,
  "2d334e6b"
);
const S3 = $3.exports, T3 = g({
  components: {
    SocialButton: Me
  },
  props: {
    type: {
      type: String,
      required: !0
    },
    typeId: {
      type: String,
      default: ""
    },
    currentUserId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      watchers: []
    };
  },
  async mounted() {
    await this.getWatchers();
  },
  computed: {
    watchingAmount() {
      return this.watchers.length;
    },
    alreadyWatching() {
      return this.watchers.some((s) => s.id === this.currentUserId);
    },
    watchLabel() {
      return this.alreadyWatching ? this.$t("common.watching").toString() : this.$t("common.watch").toString();
    },
    nobodyWatching() {
      return !this.watchingAmount;
    }
  },
  methods: {
    async getWatchers() {
      this.watchers = await this.$api.watcher.fetchWatcherForTarget(
        this.typeId,
        this.type
      );
    },
    async toggleWatcher() {
      const s = this.alreadyWatching ? "stop" : "start";
      await this.$api.watcher.setWatcherForTarget(
        this.typeId,
        this.type,
        s
      ), await this.getWatchers();
    }
  }
});
var I3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("social-button", { staticClass: "social-watch-container", class: { watching: t.alreadyWatching }, on: { click: t.toggleWatcher } }, [e("div", { staticClass: "text" }, [t._v(t._s(t.watchLabel))]), e("div", { staticClass: "bar", class: { watching: t.alreadyWatching } }, [t._v("|")]), t.nobodyWatching ? e("img", { attrs: { src: "/img/watch.svg", alt: "watch" } }) : e("div", [t._v(t._s(t.watchingAmount))])]);
}, A3 = [], P3 = /* @__PURE__ */ f(
  T3,
  I3,
  A3,
  !1,
  null,
  "31fe9c32"
);
const O3 = P3.exports, M3 = g({
  components: {
    SocialButton: Me
  }
});
var R3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("social-button", { staticClass: "social-linking-container", attrs: { title: t.$t("page.ticketDetails.linkTitle") }, on: { click: function(i) {
    return t.$emit("click");
  } } }, [e("img", { attrs: { src: "/img/link-solid.svg", alt: "watch" } })]);
}, E3 = [], D3 = /* @__PURE__ */ f(
  M3,
  R3,
  E3,
  !1,
  null,
  "ef573a37"
);
const F3 = D3.exports, L3 = g({
  components: {
    SocialButton: Me
  },
  props: {
    imagePath: {
      type: String,
      required: !0
    },
    amount: {
      type: [Number, String],
      default: 0
    }
  }
});
var q3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("social-button", { staticClass: "social-rating-container", on: { click: function(i) {
    return i.stopPropagation(), i.preventDefault(), t.$emit("click");
  } } }, [e("div", { staticClass: "social-emoji-button-container" }, [e("img", { attrs: { src: t.imagePath, height: 14, alt: "rating" } }), e("span", { staticClass: "amount" }, [t._v(t._s(t.amount))])])]);
}, U3 = [], N3 = /* @__PURE__ */ f(
  L3,
  q3,
  U3,
  !1,
  null,
  "c44de8b9"
);
const B3 = N3.exports, j3 = g({
  name: "AppMicrosoftTeams",
  props: {
    user: {
      type: Object,
      required: !0
    }
  },
  computed: {
    userDetails() {
      const { microsoftTeamsLink: s, displayEmail: t } = E({ user: this.user });
      return {
        microsoftTeamsLink: s(),
        displayEmail: t()
      };
    },
    microsoftTeamsLink() {
      return this.userDetails.microsoftTeamsLink;
    },
    userEmail() {
      return this.userDetails.displayEmail;
    }
  },
  methods: {
    openTeams() {
      window.open(this.microsoftTeamsLink, "_blank");
    }
  }
});
var z3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.microsoftTeamsLink ? e("app-tooltip", { attrs: { tooltip: t.$t("common.microsoftTeamCall", { email: t.userEmail }), placement: "top" } }, [e("app-icon-button", { attrs: { size: 36 }, on: { click: t.openTeams } }, [e("fa-icon-compat", { staticClass: "teams-icon", attrs: { icon: "fa-brands fa-windows" } })], 1)], 1) : t._e();
}, V3 = [], H3 = /* @__PURE__ */ f(
  j3,
  z3,
  V3,
  !1,
  null,
  null
);
const W3 = H3.exports, G3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppMicrosoftTeams: W3,
  SocialActionBar: S3,
  SocialButton: Me,
  SocialLinkingButton: F3,
  SocialRatingButton: B3,
  SocialWatchButton: O3
}, Symbol.toStringTag, { value: "Module" })), K3 = g({
  name: "WalletTransactionItem",
  props: {
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !0
    },
    value: {
      type: Number,
      required: !0
    },
    type: {
      type: String,
      required: !0
    }
  },
  computed: {
    iconSrc() {
      return this.type === "DEBIT" ? "/wallets/transaction-minus.svg" : this.type === "CREDIT" ? "/wallets/transaction-plus.svg" : (console.warn(`Unknown transaction type [type=${this.type}]`), "");
    },
    displayValue() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "exceptZero",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.value);
    }
  }
});
var Y3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-list-item", { staticClass: "wallet-transaction-item", attrs: { description: t.description, image: t.iconSrc, title: t.title }, scopedSlots: t._u([{ key: "controls", fn: function() {
    return [e("div", { staticClass: "transaction-value" }, [t._v(" " + t._s(t.displayValue) + " ")])];
  }, proxy: !0 }]) });
}, X3 = [], Z3 = /* @__PURE__ */ f(
  K3,
  Y3,
  X3,
  !1,
  null,
  "3031f2ef"
);
const Zc = Z3.exports, Q3 = g({
  name: "WalletWidget",
  components: {
    WalletTransactionItem: Zc
  },
  props: {
    transactions: {
      type: Array,
      required: !0
    },
    owners: {
      type: Object,
      required: !0
    }
  },
  methods: {
    getOwner(s) {
      var t;
      return ((t = this.owners[s]) == null ? void 0 : t.owner.name) ?? "";
    }
  }
});
var J3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "wallet-transactions" }, t._l(t.transactions, function(i) {
    return e("wallet-transaction-item", { key: i.id, attrs: { description: t.getOwner(i.foreignWalletId), title: i.meta.description ?? "", type: i.type, value: i.value } });
  }), 1);
}, tL = [], eL = /* @__PURE__ */ f(
  Q3,
  J3,
  tL,
  !1,
  null,
  "1ee8f8a9"
);
const sL = eL.exports, iL = g({
  name: "WalletTransferControl",
  props: {
    sourceWallet: {
      type: Object,
      required: !0
    },
    targetWallet: {
      type: Object,
      required: !0
    },
    descriptionPlaceholder: {
      type: String,
      required: !0
    },
    confirmLabel: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      transferDescription: "",
      transferAmount: 0
    };
  },
  computed: {
    expectedSourceBalance() {
      return this.sourceWallet.balance - this.transferAmount;
    },
    enableTransfer() {
      return !!this.transferDescription && this.transferAmount > 0 && this.expectedSourceBalance >= 0;
    }
  },
  methods: {
    async onConfirm() {
      this.$emit("transfer", {
        fromWalletId: this.sourceWallet.id,
        toWalletId: this.targetWallet.id,
        value: this.transferAmount,
        description: this.transferDescription
      });
    }
  }
});
var nL = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "wallet-transfer-control" }, [e("app-text-input", { staticClass: "transfer-description", attrs: { placeholder: t.descriptionPlaceholder }, model: { value: t.transferDescription, callback: function(i) {
    t.transferDescription = i;
  }, expression: "transferDescription" } }), e("div", { staticClass: "amount-button-container" }, [e("app-number-input", { staticClass: "transfer-amount", attrs: { "fraction-digits": 0 }, model: { value: t.transferAmount, callback: function(i) {
    t.transferAmount = i;
  }, expression: "transferAmount" } }), e("app-button", { staticClass: "transfer-button", attrs: { label: t.confirmLabel, enabled: t.enableTransfer }, on: { click: t.onConfirm } })], 1)], 1);
}, rL = [], aL = /* @__PURE__ */ f(
  iL,
  nL,
  rL,
  !1,
  null,
  "ce2d3536"
);
const oL = aL.exports, lL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WalletTransactionItem: Zc,
  WalletTransactions: sL,
  WalletTransferControl: oL
}, Symbol.toStringTag, { value: "Module" })), cL = g({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    ticketContext: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    },
    permissions: {
      type: Object,
      required: !0
    },
    initialFilter: {
      type: Object,
      required: !1
    }
  },
  data() {
    var s, t, e, i, n, r, a;
    return {
      form: {
        query: ((s = this.initialFilter) == null ? void 0 : s.query) ?? "",
        campaignProductRestriction: ((t = this.initialFilter) == null ? void 0 : t.campaignProductRestriction) ?? "",
        status: ((e = this.initialFilter) == null ? void 0 : e.status) ?? [],
        team: ((i = this.initialFilter) == null ? void 0 : i.team) ?? [],
        topic: ((n = this.initialFilter) == null ? void 0 : n.topic) ?? [],
        fromDate: (r = this.initialFilter) == null ? void 0 : r.fromDate,
        toDate: (a = this.initialFilter) == null ? void 0 : a.toDate
      },
      optionsStatus: [],
      teamOptions: [],
      topicOptions: [],
      workflows: []
    };
  },
  async created() {
    this.onDirty(), await Promise.allSettled([
      this.loadStatus(),
      this.loadTopics(),
      this.loadTeams()
    ]);
  },
  computed: {
    enabledProducts() {
      const { productsData: s } = Ht(this.organization);
      return s.value.filter(
        (t) => this.permissions.checkProductPermission(t.productId, [
          "USER_TICKET_LIST"
        ])
      ).map((t) => t.productId);
    }
  },
  methods: {
    onDirty() {
      this.$emit("dirty");
    },
    onSubmit() {
      this.$emit("update", this.form);
    },
    async loadStatus() {
      const s = await this.$gateway.search.status(
        this.ticketContext,
        "campaign",
        this.appId
      );
      this.optionsStatus = s[0].map((t) => ({
        text: this.$res(Y(t, s[1]), { label: t }).label,
        value: t
      }));
    },
    async loadTeams() {
      const s = await this.$gateway.search.searchTeamIds(
        {
          filter: {
            type: ["ORGANIZATIONAL_TEAM", "VIRTUAL_TEAM"]
          }
        },
        this.$res
      ), t = await this.$datasource.team.listBatch(s);
      this.teamOptions = t.map((e) => ({
        text: e.name,
        value: e.id
      }));
    },
    async loadTopics() {
      const s = {
        tags: [
          {
            tag: this.productId,
            class: "product"
          }
        ]
      }, t = await this.$gateway.topic.filterByTags(s);
      this.topicOptions = t.map((e) => ({
        text: this.$res(e == null ? void 0 : e.resources).title,
        value: e.id
      }));
    }
  }
});
var uL = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-form", { attrs: { "auto-submit": !0, form: t.form }, on: { dirty: t.onDirty, submit: t.onSubmit } }, [t._t("prepend", null, { form: t.form }), e("product-dropdown", { class: { active: !!t.form.campaignProductRestriction }, attrs: { context: t.ticketContext, label: t.$t("search.filter.product.label"), placeholder: t.$t("search.filter.product.placeholder"), products: t.enabledProducts, workflows: t.workflows }, model: { value: t.form.campaignProductRestriction, callback: function(i) {
    t.$set(t.form, "campaignProductRestriction", i);
  }, expression: "form.campaignProductRestriction" } }), e("app-datepicker-input", { class: { active: !!t.form.fromDate }, attrs: { label: t.$t("search.filter.fromDate.label") }, model: { value: t.form.fromDate, callback: function(i) {
    t.$set(t.form, "fromDate", i);
  }, expression: "form.fromDate" } }), e("app-datepicker-input", { class: { active: !!t.form.toDate }, attrs: { label: t.$t("search.filter.toDate.label") }, model: { value: t.form.toDate, callback: function(i) {
    t.$set(t.form, "toDate", i);
  }, expression: "form.toDate" } }), e("app-multiselect", { class: { active: !!t.form.status.length }, attrs: { label: t.$t("search.filter.status.label"), options: t.optionsStatus, placeholder: t.$t("search.filter.status.placeholder"), "search-enabled": !0 }, model: { value: t.form.status, callback: function(i) {
    t.$set(t.form, "status", i);
  }, expression: "form.status" } }), e("app-multiselect", { class: { active: !!t.form.topic.length }, attrs: { label: t.$t("search.filter.topic.label"), options: t.topicOptions, placeholder: t.$t("search.filter.topic.placeholder"), "search-enabled": !0 }, model: { value: t.form.topic, callback: function(i) {
    t.$set(t.form, "topic", i);
  }, expression: "form.topic" } }), e("app-multiselect", { class: { active: !!t.form.team.length }, attrs: { label: t.$t("search.filter.team.label"), options: t.teamOptions, placeholder: t.$t("search.filter.team.placeholder"), "search-enabled": !0 }, model: { value: t.form.team, callback: function(i) {
    t.$set(t.form, "team", i);
  }, expression: "form.team" } })], 2);
}, dL = [], pL = /* @__PURE__ */ f(
  cL,
  uL,
  dL,
  !1,
  null,
  null
);
const hL = pL.exports, fL = 180, mL = g({
  props: {
    searchId: {
      type: Number,
      required: !0
    },
    pageSize: {
      type: Number,
      required: !0
    },
    totalCount: {
      type: Number,
      required: !0
    },
    items: {
      type: Array,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    empty: {
      type: Object,
      required: !1
    },
    sortOrder: {
      type: String,
      default: "DESC"
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollListener, { passive: !0 });
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollListener);
  },
  watch: {
    searchId() {
      this.currentPage = 0;
    }
  },
  data() {
    return {
      currentPage: 0
    };
  },
  computed: {
    totalCountText() {
      return this.totalCount >= 1e3 ? "1000+" : this.totalCount.toString();
    },
    loadingMore() {
      return !this.lastPage && this.totalCount > 0 && this.currentPage > 0;
    },
    lastPage() {
      const s = Math.ceil(this.totalCount / this.pageSize);
      return this.currentPage >= s;
    },
    sortIcon() {
      return this.sortOrder === "DESC" ? "fa-arrow-down-short-wide" : "fa-arrow-up-wide-short";
    }
  },
  methods: {
    toggleSortOrder() {
      this.$emit("toggleSortOrder", this.sortOrder === "ASC" ? "DESC" : "ASC");
    },
    scrollListener() {
      if (this.lastPage || this.loading)
        return;
      const { scrollTop: s, scrollHeight: t, clientHeight: e } = document.documentElement;
      t - (s + e) < fL && this.loadMore();
    },
    loadMore() {
      this.lastPage || this.loading || (this.currentPage += 1, this.$emit("load-page", this.currentPage));
    }
  }
});
var gL = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "search-container-results" }, [t.loading ? e("div", { staticClass: "container-header" }, [e("div", { staticClass: "header-message" }, [t._v(t._s(t.$t("search.label-loading")))])]) : t.totalCount !== 0 ? e("div", { staticClass: "container-header" }, [e("div", { staticClass: "header-message" }, [t._v(" " + t._s(t.$t("search.label-count", { count: t.totalCountText })) + " ")]), e("div", { staticClass: "header-action" }, [e("div", { staticClass: "sort-by", on: { click: t.toggleSortOrder } }, [t._v(" " + t._s(t.$t("search.orderBy.creationDate")) + " "), e("fa-icon-compat", { attrs: { icon: `fa-light ${t.sortIcon}` } })], 1)])]) : t.empty ? e("div", { staticClass: "container-header" }, [e("app-empty-view-resource", { attrs: { resource: t.empty } })], 1) : t._e(), e("div", { staticClass: "container-content" }, t._l(t.items, function(i, n) {
    return e("div", { key: n, staticClass: "tester" }, [t._t("default", null, { item: i }), e("div", { staticClass: "separator" })], 2);
  }), 0), t.loadingMore ? e("div", { staticClass: "load-more" }, [t._v(" " + t._s(t.$t("search.label-loading-more")) + " ")]) : t._e()]);
}, _L = [], yL = /* @__PURE__ */ f(
  mL,
  gL,
  _L,
  !1,
  null,
  "04f82841"
);
const bL = yL.exports;
function T4(s) {
  const t = {};
  return Object.entries(s).forEach((e) => {
    const [i, n] = e;
    Array.isArray(n) && n.length > 0 ? t[i] = n.join(",") : n instanceof Date ? t[i] = n.toISOString().substring(0, 10) : !Array.isArray(n) && n && (t[i] = n);
  }), t;
}
function vL(s) {
  return !Object.values(s).some((t) => Object.prototype.toString.call(t) === "[object Date]" && !Number.isNaN(t) || typeof t == "string" && t.length > 2 ? !0 : Array.isArray(t) && t.length > 0);
}
const kL = 6 * 30 * 24 * 60 * 60 * 1e3, xL = g({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    defaultProductId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    },
    permissions: {
      type: Object,
      required: !0
    },
    initialFilter: {
      type: Object,
      required: !1
    }
  },
  data() {
    var s, t, e, i, n, r, a, o, l, c, u, d, p;
    return {
      form: {
        query: ((s = this.initialFilter) == null ? void 0 : s.query) ?? "",
        product: ((t = this.initialFilter) == null ? void 0 : t.product) ?? "",
        phases: ((e = this.initialFilter) == null ? void 0 : e.phases) ?? [],
        status: ((i = this.initialFilter) == null ? void 0 : i.status) ?? [],
        creator: ((n = this.initialFilter) == null ? void 0 : n.creator) ?? [],
        assignee: ((r = this.initialFilter) == null ? void 0 : r.assignee) ?? [],
        team: ((a = this.initialFilter) == null ? void 0 : a.team) ?? [],
        topic: ((o = this.initialFilter) == null ? void 0 : o.topic) ?? [],
        skills: ((l = this.initialFilter) == null ? void 0 : l.skills) ?? [],
        parent: ((c = this.initialFilter) == null ? void 0 : c.parent) ?? "",
        fromDate: (u = this.initialFilter) == null ? void 0 : u.fromDate,
        toDate: (d = this.initialFilter) == null ? void 0 : d.toDate,
        tags: ((p = this.initialFilter) == null ? void 0 : p.tags) ?? []
      },
      statusOptions: [],
      phaseOptions: [],
      teamOptions: [],
      topicOptions: [],
      skillOptions: [],
      tagsOptions: [],
      workflows: []
    };
  },
  async created() {
    this.onDirty(), this.setDefaultFilters(), await Promise.allSettled([
      this.loadPhases(),
      this.loadStatus(),
      this.loadTeams(),
      this.loadTopics(),
      this.loadSkills(),
      this.loadWorkflows(),
      this.loadTags()
    ]);
  },
  computed: {
    contextId() {
      return this.organization.context;
    },
    productIds() {
      const { productsData: s } = Ht(this.organization);
      return s.value.filter(
        (t) => this.permissions.checkProductPermission(t.productId, [
          "USER_TICKET_LIST"
        ])
      ).map((t) => t.productId);
    }
  },
  methods: {
    setDefaultFilters() {
      if (this.form.product || (this.form.product = this.defaultProductId), !this.form.fromDate) {
        const s = /* @__PURE__ */ new Date(), t = new Date(s.getTime() - kL);
        this.form.fromDate = t;
      }
    },
    onDirty() {
      this.$emit("dirty");
    },
    onSubmit() {
      vL(this.form) ? this.$emit("empty") : this.$emit("update", this.form);
    },
    async onChangeProduct(s) {
      this.form.product = s || this.defaultProductId, this.form.phases = [], this.form.status = [], await Promise.all([this.loadStatus(), this.loadPhases()]);
    },
    async loadStatus() {
      const s = await this.$gateway.search.status(
        this.contextId,
        this.form.product,
        this.appId
      );
      this.statusOptions = s[0].map((t) => ({
        text: this.$res(Y(t, s[1]), { label: t }).label,
        value: t
      }));
    },
    async loadPhases() {
      const [s, t] = await this.$gateway.search.phases(
        this.contextId,
        this.form.product,
        this.appId
      );
      this.phaseOptions = s.map((e) => ({
        text: this.$res(Y(e, t, "phases"), { label: e }).label,
        value: e
      }));
    },
    async loadTeams() {
      const s = await this.$gateway.search.searchTeamIds(
        {
          filter: {
            type: ["ORGANIZATIONAL_TEAM", "VIRTUAL_TEAM"]
          }
        },
        this.$res
      ), t = await this.$datasource.team.listBatch(s);
      this.teamOptions = t.map((e) => ({
        text: e.name,
        value: e.id
      }));
    },
    async loadTopics() {
      const s = {
        tags: [
          {
            tag: this.defaultProductId,
            class: "product"
          }
        ]
      }, t = await this.$gateway.topic.filterByTags(s);
      this.topicOptions = t.map((e) => ({
        text: this.$res(e == null ? void 0 : e.resources).title,
        value: e.id
      }));
    },
    async loadSkills() {
      const s = await this.$gateway.search.skill();
      this.skillOptions = s.map((t) => ({
        text: t,
        value: t
      }));
    },
    async loadTags() {
      const s = await this.$gateway.search.tags();
      this.tagsOptions = s.map((t) => ({
        text: t,
        value: t
      }));
    },
    async loadWorkflows() {
      this.workflows = await this.$gateway.portal.fetchWorkflowsByBatch(
        this.productIds,
        this.contextId
      );
    }
  }
});
var CL = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-form", { attrs: { "auto-submit": !0, form: t.form }, on: { dirty: t.onDirty, submit: t.onSubmit } }, [t._t("prepend", null, { form: t.form }), e("product-dropdown", { class: { active: !!t.form.product.length }, attrs: { context: t.contextId, label: t.$t("search.filter.product.label"), placeholder: t.$t("search.filter.product.placeholder"), products: t.productIds, workflows: t.workflows }, on: { input: t.onChangeProduct }, model: { value: t.form.product, callback: function(i) {
    t.$set(t.form, "product", i);
  }, expression: "form.product" } }), e("app-datepicker-input", { class: { active: !!t.form.fromDate }, attrs: { label: t.$t("search.filter.fromDate.label") }, model: { value: t.form.fromDate, callback: function(i) {
    t.$set(t.form, "fromDate", i);
  }, expression: "form.fromDate" } }), e("app-datepicker-input", { class: { active: !!t.form.toDate }, attrs: { label: t.$t("search.filter.toDate.label") }, model: { value: t.form.toDate, callback: function(i) {
    t.$set(t.form, "toDate", i);
  }, expression: "form.toDate" } }), t.phaseOptions.length ? e("app-multiselect", { class: { active: !!t.form.phases.length }, attrs: { label: t.$t("search.filter.phase.label"), options: t.phaseOptions, placeholder: t.$t("search.filter.phase.placeholder"), "search-enabled": !0 }, model: { value: t.form.phases, callback: function(i) {
    t.$set(t.form, "phases", i);
  }, expression: "form.phases" } }) : t._e(), e("app-multiselect", { class: { active: !!t.form.status.length }, attrs: { label: t.$t("search.filter.status.label"), options: t.statusOptions, placeholder: t.$t("search.filter.status.placeholder"), "search-enabled": !0 }, model: { value: t.form.status, callback: function(i) {
    t.$set(t.form, "status", i);
  }, expression: "form.status" } }), e("user-multiselect", { class: { active: !!t.form.creator.length }, attrs: { label: t.$t("search.filter.creator.label"), placeholder: t.$t("search.filter.creator.placeholder"), "search-placeholder": t.$t("search.placeholder") }, model: { value: t.form.creator, callback: function(i) {
    t.$set(t.form, "creator", i);
  }, expression: "form.creator" } }), e("user-multiselect", { class: { active: !!t.form.assignee.length }, attrs: { label: t.$t("search.filter.assignee.label"), placeholder: t.$t("search.filter.assignee.placeholder"), "search-placeholder": t.$t("search.placeholder") }, model: { value: t.form.assignee, callback: function(i) {
    t.$set(t.form, "assignee", i);
  }, expression: "form.assignee" } }), e("app-multiselect", { class: { active: !!t.form.team.length }, attrs: { label: t.$t("search.filter.team.label"), options: t.teamOptions, placeholder: t.$t("search.filter.team.placeholder"), "search-enabled": !0 }, model: { value: t.form.team, callback: function(i) {
    t.$set(t.form, "team", i);
  }, expression: "form.team" } }), e("app-multiselect", { class: { active: !!t.form.topic.length }, attrs: { label: t.$t("search.filter.topic.label"), options: t.topicOptions, placeholder: t.$t("search.filter.topic.placeholder"), "search-enabled": !0 }, model: { value: t.form.topic, callback: function(i) {
    t.$set(t.form, "topic", i);
  }, expression: "form.topic" } }), e("ticket-dropdown", { staticClass: "ticket-dropdown", class: { active: !!t.form.parent }, attrs: { context: t.organization.context, label: t.$t("search.filter.campaign.label"), placeholder: t.$t("search.filter.campaign.placeholder"), "product-id": t.defaultProductId, products: ["campaign"] }, model: { value: t.form.parent, callback: function(i) {
    t.$set(t.form, "parent", i);
  }, expression: "form.parent" } }), e("app-multiselect", { class: { active: !!t.form.skills.length }, attrs: { label: t.$t("search.filter.skills.label"), options: t.skillOptions, placeholder: t.$t("search.filter.skills.placeholder"), "search-enabled": !0 }, model: { value: t.form.skills, callback: function(i) {
    t.$set(t.form, "skills", i);
  }, expression: "form.skills" } }), t.tagsOptions.length ? e("app-multiselect", { class: { active: !!t.form.tags.length }, attrs: { label: t.$t("search.filter.tags.label"), options: t.tagsOptions, placeholder: t.$t("search.filter.tags.placeholder"), "search-enabled": !0 }, model: { value: t.form.tags, callback: function(i) {
    t.$set(t.form, "tags", i);
  }, expression: "form.tags" } }) : t._e()], 2);
}, wL = [], $L = /* @__PURE__ */ f(
  xL,
  CL,
  wL,
  !1,
  null,
  null
);
const SL = $L.exports, TL = g({
  props: {
    item: {
      type: Object,
      required: !0
    },
    attachment: {
      type: Object,
      required: !1
    },
    appId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      resource: {}
    };
  },
  async created() {
    await this.loadResource();
  },
  computed: {
    workflow() {
      return this.item.workflow;
    },
    ticket() {
      return this.item.ticket;
    },
    delegateTopic() {
      var s, t;
      return (t = (s = this.item.delegates) == null ? void 0 : s.find(({ type: e }) => e === "topic")) == null ? void 0 : t.data;
    },
    delegateTeam() {
      var s, t;
      return (t = (s = this.item.delegates) == null ? void 0 : s.find(
        ({ type: e }) => ["workgroup", "team"].includes(e)
      )) == null ? void 0 : t.data;
    },
    creatorName() {
      if (this.item.creator)
        return E(this.item.creator).displayName();
    },
    assigneeName() {
      if (this.item.assignee)
        return E(this.item.assignee).displayName();
    },
    delegateTitle() {
      return this.delegateTopic ? this.$res(this.delegateTopic.resources).title : this.delegateTeam ? Ot(this.delegateTeam, this.$res).teamName() : "";
    },
    statusLabel() {
      var t;
      const s = Y(this.ticket.status, this.item.workflow);
      return (t = this.$res(s)) == null ? void 0 : t.label;
    },
    dateCreated() {
      if (!this.ticket.createdDate)
        return "";
      try {
        const s = new Date(this.ticket.createdDate), t = {
          year: "numeric",
          month: "short",
          day: "numeric"
        };
        return s.toLocaleDateString(void 0, t);
      } catch (s) {
        return console.error("Could not parse ticket creation date", s), "";
      }
    },
    topicStyle() {
      var s;
      return {
        backgroundColor: ((s = this.delegateTopic) == null ? void 0 : s.meta.color) ?? ""
      };
    }
  },
  methods: {
    async loadResource() {
      const s = er(this.workflow, this.appId).page(
        "TicketDetails"
      );
      this.resource = this.$res(s == null ? void 0 : s.resources);
    },
    onClick() {
      this.$emit("click", this.ticket.canonicalId);
    }
  }
});
var IL = function() {
  var i, n, r, a, o, l, c;
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "search-ticket-item", on: { click: t.onClick } }, [e("div", [e("div", { staticClass: "item-header" }, [e("div", { staticClass: "item-title" }, [t._v(t._s(t.ticket.title))]), e("div", [e("div", { staticClass: "tag status" }, [t._v(t._s(t.statusLabel))])])]), e("div", { staticClass: "item-subtitle" }, [e("div", [t.creatorName ? e("span", [t._v(t._s((i = t.resource) == null ? void 0 : i.creator) + ": " + t._s(t.creatorName))]) : t._e(), t.creatorName && t.assigneeName ? e("span", [e("br")]) : t._e(), t.assigneeName ? e("span", [t._v(" " + t._s((n = t.resource) == null ? void 0 : n.assignedTo) + ": " + t._s(t.assigneeName) + " ")]) : t._e()]), e("span", { staticClass: "item-creation-date" }, [t._v(t._s(t.dateCreated))])])]), e("div", { staticClass: "item-tags" }, [e("div", [t.delegateTopic ? e("div", { staticClass: "tag topic", style: t.topicStyle }, [t._v(" " + t._s(t.delegateTitle) + " ")]) : t.delegateTeam ? e("div", { staticClass: "tag team" }, [t._v(" " + t._s(t.delegateTitle) + " ")]) : t._e()]), (r = t.attachment) != null && r.name ? e("div", { staticClass: "attachment-container" }, [e("div", { staticClass: "label", attrs: { title: t.$t("page.searchTicketItem.attachmentTooltip") } }, [t._v(" " + t._s(t.$t("page.searchTicketItem.attachmentLabel")) + " ")]), e("div", { staticClass: "files" }, [e("fa-icon-compat", { attrs: { icon: "far fa-file" } }), e("span", { staticClass: "name", attrs: { title: (a = t.attachment) == null ? void 0 : a.name } }, [t._v(" " + t._s((o = t.attachment) == null ? void 0 : o.name) + " ")]), ((l = t.attachment) == null ? void 0 : l.amount) > 0 ? e("span", [e("span", { staticClass: "plus" }, [t._v("+")]), e("span", [t._v(t._s((c = t.attachment) == null ? void 0 : c.amount))])]) : t._e()], 1)]) : t._e()])]);
}, AL = [], PL = /* @__PURE__ */ f(
  TL,
  IL,
  AL,
  !1,
  null,
  "3609fd9d"
);
const OL = PL.exports, ML = g({
  props: {
    initialFilter: {
      type: Object,
      required: !1
    }
  },
  data() {
    var s, t, e, i, n;
    return {
      form: {
        query: ((s = this.initialFilter) == null ? void 0 : s.query) ?? "",
        team: ((t = this.initialFilter) == null ? void 0 : t.team) ?? [],
        virtualTeams: ((e = this.initialFilter) == null ? void 0 : e.virtualTeams) ?? [],
        workgroups: ((i = this.initialFilter) == null ? void 0 : i.workgroups) ?? [],
        skills: ((n = this.initialFilter) == null ? void 0 : n.skills) ?? []
      },
      skillOptions: [],
      allTeams: []
    };
  },
  async created() {
    this.onDirty(), await Promise.allSettled([this.loadTeams(), this.loadSkills()]), this.onSubmit();
  },
  computed: {
    virtualTeamOptions() {
      const s = this.allTeams.filter((t) => t.type === "VIRTUAL_TEAM");
      return this.setTeamOptions(s);
    },
    workgroupOptions() {
      const s = this.allTeams.filter((t) => t.type === "WORKGROUP");
      return this.setTeamOptions(s);
    },
    organisationTeams() {
      const s = this.allTeams.filter(
        (t) => t.type === "ORGANIZATIONAL_TEAM"
      );
      return this.setTeamOptions(s);
    }
  },
  methods: {
    onDirty() {
      this.$emit("dirty");
    },
    onSubmit() {
      this.$emit("update", this.form);
    },
    async loadTeams() {
      const s = await this.$gateway.search.searchTeamIds(
        {
          filter: {
            type: ["ORGANIZATIONAL_TEAM", "VIRTUAL_TEAM", "WORKGROUP"]
          }
        },
        this.$res
      );
      this.allTeams = await this.$datasource.team.listBatch(s);
    },
    setTeamOptions(s) {
      return s.map((t) => ({
        text: Ot(t, this.$res).teamName(),
        value: t.id
      }));
    },
    async loadSkills() {
      const s = await this.$gateway.search.skill();
      this.skillOptions = s.map((t) => ({
        text: t,
        value: t
      }));
    }
  }
});
var RL = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-form", { attrs: { "auto-submit": !0, form: t.form }, on: { dirty: t.onDirty, submit: t.onSubmit } }, [t._t("prepend", null, { form: t.form }), e("app-multiselect", { class: { active: !!t.form.team.length }, attrs: { label: t.$t("search.filter.organizational-team.label"), options: t.organisationTeams, placeholder: t.$t("search.filter.organizational-team.placeholder"), "search-enabled": !0 }, model: { value: t.form.team, callback: function(i) {
    t.$set(t.form, "team", i);
  }, expression: "form.team" } }), e("app-multiselect", { class: { active: !!t.form.virtualTeams.length }, attrs: { label: t.$t("search.filter.virtual-team.label"), options: t.virtualTeamOptions, placeholder: t.$t("search.filter.virtual-team.placeholder"), "search-enabled": !0 }, model: { value: t.form.virtualTeams, callback: function(i) {
    t.$set(t.form, "virtualTeams", i);
  }, expression: "form.virtualTeams" } }), e("app-multiselect", { class: { active: !!t.form.workgroups.length }, attrs: { label: t.$t("search.filter.workgroup.label"), options: t.workgroupOptions, placeholder: t.$t("search.filter.workgroup.placeholder"), "search-enabled": !0 }, model: { value: t.form.workgroups, callback: function(i) {
    t.$set(t.form, "workgroups", i);
  }, expression: "form.workgroups" } }), e("app-multiselect", { class: { active: !!t.form.skills.length }, attrs: { label: t.$t("search.filter.skills.label"), options: t.skillOptions, placeholder: t.$t("search.filter.skills.placeholder"), "search-enabled": !0 }, model: { value: t.form.skills, callback: function(i) {
    t.$set(t.form, "skills", i);
  }, expression: "form.skills" } })], 2);
}, EL = [], DL = /* @__PURE__ */ f(
  ML,
  RL,
  EL,
  !1,
  null,
  null
);
const FL = DL.exports, LL = g({
  props: {
    userData: {
      type: Object,
      required: !0
    }
  },
  computed: {
    userDepartment() {
      return E(this.userData).userDepartment();
    },
    userEmail() {
      return E(this.userData).displayEmail();
    },
    displayName() {
      return E(this.userData).displayName();
    },
    avatar() {
      return this.userData.user.avatar;
    }
  },
  methods: {
    onClick() {
      this.$emit("click", this.userData.user.id);
    }
  }
});
var qL = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "search-user-item", on: { click: t.onClick } }, [e("div", { staticClass: "item-avatar" }, [t.avatar ? e("app-image", { attrs: { src: t.avatar, height: "70px", type: "circle", width: "70px" } }) : e("div", { staticClass: "avatar-fallback" }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-light fa-user" } })], 1)], 1), e("div", { staticClass: "item-content" }, [e("div", { staticClass: "item-title" }, [t._v(" " + t._s(t.displayName) + " ")]), e("div", { staticClass: "item-subtitle" }, [t.userDepartment ? e("span", [t._v(t._s(t.userDepartment))]) : t._e(), t.userDepartment && t.userEmail ? e("span", [t._v(" | ")]) : t._e(), t.userEmail ? e("span", [t._v(t._s(t.userEmail))]) : t._e()])])]);
}, UL = [], NL = /* @__PURE__ */ f(
  LL,
  qL,
  UL,
  !1,
  null,
  "b08706de"
);
const BL = NL.exports, jL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SearchCampaignFilters: hL,
  SearchContainerResults: bL,
  SearchTicketFilters: SL,
  SearchTicketItem: OL,
  SearchUserFilters: FL,
  SearchUserItem: BL
}, Symbol.toStringTag, { value: "Module" })), zL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QuickSearchInput: Yc,
  QuickSearchResults: Kc,
  QuickSearchTicketItem: Wc,
  QuickSearchUserItem: Gc
}, Symbol.toStringTag, { value: "Module" })), VL = {
  column: {
    width: 300
  }
}, HL = g({
  props: {
    data: {
      type: Array,
      default: () => []
    },
    groupBy: {
      type: Array,
      required: !0
    },
    groupKeys: {
      type: Array,
      required: !0
    },
    config: {
      type: Object,
      required: !1
    }
  },
  setup(s) {
    const { data: t, groupBy: e, groupKeys: i } = Pe(s), { groupedData: n, groups: r } = jl(
      t,
      e,
      i
    );
    return { groupedData: n, groups: r };
  },
  computed: {
    innerConfig() {
      return { ...VL, ...this.config };
    },
    groupList() {
      return this.groups.map((s) => ({
        key: s,
        data: this.groupedData[s]
      }));
    },
    listConfig() {
      return {
        summary: "disabled",
        display: { separators: "disabled" }
      };
    },
    columnCssStyle() {
      return {
        flex: `0 0 ${this.innerConfig.column.width}px`
      };
    }
  }
});
var WL = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-data-board" }, t._l(t.groupList, function(i) {
    return e("div", { key: i.key, staticClass: "data-column", style: t.columnCssStyle }, [e("div", { staticClass: "column-header" }, [t._t("group-header", null, { groupKey: i.key, groupData: i.data })], 2), e("div", { staticClass: "column-content scroller" }, [e("app-data-list", { attrs: { data: i.data, config: t.listConfig }, scopedSlots: t._u([{ key: "default", fn: function({ item: n }) {
      return [e("div", { staticClass: "list-item-wrapper" }, [t._t("list-item", null, { item: n })], 2)];
    } }], null, !0) })], 1)]);
  }), 0);
}, GL = [], KL = /* @__PURE__ */ f(
  HL,
  WL,
  GL,
  !1,
  null,
  "acc0f376"
);
const YL = KL.exports;
function XL(s) {
  try {
    return s.filter((t) => {
      var e;
      return (e = t.width) == null ? void 0 : e.endsWith("%");
    }).reduce((t, e) => {
      const i = e.width ?? "0%", n = Number(i.substring(0, i.length - 1));
      return t + n;
    }, 0);
  } catch {
    return console.warn("Could not calculate columns width"), 0;
  }
}
const ZL = g({
  props: {
    headerList: {
      type: Array,
      default() {
        return [];
      }
    },
    config: {
      type: Object,
      required: !0
    }
  },
  created() {
    const s = XL(this.headerList);
    s !== 0 && s !== 100 && console.warn("Table columns width do not add up to 100%");
  },
  computed: {
    selectionVisible() {
      return this.config.selection.mode === "multiple";
    }
  },
  methods: {
    colStyle(s) {
      return {
        width: s.width
      };
    }
  }
});
var QL = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("colgroup", [t.selectionVisible ? e("col", { staticClass: "selection-column" }) : t._e(), t._l(t.headerList, function(i, n) {
    return e("col", { key: n, style: t.colStyle(i) });
  })], 2);
}, JL = [], t5 = /* @__PURE__ */ f(
  ZL,
  QL,
  JL,
  !1,
  null,
  "6d79aa40"
);
const e5 = t5.exports, s5 = g({
  props: {
    sort: {
      type: String,
      required: !1
    }
  },
  computed: {
    sortIcon() {
      return this.sort === "ASC" ? "fa-regular fa-sort-up" : this.sort === "DESC" ? "fa-regular fa-sort-down" : "fa-regular fa-sort";
    }
  },
  methods: {
    onClick(s) {
      this.$emit("click", s);
    }
  }
});
var i5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-icon-button", { staticClass: "sort-button", attrs: { size: 28 }, on: { click: t.onClick } }, [e("fa-icon-compat", { staticClass: "icon", attrs: { icon: t.sortIcon } })], 1);
}, n5 = [], r5 = /* @__PURE__ */ f(
  s5,
  i5,
  n5,
  !1,
  null,
  "6f29b28c"
);
const a5 = r5.exports, o5 = g({
  components: {
    DataControlCheckbox: Rs,
    TableSortButton: a5
  },
  props: {
    headerList: {
      type: Array,
      default() {
        return [];
      }
    },
    selectionStatus: {
      type: String,
      default: "no"
    },
    sortStatus: {
      type: Object,
      required: !1
    },
    config: {
      type: Object,
      required: !0
    }
  },
  computed: {
    selectionEnabled() {
      return this.config.selection.mode === "multiple";
    },
    selectionToggleVisible() {
      return this.config.selection.selectAllButton;
    }
  },
  methods: {
    thStyle(s) {
      return {
        textAlign: s.align,
        paddingRight: s.sortKey ? "36px" : void 0,
        position: s.sortKey ? "relative" : void 0
      };
    },
    colSortDirection(s) {
      var t, e;
      if (s.sortKey)
        return ((t = this.sortStatus) == null ? void 0 : t.field) === s.sortKey ? (e = this.sortStatus) == null ? void 0 : e.direction : void 0;
    },
    toggleCheckbox() {
      this.$emit("click:all");
    },
    onClickSort(s) {
      this.$emit("click:sort", s.sortKey);
    }
  }
});
var l5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("thead", [e("tr", [t.selectionEnabled ? e("th", { staticClass: "selection-th" }, [t.selectionToggleVisible ? e("data-control-checkbox", { attrs: { "selection-status": t.selectionStatus }, on: { click: t.toggleCheckbox } }) : t._e()], 1) : t._e(), t._l(t.headerList, function(i, n) {
    return e("th", { key: n, style: t.thStyle(i) }, [e("span", { staticClass: "header-label" }, [t._v(t._s(i.label))]), i.sortKey ? e("table-sort-button", { staticClass: "sort-button", attrs: { sort: t.colSortDirection(i) }, on: { click: function(r) {
      return t.onClickSort(i);
    } } }) : t._e()], 1);
  })], 2)]);
}, c5 = [], u5 = /* @__PURE__ */ f(
  o5,
  l5,
  c5,
  !1,
  null,
  "f5709ebd"
);
const d5 = u5.exports, p5 = g({
  props: {
    header: {
      type: Object,
      required: !0
    },
    record: {
      type: Object,
      required: !0
    }
  },
  computed: {
    value() {
      return this.record[this.header.key];
    },
    tdStyle() {
      return {
        textAlign: this.header.align
      };
    },
    formattedValue() {
      return this.value ?? "-";
    }
  }
});
var h5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("td", { style: t.tdStyle, attrs: { title: t.formattedValue } }, [t.header.component ? e(t.header.component, t._g({ tag: "component", attrs: { header: t.header, value: t.value, item: t.record } }, t.$listeners)) : [e("span", [t._v(" " + t._s(t.formattedValue) + " ")])]], 2);
}, f5 = [], m5 = /* @__PURE__ */ f(
  p5,
  h5,
  f5,
  !1,
  null,
  "7380a28e"
);
const g5 = m5.exports, _5 = g({
  components: {
    TableRowItem: g5,
    DataControlCheckbox: Rs
  },
  props: {
    headerList: {
      type: Array,
      default() {
        return [];
      }
    },
    record: {
      type: Object,
      required: !0
    },
    config: {
      type: Object,
      required: !0
    },
    selection: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    clickable() {
      return !!this.$listeners["click:row"];
    },
    selectionVisible() {
      return this.config.selection.mode === "multiple";
    },
    selectionStatus() {
      var s;
      return (s = this.selection) != null && s.includes(this.record.id) ? "yes" : "no";
    }
  },
  methods: {
    onClickRow() {
      this.$emit("click:row", this.record);
    },
    onToggleCheckbox() {
      this.$emit("click:select", this.record.id);
    }
  }
});
var y5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("tr", { class: { clickable: t.clickable }, attrs: { tabindex: "0" }, on: { click: function(i) {
    return i.stopPropagation(), t.onClickRow.apply(null, arguments);
  }, keypress: [function(i) {
    return !i.type.indexOf("key") && t._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : (i.stopPropagation(), t.onClickRow.apply(null, arguments));
  }, function(i) {
    return !i.type.indexOf("key") && t._k(i.keyCode, "space", 32, i.key, [" ", "Spacebar"]) ? null : (i.stopPropagation(), i.preventDefault(), t.onToggleCheckbox.apply(null, arguments));
  }] } }, [t.selectionVisible ? e("td", { staticClass: "selection-td" }, [e("data-control-checkbox", { attrs: { "selection-status": t.selectionStatus }, on: { click: function(i) {
    return i.stopPropagation(), t.onToggleCheckbox.apply(null, arguments);
  } } })], 1) : t._e(), t._l(t.headerList, function(i, n) {
    return e("table-row-item", t._g({ key: n, attrs: { header: i, record: t.record } }, t.$listeners));
  })], 2);
}, b5 = [], v5 = /* @__PURE__ */ f(
  _5,
  y5,
  b5,
  !1,
  null,
  "6232bc55"
);
const k5 = v5.exports, x5 = g({
  components: {
    TableRow: k5
  },
  props: {
    headerList: {
      type: Array,
      default: () => []
    },
    recordList: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      required: !0
    },
    selection: {
      type: Array,
      default: () => []
    }
  }
});
var C5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("tbody", t._l(t.recordList, function(i, n) {
    return e("table-row", t._g({ key: n, attrs: { "header-list": t.headerList, record: i, config: t.config, selection: t.selection } }, t.$listeners));
  }), 1);
}, w5 = [], $5 = /* @__PURE__ */ f(
  x5,
  C5,
  w5,
  !1,
  null,
  "2ef917a9"
);
const S5 = $5.exports, T5 = {
  summary: "simple",
  selection: {
    mode: "disabled",
    selectAllButton: !1
  }
}, I5 = g({
  components: {
    DataControlSummary: pr,
    TableColgroup: e5,
    TableHead: d5,
    TableBody: S5
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      required: !1
    }
  },
  setup(s) {
    const { data: t, value: e } = Pe(s), { selection: i, selectionStatus: n, itemStatus: r, toggleAll: a, toggleItem: o } = Mi(t.value, e.value), { sortStatus: l, toggleSort: c } = zg();
    return {
      selection: i,
      selectionStatus: n,
      itemStatus: r,
      toggleAll: a,
      toggleItem: o,
      sortStatus: l,
      toggleSort: c
    };
  },
  computed: {
    innerConfig() {
      return { ...T5, ...this.config };
    },
    summaryEnabled() {
      return this.innerConfig.summary === "simple";
    },
    showHeader() {
      return this.headers.some((s) => s.label);
    }
  },
  methods: {
    onToggleSelectAll() {
      this.toggleAll(), this.updateModel(), this.$emit("click:all");
    },
    onToggleSelectItem(s) {
      this.toggleItem(s), this.updateModel(), this.$emit("click:select", s);
    },
    onClickRow(s) {
      this.$emit("click:row", s);
    },
    onClickSort(s) {
      this.toggleSort(s), this.$emit("click:sort", this.sortStatus);
    },
    updateModel() {
      this.$emit("input", [...this.selection]);
    }
  }
});
var A5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "table-container" }, [t.summaryEnabled ? e("data-control-summary", { staticClass: "data-control-summary", attrs: { selection: t.selection, data: t.data, config: { selectAllButton: !1 } }, on: { "select-all": t.onToggleSelectAll } }) : t._e(), e("table", { staticClass: "table-style" }, [e("table-colgroup", { attrs: { config: t.innerConfig, "header-list": t.headers } }), t.showHeader ? e("table-head", { attrs: { config: t.innerConfig, "header-list": t.headers, "selection-status": t.selectionStatus, "sort-status": t.sortStatus }, on: { "click:all": t.onToggleSelectAll, "click:sort": t.onClickSort } }) : t._e(), e("table-body", t._g({ attrs: { config: t.innerConfig, "header-list": t.headers, "record-list": t.data, selection: t.selection }, on: { "click:select": t.onToggleSelectItem, "click:row": t.onClickRow } }, t.$listeners))], 1)], 1);
}, P5 = [], O5 = /* @__PURE__ */ f(
  I5,
  A5,
  P5,
  !1,
  null,
  "bde91c0f"
);
const Qc = O5.exports, M5 = g({
  components: {
    DataControlCheckbox: Rs
  },
  props: {
    selectionEnabled: {
      type: Boolean,
      required: !0
    },
    selectionStatus: {
      type: String,
      default: "no"
    }
  },
  methods: {
    onToggleCheckbox() {
      this.$emit("click:select");
    }
  }
});
var R5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "data-item-container" }, [t.selectionEnabled ? e("data-control-checkbox", { staticClass: "data-control-checkbox", attrs: { "selection-status": t.selectionStatus }, on: { click: function(i) {
    return i.stopPropagation(), t.onToggleCheckbox.apply(null, arguments);
  } } }) : t._e(), e("div", { staticClass: "item-slot" }, [t._t("default")], 2)], 1);
}, E5 = [], D5 = /* @__PURE__ */ f(
  M5,
  R5,
  E5,
  !1,
  null,
  "3eb91b81"
);
const F5 = D5.exports, L5 = {
  summary: "simple",
  selection: {
    mode: "disabled",
    selectAllButton: !1
  },
  display: {
    separators: "visible"
  }
}, q5 = g({
  components: {
    DataControlSummary: pr,
    AppDataListItem: F5
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      required: !1
    }
  },
  setup(s) {
    const { data: t, value: e } = Pe(s), { selection: i, selectionStatus: n, itemStatus: r, toggleAll: a, toggleItem: o } = Mi(t.value, e.value);
    return { selection: i, selectionStatus: n, itemStatus: r, toggleAll: a, toggleItem: o };
  },
  watch: {
    value(s) {
      this.selection = s;
    }
  },
  computed: {
    innerConfig() {
      return { ...L5, ...this.config };
    },
    summaryEnabled() {
      return this.innerConfig.summary === "simple";
    },
    selectionEnabled() {
      return this.innerConfig.selection.mode === "multiple";
    },
    hasPrependSlot() {
      return !!this.$slots.prepend;
    }
  },
  methods: {
    separatorVisible(s) {
      return s && this.innerConfig.display.separators === "visible";
    },
    onToggleSelectAll() {
      this.toggleAll(), this.updateModel(), this.$emit("click:all");
    },
    onToggleCheckbox(s) {
      this.toggleItem(s), this.updateModel(), this.$emit("click:select", s);
    },
    updateModel() {
      this.$emit("input", [...this.selection]);
    }
  }
});
var U5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-data-list" }, [t.summaryEnabled ? e("data-control-summary", { staticClass: "data-control-summary", attrs: { selection: t.selection, data: t.data, config: t.innerConfig.selection }, on: { "select-all": t.onToggleSelectAll } }) : t._e(), t.hasPrependSlot ? e("div", { staticClass: "item-container slot-prepend" }, [e("app-data-list-item", { attrs: { "selection-enabled": !1 } }, [t._t("prepend")], 2)], 1) : t._e(), t._l(t.data, function(i, n) {
    return e("div", { key: i.id, staticClass: "item-container" }, [t.separatorVisible(n) ? e("div", { staticClass: "separator" }) : t._e(), e("app-data-list-item", { attrs: { "selection-enabled": t.selectionEnabled, "selection-status": t.itemStatus(i.id) }, on: { "click:select": function(r) {
      return t.onToggleCheckbox(i.id);
    } } }, [t._t("default", null, { item: i })], 2)], 1);
  })], 2);
}, N5 = [], B5 = /* @__PURE__ */ f(
  q5,
  U5,
  N5,
  !1,
  null,
  "cd4e8705"
);
const Jc = B5.exports, j5 = g({
  components: {
    AppDataTable: Qc,
    AppDataList: Jc,
    AppDataGrid: hr
  },
  props: {
    value: {
      type: Array,
      required: !1
    },
    view: {
      type: String,
      required: !0
    },
    data: {
      type: Array,
      default: () => []
    },
    tableHeaders: {
      type: Array,
      default: () => []
    },
    tableMapper: {
      type: Function,
      default: (s) => s
    },
    tableConfig: {
      type: Object,
      required: !1
    },
    listConfig: {
      type: Object,
      required: !1
    },
    gridConfig: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      selection: []
    };
  },
  watch: {
    value(s) {
      this.selection = s;
    },
    selection(s) {
      this.$emit("input", s);
    }
  },
  computed: {
    tableData() {
      return this.data.map(this.tableMapper);
    },
    dataViewCssClass() {
      return `view-${this.view}`;
    }
  }
});
var z5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-data-view", class: t.dataViewCssClass }, [t.view === "table" ? [e("app-data-table", t._g({ attrs: { data: t.tableData, headers: t.tableHeaders, config: t.tableConfig }, model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } }, t.$listeners))] : t.view === "list" ? [e("app-data-list", { attrs: { data: t.data, config: t.listConfig }, scopedSlots: t._u([{ key: "default", fn: function({ item: i }) {
    return [t._t("list-item", null, { item: i })];
  } }], null, !0), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } })] : t.view === "grid" ? [e("app-data-grid", { attrs: { data: t.data, config: t.gridConfig }, scopedSlots: t._u([{ key: "default", fn: function({ item: i }) {
    return [t._t("grid-item", null, { item: i })];
  } }], null, !0), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } })] : t._e()], 2);
}, V5 = [], H5 = /* @__PURE__ */ f(
  j5,
  z5,
  V5,
  !1,
  null,
  "c3b21c37"
);
const tu = H5.exports, W5 = g({
  props: {
    data: {
      type: Array,
      default: () => []
    },
    groupBy: {
      type: Array,
      required: !0
    },
    groupKeys: {
      type: Array,
      required: !0
    }
  },
  setup(s) {
    const { data: t, groupBy: e, groupKeys: i } = Pe(s), { groupedData: n, nonEmptyGroups: r } = jl(
      t,
      e,
      i
    );
    return { groupedData: n, nonEmptyGroups: r };
  },
  computed: {
    visibleGroups() {
      return this.nonEmptyGroups.map((s) => ({
        key: s,
        data: this.groupedData[s]
      }));
    }
  }
});
var G5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-data-groups" }, t._l(t.visibleGroups, function(i) {
    return e("div", { key: i.key, staticClass: "data-group" }, [e("div", { staticClass: "header-slot" }, [t._t("group-header", null, { groupKey: i.key, groupData: i.data })], 2), e("div", { staticClass: "view-slot" }, [e("app-data-view", t._g(t._b({ attrs: { data: i.data }, scopedSlots: t._u([{ key: "list-item", fn: function({ item: n }) {
      return [t._t("list-item", null, { item: n })];
    } }, { key: "grid-item", fn: function({ item: n }) {
      return [t._t("grid-item", null, { item: n })];
    } }], null, !0) }, "app-data-view", t.$attrs, !1), t.$listeners))], 1)]);
  }), 0);
}, K5 = [], Y5 = /* @__PURE__ */ f(
  W5,
  G5,
  K5,
  !1,
  null,
  "f076050b"
);
const eu = Y5.exports, X5 = g({
  components: {
    AppDataView: tu,
    AppDataGroups: eu
  },
  props: {
    value: {
      type: Array,
      required: !1
    },
    view: {
      type: String,
      required: !0
    },
    grouping: {
      type: String,
      required: !0
    },
    data: {
      type: Array,
      default: () => []
    },
    groupBy: {
      type: Array,
      required: !1
    },
    groupKeys: {
      type: Array,
      required: !1
    },
    tableConfig: {
      type: Object,
      required: !1
    },
    tableHeaders: {
      type: Array,
      default: () => []
    },
    tableMapper: {
      type: Function,
      default: (s) => s
    },
    listConfig: {
      type: Object,
      required: !1
    },
    gridConfig: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      selection: []
    };
  },
  watch: {
    value(s) {
      this.selection = s;
    },
    selection(s) {
      this.$emit("input", s);
    }
  }
});
var Z5 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "app-data-explorer" }, [t.grouping === "flat" ? e("app-data-view", t._g({ staticClass: "app-data-view", attrs: { data: t.data, "table-config": t.tableConfig, "table-headers": t.tableHeaders, "table-mapper": t.tableMapper, "list-config": t.listConfig, "grid-config": t.gridConfig, view: t.view }, scopedSlots: t._u([{ key: "list-item", fn: function({ item: i }) {
    return [t._t("list-item", null, { item: i })];
  } }, { key: "grid-item", fn: function({ item: i }) {
    return [t._t("grid-item", null, { item: i })];
  } }], null, !0), model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } }, t.$listeners)) : t.grouping === "grouped" ? e("app-data-groups", t._g({ staticClass: "app-data-groups", attrs: { data: t.data, "group-by": t.groupBy, "group-keys": t.groupKeys, "table-config": t.tableConfig, "table-headers": t.tableHeaders, "table-mapper": t.tableMapper, "list-config": t.listConfig, "grid-config": t.gridConfig, view: t.view }, scopedSlots: t._u([{ key: "group-header", fn: function({ groupKey: i }) {
    return [t._t("group-header", null, { groupKey: i })];
  } }, { key: "list-item", fn: function({ item: i }) {
    return [t._t("list-item", null, { item: i })];
  } }, { key: "grid-item", fn: function({ item: i }) {
    return [t._t("grid-item", null, { item: i })];
  } }], null, !0) }, t.$listeners)) : t._e()], 1);
}, Q5 = [], J5 = /* @__PURE__ */ f(
  X5,
  Z5,
  Q5,
  !1,
  null,
  "2681c12f"
);
const t4 = J5.exports, e4 = g({
  props: {
    value: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      selected: ""
    };
  },
  created() {
    this.selected = this.value;
  },
  watch: {
    value(s) {
      this.selected = s;
    },
    selected(s) {
      this.$emit("input", s);
    }
  },
  computed: {
    options() {
      return [
        {
          value: "status",
          text: this.$t("dataView.dataGroup.groupByStatus").toString()
        }
      ];
    }
  }
});
var s4 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-singleselect", { attrs: { placeholder: t.$t("dataView.dataGroup.groupBy"), options: t.options }, model: { value: t.selected, callback: function(i) {
    t.selected = i;
  }, expression: "selected" } });
}, i4 = [], n4 = /* @__PURE__ */ f(
  e4,
  s4,
  i4,
  !1,
  null,
  "e6014d0e"
);
const r4 = n4.exports, pn = ["table", "list", "grid"], a4 = g({
  props: {
    value: {
      type: String,
      required: !0
    },
    available: {
      type: Array,
      default: () => pn,
      validator: (s) => s.length > 0 && s.every((t) => pn.includes(t))
    }
  },
  data() {
    return {
      selection: ""
    };
  },
  created() {
    this.selection = this.value || this.available[0];
  },
  watch: {
    value(s) {
      this.selection = s;
    },
    selection(s) {
      const t = pn.includes(s) ? s : this.available[0];
      pe(() => {
        this.selection = t, this.$emit("input", t);
      });
    }
  },
  computed: {
    options() {
      return [
        {
          value: "table",
          text: this.$t("dataView.table.label").toString()
        },
        {
          value: "list",
          text: this.$t("dataView.list.label").toString()
        },
        {
          value: "grid",
          text: this.$t("dataView.grid.label").toString()
        }
      ].filter((s) => this.available.includes(s.value));
    }
  }
});
var o4 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-singleselect", { staticClass: "dropdown", attrs: { placeholder: "View", options: t.options }, model: { value: t.selection, callback: function(i) {
    t.selection = i;
  }, expression: "selection" } });
}, l4 = [], c4 = /* @__PURE__ */ f(
  a4,
  o4,
  l4,
  !1,
  null,
  null
);
const u4 = c4.exports, hn = ["table", "list", "grid"], d4 = g({
  props: {
    value: {
      type: String,
      required: !0
    },
    size: {
      type: Number,
      default: 26
    },
    available: {
      type: Array,
      default: () => hn,
      validator: (s) => s.length > 0 && s.every((t) => hn.includes(t))
    }
  },
  data() {
    return {
      selection: ""
    };
  },
  created() {
    this.selection = this.value || this.available[0];
  },
  watch: {
    value(s) {
      this.selection = s;
    },
    selection(s) {
      const t = hn.includes(s) ? s : this.available[0];
      pe(() => {
        this.selection = t, this.$emit("input", t);
      });
    }
  },
  computed: {
    buttons() {
      return this.available.map((s) => this.getViewInfo(s));
    }
  },
  methods: {
    getViewInfo(s) {
      switch (s) {
        case "table":
          return {
            value: "table",
            icon: "fal fa-table",
            hint: this.$t("dataView.table.label").toString()
          };
        case "list":
          return {
            value: "list",
            icon: "fal fa-list-ul",
            hint: this.$t("dataView.list.label").toString()
          };
        case "grid":
          return {
            value: "grid",
            icon: "fal fa-grid-2",
            hint: this.$t("dataView.grid.label").toString()
          };
      }
    }
  }
});
var p4 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", t._l(t.buttons, function(i) {
    return e("app-icon-button", { key: i.icon, class: { active: t.selection === i.value }, attrs: { size: t.size, padding: 15 }, on: { click: function(n) {
      t.selection = i.value;
    } } }, [e("fa-icon-compat", { attrs: { icon: i.icon, title: i.hint } })], 1);
  }), 1);
}, h4 = [], f4 = /* @__PURE__ */ f(
  d4,
  p4,
  h4,
  !1,
  null,
  "337a6dd6"
);
const m4 = f4.exports, g4 = g({
  props: {
    value: {
      type: Boolean,
      default: !1
    },
    item: null
  },
  methods: {
    onClick(s) {
      this.$emit("click:toggle", {
        value: this.item,
        status: s
      });
    }
  }
});
var _4 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("app-toggle", t._g({ attrs: { value: t.value }, on: { "!click": function(i) {
    i.stopPropagation(), i.preventDefault();
  }, input: t.onClick } }, t.$listeners));
}, y4 = [], b4 = /* @__PURE__ */ f(
  g4,
  _4,
  y4,
  !1,
  null,
  null
);
const v4 = b4.exports, k4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppDataBoard: YL,
  AppDataExplorer: t4,
  AppDataGrid: hr,
  AppDataGroups: eu,
  AppDataGroupsSwitcher: r4,
  AppDataList: Jc,
  AppDataTable: Qc,
  AppDataView: tu,
  AppDataViewSwitcher: u4,
  AppDataViewSwitcherIcons: m4,
  TableToggle: v4
}, Symbol.toStringTag, { value: "Module" })), ne = {
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
}, H = {
  xs: () => window.innerWidth < ne.sm,
  sm: () => window.innerWidth >= ne.sm && window.innerWidth < ne.md,
  md: () => window.innerWidth >= ne.md && window.innerWidth < ne.lg,
  lg: () => window.innerWidth >= ne.lg && window.innerWidth < ne.xl,
  xl: () => window.innerWidth >= ne.xl
}, x4 = {
  xsOnly: H.xs,
  smOnly: H.sm,
  smAndDown: () => H.sm() || H.xs(),
  smAndUp: () => H.sm() || H.md() || H.lg() || H.xl(),
  mdOnly: H.md,
  mdAndDown: () => H.md() || H.sm() || H.xs(),
  mdAndUp: () => H.md() || H.lg() || H.xl(),
  lgOnly: H.lg,
  lgAndDown: () => H.lg() || H.md() || H.sm() || H.xs(),
  lgAndUp: () => H.lg() || H.xl() || H.md(),
  xlOnly: H.xl
}, C4 = () => {
  const s = Object.entries(H).find(
    ([t, e]) => e()
  );
  return (s == null ? void 0 : s[0]) ?? "";
}, I4 = {
  install: function(s) {
    Object.entries(VS).forEach(([t, e]) => {
      s.component(t, e);
    }), s.prototype.$breakpoint = {
      ...x4,
      ...H,
      name: C4
    };
  }
}, A4 = {
  install: function(s) {
    Object.entries(yP).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, P4 = {
  install: function(s) {
    Object.entries(Rm).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, O4 = {
  install: function(s) {
    Object.entries(zv).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, M4 = {
  install: function(s) {
    Object.entries(Zk).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, R4 = {
  install: function(s) {
    Object.entries(Fb).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, E4 = {
  install: function(s) {
    Object.entries(N0).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, D4 = {
  install: function(s) {
    Object.entries(GP).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, F4 = {
  install: function(s) {
    Object.entries(nO).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, L4 = {
  install: function(s) {
    Object.entries(MO).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, q4 = {
  install: function(s) {
    Object.entries(ZE).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, U4 = {
  install: function(s) {
    Object.entries(R$).forEach(([t, e]) => {
      s.component(t, e);
    }), Object.entries(Lv).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, N4 = {
  install: function(s) {
    Object.entries(wR).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, B4 = {
  install: function(s) {
    Object.entries(fE).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, j4 = {
  install: function(s) {
    Object.entries(AM).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, z4 = {
  install: function(s) {
    Object.entries(NE).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, V4 = {
  install: function(s) {
    Object.entries(zF).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, H4 = {
  install: function(s) {
    Object.entries(t3).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, W4 = {
  install: function(s) {
    Object.entries(G3).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, G4 = {
  install: function(s) {
    Object.entries(lL).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, K4 = {
  install: function(s) {
    Object.entries(Ix).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, Y4 = {
  install: function(s) {
    Object.entries(jL).forEach(([t, e]) => {
      s.component(t, e);
    }), Object.entries(zL).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, X4 = {
  install: function(s) {
    Object.entries(k4).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
}, Z4 = {
  install: function(s) {
    Object.entries(I_).forEach(([t, e]) => {
      s.component(t, e);
    });
  }
};
export {
  Pg as ChatWindow,
  Yl as aiAgentTools,
  H as breakpointFunctions,
  C4 as breakpointName,
  x4 as breakpoints,
  x_ as createSimilarTicketImprovementContext,
  k_ as createTicketEditContext,
  Kl as dynamicField,
  Gl as dynamicFieldSummary,
  vL as filterIsEmpty,
  T4 as filterToQuery,
  M4 as rreadyModuleActivity,
  P4 as rreadyModuleCharts,
  Z4 as rreadyModuleChat,
  F4 as rreadyModuleComments,
  O4 as rreadyModuleCountdown,
  X4 as rreadyModuleDataView,
  R4 as rreadyModuleFeedback,
  U4 as rreadyModuleGenerics,
  Y4 as rreadyModuleGlobalSearch,
  E4 as rreadyModuleHistory,
  L4 as rreadyModuleLinking,
  K4 as rreadyModuleMarkdown,
  N4 as rreadyModuleNotifications,
  B4 as rreadyModuleServices,
  W4 as rreadyModuleSocial,
  V4 as rreadyModuleStructure,
  H4 as rreadyModuleTags,
  D4 as rreadyModuleTasks,
  I4 as rreadyModuleTeams,
  A4 as rreadyModuleTicket,
  z4 as rreadyModuleTopics,
  j4 as rreadyModuleUsers,
  q4 as rreadyModuleVirtualGoods,
  G4 as rreadyModuleWallet,
  Ci as ticketCleanup,
  T_ as useAiChatProvider
};
